'use strict';

angular.module('goApp')
  .controller('404Controller', ['$scope', '$state', '$log',
    function($scope, $state, $log) {
      $scope.$state = $state;
      $log.debug($state);
    }
  ]);
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.u.404', {
    url: '/404',
    controller: '404Controller',
    title: '404',
    templateProvider: ['hesTemplateService', function(hesTemplateService) {
      return hesTemplateService.getTemplate('/scripts/404/404.html');
    }],
    params: {
      error: null
    }
  });

  $stateProvider.state('404', {
    url: '/404',
    controller: '404Controller',
    title: '404',
    templateUrl: '/scripts/404/404.html',
    params: {
      error: null
    }
  });

});
'use strict';

angular.module('goApp')
  .controller('500Controller', ['$scope', '$state', '$log',
    function($scope, $state, $log) {
      $scope.$state = $state;
      $log.debug($state);
    }
  ]);
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('500', {
    url: '/500',
    controller: '500Controller',
    title: '500',
    templateUrl: '/scripts/500/500.html',
    params: {
      error: null
    }
  });
});

// Like ng-bind-html but can compile angular directives
angular.module('goApp').directive('compile', function ($compile) {
  return function(scope, element, attrs) {
    scope.$watch(
      function(scope) {
        return scope.$eval(attrs.compile);
      },
      function(value) {
        element.html(value);
        $compile(element.contents())(scope);
      }
   )};
});
angular.module('goApp').run(function($rootScope, $state, CurrentUser, ipCookie) {
  
  function allowNonUsers(state) {
    return false;
    //return state.name.indexOf('recipes') !== -1 || state.name.indexOf('tips') !== -1;
  };
  
  $rootScope.$on('$stateChangeStart', function(evt, toState, toParams, fromState, fromParams) {
    var redirectRoute = ipCookie('redirectRoute');

    if (toState.name.indexOf('go.u.') === 0 && !ipCookie('basic') && !allowNonUsers(toState)) {

      ipCookie('redirectRoute', {
        route: toState.name,
        params: toParams
      }, {
        path: '/'
      });

      evt.preventDefault();
      CurrentUser.remove();
      $state.go((toState.name === 'go.u.home' ? 'go.welcome' : 'go.welcome'), {
        rejection: {
          errors: ['Please log in.']
        }
      });
    }

    if (toState.name !== 'go.welcome' && toState.name !== 'go.register' && toState.name !== 'go.u.evaluation') {
      if (ipCookie('basic') && redirectRoute && redirectRoute.route && !$rootScope.redirecting) {
        evt.preventDefault();
        //Remove wasn't working locally, setting value to null to ensure weird behavior doesn't happen
        ipCookie('redirectRoute', null, {path: '/'});
        ipCookie.remove('redirectRoute');
        $rootScope.redirecting = true;
        $state.go(redirectRoute.route, redirectRoute.params).then(function() {
          $rootScope.redirecting = false;
        }, function() {
          $rootScope.redirecting = false;
        });
      }
    }
  });
});


angular.module('goApp').constant('GOKP_MIGRATION_DATE', "2020-08-14");



'use strict';

angular.module('goApp').service('BasicInterceptor', function(ipCookie) {
  this.request = function(config) {
    if (ipCookie('basic')) {
      config.headers.authorization = ipCookie('basic');
    }
    return config;
  }
});

angular.module('goApp').config(function($httpProvider) {
  $httpProvider.interceptors.push('BasicInterceptor');
});
angular.module('goApp').config(function(IdleProvider, KeepaliveProvider) {
  var idleLimitMinutes = 15, // must be > 0
    idleWatcherTimeout = 5;

  KeepaliveProvider.interval(20);

  IdleProvider.idle(idleLimitMinutes * 60);
  IdleProvider.timeout(idleWatcherTimeout * 60);
});
'use strict';

angular.module('goApp').run(function($rootScope, $window, CurrentSite, CurrentUser, DynamicCssService, DOMAIN, ErrorService, Program, $interval,ContentLoader,DialogService) {

  if (!!svg4everybody) {
    svg4everybody();
  }

  // sets the sites current theme
  CurrentSite.get().then(function(site) {
    $rootScope.appCss = DynamicCssService($rootScope.site.getTheme()) + '?' + (site.override_css_url && site.override_css_url.split("?")[1]);
    $rootScope.overrideCss = DOMAIN + site.override_css_url;
    $rootScope.favicon = $rootScope.site.getFavicon();

    //Adding to target site specific elements due to rm12932
    $("body").addClass("site-" + site.id);

    setupBranding();
  });

  $rootScope.setTitle = function(title) {
    document.title = typeof title !== 'undefined' ? $rootScope.site.name + ' - ' + title : $rootScope.site.name;
  };

  $rootScope.safeApply = function safeApply(operation) {
    var phase = this.$root.$$phase;
    if (phase !== '$apply' && phase !== '$digest') {
      this.$apply(operation);
      return;
    }

    if (operation && typeof operation === 'function') {
      operation();
    }
  };

  $rootScope.streamlineRedirect = function(programId) {
    var doRedirect = function() {
      Program.SSOUrl.show({
        id: programId
      }, function(response) {
        $window.location = response.redirect_url;
      }, function(errors) {
        ErrorService.showErrors(errors, 'Could not access site');
      });
    };

    if ($rootScope.site.flags.prompt_location_confirm_before_opt_in &&
        !$rootScope.user.hasRegisteredForProgram(programId)) {
      DialogService.openPromptLocationDialog().then(doRedirect);
    } else {
      doRedirect();
    }
  };

  $rootScope.goToProgram = function(program_id) {
    var isMobile = sessionStorage.getItem('hesPlatform');
    if (isMobile) {
      $rootScope.streamlineRedirect(program_id);
      return;
    }
    if(!!$rootScope.site.flags.prompt_location_confirm_before_opt_in && !$rootScope.user.hasRegisteredForProgram(program_id)){
      DialogService.openPromptLocationDialog().then(function () {
        var newWindow = $window.open("about:blank");
        Program.SSOUrl.show({
          id: program_id
        }, function(response) {
          if (newWindow == null || typeof(newWindow) == 'undefined') {
            window.location = response.redirect_url;
          }
          newWindow.location = response.redirect_url;
          newWindow = null;
          if (!$rootScope.user.hasRegisteredForProgram(program_id)) {
            CurrentUser.joinedProgramChecker.start();
          }
        }, function(errors) {
          ErrorService.showErrors(errors, 'Could not access site');
          newWindow.close();
        });
      })
    } else {
      var newWindow = $window.open("about:blank");
      Program.SSOUrl.show({
        id: program_id
      }, function(response) {
        if (newWindow == null || typeof(newWindow) == 'undefined') {
          window.location = response.redirect_url;
        }
        newWindow.location = response.redirect_url;
        newWindow = null;
        if (!$rootScope.user.hasRegisteredForProgram(program_id)) {
          CurrentUser.joinedProgramChecker.start();
        }
      }, function(errors) {
        ErrorService.showErrors(errors, 'Could not access site');
        newWindow.close();
      });
    }
  };

  $rootScope.downloadHistory = function(program) {
    Program.ActivitySummaryUrl.show({
      id: program.id
    }, function(response) {
      window.location = response.redirect_url;
    }, function(errors) {
      ErrorService.showErrors(errors, 'Could not access site');
    });
  };

  $rootScope.isProgramAvailableToUser = function(program) {
    var hasProgram = $rootScope.hasUserOptedInToProgram(program);
    if (!hasProgram) {
      hasProgram = !program.isRegistrationClosed($rootScope.site.current_date);
    }
    return hasProgram;
  };

  $rootScope.hasUserOptedInToProgram = function(program) {
    return !!program && $rootScope.user.registered_program_ids.indexOf(program.id) >= 0;
  };

  $rootScope.humanize = function(string) {
    return string.split('_').map(function(partial) {
      return partial[0].toUpperCase() + partial.substring(1);
    }).join(' ');
  };

  $rootScope.closeDrawer = function() {
    $rootScope.is_drawer_open = false;
  };

  $rootScope.$offMany = function(unbinders) {
    _.forEach(unbinders, function(undinder) {
      if (typeof undinder === 'function')
        undinder();
    })
  }

  $rootScope.isMobile = function() {
    return window.innerWidth <= 600;
  }

  function setupBranding(){
    new ContentLoader({
      site_id: $rootScope.site.id,
      category: 'branding'
    }, false).then(function(content) {
      var branding = {};
      _.each(content,function(c) {
        branding[c.key] = c;
      });
      $rootScope.branding = branding;
    });
  }

});
'use strict';

// Placeholders issue: see https://github.com/angular/angular.js/issues/2614#issuecomment-63563447.
angular.module('goApp').config(function($provide) {
  return $provide.decorator('$sniffer', [
    '$delegate',
    function($sniffer) {
      var _hasEvent, msie, ref, ref1, userAgent;
      userAgent = navigator.userAgent.toLowerCase();
      msie = parseInt(((ref = /msie (\d+)/.exec(userAgent)) != null ? ref : [])[1], 10);
      if (isNaN(msie)) {
        msie = parseInt(((ref1 = /trident\/.*; rv:(\d+)/.exec(userAgent)) != null ? ref1 : [])[1], 10);
      }
      _hasEvent = $sniffer.hasEvent;
      $sniffer.hasEvent = function(event) {
        if (event === 'input' && msie >= 10) {
          return false;
        }
        return _hasEvent.call(this, event);
      };
      return $sniffer;
    }
  ]);
});
'use strict';

angular.module('goApp').run(function($rootScope, $location, CurrentUser, $state, ipCookie, $window) {
  // Watch the root scope to see if the location changes to '/'.
  $rootScope.$watch(function() { return $location.path() }, handleRedirect);

  function handleRedirect(path) {
    // return early if not root url
    if(path !== '/') {
      return;
    }
    
    var regEmail = null;
    try {
      var myUrl = new URL($location.absUrl());
      regEmail = myUrl.searchParams.get('email');
      //var regEmail = $location.search().email;
    } catch (e) {
      //ignore
    }
    
    if (!!regEmail) {
      regEmail = regEmail.trim().replace(" ", "+");
      $rootScope.registerEmail = regEmail; // priority 1
      ipCookie('registerEmail', regEmail); // priority 2, due to encoding errors with plus sign
      $window.location.href = $location.absUrl().split('?')[0];
      return;
    }
    
    // Resolve the current user.
    CurrentUser.get().then(function(user) {
      // Redirect to the list of promotions.
      if (user.pending_evaluation_ids.length > 0) {
        $state.go('go.u.evaluations.current');
      }
      else if (window.location.host.split('.')[0] === 'dashboard' && user.role === 'Master') {
        $state.go("go.u.sites");
      } 
      else if(window.location.host.split('.')[0] === 'dashboard' && user.role === 'Poster'){
        $state.go('go.u.wallexpert.posts');
      }
      else if(user && user.id) {
        $state.go("go.u.home");
      }
    }, function(error) {
      // If there isn't a user, redirect to the welcome page.
      $location.path('/welcome');
    });
  }

});
'use strict';

angular.module('goApp').run(function($rootScope, $state, $log, CurrentUser, $location, IdleService) {


  // Update the page title, reset errors, etc...
  $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
    $rootScope.setTitle(toState.title);
    $rootScope.errors = [];
    if ($rootScope.goingToPrevious && fromParams.previousState) {
      toParams.previousState = fromParams.previousStateParams.previousState;
      toParams.previousStateParams = fromParams.previousStateParams.previousStateParams;
      $rootScope.goingToPrevious = false;
    } else {
      toParams.previousState = fromState;
      toParams.previousStateParams = fromParams;
    }
  });

  $rootScope.$on('$stateChangeSuccess', function() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  });

  $rootScope.$on('$stateChangeError', function(evt, toState, toParams, fromState, fromParams, error) {
    evt.preventDefault();
    $log.debug(error);
    $state.transitionTo('go.u.404', {
      error: error
    });
  });


  $rootScope.$on("userLoggedIn",checkEvaluation);
  CurrentUser.get().then(checkEvaluation);
  IdleService.start();

  function checkEvaluation(user) {
    if(user.pending_evaluation_ids && user.pending_evaluation_ids.length > 0) {
      $location.path("/");
    }
  }


});
'use strict';
angular.module('goApp')
  .config(function() {
    //Focus Ring style application
    function handleFirstTab(e) {
      if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');

        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
      }
    }

    function handleMouseDownOnce() {
      document.body.classList.remove('user-is-tabbing');

      window.removeEventListener('mousedown', handleMouseDownOnce);
      window.addEventListener('keydown', handleFirstTab);
    }

    window.addEventListener('keydown', handleFirstTab);
  });
angular.module('goApp').constant('WELLPATH_MIGRATION_YEAR', 2021);
'use strict';

angular.module('goApp')
  .factory('MetaHandler', [function() {
    return function() {
      return {
        _meta: {},
        getMeta: function() {
          return this._meta;
        },
        getMetaNext: function() {
          return this._meta;
        },
        setMeta: function(meta) {
          this._meta = meta;
        }
      };
    };
  }])
  .factory('ApiResponse', [
    function() {
      return function(metaHandler, config, transformFunc) {

        config = config || {
          isArray: false
        };
        return function(response, header) {
          if (response !== "") {
            config = config || {};
            var responseObj = JSON.parse(response);
            var resource = responseObj;
            if (responseObj.data !== undefined) {
              metaHandler.setMeta(responseObj.meta);
              resource = responseObj.data;
              if (!config.isArray) {
                if (responseObj.meta.total_records >= 1 || responseObj.data.length > 0) {
                  resource = resource[0];
                } else {
                  resource = {};
                }
              }
            }

            if (angular.isFunction(transformFunc)) {
              resource = transformFunc(resource);
            }
          } else {
            resource = response;
          }

          return resource;
        };
      };
    }
  ])

  .factory('ActiveResource', ['$resource', 'HesInflector', 'HesCollection', '$q', 'ApiResponse', 'MetaHandler', '$http', 'DOMAIN',
    function($resource, $inflector, HesCollection, $q, ApiResponse, MetaHandler, $http, DOMAIN) {
      function getActions(options, extraActions, metaHandler) {
        var actions = {
          index: angular.extend({
              method: 'GET',
              isArray: true,
              cache: options.cache,
              transformResponse: new ApiResponse(metaHandler, {
                isArray: true
              }, options.transformFunc)
            },
            extraActions.index),
          show: angular.extend({
              method: 'GET',
              cache: options.cache,
              transformResponse: new ApiResponse(metaHandler, {}, options.transformFunc)
            },
            extraActions.show),
          update: angular.extend({
              method: 'PUT',
              transformResponse: new ApiResponse(metaHandler, {}, options.transformFunc)
            },
            extraActions.updated),
          create: angular.extend({
              method: 'POST',
              transformResponse: new ApiResponse(metaHandler, {}, options.transformFunc)
            },
            extraActions.create),
          destroy: angular.extend({
              method: 'DELETE',
              transformResponse: new ApiResponse(metaHandler, {}, options.transformFunc)
            },
            extraActions.destroy)
        };


        angular.forEach(extraActions, function(action, ind) {
          var config = {
            isArray: !!action.isArray
          };

          if (!action.transformResponse) {
            action.transformResponse = new ApiResponse(metaHandler, config, options.transformFunc);
          }
        });

        return angular.extend({}, actions, extraActions);
      }

      function getCreateFunc(resource) {
        return function(successCallback, errorCallback) {
          return this.$create(function(record) {
            if (resource.records) {
              resource.records.add(record);
            }
            (successCallback || angular.noop).apply(this, arguments);
          }, errorCallback);
        };
      }

      function getDestroyFunc(resource) {
        return function(successCallback, errorCallback) {
          if (this.id) {
            return this.$destroy(function(record) {
              if (resource.records) {
                resource.records.remove(record);
              }
              (successCallback || angular.noop).apply(this, arguments);
            }, errorCallback);
          } else {
            return {};
          }
        };
      }

      function configureExtraActions(extraActions, options, metaHandler, resourceUrl) {
        angular.forEach(extraActions, function(action, ind) {
          var config = {
            isArray: !!action.isArray
          };

          action.url = resourceUrl + action.url || '';

          if (!action.transformResponse) {
            action.transformResponse = new ApiResponse(metaHandler, config, options.transformFunc);
          }
        });
        return extraActions;
      }

      function ActiveResourceFactory(url, options, extraActions) {
        var extend = angular.extend,
          forEach = angular.forEach,
          isFunction = angular.isFunction,
          metaHandler = new MetaHandler(url),
          pagedMetaHandler = new MetaHandler(url),
          foreignKeyNames;

        // If activeResource is created with a parentResource, get the new url and foreign key name
        if (options.parentResource) {
          if (typeof options.parentResource === 'string') {
            foreignKeyNames = [$inflector.underscore(options.parentResource) + '_id'];
          } else {
            foreignKeyNames = [];

            for (var i = 0, len = options.parentResource.length; i < len; i++) {
              foreignKeyNames.push($inflector.underscore(options.parentResource[i]) + '_id');
            }
          }
          url = '/:parent/:parent_id' + url;
        }

        // Add domain if one was passed in options
        url = (options.domain || '') + url;

        extraActions = configureExtraActions(extraActions || {}, options, metaHandler, url);

        // Default actions that are created for all activeResources
        var actions = getActions(options, extraActions, metaHandler),
          pagedActions = getActions(options, extraActions, pagedMetaHandler);

        options = extend({
          nestedRoutes: [],
          parentResource: null,
          domain: '',
          recordsKey: ''
        }, options);

        // Adds nested parameters to a route

        function extendNestedParams(that, params, record) {
          if (typeof params === 'undefined') {
            return params;
          }

          var nestedParams = {},
            foreignKeyName, foreignKeyValue;

          for (var i = 0, len = foreignKeyNames.length; i < len; i++) {

            foreignKeyName = foreignKeyNames[i];
            foreignKeyValue = that[foreignKeyName] || params[foreignKeyName] || (record && record[foreignKeyName]);

            delete params[foreignKeyName];

            if (foreignKeyValue) {
              nestedParams.parent_id = foreignKeyValue;
              nestedParams.parent = $inflector.pluralize(foreignKeyName.replace('_id', ''));
            }
          }

          return extend(nestedParams, params || {});
        }


        // Use angular resource factory to create a resource
        var Resource = $resource(url, {
          id: '@id'
        }, actions);

        Resource.Paged = $resource(url, {
          id: '@id'
        }, pagedActions);

        // Loop through all nested routes and override them so that nested url is used
        forEach(options.nestedRoutes, function(route) {
          var original, args;
          original = Resource[route];

          Resource[route] = function() {
            args = arguments;
            if (isFunction(arguments[0])) {
              args = [].splice.call(arguments, 0);
              args.unshift({});
            }

            if (!isFunction(args[0])) {
              args[0] = extendNestedParams.call(this, this, args[0], args[1]);
            } else if (!isFunction(arguments[1])) {
              args[1] = extendNestedParams.call(this, this, args[1], args[2]);
            }

            return original.apply(this, args);
          };
        });

        // Loop through all the extra actions and make them into promise equivalent
        forEach(extraActions || [], function(extraMethod, extraAction) {
          Resource.prototype[extraAction] = function() {
            var deferred = $q.defer();
            var params = {};
            var thisArguments = arguments || [];
            var args = [].splice.call(thisArguments, 0);
            switch (args.length) {
              case 1:
                if (isFunction(args[0])) {
                  args.unshift(params);
                }
              case 2:
                if (isFunction(args[0])) {
                  args.unshift(params);
                } else {
                  args.push(function() {
                    //Do nothing
                  });
                }
              case 3:
                this['$' + extraAction].call(this, args[0], function(record) {
                    if (isFunction(args[1])) {
                      args[1]();
                    }
                    deferred.resolve(record);
                  },
                  function(rejection) {
                    if (isFunction(args[2])) {
                      args[2]();
                    }
                    deferred.reject(rejection);
                  });
                break;
              default:
                this['$' + extraAction].call(this, function(record) {
                  deferred.resolve(record);
                });
            }
            return deferred.promise;
          };
        });

        // Grabs all the records and returns them using a promise
        Resource.fetch = function(attrs, successCallback, errorCallback) {
          return Resource.index(attrs, function(records) {
            Resource.records = new HesCollection(records);

            if (successCallback) {
              successCallback(Resource.records.all());
            }
          }, errorCallback);
        };
        Resource.Paged.fetch = Resource.fetch;

        // Finds a single record and returns it using a promise
        Resource.find = function(attrs, successCallback, errorCallback) {
          if (typeof attrs !== 'object') {
            attrs = {
              id: attrs
            };
          }
          return Resource.show(attrs, successCallback, errorCallback);
        };
        Resource.Paged.find = Resource.find;

        // Builds a single record
        Resource.build = function(attributes) {
          return new Resource(attributes);
        };
        Resource.Paged.build = Resource.build;

        Resource.wrap = function(data) {
          var resource = new Resource(data);
          if (angular.isArray(data)) {
            resource = [];
            angular.forEach(data, function(item, idx) {
              resource.push(new Resource(item));
            });
          }

          return resource;
        };

        Resource.toString = function() {
          return $inflector.singularize($inflector.titleize($inflector.camelcase(url.split('/')[url.split('/').length - 2])));
        };
        Resource.Paged.toString = Resource.toString;

        Resource.prototype['class'] = Resource;

        // Updates an existing record
        Resource.prototype.isNew = function() {
          return typeof this.id === 'undefined' || this.id === null;
        };

        Resource.prototype.getMeta = function() {
          return this.metaHandler.getMeta();
        };

        Resource.prototype.metaHandler = metaHandler;
        Resource.Paged.prototype.metaHandler = pagedMetaHandler;

        Resource.prototype.setMeta = function(meta) {
          this.metaHandler.setMeta(meta);
        };

        Resource.prototype.getMetaHandler = function() {
          return this.metaHandler;
        };

        // Saves a single record using a promise
        Resource.prototype.save = function(successCallback, errorCallback) {
          if (!this.isNew()) {
            return this.update(successCallback, errorCallback);
          } else {
            return this.create(successCallback, errorCallback);
          }
        };

        // Updates an existing record
        Resource.prototype.update = function(successCallback, errorCallback) {
          return this.$update(successCallback, errorCallback);
        };

        // Creates a new record using a promise
        Resource.prototype.create = getCreateFunc(Resource);
        Resource.Paged.prototype.create = getCreateFunc(Resource.Paged);

        // Destroys a record using a promise
        Resource.prototype.destroy = getDestroyFunc(Resource);
        Resource.Paged.prototype.destroy = getDestroyFunc(Resource.Paged);

        //Wraps the Paged Resource
        Resource.Paged.prototype.wrap = function(data) {
          var resource = new Resource.Paged(data);
          if (angular.isArray(data)) {
            resource = [];
            angular.forEach(data, function(item, idx) {
              resource.push(new Resource.Paged(item));
            });
          }

          return resource;
        };

        Resource.Paged.prototype.getFromUrl = function(url, isArray) {
          var defer = $q.defer();
          // $http.get((options.domain || '') + url, {
          $http.get(url, {
            cache: options.cache,
            transformResponse: new ApiResponse(this.getMetaHandler(), {
              isArray: isArray
            }, isArray ? this.wrap : null)
          }).then(function(response) {
            defer.resolve(response.data);
          }, function(error) {
            defer.reject(error);
          });
          return defer.promise;
        };

        Resource.Paged.prototype.total_records = function() {
          return this.getMeta().total_records;
        };

        Resource.Paged.prototype.total_replies = function() {
          return this.getMeta().reply_count;
        };

        Resource.Paged.prototype.hasNext = function() {
          var meta = this.getMeta();
          return (angular.isDefined(meta.links.next) && meta.links.next !== '');
        };

        Resource.Paged.prototype.getNext = function(isArray) {
          return this.getFromUrl(options.domain + this.getMeta().links.next, isArray);
        };

        Resource.Paged.prototype.getPrev = function(isArray) {
          return this.getFromUrl(options.domain + this.getMeta().links.prev, isArray);
        };

        Resource.Paged.prototype.getCurrent = function(isArray) {
          return this.getFromUrl(options.domain + this.getMeta().links.current, isArray);
        };

        //Copies Resource.prototype onto the Paged object but keeps essential settings
        //for the paged object... i.e. the MetaHandler
        Resource.Paged.prototype = angular.extend({}, Resource.prototype, Resource.Paged.prototype);
        Resource.Paged.prototype.metaHandler = pagedMetaHandler;

        return Resource;
      }

      return ActiveResourceFactory;
    }
  ]);
'use strict';

angular.module('hes')
  .factory('HesCollection', ['HesInflector', function(HesInflector) {

    var Collection = function() {
      if (arguments.length === 1) {
        this.records = arguments[0];
      } else {
        this.records = [].splice.call(arguments, 0);
      }

      this.indexedRecords = {};

      angular.forEach(this.records, function(record) {
        this.indexedRecords[record.id] = record;
      }, this);

      angular.forEach(this.records[0], function(attr_val, attr_key) {
        this[HesInflector.camelcase('find_by_' + attr_key)] = function(value) {
          var foundRecord;

          angular.forEach(this.records, function(record) {
            if (foundRecord === null && record[attr_key] === value) {
              foundRecord = record;
            }
          });

          return foundRecord;
        };
      }, this);
    };

    Collection.prototype.length = function() {
      return this.records.length;
    };

    Collection.prototype.all = function() {
      return this.records;
    };

    Collection.prototype.find = function(id) {
      if (typeof this.indexedRecords[id] === 'undefined') {
        throw 'The record with @id of ' + id + ' could not be found';
      }

      return this.indexedRecords[id];
    };

    Collection.prototype.add = function(record) {
      this.indexedRecords[record.id] = record;
      this.records.push(record);
    };

    Collection.prototype.remove = function(id) {
      this.records.splice(this.records.indexOf(this.indexedRecords[id]), 1);
      delete this.indexedRecords[id];
    };


    return Collection;
  }]);
'use strict';

angular.module('hes').factory('HesInflector', function() {
  /**
   * A port of the Rails/ActiveSupport Inflector class
   * http://api.rubyonrails.org/classes/ActiveSupport/Inflector.html
   */

  var inflector = {};

  var inflections = inflector.inflections = {
    plurals: [],
    singulars: [],
    uncountables: [],
    humans: []
  };

  var PLURALS = inflections.plurals,
    SINGULARS = inflections.singulars,
    UNCOUNTABLES = inflections.uncountables,
    HUMANS = inflections.humans;

  /**
   * Specifies a new pluralization rule and its replacement. The rule can either
   * be a string or a regular expression. The replacement should always be a
   * string that may include references to the matched data from the rule.
   */
  var plural = function(rule, replacement) {
    //inflections.uncountables.delete(rule) if rule.is_a?(String)
    //inflections.uncountables.delete(replacement)
    inflections.plurals.unshift([rule, replacement]);
  };

  /**
   * Specifies a new singularization rule and its replacement. The rule can either
   * be a string or a regular expression. The replacement should always be a
   * string that may include references to the matched data from the rule.
   */
  var singular = function(rule, replacement) {
    //inflections.uncountables.delete(rule) if rule.is_a?(String)
    //inflections.uncountables.delete(replacement)
    inflections.singulars.unshift([rule, replacement]);
  };

  /**
   * Add uncountable words that shouldn't be attempted inflected.
   */
  var uncountable = function(word) {
    inflections.uncountables.unshift(word);
  };

  /**
   * Specifies a new irregular that applies to both pluralization and
   * singularization at the same time. This can only be used for strings, not
   * regular expressions. You simply pass the irregular in singular and plural
   * form.
   *
   * Examples:
   *  irregular('octopus', 'octopi');
   *  irregular('person', 'people');
   */
  var irregular = function(s, p) {
    //inflections.uncountables.delete(singular);
    //inflections.uncountables.delete(plural);
    if (s.substr(0, 1).toUpperCase() === p.substr(0, 1).toUpperCase()) {
      plural(new RegExp('(' + s.substr(0, 1) + ')' + s.substr(1) + '$', 'i'), '$1' + p.substr(1));
      plural(new RegExp('(' + p.substr(0, 1) + ')' + p.substr(1) + '$', 'i'), '$1' + p.substr(1));
      singular(new RegExp('(' + p.substr(0, 1) + ')' + p.substr(1) + '$', 'i'), '$1' + s.substr(1));
    } else {
      plural(new RegExp(s.substr(0, 1).toUpperCase() + s.substr(1) + '$'), p.substr(0, 1).toUpperCase() + p.substr(1));
      plural(new RegExp(s.substr(0, 1).toLowerCase() + s.substr(1) + '$'), p.substr(0, 1).toLowerCase() + p.substr(1));
      plural(new RegExp(p.substr(0, 1).toUpperCase() + p.substr(1) + '$'), p.substr(0, 1).toUpperCase() + p.substr(1));
      plural(new RegExp(p.substr(0, 1).toLowerCase() + p.substr(1) + '$'), p.substr(0, 1).toLowerCase() + p.substr(1));
      singular(new RegExp(p.substr(0, 1).toUpperCase() + p.substr(1) + '$'), s.substr(0, 1).toUpperCase() + s.substr(1));
      singular(new RegExp(p.substr(0, 1).toLowerCase() + p.substr(1) + '$'), s.substr(0, 1).toLowerCase() + s.substr(1));
    }
  };

  /**
   * Specifies a humanized form of a string by a regular expression rule or by a
   * string mapping. When using a regular expression based replacement, the normal
   * humanize formatting is called after the replacement.
   */
  // var human = function (rule, replacement) {
  //   //inflections.uncountables.delete(rule) if rule.is_a?(String)
  //   //inflections.uncountables.delete(replacement)
  //   inflections.humans.push([rule, replacement]);
  // };

  plural(/$/, 's');
  plural(/s$/i, 's');
  plural(/(ax|test)is$/i, '$1es');
  plural(/(octop|vir)us$/i, '$1i');
  plural(/(alias|status)$/i, '$1es');
  plural(/(bu)s$/i, '$1ses');
  plural(/(buffal|tomat)o$/i, '$1oes');
  plural(/([ti])um$/i, '$1a');
  plural(/sis$/i, 'ses');
  plural(/(?:([^f])fe|([lr])f)$/i, '$1$2ves');
  plural(/(hive)$/i, '$1s');
  plural(/([^aeiouy]|qu)y$/i, '$1ies');
  plural(/(x|ch|ss|sh)$/i, '$1es');
  plural(/(matr|vert|ind)(?:ix|ex)$/i, '$1ices');
  plural(/([m|l])ouse$/i, '$1ice');
  plural(/^(ox)$/i, '$1en');
  plural(/(quiz)$/i, '$1zes');

  singular(/s$/i, '');
  singular(/(n)ews$/i, '$1ews');
  singular(/([ti])a$/i, '$1um');
  singular(/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$/i, '$1$2sis');
  singular(/(^analy)ses$/i, '$1sis');
  singular(/([^f])ves$/i, '$1fe');
  singular(/(hive)s$/i, '$1');
  singular(/(tive)s$/i, '$1');
  singular(/([lr])ves$/i, '$1f');
  singular(/([^aeiouy]|qu)ies$/i, '$1y');
  singular(/(s)eries$/i, '$1eries');
  singular(/(m)ovies$/i, '$1ovie');
  singular(/(x|ch|ss|sh)es$/i, '$1');
  singular(/([m|l])ice$/i, '$1ouse');
  singular(/(bus)es$/i, '$1');
  singular(/(o)es$/i, '$1');
  singular(/(shoe)s$/i, '$1');
  singular(/(cris|ax|test)es$/i, '$1is');
  singular(/(octop|vir)i$/i, '$1us');
  singular(/(alias|status)es$/i, '$1');
  singular(/^(ox)en/i, '$1');
  singular(/(vert|ind)ices$/i, '$1ex');
  singular(/(matr)ices$/i, '$1ix');
  singular(/(quiz)zes$/i, '$1');
  singular(/(database)s$/i, '$1');

  irregular('person', 'people');
  irregular('man', 'men');
  irregular('child', 'children');
  irregular('sex', 'sexes');
  irregular('move', 'moves');
  irregular('cow', 'kine');

  uncountable('equipment');
  uncountable('information');
  uncountable('rice');
  uncountable('money');
  uncountable('species');
  uncountable('series');
  uncountable('fish');
  uncountable('sheep');
  uncountable('jeans');

  /**
   * Returns the plural form of the word in the string.
   */
  inflector.pluralize = function(word, count) {

    if (typeof count === 'undefined') {
      var wlc = word.toLowerCase();

      for (var i = 0; i < UNCOUNTABLES.length; i++) {
        var uncountable = UNCOUNTABLES[i];
        if (wlc === uncountable) {
          return word;
        }
      }

      for (var j = 0; j < PLURALS.length; j++) {
        var rule = PLURALS[j][0],
          replacement = PLURALS[j][1];
        if (rule.test(word)) {
          return word.replace(rule, replacement);
        }
      }
    } else {
      word = count !== 1 ? inflector.pluralize(word) : inflector.singularize(word);

      // Word became undefined becuase it was already plural or singular
      if (typeof word === 'undefined') {
        word = arguments[0];
      }
      return count.toString() + ' ' + word;
    }
  };

  /**
   * Returns the singular form of the word in the string.
   */
  inflector.singularize = function(word) {
    var wlc = word.toLowerCase();

    for (var i = 0; i < UNCOUNTABLES.length; i++) {
      var uncountable = UNCOUNTABLES[i];
      if (wlc === uncountable) {
        return word;
      }
    }

    for (var j = 0; j < SINGULARS.length; j++) {
      var rule = SINGULARS[j][0],
        replacement = SINGULARS[j][1];
      if (rule.test(word)) {
        return word.replace(rule, replacement);
      }
    }
  };

  /**
   * Capitalizes the first word and turns underscores into spaces and strips a
   * trailing 'Key', if any. Like +titleize+, this is meant for creating pretty
   * output.
   *
   * Examples:
   *   'employeeSalary' => 'employee salary'
   *   'authorKey'       => 'author'
   */
  inflector.humanize = function(word) {
    for (var i = 0; i < HUMANS.length; i++) {
      var rule = HUMANS[i][0],
        replacement = HUMANS[i][1];
      if (rule.test(word)) {
        word = word.replace(rule, replacement);
      }
    }

    return inflector.split(word, ' ').toLowerCase();
  };

  /**
   * Split a camel case word in its terms.
   */
  inflector.split = function(word, delim) {
    delim = delim || ' ';
    var replacement = '$1' + delim + '$2';
    return word.replace(/([A-Z]+)([A-Z][a-z])/g, replacement)
      .replace(/([a-z\d])([A-Z])/g, replacement);
  };

  /**
   * Converts a CamelCase word to underscore format.
   */
  inflector.underscore = function(word) {
    return inflector.split(word, '_').toLowerCase();
  };

  /**
   * Converts a CamelCase word to dash (lisp style) format.
   */
  inflector.dash = inflector.dasherize = function(word) {
    return inflector.split(word, '-').toLowerCase();
  };

  /**
   * Converts an underscore formatted word to camelcase format.
   */
  inflector.camelcase = function(word) {
    return word.toLowerCase().replace(/_(.)/g, function(match, group1) {
      return group1.toUpperCase();
    });
  };

  /**
   *  Titleizes a word
   */
  inflector.titleize = function(word, allWords) {
    if (typeof allWords === 'undefined') {
      return word.charAt(0).toUpperCase() + word.slice(1);
    } else {
      return word.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
  };

  return inflector;
});
'use strict';

angular.module('goApp').directive('focusTrap', function($rootScope, $timeout) {
  var focusTrap = new Object();
  var previously_active = null;
  var is_closing = false;

  var keyboard_dispatch = null;


  var focusableElementSelector = 'a[href], area[href], input:not([disabled]), \
    select:not([disabled]), textarea:not([disabled]), button:not([disabled]), \
    iframe, object, embed, *[tabindex], *[contenteditable]';


  focusTrap.link = function($scope, $element, $attributes) {

    function onKeydown(ev) {
      var isTab = (ev.keyCode === 9);
      var backward = (ev.shiftKey === true);

      if (isTab) {
        handleTab($element, ev, backward);
      }
    }

    $scope.$watch($attributes.focusTrap, function(is_activated) {
      if (is_activated) {
        previously_active = previously_active || document.activeElement;
        previously_active.blur();
        autofocus($element);
        $element.on('keydown', onKeydown);
      } else if (is_activated == false) {
        $timeout(function(){
          if(!previously_active){
            return;
          }

          if (previously_active.id) {
            previously_active = document.getElementById(previously_active.id);
          }

          // if (previously_active) {
          //   previously_active.focus();
          // }
          previously_active = null;
          $element.off('keydown');

        }, 250);
      }
    });
  }



  function handleTab($element, ev, backward) {
    var focusableElements = getFocusableElements($element);

    if (focusableElements.length === 0) {
      if (document.activeElement) {
        document.activeElement.blur();
      }
      return;
    }

    var currentFocus = document.activeElement;
    var focusIndex = Array.prototype.indexOf.call(focusableElements, currentFocus);

    var isFocusIndexUnknown = (focusIndex === -1);
    var isFirstElementFocused = (focusIndex === 0);
    var isLastElementFocused = (focusIndex === focusableElements.length - 1);

    var cancelEvent = false;

    if (backward) {
      if (isFocusIndexUnknown || isFirstElementFocused) {
        focusableElements[focusableElements.length - 1].focus();
        cancelEvent = true;
      }
    } else {
      if (isFocusIndexUnknown || isLastElementFocused) {
        focusableElements[0].focus();
        cancelEvent = true;
      }
    }

    if (cancelEvent) {
      ev.preventDefault();
      ev.stopPropagation();
    }
  }

  function autofocus($element) {
    // Browser's (Chrome 40, Forefix 37, IE 11) don't appear to honor autofocus on the dialog, but we should
    var autoFocusEl = $element[0].querySelector('*[autofocus]');
    if (autoFocusEl !== null) {
      autoFocusEl.focus();

      if (document.activeElement === autoFocusEl) {
        return;
      }

      // Autofocus element might was display: none, so let's continue 
      
    }

    var focusableElements = getFocusableElements($element);

    if (focusableElements.length > 0) {
      $timeout(function(){
        focusableElements[0].focus();
      }, 100);
      return;
    }
  }


  function getFocusableElements($element) {
    var dialogEl = $element[0];

    var rawElements = dialogEl.querySelectorAll(focusableElementSelector);

    // Ignore untabbable elements, ie. those with tabindex = -1
    var tabbableElements = filterTabbableElements(rawElements, $element);

    return filterVisibleElements(tabbableElements);
  }

  function filterTabbableElements(els, $element) {
    var tabbableFocusableElements = [];

    for (var i = 0; i < els.length; i++) {
      var el = els[i];

      if ($element.find(el).attr('tabindex') !== '-1') {
        tabbableFocusableElements.push(el);
      }
    }

    return tabbableFocusableElements;
  }

  function filterVisibleElements(els) {
    var visibleFocusableElements = [];

    for (var i = 0; i < els.length; i++) {
      var el = els[i];

      if (el.offsetWidth > 0 || el.offsetHeight > 0) {
        visibleFocusableElements.push(el);
      }
    }

    return visibleFocusableElements;
  }



  return focusTrap;
});
'use strict';

angular.module('goApp')
  .service('ImpersonateService', ['ipCookie', '$http', '$window', 'ErrorService', '$timeout', '$location',
    function(ipCookie, $http, $window, ErrorService, $timeout, $location) {
      var ImpersonateService = {
        _devDomain: 'subscription-platform-api',
        _prodDomain: 'launchpad.fit',

        getUser: function() {
          return ipCookie('impersonatedUser');
        },

        removeUser: function() {
          // We don't need that cookie to hang around.
          // if (window.location.hostname.split('.')[1] === ImpersonateService._devDomain) {
          //   document.cookie = ['impersonatedUser=', '; domain=.' + ImpersonateService._devDomain + '.dev; ', 'path=/;', 'expires=Thu, 01 Jan 1970 00:00:01 GMT;'].join('');
          // } else if (window.location.hostname.split('.')[1] === ImpersonateService._prodDomain) {
          //   document.cookie = ['impersonatedUser=', '; domain=.' + ImpersonateService._prodDomain + '.com; ', 'path=/;', 'expires=Thu, 01 Jan 1970 00:00:01 GMT;'].join('');
          // } else if (window.location.hostname.split('.')[1] === 'staging') {
          //   document.cookie = ['impersonatedUser=', '; domain=.staging.' + ImpersonateService._prodDomain + '.com; ', 'path=/;', 'expires=Thu, 01 Jan 1970 00:00:01 GMT;'].join('');
          // }
        },

        doImpersonation: function(user, site) {
          var environment = '';

          if (window.location.hostname.split('.')[1] === ImpersonateService._devDomain) {
            environment = 'development';
          } else if (window.location.hostname.split('.')[1] === ImpersonateService._prodDomain) {
            environment = 'production';
          } else if (window.location.hostname.split('.')[1] === 'staging') {
            environment = 'staging';
          }

          if (!site.is_sso_enabled) {

            // Attach the user's site's urls.replace(/\.\*/g, '') for easy access when searching for this cookie.
            user.site_subdomain = user.origin_url;

            var userToImpersonate = {
              auth_key: user.auth_key,
              id: user.id,
              site_subdomain: user.origin_url,
            };

            var impersonatedUserCookie;

            if (environment === 'development') {
              impersonatedUserCookie = ['impersonatedUser=', JSON.stringify(userToImpersonate), '; domain=.' + ImpersonateService._devDomain + '.dev; ', 'path=/;'].join('');
            } else if (environment === 'production') {
              impersonatedUserCookie = ['impersonatedUser=', JSON.stringify(userToImpersonate), '; domain=.' + ImpersonateService._prodDomain + '.com; ', 'path=/;'].join('');
            } else if (environment === 'staging') {
              impersonatedUserCookie = ['impersonatedUser=', JSON.stringify(userToImpersonate), '; domain=.staging.' + ImpersonateService._prodDomain + '.com; ', 'path=/;'].join('');
            }

            document.cookie = impersonatedUserCookie;

            // Redirect back to list of users.
            $timeout(function() {
              $location.url('site/' + site.id + '/users');
            }, 3000);


            var openUrl = 'http://' + user.origin_url + (environment === 'development' ? ':9000/' : '');
            document.cookie = impersonatedUserCookie;
            $window.open(openUrl);
            $window.close();
          } else {

            var ssoObject = {
              key: site.wskey,
              url: '',
              identifier: user.sso_identifier
            };

            // Redirect to the user's site.
            if (environment === 'development') {
              ssoObject.url = 'http://' + user.origin_url + '/sso';
            } else {
              ssoObject.url = 'https://' + user.origin_url + '/sso';
            }

            ErrorService.clearErrors();

            var safari = safari || undefined;

            $http.post(ssoObject.url, ssoObject).then(function(response) {
              var url = response;

              if (angular.isDefined(safari)) {
                safari.self.browserWindow.openTab(url);
              } else {
                $window.open(url);
              }

              $timeout(function() {
                $location.url('site/' + site.id + '/users');
              }, 1000);
            })['catch'](function(response) {
              ErrorService.showErrors(response, 'Failed test!');
            });
          }
        }
      };
      return ImpersonateService;
    }
  ]);
'use strict';

angular.module('goApp')

.controller('ImpersonateCtrl', ['$timeout', '$http', 'User', 'Site', '$window', '$location', '$stateParams', 'ImpersonateService',
	function($timeout, $http, User, Site, $window, $location, $stateParams, ImpersonateService) {

		// Get the selected user.
		User.impersonate($stateParams.userId).then(function(user) {
			// Now get the user's promotion.
			// Site.show({
			// 	id: user.site_id
			// }, function(site) {

			ImpersonateService.doImpersonation(user, user.site);
			// });
		});
	}
]);
'use strict';

angular.module('goApp')
  .factory('Badge', ['$http', 'ActiveResource', 'DOMAIN', 'HesDate',
    function($http, ActiveResource, DOMAIN, HesDate) {

      var Badge = ActiveResource('/badges/:id', {
        nestedRoutes: ['index', 'create', 'update', 'destroy', 'show'],
        parentResource: 'Site',
        domain: DOMAIN
      });


      Badge.setOrder = function(sequence, site_id) {
        return $http.post(DOMAIN + '/badges/reorder', {
          sequence: sequence,
          site_id: site_id
        });
      };



      return Badge;
    }
  ]);
'use strict';

angular.module('goApp').service('BadgeService', function($rootScope, $filter, Badge, $q, ngDialog, DialogService) {
  var BadgeService = new Object();

  BadgeService._badges = [];
  
  var deferred = null;

  BadgeService.get = function(refresh, site_id, year) {
    if (deferred && deferred.promise.$$state.status == 0) {
      return deferred.promise;
    }

    deferred = $q.defer();
    if (BadgeService._badges.length === 0 || refresh) {
      Badge.index({
          site_id: site_id,
          year: year,
          page_size: 0
        }, function(badges) {
          BadgeService._badges = badges;
          deferred.resolve(BadgeService._badges);
        },
        function(rejection) {
          deferred.reject(rejection);
        });
    } else {
      deferred.resolve(BadgeService._badges);
    }

    return deferred.promise;
  }

  BadgeService._queue = [];
  BadgeService._showing = false;

  BadgeService._showBadges = function($scope) {
    function showNext() {
      if (BadgeService._queue.length == 0) {
        BadgeService._showing = false;
        return;
      };
      $scope.popupBadge = BadgeService._queue.shift();
      var dialog = ngDialog.open({
        template: '/scripts/badges/badgePopup.html',
        scope: $scope,
        showClose: false
      });
      var routeWatcher = DialogService.closeOnRouteChange(dialog);
      dialog.closePromise.then(showNext)
        .finally(function() {
          routeWatcher();
        });
    }
    BadgeService._showing = true;
    showNext();
  }
  
  BadgeService.swapBadge = function(badgeId) {
    var index = BadgeService._badges.map(function(b) {
      return b.id;
    }).indexOf(badgeId);
    var badge = null;
    if (typeof index == 'number' && index > -1) {
      badge = BadgeService._badges[index];
    };
    return badge;
  }

  BadgeService.showBadge = function(badgeId, site_id, $scope, doPopup) {
    var badge = BadgeService.swapBadge(badgeId);
    if (!!badge) {
      badge.$show({
        site_id: site_id,
        year: $scope.$state.params.year
      }, function(response) {
        if (doPopup) {
          BadgeService._queue.push(badge);
          if (!BadgeService._showing) {
            BadgeService._showBadges($scope);
          };
        };
      });
    }
  }

  BadgeService.getCategories = function() {
    return ["days_logged", "weekends_logged", "distance_traveled", "challenges_sent", "challenges_completed", "goals_created", "goals_completed", "goals_shared", "wall_posts_created", "wall_posts_tags", "recipes_rated", "recipes_shared", "evaluation", "campaign_opt_in", "campaign_entries", "campaign_evaluation", "buddies_added", "custom"];
  }
    
  BadgeService.getBadgeById = function(id) {
    return _.find(BadgeService._badges, {
      id: parseInt(id)
    });
  }
  
  BadgeService.getBadges = function() {
    return BadgeService._badges;
  }

  BadgeService.getNumberEarned = function() {
    return _.filter(BadgeService._badges, function(b) {
      return b.earned_on
    }).length;
  }

  BadgeService.upsertBadge = function(badge, new_badge) {
    if (badge.isNew()) {
      BadgeService._badges.push(new_badge);
    } else {
      var index = BadgeService.removeBadge(badge);
      BadgeService._badges.splice(index, 0, new_badge);
    }
  }

  BadgeService.removeBadge = function(badge) {
    var index = BadgeService._badges.map(function(b) {
      return b.id;
    }).indexOf(badge.id);
    if (typeof index == 'number' && index > -1) {
      BadgeService._badges.splice(index, 1);
      return index;
    }
  }

  BadgeService.humanize = function(string) {
    return string.split('_').map(function(partial) {
      return partial[0].toUpperCase() + partial.substring(1);
    }).join(' ');
  }

  BadgeService.clear = function() {
    BadgeService._badges = [];
    BadgeService._queue = [];
    BadgeService._showing = false;
  }

  return BadgeService;

})
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.u.site.badges', {
    title: 'Badges',
    url: '/badges',
    abstract: false,
    controller: 'BadgesListController',
    background: 'filled',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/badges/badgesList.html');
      }
    ],
  });

  $stateProvider.state('go.u.site.badges.edit', {
    title: 'Edit Badge',
    url: '/:badgeId/edit',
    abstract: false,
    controller: 'BadgesEditorController',
    background: 'filled',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/badges/badgesEditor.html');
      }
    ],
  });
  
  $stateProvider.state('go.u.site.badges.new', {
    title: 'New Badge',
    url: '/new',
    abstract: false,
    controller: 'BadgesEditorController',
    background: 'filled',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/badges/badgesEditor.html');
      }
    ],
  });

  $stateProvider.state('go.u.usermenu.badges', {
    title: 'Badges',
    url: '/badges/:year?badge_id',
    params: {
      badge_id: null
    },
    reloadOnSearch : false,
    controller: 'UserBadgesController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/badges/user_badges.html');
      }
    ]
  });

});
'use strict';

angular.module('goApp')
  .controller('BadgesEditorController', ['$scope', 'BadgeService', '$state', 'Badge', 'ErrorService',
    function($scope, BadgeService, $state, Badge, ErrorService) {
      $scope.settings = {
        loading: true,
        saving: false,
        saved: false
      };

      $scope.data = {
        categories: [],
        copy: null
      };

      $scope.humanize = BadgeService.humanize;

      BadgeService.get(false, $scope.dbSite.id).then(function() {
        if ($state.current.name == 'go.u.site.badges.edit') {
          $scope.badge = BadgeService.getBadgeById($state.params.badgeId);
        } else {
          $scope.badge = new Badge({
            site_id: $scope.dbSite.id,
            category: 'custom'
          });
        }
        $scope.badge = angular.copy($scope.badge);
        $scope.data.copy = angular.copy($scope.badge);
        $scope.data.categories = BadgeService.getCategories();
        $scope.settings.loading = false;
      });

      $scope.getFieldLabel = function(category, field) {
        return {
          days_logged:          {goal: 'Number of Days Logged', goal2: null},
          weekends_logged:      {goal: 'Times Logged on Weekends', goal2: null},
          distance_traveled:    {goal: 'Number of Steps', goal2: 'Number of Minutes'},
          evaluation:           {goal: null, goal2: null},
          campaign_opt_in:      {goal: 'App', goal2: null},
          campaign_entries:     {goal: 'App', goal2: "Number of entries"},
          campaign_evaluation:  {goal: "App", goal2: null},
          challenges_sent:      {goal: "Number of Challenges Sent", goal2: null},
          challenges_completed: {goal: "Number of Challenges Completed", goal2: null},
          goals_created:        {goal: "Number of Goals Created", goal2: null},
          goals_completed:      {goal: "Number of Goals Completed", goal2: null},
          goals_shared:         {goal: "Number of Goals Shared", goal2: null},
          wall_posts_created:   {goal: "Number of Posts Created", goal2: null},
          wall_posts_tags:      {goal: "Number of Tags", goal2: null},
          recipes_rated:        {goal: "Number of Recipes rated", goal2: null},
          recipes_shared:       {goal: "Number of Recipes shared", goal2: null},
          buddies_added:        {goal: "Number of Buddies added", goal2: null},
          custom:               {goal: 'Goal', goal2: 'Goal2'},
          undefined:            {goal: 'Goal', goal2: 'Goal2'}
        }[category][field];
      };


      $scope.isCampaignBadge = function(category) {
        return /campaign/.test(category);
      }


      $scope.handleErrors = function(response, message) {
        ErrorService.showErrors(response, 'Could not save Badge');
      };

      $scope.saveBadge = function() {
        $scope.settings.saving = true;
        if ($scope.badge.site_id == null && $scope.dbSite.id != 5) {
          $scope.badge.id = undefined; // create a new badge if default is overridden
        }
        $scope.badge.site_id = $scope.dbSite.id;
        $scope.badge.save(function(new_badge) {
          BadgeService.upsertBadge($scope.badge, new_badge);
          $scope.badge = new_badge;
          $scope.data.copy = $scope.badge;
          $scope.settings.saving = false;
          $scope.settings.saved = true;
          $state.transitionTo("go.u.site.badges.edit", {
            promotionId: $scope.dbSite.id,
            badgeId: new_badge.id
          });
        })['catch']($scope.handleErrors);
      };

      $scope.showPreview = function() {
        BadgeService.showBadge(
          $scope.badge.id,
          $scope.dbSite.id,
          $scope,
          true
        );
      };

      $scope.isBadgeEdited = function(badge) {
        return !$scope.dbSite.isDefault() && $scope.dbSite.id == badge.site_id;
      };


      $scope.saveIcon = function(newImage) {
        $scope.badge.icon = newImage.http_path;
      };

      $scope.isUnchanged = function() {
        return angular.equals($scope.badge, $scope.data.copy);
      };

      $scope.reset = function() {
        $scope.badge = angular.copy($scope.data.copy);
      };

      $scope.reloadBadges = function() {
        BadgeService.get(true, $scope.dbSite.id).then(function(badges){
          $scope.$emit("reloadBadges", badges);
          $state.transitionTo('go.u.site.badges', {
            siteId: $scope.dbSite.id
          });
        });
      };

    }
  ]);

'use strict';

angular.module('goApp').controller('BadgesListController', function($scope, $timeout, BadgeService, $state, Badge, ErrorService, ngDialog, DialogService, Site) {

    $scope.settings = {
      loading: true
    };

    $scope.data = {
      badges: []
    };


    $scope.humanize = BadgeService.humanize;

    $scope.getBadges = function() {
      BadgeService.get(true, $scope.dbSite.id).then(function(badges) {
        $scope.data.badges = badges;
        $scope.settings.loading = false;
      });
    };
    $scope.getBadges();

    $scope.confirmDeleteBadge = function(badge) {
      $scope.badge = badge;
      $scope.badge.site_id = $scope.dbSite.id;
      var title = $scope.dbSite.isDefault() ? 'Delete Badge' : 'Reset Badge';
      var message = $scope.dbSite.isDefault() ? 'Are you sure you want to delete Badge: ' + badge.name + '?' :
        'Are you sure you want to reset Badge: ' + badge.name + ' back to it\'s default?\n\n**Note: If there is no default, it will be deleted.**';
      var confirmText = $scope.dbSite.isDefault() ? 'delete' : 'reset';

      DialogService.openConfirmationDialog(title, message, 'Cancel', confirmText).then(function() {
        badge.destroy().then($scope.getBadges);
      });
    };


    $scope.saveOrder = function() {
      $scope.settings.loading = true;
      var ids = $('.badge-item').map(function(i,e){return e.getAttribute('data-id');}).toArray();
      Badge.setOrder(ids,$scope.dbSite.id).then(function(data){
        $scope.getBadges();
      });
    };

    $(document).on('click', '.move-up,.move-down', function() {
      var row = $(this).parents($(this).parent()[0].tagName + ':first');
      if ($(this).is('.move-up')) {
        row.insertBefore(row.prev());
      } else {
        row.insertAfter(row.next());
      }
    });


    $scope.saveLockedImage = function() {
      $timeout(function(){
        new Site({
          id: $scope.dbSite.id,
          badge_locked_image: $scope.dbSite.badge_locked_image
        }).save(function(site) {
          $scope.dbSite.badge_locked_image = site.badge_locked_image;
        });
      },1000);
    };

    $scope.isBadgeEdited = function(badge) {
      return !$scope.dbSite.isDefault() && $scope.dbSite.id == badge.site_id;
    };

    $scope.isCampaignBadge = function(category) {
      return /campaign/.test(category);
    }

    $scope.getAppName = function(badge) {
      return  _.find($scope.dbSite.app_options, {id: parseInt(badge.goal) }).name
    }

    $scope.$watch(function() {
        return BadgeService.getBadges();
    },
    function(badges) {
      $scope.data.badges = badges;
    });
});
'use strict';

angular.module('goApp').controller('UserBadgesController', function($scope, $rootScope, $state, BadgeService, $location, $timeout, ngDialog) {

  $scope.data = {
    badges: []
  };


  var GROUP_MAP = [
    ["Days Logged", ["days_logged"]],
    ["Weekend Logging", ["weekends_logged"]],
    ["Challenges", ["challenges_sent", "challenges_completed"]],
    ["Goals", ["goals_created", "goals_completed", "goals_shared"]],
    ["Wall Posts", ["wall_posts_created", "wall_posts_tags"]],
    ["Recipes", ["recipes_rated", "recipes_shared"]],
    [$scope.site.friend_label_plural, ["buddies_added"]],
    ["Campaign Opt In", ["campaign_opt_in", "campaign_entries", "campaign_evaluation"]],
  ]

  var FEATURES = [
    [GROUP_MAP[0], $scope.site.flags.is_logging_enabled], // Logging
    [GROUP_MAP[1], $scope.site.flags.is_logging_enabled], // Logging
    [GROUP_MAP[2], $scope.site.flags.is_challenges_enabled], // Challenges
    [GROUP_MAP[3], $scope.site.flags.is_goal_enabled], // Goals
    [GROUP_MAP[4], $scope.site.flags.is_wall_enabled], // Wall
    [GROUP_MAP[5], $scope.site.flags.is_recipes_enabled], // Recipes
    [GROUP_MAP[6], $scope.site.flags.is_peers_enabled], // Peers
    [GROUP_MAP[7], isOptinEnabled()] // Opt-in
  ]

  function isOptinEnabled() {
    var programs = $scope.site.programs;
    return programs.past.length > 0 || programs.current.length > 0 || programs.upcoming.length > 0
  }

  function groupBadges(badges) {
    var grouped = [];
    _.each(GROUP_MAP, function(map, index) {
      var new_category = map[0],
        categories = map[1];
      if (FEATURES[index][1]) {
        _.each(categories, function(c) {
          _.each(_.filter(badges, {
            category: c
          }), function(b) {
            b.category_group = new_category;
            grouped.push(b);
          });
        })
      };
    });
    return grouped;
  }



  $scope.showPopup = function(badge) {
    if (!badge.earned_on) {
      return;
    }
    $scope.popupBadge = badge;
    $rootScope.$broadcast('modelUpdate', {model:"Badge"});
    ngDialog.open({
      template: '/scripts/badges/badgePopup.html',
      scope: $scope,
      showClose: false
    });
  };

  function scrollToBadge(badges) {
    var badge = _.find(badges,{id: parseInt($state.params.badge_id)});
    $location.search({});
    if (badge) {
      $timeout(function(){
        var badge_element = $("#badge_"+badge.id);
        if (badge_element) {
          $('html').animate({
            scrollTop: badge_element.offset().top
          }, 700, function(){
            $scope.showPopup(badge);
          });
        }
      },100);
    }
  }

  $scope.showBadge = function(prevBadge, badge) {
    if (!!prevBadge && prevBadge.category === badge.category) {
      if (!!badge.earned_on || !!prevBadge.earned_on) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };


  $scope.humanize = BadgeService.humanize;

  function fetch() {
    BadgeService.get(true, $scope.site.id, $state.params.year).then(function(badges){
      var grouped_badges = _.groupBy(groupBadges(badges),'category_group');
      $scope.data.badges = grouped_badges;
      scrollToBadge(badges);
    });
  }

  fetch();

  $scope.$on("notificationPublished",function(ev, notification){
    if(notification.type == "badge") {
      fetch();
    }
  })


});

'use strict';

angular.module('goApp').factory('Banner', function($http, $state, $q, ActiveResource, DOMAIN) {

  var Banner = ActiveResource('/banners/:id', {
    domain: DOMAIN,
  });

  var _banners = null;

  Banner.current = function(refresh) {
    var defer = $q.defer();

    if (refresh || _banners == null) {
      Banner.index({page_size: 0, is_hidden: false}).$promise.then(function(banners){
        _banners = banners;
        defer.resolve(_banners);
      }, function(msg){
        defer.reject(msg);
      });
    } else {
      defer.resolve(_banners);
    }
    
    return defer.promise;
  }

  Banner.prototype.createdAt = function() {
    return moment(this.created_at).format(Entry.HUMAN_FORMAT);
  }

  return Banner;
});
'use strict';

angular
  .module('goApp')
  .controller(
    'BillboardEditController',
    function (
      $scope,
      $rootScope,
      $state,
      $timeout,
      Billboard,
      BLOCKS,
      BillboardService
    ) {
      $scope.data = new Object();
      $scope.data.billboard = Billboard.build();
      $scope.data.block_models = [];
      $scope.data.block_types = BillboardService.GROUP_TYPES[$state.params.group] || Object.keys(BLOCKS);
      $scope.view = {
        newStartFresh: false,
        newCopy: false,
        isEdit: true,
        groupLabel: BillboardService.getLabelFromParams($state.params),
        groupTypes: BillboardService.GROUP_TYPES[$state.params.group],
      };

      $scope.data.copy_billboard = {
        type: null,
        default_billboards: [],
        billboard_id: null,
        site_id: $state.params.site_id,
      };

      $scope.returnParams = _.extend($state.params, {
        custom_only: !!$state.params.site_id 
      });

      $scope.taToolbar = [
        ['h1', 'h2', 'h3', 'h4', 'h5', 'p'],
        ['justifyLeft', 'justifyCenter', 'justifyRight'],
        [
          'bold',
          'italics',
          'underline',
          'strikeThrough',
          'ul',
          'ol',
          'insertLink',
        ],
      ];

      var devToHumanTranslations = [
        ['SECTION image_backgroud backgroundImage', 'Image'],
        ['DIV overlay_backgroud overlayColor', 'Color'],
        ['H2 header_main text', 'Text'],
        ['H2 header_main color', 'Text Color'],
        ['P header_secondary text', 'Text'],
        ['P header_secondary color', 'Text Color'],
        ['DIV image_backgroud backgroundImage', 'Image'],
        ['IMG image_app_logo image', 'Image'],
        ['P content_main text', 'Content Text'],
        ['P content_main color', 'Content Color'],
        ['BUTTON button_optin text', 'Text'],
        ['BUTTON button_optin backgroundColor', 'Background Color'],
        ['BUTTON button_optin color', 'Text Color'],
        ['BUTTON button_optin link', 'Link'],
        ['DIV button_container aligned', 'Align'],
        ['DIV learn_more color', 'Color'],
        ['DIV learn_more text', 'Text'],
        ['DIV app_logo_align absoluteAligned', 'Align']
      ];

      var devToHumanAttrTrans = [
        ['image_backgroud', 'Background'],
        ['overlay_backgroud', 'Color Overlay on Background'],
        ['header_main', 'Header Content'],
        ['image_app_logo', 'App Logo'],
        ['content_main', 'Main Content'],
        ['button_container', 'Button Container'],
        ['learn_more', 'Learn More'],
        ['button_optin', 'Button'],
        ['header_secondary', 'Secondary Content'],
      ]

      $scope.humanizeKeys = function (model) {
        var phrase = model.tagName + ' ' + model.attributes + ' ' + model.key;
        var humanKey = null;
        devToHumanTranslations.forEach(function (title) {
          if (title[0] == phrase) {
            return (humanKey = title[1]);
          }
        });
        return humanKey || _.startCase(model.key);
      };

      $scope.humanizeAttributes = function(attributes) {
        var phrase = attributes
        var humanKey = null;
        devToHumanAttrTrans.forEach(function (title) {
          if (title[0] == phrase) {
            return (humanKey = title[1]);
          }
        });
        return humanKey || _.startCase(attributes);
      };

      $scope.editBlock = function (block) {
        $scope.data.block = null;
        $scope.data.templates = Object.keys(
          BLOCKS[$scope.data.billboard.billboard_type]
        );
        $timeout(function () {
          $scope.data.block = block;
        }, 100);
      };

      $scope.removeSpace = function (str) {
        str = str.replace(/[0-9]/g, '');
        return str.replace(/\s/g, '');
      };

      $scope.saveBillboard = function (billboard) {
        var prev_id = billboard.id;

        billboard.save(
          function (data) {
            $scope.data.billboard = Billboard.build(data);
            $scope.editBlock(null);
            if ($scope.data.billboard.id != prev_id) {
              $state.go('go.u.billboardEdit', { id: $scope.data.billboard.id });
            }
            $rootScope.$broadcast('BillboardSaved', {});
          },
          function (err) {
            console.log(err);
            alert('billboard did not save due to error');
          }
        );
      };

      $scope.showBillboard = function (billboard_id) {
        Billboard.show({ id: billboard_id }, function (data) {
          $scope.data.billboard = Billboard.build(data);
          $scope.view.isEdit = true;
          if($scope.data.billboard.blocks.length == 1){
            $scope.editBlock($scope.data.billboard.blocks[0]);
          } else if($scope.data.billboard.billboard_type == 'banner') {
            //Attempt to build the banner block if it doesn't exist (which it won't if it's newer)
            $scope.autoBuildBlocks();
            $scope.editBlock($scope.data.billboard.blocks[0]);
          }
        });
      };

      $scope.previewBillboard = function (billboard) {
        window.open($state.href('go.u.previewBillboard', { id: billboard.id }));
      };

      $scope.destroyBlock = function (block) {
        if (
          confirm('are you sure you want to delete ' + block.name + '?') == true
        ) {
          if (block.id) {
            block.destroy(
              function () {
                init();
              },
              function (err) {
                alert('error deleteing block');
              }
            );
          } else {
            $scope.data.billboard.destroyLocalBlock(block.local_id);
            $scope.data.block = null;
          }
        }
      };

      $scope.colorpickerSettings = {
        control: 'wheel',
        defaultValue: '',
        inline: false,
        letterCase: 'lowercase',
        opacity: false,
        position: 'bottom right',
        theme: 'default',
      };

      $scope.isUploadable = function (key) {
        return _.includes(
          ['backgroundImage', 'image', 'video', 'posterImage', 'videoCaption'],
          key
        );
      };

      $scope.isColor = function (key) {
        return key.toLowerCase().indexOf('color') !== -1;
      };

      $scope.isAlign = function (key) {
        return key.toLowerCase().indexOf('align') !== -1;
      };

      $scope.isLink = function (key) {
        return key.toLowerCase().indexOf('link') !== -1;
      };

      $scope.isButton = function (name) {
        return name.toLowerCase().indexOf('button') !== -1;
      };

      $scope.showPreview = function () {
        return !!$state.params.id;
      };

      $scope.showApp = function () {
        return (
          $scope.data.billboard.billboard_type != null &&
          $scope.data.billboard.billboard_type != 'placeholder' &&
          $scope.data.billboard.billboard_type != 'banner'
        );
      };

      $scope.getDefaultsByType = function () {
        $scope.view.newCopy = !!$scope.data.copy_billboard.type;
        BillboardService.getDefaultsByType(
          $scope.data.copy_billboard.type
        ).then(function (billboards) {
          $scope.data.copy_billboard.default_billboards = billboards || [];
        });
      };

      $scope.startFresh = function () {
        $scope.view.newStartFresh = true;
      };

      $scope.copyToSite = function () {
        BillboardService.copyToSite(
          $scope.data.copy_billboard.billboard_id,
          $scope.data.copy_billboard.site_id
        ).then(function (billboard) {
          $state.transitionTo($state.current.name,
            _.extend($state.params, {
              id: billboard.id,
            }, {reload: true, inherit: false})
          );
          init();

        });
      };

      function isMissingBlocks() {
        return $scope.data.billboard.blocks.length == 0
      }

      $scope.autoBuildBlocks = function () {
        if ($scope.view.newStartFresh || isMissingBlocks()) {
          $scope.data.billboard.blocks = [];
          let selectedType = $scope.data.billboard.billboard_type;
          if (!!selectedType) {
            _.forEach(
              BillboardService.NEW_HERO_BLOCK_TEMPLATES[selectedType],
              function (template) {
                $scope.data.billboard.buildBlock({
                  name: template,
                  template: template
                });
              }
            );
          }
        }
      };

      $scope.groupBlockModels = function(block_models){
        return _.groupBy
      };

      function init() {
        $scope.data.block = null;
        if ($state.params.id) {
          if ($state.params.id != 'new') {
            $scope.showBillboard($state.params.id);
          } else {
            $scope.view.isEdit = false;
          }
        }
      }

      init();
    }
  );

'use strict';

angular
  .module('goApp')

  .config([
    '$stateProvider',
    function ($stateProvider) {
      $stateProvider
        .state('go.u.billboards', {
          title: 'Billboards',
          url: '/billboards?site_id&group&custom_only',
          controller: 'BillboardsController',
          abstract: false,
          templateProvider: [
            'hesTemplateService',
            function (hesTemplateService) {
              return hesTemplateService.getTemplate(
                '/scripts/billboard/admin/billboards.html'
              );
            },
          ],
        })
        .state('go.u.billboardEdit', {
          title: 'Edit Billboard',
          url: '/billboards/:id/edit?site_id&site_name&app_domain&billboard_type&name&group',
          controller: 'BillboardEditController',
          abstract: false,
          templateProvider: [
            'hesTemplateService',
            function (hesTemplateService) {
              return hesTemplateService.getTemplate(
                '/scripts/billboard/admin/billboard-edit.html'
              );
            },
          ],
        })
        .state('go.u.previewBillboard', {
          title: 'Preview Billboard',
          url: '/billboards/:id/preview',
          template:
            "<div billboard-agent billboard-id='$state.params.id' user='user'></div>",
        });
    },
  ]);

'use strict';

angular
  .module('goApp')
  .controller(
    'BillboardsController',
    function ($scope, $filter, $state, BillboardService) {
      $scope.data = {
        tblBillboards: {
          fields: [
            ['name', 'string'],
            ['app_domain', 'string'],
            ['billboard_type', 'string'],
            ['site_id', 'string'],
            [
              'Actions',
              'actions',
              {
                width: 200,
              },
            ],
          ],
          rows: [],
          actions: [],
        },
        defaultBillboards: {
          fields: [
            ['name', 'string'],
            ['app_domain', 'string'],
            ['billboard_type', 'string'],
            ['site_id', 'string'],
            [
              'Actions',
              'actions',
              {
                width: 200,
              },
            ],
          ],
          rows: [],
          actions: [],
        },
      };

      $scope.allBillboards = true;

      $scope.billboardToggle = function () {
        $scope.allBillboards = !$scope.allBillboards;
      };

      $scope.billboardLabel = function () {
        return BillboardService.getLabelFromParams($state.params);
      };

      function setTableData() {
        var rows = [],
          gridRows = [],
          gridRowsDef = [];
        for (var i = 0; i < $scope.data.billboards.length; i++) {
          var ele = $scope.data.billboards[i];
          var eleLink = '/billboards/' + ele.id;

          var destroyBillboard = function (ele) {
            if (
              confirm("Are you sure you want to delete '" + ele.name + "'?") ==
              true
            ) {
              ele.destroy(init);
            }
          };

          ele.row = [
            ele.name || 'N/A',
            ele.app_domain || 'N/A',
            ele.billboard_type || 'N/A',
            ele.site_id || '',
            [
              // ['view', eleLink],
              ['edit', eleLink + '/edit?site_id='+ (ele.site_id || '') +"&group="+$state.params.group],
              // ['users', eleLink + '/users'],
              ['delete', destroyBillboard, ele],
            ],
          ];
          // ]);
          gridRows.push(ele);

          if (!ele.site_id) {
            gridRowsDef.push(ele);
          }
        }

        $scope.data.tblBillboards.rows = gridRows;
        $scope.data.defaultBillboards.rows = gridRowsDef;
      }

      function init() {
        BillboardService.index({
          page_size: 0,
          site_id: $state.params.site_id,
          billboard_group: $state.params.group,
          custom_only: $state.params.custom_only,
        }).then(function (data) {
          $scope.data.billboards = data;
          setTableData();
        });
      }

      init();

      $scope.newBillboard = function () {
        $state.go('go.u.billboardEdit', {
          site_id: $state.params.site_id,
          group: $state.params.group,
          id: 'new'
        });
      };
    }
  );

angular.module('goApp').directive('getBlockModels', function(hesTemplateService, $timeout) {
  var gbm = new Object();

  gbm.restrict = "A";

  gbm.link = function($scope, $element) {

    function getModels() {
      $scope.data.block_models = [];
      var models = $element[0].querySelectorAll("[block-attributes]");

      models.forEach(function(node) {
        var model = _.find(node.attributes, {name:"block-attributes"}).nodeValue,
            key = _.find(node.attributes, {name:"key"}).nodeValue,
            fields = [
              "background-image","image","text","background-color","color",
              "video","poster-image","video-caption", "link", "overlay-color",
              "aligned", "absolute-aligned"
            ];

        fields.forEach(function(field){
          if (_.has(node.attributes,field)) {
            var obj = new Object();
            obj.tagName = node.tagName;
            obj.model = model;
            obj.attributes = key;
            obj.key = _.camelCase(field); // fields save in DB as camelCase
            $scope.data.block_models.push(obj);
          }
        });

      });

    }
    
    // need to let the DOM finish loading the block
    $timeout(getModels,200);
  }

  return gbm;
});
angular.module('goApp').directive('billboardAgent', function(hesTemplateService, DOMAIN, BillboardService, $timeout, Billboard, $rootScope) {
  var billboard = new Object();

  billboard.restrict = "A";
  billboard.templateUrl = hesTemplateService.getTemplateUrl('/scripts/billboard/billboard-agent.html');

  billboard.scope = {
    billboardObj: "=",
    billboardId: "=",
    currentProgram: "=",
    user: "="
  }

  billboard.controller = function($scope) {
    $scope.goToProgram              = $rootScope.goToProgram;
    $scope.downloadHistory          = $rootScope.downloadHistory;
    $scope.isProgramAvailableToUser = $rootScope.isProgramAvailableToUser;
    $scope.hasUserOptedInToProgram  = $rootScope.hasUserOptedInToProgram;
    $scope.humanize                 = $rootScope.humanize;

    $scope.scroll = function($event) {
      var billboard = $($event.currentTarget.closest('.billboard'));
      var next_section = $($(billboard).children()[1]);
      $('html,body').animate({
        scrollTop: billboard.scrollTop() + next_section.offset().top
      }, 700);
    }

    var enqueued = false;

    function getBillboard() {
      if ($scope.billboardObj && typeof $scope.billboardObj == "object") {
        $scope.billboard = Billboard.build($scope.billboardObj);
        return;
      }
      
      if (!$scope.billboardId || enqueued) {
        return;
      }

      enqueued = BillboardService.show({
        id: $scope.billboardId
      });
      
      enqueued.then(function(billboard) {
        $scope.billboard = billboard;
        enqueued = false;
      });
    }

    $scope.$watch("billboardObj",getBillboard);
    $scope.$watch("billboardId",getBillboard);

  }

  return billboard;
});
angular.module('goApp').factory('Billboard', function($http, $state, ActiveResource, Block, DOMAIN, BLOCKS) {

  var Billboard = ActiveResource('/billboards/:id', {
    domain: DOMAIN
  }, {
    copyToSite: {
      method: 'POST',
      url: '/copy_to_site'
    }
  });

  Billboard.build = function(params) {
    var self = new Billboard(params);

    self.blocks = self.blocks || [];
    self.blocks = self.blocks.map(function(block) {
      return new Block(block);
    });

    self.name = self.name || '';
    if ($state.params.site_id) {
    //   if (!self.site_id) {
    //     self.name = [$state.params.site_name,$state.params.billboard_type,$state.params.name].map(_.camelCase).concat(self.name).join(':');
    //   }
      self.site_id = parseInt($state.params.site_id);
    //   self.billboard_type = $state.params.billboard_type;
    //   if($state.params.app_domain) {
    //     self.app_domain = $state.params.app_domain.replace(/%2E/g,'.');
    //   }
    }

    return self;
  }

  Billboard.prototype.buildBlock = function(params) {
    var block = new Block(_.extend({billboard_id: this.id, config_json: {}, local_id: parseInt(Math.random()*1000000)}, params));

    this.blocks.push(block);
    return block;
  }

  Billboard.prototype.destroyLocalBlock = function (local_id) {
    _.remove(this.blocks, {local_id: local_id});
  }

  return Billboard;
});
angular.module('goApp').service('BillboardService', function ($q, Billboard, BLOCKS) {
  var BillboardService = new Object();

  var cached = new Object();

  BillboardService.GROUP_TYPES = {
    'hero': _.remove(Object.keys(BLOCKS), function(n){return n != 'banner'}),
    'banner': _.remove(Object.keys(BLOCKS), function(n){return n == 'banner'})
  };

  BillboardService.NEW_HERO_BLOCK_TEMPLATES = {
    opt_in: [
      'hero_block_version_2',
      'feature_block',
      'friend_block',
      'mobile_block',
      'video_block',
    ],
    coming_soon: ['coming_soon_block'],
    enter: ['enter_block'],
    registration_closed: ['registration_closed_block'],
    placeholder: ['placeholder_block_no_shadow'],
    banner: ['banner_block']
  };

  BillboardService.index = function (params) {
    var deferred = $q.defer();

    params.page_size = 0;

    Billboard.index(
      params,
      function (billboards) {
        deferred.resolve(billboards);
      },
      function (err) {
        alert('error loading billboards with ' + params);
        deferred.reject();
      }
    );

    return deferred.promise;
  };

  BillboardService.show = function (params) {
    var deferred = $q.defer();

    if (!params) {
      deferred.reject();
    }

    var key = JSON.stringify(params);

    if (cached[key]) {
      deferred.resolve(cached[key]);
    } else {
      Billboard.show(params, function (data) {
        var billboard = Billboard.build(data);
        cached[key] = billboard;
        deferred.resolve(billboard);
      });
    }

    return deferred.promise;
  };

  BillboardService.getLabelFromParams = function (params) {
    var label = 'Default ';

    if (!!params.site_id) {
      label = 'Site ';
    }

    if (params.group) {
      label += _.capitalize(params.group);
    }

    return label;
  };

  BillboardService.getDefaultsByType = function(type) {
    return Billboard.index({
      billboard_type: type,
      site_id: null,
      page_size: 0,
    }).$promise;
  }; 

  BillboardService.copyToSite = function(billboard_id, site_id){
    return Billboard.copyToSite({
      id: billboard_id,
      site_id: site_id
    }).$promise;
  }

  return BillboardService;
});

angular.module('goApp').directive('blockAttributes', function(hesTemplateService, $compile, $location, $state, $timeout) {
  var BlockAttributes = new Object();

  BlockAttributes.restrict = "A";

  BlockAttributes.link = function($scope, $element, $attributes) {
    var node = $element[0],
        html = $element.html();

    $scope.hide_element = false;

    var config = _.get($scope, $attributes.blockAttributes),
        key    = $attributes.key;

    if (!config || !key) {
      console.log(config);
      console.log(key);
      console.log("config or key is undefinded");
      return;
    }

    config[key] = config[key] || {};


    function shouldHideElement(value) {
      if ((!value || value == "") && $state.current.name != "go.u.billboardEdit") {
        $scope.hide_element = true;
        return true;
      }
      return false;
    }

    function bindData() {
      $scope.hide_element = false;

      if (_.has($attributes,"backgroundImage")) {
        node.style.backgroundImage = "url("+config[key].backgroundImage+")";
        node.style.backgroundRepeat = "no-repeat";
        node.style.backgroundSize = "cover";
      }

      if (_.has($attributes,"image")) {
        node.src = config[key].image;
        node.alt = "";
        shouldHideElement(config[key].image);
      }

      if (_.has($attributes,"text")) {
        node.innerHTML = config[key].text;
        shouldHideElement(config[key].text);
      }

      if (_.has($attributes,"backgroundColor")) {
        node.style.backgroundColor = config[key].backgroundColor;
      }

      if (_.has($attributes,"overlayColor")) {
        node.style.backgroundColor = config[key].overlayColor;
        node.style.opacity = 0.6;
      }

      if (_.has($attributes,"color")) {
        node.style.color = config[key].color;
      }

      if (_.has($attributes,"aligned")) {
        node.style.textAlign = config[key].aligned;
      }

      if (_.has($attributes,"absoluteAligned")) {
        // Aligns an absolutely position element
        var absAlignVal = config[key].absoluteAligned;
        node.style.width = 'auto';
        switch(absAlignVal){
          case 'left':
            node.style.right = 'auto';
            break;
          case 'center': 
            node.style.right = 'auto';
            node.style.left = 'auto';
            node.style.textAlign = 'center';
            //This might be unique to hero_block_v2 so careful moving forward
            node.style.width = '93%';
            break;
          default:
            node.style.right = '20%';
            node.style.left = 'auto';
            break;
        }
      }



      if (_.has($attributes,"link")) {
        node.role = "link";
        node.href = config[key].link;
        node.onclick = function() {
          if (/^http/.test(config[key].link)) {
            var win = window.open(config[key].link, "_blank");
            win.focus();
          } else {
            // NOTE NP: why is this soo slow???
            //$location.path(config[key].link);
            var win = window.open(config[key].link, "_self");
            win.focus();
          }
        }
      }

      if (_.has($attributes,"video")) {
        node.playsinline = true;
        node.preload = "none";
        // node.crossOrigin = "anonymous";
        node.src = config[key].video;

        if(_.has($attributes,"posterImage")) {
          node.poster = config[key].posterImage;
        }

        if(_.has($attributes,"videoCaption")) {
          var track = document.createElement("track");
          track.id = "video-track";
          track.src = config[key].videoCaption;
          track.kind = "captions";
          track.default = true;
          track.addEventListener("load", function() {
            node.textTracks[0].mode = "hidden";
          });
          node.appendChild(track);
        }

        node.load();
      }

      if ($scope.hide_element) {
        $element.html("<span></span>");
        var contents = $element.contents();
        contents = $compile(contents)($scope);
        $element.replaceWith(contents);
      }

    }

    $scope.$watch(function(){ return config; }, bindData, true);


  }

  return BlockAttributes;
});

angular.module('goApp').factory('Block', function($http, ActiveResource, DOMAIN, BLOCKS) {

  var Block = ActiveResource('/blocks/:id', {
    nestedRoutes: ['destroy'],
    parentResource: ['Billboard'],
    domain: DOMAIN
  });

  Block.prototype.getTemplatePath = function(billboard) {
    return BLOCKS[billboard.billboard_type][this.template];
  }

  return Block;

});
'use strict';

angular.module('goApp').constant("BLOCKS", {
  opt_in: {
    hero_block: "/scripts/billboard/blocks/opt_in/hero_block.html",
    hero_block_no_shadow: "/scripts/billboard/blocks/opt_in/hero_block_no-shadow.html",
    hero_block_version_2: "/scripts/billboard/blocks/opt_in/hero_block_v2.html",
    feature_block: "/scripts/billboard/blocks/opt_in/feature_block.html",
    friend_block: "/scripts/billboard/blocks/opt_in/friend_block.html",
    mobile_block: "/scripts/billboard/blocks/opt_in/mobile_block.html",
    video_block: "/scripts/billboard/blocks/opt_in/video_block.html"
  },
  coming_soon: {
    coming_soon_block: "/scripts/billboard/blocks/coming_soon/coming_soon_block.html"
  },
  enter: {
    enter_block: "/scripts/billboard/blocks/enter/enter_block.html"
  },
  registration_closed: {
    registration_closed_block: "/scripts/billboard/blocks/registration_closed/registration_closed_block.html"
  },
  placeholder: {
    placeholder_block: "/scripts/billboard/blocks/placeholder/placeholder_block.html",
    placeholder_block_no_shadow: "/scripts/billboard/blocks/placeholder/placeholder_block_no_shadow.html"
  },
  banner: {
    banner_block: "/scripts/billboard/blocks/banner/banner_block.html",
    evaluation_block: "/scripts/billboard/blocks/banner/evaluation_block.html",
  }
});
'use strict';
angular.module('goApp')
  .component('hesBreadcrumb', {
    bindings: {
      crumbs: '<'
    },
    templateUrl: '/scripts/breadcrumb/breadcrumb.html',
    controller: function() {

    }
  });
'use strict';

angular.module('goApp').controller('ChallengeEditController', function($scope, $state, Challenge) {
  $scope.data = new Object();
  
  $scope.data.months = [{'month': 'January','value': 1}, {'month': 'February','value': 2},
  {'month': 'March','value': 3}, {'month': 'April','value': 4}, {'month': 'May','value': 5},
  {'month': 'June','value': 6}, {'month': 'July','value': 7},
  {'month': 'August','value': 8}, {'month': 'September','value': 9}, {'month': 'October','value': 10},
  {'month': 'November','value': 11}, {'month': 'December','value': 12}];

  init();

  $scope.save = function(challenge) {
    challenge.site_id = $scope.dbSite.id;
    challenge.save(function(resp) {
      $state.go("go.u.site.challenge_edit", {id: resp.id});
    });
  }


  function init() {
    var id = parseInt($state.params.id);
    if (id) {
      Challenge.show({id: id, site_id: $scope.dbSite.id}, function(challenge) {
        $scope.data.challenge = challenge;
      });
    } else {
      $scope.data.challenge = new Challenge({site_id: $state.params.siteId});
    }
  }


});
'use strict';

angular.module('goApp').controller('ChallengesController', function($scope, $state, Challenge) {

  $scope.data = {
    tblElements: {
      fields: [
        ["name", "string"],
        ["month", "string"],
        ["site_id", "string"],
        ["Actions", "actions", {
          width: 200
        }]
      ],
      rows: [],
      actions: []
    }
  };

  function setTableData() {

    var rows = [],
      gridRows = [];
    for (var i = 0; i < $scope.data.elements.length; i++) {
      var ele = $scope.data.elements[i];
      var eleLink = $state.href("go.u.site.challenge_edit",{id: ele.id});

      var destroyEle = function(ele) {
        if(confirm("Are you sure you want to delete '"+ele.name+"'?") == true){
          ele.destroy(init);
        }
      }

      // rows.push([
      ele.row = [
        (ele.name || 'N/A'),
        (ele.month || 'N/A'),
        (ele.site_id),
        // (site.getNumberOfWeeks() || 'N/A'),
        // site.registration_starts_on || 'N/A',
        // site.registration_ends_on || 'N/A',
        // (site.launch_on),
        [
          // ['view', eleLink],
          ['edit', eleLink ],
          // ['users', eleLink + '/users'],
          ['delete', destroyEle, ele]
        ]
      ];
      // ]);
      gridRows.push(ele);
    }

    $scope.data.tblElements.rows = gridRows;
  }

  function init() {
    Challenge.index({page_size:0, site_id: $scope.dbSite.id}, function(data) {
      $scope.data.elements = data;
      setTableData();
    });
  }
  
  init();

});
'use strict';

angular.module('goApp').factory('Challenge', function($http, $state, ActiveResource, DOMAIN) {

  var Challenge = ActiveResource('/challenges/:id', {
    domain: DOMAIN,
    nestedRoutes: ['index', 'create', 'update', 'destroy', 'show'],
    parentResource: 'Site'
  });

  return Challenge;
});
'use strict';

angular.module('goApp').controller('ChallengeSelectChallengeController', function($scope, $state, $stateParams, Challenge, UserChallenge, DialogService, CurrentSite, $timeout, Friendship) {
  $scope.data = new Object();
  $scope.showAlert = false;
  $scope.hasFriends = false;
  $scope.data.friend_count = {};
  $scope.data.selected_user = $stateParams.user;

  $scope.settings = {
    crumbs: [{
      state: 'go.u.usermenu.challenges.active',
      display: "My Challenges"
    }, {
      state: $state.current.name,
      display: "Select Challenge"
    }]
  }


  Challenge.index(function(challenges){
    $scope.data.challenges = challenges;
  });

  $scope.selectChallenge = function(challenge) {
    $state.go('go.u.usermenu.challenges.select_user',{challenge: challenge});
  }

  $scope.sendChallenge = function(user, challenge) {
    DialogService.openConfirmationDialog("Send a Challenge", description(user,challenge), 'Cancel', "Send").then(function() {
      var user_challenge = new UserChallenge({
        receiver_id: user.id,
        challenge_id: challenge.id
      });
      user_challenge.save(function(data){
        $state.go("go.u.usermenu.challenges.active");
      }, function(response) {
        DialogService.openInformationDialog("Oops!", response.data.errors[0].base[0] + ".", "OK");
      });
    });
  }

  function description(user, challenge) {
    return "If " + [user.profile.first_name,user.profile.last_name].join(" ") + " accepts your  " + challenge.name + " challenge, you'll <strong>both have " + $scope.site.userChallengeDays() + " days</strong> to complete it.";
  }

  Friendship.count().then(function(counts) {
    $scope.data.friend_count = counts;
  });

  $scope.userHasFriends = function() {
    return $scope.data.friend_count && $scope.data.friend_count.accepted > 0;
  }

  // Watch for changes in the data that userHasFriends() depends on
  $scope.$watch('data.friend_count', function(newVal, oldVal) {
    if (newVal !== oldVal) {
      $timeout(function() {
        $scope.showAlert = !$scope.userHasFriends();
        $scope.hasFriends = $scope.userHasFriends();
      }, 800);
    }
  });

  // Initial evaluation
  $timeout(function() {
    $scope.showAlert = !$scope.userHasFriends();
    $scope.hasFriends = $scope.userHasFriends();
    $scope.button_label = ($scope.userHasFriends()) ? "Challenge a " + $scope.site.friend_label : "View Challenges";
  }, 800);

});
'use strict';

angular.module('goApp').controller('ChallengeSelectUserController', function($scope, $state, $stateParams, User, FriendsLoader, DialogService, UserChallenge, CurrentSite) {
  $scope.data = new Object();
  var users = $scope.data.users = [];

  $scope.data.selected_challenge = $stateParams.challenge;

  $scope.settings = {
    crumbs: [{
      state: 'go.u.usermenu.challenges.active',
      display: "My Challenges"
    }, {
      state: 'go.u.usermenu.challenges.select_challenge',
      display: "Select Challenge"
    }, {
      state: $state.current.name,
      display: "Select " + $scope.site.friend_label
    }]
  };


  if (!$scope.data.selected_challenge) {
    $state.go("go.u.usermenu.challenges.select_challenge");
  }

  $scope.onSearchChange = function(query) {
    if(query && query.length == 0) {
      $scope.data.users = users;
    }

    $scope.clearQuery = function() {
      $scope.data.query = '';
      $scope.onSearchChange('');
      document.querySelector('.search input').focus();
      }

    var pattern = new RegExp(query, "i");
    $scope.data.users = _.filter(users, function(u) {
      return pattern.test(u.getFriend().profile.first_name) ||
             pattern.test(u.getFriend().profile.last_name);
    });
    
  }

  $scope.sendChallenge = function(user, challenge) {
    DialogService.openConfirmationDialog("Send a Challenge", description(user,challenge), 'Cancel', "Send").then(function() {
      var user_challenge = new UserChallenge({
        receiver_id: user.id,
        challenge_id: challenge.id
      });
      user_challenge.save(function(data){
        $state.go("go.u.usermenu.challenges.active");
      }, function(response) {
        DialogService.openInformationDialog("Oops!", response.data.errors[0].base[0] + ".", "OK");
      });
    });
  }


  function description(user, challenge) {
    return "If " + [user.profile.first_name,user.profile.last_name].join(" ") + " accepts your  " + challenge.name + " challenge, you'll <strong>both have " + $scope.site.userChallengeDays() + " days</strong> to complete it.";
  }


  new FriendsLoader().then(function(friends){
    users = $scope.data.users = friends;
    $scope.data.has_no_friends = users.length == 0;
  });


});
'use strict';

angular.module('goApp').config(function($stateProvider) {

  // admin states
  $stateProvider.state('go.u.site.challenges', {
    title: 'Challenges',
    url: '/challenges',
    abstract: false,
    controller: 'ChallengesController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/challenges/admin/views/challenges.html');
      }
    ],
  });

  $stateProvider.state('go.u.site.challenge_edit', {
    title: 'Edit Challenge',
    url: '/challenges/:id',
    abstract: false,
    controller: 'ChallengeEditController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/challenges/admin/views/challenge-edit.html');
      }
    ],
  });


  // user states
  $stateProvider.state('go.u.usermenu.challenges', {
    abstract: true,
    template: "<ui-view></ui-view>"
  });
  
  $stateProvider.state('go.u.usermenu.challenges.active', {
    title: 'Active Challenges',
    url: '/challenges/active?challenge_id',
    abstract: false,
    params: {
      challenge_id: null
    },
    reloadOnSearch: false,
    controller: 'UserChallengesController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/challenges/views/active.html');
      }
    ],
  });

  $stateProvider.state('go.u.usermenu.challenges.history', {
    title: 'Challenges History',
    url: '/challenges/history',
    abstract: false,
    controller: 'UserChallengesController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/challenges/views/completed.html');
      }
    ],
  });

  $stateProvider.state('go.u.usermenu.challenges.select_user', {
    title: 'Challenge Select User',
    url: '/challenges/active/select_user',
    abstract: false,
    params: {
      challenge: null
    },
    controller: 'ChallengeSelectUserController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/challenges/views/select-user.html');
      }
    ],
  });

  $stateProvider.state('go.u.usermenu.challenges.select_challenge', {
    title: 'Challenge Select Challenge',
    url: '/challenges/active/select_challenge',
    abstract: false,
    params: {
      user: null
    },
    controller: 'ChallengeSelectChallengeController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/challenges/views/select-challenge.html');
      }
    ],
  });


});
'use strict';

angular.module('goApp').directive("challengeTimer", function(hesTemplateService) {
  return {
    restrict: 'E',
    scope: {
        challenge: '=',
        seconds: '=',
        noIcon: '@',
        noCountdown: '@'
    },
    templateUrl: hesTemplateService.getTemplateUrl('/scripts/challenges/views/challenge-timer.html'),
    controller: function($scope, $interval, $element) {
        $interval(function() {
        }, 1000);

        if (!$scope.noIcon) {
            var i = 0;
            var activeBorder = $element.find("#activeBorder");
            var primaryColor = getComputedStyle(activeBorder[0]).backgroundColor;

            function loopit(){
                i++;
                if (i < 0) {
                    i = 0;
                }
                else if (i > 360) {
                    i = 360;
                }

                if (i > parseInt($scope.challenge.percentageRemaining() * 3.6)) {
                    i = parseInt($scope.challenge.percentageRemaining() * 3.6);
                }
                
                if (i <= 180){
                    activeBorder.css('background-image','linear-gradient(90deg, ' + primaryColor + ' 50%, transparent 50%),linear-gradient(' + (90+ parseInt(i)) + 'deg, #FFFFFF 50%, transparent 50%)');
                }
                else {
                    activeBorder.css('background-image','linear-gradient(' + (i-90) + 'deg, transparent 50%, #FFFFFF 50%),linear-gradient(90deg, transparent 50%, #FFFFFF 50%)');
                }
                
                setTimeout(function(){
                    loopit();
                },1);
            }

            loopit();
        }
    },
  };
});
'use strict';

angular.module('goApp').factory('UserChallenge', function($http, $state, ActiveResource, DOMAIN, Entry) {

  var UserChallenge = ActiveResource('/user_challenges/:id', {
    domain: DOMAIN
  }, {
    updateStatus: {
      method: "PUT",
      url: "/status",
      isArray: false
    }
  });

  UserChallenge.prototype.updateStatus = function(status) {
    var that = this;
    var promise = UserChallenge.updateStatus({id: this.id, status: status}).$promise;
    promise.then(function(challenge) {
      _.merge(that, challenge);
    });
    return promise; 
  }


  UserChallenge.prototype.partner = function(relative_id) {
    return this.isSender(relative_id) ? this.receiver_user : this.sender_user;
  }

  UserChallenge.prototype.isShown = function(relative_id) {
    var completed = this.isSender(relative_id) ? !!this.sender_completed_at : !!this.receiver_completed_at;
    return !completed && !this.canceled_at;
  }


  UserChallenge.prototype.partnerStatus = function(relative_id) {
    if (this.is_completed) {
      return 'completed';
    }
    if (this.isSender(relative_id)) {
      return !!this.receiver_completed_at ? "completed" : !!this.is_expired ? "expired" : "in-progress";
    } else {
      return !!this.sender_completed_at ? "completed" : !!this.is_expired ? "expired" : "in-progress";;
    }
  }

  UserChallenge.prototype.userStatus = function(relative_id) {
    if (this.is_completed) {
      return 'completed';
    }
    if (this.isSender(relative_id)) {
      return !!this.sender_completed_at ? 'completed' : !!this.is_expired ? "expired" : "in-progress";
    } else {
      return !!this.receiver_completed_at ? 'completed' : !!this.is_expired ? "expired" : "in-progress";;
    }
  }

  UserChallenge.prototype.partnerCompletionDate = function(relative_id) {
    if (this.isSender(relative_id) && this.receiver_completed_at) {
      return this.receiver_completed_at;
    } else if (!this.isSender(relative_id) && this.sender_completed_at) {
      return this.sender_completed_at;
    } else {
      return this.expires_at;
    }
  }

  UserChallenge.prototype.userCompletionDate = function(relative_id) {
    if (this.isSender(relative_id) && this.sender_completed_at) {
      return this.sender_completed_at;
    } else if (!this.isSender(relative_id) && this.receiver_completed_at) {
      return this.receiver_completed_at;
    } else {
      return this.expires_at;
    }
  }

  UserChallenge.prototype.createdAt = function(relative_id) {
    var action = this.isSender(relative_id) ? 'Sent' : 'Received';
    return action + " on " + moment(this.created_at).format(Entry.HUMAN_FORMAT);
  }

  UserChallenge.prototype.isCompleted = function(relative_id) {
    return this.isSender(relative_id) ? !!this.sender_completed_at : !!this.receiver_completed_at;
  }

  UserChallenge.prototype.timeRemaining = function() {
    return this.expiresAt();
  }

  UserChallenge.prototype.expiresAt = function() {
    var exp = moment(this.expires_at);
    return { 
      days: -moment().diff(exp, 'days'),
      hours: -moment().diff(exp, 'hours'),
      minutes: -(moment().diff(exp, 'minutes') - (moment().diff(exp, 'hours') * 60)),
      seconds: -(moment().diff(exp, 'seconds') - moment().diff(exp, 'minutes') * 60)
    }
  }

  UserChallenge.prototype.percentageRemaining = function() {
    return parseInt((moment().diff(this.expires_at) / moment(this.accepted_at).diff(this.expires_at)) * 100);
  }

  UserChallenge.prototype.isSender = function(relative_id) {
    return this.sender_id == relative_id;
  }

  UserChallenge.prototype.completedOrExpiredDate = function () {
    return new Date(this.completed_at || this.expires_at);
  }

  UserChallenge.prototype.resultDate = function() {
    return moment(this.completedOrExpiredDate()).format(Entry.HUMAN_FORMAT);
  }
  
  UserChallenge.prototype.partnerCompletedAt = function(relative_id) {
    return moment((this.isSender(relative_id) ? this.receiver_completed_at : this.sender_completed_at)).format(Entry.HUMAN_FORMAT);
  }

  return UserChallenge;
});
'use strict';

angular.module('goApp').controller('UserChallengesController', function($scope, $rootScope, $state, $stateParams, $location, $timeout, DialogService, UserChallenge, User, ngDialog, hesTemplateService, ContentLoader, Friendship) {
  var MAX_CHALLENGES = 5;
  $scope.showAlert = false;
  $scope.hasFriends = false;
  $scope.button_label = null;
  $scope.data = new Object();

  var user_challenges = [];

  $scope.data.counts = {
    active: 0,
    max: MAX_CHALLENGES
  }

  $scope.data.friend_count = {};
  $scope.data.limit = 20;

  init();

  $scope.date = Date.now();

  $scope.updateStatus = function(user_challenge, status) {
    var proceed = false;
    switch (status) {
      case "cancel":
        var action = user_challenge.isSender($scope.user.id) ? "Withdraw from" : "Decline";
        var message = "Are you sure you want to " + action.toLowerCase() + " this challenge?"
        DialogService.openConfirmationDialog("Hold Up!", message, 'Cancel', action.split(" ")[0]).then(function() {
          user_challenge.updateStatus(status).then(onUpdated, onError);
        });
        break;
      default:
        user_challenge.updateStatus(status).then(onUpdated, onError);
    }

    function onUpdated(uc) {
      init();
      if (status == 'accept' || status == "cancel") {
        return;
      }
      
      $scope.data.user_challenge = uc;
      if(uc.completed_at){
        ngDialog.closeAll();
        ngDialog.open({
          className: 'ngdialog-theme-default',
          template: hesTemplateService.getTemplateUrl('/scripts/challenges/views/_completed_popup.html'),
          scope: $scope
        });
      } else {
        ngDialog.closeAll();
        ngDialog.open({
          className: 'ngdialog-theme-default',
          template: hesTemplateService.getTemplateUrl('/scripts/challenges/views/_pending_popup.html'),
          scope: $scope
        });
      }
    }

    function onError(response) {
      DialogService.openInformationDialog("Oops!", response.data.errors[0].base[0] + ".", "OK");
    }
  }

  $scope.$on("modelUpdate", function(e, data) {
    if(data.model == "UserChallenge") {
      init();
    }
  });

  $scope.completedOrExpiredDate = function(user_challenge) {
    return user_challenge.completedOrExpiredDate();
  }

  $scope.confirmComplete = function(user_challenge) {
    $scope.data.user_challenge = user_challenge;
    ngDialog.closeAll();
    ngDialog.open({
      className: 'ngdialog-theme-default',
      template: hesTemplateService.getTemplateUrl('/scripts/challenges/views/_confirm_complete.html'),
      scope: $scope
    });
  }

  $scope.goToAlertLink = function() {
    $state.go('go.u.usermenu.friends.list');
  }

  function init() {
    var filter = $state.current.name == 'go.u.usermenu.challenges.active' ? 'active' : 'completed';
    var limit = $scope.data.limit;

    UserChallenge.index({filter: filter, page_size: limit}, function(data){
      if (filter == "active") {
        if ($state.params.challenge_id) {
          var user_challenge =  _.find(data,{id: parseInt($state.params.challenge_id)});
          if(!user_challenge) {
            DialogService.openInformationDialog("", "This challenge no longer exists.").then(_.noop);
          }
          $location.search({});
        }
        var challenges = [];
        _.times(MAX_CHALLENGES, function() {
          challenges.push(new UserChallenge({id: null}));
        });
        _.each(data,function(uc,i){
          challenges[i] = uc;
        });
        $scope.data.counts.active = data.length;
        $scope.data.user_challenges = user_challenges = challenges;
      } else {
        $scope.data.user_challenges = user_challenges = data;
        $scope.data.has_no_completed = $scope.data.user_challenges.length == 0;
      }
    });
    
    User.stats({user_id: $scope.user.id, year: new Date().getFullYear()}).$promise.then(function(stats) {
      $scope.user.stats = stats;
    });

    Friendship.count().then(function(counts) {
      $scope.data.friend_count = counts;
    });

    $scope.userHasFriends = function() {
      return $scope.data.friend_count && $scope.data.friend_count.accepted > 0;
    }

    // Watch for changes in the data that userHasFriends() depends on
    $scope.$watch('data.friend_count', function(newVal, oldVal) {
      if (newVal !== oldVal) {
        $timeout(function() {
          $scope.showAlert = !$scope.userHasFriends();
          $scope.hasFriends = $scope.userHasFriends();
        }, 800);
      }
    });

    // Initial evaluation
    $timeout(function() {
      $scope.showAlert = !$scope.userHasFriends();
      $scope.hasFriends = $scope.userHasFriends();
      $scope.button_label = ($scope.userHasFriends()) ? "Challenge a " + $scope.site.friend_label : "View Challenges";
    }, 800);

  
  }

  $scope.showMore = function() {
    $scope.data.limit += 20; // Standard page size
    init()
  }

  $scope.showPlaceholder = function(user, user_challenge) {
    return !user_challenge.id;
  }

  $scope.showPending = function(user, user_challenge) {
    return !!user_challenge.id && !user_challenge.is_active && user_challenge.isShown(user.id);
  }

  $scope.showActive = function(user, user_challenge) {
    return !!user_challenge.id && user_challenge.is_active && user_challenge.isShown(user.id)
  }

  new ContentLoader({
    site_id: $scope.site.id,
    category: 'explanations'
  }, false).then(function(content) {
      $scope.data.content = _.find(content,{key:'challenge'});
  });

});
'use strict';

angular.module('goApp')
  .component('hesChooseLogging', {
    bindings: {
      'user': '<',
      'site': '<',
      'onUserUpdated': '&?',
      'onSelectDevice': '&'
    },
    templateUrl: '/scripts/choose-logging/choose-logging.html',
    controller: function(ContentService) {
      var ctrl = this;

      ctrl.view = {
        logManualContent: {}
      };

      ctrl.chooseManual = function() {
        ctrl.view.saving = true;
        ctrl.user.saveManuallyLog()
          .then(function(user) {
            if (!!ctrl.onUserUpdated) {
              ctrl.onUserUpdated(user);
            }
          }).finally(function() {
            ctrl.view.saving = false;
          });
      };

      ctrl.chooseDevice = function() {
        ctrl.onSelectDevice();
      };

      ctrl.$onInit = function() {
        ctrl.view.logManualContent = ContentService
          .getContentByCategoryAndKey('choose_device', ctrl.site.id, 'logging_manual_message');
      }
    }
  });
'use strict';

angular.module('hes.config')
  .controller('ConfigController', ['site', '$scope', '$rootScope', '$state', 'hesTemplateService',
    function(site, $scope, $rootScope, $state, hesTemplateService) {


      $scope.hesTemplateService = hesTemplateService;
      $scope.$state = $state;

      $scope.isUserPage = function() {
        return $scope.$state.current.name.indexOf('go.u') === 0;
      };

      $scope.isWelcomePage = function() {
        return $scope.$state.current.name.indexOf('go.welcome') === 0;
      };

      $scope.$on('$destroy', function() {
        $scope.$state = null;
      });
    }
  ]);
'use strict';

angular.module('hes.config')
	.service('ConfigService', ['$rootScope', '$q', '$http', 'CurrentSite',
		 function($rootScope, $q, $http, CurrentSite) {

			var configService = {
				getSite: function() {
					return CurrentSite.get(true);
				}
			};

			return configService;
		}
	]);

'use strict';

angular.module('hes.config')
  .controller('ConfigUserController', ['$rootScope', '$scope', 'CurrentUser', 'CurrentSite', '$state', 'Utils', '$q', 'HesDate', '$timeout', 'ngDialog',
    function($rootScope, $scope, CurrentUser, CurrentSite, $state, Utils, $q, HesDate, $timeout, ngDialog) {

      $scope.settings = {
        hasDirtyForm: false
      };

      $scope.view = {
        current: Utils.isUndefinedOrNull($state.params.view) ? 'act' : $state.params.view,
        act: 1,
        mobile: {
          current: null
        }
      };

      function hideAllMobile() {
        $scope.view.mobile.current = null;
      }

      function showMobile(value) {
        if ($scope.view.mobile.current !== value) {
          $scope.view.mobile.current = value;
        } else {
          hideAllMobile();
        }
      }

      $scope.switchView = function(view, act) {
        $scope.view.current = view;
        $scope.view.act = (act || $scope.view.act);
      };
    }
  ]);
'use strict';

angular.module('hes.constants').constant('PROG_NAME', (function() {
	var programName = 'default';

	if (window.location.hostname !== 'localhost') {
		var parts = window.location.hostname.split('.');
		programName = parts[1];
	}

	return programName;
})());

angular.module('hes.constants').constant('dynamicTemplate', function(dir, subDir, file) {
	return '/scripts/home/home.html';
});

angular.module('hes.constants').constant('MONTHS', [{
	'month': 'Jan',
	'value': '01'
}, {
	'month': 'Feb',
	'value': '02'
}, {
	'month': 'Mar',
	'value': '03'
}, {
	'month': 'Apr',
	'value': '04'
}, {
	'month': 'May',
	'value': '05'
}, {
	'month': 'Jun',
	'value': '06'
}, {
	'month': 'Jul',
	'value': '07'
}, {
	'month': 'Aug',
	'value': '08'
}, {
	'month': 'Sep',
	'value': '09'
}, {
	'month': 'Oct',
	'value': '10'
}, {
	'month': 'Nov',
	'value': '11'
}, {
	'month': 'Dec',
	'value': '12'
}]);

angular.module('hes.constants').constant('MONTH_DAYS', [{
	"day": 1,
	"value": 1
}, {
	"day": 2,
	"value": 2
}, {
	"day": 3,
	"value": 3
}, {
	"day": 4,
	"value": 4
}, {
	"day": 5,
	"value": 5
}, {
	"day": 6,
	"value": 6
}, {
	"day": 7,
	"value": 7
}, {
	"day": 8,
	"value": 8
}, {
	"day": 9,
	"value": 9
}, {
	"day": 10,
	"value": 10
}, {
	"day": 11,
	"value": 11
}, {
	"day": 12,
	"value": 12
}, {
	"day": 13,
	"value": 13
}, {
	"day": 14,
	"value": 14
}, {
	"day": 15,
	"value": 15
}, {
	"day": 16,
	"value": 16
}, {
	"day": 17,
	"value": 17
}, {
	"day": 18,
	"value": 18
}, {
	"day": 19,
	"value": 19
}, {
	"day": 20,
	"value": 20
}, {
	"day": 21,
	"value": 21
}, {
	"day": 22,
	"value": 22
}, {
	"day": 23,
	"value": 23
}, {
	"day": 24,
	"value": 24
}, {
	"day": 25,
	"value": 25
}, {
	"day": 26,
	"value": 26
}, {
	"day": 27,
	"value": 27
}, {
	"day": 28,
	"value": 28
}, {
	"day": 29,
	"value": 29
}, {
	"day": 30,
	"value": 30
}, {
	"day": 31,
	"value": 31
}]);

angular.module('hes.constants').constant('SITE', window.location.hostname);
angular.module('hes.constants').constant('DOMAIN', '//' + window.location.hostname + (!!window.location.port ? ':' + 8080 : '') + '/api');

angular.module('hes.constants').constant('STATE_CHOICES', [{
	'stateName': 'Alabama',
	'abbreviation': 'AL'
}, {
	'stateName': 'Alaska',
	'abbreviation': 'AK'
}, {
	'stateName': 'Arizona',
	'abbreviation': 'AZ'
}, {
	'stateName': 'Arkansas',
	'abbreviation': 'AR'
}, {
	'stateName': 'California',
	'abbreviation': 'CA'
}, {
	'stateName': 'Colorado',
	'abbreviation': 'CO'
}, {
	'stateName': 'Connecticut',
	'abbreviation': 'CT'
}, {
	'stateName': 'Delaware',
	'abbreviation': 'DE'
}, {
	'stateName': 'District Of Columbia',
	'abbreviation': 'DC'
}, {
	'stateName': 'Florida',
	'abbreviation': 'FL'
}, {
	'stateName': 'Georgia',
	'abbreviation': 'GA'
}, {
	'stateName': 'Hawaii',
	'abbreviation': 'HI'
}, {
	'stateName': 'Idaho',
	'abbreviation': 'ID'
}, {
	'stateName': 'Illinois',
	'abbreviation': 'IL'
}, {
	'stateName': 'Indiana',
	'abbreviation': 'IN'
}, {
	'stateName': 'Iowa',
	'abbreviation': 'IA'
}, {
	'stateName': 'Kansas',
	'abbreviation': 'KS'
}, {
	'stateName': 'Kentucky',
	'abbreviation': 'KY'
}, {
	'stateName': 'Louisiana',
	'abbreviation': 'LA'
}, {
	'stateName': 'Maine',
	'abbreviation': 'ME'
}, {
	'stateName': 'Maryland',
	'abbreviation': 'MD'
}, {
	'stateName': 'Massachusetts',
	'abbreviation': 'MA'
}, {
	'stateName': 'Michigan',
	'abbreviation': 'MI'
}, {
	'stateName': 'Minnesota',
	'abbreviation': 'MN'
}, {
	'stateName': 'Mississippi',
	'abbreviation': 'MS'
}, {
	'stateName': 'Missouri',
	'abbreviation': 'MO'
}, {
	'stateName': 'Montana',
	'abbreviation': 'MT'
}, {
	'stateName': 'Nebraska',
	'abbreviation': 'NE'
}, {
	'stateName': 'Nevada',
	'abbreviation': 'NV'
}, {
	'stateName': 'New Hampshire',
	'abbreviation': 'NH'
}, {
	'stateName': 'New Jersey',
	'abbreviation': 'NJ'
}, {
	'stateName': 'New Mexico',
	'abbreviation': 'NM'
}, {
	'stateName': 'New York',
	'abbreviation': 'NY'
}, {
	'stateName': 'North Carolina',
	'abbreviation': 'NC'
}, {
	'stateName': 'North Dakota',
	'abbreviation': 'ND'
}, {
	'stateName': 'Ohio',
	'abbreviation': 'OH'
}, {
	'stateName': 'Oklahoma',
	'abbreviation': 'OK'
}, {
	'stateName': 'Oregon',
	'abbreviation': 'OR'
}, {
	'stateName': 'Pennsylvania',
	'abbreviation': 'PA'
}, {
	'stateName': 'Rhode Island',
	'abbreviation': 'RI'
}, {
	'stateName': 'South Carolina',
	'abbreviation': 'SC'
}, {
	'stateName': 'South Dakota',
	'abbreviation': 'SD'
}, {
	'stateName': 'Tennessee',
	'abbreviation': 'TN'
}, {
	'stateName': 'Texas',
	'abbreviation': 'TX'
}, {
	'stateName': 'Utah',
	'abbreviation': 'UT'
}, {
	'stateName': 'Vermont',
	'abbreviation': 'VT'
}, {
	'stateName': 'Virginia',
	'abbreviation': 'VA'
}, {
	'stateName': 'Washington',
	'abbreviation': 'WA'
}, {
	'stateName': 'West Virginia',
	'abbreviation': 'WV'
}, {
	'stateName': 'Wisconsin',
	'abbreviation': 'WI'
}, {
	'stateName': 'Wyoming',
	'abbreviation': 'WY'
}])
'use strict';

// Resource.
angular.module('goApp')

.factory('ContactRequest', ['ActiveResource', 'DOMAIN',
	function(ActiveResource, DOMAIN) {
		var ContactRequest = ActiveResource('/contact_requests/:id', {
			domain: DOMAIN
		});

		return ContactRequest;
	}
]);

// Controller.
angular.module('goApp')

.controller('ContactController', ['$scope', '$rootScope', '$q', 'CurrentUser', 'CurrentSite', 'ContentLoader', 'Content', 'ContactRequest', 'bowser', 'SITE',
	function($scope, $rootScope, $q, CurrentUser, CurrentSite, ContentLoader, Content, ContactRequest, bowser, SITE) {

		function initializeContactRequest(user) {
			$scope.contactRequest = new ContactRequest();

			// User info.
			if(user && !!$scope.user && !!$scope.user.profile) {
				$scope.contactRequest.first_name = $scope.user.profile.first_name;
				$scope.contactRequest.last_name = $scope.user.profile.last_name;
				$scope.contactRequest.email = $scope.user.email;
			}


			$scope.contactRequest.organization = $scope.site.name;

			// Other info.
			$scope.contactRequest.extra_tags = SITE;

			$scope.contactRequest.info = {
				browser_name: bowser.name,
				browser_version: bowser.version,
				operating_system: navigator.userAgent.split(/\(([^)]+)\)/)[1],
				session_data: user ? JSON.stringify($scope.user) : 'No User',
				user_id: user ? $scope.user.id : 'No User'
			}

			resetValidationErrors();
		}

		CurrentSite.get().then(function(site) {
			new ContentLoader({
			category: 'contact',
			site_id: $scope.site.id
			}).then(function(contents) {
			  $scope.messages = contents;
			  $scope.messages.contact = Content.getByKey($scope.messages, 'default_contact_message', true);
			});
		})['catch'](function(err) {
			console.log(err);
		});


		function isFormValid() {
			return !$scope.firstNameRequired && !$scope.lastNameRequired && !$scope.emailRequired && !$scope.commentsRequired;
		}

		function resetValidationErrors() {
			$scope.contactRequest.invalid = false;
			$scope.firstNameRequired = false;
			$scope.lastNameRequired = false;
			$scope.emailRequired = false;
			// $scope.phoneRequired = false;
			// $scope.phoneFormatIncorrect = false;
			$scope.commentsRequired = false;
		}

		// function validatePhoneNumber() {

		// 	if ((/^\d{10,}$/).test($scope.contactRequest.phone.replace(/[\s()+\-\.]|ext/gi, ''))) {
		// 		$scope.phoneRequired = false;
		// 	} else {
		// 		$scope.phoneRequired = true;
		// 		$scope.phoneFormatIncorrect = true;
		// 	}
		// }

		$scope.submitContactRequest = function() {
			resetValidationErrors();

			if (!$scope.contactRequest.first_name) {
				$scope.firstNameRequired = true;
			}

			if (!$scope.contactRequest.last_name) {
				$scope.lastNameRequired = true;
			}

			if (!$scope.contactRequest.email) {
				$scope.emailRequired = true;
			}

			// if (!$scope.contactRequest.phone) {
			// 	$scope.phoneRequired = true;
			// } else {
			// 	validatePhoneNumber();
			// }

			if (!$scope.contactRequest.comments) {
				$scope.commentsRequired = true;
			}

			if (isFormValid()) {
				$scope.sendingContactRequest = true;

				$scope.contactRequest.create(function(response) {
					$scope.sendingContactRequest = false;
					$scope.contactRequestSent = true;
					$rootScope.announcer.message = $scope.explanations.contact_request_sent.content;
				}, function(error) {
					$scope.sendingContactRequest = false;
					$scope.contactRequestError = true;
				});
			} else {
				$scope.contactRequest.invalid = true;
				$scope.sendingContactRequest = false;
			}
		};

		// Get site and user first.
		$q.all([
			CurrentSite.get(),
			CurrentUser.get()
		]).then(function() {
			$scope.contactRequestSent = false;
			$scope.contactRequestError = false;

			initializeContactRequest(true);
		}, function() {
			initializeContactRequest(false);
		});
	}
]);

'use strict';

angular.module('goApp')

.config(['$stateProvider',
	function($stateProvider) {
		$stateProvider
			.state('go.help.contact', {
				title: 'Contact',
				url: '/contact',
				controller: 'ContactController',
				abstract: false,
				templateProvider: ['hesTemplateService',
					function(hesTemplateService) {
						return hesTemplateService.getTemplate('/scripts/contact/contact.html');
					}
				]
			});
	}
]);
'use strict';

angular.module('goApp')
  .factory('ContentLoader', ['Content', '$q', 'Utils', 'ContentService', '$rootScope',
    function(Content, $q, Utils, ContentService, $rootScope) {
      return function(opts, refresh) {
        var defer = $q.defer();

        if(Utils.isUndefinedOrNull(refresh)) {
          refresh = false;
        }

        opts = opts || {};
        var options = _.merge({
          site_id: opts.site_id,
          category: opts.category,
          page_size: 0,
          hidden: opts.hidden
        }, opts);

        if(refresh) {
          Content.index(options, function(content) {
            ContentService.setContentsForCategory(content, options.category, options.site_id);
            defer.resolve(content);
          }, function() {
            defer.reject('Custom Content could not be found');
          });
        } else {
          ContentService.loadSiteContent(options.site_id).then(function(){
            var content = ContentService.getContentsForCategory(options.category, options.site_id);
            if (content) {
              defer.resolve(content);
            } else {
              //defer.reject("no content for " + options.category);
              // no need to reject the promise if there is legitimately no content
              defer.resolve([]);
            }
          });
        }

        return defer.promise;
      };
    }
  ])

'use strict';

angular.module('goApp')
  .factory('Content', ['$http', 'ActiveResource', 'DOMAIN', 'HesDate', '$filter', '$state',
    function($http, ActiveResource, DOMAIN, HesDate, $filter, $state) {

      var Content = ActiveResource('/custom_content/:id', {
        nestedRoutes: ['index', 'show', 'allSiteContent'],
        parentResource: 'Site',
        domain: DOMAIN
      }, {
        like: {
          method: 'POST',
          likeable_type: 'custom_content',
          url: '/likes'
        },
        unlike: {
          method: 'DELETE',
          likeable_type: 'custom_content',
          url: '/likes'
        },
        allSiteContent: {
          method: 'GET',
          params: {
            structured: true,
            page_size: 0,
            category: null,
            id: null
          },
          isArray: true
        }
      });

      Content.getByKey = function(contentArray, key, strict) {
        if (strict === null || strict === undefined) {
          strict = true;
        }
        var result = $filter('filter')(contentArray, {
          key: key
        }, strict);
        if (result !== undefined && result.length === 1) {
          result = result[0];
        } else if (result.length === 0) {
          result = new Content({
            key: key
          });
        }
        return result;
      };

      Content.getByKeyGroup = function(contentArray, key) {
        var result = $filter('filter')(contentArray, function(e) {
          return e.key.indexOf(key) === 0 && (e.key.indexOf('+') === -1 || e.key.indexOf('+') === key.length);
        });
        return result;
      };

      Content.getByGroup = function(contentArray, group, strict) {
        if (strict === null || strict === undefined) {
          strict = true;
        }

        return $filter('filter')(contentArray, {
          group: group
        }, strict);
      };

      Content.orderBySequence = function(contentArray) {
        return $filter('orderBy')(contentArray, 'sequence');
      };

      Content.removeWallContent = function(contentArray) {
        return $filter('filter')(contentArray, {
          key: '!wall'
        });
      };

      Content.removeFriendsContent = function(contentArray) {
        return $filter('filter')(contentArray, {
          key: '!friends'
        });
      };

      Content.getRandomItem = function(contentArray) {
        var index = _.random(contentArray.length - 1);
        return contentArray &&
          contentArray.length &&
          contentArray[index];
      };

      Content.setOrder = function(sequence, siteId, category, successCallback, errorCallback) {
        $http.post(DOMAIN + '/sites/' + siteId + '/custom_content/reorder?hidden=true&category=' + category, {
          sequence: sequence
        }).then(successCallback, errorCallback);
      };

      Content.prototype.getFullUrl = function(routeName) {
        return $state.href(routeName, {
          key: this.key
        }, {
          absolute: true
        });
      };

      Content.prototype.humanize = function(string) {
        return string.split('_').map(function(partial) {
          return partial[0].toUpperCase() + partial.substring(1);
        }).join(' ');
      };

      return Content;
    }
  ]);
'use strict';

angular.module('goApp')
  .config(['$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('go.u.site.content', {
          url: '/content/:category',
          template: '<div ui-view></div>',
          abstract: true,
          // resolve: {
          //   contents: ['ContentLoader', '$stateParams',
          //     function(ContentLoader, $stateParams) {
          //       return new ContentLoader({
          //         site_id: $stateParams.siteId,
          //         category: $stateParams.category,
          //         hidden: true
          //       },true);
          //     }
          //   ]
          // }
        })
        .state('go.u.site.content.welcome', {
          url: '/welcome',
          abstract: false,
          controller: 'ContentAddEditController',
          contentHtml: '/scripts/content/contentPreview.html',
          templateProvider: ['hesTemplateService',
            function(hesTemplateService) {
              return hesTemplateService.getTemplate('/scripts/content/contentAddEdit.html');
            }
          ],
        })
        .state('go.u.site.content.editadd', {
          url: '/editadd',
          abstract: false,
          controller: 'ContentAddEditController',
          contentHtml: '/scripts/content/contentPreview.html',
          templateProvider: ['hesTemplateService',
            function(hesTemplateService) {
              return hesTemplateService.getTemplate('/scripts/content/contentAddEdit.html');
            }
          ],
        })
    }
  ]);
'use strict';

var generateKeys = function() {
  var keyArrary = [];
  for (var i=1; i <= 125; i++) {
   keyArrary.push('post_' + i);
  }
  return keyArrary;
}

var autoGeneratedKeys = generateKeys();

angular.module('goApp')
  .service('ContentService', ['Content', '$filter', '$q', '$rootScope', 'Site', '$state','LocationService',
    function(Content, $filter, $q, $rootScope, Site, $state, LocationService) {
      var ContentService = {
        _contents: {},
        noAddGroups: [],
        hasGroups: ['resources', 'goal_images', 'location_resources'],
        noAddKeys: ['branding','monthly_email','app_email_banners', 'optin_program_overlay', 'evaluation_banner', 'explanations', 'unsubscribe', 'shared_logging_content', 'eligibility', 'registration', 'wall', 'evaluation', 'friends', 'other_resources', 'leaderboards', 'mobile', 'emails', 'application_messages', 'mobile_overlay', 'tips', 'welcome_logo', 'location_resources', 'welcome_elevate', 'mobile_password_instructions','monthly_notifications', 'cookie_consent'],
        noModifyKeys: [],
        noHiddenCheckbox: ['eligibility', 'application_messages', 'tips', 'welcome_logo', 'settings', 'webcart', 'countdown', 'home', 'registration', 'emails', 'sms_templates'],
        noRichTextKeys: {
          // use specific key to hide rich text
          // use empty array to hide rich text for all keys
          'auto_moderator': ['summary'],
        },
        richTextEnabledKeys: {
          description: {
            'google_health': ['marketplace_description']
          }
        },
        isSequenced: ['resources', 'location_resources', 'faqs', 'how_it_works', 'articles', 'prestart', 'tips','walkthrough'],
        image1: {
          categoryLabels: {
            'welcome_logo': 'Welcome Logo',
            'hes_app_content': "Logo",
            'monthly_email': "Email Banner"
          },
          keyLabels: {
            'global_email_message': 'Appears at the bottom of every email (custom, daily, peer requests, etc.)',
            'launchpad_welcome_email': 'Welcome Email Image (if not set will use default)',
            'aktivetrak_welcome_email': 'Welcome Email Image (if not set will use default)',
            'elevate_welcome_email': 'Welcome Email Image (if not set will use default)',
            'daily_main': "appears at the bottom of the next daily email that's sent out. It disappears after 1 day",
            'forgot_password': 'Forgot Password Email Image (if not set will use default)'
          },
          showCategory: ['branding','monthly_email','app_email_banners', 'evaluation_banner', 'walkthrough', 'how_it_works', 'articles', 'welcome', '404', 'messaging', 'mobile_overlay', 'summary_prestart', 'tips', 'welcome_logo', 'hes_app_content', 'resources', 'location_resources', 'auto_generated_emails', 'feature_descriptions', 'auto_moderator'],
          showKeys: {
            'emails': ['global_email_message', 'elevate_welcome_email', 'aktivetrak_welcome_email', 'launchpad_welcome_email', 'daily_main', 'forgot_password', 'password_reset_confirmation'],
            'wall': ['wall_moderator_name', 'guidelines'],
            'health_connect': ['health_connect_icon', 'app_sync'],
            'health_kit': ['health_kit_icon', 'app_sync'],
            'google_health': ['marketplace', 'marketplace_description'],
            'mobile': ['ios_app_link', 'android_app_link']
          },
          hiddenKeys: {
            'mobile': ['active_program_log_message'],
          },
        },
        image2: {
          categoryLabels: {
            'goal_images': 'Image'
          },
          keyLabels: {},
          showCategory: ['welcome', 'articles', 'goal_images', 'mobile_overlay'],
          showKeys: {
            'competition': [],
            'emails': ['forgot_password'],
          },
          hiddenKeys: {}
        },
        mobile_image1: {
          categoryLabels: {},
          keyLabels: {},
          showCategory: ['articles', 'tips'],
          showKeys: {},
          hiddenKeys: {}
        },
        email_image: {
          categoryLabels: {},
          keyLabels: {},
          showCategory: [],
          showKeys: {},
          hiddenKeys: {}
        },
        sequence: {
          categoryLabels: {
            'tips': 'Day'
          },
          keyLabels: {},
        },
        summary: {
          categoryLabels: {
            'google_health': 'Disclaimer (Terms of Service & Privacy Policy)',
            'eligibility': 'Label',
            'shared_logging_content': 'Paragraph',
            'resources': "Link (use 'http://' if link is external)",
            'location_resources': "Link (use 'http://' if link is external)",
            'marketplace': 'Line 2'
          },
          keyLabels: {
            'resources': 'Link'
          },
          hiddenCategory: ['branding','monthly_email','auto_generated_emails', 'app_email_banners', 'optin_program_overlay', 'welcome_elevate', 'contact', 'explanations', 'unsubscribe', 'evaluation', 'registration', 'custom_emails', 'privacy', 'terms', 'countdown', 'emails', 'home', 'webcart', 'settings', 'welcome_logo', 'goal_images', , 'hes_app_content', 'choose_device','walkthrough', 'sms_templates', 'mobile_password_instructions', 'monthly_notifications'],
          hiddenKeys: {
            'google_health': ['marketplace'],
            'marketplace': ['connection_failed'],
            'recipes': ['no_favorites_message'],
            'wall': ['wall_moderator_name'],
            'reset_password': ['forgot_password','password_reset_success','password_reset_expired'],
            'mobile': ['active_program_log_message'],
          },
          useHtmlInput: ['resources','location_resources'],
        },
        description: {
          categoryLabels: {},
          keyLabels: {
            'google_health': {
              'marketplace_description': 'Button Label'
            }
          },
          showCategory: [],
          showKeys: {
            'google_health': ['marketplace_description']
          },
          hiddenKeys: {}
        },
        title: {
          categoryLabels: {
            'faqs': 'Question',
            'emails': 'Subject Line (if blank, it will be default)',
            '404': 'Color',
            'resources': 'Resource title',
            'location_resources': 'Resource title',
            'mapwalk': 'Dialog Title',
            'step_conversions': 'Activity',
            'eligibility': 'Dialog Title',
            'goal_images': 'Caption',
            'sms_templates': "SMS Template Name"
          },
          keyLabels: {
            'logging': {
              'unavailable_until_logging_begins': 'Message'
            },
            'reset_password': {
              'forgot_password': 'Dialog Title',
              'password_reset_success': 'Dialog Title',
              'password_reset_expired': 'Dialog Title'
            },
            'mobile': {
              'ios_app_link': 'iOS application link',
              'android_app_link': 'Android application link'
            },
            'emails': {
              'welcome_mobile': 'Mobile Blurb Heading'
            },
            'wall': {
              'wall_moderator_name': 'Wall Moderator Name',
              'guidelines': 'Guidelines'
            },
            'choose_device': {
              'logging_manual_message': 'Logging Manually Message'
            }
          },
          hiddenCategory: ['monthly_email','app_email_banners', 'optin_program_overlay', 'welcome_elevate', 'unsubscribe', 'privacy', 'terms', 'contact', 'countdown', 'home', 'hes_app_content', 'shared_logging_content', 'explanations','monthly_notifications', 'cookie_consent', 'marketplace'],
          showKeys: {
            'health_connect': ['health_connect_icon', 'app_sync'],
            'health_kit': ['health_kit_icon', 'app_sync'],
            'google_health': ['marketplace', 'marketplace_description']
          },
          hiddenKeys: {
            'mapwalk': ['mw_description', 'mw_register', 'mw_agreement'],
            'logging': ['unavailable_until_logging_begins'],
            'emails': ['welcome_mobile_sso'],
            'registration': ['mobile_password_message','password_requirement_error_message'],
            'recipes': ['no_favorites_message'],
          }
        },
        content: {
          categoryLabels: {
            'reset_password': 'Message',
            'faqs': 'Answer',
            'eligibility': 'Message',
            'hes_app_content': "Description",
            'shared_logging_content': "Headline",
            'sms_templates': "Message",
            'cookie_consent': 'Message',
            'mobile': "Message",
            'marketplace': 'Line 1'
          },
          keyLabels: {
            'mapwalk': {
              'mw_agreement': 'Checkbox Label'
            },
            'other_resources': {
              'conversion_paragraph_and_pdf_link': 'Conversion Paragraph and PDF link'
            },
            'prestart': {
              'message': 'Message to display at top of Getting Started'
            },
            'emails': {
              'welcome_mobile': 'Mobile Blurb Content',
              'welcome_mobile_sso': 'SSO Mobile Note',
              'global_email_message': 'Content: Appears at the bottom of emails (daily, peer requests, etc.) Not Custom',
              'daily_main': "Content :Daily Email Custom Message (one time - clears after email sends)",
              'forgot_password': 'Email Content - use {email} to insert recipient email, {link} for reset link, {support} for contact link'
            }
          },
          showKeys: {
            'health_connect': ['health_connect_icon', 'app_sync'],
            'health_kit': ['health_kit_icon', 'app_sync'],
            'google_health': ['marketplace', 'marketplace_description'],
            'mobile': ['active_program_log_message']
          },
          hiddenCategory: ['branding','monthly_email','app_email_banners', 'goal_images', "shared_logging_content"],
          hiddenKeys: {
            'google_health': ['marketplace'],
            'logging': ['behaviors_label', 'activity_label', 'behaviors_points_label', 'activity_points_label'],
            'wall': ['wall_moderator_name'],
            'choose_device': ['logging_manual_message'],
            'mobile': ['ios_app_link', 'android_app_link'],
            'auto_moderator': autoGeneratedKeys
            //'shared_logging_content': ['enter_logging',"enter_no_logging","opt_in_logging"]
          }
        },
        group: {
          categoryLabels: {
            'resource': 'Category',
            'goal_images': 'Category'
          },
          keyLabels: {}
        },
        customFields: {
          category: {
            'tips': {
              fields: [{
                title: 'Email Subject:',
                type: 'text',
                placeholder: 'Give it a subject.',
                modelName: 'email_subject'
              }, {
                title: 'Email Image Caption:',
                type: 'text',
                placeholder: 'Give it a caption.',
                modelName: 'email_image_caption'
              }, {
                title: 'Email Image',
                type: 'image',
                modelName: 'email_image'
              }]
            }
          }
        },
        dataFormatters: {
          category: {}
        },
        _contentHashKey: function(category, siteId) {
          return category + (!!siteId ? siteId : '');
        },
        setContentsForCategory: function(contents, category, siteId) {
          ContentService._contents[ContentService._contentHashKey(category, siteId)] = contents;
        },
        getContentsForCategory: function(category, siteId) {
          return ContentService._contents[ContentService._contentHashKey(category, siteId)];
        },
        getContentByCategoryAndKey: function(category, siteId, key, strict) {
          var contentArray = ContentService.getContentsForCategory(category, siteId);
          if (strict === null || strict === undefined) {
            strict = true;
          }
          var result = $filter('filter')(contentArray, {
            key: key
          }, strict);
          if (result !== undefined && result.length === 1) {
            result = result[0];
          } else if (!result || result.length === 0) {
            result = new Content({
              key: key
            });
          }
          return result;
        },
        getCustomHtmlUrl: function(category) {
          var foundHtml = null;
          if (category === 'how_it_works') {
            foundHtml = '/scripts/how_it_works/how_it_worksPreview.html';
          } else if (category === 'resources') {
            foundHtml = '/scripts/resources/views/resourcePreview.html';
          }

          return foundHtml;
        },
        getCustomDefaultKeys: function(category) {
          var keys;

          switch (category) {
            case 'optin_program_overlay':
              keys = ['main'];
              break;
            case 'welcome_elevate':
              keys = ['welcome']
              break;
            case 'eligibility':
              keys = ['label_message'];
              break;
            case 'registration':
              keys = ['registration_message',  'closed_max_message',  'custom_confidentiality_message', 'closed_message', 'read_more', 'sms_agreement', 'mobile_password_message', 'address_label', 'password_requirement_error_message'];
              break;
            case 'evaluation':
              keys = ['message'];
              break;
            case 'emails':
              keys = ['global_email_message', 'elevate_welcome_email', 'aktivetrak_welcome_email','launchpad_welcome_email', 'daily_main', 'forgot_password', 'password_reset_confirmation'];
              break;
            case 'reset_password':
              keys = ['forgot_password','password_reset_success','password_reset_expired'];
              break;
            case 'countdown':
              keys = ['coming_soon', 'banner'];
              break;
            case 'welcome':
              keys = ['default', 'campaign_opt_in', 'campaign_closed'];
              break;
            case 'home':
              keys = ['placeholder'];
              break;
            case 'webcart':
              keys = ['popup'];
              break;
            case 'settings':
              keys = [];
              break;
            case 'welcome_logo':
              keys = ['site_logo', 'welcome_banner_text'];
              break;
            case 'tips':
              keys = ['tips'];
              break;
            case 'recipes':
              keys = ['no_favorites_message'];
              break;
            case 'wall':
              keys = ['wall_moderator_name', 'guidelines'];
              break;
            case 'contact':
              keys = ['default_contact_message'];
              break;
            case 'hes_app_content':
              keys = $rootScope.site.app_options.map(function(a) {
                return a.name;
              });
              break;
            case 'app_email_banners':
              keys = $rootScope.site.app_options.map(function(a) {
                return a.domain_name;
              });
              break;
            case 'location_resources':
              var site = $rootScope.dbSite;
              keys = site.nested_locations;
              break;
            case "shared_logging_content":
              keys = ['registration_closed', 'enter_logging', 'opt_in_logging', 'enter_no_logging', 'opt_in_no_logging', 'coming_soon'];
              break;
            case "explanations":
              keys = ['goal_active', 'goal_choose', 'goal_tip', 'goal_completed', 'wall_no_posts', 'wall_no_peers', 'wall_no_following', 'stats_steps', 'peers_no_pending', 'challenges_start', 'challenges_select', 'challenges_no_peers', 'challenges_completed', 'contact_request_sent', 'feedback_form', 'feedback_sent', 'why_steps'];
              break;
            case "unsubscribe":
              keys = ['unsubscribed'];
              break;
            case 'mobile':
              keys = ['ios_app_link', 'android_app_link', 'active_program_log_message'];
              break;
            case 'mobile_overlay':
              keys = ['mobile_overlay', 'responsive_overlay'];
              break;
            case 'evaluation_banner':
              keys = ['global_evaluation_banner'];
              break;
            case 'choose_device':
              keys = ['log_activity_message', 'settings_message', 'logging_manual_message'];
              break;
            case 'monthly_email':
              keys = [ "january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december" ];
              break;
            case 'branding':
              keys = ['secondary_logo'];
              break;
            case 'walkthrough':
              keys = ['wall','peer_challenges','recipes','goals'];
              break;
            case 'mobile_password_instructions':
              keys = ['instructions']
              break;
            case 'monthly_notifications':
              keys = ['monthly_notification']
              break;
            case 'cookie_consent':
              keys = ['banner_consent']
              break;
            case 'health_kit':
              keys = ['health_kit_icon', 'app_sync']
              break;
            case 'health_connect':
              keys = ['health_connect_icon', 'app_sync']
              break;
            case 'google_health':
              keys = ['marketplace', 'marketplace_description']
              break;
            case 'marketplace':
              keys = ['connected_information', 'connection_failed']
              break;
            case 'auto_moderator':
              keys = autoGeneratedKeys
              break;
            default:
              keys = [];
          }

          return keys;
        },
        getCustomDefaultGroups: function(category) {
          var groups = [];

          switch (category) {
            case 'quiz_responses':
              groups = ['correct', 'incorrect'];
              break;
            case 'goal_images':
              groups = ['Locations and Travel', 'Activities and Hobbies'];
              break;
          }

          return groups;
        },
        getCustomFieldsForCategory: function(category) {
          return ContentService.customFields.category[category];
        },
        hasCustomFieldsForCategory: function(category) {
          return ContentService.customFields.category.hasOwnProperty(category);
        },
        getDataFormatterForCategory: function(category) {
          return ContentService.dataFormatters.category[category];
        },
        hasDataFormatterForCategory: function(category) {
          return ContentService.dataFormatters.category.hasOwnProperty(category);
        },
        allowAddKeys: function(category) {
          return ContentService.noAddKeys.indexOf(category) === -1;
        },
        allowAddGroups: function(category) {
          return ContentService.noAddGroups.indexOf(category) === -1;
        },
        hideKeyField: function(category) {
          return ContentService.noModifyKeys.indexOf(category) !== -1;
        },
        hideHiddenCheckbox: function(category) {
          return ContentService.noHiddenCheckbox.indexOf(category) !== -1;
        },
        showGroup: function(category) {
          return ContentService.hasGroups.indexOf(category) !== -1;
        },
        showImage: function(category, key) {
          return ContentService.getCategoryKeyShowInput('image1', category, key);
        },
        showSecondImage: function(category, key) {
          return ContentService.getCategoryKeyShowInput('image2', category, key);
        },
        showMobileImage1: function(category, key) {
          return ContentService.getCategoryKeyShowInput('mobile_image1', category, key);
        },
        showEmailImage: function(category, key) {
          return ContentService.getCategoryKeyShowInput('email_image', category, key);
        },
        showSequence: function(category) {
          return ContentService.isSequenced.indexOf(category) !== -1;
        },
        hideSummary: function(category, key) {
          return ContentService.getCategoryKeyHiddenInput('summary', category, key);
        },
        useHtmlInputSummary: function(category) {
          return ContentService.getCategoryUseHtmlInput('summary', category);
        },
        hideContent: function(category, key) {
          return ContentService.getCategoryKeyHiddenInput('content', category, key);
        },
        hideTitle: function(category, key) {
          return ContentService.getCategoryKeyHiddenInput('title', category, key);
        },
        showDescription: function(category, key) {
          return ContentService.getCategoryKeyShowInput('description', category, key);
        },
        hideRichText: function(content, inputType) {
          if (!ContentService.noRichTextKeys[content.category]) return false;

          if (ContentService.noRichTextKeys[content.category].length === 0) return true;
          if (inputType){
            const inputTypeCheck = [inputType, content.key].filter(Boolean);
            return inputTypeCheck.some(key => (ContentService.noRichTextKeys[content.category] || []).includes(key));
          }
          return false;
        },
        isRichTextEnabled: function(inputType, category, key) {
          var categories = ContentService.richTextEnabledKeys[inputType] || {};
          var keys = categories[category] || [];
          return keys.indexOf(key) !== -1;
        },
        getTitleLabel: function(category, key) {
          return ContentService.getCategoryKeyLabel('Title', category, key);
        },
        getContentLabel: function(category, key) {
          return ContentService.getCategoryKeyLabel('Content', category, key);
        },
        getDescriptionLabel: function(category, key) {
          return ContentService.getCategoryKeyLabel('Description', category, key);
        },
        getSummaryLabel: function(category, key) {
          return ContentService.getCategoryKeyLabel('Summary', category, key);
        },
        getGroupLabel: function(category, key) {
          return ContentService.getCategoryKeyLabel('Group', category, key);
        },
        getSequenceLabel: function(category, key) {
          return ContentService.getCategoryKeyLabel('Sequence', category, key);
        },
        getImage1Label: function(category) {
          var value = 'Select Image 1';
          switch (category) {
            case 'welcome':
              value = 'Select Web Image';
              break;
            case 'articles':
              value = 'Select Web Image';
              break;
            case 'competition':
              value = 'Select Web Image';
              break;
            case 'tips':
              value = 'Select Tip Image';
              break;
            case 'welcome_logo':
              value = 'Select Welcome Overlay Logo';
              break;
            case 'emails':
              value = "Welcome Emails(if not set will use default)";
              break;
            case 'evaluation_banner':
              value = "Background Image";
              break;
            case 'hes_app_content':
              value = "Logo";
              break;
            case 'mobile_overlay':
              value = "phone image";
              break;
            case 'resources':
              value = "Select image (dimensions should be 150x150 pixels)";
              break;
            case 'location_resources':
              value = "Select image (dimensions should be 150x150 pixels)";
              break;
            case 'walkthrough':
              value = "Select image (dimensions should be 365x217 pixels)";
              break;
          }
          return value;
        },
        getImage2Label: function(category) {
          var value = 'Select Image 2';
          switch (category) {
            case 'welcome':
              value = 'Select Responsive Image';
              ContentService.defered = null;
              break;
            case 'articles':
              value = 'Select Email Image';
              break;
            case 'competition':
              value = 'Select Mobile Image';
              break;
            case 'mobile_overlay':
              value = "Brand Image";
              break;
          }
          return value;
        },
        getMobileImage1Label: function(category) {
          var value = 'Select Mobile Image 1';
          switch (category) {
            case 'tips':
              value = 'Select Mobile Tip Image';
              break;
            case 'hes_app_content':
              value = "App Logo";
              break;
          }
          return value;
        },
        getCategoryKeyHiddenInput: function(inputType, category, key) {
          var hide = false;

          if (ContentService[inputType].hiddenCategory.indexOf(category) !== -1) {
            hide = true;
          }

          if (!hide) {
            var contentKeys = ContentService[inputType].hiddenKeys[category];
            if (!!contentKeys) {
              hide = contentKeys.indexOf(key) !== -1;
            }
          } else {
            //If it's hidden for the category but we hav a label for the key... show it
            var keyLabels = ContentService[inputType].keyLabels[category];
            if (!!keyLabels && !!key && !!keyLabels[key]) {
              hide = false;
            }
          }
          return hide;
        },
        getCategoryUseHtmlInput: function(inputType, category, key) {
          var useHtmlInput = false;

          if (ContentService[inputType].useHtmlInput.indexOf(category) !== -1) {
            useHtmlInput = true;
          }

          return useHtmlInput;
        },
        getCategoryKeyShowInput: function(inputType, category, key) {
          var show = false;

          if (ContentService[inputType].showCategory.indexOf(category) !== -1) {
            show = true;
          }

          if (!show) {
            var contentKeys = ContentService[inputType].showKeys[category];
            if (!!contentKeys) {
              show = contentKeys.indexOf(key) !== -1;
            }
          } else {
            //If it's visible for the category but the key hides it
            var hiddenKeys = ContentService[inputType].hiddenKeys[category];
            if (!!hiddenKeys && !!key && !!hiddenKeys[key]) {
              show = false;
            }
          }

          return show;
        },
        getCategoryKeyLabel: function(defaultStr, category, key) {
          var value = defaultStr;
          var catValue = ContentService[defaultStr.toLowerCase()].categoryLabels[category];
          var catKeys = ContentService[defaultStr.toLowerCase()].keyLabels[category];
          if (!!category && !!catValue) {
            value = catValue;
          }
          if (!!key && !!catKeys && !!catKeys[key]) {
            value = catKeys[key];
          }
          return value;
        },
        loadSiteContent: function(siteId) {
          if (ContentService.defered && ContentService.defered.promise.$$state.status == 0) {
            return ContentService.defered.promise;
          }
          ContentService.defered = $q.defer();

          if (ContentService.loadedSiteContent) {
            ContentService.defered.resolve(ContentService._contents);
          } else {
            Content.allSiteContent({
              site_id: siteId
            }).$promise.then(function(contents) {
              angular.forEach(contents, function(content) {
                ContentService.setContentsForCategory(content.custom_content, content.category);
                ContentService.setContentsForCategory(content.custom_content, content.category, siteId);
              });
              ContentService.loadedSiteContent = true;
              ContentService.defered.resolve(contents);
            }, function(rejection) {
              ContentService.defered.reject(rejection);
            }).finally(function() {
              ContentService.defered = null;
            });
          }
          return ContentService.defered.promise;
        }
      };

      return ContentService;
    }
  ]);

'use strict';

angular.module('goApp')
  .controller('ContentAddEditController', function($scope, Content, $state, Utils, ErrorService, $timeout, ContentLoader, ngDialog, $filter, ContentService, DialogService) {
    $scope.taToolbar = [
      ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'insertLink']
    ];

    $scope.useHtmlInput = function(content, field) {
      if(content.category == 'resources' && field == 'summary') {
        return true;
      } else if (content.category == 'location_resources' && field == 'summary') {
        return true
      } else {
        return false;
      }
    }

    $scope.plainText = function(value) {
      return value ? String(value).replace(/<[^>]+>/gm, '') : '';
    };

    $scope.contentConfig = {
      data: {
        siteId: $state.params.siteId,
        category: $state.params.category,
        html: $state.current.contentHtml
      },
      editContent: null,
      contents: null, //contents,
      contentKeys: [],
      contentGroups: [],
      hideToolbarCategories: [
        'location_resources',
      ],
      titleToolbarCategories: [
        'resources',
      ],
      newKey: '',
      showNewKey: false
    };

    $scope.contentConfig.contentKeys = ContentService.getCustomDefaultKeys($scope.contentConfig.data.category);

    var category = $scope.contentConfig.data.category;
    $scope.settings = {
      saving: false,
      errors: [],
      allowAddKeys: ContentService.allowAddKeys(category),
      allowAddGroups: ContentService.allowAddGroups(category),
      showGroup: ContentService.showGroup(category),
      showSequence: ContentService.showSequence(category),
      hideKeyField: ContentService.hideKeyField(category),
      hideHiddenCheckbox: ContentService.hideHiddenCheckbox(category),
      hasCustomFieldsForCategory: ContentService.hasCustomFieldsForCategory(category),
      customFields: ContentService.getCustomFieldsForCategory(category),
      hasDataFormatterForCategory: ContentService.hasDataFormatterForCategory(category),
      dataFormatterForCategory: ContentService.getDataFormatterForCategory(category),
      useHtmlInputSummary: ContentService.useHtmlInputSummary(category),
      hideSummary: function() {
        return ContentService.hideSummary(category, $scope.contentConfig.editContent.key);
      },
      hideContent: function() {
        return ContentService.hideContent(category, $scope.contentConfig.editContent.key);
      },
      titleLabel: function() {
        return ContentService.getTitleLabel(category, $scope.contentConfig.editContent.key);
      },
      contentLabel: function() {
        return ContentService.getContentLabel(category, $scope.contentConfig.editContent.key);
      },
      hideTitle: function() {
        return ContentService.hideTitle(category, $scope.contentConfig.editContent.key);
      },
      showDescription: function() {
        var key = !!$scope.contentConfig.editContent ? $scope.contentConfig.editContent.key : '';
        return ContentService.showDescription(category, key);
      },
      descriptionLabel: function() {
        return ContentService.getDescriptionLabel(category, $scope.contentConfig.editContent.key);
      },
      hideRichTextTitle: function() {
        return ContentService.hideRichText($scope.contentConfig.editContent, 'title');
      },
      useRichTextDescription: function() {
        return ContentService.isRichTextEnabled('description', category, $scope.contentConfig.editContent.key);
      },
      hideRichTextContent: function () {
        return ContentService.hideRichText($scope.contentConfig.editContent, 'content');
      },
      hideRichTextSummary: function () {
        return ContentService.hideRichText($scope.contentConfig.editContent, 'summary');
      },
      summaryLabel: function() {
        return ContentService.getSummaryLabel(category, $scope.contentConfig.editContent.key);
      },
      groupLabel: function() {
        return ContentService.getGroupLabel(category, $scope.contentConfig.editContent.key);
      },
      sequenceLabel: function() {
        var key = !!$scope.contentConfig.editContent ? $scope.contentConfig.editContent.key : '';
        return ContentService.getSequenceLabel(category, key);
      },
      showImage: function() {
        var key = !!$scope.contentConfig.editContent ? $scope.contentConfig.editContent.key : '';
        return ContentService.showImage(category, key);
      },
      showSecondImage: function() {
        var key = !!$scope.contentConfig.editContent ? $scope.contentConfig.editContent.key : '';
        return ContentService.showSecondImage(category, key);
      },
      showMobileImage1: function() {
        var key = !!$scope.contentConfig.editContent ? $scope.contentConfig.editContent.key : '';
        return ContentService.showMobileImage1(category, key);
      },
      showEmailImage: function() {
        var key = !!$scope.contentConfig.editContent ? $scope.contentConfig.editContent.key : '';
        return ContentService.showEmailImage(category, key);
      },
      image1Label: ContentService.getImage1Label(category),
      image2Label: ContentService.getImage2Label(category),
      mobileImage1Label: ContentService.getMobileImage1Label(category)
    };
    $scope.showToolbar = function(category) {
      if ($scope.contentConfig.hideToolbarCategories.indexOf(category) > -1) {
        return false;
      } else {
        return true;
      }
    };
    $scope.showTitleToolbar = function(category) {
      if ($scope.contentConfig.titleToolbarCategories.indexOf(category) > -1) {
        return true;
      } else {
        return false;
      }
    };
    $scope.showAddKey = function() {
      $scope.contentConfig.newKey = '';
      $scope.contentConfig.showNewKey = true;
    };

    $scope.cancelAddKey = function() {
      $scope.contentConfig.showNewKey = false;
    };

    $scope.addNewKey = function() {
      var tmpKey = $scope.contentConfig.newKey.replace(/ /g, '_').toLowerCase();
      if ($scope.contentConfig.contentKeys.indexOf(tmpKey) === -1) {
        $scope.contentConfig.newKey = tmpKey;
        $scope.contentConfig.contentKeys.push($scope.contentConfig.newKey);
        $scope.contentConfig.editContent.key = $scope.contentConfig.newKey;
        $scope.contentConfig.showNewKey = false;
      } else {
        ErrorService.showErrors({}, 'Key already exists!!');
      }
    };

    $scope.showAddGroup = function() {
      $scope.contentConfig.newGroup = '';
      $scope.contentConfig.showNewGroup = true;
    };

    $scope.cancelAddGroup = function() {
      $scope.contentConfig.showNewGroup = false;
    };

    $scope.addNewGroup = function() {
      var tmpGroup = $scope.contentConfig.newGroup;
      if ($scope.contentConfig.contentGroups.indexOf(tmpGroup) === -1) {
        $scope.contentConfig.newGroup = tmpGroup;
        $scope.contentConfig.contentGroups.push($scope.contentConfig.newGroup);
        $scope.contentConfig.editContent.group = $scope.contentConfig.newGroup;
        $scope.contentConfig.showNewGroup = false;
      } else {
        ErrorService.showErrors({}, 'Group already exists!!');
      }
    };

    $scope.createNewContent = function() {
      $scope.contentConfig.editContent = new Content({
        category: $scope.contentConfig.data.category,
        site_id: $scope.contentConfig.data.siteId,
        key: $scope.contentConfig.contentKeys[0] || '',
        group: $scope.contentConfig.contentGroups[0] || ''
      });
    };

    $scope.confirmDeleteContent = function(content) {
      $scope.content = content;
      ngDialog.openConfirm({
        scope: $scope,
        template: '/scripts/content/confirmDeleteContent.html'
      }).then($scope.deleteContent);
    };

    $scope.deleteContent = function(content) {
      content.destroy(function() {
        $scope.getContents();
      });
    };

    $scope.isContentEdited = function(content) {
      content.isEdited = !$scope.dbSite.isDefault() && $scope.dbSite.id === content.site_id;
      return content.isEdited;
    };

    $scope.getContent = function(key) {
      return Content.getByKey($scope.contentConfig.contents, key);
    };

    $scope.confirmUseDefault = function(content) {
      content.confirmSwitch = true;
    };

    $scope.cancelSwitchToDefault = function(content) {
      content.confirmSwitch = false;
    };

    $scope.switchToDefault = function(content, index) {
      content.destroy(function(destroyedContent) {
        $scope.getContents();
      })['catch'](function(response) {
        ErrorService.showErrors(response, 'Could not reset to default');
      });
    };

    $scope.doEdit = function(content, index) {
      $scope.contentConfig.editContent = content;
      $scope.contentConfig.editContent.originalSequence = content.sequence;
      setContentKeys();
    };

    $scope.cancelEdit = function() {
      var content = $scope.contentConfig.editContent;
      $scope.contentConfig.editContent = null;
      content && content.$show({
        site_id: $scope.dbSite.id
      });
      content = null;
    };

    $scope.handleErrors = function(response) {
      $scope.settings.saving = false;
      $scope.settings.showSaving = false;
      ErrorService.showErrors(response, 'Could not save Content');
    };

    $scope.getContents = function() {
      var content_promise = new ContentLoader({
        category: $scope.contentConfig.data.category,
        site_id: $scope.contentConfig.data.siteId,
        hidden: true
      }, true);

      content_promise.then(function(contents) {
        $scope.contentConfig.contents = $scope.settings.showSequence ? $filter('orderBy')(contents, 'sequence') : contents;
      });

      return content_promise;
    };

    $scope.save = function(index) {
      $scope.settings.saving = true;
      if ($scope.contentConfig.showNewKey) {
        $scope.addNewKey();
      }
      $scope.timeoutSave = $timeout(function() {
        $scope.settings.showSaving = true;
      }, 300);

      var siteId = $scope.contentConfig.data.siteId;
      var key = $scope.contentConfig.editContent.key;
      var category = $scope.contentConfig.data.category;
      var content = $scope.contentConfig.editContent;

      content.key = content.key || content.group;

      if ($scope.dbSite.isDefault()) {
        siteId = null;
      }

      var wasNew = content.isNew();
      var previousId = content.id;
      if (siteId !== null) {
        if (content.isNew() || ($scope.contentConfig.data.siteId != content.site_id)) {
          wasNew = true;
          var contentDataObj = {
            site_id: $scope.contentConfig.data.siteId,
            category: $scope.contentConfig.data.category,
            key: content.key,
            content: content.content,
            title: content.title,
            hidden: content.hidden,
            sequence: content.sequence,
            group: content.group,
            summary: content.summary,
            description: content.description,
            image1: content.image1,
            image2: content.image2,
            mobile_image1: content.mobile_image1,
            email_image: content.email_image
          };

          if ($scope.settings.hasCustomFieldsForCategory) {
            $scope.settings.customFields.fields.forEach(function(item) {
              contentDataObj[item.modelName] = content[item.modelName];
            });
          }

          if ($scope.settings.hasDataFormatterForCategory) {
            contentDataObj = $scope.settings.dataFormatterForCategory(contentDataObj);
          }

          content = Content.build(contentDataObj);
        }
      }

      setKey(content, previousId);

      var originalSequence = $scope.contentConfig.editContent.originalSequence;

      //Just make sure the category is correct
      content.category = $scope.contentConfig.data.category;
      // content.image = $scope.contentConfig.image;
      // $scope.contentConfig.image = '';

      if (category == "tips") {
        content.days_from_start = content.sequence
      }

      content.save(function(savedContent) {
        if (wasNew) {
          $scope.contentConfig.contents.push(content);
        }
        if (originalSequence != content.sequence) {
          if (content.category == 'walkthrough' && content.sequence && content.sequence != "") {
            // then take the user input and do nothing
            finishSave();
          } else {
            content.sequence = content.sequence < originalSequence ? content.sequence - 0.5 : content.sequence + 0.5;
            var sequence = getNewSequence();
            if (previousId !== content.id && !Utils.isUndefinedOrNull(previousId)) {
              sequence.splice(sequence.indexOf(previousId), 1);
            }
            Content.setOrder(sequence, $scope.dbSite.id, $scope.contentConfig.data.category, finishSave, function(response) {
              ErrorService.showErrors(response, 'Could not resequence content.');
              finishSave();
            });
          }
        } else {
          finishSave();
        }
      })['catch']($scope.handleErrors);
    };

    function finishSave() {
      $scope.getContents().then(function() {
        $timeout.cancel($scope.timeoutSave);
        $scope.settings.saving = false;
        $scope.settings.showSaving = false;
        $scope.cancelEdit();
      });
    }

    function getNewSequence(noSort) {
      var contents = !noSort ? $filter('orderBy')($scope.contentConfig.contents, 'sequence') : $scope.contentConfig.contents;

      return contents.map(function(item) {
        return item.id;
      });
    }

    function setKey(content, previousId) {
      var newKey = content.key;
      var contentsWithKey = $filter('filter')($scope.contentConfig.contents, {
        key: content.key
      }, true);
      if ((contentsWithKey.length === 1 && contentsWithKey[0].id !== content.id && contentsWithKey[0].id !== previousId) || contentsWithKey.length === 2) {
        var contentsLikeKey = $filter('filter')($scope.contentConfig.contents, {
          key: content.key + "+"
        });
        newKey = content.key + '+' + contentsLikeKey.length;
      }
      content.key = newKey;
    }

    function setContentKeys() {
      $scope.contentConfig.contentKeys = ContentService.getCustomDefaultKeys($scope.contentConfig.data.category);
      var result = $scope.contentConfig.contents.map(function(content) {
        return content.key;
      });
      if (result !== undefined) {
        var tmpResult = [];
        angular.forEach(result, function(r, idx) {
          if (tmpResult.indexOf(r) === -1) {
            tmpResult.push(r);
          }
        });
        $scope.contentConfig.contentKeys = $scope.contentConfig.contentKeys.concat(tmpResult.slice(0));
        $scope.contentConfig.contentKeys = $filter('unique')($scope.contentConfig.contentKeys);
      }
    }

    function setContentGroups() {
      var result = $scope.contentConfig.contents.map(function(content) {
        if (content.group === null) {
          content.group = undefined;
        }
        return content.group;
      });
      if (result === undefined) {
        $scope.contentConfig.contentGroups = [];
      } else {
        var tmpResult = [];
        angular.forEach(result, function(r, idx) {
          if (tmpResult.indexOf(r) === -1) {
            tmpResult.push(r);
          }
        });
        $scope.contentConfig.contentGroups = tmpResult.slice(0);
      }

      $scope.contentConfig.contentGroups = _.union($scope.contentConfig.contentGroups,
        ContentService.getCustomDefaultGroups($scope.contentConfig.data.category));
    }

    function setCustomHtmlUrl() {
      var tmpHtmlUrl = ContentService.getCustomHtmlUrl($scope.contentConfig.data.category);
      if (tmpHtmlUrl !== null) {
        $scope.contentConfig.data.html = tmpHtmlUrl;
      }
    }

    $scope.sortableOptions = {
      //Only allow draggable when click on handle element
      handle: '.drag-handle',
      //Construct method before sortable code
      construct: function(model) {},
      //Callback after item is dropped
      stop: function(list, dropped_index) {
        var dialog = DialogService.openUploadingDialog("Saving Sequencing...");
        Content.setOrder(getNewSequence(true), $scope.dbSite.id, $scope.contentConfig.data.category,
          function() {
            finishSave();
            dialog.close();
          },
          function(response) {
            ErrorService.showErrors(response, 'Could not resequence content.');
            finishSave();
            dialog.close();
            DialogService.openInformationDialog('Error', 'Could not resquence content.');
          });
      }
    };

    init();

    function init() {
      $scope.getContents().then(function(){
        setCustomHtmlUrl();
        setContentKeys();
        setContentGroups();
      });
    }

  });

'use strict';

angular.module('goApp')
  .controller('KeywordController', ['$scope', 'KeywordsLoader',
    function($scope, KeywordsLoader) {
      $scope.keywords = [];
      new KeywordsLoader({
        type: 'sites',
        id: $scope.dbSite.id
      }).then(function(keywords) {
        for (var i = 0; i < keywords.length; i++) {
          $scope.keywords.push(keywords[i]);
        }
      });

      new KeywordsLoader({
        type: 'users',
        id: $scope.user.id
      }).then(function(keywords) {
        for (var i = 0; i < keywords.length; i++) {
          $scope.keywords.push(keywords[i]);
        }
      });
    }
  ]);
'use strict';

angular.module('goApp')
  .factory('KeywordsLoader', ['Keywords', '$q', 'Utils',
    function(Keywords, $q, Utils) {
      return function(opts) {
        var defer = $q.defer();

        var options = {};
        options.page_size = 0;

        if (!Utils.isUndefinedOrNull(opts.id)) {
          options.id = opts.id;
        }

        if (!Utils.isUndefinedOrNull(opts.type)) {
          options.type = opts.type;
        }

        Keywords.index(options, function(keywords) {
          defer.resolve(keywords);
        }, function() {
          defer.reject('Keywords could not be found');
        });

        return defer.promise;
      };
    }
  ]);
'use strict';

angular.module('goApp')
  .factory('Keywords', ['ActiveResource', 'DOMAIN',
    function(ActiveResource, DOMAIN) {

      	var Keywords = ActiveResource('/:type/:id/keywords', {
        	domain: DOMAIN,
        	parentResource: ['Site', 'User'],
        	nestedRoutes: ['index']
      	});

      return Keywords;
    }
  ]);
"use strict";

angular.module("goApp").config(function (ngQuillConfigProvider) {
  //In a try block is if something fails, nothing breaks
  try {
    // implementation borrowed from https://codepen.io/mackermedia/pen/gmNwZP
    var Delta = Quill.import("delta");
    let Break = Quill.import("blots/break");
    let Embed = Quill.import("blots/embed");

    function lineBreakMatcher() {
      var newDelta = new Delta();
      newDelta.insert({ break: "" });
      return newDelta;
    }

    class SmartBreak extends Break {
      length() {
        return 1;
      }
      value() {
        return "\n";
      }

      insertInto(parent, ref) {
        Embed.prototype.insertInto.call(this, parent, ref);
      }
    }

    SmartBreak.blotName = "break";
    SmartBreak.tagName = "BR";

    Quill.register(SmartBreak);

    ngQuillConfigProvider.set({
      modules: {
        clipboard: {
          matchers: [["BR", lineBreakMatcher]],
        },
        keyboard: {
          bindings: {
            "shift enter": {
              key: 13,
              shiftKey: true,
              handler: function (range, context) {
                let currentLeaf = this.quill.getLeaf(range.index)[0];
                let nextLeaf = this.quill.getLeaf(range.index + 1)[0];

                this.quill.insertEmbed(range.index, "break", true, "user");

                // Now that we've inserted a line break, move the cursor forward
                this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
                return false;
              },
            },
          },
        },
      },
    });
  } catch (error) {
    //ignore, we are doing ES6 stuff and I don't care if this fails
  }
});

'use strict';

angular.module('goApp')
  .factory('WelcomeContentLoader', ['Content', '$q', 'Utils',
    function(Content, $q, Utils) {
      return function(opts) {
        opts = opts || {};
        var defer = $q.defer();

        var options = {
          site_id: opts.site_id,
          category: 'welcome'
        };

        Content.index(options, function(content) {
          defer.resolve(content);
        }, function() {
          defer.reject('Welcome content could not be found');
        });

        return defer.promise;
      };
    }
  ]);

'use strict';

angular.module('goApp')
  .controller('WelcomeEditController', ['$scope', 'contents', 'Content', '$state', 'Utils', 'ErrorService', '$timeout',
    function($scope, contents, Content, $state, Utils, ErrorService, $timeout) {
      $scope.welcomeConfig = {
        data: {
          promotionId: $state.params.promotionId,
          category: $state.params.category
        },
        editContent: null,
        contents: contents,
        whatContent: Content.getByKey(contents, 'what'),
        whenContent: Content.getByKey(contents, 'when'),
        howProgramContent: Content.getByKey(contents, 'how'),
        howTeamContent: Content.getByKey(contents, 'how_team'),
        registerContent: Content.getByKey(contents, 'register')
      };

      $scope.settings = {
        saving: false,
        errors: []
      };

      $scope.isContentEdited = function(content){
        content.isEdited =  !$scope.dbPromotion.isDefault() && !Utils.isUndefinedOrNull(content.promotion_id);
        return content.isEdited;
      };

      $scope.getContent = function(key) {
        return Content.getByKey($scope.welcomeConfig.contents, key);
      };

      $scope.confirmUseDefault = function(content){
        content.confirmSwitch = true;
      };

      $scope.cancelSwitchToDefault = function(content){
        content.confirmSwitch = false;
      };

      $scope.switchToDefault = function(content, index){
        content.destroy(function(destroyedContent){
          Content.show({
            category: $scope.welcomeConfig.data.category,
            key: content.key
          }, function(defaultContent){
            content = defaultContent;
            $scope.welcomeConfig.contents[index] = defaultContent;
          });
        })['catch'](function(response){
          ErrorService.showErrors(response, 'Could not reset to default');
        });
      };

      $scope.doEdit = function(content, index) {
        $scope.welcomeConfig.editContent = content;
        $scope.welcomeConfig.editContent.index = index;
      };

      $scope.cancelEdit = function() {
        $scope.welcomeConfig.editContent = null;
      };

      $scope.handleErrors = function(response) {
        $scope.settings.saving = false;
        $scope.settings.showSaving = false;
        ErrorService.showErrors(response, 'Could not save Content');
      };


      $scope.save = function(index) {
        $scope.settings.saving = true;
        var timeoutSave = $timeout(function() {
          $scope.settings.showSaving = true;
        }, 300);

        var promotionId = $scope.welcomeConfig.data.promotionId;
        var key = $scope.welcomeConfig.editContent.key;
        var category = $scope.welcomeConfig.data.category;
        var content = $scope.welcomeConfig.editContent;
        if ($scope.dbPromotion.subdomain === 'www') {
          promotionId = null;
        }

        if (promotionId !== null) {
          if (content.isNew() || Utils.isUndefinedOrNull(content.promotion_id)) {
            content = Content.build({
              promotion_id: $scope.welcomeConfig.data.promotionId,
              category: $scope.welcomeConfig.data.category,
              key: content.key,
              content: content.content,
              title: content.title,
              sequence: content.sequence
            });
          }
        }

        //Just make sure the category is correct
        content.category = $scope.welcomeConfig.data.category;

        content.save(function(savedContent) {
          $scope.welcomeConfig.contents[index] = savedContent;
          $timeout.cancel(timeoutSave);
          $scope.settings.saving = false;
          $scope.settings.showSaving = false;
          $scope.cancelEdit();
        })['catch']($scope.handleErrors);
      };
    }
  ]);
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.u.coordinator.helm', {
    url: '/dashboard/helm',
    controller: function($scope, $state){
      if($scope.site.flags.is_aktivetrak) {
        $state.go("go.u.coordinator.reporting");
      } else if (!($scope.site.features_on && $scope.site.programs.reporting.length == 0)) {
        $state.go("go.u.coordinator.program_reports");
      } else {
        $state.go("go.u.coordinator.notifications");
      }
    },
    abstract: false
  });


  $stateProvider.state('go.u.coordinator.program_reports', {
    url: '/dashboard/reports',
    controller: 'CoordinatorReportsController',
    title: 'Dashboard',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/coordinator/reports/reports.html');
      }
    ],
    abstract: false
  });

  $stateProvider.state('go.u.coordinator.notifications', {
    url: '/dashboard/notifications',
    controller: 'CoordinatorNotificationsController',
    title: 'Notifications',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/coordinator/notifications/notifications.html');
      }
    ],
    abstract: false
  });
  
  $stateProvider.state('go.u.coordinator.stats', {
    url: '/dashboard/stats',
    controller: 'CoordinatorStatsController',
    title: 'Stats',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/coordinator/stats/stats.html');
      }
    ],
    abstract: false
  });

  $stateProvider.state('go.u.coordinator.flagged_posts', {
    url: '/dashboard/flagged_posts',
    controller: 'FlaggedPostsController',
    title: 'Flagged Posts',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/coordinator/flagged_posts/flagged_posts.html');
      }
    ],
    abstract: false
  });

  $stateProvider.state('go.u.coordinator.eligibility', {
    url: '/dashboard/eligibility',
    controller: 'EligibilityFilesController',
    title: 'Eligibility',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/coordinator/eligibility/eligibilityFile.html');
      }
    ],
    abstract: false
  });

  $stateProvider.state('go.u.coordinator.participants', {
    url: '/dashboard/participants',
    controller: 'UsersController',
    title: 'Participants',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/coordinator/users.html');
      }
    ],
    abstract: false
  });
  
  $stateProvider.state('go.u.coordinator.upcoming_launches', {
    url: '/dashboard/upcoming_launches',
    controller: _.noop,
    title: 'Upcoming Launches',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/coordinator/upcoming_launches/upcoming_launches.template.html');
      }
    ],
    abstract: false
  });


  $stateProvider.state('go.u.coordinator.reporting', {
    url: '/dashboard/reporting',
    controller: 'ReportsCtrl',
    abstract: false,
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/reports/reports.html');
      }
    ],
    resolve: {
      coordinatorSite: function(CurrentSite) {
        return CurrentSite.get();
      },
      reports: function(coordinatorSite, ReportsLoader) {
        return new ReportsLoader({
          site_id: coordinatorSite.id
        });
      },
      reportFields: function(coordinatorSite, ReportFieldsLoader) {
        return new ReportFieldsLoader(coordinatorSite.id);
      }
    }
  });

});
'use strict';

angular.module('goApp')
  .controller('CoordinatorMessagesController', ['$scope', 'Notification', 'CurrentSite', 'ngDialog', 'ErrorService', 'Utils', '$timeout', 'NotificationsService',
    function($scope, Notification, CurrentSite, ngDialog, ErrorService, Utils, $timeout, NotificationsService) {
      $scope.data = {
        newNotification: null,
        previousNotifications: []
      };

      $scope.config = {
        saving: false,
        loading: true,
        confirmSent: false,
        show: {
          amount: 10,
          increment: 10
        }
      };
      
      (function init() {
        NotificationsService
          .getPreviousNotifications()
          .then(function (notifications) {
            $scope.data.previousNotifications = notifications;
            $scope.config.loading = false;
          });

        CurrentSite.get().then(function() {
          $scope.createNewNotification($scope.site.id);
        });
      })();

      $scope.createNewNotification = function(siteId) {
        $scope.data.newNotification = new Notification({
          site_id: siteId,
          message: null
        });
      };

      function handleSaveError(response) {
        ErrorService.showErrors(response, 'Could not send notification.');
        $scope.config.saving = false;
      }

      function needMessage() {
        ErrorService.showErrors({}, 'Oops, a message is needed.');
        $scope.config.saving = false;
      }

      $scope.showMore = function () {
        if ($scope.config.show.amount < $scope.data.previousNotifications.length) {
          $scope.config.show.amount += $scope.config.show.increment;
        }
      };

      $scope.sendNotification = function() {
        $scope.config.saving = true;
        ErrorService.clearErrors();
        if ($scope.data.newNotification.message) {
          $scope.data.newNotification.save(function(notification) {
            $scope.config.confirmSent = true;
            $scope.data.previousNotifications.unshift(notification);
            $scope.createNewNotification($scope.site.id);
            $scope.config.saving = false;
          }, handleSaveError);
        } else {
          needMessage();
        }
      };

      $scope.deleteNotification = function(notificationIndex) {
        NotificationsService
          .deletePreviousNotification(notificationIndex);
      };

      $scope.resendNotification = function(notification) {
        $scope.data.newNotification.message = notification.message;
        $scope.confirmSendNotification();
      };

      $scope.confirmSendNotification = function() {
        if (!Utils.isUndefinedOrNull($scope.data.newNotification.message) && $scope.data.newNotification.message !== '') {
          $scope.confirmation = {
            message: 'Send this message to all participants?',
            confirmText: 'Yes',
            cancelText: 'No'
          };

          ngDialog.openConfirm({
            template: '/scripts/dialogs/confirmationDialog.html',
            scope: $scope
          }).then($scope.sendNotification);
        } else {
          needMessage();
        }
      };

      $scope.confirmDeleteNotification = function(notificationIndex) {
          $scope.confirmation = {
            message: 'Delete this message for all participants?',
            confirmText: 'Yes',
            cancelText: 'No'
          };

        ngDialog.openConfirm({
          template: '/scripts/dialogs/confirmationDialog.html',
          scope: $scope
        }).then(function() {
          $scope.deleteNotification(notificationIndex);
        });
      };
    }
  ]);
'use strict';

angular.module('goApp')
  .controller('CoordinatorUsersController', ['$scope', '$filter', '$state', 'CurrentSite', 'ErrorService', 'UsersLoader', 'LocationsLoader', 'LocationService', '$timeout', 'ContentLoader', 'Content',
    function($scope, $filter, $state, CurrentSite, ErrorService, UsersLoader, LocationsLoader, LocationService, $timeout, ContentLoader, Content) {
      $scope.data = {
        loading: true,
        users: [],
        locations: [],
        table: {
          fields: [
            ['First Name', 'string'],
            ['Last Name', 'string'],
            ['Email', 'string'],
            ['Registered On', 'date'],
          ],
          rows: [],
          actions: []
        }
      };

      CurrentSite.get().then(function(site) {
        new ContentLoader({
          site_id: $scope.site.id,
          category: 'eligibility'
        }, true).then(function(eligibilityContent) {

          $scope.site = site;
          if ($scope.site.isLocationDisplayed()) {
            $scope.data.table.fields.splice(3, 0, [site.getLocationLabel($scope.site.hasNestedLocations() ? 1 : 0), 'string']);

            if ($scope.site.hasNestedLocations()) {
              $scope.data.table.fields.splice(3, 0, [site.getLocationLabel(0), 'string']);
            }

          }

          // Leave out Until we are told to include it... not quite the same as other progams
          if ($scope.site.isEligibilityDisplayed()) {
            var value = Content.getByKey(eligibilityContent, 'label').content_html;
            var converter = new Showdown.converter();
            var htmlText = converter.makeHtml(value);
            $scope.eligLabel = $(htmlText).text();
            $scope.data.table.fields.splice(3, 0, [$scope.eligLabel || 'ELIG ID', 'string']);
          }

          function setTableData() {

            var rows = [];
            for (var i = 0; i < $scope.data.users.length; i++) {
              var site = $scope.data.users[i];
              var siteLink = '#/site/' + site.id;
              var user = $scope.data.users[i];

              user.row = [
                user.first_name,
                user.last_name,
                user.email,
                user.created_at
              ];

              if ($scope.site.isLocationDisplayed()) {
                var location = LocationService.getLocationById($scope.data.locations, user.location_id);
                user.row.splice(3, 0, location ? location.name : '');

                if ($scope.site.hasNestedLocations()) {
                  var top_level_location = LocationService.getLocationById($scope.data.locations, user.top_level_location_id);
                  user.row.splice(3, 0, top_level_location ? top_level_location.name : '');
                }
              }

              // Leave out Until we are told to include it... not quite the same as other progams
              if ($scope.site.isEligibilityDisplayed()) {
                user.row.splice(3, 0, user.sso_identifier);
              }

              rows.push(user);
            }

            $scope.data.table.rows = rows;
          }

          new UsersLoader(site.id).then(function(users) {
            $scope.data.users = users;
            if ($scope.site.isLocationDisplayed()) {
              new LocationsLoader().then(function(locations) {
                $scope.data.locations = locations;
                setTableData();
              });
            } else {
              setTableData();
            }
          }, function(response) {
            ErrorService.showErrors(response, "Oops, we could not get the participants.");
          })['finally'](function() {
            $scope.data.loading = false;
          });
        });
      });
    }
  ]);
'use strict';
angular.module('goApp')
  .controller('FlaggedPostsController', function($scope, Post, WallFactory) {

    $scope.settings = {};

    $scope.settings.flaggedWall = new WallFactory($scope.site, {
      flagged: true
    });

    $scope.settings.flaggedWall.load().then(function(posts) {
      for (var i = 0; i < $scope.settings.flaggedWall.posts.length; i++) {
        $scope.settings.flaggedWall.posts[i].toggleReportedContent();
      }
    });

    $scope.removePost = function(post) {
      $scope.settings.flaggedWall.removePost(post);
    };

  });
'use strict';

angular.module('goApp').controller('CoordinatorNotificationsController', function($scope, $rootScope, $location, ngDialog, LocationsLoader, LocationService, Notification, DialogService) {
  $scope.data = new Object();
  $scope.data.current_message = "";
  $scope.data.selected_location = null;
  $scope.data.previous_notifications = [];
  $scope.showLocations = $scope.site.flags.is_location_displayed;
  $scope.locations = [];
  $scope.is_coordinator_or_above = $rootScope.user.isCoordinatorOrAbove();
  $scope.is_regional_coordinator_or_above = $rootScope.user.isRegionalCoordinatorOrAbove();
  $scope.is_regional_coordinator = $rootScope.user.isRegionalCoordinator();
  $scope.coordinator_location_id = $rootScope.user.top_level_location_id

  $scope.locationFilter = {
    parentLocation: null,
    childLocation: null,
    grandchildLocation: null
  };

  $scope.confirmSend = function(current_message) {
    $scope.message = current_message;
    var loc = $scope.data.selected_location != null ? $scope.data.selected_location.id : null;
    ngDialog.openConfirm({
      scope: $scope,
      template: '/scripts/coordinator/notifications/confirmSendMessage.html'
    }).then(function(data){
      new Notification({message: $scope.data.current_message, location: loc}).$save(function(notification) {
        $scope.data.current_message = "";
        $scope.data.previous_notifications.unshift(new Notification(notification));
      })
    });
  }
  
  Notification.index({site_id:$scope.site.id}).$promise.then(function(previous_notifications){
    $scope.data.previous_notifications = previous_notifications;
  });

  $scope.displayChildLocations = function() {
    return $scope.locationFilter && $scope.locationFilter.parentLocation && $scope.locationFilter.parentLocation.locations.length > 0;
  };

  $scope.displayGrandchildLocations = function() {
    return $scope.locationFilter && $scope.locationFilter.childLocation && $scope.locationFilter.childLocation.locations.length > 0;
  };

  $scope.displayParentLocations = function() {
      return $scope.site.flags.is_location_displayed;
  };

  $scope.locationChanged = function(location) {
    if (location === 'parent') {
      $scope.data.selected_location = $scope.locationFilter.parentLocation ? $scope.locationFilter.parentLocation : null;
      $scope.locationFilter.childLocation = null;
    } else if (location === 'child') {
      $scope.data.selected_location = $scope.locationFilter.childLocation ? $scope.locationFilter.childLocation : $scope.locationFilter.parentLocation;
      $scope.locationFilter.grandchildLocation = null;
    }
  };

  function init() {
    if ($scope.showLocations) {
      new LocationsLoader($scope.site.id).then(function(locations) {
        $scope.locations = locations;
        // if it's the regional coordinator, loop through the locations
        // and assign their location to parentLocation to populate both drop downs
        // and trigger displayChildLocations as true in teh template
        if ($scope.is_regional_coordinator) {
          for(var i=0; i < ($scope.locations.length); i++){
            if ($scope.locations[i].id === $scope.coordinator_location_id) {
              $scope.locationFilter.parentLocation = $scope.locations[i];
            }
          }
        }
      });
    }
  }

  init();

});
'use strict';

angular.module('goApp')
  .controller('CoordinatorReportsController', ['$scope', 'CurrentSite', 'Notification', 'Program', '$window', 'LocationService',
    function($scope, CurrentSite, Notification, Program, $window, LocationService) {
      $scope.loadingReports = true;
      CurrentSite.get().then(function() {
        //$scope.reportingPrograms = $scope.site.reportingPrograms($scope.user);
        $scope.reportingPrograms = $scope.site.programs.reporting;
        sortReportingProgramsByLocation();
      });

      function sortReportingProgramsByLocation() {
        $scope.sortedReportingPrograms = [{
          location_id: null,
          name: $scope.site.global_program_group,
          programs: []
        }];

        LocationService.get()
          .then(sortPrograms)
          .finally(function() {
            $scope.loadingReports = false;
          });

        function sortPrograms(locations) {
          angular.forEach($scope.reportingPrograms, function(program) {
            var programGroup = _.filter($scope.sortedReportingPrograms, {location_id: program.location_id})
            if (programGroup.length) {
              programGroup[0].programs.push(program);
            } else {
              var location = LocationService.getLocationById(program.location_id);
              $scope.sortedReportingPrograms.push({
                location_id: program.location_id,
                name: (location && location.name),
                programs: [program]
              });
            }
          });
        }
      }

      $scope.goToProgramReports = function(program) {
        $window.open(program.getReportsURL(), '_blank');
      };
    }
  ]);
'use strict';

angular.module('goApp').controller('CoordinatorStatsController', function($scope, Notification, Program, $window, LocationService, Site) {
  $scope.data = new Object();
  $scope.availableYears = $scope.site.flags.is_wustl ? _.filter($scope.site.years, function(year) {
    return year >= 2026;
  }) : $scope.site.years;
  $scope.data.selected_year = $scope.availableYears[0];
  fetch($scope.data.selected_year);

  $scope.getDataFor = function(year) {
    fetch(year);
  }


  function fetch(year) {
    new Site({id: $scope.site.id}).coordinator_stats({year: year}).then(function(data){
      $scope.data.stats = data;
      console.log($scope.data.stats);
    });
  }


});
'use strict';

angular.module('goApp')
  .controller('CountdownController', ['$rootScope', '$scope', 'CurrentSite', '$state', 'ErrorService', 'ipCookie', 'Content', 'ContentLoader',
    function($rootScope, $scope, CurrentSite, $state, ErrorService, ipCookie, Content, ContentLoader) {

      $scope.setup = {
        hasPilotPassword: false,
        loading: true
      };

      $scope.data = {
        // pilotPassword: '',
        startDate:null,
        countdownContent: {}
      };

      if(ipCookie('pilotPassword')) {
        // $scope.setup.hasPilotPassword = true;
        $state.go('go.welcome');
      }

      CurrentSite.get().then(function(site){
        $scope.data.startDate = site.launchesOn();
      });

      new ContentLoader({
          site_id: $scope.site.id,
          category: 'countdown'
      }).then(function(contents) {
        $scope.data.countdownContent = Content.getByKey(contents, 'coming_soon', true);
      });

      // $scope.verifyPilotPassword = function(){
      //   ErrorService.clearErrors();

      //   $scope.site.verifyPilotPassword($scope.data.pilotPassword, function(response){
      //     ipCookie('pilotPassword', response.message, { expires: 1 });
      //     $state.go('go.welcome', {pilotPassword: $scope.data.pilotPassword});
      //   }, function(){
      //     ErrorService.showErrors({}, 'Incorrect pilot password.');
      //   });
      // };
    }
  ]);
'use strict';

angular.module('goApp')
  .directive('hesCountdown', ['hesTemplateService',
    function(hesTemplateService) {
      return {
        restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
        scope: {
          endDate: '='
        },
        controller: 'HesCountdownController',
        templateUrl: hesTemplateService.getTemplateUrl('/scripts/countdown/countdown.html'),
        link: function($scope, $element, $attrs, controller) {
          $scope.startCountdown();
        }
      };
    }
  ])
  .controller('HesCountdownController', ['$scope', '$interval', '$state',
    function($scope, $interval, $state) {

      $scope.countdown = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };

      $scope.startCountdown = function() {
        var time = $scope.endDate.getTime() - new Date().getTime();
        var duration = moment.duration(time, 'milliseconds');
        var interval = 1000;

        $scope.killInterval = $interval(function() {
          duration = moment.duration(duration.asMilliseconds() - interval, 'milliseconds');
          if (duration.asSeconds() >= 0) {
            $scope.countdown.days = Math.floor(duration.asDays());
            $scope.countdown.hours = duration.hours();
            $scope.countdown.minutes = duration.minutes();
            $scope.countdown.seconds = duration.seconds();
          } else {
            $scope.countdownComplete();
          }
        }, interval);
      };

      $scope.countdownComplete = function(){
        $interval.cancel($scope.killInterval);
        $state.go('go.welcome');
      };
    }
  ]);
// 'use strict';

// angular.module('goApp')
//   .config(['$stateProvider', '$urlRouterProvider',
//     function($stateProvider, $urlRouterProvider) {
//       $stateProvider
//         .state('go.countdown', {
//           url: '/countdown',
//           background: 'filled',
//           abstract: false,
//           templateProvider: ['hesTemplateService',
//             function(hesTemplateService) {
//               return hesTemplateService.getTemplate('/scripts/countdown/countdownPage.html');
//             }
//           ],
//           controller: 'CountdownController',
//           resolve: {
//             contents: ['ContentLoader', function(ContentLoader) {
//               return new ContentLoader({
//                 category: 'countdown'
//               });
//             }]
//           }
//         });
//     }
//   ]);
angular.module('goApp')
  .controller('CustomEmailsSendCtrl', function($scope, $state, CustomEmailsService, emailSettings, CustomEmail, $rootScope) {
    $scope.options = {
      dateFormat: 'dddd, D MMMM, YYYY'
    };

    function loadCustomEmail() {
      initFilters();
      if ($state.params.id) {
        CustomEmail.show({id: $state.params.id}, function(data){
          $scope.email.recipients = $scope.email.rawRecipients = (data.recipients || []);
          (data.filters||[]).forEach(function(filter) {
            var field = _.filter($scope.data.filters,{key: filter.key})[0];
            if (field) {
              field.isSelected = true;
              if (field.key.indexOf("LOCATION") > -1) {
                $scope.email.selectedLocations = filter.value;
              } else {
                field.value = filter.value;
              }
            }
          }); 
          $scope.data.baseDate = data.send_at;
          initDate();
          if ($scope.data.baseDate) {
            $scope.date.useDate = 1;
          }

          $scope.email.template = data.theme_id;
          $scope.email.prompts = data.prompts;
          $scope.email.body = data.body;
          $scope.email.subject = data.subject;
          $scope.email.from_address = $rootScope.dbSite.from_name ? $rootScope.dbSite.from_name + " <" + $rootScope.dbSite.from_address + ">" : $rootScope.dbSite.from_address;

        });
      } else {
        initDate();
      }
    }

    $scope.data = {
      // @todo rework this crap to service fetching
      templates: emailSettings.templates,
      filters: emailSettings.filters
    };

    $scope.email = {
      selectedLocations: [],
      recipients: [],
      from_address: $rootScope.dbSite.from_name ? $rootScope.dbSite.from_name + " <" + $rootScope.dbSite.from_address + ">" : $rootScope.dbSite.from_address
    };

    loadCustomEmail();

    $scope.$watch('email.template', function(templateId) {
      var selectedTemplate = _.filter($scope.data.templates, {
        id: templateId
      })[0];

      if (selectedTemplate && selectedTemplate.prompts)
        $scope.email.prompts = angular.copy(selectedTemplate.prompts);
      else
        $scope.email.prompts = [];
    });

    $scope.recipientsChangeHandler = function() {
      $scope.email.recipients = CustomEmailsService.filterRecipients($scope.email.rawRecipients);
    };

    $scope.isFormFilled = function() {
      return $scope.email.subject && ($scope.email.recipients.length || $scope.selectedFilters.length);
    };

    $scope.sendEmail = function() {
      $scope.validationErrors = [];

      var sendData = {
        recipients: $scope.email.recipients,
        filters: $scope.selectedFilters,
        send_at: $scope.date.getRealSendTime(),
        theme_id: $scope.email.template,
        prompts: $scope.email.prompts,
        body: $scope.email.body,
        subject: $scope.email.subject,
        from_address: $scope.email.from_address,
        id: $state.params.id
      };

      CustomEmailsService.emailActions.send(sendData).then(null, function(errors) {
        $scope.validationErrors = errors;
      });
    };


    $scope.previewEmail = function() {
      CustomEmailsService.emailActions.preview({
        theme_id: $scope.email.template,
        prompts: $scope.email.prompts,
        body: $scope.email.body,
        name: $scope.email.name // probably this prop isn't required?
      });
    };

    function initFilters() {
  
      $scope.filterLocationChangeHandler = function(filter) {
        filter.isSelected = !!$scope.email.selectedLocations.length;
      };

      $scope.filterSelectChangeHandler = function(filter) {
        filter.isSelected = !!filter.value;
      };

      $scope.addLocation = function(locationFilter) {
        $scope.email.selectedLocations.push('');
        $scope.filterLocationChangeHandler(locationFilter);
      };

      $scope.setSelectedLocation = function(locationId, idx){
        $scope.email.selectedLocations[idx] = locationId;
      };

      $scope.removeLocation = function(locationIndex, locationFilter) {
        $scope.email.selectedLocations.splice(locationIndex, 1);
        $scope.filterLocationChangeHandler(locationFilter);
      };

      $scope.$watch('data.filters', filterChangeHandler, true);

      function filterChangeHandler() {
        var selectedFilters = _.compact(_.map($scope.data.filters, function(value) {
          if (value.isSelected)
            return value;
        }));

        $scope.selectedFilters = _.map(selectedFilters, function(filter) {
          return filter.key !== 'LOCATION_PARTICIPANTS' ? {
            key: filter.key,
            value: filter.value
          } : {
            key: filter.key,
            value: $scope.email.selectedLocations
          };
        });
      }
    }

    function initDate() {
      var baseDate = $scope.data.baseDate || new Date().getTime();

      $scope.date = {
        sendDate: new Date(baseDate),
        sendTime: new Date(baseDate),
        isTimeChanged: function() {
          return $scope.date.sendTime.getTime() !== baseDate;
        },
        isDateChanged: function() {
          return moment($scope.date.sendDate).milliseconds() !== baseDate;
        },
        getRealSendTime: function() {
          var realSendTime = null;
          if (!!this.useDate) {
            var realSendTime = moment().add(1, 'hour');
            var sendDateMoment = moment(this.sendDate);
            var sendTimeMoment = moment(this.sendTime);


            if (sendDateMoment.milliseconds() !== baseDate ||
              sendTimeMoment.milliseconds() !== baseDate) {
              realSendTime = sendDateMoment
                .hours(sendTimeMoment.hours())
                .minutes(sendTimeMoment.minutes());
            }
            realSendTime = realSendTime.zone(0)._d;
          }

          return realSendTime;
        }
      };
    }

  });
'use strict';

angular.module('goApp')
.factory('CustomEmail', function(ActiveResource, $http, DOMAIN, $stateParams) {

  var CustomEmail = ActiveResource('/custom_emails/:id', {
    domain: DOMAIN,
    parentResource: ['Site']
  });

  CustomEmail.getSettings = function(siteId) {
    return $http.get(DOMAIN + '/sites/' + siteId + '/custom_emails/settings');
  };

  CustomEmail.getEstimateRecipients = function(siteId, filters) {
    return $http.post(DOMAIN + '/sites/' + siteId + '/custom_emails/estimate_recipients', filters);
  };

  CustomEmail.send = function(siteId, emailData) {
    return $http.post(DOMAIN + '/sites/' + siteId + '/custom_emails/send', emailData);
  };

  CustomEmail.preview = function(siteId, data) {
    return $http.post(DOMAIN + '/sites/' + siteId + '/custom_emails/preview', data);
  };



  return CustomEmail;
});
'use strict';

angular.module('goApp')
.config(function($stateProvider) {
  $stateProvider
  .state('go.u.site.custom-emails', {
    url: '/custom-emails',
    template: '<div ui-view></div>',
    abstract: true
  })
  .state('go.u.site.custom-emails.template-editor', {
    url: '/edit',
    templateUrl: '/scripts/customEmails/editor/customEmailsEditor.html',
    controller: 'CustomEmailsTemplateEditorCtrl'
  })
  .state('go.u.site.custom-emails.send', {
    url: '/send/:id',
    templateUrl: '/scripts/customEmails/customEmails.html',
    controller: 'CustomEmailsSendCtrl',
    params: {
      id: null
    },
    resolve: {
      emailSettings: function (CustomEmailsService, $stateParams) {
          return CustomEmailsService.getSettings($stateParams.siteId);
      }
    }
  });
});
angular.module('goApp')
  .service('CustomEmailsService', function($q, CustomEmail, $interpolate, LocationService, ngDialog, CustomEmailTemplate, FetchedDataGroup, $stateParams, $state, $rootScope, ErrorService) {
    var dialogTexts = {
      currentNewTemplateWillBeLost: 'Unsaved new template will be wiped. Proceed?',
      emailSend: "Your email will be sent to {{participantsAmount}} participants. Are you sure you\'d like to {{ operation }} now?",
      deleteTemplate: 'Template will be completely removed from the system. Procced?'
    };

    var CustomEmailService = {
      getSettings: function(siteId) {
        var defer = $q.defer(),
          settings = {},
          locationFilter;

        $q.all({
          locations: LocationService.get(true, getSiteId(siteId)),
          settings: CustomEmail.getSettings(getSiteId(siteId))
        }).then(function(data) {
          settings = {
            templates: _.result(data.settings, 'data.data[0].themes', []),
            filters: _.result(data.settings, 'data.data[0].filters', []),
            from_address: _.result(data.settings, 'data.data[0].from_address'),
          };

          locationFilter = _.filter(settings.filters, {
            key: 'LOCATION_PARTICIPANTS'
          })[0];

          if (locationFilter && !locationFilter.options.length) {
            locationFilter.options = data.locations;
          }

          defer.resolve(settings);
        }, function() {
          defer.reject();
        });

        return defer.promise;
      },
      templates: new FetchedDataGroup(function() {
        return CustomEmailTemplate.index({
          page_size: 0,
          site_id: CustomEmailService.getSiteId()
        });
      }, true),
      editorActions: {
        saveTemplate: function(template) {
          return CustomEmailTemplate.save(template, getSiteId());
        },
        deleteTemplate: function(template, successCallback, errorCallback) {
          return CustomEmailTemplate.destroy({
            id: template.id,
            site_id: getSiteId()
          }, successCallback, errorCallback);
        },
        confirm: {
          deleteTemplate: function() {
            var popupScope = $rootScope.$new();
            popupScope.confirmation = {
              confirmText: 'Yes',
              cancelText: 'No',
              message: dialogTexts.deleteTemplate
            };

            return callConfirmation(popupScope);
          },
          currentNewTemplateWillBeLost: function() {
            var popupScope = $rootScope.$new();
            popupScope.confirmation = {
              confirmText: 'Yes',
              cancelText: 'No',
              message: dialogTexts.currentNewTemplateWillBeLost
            };

            return callConfirmation(popupScope);
          }
        }
      },
      emailActions: {
        send: function(emailData) {
          var popupScope = $rootScope.$new();
          var defer = $q.defer();

          CustomEmail.getEstimateRecipients(getSiteId(), {
              filters: emailData.filters,
              recipients: emailData.recipients
            })
            .then(function(participants) {
              popupScope.confirmation = {
                confirmText: 'Yes',
                cancelText: 'No',
                message: $interpolate(dialogTexts.emailSend)({
                  participantsAmount: participants.data.data[0].total,
                  operation: emailData.send_at ? "enqueue" : "send"
                })
              };

              callConfirmation(popupScope).then(function() {
                CustomEmail.send(getSiteId(), emailData)
                  .then(function(resp) {
                    defer.resolve(resp);
                    popupScope.information = {
                      title: 'Done',
                      message: $interpolate('Email has been {{ operation }}!')({
                        operation: emailData.send_at ? "enqueued" : "sent"
                      })
                    };
                    callInformation(popupScope);

                  }, function(resp) {
                    var errors = resp && resp.data && resp.data.errors || [];
                    defer.reject(errors);
                    ErrorService.showErrors(resp, 'Could not send email.');
                  });
              });
            });

          return defer.promise;
        },
        preview: function(data) {
          CustomEmail.preview(getSiteId(), data)
            .then(function(data) {
              var popupScope = $rootScope.$new();
              popupScope.previewHtml = data.data.data[0].html;

              ngDialog.openConfirm({
                scope: popupScope,
                className: 'ngdialog-theme-default col-3',
                template: '/scripts/customEmails/dialogs/previewDialog.html'
              });
            });
        }
      },
      filterRecipients: function(recipientsString) {
        recipientsString = recipientsString || '';

        var bare = recipientsString.split(/(\s|\;|\,|\|)/);
        var emailsMap = _.map(bare, function(val) {
          if (val.indexOf('@') > -1 && val.indexOf('.') > -1) {
            return val;
          }
        });

        return _.compact(emailsMap) || [];
      },
      getSiteId: function(passedSiteId) {
        return passedSiteId || $stateParams.siteId || ($rootScope.site && $rootScope.site.id);
      }
    };

    function callConfirmation(popupScope) {
      return ngDialog.openConfirm({
        scope: popupScope,
        template: '/scripts/dialogs/confirmationDialog.html'
      });
    }

    function callInformation(popupScope) {
      return ngDialog.openConfirm({
        scope: popupScope,
        template: '/scripts/dialogs/informationDialog.html'
      });
    }

    function getSiteId(passedSiteId) {
      return passedSiteId || $stateParams.siteId || ($rootScope.site && $rootScope.site.id);
    }

    return CustomEmailService;
  });
angular.module('goApp')
  .controller('CustomEmailsTemplateEditorCtrl', function($scope, CustomEmailTemplate, CustomEmailsService) {
    $scope.currentTemplate = {};

    $scope.data = {
      templates: []
    };

    $scope.status = {
      deletingTemplate: false,
      savingTemplate: false
    };

    $scope.createNewTemplate = function() {
      if (findEmptyTemplate()) {
        CustomEmailsService.editorActions.confirm.currentNewTemplateWillBeLost()
          .then(function() {
            $scope.selectTemplate(createTemplate());
          });
      } else {
        var newTemplate = createTemplate();

        $scope.data.templates.push(newTemplate);
        $scope.selectTemplate(newTemplate);
      }

      function createTemplate() {
        var newTemplate = new CustomEmailTemplate();
        newTemplate.name = 'New template';

        return newTemplate;
      }
    };

    $scope.deleteTemplate = function() {
      CustomEmailsService.editorActions.confirm.deleteTemplate()
        .then(deleteTemplate);

      function deleteTemplate() {
        $scope.status.savingTemplate = true;

        if ($scope.currentTemplate.template.id) {
          CustomEmailsService.editorActions.deleteTemplate(
            $scope.currentTemplate.template,
            function() {
              _.remove($scope.data.templates, function(template) {
                return template.id === $scope.currentTemplate.template.id;
              });

              initTemplate();

              $scope.status.deletingTemplate = false;
            },
            function() {
              $scope.status.deletingTemplate = false;
            }
          )
        } else {
          _.remove($scope.data.templates, function(template) {
            return !template.id;
          });

          initTemplate();
        }
      }
    };

    $scope.saveTemplate = function() {
      $scope.status.savingTemplate = true;

      CustomEmailsService.editorActions.saveTemplate($scope.currentTemplate.template)
        .then(function(template) {
          !$scope.currentTemplate.id && _.extend(findEmptyTemplate(), template);
        })
        .finally(function() {
          $scope.status.savingTemplate = false;
        });
    };

    $scope.selectTemplate = function(template) {
      if (!template.prompts)
        template.prompts = [];

      $scope.currentTemplate.template = template;

      if (!$scope.currentTemplate.id || $scope.currentTemplate.id !== template.id)
        $scope.currentTemplate.id = template.id;
    };

    $scope.addPrompt = function() {
      $scope.currentTemplate.template.prompts.push({});
    };

    $scope.removePrompt = function(promptIndex) {
      $scope.currentTemplate.template.prompts.splice(promptIndex, 1);
    };

    $scope.currentTemplateChangeHandler = function() {
      $scope.selectTemplate(_.filter($scope.data.templates, function(template) {
        return $scope.currentTemplate.id === template.id;
      })[0]);
    };

    function findEmptyTemplate() {
      return _.filter($scope.data.templates, function(template) {
        return !template.id;
      })[0];
    }

    function initTemplate() {
      CustomEmailsService.templates.get(true).then(function(templates) {
        $scope.data.templates = templates;
        if ($scope.data.templates.length) {
          $scope.selectTemplate($scope.data.templates[0]);
        } else {
          $scope.createNewTemplate();
        }
      });
    }

    initTemplate();
  });
'use strict';

angular.module('goApp')
  .factory('CustomEmailTemplate', function(ActiveResource, DOMAIN, $http, $q) {

    // @TODO rework to resource

    var CustomEmailTemplate = ActiveResource('/custom_email_themes/:id', {
      domain: DOMAIN,
      parentResource: 'Site',
      nestedRoutes: ['index', 'create', 'save', 'show', 'update', 'destroy']
    });

    CustomEmailTemplate.save = function(template, siteId) {
      var defer = $q.defer(), callPromise;

      if (template.id)
        callPromise = $http.put(DOMAIN + '/sites/' + siteId + '/custom_email_themes/' + template.id, template);
      else
        callPromise = $http.post(DOMAIN + '/sites/' + siteId + '/custom_email_themes', template);

      callPromise
        .then(function (response) {
          // for existing templates API returns empty data, for new - data with template in it
          if (response.data)
            defer.resolve(new CustomEmailTemplate(response.data.data[0]));
          else
            defer.resolve();
        }, function() {
          defer.reject();
        });

      return defer.promise;
    };

    return CustomEmailTemplate;
  });
angular.module("goApp").controller("CustomEmailsQueueCtrl", function($scope, $http, DOMAIN, queued_emails, ngDialog, $state){
  
  console.log(queued_emails);
  
  $scope.data = {
    table: {
      fields: [
        ["send_at", "string"],
        ["status", "string"],
        ["actions", "actions", {
          width: 200
        }]
      ],
      rows: [],
      actions: []
    }
  };

  function setTableData() {

    var editMail = function(ele) {
      $state.go("go.u.site.custom-emails.send",{site_id:ele.site_id,id:ele.id})
    }

    var showMail = function(ele) {
      $http.get(DOMAIN+"/custom_emails/queue/"+ele.id).then(function(response){
        $scope.mail = response.data;
        ngDialog.openConfirm({
          template: '/scripts/customEmails/queued_emails/show.template.html',
          className: 'ngdialog-theme-default col-3',
          controller: function($scope) {
            $scope.date = new Object();
          },
          scope: $scope
        }).then(function() {
        
        });
      });
    }

    var destroyMail = function(ele) {
      if(confirm("Are you sure you want to delete '"+ele.id+"'?") == true){
        $http.delete(DOMAIN+"/custom_emails/queue/"+ele.id).then(function(){
          _.remove($scope.data.table.rows, {
            key: ele.key
          });
        });
      }
    }

    var rows = [],
      gridRows = [];
    for (var i = 0; i < queued_emails.data.length; i++) {
      var ele = queued_emails.data[i];
      var eleLink = '/custom_emails/queue/' + ele.id;


      // rows.push([
      ele.row = [
        (ele.send_at || ''),
        (ele.status || 'N/A'),
        // (ele.key || 'N/A'),




        [
          ['edit', editMail, ele],
          ['show', showMail, ele],
          // ['users', eleLink + '/users'],
          ['delete', destroyMail, ele]
        ]
      ];
      // ]);
      gridRows.push(ele);
    }

    $scope.data.table.rows = gridRows;
  }

  setTableData();

})
angular.module('goApp').config(function($stateProvider) {
  $stateProvider.state('go.u.queued_emails', {
    url: '/queued_emails',
    templateUrl: '/scripts/customEmails/queued_emails/index.template.html',
    controller: 'CustomEmailsQueueCtrl',
    resolve: {
      queued_emails: function ($http, DOMAIN, $stateParams) {
        return $http.get(DOMAIN + '/custom_emails/queue');
      }
    }
  })
  
  $stateProvider.state('go.u.site.queued_emails', {
    url: '/queued_emails',
    templateUrl: '/scripts/customEmails/queued_emails/index.template.html',
    controller: 'CustomEmailsQueueCtrl',
    resolve: {
      queued_emails: function ($http, DOMAIN, $stateParams) {
        return $http.get(DOMAIN + '/sites/'+ $stateParams.siteId +'/custom_emails/queue');
      }
    }
  })
  
})
'use strict';

angular.module('goApp').factory('Daily', function($http, $q, ActiveResource, DOMAIN, HesDate) {

  var Daily = ActiveResource('/daily/:id', {
    domain: DOMAIN
  });


  Daily.get = function() {
    return Daily.show().$promise;
  }



  return Daily;
});
'use strict';

angular.module('goApp')
  .controller('ChooseHowToLogController',
    function($scope, $state, ContentService, CurrentUser) {

      var ctrl = this;

      ctrl.view = {
        saving: false,
        selectDevice: false,
        crumbs: [],
        activityContent: {},
        settingsContent: {}
      };

      ctrl.view.crumbs = [{
        state: 'go.u.choose.log',
        display: 'Choose how to log',
        isButton: $state.current.name === 'go.u.settings.tracking',
        onClick: function() {
          ctrl.view.selectDevice = false;
        }
      }, {
        state: 'go.u.choose.device',
        display: 'Connect Device'
      }];

      ctrl.view.activityContent = ContentService
        .getContentByCategoryAndKey('choose_device', $scope.site.id, 'log_activity_message');

      ctrl.view.settingsContent = ContentService
        .getContentByCategoryAndKey('choose_device', $scope.site.id, 'settings_message');

      ctrl.showSelectDevice = function() {
        ctrl.view.selectDevice = true;
      };

      ctrl.selectedManual = function() {
        console.log('User updated', $scope.user.active_device);
      };

      ctrl.showDevices = function() {
        $state.go('go.u.choose.device');
      };

      ctrl.allDone = function() {
        CurrentUser.get(true).then(function() {
          $state.go('go.u.personal.entries', {
            year: $scope.site.years[0]
          });
        });
      }

    });
'use strict';

angular.module('goApp')
    .controller('ConnectionSuccessfulController', ['$rootScope', '$scope', 'CurrentUser', '$location', '$http', 'DOMAIN', '$state', 'ngDialog',
        function($rootScope, $scope, CurrentUser, $location, $http, DOMAIN, $state, ngDialog) {
          $scope.connectionCompleted = false;
          
          // Did the user connect through Validic? Still needs to finish.
          if($location.search()['marketplace']) {
            $http.get(DOMAIN + "/validic/finish_connection").then(function(d) {
              CurrentUser.get(true).then(function() {
                if($scope.user.isValidicConnected() && $scope.user.validic_user.applications) {
                  $scope.validicConnected = true;
                  $rootScope.$broadcast('validicConnectionFinished');
                }
                else {
                  $scope.validicNotConnected = true;
                }
                
                $scope.connectionCompleted = true;
              });
        		}, function() {
              $scope.validicNotConnected = true;
        		});
            
            //$location.search('marketplace', null);
          }
          else if ($location.search()['garmin']) {
            $http.get(DOMAIN + "/garmin/finish_connection").then(function() {
              CurrentUser.get(true).then(function() {
                if($scope.user.isGarminConnected()) {
                  $scope.garminConnected = true;
                  $rootScope.$broadcast('garminConnectionFinished');
                }
                else {
                  $scope.garminNotConnected = true;
                }
                
                $scope.connectionCompleted = true;
              });
        		}, function() {
              $scope.garminNotConnected = true;
        		});
            
            $location.search('garmin', null);
          }
          else {
            CurrentUser.get(true).then(function() {
              $scope.connected = true;
              $scope.connectionCompleted = true;
            });
          }
          
          $scope.redirectToConnect = function() {
            ngDialog.close();
            $state.go("go.u.settings.tracking");
          };
        }
    ]);

'use strict';

angular.module('goApp')
  .controller('DeviceInformationController', ['$scope', '$filter', 'DevicesService', 'DOMAIN', '$http', '$state',
    function($scope, $filter, DevicesService, DOMAIN, $http, $state) {
      
      function buildCrawlerHistory() {
        var copy = $scope.deviceUser.device_crawler_history;
        var crawlerLines = copy.split('\n');
        
        for(var i = 0; i < crawlerLines.length; i++) {
          crawlerLines[i] = {
            timestamp: crawlerLines[i].split(" ").splice(0, 6).join (" "),
            action: crawlerLines[i].split(" ").splice(8).join(" ")
          };
        }
        
        $scope.deviceCrawlerHistory = crawlerLines;
      }

      function buildDeviceWeeks() {
        var deviceWeeks = [];

        if($scope.deviceUser.fitbit_weeks) {
          for(var i = 0; i < $scope.deviceUser.fitbit_weeks.length; i++) {
            var deviceWeekObject = {
              week_label: $scope.deviceUser.fitbit_weeks[i][0],
              week_number: $scope.deviceUser.fitbit_weeks[i][1]
            }

            deviceWeeks.push(deviceWeekObject);
          }

          delete $scope.deviceUser.device_weeks;
          $scope.deviceUser.device_weeks = deviceWeeks;
        }
      }

      $scope.formatFitbitDate = function(fitbitDate) {
        return fitbitDate ? [$filter('date')(fitbitDate, 'yyyy-MM-dd'), $filter('date')(fitbitDate, 'HH:mm:ss Z')].join(' at ') : 'N/A';
      };
      
      $scope.getFormattedNotification = function(notification) {
        return DevicesService.formattedNotification(notification);
      };

      $scope.getValidicData = function(week) {
        $scope.loadingValidicData = true;
        $scope.validicData = [];

        DevicesService.viewValidicData($scope.deviceUser.id, week).then(function(data) {
          $scope.loadingValidicData = false;
          $scope.validicData = data;
        });
      };
      
      $scope.isCurrentSubscription = function(subscription) {
        return parseInt(subscription.subscriptionId) === $scope.deviceUser.fitbit_user.id;
      };
      
      $scope.refreshWeekData = function(chosenWeek) {
        $scope.refreshingDeviceData = true;

        var path = (function() {
          if($scope.deviceUser.isFitbitConnected()) {
            return DOMAIN + '/fitbit/refresh_week?week=' + chosenWeek + '&user_id=' + $scope.deviceUser.id;
          }
          else if($scope.deviceUser.isValidicConnected()) {
            return DOMAIN + '/validic/refresh_week?week=' + chosenWeek + '&user_id=' + $scope.deviceUser.id;
          }
          else if($scope.deviceUser.isGarminConnected()) {
            return DOMAIN + '/garmin/refresh_week?week=' + chosenWeek + '&user_id=' + $scope.deviceUser.id;
          }
          else if($scope.deviceUser.isGoogleHealthConnected()) {
            return DOMAIN + '/google_health/refresh_week?week=' + chosenWeek + '&user_id=' + $scope.deviceUser.id;
          }
        })();

        $http.post(path).then(function() {
          $state.reload();
        }, function() {
          // Error refreshing.
        });
      };
      
      // Do stuff.
      $scope.$watch("dashboardSettingsUser",function(new_val){
        if (!new_val || !new_val.id) return;

        $scope.deviceUser = $scope.dashboardSettingsUser;

        $scope.deviceNotifications = $scope.deviceUser.google_health_user_notifications || $scope.deviceUser.garmin_user_notifications || $scope.deviceUser.fitbit_user_notifications || $scope.deviceUser.jawbone_user_notifications || $scope.deviceUser.validic_user_notifications || [];
        $scope.showCrawlerHistory = $scope.deviceUser.isFitbitConnected() || $scope.deviceUser.isValidicConnected();

        if($scope.deviceUser.device_crawler_history) {
          buildCrawlerHistory();
        }

        buildDeviceWeeks();

        if($scope.deviceUser.isValidicConnected()) {
          $scope.getValidicData();
        }
      });

    }
  ]);
'use strict';

angular.module('goApp')

.factory('MarketplaceLoader', ['$http', '$q', 'DOMAIN', '$state', function($http, $q, DOMAIN, $state) {
  return function() {
    var defer = $q.defer();
    //var returnURL = encodeURIComponent(window.location.href.split('#')[0].slice(0, -1) + '/#/' + $state.current.name.split('go.u.')[1].replace(".", "/") + '?deviceConnected=true' + '&marketplace=true');
    //var returnURL = encodeURIComponent(window.location.href + '?deviceConnected=true' + '&marketplace=true');
    var returnURL = window.location.protocol + '//' + window.location.host + window.location.pathname + '?deviceConnected=true' + '&marketplace=true';

    $http.get(DOMAIN + "/validic/marketplace", {
			params: {
        return_url: encodeURIComponent(returnURL)
			}
		}).then(function(response) {
			defer.resolve(response.data);
		}, function(error) {
      defer.reject('Marketplace options could not be loaded.');
		});

    return defer.promise;
  };
}]);
'use strict';

angular.module('goApp').controller('DeviceOptionsController', function($rootScope, $scope, $http, $q, $state, CurrentSite, CurrentUser, DOMAIN, DevicesService, ngDialog, $sce) {

  function isWebcart(items) {
    return items[0].key === 'WEBCART';
  }

  // Hide initial options and display the connect options.
  $scope.displayConnect = function() {
      $scope.displayInitialOptions = false;
      $scope.displayConnectOptions = true;
      $scope.displayManualOptions = false;
      $scope.displayStoreOptions = false;
  };

  // Hide inital options and display the manual logging options.
  $scope.displayManual = function() {
      $scope.displayInitialOptions = false;
      $scope.displayConnectOptions = false;
      $scope.displayManualOptions = true;
      $scope.displayStoreOptions = false;
  };

  // Hide initial options and display the store options.
  $scope.displayStore = function() {
      $scope.displayInitialOptions = false;
      $scope.displayConnectOptions = false;
      $scope.displayManualOptions = false;
      $scope.displayStoreOptions = true;
      
      // Webcart only has one item.
			if(isWebcart($scope.items)) {
				$scope.isWebcart = true;
				$scope.item = $scope.items[0];
        
        $scope.webcartHtml = $sce.trustAsHtml($scope.item.paragraph);
			}
  };

  $scope.itemsAvailable = function() {
    return $scope.items ? $scope.items.length > 0 : false;
  };
    
  $scope.setAvailableDevices = function() {
		$scope.activeDevices = [];

    if($scope.user.isAnyDeviceConnected()) {
      $scope.activeDevices.push({deviceName: "ALL", displayName: "Device/App", isConnecting: false});
    }

    $scope.devicesTitle = DevicesService.getTitle();
	};

  $scope.setDisplayedOptions = function() {

    // If there are items available to buy, the user has no orders, and the user does not have a device connected, display the initial options.
    if($scope.user.order_count === 0 && !$scope.isConnected && !$scope.isLoggingManually) {
        $scope.displayInitialOptions = true;
    }
    else if($scope.isLoggingManually) {
        $scope.displayManualOptions = true;
    }
    else {
        $scope.displayConnectOptions = true;
    }
  };

  $scope.tryDisconnect = function(device) {
    var title = 'Are you sure you want to disconnect?';
    var message = 'Your device steps won\'t sync with <em>AktiveTrak</em>';
    var confirmText = 'Disconnect';

    DialogService.openConfirmationDialog(title, message, 'Cancel', confirmText, 'device-confirm-dialog', true).then(function () {
        $scope.disconnectDevice(device)
    });
  };

  $scope.disconnectDevice = function(device) {
    $scope.isDisconnecting = true;

    DevicesService.disconnectDevice(device).then(function(disconnected) {
      $scope.isDisconnecting = false;
      
      // Display connect option if successfully disconnected.
      if(typeof disconnected === 'boolean') {
        $scope.isConnected = !$scope.isConnected;

        // Display the initial options.
        $scope.displayInitialOptions = true;
        $scope.displayConnectOptions = false;
        $scope.displayStoreOptions = false;
        
        // Set the user.
        CurrentUser.get(true);
      }
    }, function() {
      // Error disconnecting.
    });
  };


  $q.all([
    CurrentSite.get(),
    CurrentUser.get(true)
  ]).then(function() {
      $scope.setAvailableDevices();
      $scope.isViewingPrestart = $state.current.name === 'go.u.prestart';
      
      // Has the user already chose something?
      if($scope.user.isAnyDeviceConnected()) {
				$scope.isConnected = true;
				$scope.$emit('hasChosenDevicePreference', true);
			}
			else if($scope.user.isLoggingManually()) {
				$scope.isLoggingManually = true;
				$scope.$emit('hasChosenDevicePreference', true);
			}

      // Get all items from the store. Should be ONLY Webcart for KAA.
      $http.get(DOMAIN + '/store').then(function(response) {
        $scope.items = response.items;
        $scope.setDisplayedOptions();
      }, function(error) {
          // Error getting store items.
      });
  }, function() {
      // TODO: Handle this somehow?
  });
  
  $scope.$on('garminConnectionFinished', function() {
    $scope.displayConnect();
    
    if($scope.user.isAnyDeviceConnected()) {
      $scope.isConnected = true;
    }
  });

  // Need to reset displayed options after finishing a Validic connection.
  $scope.$on('validicConnectionFinished', function() {
    $scope.displayConnect();
    
    if($scope.user.isAnyDeviceConnected()) {
      $scope.isConnected = true;
    }
  });
});
'use strict';

angular.module('goApp')
  .config(['$stateProvider',
    function($stateProvider) {

      $stateProvider.state('go.u.choose', {
        title: 'Log Activity',
        abstract: true,
        controller: 'ChooseHowToLogController as ChooseLogCtrl',
        templateProvider: function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/devices/choose/choose-layout.html');
        }
      });

      $stateProvider.state('go.u.choose.log', {
        title: 'Log Activity',
        url: '/choose',
        templateProvider: function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/devices/choose/choose-view.html');
        },
        onEnter: function($rootScope, site, $state) {
          if ($rootScope.user.hasChosenLogging() && site.hasDevicesEnabled()) {
            $state.transition.then(function() {
              $state.go('go.u.personal.entries', {
                year: site.years[0]
              });
            });
          }
        }
      });

      $stateProvider.state('go.u.choose.device', {
        title: 'Log Activity',
        url: '/choosedevice',
        controller: 'ChooseHowToLogController as ChooseLogCtrl',
        templateProvider: function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/devices/choose/choose-device-view.html');
        }
      });
    }
  ]);


angular.module("goApp").run(function($rootScope, $location, ngDialog, $timeout, GoogleHealthConnection){

  $rootScope.$on('$stateChangeSuccess', function() {
    if ($location.search()['fitbit_error']) {
      ngDialog.open({
          className: 'ngdialog-theme-default',
          template: '/scripts/devices/fitbit_connection_error.html',
          scope: $rootScope
      });

      $location.search('fitbit_error', null);
    }
    else if ($location.search()['garmin_error']) {
      ngDialog.open({
          className: 'ngdialog-theme-default',
          template: '/scripts/devices/garmin_connection_error.html',
          scope: $rootScope
      });

      $location.search('garmin_error', null);
    }
    else if ($location.search()['googlefit_error']) {
      ngDialog.open({
          className: 'ngdialog-theme-default',
          template: '/scripts/devices/googlefit_connection_error.html',
          scope: $rootScope
      });

      $location.search('googlefit_error', null);
    }
    else if ($location.search()['google_health_error']) {
      GoogleHealthConnection.clearPending();
      GoogleHealthConnection.showConnectionError();

      $location.search('google_health_error', null);
      $location.search('deviceConnected', null);
    }
    else if ($location.search()['connection_error']) {
      $rootScope.error_code = $location.search()['connection_error'];
      ngDialog.open({
        className: 'ngdialog-theme-default',
        template: '/scripts/devices/connection_error.html',
        scope: $rootScope
      });

      $location.search('connection_error', null);
    }
    else if ($location.search()['deviceConnected'] === 'true') {
      if ($location.search()['google_health']) {
        GoogleHealthConnection.clearPending();
        GoogleHealthConnection.showConnectionConfirmed();
        $location.search('google_health', null);
      }
      else {
        ngDialog.open({
          className: 'ngdialog-theme-default',
          template: '/scripts/devices/connection_successful.html',
          controller: 'ConnectionSuccessfulController'
        });
      }

      $location.search('deviceConnected', null);
    }
    else if (GoogleHealthConnection.consumeUnresolved(false)) {
      GoogleHealthConnection.showConnectionOutcome();
    }
  });


  angular.element(window).on('pageshow', function(event) {
    var restored = !!(event.originalEvent ? event.originalEvent.persisted : event.persisted);

    if (restored && GoogleHealthConnection.consumeUnresolved(true)) {
      $timeout(function() {
        GoogleHealthConnection.showConnectionOutcome();
      });
    }
  });

});

'use strict';

angular.module('goApp')

.service('DevicesService', function($rootScope, $http, $q, DOMAIN, $filter, Entry) {
		var Devices = function() {
			
			this.connectDevice = function(deviceType, returnURL) {
				var defer = $q.defer();
				
				// Used a switch here since Jawbone used to be an option... leaving it for potential future integrations.
				var path = (function() {
					switch(deviceType.toUpperCase()) {
					case 'FITBIT':
						return '/fitbit/begin';
						break;
					case 'GARMIN':
						return '/garmin/begin';
						break;
					case 'GOOGLE_HEALTH':
						return '/google_health/begin';
					}
				}());

				$http.post(DOMAIN + path, {
					return_url: returnURL
				}).then(function(response) {
					defer.resolve(response.data.url);
				}, function() {
					defer.reject('Error connecting to ' + deviceType + '.');
				});
				
				return defer.promise;
			};

			this.disconnectDevice = function(deviceType) {
				var defer = $q.defer();
				
				var path = (function() {
					switch(deviceType.toUpperCase()) {
					case 'FITBIT':
						return '/fitbit/disconnect';
						break;
					case 'VALIDIC':
						return '/validic/disconnect';
						break;
					case 'GARMIN':
						return '/garmin/disconnect';
						break;
					case 'GOOGLE_HEALTH':
						return '/google_health/disconnect';
					case 'APPLE':
					case 'HEALTH_CONNECT':
						return '/apps/disconnect_mobaggdevice';
						break;
					}
				}());
				
				$http.post(DOMAIN + path).then(function(response) {
					defer.resolve(true);
				}, function() {
					defer.reject('Error disconnecting from ' + $rootScope.user.formattedActiveDevice() + '.');
				});
				
				return defer.promise;
			};
			
			this.formattedNotification = function(notification) {
				if(notification.hasOwnProperty('validic_user_id') && !notification.is_processed) {
					return "Received update for " + $filter('date')(notification.reported_on, 'yyyy-MM-dd') + ". Not yet processed.";
				}
				
				var dateProperty = 'date';

				if(notification.hasOwnProperty('fitbit_user_id')) {
					dateProperty = 'date';
				}
				else if(notification.hasOwnProperty('validic_user_id')) {
					dateProperty = 'reported_on';
				}
				else{
					dateProperty = 'date';
				}
				
				switch(notification.status) {
				case 'E':
					return $filter('date')(notification.updated_at, 'yyyy-MM-dd HH:mm:ss Z') + ' - Error processing update for ' + $filter('date')(notification[dateProperty], 'yyyy-MM-dd') + '.';
					break;
				case 'H':
					return $filter('date')(notification.updated_at, 'yyyy-MM-dd HH:mm:ss Z') + ' - Received update for ' + $filter('date')(notification[dateProperty], 'yyyy-MM-dd') + '. Held for unknown reason.'
					break;
				case 'P':
					return $filter('date')(notification.updated_at, 'yyyy-MM-dd HH:mm:ss Z') + ' - Processed update for ' + $filter('date')(notification[dateProperty], 'yyyy-MM-dd') + '.';
					break;
				case 'S':
					return $filter('date')(notification.updated_at, 'yyyy-MM-dd HH:mm:ss Z') + ' - Processing update for ' + $filter('date')(notification[dateProperty], 'yyyy-MM-dd') + '.';
					break;
				case 'I':
					return $filter('date')(notification.updated_at, 'yyyy-MM-dd HH:mm:ss Z') + ' - Ignored update for ' + $filter('date')(notification[dateProperty], 'yyyy-MM-dd') + '.';
					break;
				case 'T':
					return $filter('date')(notification.updated_at, 'yyyy-MM-dd HH:mm:ss Z') + ' - Ignored and not processed for ' + $filter('date')(notification[dateProperty], 'yyyy-MM-dd') + ' for testing the crawler.';
					break;
				default:
					return $filter('date')(notification.updated_at, 'yyyy-MM-dd HH:mm:ss Z') + ' - Received update for ' + $filter('date')(notification[dateProperty], 'yyyy-MM-dd') + '.';
					break;
				}
			};
			
			this.getTitle = function() {
				if($rootScope.site.flags.disable_manual_logging) {
					var count = 0;
					var possibleTitle;

					if($rootScope.site.flags.is_fitbit_enabled && !$rootScope.site.flags.is_validic_enabled) {
						count += 1;
						possibleTitle = "Fitbit";
					}
					
					if($rootScope.site.flags.is_garmin_enabled && !$rootScope.site.flags.is_validic_enabled) {
						count += 1;
						possibleTitle = "Garmin";
					}

					if($rootScope.site.flags.is_google_health_enabled && !$rootScope.site.flags.is_validic_enabled) {
						count += 1;
						possibleTitle = "Google Health";
					}

					if($rootScope.site.flags.is_validic_enabled) {
						count += 1;
						possibleTitle = "Device/App";
					}
					
					return "Connect Your " + (count === 1 ? possibleTitle : "Device");
				}
				else {
					return "Decide How You Want to Log Activity";
				}
			};
			
			this.useDeviceDataText = function() {
				return 'Sync';
			};
			
			this.viewValidicData = function(userId, week) {
				var defer = $q.defer();
				
				$http.get(DOMAIN + '/validic/view_data', {
					params: {
						user_id: userId,
						week: week
					}
				}).then(function(response) {
					defer.resolve(response.data);
				}, function() {
					defer.reject('Validic data could not be loaded.');
				});
				
				return defer.promise;
			};

			// NOTE moved to entry-resource
			// this.useDeviceDataForEntry = function(deviceType, entryId) {
			// 	var defer = $q.defer();
			// 	var url = DOMAIN +  '/use_' + $rootScope.user.active_device.toLowerCase() + '_data';
			// 	var rejectMsg = 'Cannot find ' + $rootScope.user.formattedActiveDevice() + ' data for this date.';
			// 
			// 	$http.post(url, {
			// 		entry_id: entryId
			// 	}).then(function(response, status) {
			// 		var entry = Entry.build(response.data);
			// 		// Need to update the Entry regardless since "manually_recorded" gets set to false whether there is device data or not.
			// 		$rootScope.$broadcast('EntrySaved', entry);
			// 
			// 		// 204 means there are zero steps for the device on this day.
			// 		if(status === 204) {
			// 			defer.reject(rejectMsg);
			// 		}
			// 		else {
			// 			defer.resolve(entry);
			// 		}
			// 	}, function() {
			// 		defer.reject(rejectMsg);
			// 	});
			// 
			// 	return defer.promise;
			// };

			this.getSummaries = function(deviceType, timeInterval, currentDate, successCallback, failCallback) {

				var url = DOMAIN;
				
				if(deviceType == 'FITBIT'){
					url += '/fitbits/get_daily_summaries'
				}

				return $http.post(url, {
					chart_type: timeInterval,
					current_date: currentDate || new Date()
				});
			};
			
			this.listApps = function() {
			 return $http.get(DOMAIN + '/validic/list_apps');
			};
		};

		return new Devices();
});

'use strict';

angular.module('goApp')
  .controller('FitbitSummaryController', ['$scope', '$filter', 'DevicesService', 'Utils', 'CurrentUser', 'ChartService', 'HesDate', 'CurrentPromotion',
    function($scope, $filter, DevicesService, Utils, CurrentUser, ChartService, HesDate, CurrentPromotion) {

      $scope.view = {
        loading: true,
        timeInterval: 'week',
        currentDate: new Date(),
        currentInterval: ''
      };

      $scope.deviceData = {
        stepsTaken: 0,
        caloriesBurned: 0,
        veryActiveMinutes: 0,
        chartObj: {
          type: 'ColumnChart',
          displayed: true,
          data: {
            cols: [{
              id: "t",
              label: 'Days',
              type: 'string'
            }, {
              id: "s",
              label: 'Steps',
              type: 'number'
            }],
            rows: []
          },
          options: {
            title: 'Fitbit Summary Data',
            titlePosition: 'none',
            height: 350,
            vAxis: {
              title: 'Steps',
              format: '#',
              maxValue: 5000,
              viewWindow: {
                min: 0
              }
            },
            colors: ['#f7941e', '#b6354b', '#777569', '#5d7d43', '#154c4b', '#57b6b4', '#c5b174', '#e21351', '#1d4f91', '#879e3b', '#5a4a42', '#508293'],
            legend: {
              position: 'none',
              maxLines: 30,
              width: '70%'
            },
            chartArea: {
              // left: 10,
            //   top: 0,
              width: '80%',
              height: 260
            },
            fontName: 'Arial'
          }
        }
      };


      $scope.setChartData = function(days) {
        // Display a date range (for a week) or just the month name.
        $scope.view.currentInterval = ($scope.view.timeInterval === 'week') ? 'Week of ' + $filter('date')(days[0].reported_on, 'MMMM d') + ' - ' + $filter('date')(days[days.length - 1].reported_on, 'MMMM d') : $filter('date')(days[0].reported_on, 'MMMM yyyy');

        // Graph data.
        var rows = [];
        var stepsData = [];

        // Stats data.
        $scope.deviceData.stepsTaken = 0;
        $scope.deviceData.caloriesBurned = 0;
        $scope.deviceData.veryActiveMinutes = 0;

        for (var i = 0; i < days.length; i++) {

          var day = days[i];
          // Graph data.
          rows.push([$filter('date')(day.reported_on, 'MMM d'), day.steps || 0]);

          // Sidebar data.
          $scope.deviceData.stepsTaken += day.steps;
          $scope.deviceData.caloriesBurned += day.calories_out;
          $scope.deviceData.veryActiveMinutes += day.very_active_minutes;
          $scope.deviceData.veryActiveMinutes += day.fairly_active_minutes;
        }

        $scope.deviceData.chartObj.data.rows = ChartService.getRows(rows);

      };

      $scope.getSummaries = function() {
        $scope.view.loading = true;
        DevicesService.getSummaries($scope.user.active_device, $scope.view.timeInterval, $scope.view.currentDate).then(function(days) {
          $scope.setChartData(days);
          $scope.view.loading = false;
        });
      };

      // Resets the current date.
      $scope.resetCurrentDate = function() {
        if($scope.promotion.hasEnded()){
          $scope.view.currentDate = $scope.promotion.endsOn();
        } else {
          $scope.view.currentDate = $scope.promotion.getCurrentDate();
        }
      };

      // Displays data for a new time interval.
      $scope.moveTimeInterval = function(direction) {

        // Move forward or backward?
        if (direction === -1 && $scope.canMoveBackward) {
          $scope.view.timeInterval === 'week' ? HesDate.addDays($scope.view.currentDate, -7) : $scope.view.currentDate = new Date($scope.view.currentDate.setMonth($scope.view.currentDate.getMonth() - 1));
        } else if (direction === 1 && $scope.canMoveForward) {
          $scope.view.timeInterval === 'week' ? HesDate.addDays($scope.view.currentDate, 7) : $scope.view.currentDate = new Date($scope.view.currentDate.setMonth($scope.view.currentDate.getMonth() + 1));
        }

        $scope.getSummaries();
        $scope.setMovementControls();
      };

      $scope.setMovementControls = function() {
        $scope.canMoveBackward = true;
        $scope.canMoveForward = true;
        var pastDate, futureDate;

        // Promotion start date.
        var startsOn = $scope.promotion.startsOn();
        startsOn = new Date(startsOn.setHours(0, 0, 0, 0));
        HesDate.addDays(startsOn, 1);

        // Promotion end date.
        var endsOn = $scope.promotion.endsOn();
        endsOn = new Date(endsOn.setHours(0, 0, 0, 0));
        HesDate.addDays(endsOn, 1);

        if ($scope.view.timeInterval === 'week') {

          // Past and future dates to check against.
          pastDate = $scope.view.currentDate;
          pastDate = new Date(pastDate.setHours(0, 0, 0, 0));
          pastDate = HesDate.addDays(pastDate, -7);

          futureDate = $scope.view.currentDate;
          futureDate = new Date(futureDate.setHours(0, 0, 0, 0));
          futureDate = HesDate.addDays(futureDate, 7);

          // Move backwards.
          if (pastDate >= startsOn) {
            $scope.canMoveBackward = true;
          } else {
            $scope.canMoveBackward = false;
          }

          // Move forwards.
          if (futureDate < endsOn) {
            $scope.canMoveForward = true;
          } else {
            $scope.canMoveForward = false;
          }
        } else {

          // Past and future dates to check against.
          pastDate = $scope.view.currentDate;
          pastDate = new Date(pastDate.setHours(0, 0, 0, 0));
          pastDate = new Date(pastDate.getFullYear(), pastDate.getMonth(), 1);

          futureDate = $scope.view.currentDate;
          futureDate = new Date(futureDate.setHours(0, 0, 0, 0));
          futureDate = new Date(futureDate.getFullYear(), futureDate.getMonth() + 1, 0);

          // Move backwards.
          if (pastDate > startsOn) {
            $scope.canMoveBackward = true;
          } else {
            $scope.canMoveBackward = false;
          }

          // Move forwards.
          if (futureDate < endsOn) {
            $scope.canMoveForward = true;
          } else {
            $scope.canMoveForward = false;
          }
        }
      };

      // Switches the display to a month.
      $scope.switchToMonthMode = function() {
        $scope.resetCurrentDate();
        $scope.view.timeInterval = 'month';
        $scope.getSummaries();
        $scope.setMovementControls();
      };

      // Switches the display to a week.
      $scope.switchToWeekMode = function() {
        $scope.resetCurrentDate();
        $scope.view.timeInterval = 'week';
        $scope.getSummaries();
        $scope.setMovementControls();
      };

      CurrentPromotion.get().then(function() {
        CurrentUser.get().then(function() {
          $scope.switchToWeekMode();
        });
      });

    }
  ]);
'use strict';

angular.module('goApp')
  .controller('GoogleHealthConnectionErrorController', ['$rootScope', '$scope', 'ContentLoader', 'Content',
    function($rootScope, $scope, ContentLoader, Content) {
      new ContentLoader({
        site_id: $rootScope.site.id,
        category: 'marketplace'
      }, true).then(function(content) {
        $scope.connection_failed = Content.getByKey(content, 'connection_failed', true);
      });
    }
  ]);

'use strict';

angular.module('goApp')

.service('GoogleHealthConnection', function($rootScope, ngDialog, CurrentUser) {
	var PENDING_KEY = 'google_health_connecting';
	var startedHere = false;

	function read() {
		try {
			return window.sessionStorage.getItem(PENDING_KEY);
		} catch(e) {
			return null;
		}
	}

	this.markPending = function() {
		startedHere = true;
		try {
			window.sessionStorage.setItem(PENDING_KEY, '1');
		} catch(e) {}
	};

	this.clearPending = function() {
		startedHere = false;
		try {
			window.sessionStorage.removeItem(PENDING_KEY);
		} catch(e) {}
	};

	this.consumeUnresolved = function(restored) {
		if (!read() || (startedHere && !restored)) {
			return false;
		}

		this.clearPending();
		return true;
	};

		this.showConnectionError = function() {
			ngDialog.open({
				className: 'ngdialog-theme-default',
				template: '/scripts/devices/google_health_connection_error.html',
				controller: 'GoogleHealthConnectionErrorController',
				showClose: true
			});
		};

	this.showConnectionSuccess = function() {
			ngDialog.open({
				className: 'ngdialog-theme-default',
				template: '/scripts/devices/google_health_connection_success.html',
				controller: 'GoogleHealthConnectionSuccessController',
				showClose: true
			});
	};

	this.showConnectionConfirmed = function() {
		this.showConnectionSuccess();

		CurrentUser.get(true).then(function() {
			$rootScope.$broadcast('googleHealthConnectionFinished');
		});
	};

	this.showConnectionOutcome = function() {
		var self = this;

		CurrentUser.get(true).then(function() {
			if ($rootScope.user && $rootScope.user.isGoogleHealthConnected()) {
				$rootScope.$broadcast('googleHealthConnectionFinished');
				self.showConnectionSuccess();
			}
			else {
				self.showConnectionError();
			}
		}, function() {
			self.showConnectionError();
		});
	};
});

'use strict';

angular.module('goApp')
  .controller('GoogleHealthConnectionSuccessController', ['$rootScope', '$scope', 'ContentLoader', 'Content',
    function($rootScope, $scope, ContentLoader, Content) {
      new ContentLoader({
        site_id: $rootScope.site.id,
        category: 'marketplace'
      }, true).then(function(content) {
        $scope.connected_information = Content.getByKey(content, 'connected_information', true);
      });
    }
  ]);

'use strict';

angular.module('goApp')

	.controller('MarketplaceController',
		function($rootScope, $scope, $q, CurrentUser, MarketplaceLoader, DevicesService, ContentLoader, ngDialog, Content, $state, DialogService, GoogleHealthConnection) {

			var ctrl = this;
			$scope.plainText = function(value) {
				return value ? String(value).replace(/<[^>]+>/gm, '') : '';
			};

			ctrl.market = {
				options: [],
				loading: true,
				user: $rootScope.user,
				site: $rootScope.site,
				content: {}
			};

			if (!$rootScope.user.active_device) {
				ctrl.market.loading = true;
			}

			CurrentUser.get(true).then(function() {
				new MarketplaceLoader().then(function(data) {
					ctrl.market.options = data.apps;
					ctrl.market.loading = false;
				}, function() {
					// Error getting marketplace data.
					ctrl.market.loading = false;
				});
			});

			ctrl.tryDisconnect = function(device) {
				var title = 'Are you sure you want to disconnect?';
				var message = "Your device steps won't sync with <em>" + ctrl.market.site.name + "</em>.";
				var confirmText = 'Disconnect';
			
				DialogService.openConfirmationDialog(title, message, 'Cancel', confirmText, 'device-confirm-dialog', true).then(function () {
					ctrl.disconnectDevice(device)
				});
			};
			
			ctrl.disconnectDevice = function(device) {
				DevicesService.disconnectDevice(device).then(function(disconnected) {
					// Set the user.
					CurrentUser.get(true);
				}, function() {
					// Error disconnecting.
				});
			};

			ctrl.isValidicAppConnected = function(validicAppName) {
				return ctrl.market.user.connectedValidicApp() === validicAppName;
			};

			ctrl.fitbitRedirect = function() {
				var returnURL = window.location.href;
				$scope.connecting = true;

				DevicesService.connectDevice('FITBIT', returnURL).then(function(deviceURL) {
					location.href = deviceURL;
				}, function() {
					// Error connecting.
				});
			};

			ctrl.garminRedirect = function() {
				var returnURL = window.location.href;
				$scope.connecting = true;
				
				DevicesService.connectDevice('GARMIN', returnURL).then(function(deviceURL) {
					location.href = deviceURL;
				}, function() {
					// Error connecting.
				});
			}

			ctrl.validicRedirect = function(url) {
				$scope.connecting = true;
				window.location = url;
			}


			$scope.content = {
				hk: {},
				hc: {},
				gh: {},
				ghDescription: {}
			};

			$q.all([
				new ContentLoader({category: 'mobile'}),
				new ContentLoader({category: 'health_kit'}),
				new ContentLoader({category: 'health_connect'}),
				new ContentLoader({category: 'google_health'})
			]).then(function(data){
				$scope.content.hk.ios_app_link = Content.getByKey(data[0], 'ios_app_link', true)
				$scope.content.hc.android_app_link = Content.getByKey(data[0], 'android_app_link', true)
				$scope.content.hk.icon = Content.getByKey(data[1], 'health_kit_icon', true)
				$scope.content.hk.sync = Content.getByKey(data[1], 'app_sync', true)
				$scope.content.hc.icon = Content.getByKey(data[2], 'health_connect_icon', true)
				$scope.content.hc.sync = Content.getByKey(data[2], 'app_sync', true)
				$scope.content.gh = Content.getByKey(data[3], 'marketplace', true) || {};
				$scope.content.ghDescription = Content.getByKey(data[3], 'marketplace_description', true) || {};
			})

			ctrl.openGoogleHealthDialog = function() {
				ngDialog.open({
					className: 'ngdialog-theme-default',
					template: '/scripts/devices/google_health_connect.html',
					scope: $scope,
					showClose: false
				});
			};

			ctrl.googleHealthRedirect = function() {
				$scope.connecting = true;
				GoogleHealthConnection.markPending();

				DevicesService.connectDevice('GOOGLE_HEALTH', window.location.href).then(function(deviceURL) {
					location.href = deviceURL;
				}, function() {
					$scope.connecting = false;
					GoogleHealthConnection.clearPending();
					ngDialog.closeAll();
					GoogleHealthConnection.showConnectionError();
				});
			};

			ctrl.connectAppleHealth = function() {
				ngDialog.openConfirm({
					template: '/scripts/devices/apple_health_popup.html',
					scope: $scope
				})
			}

			ctrl.connectHealthConnect = function() {
				ngDialog.openConfirm({
					template: '/scripts/devices/health_connect_popup.html',
					scope: $scope
				})
			}
		}
	);

'use strict';
angular.module('goApp')
  .component('hesMarketplace', {
    templateUrl: '/scripts/devices/marketplace/marketplace.html',
    controller: 'MarketplaceController'
  });
'use strict';

angular.module('goApp')
  .config(['ngDialogProvider', function(ngDialogProvider) {
    ngDialogProvider.setDefaults({
      ariaRole: 'dialog',
      trapFocus: true,
      showClose: true,
      ariaLabelledBySelector: 'h2',
      ariaAuto: true,
      controller: function($scope, $mdUtil) {
        var restoreScroll = $mdUtil.disableScrollAround();
        $scope.$on('$destroy', function() {
          restoreScroll();
        });
      }
    });
  }])
  .service('DialogService', function(ngDialog, $rootScope, $mdUtil) {
    var DialogService = {
      closeOnRouteChange: function(dialog) {
        return $rootScope.$on('$stateChangeStart', function() {
          dialog && dialog.close();
        });
      },
      openInformationDialog: function(title, message, className) {
        var dialogScope = $rootScope.$new();
        dialogScope.information = {
          title: title,
          message: message
        };

        var dialog = ngDialog.open({
          scope: dialogScope,
          template: '/scripts/dialogs/informationDialog.html',
          //className: 'ngdialog-theme-default ' + (className || ''),
          showClose: true
        });
        var routeWatcher = DialogService.closeOnRouteChange(dialog);
        dialog.closePromise
          .finally(function() {
            routeWatcher();
            dialogScope.$destroy();
          });

        return dialog.closePromise;
      },
      openConfirmationDialog: function(title, message, cancelText, confirmText, className, isUnsavedPopup) {
        // take only em tag
        message = message.replace(/<(?!\/?em(?=>|\s.*>))(.|\n)*?>/g, ''); // XXS issue patch
        var dialogScope = $rootScope.$new();

        dialogScope.confirmation = {
          title: title,
          message: message,
          cancelText: cancelText,
          confirmText: confirmText
        };

        var settings = {
          template: isUnsavedPopup ? '/scripts/dialogs/confirmationUnsavedDialog.html' : '/scripts/dialogs/confirmationDialog.html',
          scope: dialogScope,
          showClose: false,  
        }

        if (className) {
          settings.className = 'ngdialog-theme-default ' + (className || '');
        }

        var promise = ngDialog.openConfirm(settings);

        promise.finally(function() {
          dialogScope.$destroy();
        });

        return promise;
      },
      openEmailDialog: function(user) {
        var dialogScope = $rootScope.$new();

        dialogScope.emailSettings = {
          sent: false,
          disabled: false,
          emailMsg: '',
          email: {
            message: '',
            recipient: user
          },
          showClose: false
        };

        var dialog = ngDialog.open({
          //className: 'ngdialog-theme-default email',
          template: '/scripts/dialogs/email.html',
          scope: dialogScope,
          controller: 'EmailController'
        });

        dialog.closePromise
          .finally(function() {
            dialogScope.$destroy();
          });

        return dialog.closePromise;
      },
      openUploadingDialog: function(message) {
        var dialogScope = $rootScope.$new();
        dialogScope.uploading = true;
        dialogScope.message = message || "Uploading... this may take a few minutes.";
        return ngDialog.open({
          //className: 'ngdialog-theme-default uploading',
          template: '/scripts/dialogs/uploading.html',
          scope: dialogScope,
          closeByEscape: false,
          closeByDocument: false
        });
      },
      openSmsSendDialog: function(data) {
        var dialogScope = $rootScope.$new();

        dialogScope.data = data
        var settings = {
          template: '/scripts/sms/dialogs/sendSmsDialog.html',
          scope: dialogScope,
          controller: 'SmsDialogCtrl',
          showClose: false,  
        }

        var promise = ngDialog.openConfirm(settings);

        promise.finally(function() {
          dialogScope.$destroy();
        });

        return promise;
      },
      openPromptLocationDialog: function(data) {
        var dialogScope = $rootScope.$new();

        dialogScope.data = data
        var settings = {
          template: '/scripts/location/prompt_location/promptLocationDialog.html',
          scope: dialogScope,
          controller: 'PromptLocationCtrl',
          showClose: true,  
        }

        var promise = ngDialog.openConfirm(settings);

        promise.finally(function() {
          dialogScope.$destroy();
        });

        return promise;
      },
      openCustomConfirmationDialog: function(options) {
        var defaults = {
          //className: 'ngdialog-theme-default',
          template: '/scripts/dialogs/confirmationDialog.html'
        };

        options = angular.extend(defaults, options);

        var dialog = ngDialog.openConfirm(options);

        if (options.scope) {
          dialog
            .finally(function() {
              options.scope.$destroy();
            });
        }

        return dialog;
      }
    };

    return DialogService;
  });
'use strict';

angular.module('hes.config')
  .service('DynamicCssService', ['THEMES',
    function(THEMES) {

      function isIE() {
        var myNav = navigator.userAgent.toLowerCase();
        return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
      }

      return function(theme) {
        var cssPath = "styles/themes/" + theme + "/" + theme.toLowerCase() + ".css";
        return cssPath + "?" + new Date().getTime();
      };
    }
  ]);
'use strict';

/**
 * goKpApp Module - Dynamic Template
 *
 * Uses the Current promotion to set custom templates if available
 */
angular.module('hes.config')
	.service('hesImageService', function($rootScope, THEMES, THEMED_IMAGES) {
		var templateService = {
			getImagePath: function(imagePath) {
				var theme = THEMES[0].key;

				imagePath = imagePath.replace('/images/', '');
				imagePath = imagePath[0] === '/' ? imagePath.substring(1) : imagePath;

				if ($rootScope.dbSiteTheme) {
					theme = $rootScope.dbSiteTheme;
				} else if ($rootScope.promotion) {
					theme = $rootScope.dbSite.getTheme();
				}

				if (theme !== THEMES[0].key) {
					if (THEMED_IMAGES.indexOf(theme + '/' + imagePath) === -1) {
						theme = THEMES[0].key;
					}
				}

				return '/images/' + theme + "/" + imagePath;
			},
			getIconTheme: function(iconName) {
				var theme = THEMES[0].key;
				if ($rootScope.site) {
					theme = $rootScope.site.getTheme();
				}

				return theme + "-" + iconName;
			}
		};

		return templateService;
	});
'use strict';

angular.module('goApp')
  .controller('EligibilitiesController', ['$scope', 'CurrentPromotion', 'Eligibility', 'EligibilitiesLoader', 'ngDialog',
    function($scope, CurrentPromotion, Eligibility, EligibilitiesLoader, ngDialog) {

      $scope.settings = {
        loading: true
      };

      // wustl-only columns prove the roster import (alt_id, structure_level_10) and dob actually landed
      var wustlFields = $scope.dbSite.isWUSTL() ? [
        ['Employee ID', 'string'],
        ['DOB', 'string'],
        ['Structure Level 10', 'string']
      ] : [];

      $scope.data = {
        eligibilities: [],
        tblData: {
          fields: [
            ["ID", "string"],
            ["First Name", "string"],
            ["Last Name", "string"],
            ["Email", "string"],
            ['Location', 'string']
          ].concat(wustlFields).concat([
            ["Registered", "string"],
            ['Actions', 'actions', {
              width: 200
            }]
          ]),
          rows: [],
          actions: []
        }
      };

      $scope.reset = function(index) {
        $scope.data.eligToReset = $scope.data.eligibilities[index];
        var promise = ngDialog.openConfirm({
          template: '/scripts/eligibility/confirmResetElig.html',
          scope: $scope
        });
        promise.then(function() {
          $scope.data.eligToReset.user_id = null;
          $scope.data.eligibilities[index].save(function(updatedEligibility) {
            $scope.data.eligibilities[index] = updatedEligibility;
            $scope.reloadTable();
          });
        });
      };

      $scope.edit = function(eligibility) {
        eligibility.save(function(updatedEligibility) {
          eligibility = updatedEligibility;
          $scope.isSaving = false;
          $scope.isEditing = false;
        }, function() {
          $scope.isSaving = false;
          $scope.hasError = true;
        });
      };

      $scope.confirmDelete = function(index) {
        $scope.data.eligToDelete = $scope.data.eligibilities[index];
        ngDialog.openConfirm({
          template: '/scripts/eligibility/confirmDeleteElig.html',
          scope: $scope
        }).then(function() {
          $scope.destroy(index);
        });
      };

      $scope.destroy = function(index) {
        $scope.data.eligibilities[index].destroy(function() {
          $scope.data.eligibilities.splice(index, 1);
          $scope.reloadTable();
        });
      };

      $scope.isRegistered = function(eligibility) {
        return eligibility.user_id ? 'Yes' : 'No';
      };

      function setTableData() {

        var rows = [];
        for (var i = 0; i < $scope.data.eligibilities.length; i++) {
          var elig = $scope.data.eligibilities[i];
          var index = i;
          var eligLink = '/site/' + $scope.dbSite.id + '/eligibility/';

          var showMembers = function(args) {
            $scope.viewProgress.apply(this, args);
          };

          var triggerReset = function(args) {
            $scope.reset.apply(this, args);
          };

          var doDelete = function(args) {
            $scope.confirmDelete.apply(this, args);
          };

          var wustlRow = $scope.dbSite.isWUSTL() ? [elig.alt_id, elig.birth_date, elig.structure_level_10] : [];

          elig.row = [
            elig.identifier,
            elig.first_name,
            elig.last_name,
            elig.email,
            elig.string_1
          ].concat(wustlRow).concat([
            $scope.isRegistered(elig), [
              ['Edit', eligLink + elig.id + '/edit'],
              ($scope.isRegistered(elig) === 'Yes' ? ['Reset', triggerReset, [index]] : ''), ['Delete', doDelete, [index]]
            ]
          ]);

          rows.push(elig);
          index = null;
        }

        $scope.data.tblData.rows = rows;
        $scope.data.loading = false;
      }

      new EligibilitiesLoader({
        site_id: $scope.dbSite.id
      }).then(function(eligs) {
        $scope.data.eligibilities = eligs;

        setTableData();
      }, function() {
        $scope.data.loading = false;
      });

      $scope.reloadTable = function() {
        $scope.settings.loading = true;
        setTableData();
      };

    }
  ]);
'use strict';

angular.module('goApp')
  .controller('EligibilityController', ['$scope', 'dbEligibility',
    function($scope, dbEligibility) {
      $scope.dbEligibility = dbEligibility;
    }
  ]);
'use strict';

angular.module('goApp')
  .factory('EligibilitiesLoader', ['Eligibility', '$q', 'Utils',
    function(Eligibility, $q, Utils) {
      return function(opts) {
        var defer = $q.defer();

        var options = {
          page_size: 0
        };
        if (!Utils.isUndefinedOrNull(opts.site_id)) {
          options.site_id = opts.site_id;
        }

        Eligibility.index(options, function(files) {
          defer.resolve(files);
        }, function() {
          defer.reject('Eligibilities could not be loaded.');
        });

        return defer.promise;
      };
    }
  ])
  .factory('EligibilityFilesLoader', ['EligibilityFile', '$q', 'Utils',
    function(EligibilityFile, $q, Utils) {
      return function(opts) {
        var defer = $q.defer();

        var options = {
          page_size: 0
        };
        if (!Utils.isUndefinedOrNull(opts.site_id)) {
          options.site_id = opts.site_id;
        }

        EligibilityFile.index(options, function(files) {
          defer.resolve(files);
        }, function() {
          defer.reject('Eligibility Files could not be loaded.');
        });

        return defer.promise;
      };
    }
  ])
  .factory('EligibilityLoader', ['Eligibility', '$q', 'Utils',
    function(Eligibility, $q, Utils) {
      return function(opts) {
        var defer = $q.defer();

        var options = {
          page_size: 0, 
          id: opts.eligibility_id
        };
        if (!Utils.isUndefinedOrNull(opts.site_id)) {
          options.site_id = opts.site_id;
        }

        if (Utils.isUndefinedOrNull(opts.eligibility_id) || opts.eligibility_id === "new") {
          defer.resolve(Eligibility.build({
            site_id: parseInt(opts.site_id)
          }));
        } else {
          Eligibility.index(options, function(eligs) {
            defer.resolve(eligs[0]);
          }, function() {
            defer.reject('Eligibility could not be loaded.');
          });
        }
        return defer.promise;
      };
    }
  ]);
'use strict';

angular.module('goApp')
  .factory('Eligibility', ['ActiveResource', 'DOMAIN',
    function(ActiveResource, DOMAIN) {
      var Eligibility = ActiveResource('/eligibilities/:id', {
        nestedRoutes: ['index', 'create', 'update', 'destroy'],
        parentResource: 'Site',
        domain: DOMAIN
      });

      Eligibility.prototype.save = function(successCallback, errorCallback) {
        if (typeof this.id !== 'undefined' && this.id !== 'validate') {
          return this.update(successCallback, errorCallback);
        } else {
          return this.create(successCallback, errorCallback);
        }
      };

      Eligibility.validate = function(siteId, identifier, birth_date, success, fail) {
        return new Eligibility({
          id: 'validate',
          site_id: siteId,
          identifier: identifier,
          birth_date: birth_date
        }).save(success, fail);
      };


      return Eligibility;
    }
  ]);
'use strict';

angular.module('goApp')
  .config(['$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('go.u.site.eligibilities', {
          url: '/eligibilities',
          controller: 'EligibilitiesController',
          templateProvider: ['hesTemplateService',
            function(hesTemplateService) {
              return hesTemplateService.getTemplate('/scripts/eligibility/eligibilities.html');
            }
          ]
        })
        .state('go.u.site.eligibilityfiles', {
          url: '/eligibilityfiles',
          controller: 'EligibilityFilesController',
          templateProvider: ['hesTemplateService',
            function(hesTemplateService) {
              return hesTemplateService.getTemplate('/scripts/eligibility/eligibilityFile.html');
            }
          ]
        })
        .state('go.u.site.eligibility', {
          url: '/eligibility/:eligId',
          controller: 'EligibilityController',
          template: '<div ui-view></div>',
          abstract: true,
          resolve: {
            dbEligibility: ['EligibilityLoader', '$stateParams',
              function(EligibilityLoader, $stateParams) {
                return new EligibilityLoader({eligibility_id: $stateParams.eligId, site_id: $stateParams.siteId});
              }
            ]
          }
        })
        .state('go.u.site.eligibility.create', {
          url: '/create',
          controller: 'EligibilityCreateEditController',
          templateProvider: ['hesTemplateService',
            function(hesTemplateService) {
              return hesTemplateService.getTemplate('/scripts/eligibility/eligibilityCreateEdit.html');
            }
          ]
        })
        .state('go.u.site.eligibility.edit', {
          url: '/edit',
          controller: 'EligibilityCreateEditController',
          abstract: false,
          templateProvider: ['hesTemplateService',
            function(hesTemplateService) {
              return hesTemplateService.getTemplate('/scripts/eligibility/eligibilityCreateEdit.html');
            }
          ]
        });
    }
  ]);
'use strict';

angular.module('goApp')
  .controller('EligibilityCreateEditController', ['$scope', '$state', '$q', 'ErrorService', '$timeout',
    function($scope, $state, $q, ErrorService, $timeout) {
      $scope.dateFormat = 'L';

      $scope.data = {};

      $scope.settings = {
        saving: false,
        showSaving: false
      };

      $scope.view = {
        isEdit: false
      };


      $scope.editEligibility = $scope.dbEligibility;

      if ($state.current.name === 'go.u.site.eligibility.edit') {
        $scope.view.isEdit = true;
      }

      $scope.handleErrors = function(response) {
        $scope.settings.saving = false;
        $scope.settings.showSaving = false;
        ErrorService.showPriorityErrors(response, 'Could not save Eligibility', 1);
      };

      $scope.save = function() {
        var wasNew = $scope.editEligibility.isNew();
        $scope.settings.saving = true;
        var timeoutSave = $timeout(function() {
          $scope.settings.showSaving = true;
        }, 300);
        $scope.editEligibility.save(function(eligibility) {
          $timeout.cancel(timeoutSave);
          $scope.settings.saving = false;
          $scope.settings.showSaving = false;
          $scope.editEligibility = eligibility;
          if (wasNew) {
            $scope.view.isEdit = true;
          }
          $state.go('go.u.site.eligibilities');
        })['catch']($scope.handleErrors);
      };
    }
  ]);
'use strict';

angular.module('goApp')
  .factory('EligibilityFile', ['ActiveResource', 'DOMAIN', '$http', '$q',
    function(ActiveResource, DOMAIN, $http, $q) {
      var EligibilityFile = ActiveResource('/eligibility_files/:id', {
        nestedRoutes: ['index', 'create'],
        parentResource: 'Site',
        domain: DOMAIN
      });


      EligibilityFile.Process = ActiveResource('/eligibility_files/:id', {
        nestedRoutes: ['index', 'create'],
        parentResource: 'Site',
        domain: DOMAIN
      });

      EligibilityFile.prototype.getFileName = function() {
        return this.filename;
      };

      EligibilityFile.prototype.getUploadedAt = function() {
        return moment(this.created_at).format('lll');
      };

      EligibilityFile.prototype.getStatus = function() {
        var status = this.status;
        if (this.status === 'processing') {
          status += '... ' + this.getPercentProcessed() + '%';
        }
        return status;
      };

      EligibilityFile.prototype.getPercentProcessed = function() {
        var totalRows = this.total_rows > 0 ? this.total_rows : 1;
        var processed = this.rows_processed > 0 ? this.rows_processed : 0;
        return Math.floor((this.rows_processed / totalRows) * 100);
      };

      //TODO: change endpoints and use embedded resources

      EligibilityFile.prototype.process = function() {
        //var defer = $q.defer();
        //$http.post(DOMAIN + '/eligibility_files/' + this.id + '/process').then(defer.resolve,defer.reject);
        //defer.promise.then.apply(this, arguments);
        //return defer.promise;
        return $http.post(DOMAIN + '/eligibility_files/' + this.id + '/process');
      };

      EligibilityFile.prototype.processStatus = function() {
        // var defer = $q.defer();
        // $http.post(DOMAIN + '/eligibility_files/' + this.id + '/processing_status').then(defer.resolve, defer.reject);
        // defer.promise.then.apply(this, arguments);
        // return defer.promise;
        return $http.post(DOMAIN + '/eligibility_files/' + this.id + '/processing_status');
      };

      EligibilityFile.prototype.download = function() {
        // var defer = $q.defer();
        // $http.get(DOMAIN + '/eligibility_files/' + this.id + '/download').then(defer.resolve,defer.reject);
        // defer.promise.then.apply(this, arguments);
        // return defer.promise;
        return $http.get(DOMAIN + '/eligibility_files/' + this.id + '/download');
      };

      return EligibilityFile;
    }
  ]);
'use strict';

angular.module('goApp')
  .controller('EligibilityFilesController', ['$scope', 'EligibilityFile', 'CurrentPromotion', 'ContentLoader', 'Content', 'EligibilityFilesLoader', 'ngDialog', '$filter', 'ErrorService', '$interval',
    function($scope, EligibilityFile, CurrentPromotion, ContentLoader, Content, EligibilityFilesLoader, ngDialog, $filter, ErrorService, $interval) {
      $scope.viewProgressVisible = false;

      $scope.settings = {
        loading: true,
        loadingFileProgress: false,
        isUploading: false,
        anySize: true,
        anyType: true
      };

      $scope.data = {
        activeEligibilityFile: null,
        eligFiles: [],
        filesToWatch: [],
        tblData: {
          fields: [
            ["File Name", "string"],
            ["Uploaded At", "string"],
            ["Status", "string"]
          ],
          rows: [],
          actions: []
        }
      };

      $scope.fileWatcher = null;

      if ($scope.user.isMaster()) {
        $scope.data.tblData.fields.push(["Actions", "actions", 3]);
      }

      function setTableData() {

        var rows = [];
        for (var i = 0; i < $scope.data.eligFiles.length; i++) {
          var file = $scope.data.eligFiles[i];
          var index = i;

          var download = function(args) {
            $scope.viewFile.apply(this, args);
          };

          var triggerProcess = function(args) {
            $scope.process.apply(this, args);
          };

          var doDelete = function(args) {
            $scope.confirmDelete.apply(this, args);
          };

          file.row = [
            file.getFileName(),
            file.getUploadedAt(),
            file.getStatus()
          ];
          if ($scope.user.isMaster()) {
            file.row.push([
              ['View', download, [index]],
              [(file.status === 'processing' ? 'Cancel' : 'Process'), triggerProcess, [file]], (file.status === 'processing' ? '' : ['Delete', doDelete, [index]])
            ]);
            if (file.status === 'processing') {
              $scope.setupProcessChecker(file);
            }
          }

          rows.push(file);
          index = null;
        }

        $scope.data.tblData.rows = rows;
        $scope.data.loading = false;
      }

      $scope.setupProcessChecker = function(eligFile) {
        $scope.data.filesToWatch.unshift(eligFile);
        if ($scope.watcher !== null) {
          $interval.cancel($scope.watcher);
        }

        $scope.watcher = $interval(function() {
          var eligFile = $scope.data.filesToWatch.pop();
          eligFile.$show(function(file) {
            eligFile = file;
            if (file.status === 'processing') {
              $scope.setupProcessChecker(file);
            } else {
              $interval.cancel($scope.watcher);
            }
            setTableData();
          });
        }, 1000);
      };

      $scope.process = function(eligFile) {
        if (eligFile.status === 'processing') {
          eligFile.status = 'canceled';
          delete eligFile.row;
          eligFile.save(function(file) {
            setTableData();
          }, function(response) {
            ErrorService.showPriorityErrors(response, 'Something went wrong', 1);
          });
        } else {
          eligFile.process().then(function(file) {
            eligFile.status = 'processing';
            eligFile.rows_processed = 0;
            setTableData();
          }, function(response) {
            ErrorService.showPriorityErrors(response, 'Something went wrong.', 1);
          });
        }
      };

      $scope.viewFile = function(index) {
        $scope.data.eligFiles[index].download().then(function(data) {
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          var blob = new Blob([data.data], {
              type: "octet/stream"
            }),
            url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = $scope.data.eligFiles[index].getFileName();
          a.click();
          window.URL.revokeObjectURL(url);
        });
      };

      $scope.confirmDelete = function(index) {
        $scope.data.activeEligibilityFile = $scope.data.eligFiles[index];
        $scope.settings.loadingFileProgress = true;

        $scope.confirmation = {
          message: 'Are you sure you want to delete ' + $scope.data.activeEligibilityFile.filename + '?',
          confirmText: 'Yes',
          cancelText: 'No'
        };
        ngDialog.openConfirm({
          scope: $scope,
          template: '/scripts/dialogs/confirmationDialog.html'
        }).then(function() {
          $scope.data.activeEligibilityFile.destroy().then(function() {
            $scope.doLoad();
          });
        });
      };

      $scope.uploadDone = function(data) {
        $scope.eligibilityFile.filename = data.files[0].url;
        $scope.saveEligibility();
      };

      $scope.doLoad = function() {
        new EligibilityFilesLoader({
          site_id: $scope.dbSite ? $scope.dbSite.id : $scope.site.id
        }).then(function(files) {

          $scope.data.eligFiles = $filter('orderBy')(files, '-created_at');
          setTableData();
          $scope.settings.loading = false;
        });

        $scope.eligibilityFile = new EligibilityFile({
          site_id: $scope.dbSite ? $scope.dbSite.id : $scope.site.id
        });

      };

      $scope.saveEligibility = function() {
        $scope.isUploading = true;
        $scope.eligibilityFile.save(function(file) {
          $scope.settings.isUploading = false;
          $scope.doLoad();
        }, function(error) {
          $scope.settings.isUploading = false;
          $scope.hasError = error;
        });
      };


      if ($scope.user.isMaster()) {
        $scope.doLoad();
      } else {
        CurrentPromotion.get().then(function(site) {
          $scope.dbSite = site;
          $scope.doLoad();
        });
      }

      $scope.$on('$destroy', function() {
        if ($scope.watcher !== null) {
          $interval.cancel($scope.watcher);
        }
      });
    }
  ]);
angular.module('goApp').directive("entriesChart", function(DOMAIN, $timeout, EntryWeek) {
  var entriesChart = new Object(),
      chart_element = null,
      unique_id = Math.random().toString(36).substr(2, 9);

  entriesChart.restrict = "EA";
  entriesChart.templateUrl = "/scripts/entries-chart/entries-chart.template.html";


  entriesChart.controller = function($scope, $http, $rootScope) {
    $scope.data = new Object();
    $scope.data.is_loading = true;
    $scope.data.total_steps = 0;


    $scope.data.group_options = ["Week", "Month", "Year"];
    $scope.data.selected_group = $scope.data.group_options[0];
    var current_group = null;

    $scope.data.from_date = null;
    $scope.data.to_date = null;

    $scope.updateChart = function(option) {
      $scope.data.selected_group = option || $scope.data.selected_group;

      if (current_group != $scope.data.selected_group) {
        var values = [];
        switch($scope.data.selected_group) {
          case "Week":
            var current_date = moment(),
                current_year = $rootScope.site.years[0],
                started_on = moment($rootScope.user.profile.started_on),
                from = null,
                to = null,
                base_format = "MMM D",
                to_format = null,
                from_format = null,
                humanized_date = null;

              var year_ago = moment.max([started_on, moment().subtract(1,"year")]);

              for (var m = year_ago; m.diff(moment(), 'week') <= 0; m.add(1, 'week')) {
                from = moment(m).startOf('isoWeek');
                to   = moment(m).endOf('isoWeek');


                from_format = to_format = base_format;
                if (from.year() != current_year) {
                  from_format = from_format + " YYYY";
                }
                if (to.year() != current_year) {
                  to_format = to_format + " YYYY";
                }
                
                humanized_date = [from.format(from_format),to.format(to_format)].join(" - ")
                
                if (to >= started_on && from <= current_date) {
                  values.push({
                    from_date: from.toDate(),
                    to_date:   to.toDate(),
                    humanized: humanized_date
                  });
                }
              }

            break;
          case "Month":
            var current_month = moment().month(),
                started_on = moment($rootScope.user.profile.started_on),
                years = _.reverse(_.clone($rootScope.site.years).slice(0,3)),
                from = null,
                to = null;

            _.each(years, function(y){
              var times = (y == $rootScope.site.years[0] ? current_month+1 : 12);
              _.times(times, function(n){
                from = moment().year(y).month(n).startOf('month');
                to   = moment().year(y).month(n).endOf('month');

                if (to >= started_on) {
                  values.push({
                    from_date: from.toDate(),
                    to_date:   to.toDate(),
                    humanized: from.format("MMM YYYY")
                  });
                }
              });
            });
            break;
          case "Year":
            var current_year = $rootScope.site.years[0],
                years = _.reverse(_.clone($rootScope.site.years)),
                from = null,
                to = null;

            _.each(years, function(y){
              from = moment().year(y).startOf('year');
              to   = moment().year(y).endOf('year');
              values.push({
                from_date: from.toDate(),
                to_date:   to.toDate(),
                humanized: from.format("YYYY")
              });
            });
            break;
        }
        $scope.data.values = _.reverse(values);
        $scope.data.selected_value = $scope.data.values[0];
        current_group = $scope.data.selected_group;
      }
      $timeout($scope.getChart);
    }

    function getConfig() {
     var _config = {
        type: 'bar',
        data: {
          datasets: [] // get dataset from api
        },
        options: {
          showLine: true,
          spanGaps: false,
          elements: {
            point:{
              radius: 0,
              hitRadius: 10
            }
          },
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: false,
            text: 'Total steps'
          },
          legend: {
            display: false
          },
          tooltips: {
            mode: 'nearest',
            displayColors: false,
            callbacks: {
              title: function(tooltipItem, data) {
                var ds = data.datasets[tooltipItem[0].datasetIndex];
                if (ds.label.match(/steps$/gi)) {
                  return tooltipItem[0].yLabel.toLocaleString() + " steps";
                } else {
                  return ds.label;
                }
              },
              label: function(tooltipItem, data) {
                var ds = data.datasets[tooltipItem.datasetIndex];
                var data_point = _.find(ds.data, {x:tooltipItem.xLabel});
                //return "week " + data_point.week_numbers[0];
                //return moment(data_point.from_date).format("MMM Do")  + " - " + moment(data_point.to_date).format("MMM Do");
                if (ds.label.match(/steps$/gi)) {
                  return moment(data_point.x).format("MMM D")
                } else {
                  return moment(data_point.from_date).format("MMM D")  + " - " + moment(data_point.to_date).format("MMM D");
                }
              },
            },
          },
          scaleShowValues: true,
          scales: {
            display: true,
            xAxes: [{
              offset: (function(){
                switch(current_group) {
                  case "Year":
                    return false;
                  case "Month":
                    return true;
                  case "Week":
                    return true;
                }
              })(),
              beginAtZero: true,
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              },   
              type: 'time',
              time: {
                unitStepSize: (function(){
                  switch(current_group) {
                    case "Year":
                      return null;
                    case "Month":
                      return 1;
                    case "Week":
                      return null;
                  }
                })(),
                displayFormats: (function(){
                  var format = {
                    month: 'MMM',
                    day: 'D'
                  };
                  if (current_group == "Week") {
                    format.day = "dddd";
                  }
                  return format;
                })(),
                unit: (function(){
                  switch(current_group) {
                    case "Year":
                      return 'month';
                    case "Month":
                      return 'day';
                    case "Week":
                      return 'day';
                  }
                })()
              },
              ticks: {
                autoSkip: false,
                callback: function(value, index, values) {
                  // if (current_group == "Week") {
                  //   return value.charAt(0);
                  // }
                  return value;
                }
             }
             }],
            yAxes: [{
              display: true,
              position: 'left',
              id: "y-axis-steps",
              ticks: {
                callback: function(value, index, values) {
                  if (value == 0) {
                    return value + ' steps';
                  } 
                  return value.toLocaleString();
                },
                //maxTicksLimit: 8,
                stepSize: 5000,
                // max: 35000,
                suggestedMax: 10000,
                suggestedMin: 0,
                beginAtZero: true
              },
              scaleLabel: {
                display: false,
                labelString: 'steps per week',
              },
              gridLines: {
                offsetGridLines: false
              }
            },
            {
              display: true,
              position: "right",
              id: "y-axis-program",
              scaleLabel: {
                display: false
              },
              ticks: {
                display: false,
                beginAtZero: true,
                stepSize: 1,
                suggestedMax: 2,
              },
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              }
            }
          ]
          }
        }
      }
      return _config;
    }
    

    $scope.getChart = function() {
      $scope.data.total_steps = 0;
      
      var canvas_ele_parent = document.getElementById("canvas-wrapper");
      canvas_ele_parent.innerHTML = "<canvas  height='250' id='"+unique_id+"'></canvas>";
      $http.get(DOMAIN+'/entries/chart',{
        params: {
          from_date: $scope.data.selected_value.from_date,
          to_date: $scope.data.selected_value.to_date
        }
      }).then(function(response){
        var chart_config = getConfig();
        chart_config.data.datasets = response.data;
        setTotalSteps(chart_config.data.datasets);
        _.each(chart_config.data.datasets, function(dataset) {
          if (dataset.image) {
            var img = new Image();
            img.src = dataset.image;
            img.width = 32;
            img.height = 32;
            dataset.pointStyle = img;
          }
        });
        chart_element = document.getElementById(unique_id).getContext('2d');
        var chart = new Chart(chart_element, chart_config);
        document.getElementById(unique_id).onclick = function(evt) {
          var active_points = chart.getElementsAtEvent(evt);
          _.each(active_points, function(active_point) {
           var clickedElementindex = active_point["_index"];
           var data_point = chart.data.datasets[active_point._datasetIndex].data[clickedElementindex];
           if (data_point && data_point.program) {
             if (data_point.program.logging_state == null) {
               if ($rootScope.hasUserOptedInToProgram(data_point.program)) {
                $rootScope.downloadHistory(data_point.program);
               }
             } else {
               $rootScope.goToProgram(data_point.program.id);
             }
             return false; // break each loop after program is found;
            }
          });
        }
      }).finally(function(){
        $scope.data.is_loading = false;
      });
    }

    function setTotalSteps(datasets) {
      $scope.data.total_steps = _.reduce(_.flatten(_.filter(datasets,
        function(ds){
          return ds.yAxisID != "y-axis-program";
        }).map(function(ds){
            return ds.data.map(function(data){
              return data.y || 0;
            })
          })
        ), function(acc, cur) {
          return acc + cur
        }) || 0;
    }
    
    
    $scope.updateChart();

  }



  return entriesChart;
});
'use strict';

angular.module('goApp').controller("EntriesController", function($scope, $rootScope, $filter, $state, $timeout, EntryService, Entry, Program, ErrorService, ContentLoader, hesTemplateService, BillboardService, ExportService){
  $scope.data = new Object();

  EntryService.getEntriesBetween({
    year: $state.params.year
  }).then(function(entry_weeks) {
    $scope.data.entry_weeks = entry_weeks;
    $scope.data.entry_weeks.forEach(function(ew) {
      ew.is_showing = false;
    });

    var top = $scope.data.entry_weeks[0];
    if (top && !$scope.user.isProgramLoggingActive()) {
      top.is_showing = true;
    }
  });

  $scope.toggleWeek = function(entry_week) {
    if (entry_week.program || $scope.isDisabled()) {
      return;
    }
    if (!entry_week.loaded_entries) {
      $scope.data.is_fetching_data = true;
      EntryService.getEntriesBetween({
        from_date: entry_week.from_date,
        to_date: entry_week.to_date,
        year: $state.params.year
      }).then(_.noop).finally(function(){
        $scope.data.is_fetching_data = false;
        entry_week.is_showing = !entry_week.is_showing;
      });
    } else {
      entry_week.is_showing = !entry_week.is_showing;
    }
  }

  $scope.formatted = function(date, format) {
    if (format == 'long') {
      return moment(date).format("dddd, MMMM D");
    }
    return moment(date).format(Entry.HUMAN_FORMAT);
  }

  $scope.isDisabled = function() {
    return $scope.data.edit_entry && $scope.data.edit_entry.origin.is_editing;
  }

  $scope.exportEntries = ExportService.exportEntries;

  $scope.formattedTotalSteps = function(steps) {
    return $filter('numberFormatter')(steps);
  };

  function init_activities(){
    $scope.user.getRecentActivities().then(function(response){
      var activities = {}
      if (response && response.data.length) {
        activities["Recent Activities"] = response.data;
      }
      activities["Activities"] = Entry.exercise_activities;
      $scope.data.activities = activities; 
    });
  }
  
  init_activities();

  window.addEventListener('resize', function () {
    $scope.$apply();
  });

});
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.u.personal.entries', {
    title: "Log Activity",
    url: "/log/:year",
    params: {year: new Date().getFullYear().toString()},
    controller: "EntriesController",
    onEnter: function($rootScope, site, $state) {
      if (!$rootScope.user.hasChosenLogging() && site.hasDevicesEnabled()) {
        $state.transition.then(function() {
          $state.transitionTo('go.u.choose.log');
        });
      }
    },
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/entries/views/entries.html');
      }
    ]
  });

});
'use strict';

angular.module('goApp').controller("EntryEditController", function($scope, $state, $timeout, EntryService, Entry, hesTemplateService, DialogService) {
  $scope.data = $scope.data || new Object();
  $scope.data.edit_entry = $scope.data.edit_entry || Entry.build();
  $scope.errors = new Object();

  $scope.view = {
    displaySave: false,
    showWhySteps: false,
    whyStepsTemplate: '/scripts/entries/views/why-steps.html'
  };

  $scope.editEntry = function(entry) {
    if ($scope.isDisabled()) {
      return;
    }
    $scope.cancelEdit($scope.data.edit_entry);
    $scope.data.edit_entry.origin.is_editing = false;
    $scope.data.edit_entry = Entry.build(entry);
    $scope.data.edit_entry.buildExerciseActivity(); // always need a exercise activity to start with
    $scope.data.edit_entry.origin.is_editing = true;
    $scope.changeToButton();
  };

  $scope.removeActivity = function(ea) {
    $scope.data.edit_entry.removeExerciseActivity(ea);
    $scope.view.displaySave = true;
    $scope.onSelect();
    // if ($scope.data.edit_entry.entry_exercise_activities.length < 1) {
    //   $scope.data.edit_entry.buildExerciseActivity();
    // }
  };


  $scope.overwrite = function($event) {
    $scope.data.edit_entry.override = true;
    var parent = $event.target.parentNode;
    setTimeout(function() {
      parent.querySelector('input').focus();
    }, 200);
  }


  $scope.onSelect = function() {
    $scope.view.displaySave = true;
    setTimeout(function() {
      var activity_length = $scope.data.edit_entry.entry_exercise_activities.length;
      var last_activity = $scope.data.edit_entry.entry_exercise_activities[activity_length - 1];
      var min_field = document.querySelectorAll(".minutes-input input:not([style='display:none'])");
      if (min_field) {
        $(min_field).focus();
      }

      // build new activity
      if ((last_activity && last_activity.exercise_activity_id || activity_length == 0) && activity_length < 4) {
        $scope.data.edit_entry.buildExerciseActivity();
      }
    }, 250);
  }

  $scope.saveEntry = function(entry, overwrite) {
    entry.override = !!overwrite;
    $scope.view.isSaving = true;
    EntryService.save(entry, $scope.data.edit_entry).then(function(entry) {
      if (!$scope.user.flags.has_seen_why_steps && !!entry.steps_from_minutes) {
        entry.showWhySteps = true;
        $scope.user.updateFlags({'has_seen_why_steps': true});
      }

      $scope.cancelEdit(entry);
    }).finally(function() {
      $scope.view.isSaving = false;
    });
  };

  $scope.showOption = function(entry, current_activity_id, activity_id) {
    return current_activity_id == activity_id || !_.find(entry.entry_exercise_activities, {
      exercise_activity_id: activity_id
    });
  };

  $scope.checkIfUnsavedCancel = function(entry) {
    $scope.cancelEdit(entry);
  };

  $scope.cancelEdit = function(entry) {
    $scope.data.entry_message = null;
    entry.is_editing = false;
    $scope.entry_form = null;
    entry.clean();
    $scope.view.displaySave = false;
  };

  $scope.areStepsFromDevice = function(entry) {
    return entry.manually_recorded === false || ($scope.user.isAnyDeviceConnected() && !entry.manually_recorded);
  }

  $scope.shouldStepsLookLikeActivity = function(entry) {
    if (!$scope.areStepsFromDevice(entry) && !$scope.user.isAnyDeviceConnected()) {
      return true;
    } else if ($scope.areStepsFromDevice(entry) || $scope.user.isAnyDeviceConnected()) {
      return false;
    }
  }

  $scope.areStepsClosed = function() {
    if (!$scope.data.edit_entry.exercise_steps && (!$scope.view.displaySave || $scope.stepsAreClosed)) {
      return true;
    } else if ($scope.data.edit_entry.exercise_steps && $scope.view.displaySave || !$scope.stepsAreClosed) {
      return false;
    }
  }
  $scope.changeToInput = function() {
    $scope.data.edit_entry.exercise_steps = null;
    $scope.stepsAreClosed = false;
    $scope.view.displaySave = true;

    $('.input-imitation.closed').removeClass('closed bg-gray');
    $('.steps-minutes-input.closed').removeClass('closed');
    $('.steps .minutes-remove.closed').removeClass('closed');

    setTimeout(function(){
      $(document.querySelectorAll(".steps-minutes-input input:not([style='display:none'])")).focus();
    },250);

  }

  $scope.changeToButton = function(opts) {
    if (opts && opts.clear_steps) {
      $scope.data.edit_entry.exercise_steps = null;
    }
    $scope.stepsAreClosed = true;
    $scope.view.displaySave = true;

    $('.input-imitation').addClass('closed bg-gray');
    $('.steps-minutes-input').addClass('closed');
    $('.steps .minutes-remove').addClass('closed');
  }

  $scope.useDeviceData = function(user, entry) {
    $scope.data.entry_message = "updating.."
    entry.useDeviceData(user.active_device).then(function(data) {
      $scope.cancelEdit(entry);
      $scope.data.entry_message = null;
    }, function(err) {
      // entry.exercise_steps = null;
      // $scope.data.edit_entry.exercise_steps = null;
      $scope.data.entry_message = "No device data found for this date."
    });
  };

  $scope.entryTemplate = function(entry, entry_week) {
    return hesTemplateService.getTemplateUrl(entry.is_editing ?
      '/scripts/entries/views/entry-edit.html' : '/scripts/entries/views/entry-show.html');
  };

  $scope.bindForm = function(form) {
    $scope.entry_form = form;
  };

  $scope.isFormDirty = function() {
    return ($scope.entry_form && $scope.entry_form.$dirty) || $scope.data.edit_entry.is_dirty;
  };

  $scope.isFormComplete = function() {
    return $scope.entry_form.$valid;
  };

  var deregister_state_watcher = $scope.$on('$stateChangeStart', function(event, toState, toParams) {
    if ($scope.isFormDirty()) {
      event.preventDefault();

      DialogService.openConfirmationDialog("", "You haven't saved.", 'Stay', "Leave", "tiny", true).then(function() {
        deregister_state_watcher();
        setTimeout(function() {
          $state.go(toState.name, toParams);
        });
      }, _.noop);
    }
  });

  $scope.$on("$destroy", function() {
    if (typeof deregister_state_watcher == 'function') {
      deregister_state_watcher();
    }
    $scope.entry_form
  });


});
'use strict';

angular.module('goApp').factory('Entry', function(ActiveResource, DOMAIN, CurrentSite, $q, $http, $rootScope) {

  var extras = new Object();

  var Entry = ActiveResource('/entries/:id', {
    domain: DOMAIN
  }, extras);

  // class methods
  Entry.build = function(attrs) {
    var attrs = attrs || {};
    attrs.recorded_on = attrs.recorded_on || "";
    attrs.origin = attrs.origin || {};
    attrs.entry_exercise_activities = attrs.entry_exercise_activities || [];
    attrs.exercise_steps = attrs.exercise_steps || null; // to not have a real '0' in input field
    attrs.exercise_minutes = attrs.exercise_minutes || 0;
    attrs.total_steps = attrs.total_steps || 0;
    attrs.goal_steps = attrs.goal_steps || 0;
    attrs.steps_from_minutes = attrs.steps_from_minutes || 0;
    attrs.exercise_points = attrs.exercise_points || 0;
    attrs.behavior_points = attrs.behavior_points || 0;
    attrs.manually_recorded = attrs.manually_recorded;

    if (attrs.class == "Entry") {
      attrs.origin = attrs;
    }

    attrs.entry_exercise_activities = attrs.entry_exercise_activities.map(function(activity, index) {
      activity.sequence = index;
      return new ExerciseActivity(activity);
    });

    attrs.cached_exercise_activities = _.clone(attrs.entry_exercise_activities);

    return new Entry(attrs);
  }

  // instance methods
  Entry.prototype.buildExerciseActivity = function(attrs) {
    if (this.entry_exercise_activities.length >= 4) {
      return;
    }
    var attrs = attrs || {};
    var max = _.maxBy(this.entry_exercise_activities, 'sequence');
    max = (max && max.sequence) || 0;
    attrs.sequence = max + 1;
    this.entry_exercise_activities.push(new ExerciseActivity(attrs))
  };

  Entry.prototype.isActivitiesComplete = function() {
    var entryEeaComplete;
    _.forEach(this.entry_exercise_activities, function(eea) {
      // we don't have an activity id OR we have one AND a value, then we are complete 
      var eeaComplete = !eea.exercise_activity_id || (!!eea.exercise_activity_id && !!eea.value);
      entryEeaComplete = (entryEeaComplete === undefined) ? !!eeaComplete : entryEeaComplete && !!eeaComplete;
    });
    return entryEeaComplete;
  };


  var saveMethod = Entry.prototype.save;

  Entry.prototype.save = function() {
    var obj = _.omit(this, ['origin', 'cached_exercise_activities']);
    return saveMethod.apply(obj, arguments);
  }


  Entry.prototype.humanize = function() {
    return moment(this.recorded_on).format(Entry.HUMAN_FORMAT);
  }

  // class constants
  Entry.RECORDED_FORMAT = 'YYYY-MM-DD';
  Entry.MONTH_FORMAT = 'MMMM';
  Entry.DAY_FORMAT = 'D';
  Entry.HUMAN_FORMAT = 'ddd, MMM D';
  Entry.YEAR_FORMAT = 'YYYY';


  Entry.prototype.isRecordable = function() {
    return true;
  }
  

  Entry.prototype.removeExerciseActivity = function(activity) {
    this.is_dirty = true;
    return _.remove(this.entry_exercise_activities, {
      exercise_activity_id: activity.exercise_activity_id
    });
  }

  Entry.prototype.clean = function() {
    this.entry_exercise_activities = this.cached_exercise_activities;
    this.is_dirty = false;
  }

  Entry.prototype.usingDeviceSteps = function() {
    // Returning FALSE, does not mean it MAY not be linked to a device
    // ONLY can trust when this is TRUE
    return this.manually_recorded === false;
  };

  Entry.prototype.useDeviceData = function(active_device) {
    var defer = $q.defer(),
      self = this,
      promise;


    switch (active_device) {
      case "FITBIT":
        promise = $http.post(DOMAIN + "/use_fitbit_data", {
          entry_id: self.id
        });
        break;
      case "VALIDIC":
        promise = $http.post(DOMAIN + "/use_validic_data", {
          entry_id: self.id
        });
        break;
      case "GARMIN":
        promise = $http.post(DOMAIN + "/use_garmin_data", {
          entry_id: self.id
        });
        break;
      case "GOOGLE_HEALTH":
        promise = $http.post(DOMAIN + "/use_google_health_data", {
          entry_id: self.id
        });
        break;
      case "APPLE":
        promise = Entry.update({
          id: self.id,
          manually_recorded: false
        }).$promise;
        break;
    }

    if (!promise) {
      defer.reject('no device');
    }

    promise.then(function(response) {
      _.merge(self, Entry.build((response.data || response)));
      $rootScope.$broadcast('EntryUpdated');
      defer.resolve(self);
    }, function(err) {
      defer.reject(err);
    });

    return defer.promise;
  }

  // constructor for exercise activity
  var ExerciseActivity = function(attrs) {
    var attrs = attrs || {};
    attrs.value = attrs.value || null;
    attrs.exercise_activity_id = attrs.exercise_activity_id || "";
    _.extend(this, attrs);
    return this;
  }


  CurrentSite.get().then(function(site) {
    Entry.exercise_activities = site.exercise_activities.map(function(activity) {
      return new ExerciseActivity(activity);
    });
  });


  return Entry;

});

'use strict';

angular.module('goApp').service('EntryService', function($q, $rootScope, CurrentSite, EntryWeek, Entry) {
  var EntryService = new Object();

  var entry_weeks = {};

  EntryService.getEntriesBetween = function(params) {
    var defered = $q.defer();

    params = params || {};
    params.page_size = 0;

    EntryWeek.index(params, function(data) {
      _.each(data, function(ew) {
        mergeOrPushEntryWeek(ew, params.year)
      });
      entry_weeks[params.year] = _.orderBy(entry_weeks[params.year], ['from_date'], ['desc']);
      defered.resolve(entry_weeks[params.year]);
    });

    return defered.promise;
  }

  EntryService.save = function(entry, edit_entry) {
    var defered = $q.defer();
    edit_entry.save(function(remote_entry) {
      _.merge(entry, remote_entry);
      entry.cached_exercise_activities = _.clone(remote_entry.entry_exercise_activities);
      entry.is_dirty = false;
      $rootScope.$broadcast('EntryUpdated');
      defered.resolve(entry);
    });
    return defered.promise;
  }


  function mergeOrPushEntryWeek(entry_week, year) {
    var local = _.find(entry_weeks[year], {
      key: entry_week.key
    });
    if (local) {
      entry_week.entries = _.map(entry_week.entries, Entry.build);
      _.extend(local, entry_week);
    } else {
      entry_week = EntryWeek.build(entry_week);
      entry_weeks[year] = entry_weeks[year] || [];
      entry_weeks[year].push(entry_week);
    }
  }

  function mergeEntry(entry, year) {
    var entry_week = _.find(entry_weeks[year], {
      entries: [{
        recorded_on: entry.recorded_on
      }]
    });
    var local = _.find(entry_week.entries, {
      recorded_on: entry.recorded_on
    });

    if (local) {
      _.merge(local, entry);
      $rootScope.$broadcast('EntryUpdated');
    }

    return local;
  }


  $rootScope.$on("modelUpdate", function(e, data) {
    if (data.model == "Entry") {
      Entry.show({
        id: data.id
      }).$promise.then(function(entry) {
        var year = new Date(entry.recorded_on).getFullYear();
        mergeEntry(entry, year);
      });
    }
  });


  $rootScope.$on("userLoggedOut", function(ev, data) {
    entry_weeks = {};
  })

  return EntryService;

});
'use strict';

angular.module('goApp').factory('EntryWeek', function(ActiveResource, Entry, DOMAIN) {

  var extras = new Object();

  var EntryWeek = ActiveResource('/entry_weeks', {domain: DOMAIN}, extras);

  EntryWeek.build = function(attrs) {
    var attrs     = attrs || {};
    attrs.entries = attrs.entries || [];
    attrs.entries = attrs.entries.map(Entry.build); 
    return new EntryWeek(attrs);
  }

  EntryWeek.prototype.totalSteps = function() {
    if (!this.loaded_entries) {
      return this.total_steps;
    } else {
      return _.sumBy(this.entries, function(e) {
        return parseInt(e.total_steps);
      });
    }
  }

  EntryWeek.prototype.datesHumanized = function(current_year) {
    var month  = moment(this.from_date).format(Entry.MONTH_FORMAT),
        day    = moment(this.from_date).format(Entry.DAY_FORMAT),
        year   = moment(this.from_date).format(Entry.YEAR_FORMAT),
        month2 = moment(this.to_date).format(Entry.MONTH_FORMAT),
        day2   = moment(this.to_date).format(Entry.DAY_FORMAT),
        year2  = moment(this.to_date).format(Entry.YEAR_FORMAT);

    var parts = [];

    // parts.push(month);
    // parts.push(day);
    // if (year != current_year) {
    //   parts.push(", "+year);
    // }
    // parts.push("-");  // the date separator
    // if (year2 != year || month != month2) {
    //   parts.push(month2);
    // }
    // parts.push(day2);
    // if (year2 != current_year) {
    //   parts.push(", "+year2);
    // }
    // return parts.join(" ");

    parts.push(month+" ");
    if (year != current_year) {
      parts.push(day);
      parts.push(", "+year);
    } else {
      parts.push(day);
    }
    parts.push(" - ");  // the date separator
    if (year2 != year || month != month2) {
      parts.push(month2+" ");
    }
    if (year2 != current_year) {
      parts.push(day2);
      parts.push(", "+year2);
    } else {
      parts.push(day2);
    }

    return parts.join("");
  }

  EntryWeek.prototype.weeksHumanized = function() {
    var week = this.week_numbers[0],
        week2 = this.week_numbers[this.week_numbers.length-1];

    if (week == week2) {
      return "Week " + week;
    }

    return "Week " + [week,week2].join(' - ');
  }


  return EntryWeek;

});

angular.module('goApp').directive('loggingBanner', function(){
  var loggingBanner = new Object();
  loggingBanner.restrict = "E";
  loggingBanner.template = "<div ng-if='applicationState.logging_state' ng-include='bannerTemplate'></div>";
  loggingBanner.scope = {
    applicationState: "=",
    program: "="
  }
  loggingBanner.controller = function($scope, $rootScope, $state, ContentLoader,BillboardService, CurrentSite) {
    $scope.data = new Object();
    $scope.data.logging_contents = {};

    var shared_logging_contents = [];
    var billboard_promise = null;

    $scope.goToProgram = $rootScope.goToProgram;

    function setBillboard() {
      var current = $scope.program || $rootScope.site.programs.current[0];
      var billboardId = null;
      if (current) {
        var start_year = (new Date(current.effective_date_start).getFullYear());
        var end_year = (new Date(current.effective_date_end).getFullYear());

        if (start_year == $state.params.year || end_year == $state.params.year || $state.current.name == "go.u.preview_logging_states") {
          $scope.data.current_program = current;
          billboardId = $scope.applicationState.current_billboard_id;
        }
      }

      if (billboardId) {
        if (!billboard_promise) {
          billboard_promise = BillboardService.show({
            id: billboardId
          });
        }
        billboard_promise.then(function(billboard) {
          $scope.data.current_billboard = billboard;
          $scope.data.logging_content = _.find(shared_logging_contents, {key: $scope.applicationState.logging_state}) || {};
          $scope.bannerTemplate = '/scripts/entries/banners/' + $scope.applicationState.logging_state + '.html';
        }).finally(function(){
          billboard_promise = null
        });
      }
    }

    // this is content has user specific keywords, must get data from API each time!
    function loadContent() {
      new ContentLoader({
        site_id: $scope.program ? $scope.program.site_id : $rootScope.site.id,
        category: 'shared_logging_content'
      }, true).then(function(contents) {
        shared_logging_contents = contents;
        setBillboard();
      });
    }

    $scope.$watch('applicationState.hash_key', function(newVal){
      if ($state.current.name == "go.u.preview_logging_states") {
        loadContent();
      } else {
        setBillboard();
      }
    });

    loadContent();



  }
  
  return loggingBanner;
});

'use strict';

angular.module('goApp')
  .service('ErrorService', ['$rootScope', function($rootScope) {
    var ErrorService = {
      showErrors: function(response, customMsg) {
        ErrorService.showPriorityErrors(response, customMsg, 0);
      },

      showPriorityErrors: function(response, customMsg, priority) {
        var emitErrors = [];
        priority = priority || 0;

        if (response.status && response.status !== 500) {
          emitErrors = response.data.errors;
        } else {
          emitErrors = [customMsg];
        }

        $rootScope.$emit('errors', emitErrors, priority);
      },

      clearErrors: function() {
        $rootScope.$emit('errors', []);
      }
    };

    return ErrorService;
  }]);
'use strict';

angular.module('goApp')
  .directive('errorBanner', ['hesTemplateService', 'Utils',
    function(hesTemplateService, Utils) {
      // Runs during compile
      return {
        scope: false, // {} = isolate, true = child, false/undefined = no change
        controller: 'ErrorBannerController',
        restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
        templateUrl: hesTemplateService.getTemplateUrl('/scripts/errors/errorBanner.html'),
        replace: true,
        // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
        link: function($scope, $element, $attrs, controller) {
          if (!Utils.isUndefinedOrNull($attrs.priorityLevel)) {
            $scope.errorsConfig.priorityLevel = parseInt($attrs.priorityLevel);
          }
        }
      };
    }
  ])
  .controller('ErrorBannerController', ['$rootScope', '$scope', 'Utils',
    function($rootScope, $scope, Utils) {

      //Level 0 is the TOP level
      $scope.errorsConfig = {
        priorityLevel: 0
      };

      $scope.hideError = function(index) {
        $scope.errors.splice(index, 1);
      };

      var removeErrorsWatch = $rootScope.$on('errors', function(meta, errors, priorityLevel) {
        if (Utils.isUndefinedOrNull(priorityLevel)) {
          priorityLevel = 0;
        }

        if (errors && errors.length > 0 && priorityLevel === $scope.errorsConfig.priorityLevel) {
          $scope.errors = errors;
          var distance = errors.length * -40;
          new TweenMax.fromTo(".error-banner", 1, {
            top: distance + "px"
          }, {
            top: '0px'
          });
        } else {
          $scope.errors = [];
          $rootScope.$$phase || $rootScope.$apply();
        }
      });

      var removeStateChangeWatch = $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
        $scope.errors = [];
      });

      $scope.$on('$destroy', function() {
        removeErrorsWatch();
        removeStateChangeWatch();
      });
    }
  ]);
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider
    .state('go.u.evaluations.current', {
      url: '/evaluation/current',
      controller: 'EvaluationController',
      abstract: false,
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/evaluations/evaluation.html');
        }
      ],
      resolve: {
        evaluation: function(SiteEvaluationLoader, $stateParams, user, $q, $state) {
          var defer = $q.defer();
          var next_eval_id =  user.pending_evaluation_ids[0];
          if (!next_eval_id) {
            defer.reject('no eval to take');
            $state.go('go.u.home');
          } else {
            new SiteEvaluationLoader({
              siteEvaluationId: next_eval_id,
            }).then(function(ev) {
              defer.resolve(ev);
            }, function(){
              defer.reject('error loading eval');
              $state.go('go.u.home');
            });
          }
          return defer.promise;
        }
      }
    })
    .state('go.u.site.site_evaluation', {
      url: '/site_evaluation/:siteEvaluationId',
      controller: 'SiteEvaluationCreateEditController',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/evaluations/siteEvaluation-createEdit.html');
        }
      ],
      resolve: {
        siteEvaluation: ['SiteEvaluationLoader', '$stateParams', function(SiteEvaluationLoader, $stateParams) {
          return new SiteEvaluationLoader({
            siteId: $stateParams.siteId,
            siteEvaluationId: $stateParams.siteEvaluationId,
          });
        }]
      }
    })
});
'use strict';

angular.module('goApp').controller('SiteEvaluationCreateEditController', function($scope, $state, SiteEvaluation, siteEvaluation, ngDialog, hesTemplateService, DialogService) {
	$scope.config = {
		options: [
			"CHECKBOX",
			"DROPDOWN",
			"TEXTAREA",
			"TEXTBOX"
		],
		is_days_from_start: true
	};
	$scope.siteEvaluation = siteEvaluation;
	$scope.dateFormat = 'L';

	$scope.isNewSiteEvaluation = function() {
		return $state.params.siteEvaluationId == 'new';
	};


	$scope.addQuestion = function() {
		var question = {
			is_new: true,
			is_active: true,
			sequence: $scope.siteEvaluation.site_evaluation_questions ? $scope.siteEvaluation.site_evaluation_questions.length + 1 : 1
		};
		$scope.editQuestionPopup(question, true)
	}

	$scope.editQuestionPopup = function(question, isnew) {
		question.is_new = isnew;
		$scope.config.addEditQuestion = question;
		ngDialog.closeAll();
		ngDialog.open({
		  className: 'ngdialog-theme-default',
		  template: hesTemplateService.getTemplateUrl('/scripts/evaluations/siteEvaluationQuestion-createEdit.html'),
		  scope: $scope
		});
	};

	$scope.saveQuestion = function(question) {
		if (question.is_new) {
			$scope.siteEvaluation.site_evaluation_questions.push(question);
		}
		ngDialog.closeAll();
	}

	$scope.selectEvalType = function(val) {
		$scope.config.is_days_from_start = val;
		if ($scope.config.is_days_from_start) {
			$scope.siteEvaluation.start_date = null;
			$scope.siteEvaluation.end_date = null;
		} else {
			$scope.siteEvaluation.days_from_start = null;
		}
	};

	$scope.submitSiteEvaluation = function() {
		$scope.data.is_saving = true;
		if ($scope.siteEvaluation.is_initial_evaluation) {
			$scope.siteEvaluation.name = "Registration";
			$scope.siteEvaluation.days_from_start = 0;
		}
		
		$scope.siteEvaluation.save(function(siteEval) {
			$state.go('go.u.site', {siteId: siteEval.site_id});
		}, function(response) {
				DialogService.openInformationDialog("Error", response.data.errors[0].base.join("<br/>"), "OK");
		})['finally'](function(){
			$scope.data.is_saving = false;
		});
	};

	$scope.turnOptionsIntoArray = function(question) {
        $scope.editQuestionSampleData = question.options.split('\n');
      };

	$scope.destroy = function(evaluation) {
		evaluation.$destroy(function(){
			$state.go('go.u.site.site_evaluation', {siteEvaluationId: 'new'});
		});
	}

});
'use strict';

angular.module('goApp')

.factory('SiteEvaluationLoader', ['SiteEvaluation', '$q', 'Utils',
  function(SiteEvaluation, $q, Utils) {
    return function(opts) {
      var defer = $q.defer();

      SiteEvaluation.show({
        site_id: opts.siteId,
        id: opts.siteEvaluationId
      }, function(siteEvaluation) {
        if(opts.siteEvaluationId == "new") {
          delete siteEvaluation.id;
          siteEvaluation.site_id = opts.siteId;
          siteEvaluation.site_evaluation_questions.forEach(function(q) {
            delete q.id 
            delete q.site_evaluation_id;
          });
        }
        defer.resolve(siteEvaluation);
      }, function() {
        defer.reject('Site Evaluation could not be loaded.');
      });


      return defer.promise;
    };
  }
]);
'use strict';

angular.module('goApp')

.factory('SiteEvaluation', ['ActiveResource', '$http', 'DOMAIN',
	function(ActiveResource, $http, DOMAIN) {
		var SiteEvaluation = ActiveResource('/site_evaluations/:id', {
			nestedRoutes: ['index', 'create', 'update', 'destroy', 'show'],
			parentResource: 'Site',
			domain: DOMAIN
		});

		return SiteEvaluation;
	}
]);
'use strict';

angular.module('goApp').controller('EvaluationController',
	function($rootScope, $scope, $state, UserEvaluationAnswers, evaluation, MainNavigation) {

		$scope.data = {
			evaluation: new UserEvaluationAnswers(),
			site_evaluation: evaluation
		};

		MainNavigation.get().then(function(navigation) {
			if (!!navigation) {
				navigation.findMenuByLink('go.u.evaluations.current').name = $scope.data.site_evaluation.name;
			}
		});

		$scope.data.evaluation.user_id = $rootScope.user.id;
		$scope.data.evaluation.site_evaluation_id = evaluation.id;

		$scope.submitEvaluation = function() {
			$scope.data.evaluation.save(function(completed_eval) {
				$rootScope.user.completed_evaluation_ids.push($scope.data.evaluation.site_evaluation_id);
				$rootScope.user.remove_pending_eval(completed_eval.site_evaluation_id)
				$rootScope.$broadcast('modelUpdate', {
					model: "Evaluation"
				});
				$state.reload();
			});
		};
	});
'use strict';

angular.module('goApp')
  .directive('userEvaluation', ['hesTemplateService', function(hesTemplateService) {
    // Runs during compile
    return {
      scope: {
        siteEvaluation: '=',
        evaluation: '=',
        profileOnly: '@?'
      }, // {} = isolate, true = child, false/undefined = no change
      restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
      templateUrl: hesTemplateService.getTemplateUrl('/scripts/evaluations/userEvaluation.html'),
      controller: ['$scope',
        function($scope) {

          $scope.getOptions = function(question) {
            return question.options.split("|");
          };

          // $scope.showQuestion = function(question){
          //   return ((!!$scope.profileOnly && !!question.flags && question.flags.is_visible_in_profile) || (question.is_active && !(!!$scope.profileOnly)) && !question.profile_only);
          // };

          // var questions = $scope.evaluationDefinition.activeQuestions($scope.profileOnly);
          // for (var i = 0; i < questions.length; i++) {
          //   if ($scope.showQuestion(questions[i]) && questions[i].type_of_prompt == "CHECKBOX") {
          //     if ($scope.evaluation[questions[i].name] !== "Y") {
          //       $scope.evaluation[questions[i].name] = (questions[i].data_type == "string" ? "N" : false);
          //     }
          //   }
          // }
        }
      ]
    };
  }]);
'use strict';

angular.module('goApp')

.factory('UserEvaluationAnswers', ['ActiveResource', '$http', 'DOMAIN',
	function(ActiveResource, $http, DOMAIN) {
		var UserEvaluationAnswers = ActiveResource('/user_evaluation_answers/', {
			nestedRoutes: ['show', 'create'],
			parentResource: 'SiteEvaluation',
			domain: DOMAIN
		});

		return UserEvaluationAnswers;
	}
]);
'use strict';

angular.module('goApp')
  .run(function($rootScope) {
    $rootScope.$on('$mdMenuOpen', function(event, menu) {
      $('body').addClass('md-dialog-is-showing');
    });
    $rootScope.$on('$mdMenuClose', function(event, menu) {
      $('body').removeClass('md-dialog-is-showing');
    });
  });
angular.module('goApp').run(function($rootScope, ContentLoader, CurrentSite) {
  $rootScope.explanations = {};
  CurrentSite.get().then(function(site){
    new ContentLoader({
      site_id: site.id,
      category: 'explanations',
      page_size: 0
    }, false).then(function(content) {
      _.each(content, function(c){
        $rootScope.explanations[c.key] = c;
      });
    });
  });

});

angular.module('goApp').service('ExportService', function(DOMAIN, $rootScope, $http) {
  
  this.exportEntries = function(year) {
    var uri = "/entries/export";
    if (year) {
      uri += "?year=" + year;
    }

    var fileName = [
      _.snakeCase($rootScope.site.name),
      'user',
      $rootScope.user.id,
      'entries',
      year
    ].join('-') + '.csv';

    downloadCsv(uri, fileName);
  }
  
  
  this.exportStats = function(year) {
    var uri = "/export/stats";
    if (year) {
      uri += "?year=" + year;
    }

    var fileName = [
      _.snakeCase($rootScope.site.name),
      'user',
      $rootScope.user.id,
      'stats',
      year
    ].join('-') + '.csv';

    downloadCsv(uri, fileName);
  }
  
  function downloadCsv(uri, fileName) {
    window.location = DOMAIN + uri;
    return;
  }
  
});

'use strict';

angular.module('goApp')
  .controller('FaqsController', ['$scope', '$q', 'CurrentSite', 'ContentLoader', 'ErrorService', '$timeout',
    function($scope, $q, CurrentSite, ContentLoader, ErrorService, $timeout) {

      if (/Edge/.test(navigator.userAgent)) {
        // Edge opens at the bottom of the page quick fix
        $timeout(function() {
          $(window).scrollTop(0);
        }, 100);
      }


      $scope.showFaq = function(key) {
        var show = true;
        return show;
      }

      $scope.goToItem = function(item_id) {
        $('html, body').animate({
          scrollTop: $("#faq_" + item_id).offset().top - 20
        }, 500);
      };

      $scope.backToTop = function() {
        $('html, body').animate({
          scrollTop: 0
        }, 500);
      };

      $scope.faqs = [];

      $scope.faqsConfig = {
        loading: true
      };

      /* Determine what FAQs should be shown, for lpd2 or lpd2+
        The 'normal_faqs' are exclusive for the first campaign experience,
        for every other campaign, the 'plus' ones should be shown */
      var cat;
      if ($scope.site.flags.is_launchpad_plus && $scope.site.features_on) {
        cat = 'faqs';
      } else {
        cat = 'normal_faqs';
      }


      $q.all([
        CurrentSite.get(),
      ]).then(function() {
        new ContentLoader({
          site_id: $scope.site.id,
          category: cat
        }).then(function(faqs) {
          $scope.faqs = faqs;
          $scope.faqsConfig.loading = false;
        }, function(response) {
          $scope.faqsConfig.loading = false;
          ErrorService.showErrors(response);
        });
      }, function(response) {
        $scope.faqsConfig.loading = false;
        ErrorService.showErrors(response);
      });
    }
  ]);
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.help.faqs', {
    url: '/faqs',
    controller: 'FaqsController',
    templateProvider: ['hesTemplateService', function(hesTemplateService) {
      return hesTemplateService.getTemplate('/scripts/faqs/faqs.html');
    }]
  });
  
});
'use strict';

// Resource.
angular.module('goApp')

.factory('Feedback', ['ActiveResource', 'DOMAIN',
	function(ActiveResource, DOMAIN) {
		var Feedback = ActiveResource('/feedbacks/:id', {
			domain: DOMAIN
		});

		return Feedback;
	}
]);

// Controller.
angular.module('goApp')

.controller('FeedbackCtrl', ['$scope', '$location', 'CurrentUser', 'Feedback', 'bowser', 'ErrorService',
	function($scope, $location, CurrentUser, Feedback, bowser, ErrorService) {
		CurrentUser.get().then(function(user) {

			function initializeFeedback() {
				$scope.feedbackUser = {
					full_name: user.profile.first_name + ' ' + user.profile.last_name,	
					email: user.email
				};
			
				$scope.feedback = new Feedback({
					browser: bowser.name + ' ' + bowser.version,
					email: $scope.feedbackUser.email,
					feedback: '',
					name: $scope.feedbackUser.full_name,
					request_url: $location.absUrl()
				});

				$scope.feedbackSent = false;
			}

			function isFormValid() {
				return !$scope.fullNameRequired && !$scope.emailRequired && !$scope.feedbackRequired;
			}

			$scope.resetFeedback = function() {
				initializeFeedback();
			};

			$scope.submitFeedback = function() {
				ErrorService.clearErrors();

				if(!$scope.feedbackUser.full_name) {
					$scope.fullNameRequired = true;
				}

				if(!$scope.feedbackUser.email) {
					$scope.emailRequired = true;
				}

				if(!$scope.feedback.feedback) {
					$scope.feedbackRequired = true;
				}

				if(isFormValid()) {
					$scope.sendingFeedback = true;

					$scope.feedback.create(function(response) {
						$scope.sendingFeedback = false;
						$scope.feedbackSent = true;
					
					}, function(error) {
						$scope.sendingFeedback = false;
						
						ErrorService.showErrors(error, 'Sorry, there was an error sending your feedback.');
					});
				}
				else {
					$scope.sendingFeedback = false;
				}
			};

			initializeFeedback();
		});
	}
]);
'use strict';

angular.module('goApp')

	.config(['$stateProvider',
		function($stateProvider) {
			$stateProvider.state('go.give', {
					abstract: true,
					controller: "TabsController",
					templateProvider: ['hesTemplateService',
						function(hesTemplateService) {
							return hesTemplateService.getTemplate('/scripts/tabs/secondary-tabs-only-layout.html');
						}
					]
				})
				.state('go.give.feedback', {
					title: 'Feedback',
					url: '/feedback',
					controller: 'FeedbackCtrl',
					abstract: false,
					templateProvider: ['hesTemplateService',
						function(hesTemplateService) {
							return hesTemplateService.getTemplate('/scripts/feedback/feedback.html');
						}
					]
				});
		}
	]);
'use strict';
angular.module('goApp')
  .filter('camelCase', function() {
    return function(input) {
      input = input || '';
      return input.replace(/([A-Z]+)*([A-Z][a-z])/g, "$1 $2");
    };
  });

'use strict';
angular.module('goApp')
  .filter('exclude', function() {
    return function(input, exclude, prop) {
      if (!angular.isArray(input))
        return input;

      if (!angular.isArray(exclude))
        exclude = [];

      if (prop) {
        exclude = exclude.map(function byProp(item) {
          return item[prop];
        });
      }

      return input.filter(function byExclude(item) {
        return exclude.indexOf(prop ? item[prop] : item) === -1;
      });
    };
  });
'use strict';

angular.module('goApp')
  .filter('friendSearch', [function() {
    return function(friends, searchValue) {
      var ret = [];
      if (searchValue) {
        var searchStr = searchValue.toLowerCase();
        angular.forEach(friends, function(friend) {
          if ((friend.friendee.profile.first_name.toLowerCase() + " " + friend.friendee.profile.last_name.toLowerCase()).indexOf(searchStr) >= 0 || 
            friend.friendee.profile.first_name.toLowerCase().indexOf(searchStr) >= 0 || 
            friend.friendee.profile.last_name.toLowerCase().indexOf(searchStr) >= 0) {
            ret.push(friend);
          }
        });
      } else {
        ret = friends;
      }
      return ret;
    };
  }]);
'use strict';
angular.module('goApp')
    .filter('numberFormatter', function() {
        return function(input) {
        if (typeof input === 'number' && input >= 10000) {
            return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return input;
        }
    });
  
'use strict';
angular.module('goApp')
  .filter('datePlusTime', ['$filter', function($filter) {
    return function(val) {
      if (!val) return '';
      return $filter('date')(val, 'MM/dd/yyyy hh:mm a');
    };
  }])
  .filter('dateOnly', ['$filter', function($filter) {
    return function(val) {
      if (!val) return '';
      return $filter('date')(val, 'MM/dd/yyyy');
    };
  }])
  .filter('tablecelldate', function() {
    return function(val) {
      return moment(val).format('l');
    };
  })
  .filter('tablecelldatetime', function() {
    return function(val) {
      return moment(val).format('YYYY-MM-DD hh:mm A');
    };
  })
  .filter('tablecellstring', function() {
    return function(val) {
      if (val === null || val === undefined) {
        val = '';
      }

      return val;
    };  
  });
  
'use strict';

angular.module('goApp')
  .directive('hesFocusManager', function(hesTemplateService, FocusManagerService) {
    // Runs during compile
    return {
      controller: function($rootScope, $timeout) {
        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {

          FocusManagerService.sameParent = false;
          FocusManagerService.fromItemToList = false;

          // Focus Management for AT. Since we are a SPA, we need to tell AT's when changes occur dynamically
          // on a route change. Two scenearios
          // 1. Navigation occurs to new "page" and main content view is replaced, then put focus on the H1 describing the page
          // 2. Navigation occurs but the "page" doesn't change (i.e. tabs), here we are going to announce a change has occurred
          //    view the aria-live element.
          //Do not manage focus if we just came to the site
          if (fromState.name !== '') {
            FocusManagerService.initialLoad = false;


            //Get rid of go.u and go., so we can more easily know what is going on
            var fromParts = fromState.name.replace('go.u.', '').replace('go.', '').split('.');
            var toParts = toState.name.replace('go.u.', '').replace('go.', '').split('.');
            var len = fromParts.length;

            // TODO: LOGIC is no longer accurate
            // The difference between pages will always be the first part of the name 
            // because we removed the go and go.u appendage, so check that for parent
            FocusManagerService.sameParent = fromParts[0] === toParts[0];
            FocusManagerService.fromItemToList = !!fromState.isItem && !!toState.isList;

            if (!FocusManagerService.sameParent) {
              //Navigation headings should always be within the main landmark
              var focusElement = $('div[role="main"] h1')[0];
              if (!!focusElement) {
                focusElement.focus();
              }
            } else {
              // Message to be announced in live region to AT users, this could be pulled into a service.
              var title = toParams.course || toState.tabLabel || toState.title;
              var message = !!title ? "Loaded " + title.toLowerCase() : 'new content loaded';
              FocusManagerService.announceMessage(message);

              if (toState.focusFirst) {
                FocusManagerService.focusFirst = true;
              }
            }
          } else {
            FocusManagerService.initialLoad = true;
          }
        });
      },
      restrict: 'A'
    };
  });
'use strict';
angular.module('goApp')
  .service('FocusManagerService', function($rootScope, $timeout) {
    
    $rootScope.announcer = {
      message: ''
    };
    
    $rootScope.focusMain = function() {
      $('div[role="main"] [tabindex]:visible, div[role="main"] input:visible, div[role="main"] button:visible')[0].focus();
    };

    $rootScope.ariaClick = function($event) {
      if ($event.keyCode == 13 || $event.keyCode == 32) {
        $event.preventDefault();
        $timeout(function() {
          $($event.currentTarget).click();
        }, 0);
      }
    };
    var FocusManagerService = {
      sameParent: false, //Used by hesManageFocusOnLoad, set when navigating routes of the same parent, i.e. clicking a tab on teams/recipes/tips
      fromItemToList: false, //Used by hesManageFocusOnLoad, indicates changes when moving about tabs of lists, like recipes, tips
      focusFirst: false, //Used by hesManageFocusOnLoad, focuses the first element
      focusSelectors: 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]',
      announceMessage: function(message) {
        $rootScope.announcer.message = message;

        // Remove the message after 7 seconds to ensure user doesn't find by accident
        // recommendation
        $timeout(function() {
          if (message === $rootScope.announcer.message) {
            $rootScope.announcer.message = "";
          }
        }, 7000);
      },
      moveFocusToFirstTabbable: function(el) {
        var focusElement = $(el).find(FocusManagerService.focusSelectors)[0];
        if (focusElement) {
          focusElement.focus();
        }
      },
      moveFocusToLastTabbable: function(el) {
        var focusElements = $(el).find(FocusManagerService.focusSelectors);

        //we have tabbable elements
        if (!!focusElements.length) {
          var focusElements = $(el).find(FocusManagerService.focusSelectors)[focusElements.length - 1];
          if (focusElement) {
            focusElement.focus();
          }
        }
      },
      moveFocusToTabPaneHeader: function() {
        var focusElement = $('.pane h*, .pane [tabindex="-1"]')[0];
        if (focusElement) {
          focusElement.focus();
        }
      },
      moveFocusToDialogHeader: function() {
        var focusElement = $('.ngdialog-content h*, .ngdialog-content [tabindex="-1"]')[0];
        if (focusElement) {
          focusElement.focus();
        }
      }
    };
    return FocusManagerService;
  });
angular.module('goApp')
  .directive('hesManageFocusOnChange', function($rootScope, hesTemplateService, FocusManagerService, $timeout) {
    // Runs during compile
    return {
      link: function($scope, $element, $attrs, controller) {

        var moveFocus = function() {
          $timeout(function() {
            var focusElm = $element.find('select, input, button, a, *[tabindex]');
            if (!!focusElm && !!focusElm.length) {
              focusElm[focusElm.length - 1].focus();
            }
          }, 0);
        };

        if (!!$attrs.onTrue) {
          $attrs.$observe('onTrue', function(newVal, oldVal) {
            if (newVal == 'true') {
              moveFocus();
            }
            newVal = 'false';
          });
        }

        if (!!$attrs.scopeKey) {
          $scope.$watch($attrs.scopeKey, function(newVal, oldVal) {
            if (newVal !== oldVal && !!oldVal && newVal < oldVal) {
              moveFocus();
            }
          });
        }
      }
    };
  });
angular.module('goApp')
  .directive('hesManageFocusOnLoad', function($rootScope, hesTemplateService, FocusManagerService, $timeout) {
    // Runs during compile
    return {
      link: function($scope, $element, $attrs, controller) {
        var focusElement;
        if (FocusManagerService.sameParent) {
          focusElement = $($element).find('[tabindex="-1"]');

          if (FocusManagerService.fromItemToList) {
            focusElement = $('[role="tab"][aria-selected="true"]');
          }
          FocusManagerService.sameParent = false;
        } else if (FocusManagerService.focusFirst) {
          $timeout(function() {
            FocusManagerService.moveFocusToFirstTabbable($element);
          });
          FocusManagerService.focusFirst = false;
        }

        if (focusElement) {
          focusElement.focus();
        }
      }
    };
  });
angular.module('goApp').service("FooterContentService", function($rootScope, $q, ContentLoader, CurrentSite, Content) {

  var defered = null;
  var content = null;

  this.get = function() {
    if (defered && defered.promise.$$state.status == 0) {
      return defered.promise;
    }
    defered = $q.defer();
    
    if (content) {
      defered.resolve(content);
    } else {
      $q.all([
        new ContentLoader({category: 'mobile_overlay', site_id: $rootScope.site.id}),
        new ContentLoader({category: 'mobile', site_id: $rootScope.site.id})
      ]).then(function(data){
        content = {
          mobile_overlay: data[0],
          mobile: data[1]
        }
        defered.resolve(content);
        defered = null;
      });
    }

    return defered.promise;
  }

});

'use strict';

angular.module('goApp').directive('goFooter', function($rootScope, hesTemplateService, ngDialog, $location, $timeout, ContentLoader, Content, FooterContentService){
	// Runs during compile
	return {
		templateUrl: hesTemplateService.getTemplateUrl('/scripts/footer/footer.html'),
    	replace: true,
		link: function($scope, $element, attrs, controller) {
	
			function initLinks() {
			$scope.footerLinks = [
				{
					linkPath: (function(){
						var link = "";
						if($rootScope.site.flags.is_faqs_enabled) {
							link = "go.help.faqs";
						} else {
							link = "go.help.contact";
						}
						return link;
					})(),
					linkTarget: '_self',
					linkText: (function(){
						var link = "";
						if($rootScope.site.flags.is_faqs_enabled) {
							link = "Help"
						} else {
							link = "Contact";
						}
						return link;
					})(),
					hidden: false
				},
				{
					linkPath: 'go.map.site_map',
					linkTarget: '_self',
					linkText: 'Site Map',
					hidden: !$rootScope.user
				},
				{
					linkPath: (function(){
						var link = "";
						if ($rootScope.site.flags.is_privacy_enabled && $rootScope.site.flags.is_terms_enabled) {
							link = "go.privacy_terms.privacy";
						} else if($rootScope.site.flags.is_privacy_enabled) {
							link = "go.privacy_terms.privacy";
						} else if ($rootScope.site.flags.is_terms_enabled) {
							link = "go.privacy_terms.terms";
						}
						return link;
					})(),
					linkTarget: '_self',
					linkText: (function(){
						var label = "";
						if ($rootScope.site.flags.is_privacy_enabled && $rootScope.site.flags.is_terms_enabled) {
							label = "Privacy & Terms";
						} else if($rootScope.site.flags.is_privacy_enabled) {
							label = "Privacy";
						} else if ($rootScope.site.flags.is_terms_enabled) {
							label = "Terms"
						}
						return label;
					})(),
					hidden: !($scope.site.flags.is_terms_enabled || $scope.site.flags.is_privacy_enabled)
				},
				{
					linkMethod: 'showMobileApp',
					linkText: 'App',
					hidden: !$scope.user || !$scope.site.flags.is_mobile_enabled || !$scope.site.flags.is_launchpad_plus || !$scope.site.features_on
				}
			]} initLinks();

			$scope.$watch("user.id",initLinks);

			$scope.year = new Date().getFullYear();
			
			$scope.setup = $scope.setup || new Object({content: new Object()});

			$scope.isCountdownPage = function(){
				return !$rootScope.site.hasLaunched() && $location.url() === '/welcome';
			}

			FooterContentService.get().then(function(content_hash){
				$scope.setup.content.mobile_overlay = Content.getByKey(content_hash.mobile_overlay, 'mobile_overlay', true);
				$scope.setup.content.ios_app_link = Content.getByKey(content_hash.mobile, 'ios_app_link', true);
				$scope.setup.content.android_app_link = Content.getByKey(content_hash.mobile, 'android_app_link', true);
			});

			$scope.showMobileApp = function() {
				ngDialog.open({
					className: 'ngdialog-theme-default col-2',
					template: '/scripts/footer/mobile-overlay.html',
					scope: $scope,
					showClose: false
				});
			};

			$scope.pilotPassword = function() {
				ngDialog.open({
					className: 'ngdialog-theme-default pilot-password',
					template: '/scripts/password/pilot_password.html',
					controller: 'PilotPasswordController'
				});
			};

			if (_.has(attrs,"isMenu")) {
				$scope.is_menu = true;
			}

			// Because IE.
			$timeout(function() {
				$('.footer-wrapper ul li')[0].style.display = 'inline';
			}, 0);
		}
	};
});

'use strict';

angular.module('goApp')
  .controller('EmailController', ['$scope', 'Email', '$timeout', 'FriendService', 'ErrorService',
    function($scope, Email, $timeout, FriendService, ErrorService) {

      $scope.sendEmail = function() {
        ErrorService.clearErrors();
        if ($scope.emailSettings.email.message && $scope.emailSettings.email.message !== "") {
          $scope.emailSettings.disabled = true;
          Email.create({
            email_type: 'individual',
            recipient_id: $scope.emailSettings.email.recipient.id,
            message: $scope.emailSettings.email.message
          }, function(sent_email) {
            $scope.emailSettings.sent = true;
            $scope.emailSettings.disabled = false;

          }, function(response) {
            ErrorService.showPriorityErrors(response, 3);
            $scope.emailSettings.disabled = false;
          });
        } else {
          ErrorService.showPriorityErrors({}, "Please include a message.", 3);
          $timeout(function() {
            $scope.emailSettings.emailMsg = "";
          }, 5000);
        }
      };
    }
  ]);
'use strict';

angular.module('goApp')
  .factory('Email', ['ActiveResource', 'DOMAIN',
    function(ActiveResource, DOMAIN) {

      var Email = ActiveResource('/send_mail', {
        domain: DOMAIN
      });

      return Email;
    }
  ]);
'use strict';

angular.module('goApp')
  .service('FriendService',
    function(Friendship, $q, CurrentSite, FetchedDataGroup, FriendsLoader, IncomingFriendRequestsLoader, SentFriendRequestsLoader, FriendshipStatusLoader) {
      var FriendService = new Object();

      FriendService.friends = new FetchedDataGroup(function() {
        return new FriendsLoader();
      }, true);
      
      FriendService.sentRequests = new FetchedDataGroup(function() {
        return new SentFriendRequestsLoader();
      }, true);

      FriendService.incomingRequests = new FetchedDataGroup(function() {
        return new IncomingFriendRequestsLoader();
      }, true);

      FriendService.getFriendshipStatus = function(userId) {
        return new FriendshipStatusLoader(userId);
      };
        
      FriendService.markUsersRelations = function(users) {
        // marks array of User objects with .friend/.requestSent/.requestReceived properties

        var that = this;
        var defer = $q.defer();

        if (!users || !users.length) {
          defer.resolve(users);
        } else {
          $q.all([that.friends.get(), this.sentRequests.get(), this.incomingRequests.get()])
            .then(function(data) {
              var friends = data[0],
                sent = data[1],
                incoming = data[2];

              for (var i = 0, j = users.length; i < j; i++) {
                var user = users[i];

                user.relationsStatus = null;
                markUser('friend', user, friends) ||
                  markUser('requestReceiver', user, sent) ||
                  markUser('requestSender', user, incoming);
              }

              function markUser(status, user, group) {
                var friendArr;

                friendArr = _.filter(group, {
                  friendee_id: user.id
                });

                if (friendArr.length) {
                  // friendArr[0].from_search = true;
                  user.relationsStatus = {
                    value: status,
                    friendship: friendArr[0]
                  };
                  return true;
                }
                return false;
              }

              defer.resolve(users);
            });
        }

        return defer.promise;
      };

      FriendService.init = function() {
        CurrentSite.get().then(function(site) {
          if (site.flags.is_peers_enabled) {
            FriendService.is_peers_enabled = site.flags.is_peers_enabled;
            // FriendService.friends.get();
            // FriendService.sentRequests.get();
            // FriendService.incomingRequests.get();
          }
        });
      };

      FriendService.init();

      return FriendService;
    });
'use strict';
angular.module('goApp')
  .controller('FriendsController', function($rootScope, $scope, $state, $location, $timeout, FriendService, DialogService, Friendship, User, CurrentSite, MessageService, FriendsLoader) {

    var PAGE_SIZE = 40;  // how many friends do you want to show at once?

    $scope.data = {
      sentRequests: [],
      incomingRequests: [],
      invitedEmails: []
    };

    $scope.filter = {
      options: [
        { name: 'First Name', value: 'friendee.profile.first_name' } ,
        { name: 'Last Name', value: 'friendee.profile.last_name' },
        { name: 'Total Steps', value: '-friendee.total_steps' },
        { name: 'Total Challenges', value: '-friendee.total_completed_challenges' }
      ]
  };

    CurrentSite.get().then(function(site) {
      $scope.site = site;

      if (!site.flags.is_logging_enabled) {
        _.remove($scope.filter.options, { value: '-friendee.total_steps' });
      }
    });

    $scope.status = {
      loading: true
    };

    $scope.search = {
      query: '',
      status: {
        active: false,
        loading: false,
        directEmailInvite: false
      },
      result: {
        all: [],
        allSorted: []
      },
      actions: {
        markUsersRelations: function() {
          FriendService.markUsersRelations(_.cloneDeep($scope.search.result.all))
            .then(function(markedUsers) {
              $scope.search.result.allSorted = markedUsers;
            });
        },
        updateDirectEmailInvite: function(query) {
          if (query.indexOf('@') > -1 &&
            query.indexOf('.') > -1 &&
            !$scope.search.result.all.length) {

            $scope.search.status.directEmailInvite = {
              invited: _.indexOf($scope.data.invitedEmails, query) > -1
            };
          } else {
            $scope.search.status.directEmailInvite = false;
          }
        },
        clearSearch: function() {
          $scope.search.query = '';
          $scope.search.handlers.change($scope.search.query);
        }
      },
      handlers: {
        change: function(query) {
          if (!query) {
            $scope.search.handlers.clear();
          }

          $scope.search.status.active = !!query;

          if ($scope.search._timeout) {
            $timeout.cancel($scope.search._timeout);
          }

          $scope.search.status.loading = !!query;
          
          if ($state.current.name == 'go.u.usermenu.friends.search' || $state.current.name == 'go.u.usermenu.friends.list') {
            $scope.search._timeout = $timeout(function() {
              User.search(query, {}).then(function(users) {
                $scope.search.status.loading = false;
                $scope.search.result.all = users.data.data;
                $scope.search.actions.markUsersRelations();
                $scope.search.actions.updateDirectEmailInvite(query);
                $scope.data.friends = users.data.data;
              });
            }, 300);
          }
        },
        clear: function(clearQuery) {
          if (clearQuery) {
            FriendService.search.setValue('');
            return;
          }

          $scope.search.status = {
            loading: false,
            active: false,
            directEmailInvite: false
          };

          $scope.search.result = {
            all: [],
            allSorted: []
          };

          $scope.search._timeout = null;
          loadFriends();
        }
      }
    };

    $scope.inviteByEmail = function(email) {
      DialogService.openConfirmationDialog('Invite by email', 'Invite <strong>' + email + '</strong> to join <em>' + $scope.site.name + '</em>.', 'Cancel', 'Send').then(function() {
        new Friendship({
          status: 'P',
          friend_email: email
        }).create(function(friendship) {
          FriendService.sentRequests.push(friendship);
          $state.go('go.u.usermenu.friends.pending');
        });
      });
    };

    $scope.goToSendInvites = function(email) {
      $state.go('go.u.usermenu.friends.search');
    };

    $rootScope.$on('resetFriendSearch', function() {
      $scope.search.handlers.change($scope.search.query);
    });

    function checkIfExists(friends) {
      if ($state.params.friend_id) {
        var id = parseInt($state.params.friend_id);
        var friend =  _.find(friends,function(f){
          return f.id == id || f.inverse_friendship_id == id;
        });
        if (!friend) {
          DialogService.openInformationDialog("", $scope.site.friend_label + " request no longer exists.").then(_.noop);
        }
        $location.search({});
      }
    }

    switch($state.current.name) {
      case "go.u.usermenu.friends.list":
        loadFriends();
        User.stats({user_id: $scope.user.id, year: new Date().getFullYear()}).$promise.then(function(stats) {
          $scope.user.stats = stats;
        });
        break;
      case "go.u.usermenu.friends.pending":
        FriendService.sentRequests.get(true).then(function(data) {
          $scope.data.sentRequests = data;
          checkIfExists($scope.data.sentRequests);
          $scope.status.loading = false;
          $scope.data.invitedEmails = _.map($scope.data.sentRequests, 'friend_email');

          FriendService.sentRequests.events.onAnyUpdate.subscribe($scope, function(newData) {
            $scope.data.sentRequests = newData;
            $scope.status.loading = false;
            $scope.data.invitedEmails = _.map(newData, 'friend_email');
          });
        });

        FriendService.incomingRequests.get(true).then(function(data) {
          $scope.data.incomingRequests = data;
          $scope.status.loading = false;
          FriendService.incomingRequests.events.onAnyUpdate.subscribe($scope, function(newData) {
            $scope.data.incomingRequests = newData;
          });
        });
        break;
    }

    function loadFriends(offset){
      $scope.status.loading = true;
      new FriendsLoader({
        offset: offset || 0,
        page_size: PAGE_SIZE,
        include: "stats",
      }).then(function(data){
        initPager(data);
        $scope.data.friends = data;
        checkIfExists($scope.data.friends);
        $scope.status.loading = false;
        FriendService.friends.events.onAnyUpdate.subscribe($scope, function(newData) {
          $scope.data.friends = newData;
        });
      });
    }

    function initPager(data) {
      if(!data[0] || typeof data[0].getMeta !== 'function') {
        console.log("no data elements to get up pager with");
        return;
      }

      var meta, pager;
      
      meta = data[0].getMeta();
      if (meta.total_pages <= 1) {
        console.log("less than 2 pages, do not need pager");
        return;
      }

      pager = {
        total_pages: meta.total_pages,
        current_page: meta.page,
        nextPage: function(page){
          $scope.status.loading_page = page+1;
          return loadFriends(page*meta.page_size);
        },
        previousPage: function(page){
          $scope.status.loading_page = page+1;
          return loadFriends(page*meta.page_size);
        }
      }


      $scope.pager = pager;
    }

  });
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.u.usermenu.friends', {
    abstract: true,
    template: '<ui-view></ui-view>'
  });

  $stateProvider.state('go.u.usermenu.friends.list', {
    title: 'Friends',
    url: '/friends/list?friend_id',
    params: {
      friend_id: null
    },
    reloadOnSearch: false,
    controller: 'FriendsController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/friendships/friends-list.html');
      }
    ]
  });

  $stateProvider.state('go.u.usermenu.friends.pending', {
    title: 'Friend Invites',
    url: '/friends/pending?friend_id',
    params: {
      friend_id: null
    },
    reloadOnSearch: false,
    controller: 'FriendsController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/friendships/friends-pending.html');
      }
    ]
  });

  $stateProvider.state('go.u.usermenu.friends.search', {
    title: 'Friends Search',
    url: '/friends/search',
    controller: 'FriendsController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/friendships/friends-search.html');
      }
    ]
  });

});
'use strict';

angular.module('goApp')
  .directive('hesFriendship', function(hesTemplateService) {
    // Runs during compile
    return {
      scope: {
        friendship: '='
      }, // {} = isolate, true = child, false/undefined = no change
      restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
      templateUrl: hesTemplateService.getTemplateUrl('/scripts/friendships/friendship.html'),
      controller: function($rootScope, $scope, $state, CurrentUser, CurrentSite, DialogService, Friendship, FriendService, ErrorService, MessageService) {

          $scope.alreadyFriends = function() {
            return $scope.friendship.status == "A";
          };

          $scope.isPendingIncoming = function() {
            return $scope.friendship.status == "P" && $scope.user.id !== $scope.friendship.sender_id;
          };

          $scope.isPendingOutgoing = function() {
            return $scope.friendship.status == "P" && $scope.user.id == $scope.friendship.sender_id;
          };

          $scope.sendRequest = function(user) {
            DialogService.openConfirmationDialog('Send ' + $scope.site.getFriendsLabel() + ' Request', 'Are you sure you want '+user.profile.full_name+' to be your '+ $scope.site.getFriendsLabel()+'?', 'Cancel', 'Send').then(function() {
              new Friendship({
                status: "P",
                friendee_id: user.id
              }).create(function(newSentRequest) {
                FriendService.sentRequests.push(newSentRequest);
                $rootScope.$broadcast('resetFriendSearch');
              });
            });
          };

          $scope.acceptRequest = function(request) {
            DialogService.openConfirmationDialog('Accept Request', 'Are you sure you&rsquo;d like to be <strong>' + request.friendee.profile.full_name + '</strong>&rsquo;s '+ $scope.site.getFriendsLabel() + '?', 'Cancel', 'Accept').then(function() {
              Friendship.build({
                id: request.id,
                status: 'A'
              }).save(function(friendship) {
                FriendService.friends.push(friendship);
                FriendService.incomingRequests.removeById(request.id);
                $rootScope.$broadcast('resetFriendSearch');
              });
            });
          };

          $scope.declineRequest = function(request) {
            DialogService.openConfirmationDialog('Decline Request', 'Are you sure you&rsquo;d like to decline <strong>' + request.friendee.profile.full_name + '</strong>&rsquo;s request to be your '+ $scope.site.getFriendsLabel() + '?', 'Cancel', 'Decline').then(function() {
              Friendship.build({
                id: request.id,
                status: 'D'
              }).save(function() {
                FriendService.incomingRequests.removeById(request.id);
                $rootScope.$broadcast('resetFriendSearch');
              });
            });
          };

          $scope.removeRequest = function(request) {
            DialogService.openConfirmationDialog('Remove Request', 'Are you sure you&rsquo;d like to remove your '+ $scope.site.getFriendsLabel() + ' request sent to <strong>' + (request.friendee ? request.friendee.profile.full_name : request.friend_email) + '</strong>?', 'Cancel', 'Remove').then(function() {
              request.destroy(function() {
                FriendService.sentRequests.removeById(request.id);
                $rootScope.$broadcast('resetFriendSearch');
              });
            });
          };

          $scope.resendRequest = function(request) {
            DialogService.openConfirmationDialog('Remove Request', 'Are you sure you&rsquo;d like to resend your request to <strong>' + (request.friendee ? request.friendee.profile.full_name : request.friend_email) + '</strong>?', 'Cancel', 'Resend').then(function() {
              var requestDefinition = {
                status: 'P'
              },
                teamRelationsBackup = angular.copy(request.teamRelationsStatus),
                relationsBackup = angular.copy(request.relationsStatus);

              if (request.friend_email) {
                requestDefinition.friend_email = request.friend_email;
              } else {
                requestDefinition.friendee_id = request.friendee_id;
              }

              // this is string is needed for backend!
              request.resend = true;
              request.save(function(updatedRequest) {
                request.resent = true;
                request.updated_at = updatedRequest.updated_at;
                request.relationsStatus = relationsBackup;
                request.relationsStatus = teamRelationsBackup;
              }, function(rejection) {
                ErrorService.showPriorityErrors(rejection, 'Could not resend request', 1);
              });
            });
          };

          $scope.removeFriend = function(friendship) {
            DialogService.openConfirmationDialog('Remove ' + $scope.site.getFriendsLabel(), 'Are you sure you&rsquo;d like to remove <strong>' + friendship.friendee.profile.full_name + '</strong>?', 'Cancel', 'Remove').then(function() {
              friendship.destroy(function() {
                FriendService.friends.removeById(friendship.id);
              });
            });
          };

          $scope.onFriendsList = function() {
            return $state.current.name == "go.u.usermenu.friends.list";
          };

          $scope.sendChallenge = function(user) {
            $state.go('go.u.usermenu.challenges.select_challenge',{user: user});
          };

          // $scope.sendMessage = function(user) {
          //   var convo = MessageService.getUserConversation(user);
          //   if (convo) {
          //     $state.go('go.u.usermenu.conversation', {conversationId: convo.id});
          //   } else {
          //     $state.go('go.u.usermenu.conversation_create', {user_id: user.id});
          //   }
          // };

          $scope.sendEmail = function(user) {
            DialogService.openEmailDialog(user).then(function() {
              
            });
          };

          CurrentUser.get().then(function(user) {
            $scope.user = user;
          });

          CurrentSite.get().then(function(site){
            $scope.site = site;
          });
        }
    };
  });
'use strict';

angular.module('goApp')
  .factory('FriendsLoader', function(Friendship, $q) {
    return function(options) {
      var options = _.merge({
        status: "A",
      },options);
      var defer = $q.defer();
      Friendship.index(options, function(friends) {
        defer.resolve(friends);
      }, function() {
        defer.reject('Friends could not be found');
      });

      return defer.promise;
    };
  })

.factory('IncomingFriendRequestsLoader', function(Friendship, $q) {
  return function() {
    var defer = $q.defer();
    Friendship.index({
      status: 'received_requests',
      page_size: 0
    }, function(friendships) {
      defer.resolve(friendships);
    }, function() {
      defer.reject('Incoming Friend Requests could not be found');
    });

    return defer.promise;
  };
})

.factory('SentFriendRequestsLoader', function(Friendship, $q) {
    return function() {
      var defer = $q.defer();
      Friendship.index({
        status: 'sent_requests',
        page_size: 0
      }, function(friendships) {
        defer.resolve(friendships);
      }, function() {
        defer.reject('Sent Friend Requests could not be found');
      });

      return defer.promise;
    };
  })
  .factory('FriendshipStatusLoader', function(Friendship, $q) {
    return function(userId) {
      var defer = $q.defer();
      if (!userId) {
        defer.reject();
        return defer.promise;
      }

      Friendship.getFriendshipStatus(userId).then(function(friendships) {
        var data = (friendships.data && friendships.data.data) || [];
        defer.resolve(Friendship.wrap(data[0]));
      }, function(rejection) {
        if (rejection.status == 403) {
          defer.resolve(Friendship.wrap({
            status: 'X',
            is_moderator: true
          }));
        }
        defer.reject('Sent Friend Requests could not be found');
      });

      return defer.promise;
    };
  });
'use strict';

angular.module('goApp')
  .factory('Friendship', function(ActiveResource, DOMAIN, $http, $q) {

    var Friendship = ActiveResource('/friendships/:id', {
      domain: DOMAIN,
      parentResource: ['User'],
      nestedRoutes: ['create', 'index']
    });

    Friendship.getFriendshipStatus = function(userId) {
      return $http.get(DOMAIN + '/friendship_status/' + userId);
    };

    Friendship.prototype.getFriend = function() {
      return this.friendee || this.friender
    };

    Friendship.prototype.getFriendFullName = function(){
      return this.getFriend().profile.full_name;
    };

    var defered_count = null;
    Friendship.count = function() {
      if (defered_count && defered_count.promise.$$state.status == 0) {
        return defered_count.promise;
      }
      var defered_count = $q.defer();
      
      $http.get(DOMAIN + '/friendships/count',{isArray:false}).then(function(response){
        defered_count.resolve(response.data);
      }).finally(function(){
        defered_count = null;
      });

      return defered_count.promise;
    }

    return Friendship;
  });
'use strict';

angular.module('goApp')
  .factory('Gallery', ['ActiveResource', '$http', 'DOMAIN',
    function(ActiveResource, $http, DOMAIN) {
      var Gallery = ActiveResource('/gallery_images/:path', {
        // nestedRoutes: ['update', 'index', 'create'],
        // parentResource: '',
        domain: DOMAIN
      });

      Gallery.get_path = function(path) {
        return $http.get(DOMAIN + '/gallery_images' + path);
      };

      Gallery.delete_photo = function(path) {
        return $http.delete(DOMAIN + path);
      };

      Gallery.un_delete_photo = function(path) {
        return $http.delete(DOMAIN + path + '?undelete=true');
      };

      return Gallery;
    }
  ]);
'use strict';

angular.module('goApp')
  .directive('hesImageGallery', ['hesTemplateService',
    function(hesTemplateService) {
      // Runs during compile
      return {
        scope: {
          ngModel: '=',
          updateHandler: '&?'
        }, // {} = isolate, true = child, false/undefined = no change
        controller: 'ImageGalleryController',
        restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
        templateUrl: hesTemplateService.getTemplateUrl('/scripts/galleries/image_gallery_placeholder.html'),
        replace: true,
        // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
        link: function($scope, $element, $attrs, controller) {
          //New default behavior is to not show the galleries
          $scope.uploadOnly = true;

          function setFolderPath() {
            if ($attrs.folderLocation) {
              $scope.top_path = String($attrs.folderLocation);
              $scope.current_path = String($attrs.folderLocation);
            }
          };

          if ($attrs.imageResultSize) {
            $scope.image_result_size = $attrs.imageResultSize;
          }

          if ($attrs.hideSearch) {
            $scope.hide_search = $attrs.hideSearch;
          }

          if ($attrs.hideDirectories) {
            $scope.hide_directories = $attrs.hideDirectories;
          }

          if ($attrs.hideImageName) {
            $scope.hide_image_name = $attrs.hideImageName;
          }

          if ($attrs.noUpload) {
            $scope.no_upload = $attrs.noUpload;
          }

          if ($attrs.hasOwnProperty('fullGallery')) {
            $scope.uploadOnly = false;
          }

          if ($attrs.allowRemove) {
            $scope.allow_remove = $attrs.allowRemove;
          }

          if ($attrs.imageLabel) {
            $scope.image_label = $attrs.imageLabel;
          } else {
            $scope.image_label = "No Logo Yet";
          }

          if ($attrs.label) {
            $scope.label = $attrs.label;
          } else {
            $scope.label = "Use this image?"
          }

          $attrs.$observe('folderLocation', function() {
            setFolderPath();
          });

        }
      };
    }
  ])
  .controller('ImageGalleryController', ['$rootScope', '$scope', 'ngDialog', 'Gallery', 'FileUploader', 'ipCookie', 'DOMAIN', 'DialogService',
    function($rootScope, $scope, ngDialog, Gallery, FileUploader, ipCookie, DOMAIN, DialogService) {
      $scope.file_name = "placeholder-image.png";
      $scope.uploadErrors = [];
      $scope.selected_photo = null;
      $scope.upload_progress = null;
      $scope.gallery;
      $scope.top_path = "";
      $scope.current_path = "";
      $scope.upload_file = {
        photo: null
      };

      function fileAdded(file) {
        file.url = file.url + makePaths() + file.file.name;
        file.upload();
      }

      $scope.options = {
        url: '/gallery_images',
        uploadUrl: '',
        autoUpload: true,
        onAfterAddingFile: fileAdded,
        progress: $scope.upload_progress,
        headers: {
          Authorization: ipCookie('basic')
        }
      };

      function resetVariables() {
        $scope.selected_photo = null;
        $scope.setup.search_term = "";
      }

      $scope.setup = {
        search_term: "",
        uploader: new FileUploader($scope.options)
      };

      function setUpPaths() {
        if (typeof $scope.top_path === 'string') {
          $scope.top_path = $scope.top_path.split('/').filter(Boolean) || [];
        }
        if (typeof $scope.current_path === 'string') {
          $scope.current_path = $scope.current_path.split('/').filter(Boolean) || [];
        }

      }

      function makePaths() {
        var string_path = "/";
        for (var i = 0; i < $scope.current_path.length; i++) {
          string_path = string_path + $scope.current_path[i] + "/";
        }
        $scope.options.uploadUrl = $scope.options.url + string_path;
        return string_path;
      }

      $scope.getFileName = function() {
        return '/gallery/' + $scope.file_name;
      };

      $scope.isImage = function(filename) {
        return (/\.(gif|jpg|jpe?g|tiff|png|svg)$/i).test(filename);
      };

      $scope.fileNameWithoutPath = function(path) {
        return path.split("/").reverse()[0];
      };

      $scope.openGallery = function(path) {
        resetVariables();
        setUpPaths();
        $scope.getFolder();

        $scope.dialogScope = $scope.$new();

        ngDialog.openConfirm({
          className: 'ngdialog-theme-default' + ($scope.uploadOnly ? '' : 'col-3'),
          template: '/scripts/galleries/image_gallery.html',
          scope: $scope.dialogScope
        }).then(function(photo) {
          var onUpdate = $scope.updateHandler;
          $scope.ngModel = photo.http_path;
          if (!!onUpdate && angular.isFunction(onUpdate)) {
            onUpdate(photo);
          }
        })['finally'](function(){
          $scope.dialogScope.$destroy();
        });
      };

      $scope.getImageURL = function(image_url) {
        return image_url ? "http:" + DOMAIN + image_url : "/gallery/placeholder.png";
      };


      // SVG's don't like max-height and max-width without a width
      $scope.isSVG = function(image_url) {
        return image_url.substring(image_url.length - 3, image_url.length) == "svg";
      };

      $scope.fetchGallery = function() {
        $scope.deselectPhoto();

        Gallery.get_path(makePaths()).then(function(results) {
          $scope.gallery = results.data;
          $scope.loading_gallery = false;
        });
      };


      $scope.getFolder = function(folder_path) {
        if (folder_path) {
          $scope.current_path.push(folder_path);
          makePaths();
        }
        $scope.loading_gallery = true;
        $scope.fetchGallery();
      };

      $scope.upFolder = function() {
        if ($scope.current_path.length > $scope.top_path.length) {
          $scope.current_path.pop();
          $scope.loading_gallery = true;
          $scope.fetchGallery();
        }
      };

      $scope.backFolder = function(name) {
        var new_path = $scope.current_path.splice(0, $scope.current_path.indexOf(name) + 1);
        $scope.current_path = new_path;
        $scope.loading_gallery = true;
        $scope.fetchGallery();
      };

      $scope.selectPhoto = function(image) {
        $scope.selected_photo = image;
      };

      $scope.deselectPhoto = function() {
        $scope.selected_photo = null;
      };

      $scope.selectDeletedPhoto = function(image) {
        $scope.selected_deleted_photo = image;
      };

      $scope.deselectDeletedPhoto = function() {
        $scope.selected_deleted_photo = null;
      };

      $scope.uploadPhotoStart = function() {
        $scope.loading_gallery = true;
      };

      $scope.uploadPhotoFinished = function(data) {
        $scope.loading_gallery = false;
        $scope.gallery.files.push(data);
        $scope.selected_photo = $scope.gallery.files[$scope.gallery.files.length - 1];
        if ($scope.uploadOnly && $scope.dialogScope.$$childHead) {
          $scope.dialogScope.$$childHead.confirm($scope.selected_photo);
        }
      };

      $scope.promptRemove = function() {
        $scope.prompt_remove = true;
      };

      $scope.confirmRemove = function(photo) {
        $scope.prompt_remove = false;
        $scope.deselectPhoto();
        $scope.loading_gallery = true;

        Gallery.delete_photo(photo.edit_path).then(function() {
          $scope.fetchGallery();
        });
      };

      $scope.unDelete = function(photo) {
        $scope.deselectDeletedPhoto();
        $scope.loading_gallery = true;

        Gallery.un_delete_photo(photo.edit_path).then(function() {
          $scope.fetchGallery();
        });
      };

      $scope.deselectRemove = function() {
        $scope.prompt_remove = false;
      };

      $scope.removeImage = function() {
        DialogService.openConfirmationDialog('Remove Image', 'Remove this image? (You still need to save)', 'cancel', 'Remove').then(function() {
          $scope.ngModel = null;
        });
      };

      setUpPaths();

    }
  ]);
'use strict';
angular.module('goApp')
  .controller('GoalAdminEditController', function($scope, $state, Goal, editGoal, ErrorService, $mdToast) {

    $scope.data = {
      editGoal: editGoal,
      months: [{'month': 'January','value': 1}, {'month': 'February','value': 2}, {'month': 'March','value': 3}, {'month': 'April','value': 4}, {'month': 'May','value': 5}, {'month': 'June','value': 6}, {'month': 'July','value': 7}, {'month': 'August','value': 8}, {'month': 'September','value': 9}, {'month': 'October','value': 10}, {'month': 'November','value': 11}, {'month': 'December','value': 12}],
      goalCats: []
    };

    $scope.saveGoal = function() {
      var image = ($scope.data.editGoal.image && $scope.data.editGoal.image.path) || $scope.data.editGoal.image;

      var goalParams = {
        title: $scope.data.editGoal.title,
        summary: $scope.data.editGoal.summary,
        site_id: $state.params.siteId,
        category: $scope.data.editGoal.category,
        image: image,
        month_integer: parseInt($scope.data.editGoal.month_integer),
        final_month_integer: parseInt($scope.data.editGoal.final_month_integer) || null,
        description: $scope.data.editGoal.description
      };

      if($scope.dbSite.isDefault()){                                    // site_id is null for default goals, so only replace id with no parent_id if default site
        goalParams.id = $scope.data.editGoal.id;
      } else if($scope.data.editGoal.site_id == $state.params.siteId) { // if saving a goal from the same site, replace goal with new goal of same id and parent_id
        goalParams.id = $scope.data.editGoal.id;
        goalParams.parent_id = $scope.data.editGoal.parent_id;
      } else {                                                          // otherwise, make new goal with reference by parent_id
        goalParams.parent_id = $scope.data.editGoal.id;
      }

      var goal = Goal.build(goalParams);

      if ($scope.data.editGoal.id) {
        goal.save(function(goal) {
          $state.go('go.u.site.goals');
        });  
      } else {
        goal.create(function(goal) {
          $state.go('go.u.site.goals');
        });
      }
    };

    $scope.cancelEdit = function() {
      $state.go('go.u.site.goals');
    };

    $scope.showAddCat = function() {
      $scope.data.newCat = '';
      $scope.data.showNewCat = true;
    };

    $scope.cancelAddCat = function() {
      $scope.data.showNewCat = false;
      $scope.data.newCat = '';
    };

    $scope.addNewCat = function() {
      if ($scope.data.goalCats.indexOf($scope.data.newCat) === -1) {
        $scope.data.newCat = $scope.data.newCat;
        $scope.data.goalCats.push($scope.data.newCat);
        $scope.data.editGoal.category = $scope.data.newCat;
        $scope.data.showNewCat = false;


        $scope.data.goalCats.sort(function (a, b) {
          if(!a) {a = ''};
          if(!b) {b = ''};
          return a.toLowerCase().localeCompare(b.toLowerCase());
        });


      } else {
        ErrorService.showErrors({}, 'Category already exists!!');
      }
    };

    Goal.index({page_size:0, site_id: $state.params.siteId}, function(data) {
      for(var idx = 0; idx < data.length; idx++){
        if($scope.data.goalCats.indexOf(data[idx].category) === -1){
          $scope.data.goalCats.push(data[idx].category);
        }
      }

      $scope.data.goalCats.sort(function (a, b) {
        if(!a) {a = ''};
        if(!b) {b = ''};
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });
    });

  });
'use strict';

angular.module('goApp').controller('GoalsAdminController', function($scope, $state, Goal) {

  $scope.data = {
    tblElements: {
      fields: [
        ["title", "string"],
        ["starting_month", "string"],
        ["ending_month", "string"],
        ["category", "string"],
        ["site_id", "string"],
        // ["is_default", "string"],
        // ["is_current", "string"],
        ["Actions", "actions", {
          width: 200
        }]
      ],
      rows: [],
      actions: []
    }
  };

  var months = ["January","February","March","April","May","June","July",
                "August","September","October","November","December"];

  function setTableData() {
    var gridRows = [];

    var destroyEle = function(ele) {
      if(confirm("Are you sure you want to delete '"+ele.title+"'?") == true){
  
        // most goals except for default goals or edge cases won't have children
        // update children to new parent
        if(ele.children_ids){
          ele.children_ids.forEach(function(child_id){
            var child = $scope.data.elements.find(function(goal){return goal.id == child_id;});
            // map any children to refer to parent or null
            child.parent_id = ele.parent_id || null;
            // and save
            var saveChild = angular.copy(child);
            saveChild.row = undefined; // causing recursion
            saveChild.save();
          });
        }
  
        // update parent to new children and show
        if(ele.parent_id){
          var parent = $scope.data.elements.find(function(goal){return goal.id == ele.parent_id;});
  
          if(parent){
            // merge with current children_ids and remove self from parent's children
            parent.children_ids = (parent.children_ids || []).concat(ele.children_ids || []).filter(function(child_id){ return child_id != ele.id; });
  
            if(parent.hidden && parent.children_ids.length == 0){
              parent.hidden = undefined;
            }
          } else {
            console.error("Goal has no available parent");
          }
        }
        ele.destroy(init);
        setTableData();
      }
    };

    for (var i = 0; i < $scope.data.elements.length; i++) {
        var ele = $scope.data.elements[i];
        var eleLink = $state.href("go.u.site.goal_edit",{id: ele.id});

        if (!ele.user_id && !ele.hidden) {
          ele.row = [
            (ele.title || 'N/A'),
            (ele.month || 'N/A'),
            (months[ele.final_month_integer-1] || 'N/A'),
            (ele.category || 'N/A'),
            (ele.site_id),
            [
              ['edit', eleLink ],
              ele.site_id || $scope.dbSite.id == $scope.site.id ? ['delete', destroyEle, ele] : null
            ]
          ];
          gridRows.push(ele);
        }
    }

    $scope.data.tblElements.rows = gridRows;
  }

  function init() {
    Goal.index({page_size:0, site_id: $scope.dbSite.id}, function(data) {
      var derived_goals = data.filter(function(goal){ return goal.parent_id; }); // goals with a parent id;

      derived_goals.forEach(function(d_goal){
        data.find(function(goal) {
          if(goal.id == d_goal.parent_id){
            // set children on parents
            goal.children_ids = goal.children_ids || [];
            goal.children_ids.push(d_goal.id);

            // hide goal if it has a child and is from a different site
            if(goal.site_id != $scope.dbSite.id){
              goal.hidden = true;
            }
          }
        });
      });

      $scope.data.elements = data;

      setTableData();
    });
  }
  
  init();

});
'use strict';

angular.module('goApp').factory('Goal', function($http, $state, ActiveResource, DOMAIN) {

  var Goal = ActiveResource('/goals/:id', {
    domain: DOMAIN,
    nestedRoutes: ['index', 'create', 'update', 'destroy', 'show'],
    parentResource: 'Site'
  }, {
    updateStatus: {
      method: "PUT",
      url: "/status",
      isArray: false
    }
  });

  Goal.current = function() {
    return Goal.index({page_size: 0});
  }

  Goal.active = function() {
    return Goal.index({filter: 'active', page_size:0});
  }

  Goal.completed = function() {
    return Goal.index({filter: 'completed', page_size:0});
  }

  Goal.prototype.updateStatus = function(status) {
    var that = this;
    var promise = Goal.updateStatus({id: this.id, status: status}).$promise;
    promise.then(function(goal) {
      _.merge(that, goal);
    });
    return promise; 
  }

  Goal.prototype.completedDateString = function() {
    return moment(this.completed_at).format('MMMM YYYY');
  };

  Goal.prototype.complete = function() {
    return this.updateStatus("complete");
  }

  Goal.prototype.cancel = function() {
    return this.updateStatus("cancel");
  }

  Goal.prototype.createdAt = function() {
    return moment(this.created_at).format(Entry.HUMAN_FORMAT);
  }



  return Goal;
});
'use strict';

angular.module('goApp')
  .service('GoalService',
    function(Goal, CurrentSite, FetchedDataGroup, GoalsLoader, ActiveUserGoalsLoader, CompletedUserGoalsLoader) {
      var GoalService = new Object();

      GoalService.goals = new FetchedDataGroup(function() {
        return new GoalsLoader();
      }, true);
      
      GoalService.active = new FetchedDataGroup(function() {
        return new ActiveUserGoalsLoader();
      }, true);

      GoalService.completed = new FetchedDataGroup(function() {
        return new CompletedUserGoalsLoader();
      }, true);

      GoalService.setEditGoal = function(goal) {
        GoalService.editGoal = goal;
      };

      GoalService.markUsingCustomPhoto = function() {
        GoalService.editGoal.is_custom = true;
      };

      GoalService.getEditGoal = function() {
        if(!GoalService.editGoal) {
          GoalService.editGoal = new Goal({image:{}});
        }
        return GoalService.editGoal;
      };

      GoalService.init = function() {
        // GoalService.goals.get();
        // GoalService.active.get();
        // GoalService.completed.get();
        GoalService.editGoal = new Goal;
      };

      GoalService.init();

      return GoalService;
    });
'use strict';
angular.module('goApp')
  .controller('GoalsController', function($scope, $state, $filter, GoalService, DialogService, ContentLoader, ngDialog, Goal) {

    $scope.settings = {
      crumbs: [{
        state: 'go.u.personal.goals.active',
        display: "My Goals"
      }, {
        state: 'go.u.personal.goals.choose',
        display: "Choose"
      }],
      data_fetched: false,
      saving: false,
      default_filter: "Filter by category…"
    };

    $scope.data = {
      goals: [],
      current_filter: $scope.settings.default_filter,
      shareOpen: false,
    };

    $scope.currentDate = new Date();

    switch($state.current.name) {
      case "go.u.personal.goals.choose":
        GoalService.goals.get(true).then(function(goals) {
          $scope.data.goals = goals;
          //var previous = _.filter($scope.data.goals,function(g){ return !!g.user_id});
          //var filters = previous.length > 0 ? ["Categories", "My Previous"] : ["Categories"];
          var filters = [$scope.settings.default_filter];
          filters.push(_.compact(_.uniq(_.map(goals, 'category'))));
          $scope.data.goal_groups = _.flatten(filters);
          $scope.groupGoals($scope.data.current_filter);
        });
        break;
      case "go.u.personal.goals.active":
        GoalService.active.get(true).then(function(user_goals) {
          $scope.data.active_user_goals = _.orderBy(user_goals,"created_at");
          $scope.settings.data_fetched = true;
        });
        break;
      case "go.u.personal.goals.history":
        GoalService.active.get(true).then(function(user_goals) {
          $scope.data.active_user_goals = _.orderBy(user_goals,"created_at");
        });
        GoalService.completed.get(true).then(function(user_goals) {
          var full_dates = [];
          user_goals = $filter('orderBy')(user_goals, '-completed_at');
          for (var i = 0; i < user_goals.length; i++) {
            full_dates.push(user_goals[i].completedDateString());
          }
          $scope.data.completed_user_goals = user_goals;
          $scope.data.completed_dates = _.uniq(full_dates);
        });
        break;
    }
  

    $scope.groupGoals = function(filter) {
      switch(filter) {
        case $scope.settings.default_filter:
          var grouped = _.groupBy(_.filter($scope.data.goals,{user_id:null}), "month");
          // var previous = _.filter($scope.data.goals,function(g){ return !!g.user_id});
          // if (previous.length > 0) {
          //   grouped['My Previous'] = _.filter($scope.data.goals,function(g){ return !!g.user_id});
          // }
          $scope.data.grouped_goals = grouped;
          break;
        case "My Previous":
          $scope.data.grouped_goals = {"My Previous": _.filter($scope.data.goals,function(g){ return !!g.user_id})};
          break;
        default:
          $scope.data.grouped_goals = _.groupBy(_.filter($scope.data.goals,{category:filter, user_id: null}), "category");
          break;
      }
    };

    $scope.deleteGoal = function(goal) {
      DialogService.openConfirmationDialog("Remove Goal", "Are you sure you want to remove this goal?", 'Cancel', "Remove").then(function() {
        goal.destroy(function(goal) {
          GoalService.active.removeById(goal.id);
          GoalService.active.get(true).then(function(user_goals) {
            $scope.data.active_user_goals = _.orderBy(user_goals,"created_at");
            $scope.settings.data_fetched = true;

            $('.my-goal .delete-btn').blur();
          });
        });
      });
    };

    $scope.completeGoal = function(goal) {
      DialogService.openConfirmationDialog("Complete Goal", "Are you sure you want to mark this goal as completed?", 'Cancel', "Complete").then(function() {
        goal.status = "complete";
        goal.completed_at = new Date();
        goal.save(function(completed_goal) {
          GoalService.active.removeById(completed_goal.id);
          GoalService.active.get(true).then(function(user_goals) {
            $scope.data.active_user_goals = _.orderBy(user_goals,"created_at");
            $scope.settings.data_fetched = true;
          });
          GoalService.completed.push(completed_goal);
          $scope.openSharePopup(goal);
        });
      });
    };

    $scope.openSharePopup = function(goal) {
      $scope.data.completed_goal = goal;
      ngDialog.open({
        className: 'ngdialog-theme-default',
        template: '/scripts/goals/goal-share-popup.html',
        scope: $scope
      });
    }

    $scope.emailGoal = function() {
      ngDialog.open({
        template: '/scripts/shareResource/email/emailResource.html',
        data: {
          resource: $scope.data.completed_goal,
          type: "Goal"
        }
      });
    };

    $scope.shareOnWall = function() {
      ngDialog.open({
        template: '/scripts/shareResource/shareToWall/shareToWall.html',
        controller: 'ShareToWallController',
        className: 'ngdialog-theme-default share-to-wall',
        data: {
          resource: $scope.data.completed_goal,
          type: "Goal"
        }
      });
    };

    $scope.goalsByGroup = function(group) {
      return $filter('filter')($scope.data.goals, {
        category: group
      }, true);
    };

    $scope.completedByDate = function(date) {
      return $filter('filter')($scope.data.completed_user_goals, function(goal) {
        return goal.completedDateString() === date;
      });
    };

    $scope.createEditGoal = function(goal) {
      GoalService.setEditGoal(goal);
      ngDialog.closeAll();
      $state.go('go.u.personal.goals.create');
    };

    $scope.startDefaultGoal = function(goal) {
      var defaultGoal = goal;
      $scope.settings.saving = true;
      var image = (defaultGoal.image && defaultGoal.image.path) || defaultGoal.image;
      Goal.build({
        id: defaultGoal.id,
        user_id: $scope.user.id,
        title: defaultGoal.title,
        category: defaultGoal.category,
        image: image,
        completed_at: null,
        description: defaultGoal.description,
        parent_id: defaultGoal.user_id ? defaultGoal.parent_id : defaultGoal.id
      }).save(function(goal) {
        GoalService.active.push(goal);
        ngDialog.closeAll();
        $scope.settings.saving = false;
        $state.go('go.u.personal.goals.active');
      }, function(response){
        $scope.settings.saving = false;
        DialogService.openInformationDialog("Error", response.data.errors[0].base.join("<br/>"), "OK");
      });
    };

    $scope.showRunAgain = function(goal){
      var show = true;

      var current_month = new Date($scope.site.current_date).getMonth() + 1;

      // if current_month is less than start_month, wrap around year
      if ( current_month < goal.month_integer ) { current_month += 12; }

      // if no end, assume difference is 6 months
      var difference = 6;

      if(goal.final_month_integer){ // if end date is set
        // get different between months
        difference = goal.final_month_integer - goal.month_integer;
        // if negative, wrap around year
        if ( difference < 0) { difference += 12; }
      }

      // true if current month is between start and end
      show *= current_month >= goal.month_integer && current_month <= (goal.month_integer + difference);

      // true if active goals is less than 3
      show *= !$scope.data.active_user_goals || $scope.data.active_user_goals.length < 3;

      return show;
    }

    $scope.viewGoal = function(goal) {
      $scope.viewableGoal = goal;
      ngDialog.open({
        className: 'ngdialog-theme-default goal-view-popup',
        template: '/scripts/goals/goal-view-popup.html',
        scope: $scope
      });
    };

    new ContentLoader({
      site_id: $scope.site.id,
      category: 'explanations'
    }, false).then(function(content) {
        $scope.data.content = _.find(content,{key:'goal'});
    });


  });
'use strict';
angular.module('goApp')
  .controller('GoalsCreateEditController', function($scope, $state, $filter, GoalService, Goal, ngDialog, Content, ContentLoader, DialogService) {

    $scope.taToolbar = [
      ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'insertLink']
    ];


    $scope.data = {
      editGoal: GoalService.getEditGoal(),
      goal_images: [],
      goal_groups: []
    };

    new ContentLoader({
      site_id: $scope.site.id,
      category: 'goal_images'
    }, true).then(function(contents) {
      $scope.data.goal_images = contents;
      $scope.data.goal_groups = _.uniq(_.map(contents, 'group'));
      // textAngularMods();
    });

    $scope.settings = {
      crumbs: [{
        state: 'go.u.personal.goals.active',
        display: "My Goals"
      }, {
        state: 'go.u.personal.goals.choose',
        display: "Choose"
      }, {
        state: 'go.u.personal.goals.create',
        display: "Create"
      }]
    };

    $scope.photosByGroup = function(group) {
      return $filter('filter')($scope.data.goal_images, {
        group: group
      }, true);
    };

    $scope.openGallery = function() {
      ngDialog.open({
        className: 'ngdialog-theme-default goals-gallery',
        template: '/scripts/goals/goal_gallery.html',
        scope: $scope
      });
    };

    $scope.chooseImageFromGallery = function(image) {
      $scope.data.editGoal.image = image;
      ngDialog.close();
    };

    // var textAngularMods = function() {
    //   var textBox = document.querySelector('*[id^="taTextElement"]');
    //   textBox.setAttribute('aria-label', 'Goal description');

    //   textBox.addEventListener('keydown', function(event) {
    //     if (event.keyCode == 9) {
    //       event.target.blur();
    //       $('.button-row a').focus();
    //     }
    //   })
    // }

    $scope.saveGoal = function() {
      var image = ($scope.data.editGoal.image && $scope.data.editGoal.image.path) || $scope.data.editGoal.image;
      if ($scope.data.editGoal.description) {
      Goal.build({
        id: $scope.data.editGoal.id,
        user_id: $scope.user.id,
        title: $scope.data.editGoal.title,
        image: image,
        category: $scope.data.editGoal.category,
        completed_at: null,
        description: $scope.data.editGoal.description,
        summary: $scope.data.editGoal.summary,
        parent_id: $scope.data.editGoal.user_id ? $scope.data.editGoal.parent_id : $scope.data.editGoal.id
      }).save(function(goal) {
        GoalService.active.push(goal);
        $state.go('go.u.personal.goals.active');
      }, function(response){
        DialogService.openInformationDialog("Error", response.data.errors[0].base.join("<br/>"), "OK");
      });
    } else {
      // $('text-angular .ng-empty').addClass('invalid');
    }
    };

  });
'use strict';

angular.module('goApp')
  .factory('GoalLoader', function(Goal, $q) {
    return function(params) {
      var defer = $q.defer();
      if (params.goalId) {
        Goal.show({
          id: params.goalId
        }, function(goal) {
          defer.resolve(goal);
        }, function() {
          defer.reject('Goal could not be found');
        });
      } else {
        defer.resolve(new Goal());
      }

      return defer.promise;
    };
  })
  .factory('GoalsLoader', function(Goal, $q) {
    return function() {
      var defer = $q.defer();
      Goal.index({
        page_size: 0
      }, function(goals) {
        defer.resolve(goals);
      }, function() {
        defer.reject('Goals could not be found');
      });

      return defer.promise;
    };
  })
  .factory('ActiveUserGoalsLoader', function(Goal, $q) {
    return function() {
      var defer = $q.defer();

      Goal.index({
        filter: 'active',
        page_size: 0
      }, function(goals) {
        defer.resolve(goals);
      }, function() {
        defer.reject('Active User Goals could not be found');
      });

      return defer.promise;
    };
  })

  .factory('CompletedUserGoalsLoader', function(Goal, $q) {
    return function() {
      var defer = $q.defer();

      Goal.index({
        filter: 'completed',
        page_size: 0
      }, function(goals) {
        defer.resolve(goals);
      }, function() {
        defer.reject('Completed User Goals could not be found');
      });

      return defer.promise;
    };
  });
'use strict';

angular.module('goApp').config(function($stateProvider) {

  // admin states
  $stateProvider.state('go.u.site.goals', {
    title: 'Goals',
    url: '/goals',
    abstract: false,
    controller: 'GoalsAdminController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/goals/admin/goals-list-admin.html');
      }
    ],
  });

  $stateProvider.state('go.u.site.goal_edit', {
    title: 'Edit Goal',
    url: '/goals/:id',
    abstract: false,
    controller: 'GoalAdminEditController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/goals/admin/goal-admin-edit.html');
      }
    ],
    resolve: {
      editGoal: ['GoalLoader', '$stateParams', function(GoalLoader, $stateParams) {
        return new GoalLoader({goalId: $stateParams.id});
      }]
    }
  });

  // goal states

  $stateProvider.state('go.u.personal.goals', {
    abstract: true,
    template: '<ui-view></ui-view>'
  });

  $stateProvider.state('go.u.personal.goals.active', {
    title: 'Goals',
    url: '/goals/active',
    abstract: false,
    controller: 'GoalsController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/goals/goals-active.html');
      }
    ]
  });

  $stateProvider.state('go.u.personal.goals.choose', {
    title: 'Goals',
    url: '/goals/active/choose',
    abstract: false,
    controller: 'GoalsController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/goals/goals-choose.html');
      }
    ]
  });

  $stateProvider.state('go.u.personal.goals.create', {
    title: 'Goals',
    url: '/goals/active/create',
    abstract: false,
    controller: 'GoalsCreateEditController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/goals/goal-create.html');
      }
    ]
  });

  $stateProvider.state('go.u.personal.goals.history', {
    title: 'Goals History',
    url: '/goals/history',
    abstract: false,
    controller: 'GoalsController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/goals/goals-completed.html');
      }
    ]
  });

});
'use strict';

angular.module('goApp').run(function($rootScope) {
  $rootScope.is_mega_menu_open = false;
  

  $rootScope.$on('$stateChangeSuccess', function(){ 
    $rootScope.is_mega_menu_open = false;
  });


});
'use strict';

angular.module('goApp').controller('MegaMenuController', function($scope, $rootScope, $q, $timeout, CurrentSite, Notification, MessageService) {
  $scope.includes_feature = new Object();
  $scope.data = new Object();

  $scope.data.count = {
    challenges: 0,
    messages: 0,
    notifications: 0,
    evaluation: 0
  }

  CurrentSite.get().then(function(site) {
    _.each(site.enabled_features, function(feature) {
      $scope.includes_feature[feature] = true;
    });
  });


  $scope.getTotalCount = function() {
    return $scope.data.count.challenges +
      $scope.data.count.messages +
      $scope.data.count.notifications +
      $scope.data.count.evaluations;
  }

  $scope.anyFeatureEnabled = function() {
    return $scope.includes_feature.notifications ||
      $scope.includes_feature.messages ||
      $scope.includes_feature.challenges;
  }


  $scope.showDot = function(menu) {
    switch (menu.link) {
      case "go.u.personal.notifications_unread":
        return $scope.data.count.notifications > 0 && $scope.site.flags.is_notifications_enabled;
      case "main-menu":
        return $scope.data.count.notifications > 0 && $scope.site.flags.is_notifications_enabled;
      default:
        return false;
    }
  }

  $scope.toggleMobileMenu = function() {
    if ($rootScope.is_mega_menu_open) {
      $('body').removeClass('fixed-screen');
    } else {
      $('body').addClass('fixed-screen');
      $timeout(function() {
        $('.fixed-screen').on('click', function() {
          $('body').removeClass('fixed-screen');
        })
      }, 100)
    }
    //IOS mobile devices
    $('.fixed-screen').ontouchend = function(e) {
      e.preventDefault();
    };
  }

  function getCounts() {
    Notification.count().then(function(counts) {
      $scope.data.count = counts;
    });
  }

  $scope.truncate = function(name) {
    return _.truncate(name, {
      length: 13
    });
  }

  getCounts();

  $rootScope.$on("modelUpdate", function(e, data) {
    if (_.includes(["UserChallenge", "Message", "Notification", "Evaluation", "Badge"], data.model)) {
      getCounts();
    }
  });


});
'use strict';

angular.module('goApp').directive('hesMegaMenu', function(hesTemplateService, $timeout, $rootScope) {
  // Runs during compile
  return {
    controller: "MegaMenuController",
    scope: false,
    restrict: 'E', // E = Element, A = Attribute, C = Class, M = Comment
    templateUrl: hesTemplateService.getTemplateUrl('/scripts/header/megaMenu/megaMenu.html'),
    link: function($scope, $element, $attrs, controller) {

      $element.find('.mega-menu').on('mouseenter', function(e) {
        var isMobile = e.target.parentElement.parentElement.classList.contains('mobile-menu') || e.target.parentElement.classList.contains('mobile-menu');
        if (!$rootScope.is_welcome_overlay && !isMobile) {
        $rootScope.is_mega_menu_open = true;
        $scope.$apply();
        }
      });

      $element.find('.mega-menu').on('mouseleave', function() {
        if (!!$rootScope.is_mega_menu_open && !$scope.isClicked) {
          $rootScope.is_mega_menu_open = false;
          $scope.$apply();
        }
      });

      $element.find('.mega-menu').on('click', function(event) {
        var isMobile = event.target.parentElement.parentElement.classList.contains('mobile-menu') || event.target.parentElement.classList.contains('mobile-menu');
        if (!$scope.isClicked && !isMobile) {
          $rootScope.is_mega_menu_open = true;
          $scope.isClicked = true;
        } else if(isMobile && !$rootScope.is_mega_menu_open) {
          $rootScope.is_mega_menu_open = true;
          $scope.isClicked = true;
        } else {
          $rootScope.is_mega_menu_open = false;
          $scope.isClicked = false;
        }
        $scope.$apply();
      });

      $scope.$watch("is_mega_menu_open",function(val){
        $rootScope.$broadcast("is_mega_menu_open",val);
      })

      $timeout(function() {
        $('.links a').on('click', function(e) {
          $('body').removeClass('locked-screen');
        });
        $('a').on('click', function(e) {
          $('body').removeClass('fixed-screen');
        }); 
      }, 300);

      $('body').on('click', function(e) {
        if ($scope.isClicked && e.target != $element.find(e.target)[0]) {
          $rootScope.is_mega_menu_open = false;
          $scope.isClicked = false;
          $scope.$apply();
        }
      });

      $element.find('.last-item').on('blur', function() {
        $rootScope.is_mega_menu_open = false;
      });

      $timeout(function() {
        $element.find('a:not([high-contrast-toggle])')
          .on('click', function() {
            $rootScope.is_mega_menu_open = false;
          });
      }, 0);

      $scope.$on("$destroy", function() {
        $element.find('.mega-menu').off();
        $element.find('a').off();
        $('body').removeClass('locked-screen', 'fixed-screen');
      });

    }
  };
});
'use strict';

angular.module('goApp')
  .directive('hesUserMenu', function(hesTemplateService, $timeout) {
    // Runs during compile
    return {
      controller: function($scope, UserMenuService) {
        $scope.view = {
          userMenuService: UserMenuService
        };
      },
      scope: true,
      restrict: 'E', // E = Element, A = Attribute, C = Class, M = Comment
      templateUrl: hesTemplateService.getTemplateUrl('/scripts/header/user-menu/user-menu.html'),
      link: function($scope, $element, $attrs, controller) {
        $element.find('.user-menu').on('mouseenter', function() {
          $scope.view.userMenuService.isOpen = true;
          $scope.$apply();
        });
        $element.find('.user-menu').on('mouseleave', function() {
          if (!$scope.view.userMenuService.isClicked) {
          $scope.view.userMenuService.isOpen = false;
          $scope.$apply();
          }
        });

        $('body').on('click', function(e) {
          if ($scope.view.userMenuService.isClicked && e.target != $element.find(e.target)[0]) {
            $scope.closeTimeout = $timeout(function() {
              $scope.view.userMenuService.isOpen = false;
              $scope.view.userMenuService.isClicked = false;
              $scope.closeTimeout = null;
              $scope.$apply();
            }, 300);
          }
        });

        $scope.$on("$destroy", function() {
          $element.find('.user-menu').off();
          $element.find('a').off();
        });
      }
    };
  });
'use strict';

angular.module('goApp')
  .service('UserMenuService', function($rootScope, $timeout) {
    var userMenu = {
      isOpen: false,
      isClicked: false
    };

    userMenu.toggle = function() {
      if (userMenu.isClicked && userMenu.isOpen) {
        userMenu.isOpen = false;
      } else if (!userMenu.isClicked && !userMenu.isOpen) {
        userMenu.stayOpen();
      }
      userMenu.isClicked = !userMenu.isClicked;
      $rootScope.$safeApply();
    };

    userMenu.stayOpen = function() {
      userMenu.isOpen = true;
    };

    return userMenu;
  })
  .run(function($rootScope, UserMenuService) {
    $rootScope.$on('$stateChangeSuccess', function() {
      UserMenuService.isOpen = false;
    });
  });
'use strict';

angular.module('goApp').directive('hesCharactersRemaining', function() {
	return {
		restrict: 'EC',
		template: '<p class="margin-xs-top font-semi-bold">{{charactersLeft}} characters remaining</p>',
		replace: true,
		scope: {
			containingText: '=',
			charactersAllowed: '@',
			limitReached: '&'
		},
		link: function (scope, element) {
			var textContaining = 0;
			var storedValue = '';

			scope.$watch('containingText', function(value) {
				if (!value) {
					value = '';
				}

				textContaining = value.length;
				scope.charactersLeft = (scope.charactersAllowed * 1) - textContaining;

				if(scope.charactersLeft > 20) {
					element.css('color', 'black');
				}
				else if (scope.charactersLeft <= 20 && scope.charactersLeft > 10) {
					element.css('color', '#DBAF00');
				}
				else if (scope.charactersLeft <= 10 && scope.charactersLeft > 0) {
					element.css('color', '#ED6300');
				}
				else if (scope.charactersLeft === 0) {
					element.css('color', '#CF0000');
				}

				if (scope.charactersLeft < 0) {
					if (storedValue.length === parseInt(scope.charactersAllowed)) {
						scope.containingText = storedValue;
					} else {
						scope.containingText = value.substring(0, (scope.charactersAllowed * 1));
					}
					if (scope.limitReached) {
						scope.limitReached();
					}
				}
				storedValue = scope.containingText;
			});
		}
	};
});
'use strict';

angular.module('goApp')
  .directive('closeOnClickOutside', ['$rootScope', '$document', function( $rootScope, $document ) {
    return {
      restrict: 'A',
      priority: 2,
      scope: {
        onClickOutside: '&',
        valueToChange: '=',
        excludedElements: '@' // allows prevent closing from clicking on some elements, e.g. popup. ]
                              // HTML Example: excluded-elements="['.ngdialog']"
      }, link : function( scope, $element, attrs ) {
        function close( event ) {
          var isElementClicked = $element.find(event.target).length > 0 || $element.is(event.target);

          if (isElementClicked || isExcludedClicked())
            return;


          // Call function if provided.
          if (scope.onClickOutside && typeof scope.onClickOutside() === 'function') {
            scope.onClickOutside()();
            $rootScope.$broadcast('drawerClosed');
          }

          // Switch boolean if provided.
          if (!angular.isUndefined(scope.valueToChange) && typeof scope.valueToChange === 'boolean') {
            scope.valueToChange = false;
            scope.$apply('scope.valueToChange');
          }
        }

        function isExcludedClicked() {
          var isClicked = false;
          var excludedElements = scope.$eval(scope.excludedElements);

          for (var i = 0, j = excludedElements.length; i < j; i++) {
            if (isExcludedClickedTest(excludedElements[i])) {
              isClicked = true;
              break;
            }
          }

          function isExcludedClickedTest( excludedEl ) {
            var $excludedEl = $(excludedEl);
            return $excludedEl.find(event.target).length > 0 || $excludedEl.is(event.target);
          }

          return isClicked;
        }

        $document.bind('click', close);

        scope.$on('$destroy', function() {
          $document.unbind('click', close);
        });
      }
    };
  }]);
'use strict';

angular
  .module("goApp")
  .component("countryCodeSelect",{
    template: '<select ng-options="x.name for x in $ctrl.countries" ng-model="myModel"></select>',
    bindings: { myModel:'='},
    controller: function () {

     this.countries = [
        {
            "name": "Afghanistan",
            "dialCode": "+93",
            "isoCode": "AF"
        },
        {
            "name": "Aland Islands",
            "dialCode": "+358",
            "isoCode": "AX"
        },
        {
            "name": "Albania",
            "dialCode": "+355",
            "isoCode": "AL"
        },
        {
            "name": "Algeria",
            "dialCode": "+213",
            "isoCode": "DZ"
        },
        {
            "name": "AmericanSamoa",
            "dialCode": "+1684",
            "isoCode": "AS"
        },
        {
            "name": "Andorra",
            "dialCode": "+376",
            "isoCode": "AD"
        },
        {
            "name": "Angola",
            "dialCode": "+244",
            "isoCode": "AO"
        },
        {
            "name": "Anguilla",
            "dialCode": "+1264",
            "isoCode": "AI"
        },
        {
            "name": "Antarctica",
            "dialCode": "+672",
            "isoCode": "AQ"
        },
        {
            "name": "Antigua and Barbuda",
            "dialCode": "+1268",
            "isoCode": "AG"
        },
        {
            "name": "Argentina",
            "dialCode": "+54",
            "isoCode": "AR"
        },
        {
            "name": "Armenia",
            "dialCode": "+374",
            "isoCode": "AM"
        },
        {
            "name": "Aruba",
            "dialCode": "+297",
            "isoCode": "AW"
        },
        {
            "name": "Ascension Island",
            "dialCode": "+247",
            "isoCode": "AC"
        },
        {
            "name": "Australia",
            "dialCode": "+61",
            "isoCode": "AU"
        },
        {
            "name": "Austria",
            "dialCode": "+43",
            "isoCode": "AT"
        },
        {
            "name": "Azerbaijan",
            "dialCode": "+994",
            "isoCode": "AZ"
        },
        {
            "name": "Bahamas",
            "dialCode": "+1242",
            "isoCode": "BS"
        },
        {
            "name": "Bahrain",
            "dialCode": "+973",
            "isoCode": "BH"
        },
        {
            "name": "Bangladesh",
            "dialCode": "+880",
            "isoCode": "BD"
        },
        {
            "name": "Barbados",
            "dialCode": "+1246",
            "isoCode": "BB"
        },
        {
            "name": "Belarus",
            "dialCode": "+375",
            "isoCode": "BY"
        },
        {
            "name": "Belgium",
            "dialCode": "+32",
            "isoCode": "BE"
        },
        {
            "name": "Belize",
            "dialCode": "+501",
            "isoCode": "BZ"
        },
        {
            "name": "Benin",
            "dialCode": "+229",
            "isoCode": "BJ"
        },
        {
            "name": "Bermuda",
            "dialCode": "+1441",
            "isoCode": "BM"
        },
        {
            "name": "Bhutan",
            "dialCode": "+975",
            "isoCode": "BT"
        },
        {
            "name": "Bolivia",
            "dialCode": "+591",
            "isoCode": "BO"
        },
        {
            "name": "Bosnia and Herzegovina",
            "dialCode": "+387",
            "isoCode": "BA"
        },
        {
            "name": "Botswana",
            "dialCode": "+267",
            "isoCode": "BW"
        },
        {
            "name": "Brazil",
            "dialCode": "+55",
            "isoCode": "BR"
        },
        {
            "name": "British Indian Ocean Territory",
            "dialCode": "+246",
            "isoCode": "IO"
        },
        {
            "name": "Brunei Darussalam",
            "dialCode": "+673",
            "isoCode": "BN"
        },
        {
            "name": "Bulgaria",
            "dialCode": "+359",
            "isoCode": "BG"
        },
        {
            "name": "Burkina Faso",
            "dialCode": "+226",
            "isoCode": "BF"
        },
        {
            "name": "Burundi",
            "dialCode": "+257",
            "isoCode": "BI"
        },
        {
            "name": "Cambodia",
            "dialCode": "+855",
            "isoCode": "KH"
        },
        {
            "name": "Cameroon",
            "dialCode": "+237",
            "isoCode": "CM"
        },
        {
            "name": "Canada",
            "dialCode": "+1",
            "isoCode": "CA"
        },
        {
            "name": "Cape Verde",
            "dialCode": "+238",
            "isoCode": "CV"
        },
        {
            "name": "Cayman Islands",
            "dialCode": "+1345",
            "isoCode": "KY"
        },
        {
            "name": "Central African Republic",
            "dialCode": "+236",
            "isoCode": "CF"
        },
        {
            "name": "Chad",
            "dialCode": "+235",
            "isoCode": "TD"
        },
        {
            "name": "Chile",
            "dialCode": "+56",
            "isoCode": "CL"
        },
        {
            "name": "China",
            "dialCode": "+86",
            "isoCode": "CN"
        },
        {
            "name": "Christmas Island",
            "dialCode": "+61",
            "isoCode": "CX"
        },
        {
            "name": "Cocos (Keeling) Islands",
            "dialCode": "+61",
            "isoCode": "CC"
        },
        {
            "name": "Colombia",
            "dialCode": "+57",
            "isoCode": "CO"
        },
        {
            "name": "Comoros",
            "dialCode": "+269",
            "isoCode": "KM"
        },
        {
            "name": "Congo",
            "dialCode": "+242",
            "isoCode": "CG"
        },
        {
            "name": "Cook Islands",
            "dialCode": "+682",
            "isoCode": "CK"
        },
        {
            "name": "Costa Rica",
            "dialCode": "+506",
            "isoCode": "CR"
        },
        {
            "name": "Croatia",
            "dialCode": "+385",
            "isoCode": "HR"
        },
        {
            "name": "Cuba",
            "dialCode": "+53",
            "isoCode": "CU"
        },
        {
            "name": "Cyprus",
            "dialCode": "+357",
            "isoCode": "CY"
        },
        {
            "name": "Czech Republic",
            "dialCode": "+420",
            "isoCode": "CZ"
        },
        {
            "name": "Democratic Republic of the Congo",
            "dialCode": "+243",
            "isoCode": "CD"
        },
        {
            "name": "Denmark",
            "dialCode": "+45",
            "isoCode": "DK"
        },
        {
            "name": "Djibouti",
            "dialCode": "+253",
            "isoCode": "DJ"
        },
        {
            "name": "Dominica",
            "dialCode": "+1767",
            "isoCode": "DM"
        },
        {
            "name": "Dominican Republic",
            "dialCode": "+1849",
            "isoCode": "DO"
        },
        {
            "name": "Ecuador",
            "dialCode": "+593",
            "isoCode": "EC"
        },
        {
            "name": "Egypt",
            "dialCode": "+20",
            "isoCode": "EG"
        },
        {
            "name": "El Salvador",
            "dialCode": "+503",
            "isoCode": "SV"
        },
        {
            "name": "Equatorial Guinea",
            "dialCode": "+240",
            "isoCode": "GQ"
        },
        {
            "name": "Eritrea",
            "dialCode": "+291",
            "isoCode": "ER"
        },
        {
            "name": "Estonia",
            "dialCode": "+372",
            "isoCode": "EE"
        },
        {
            "name": "Eswatini",
            "dialCode": "+268",
            "isoCode": "SZ"
        },
        {
            "name": "Ethiopia",
            "dialCode": "+251",
            "isoCode": "ET"
        },
        {
            "name": "Falkland Islands (Malvinas)",
            "dialCode": "+500",
            "isoCode": "FK"
        },
        {
            "name": "Faroe Islands",
            "dialCode": "+298",
            "isoCode": "FO"
        },
        {
            "name": "Fiji",
            "dialCode": "+679",
            "isoCode": "FJ"
        },
        {
            "name": "Finland",
            "dialCode": "+358",
            "isoCode": "FI"
        },
        {
            "name": "France",
            "dialCode": "+33",
            "isoCode": "FR"
        },
        {
            "name": "French Guiana",
            "dialCode": "+594",
            "isoCode": "GF"
        },
        {
            "name": "French Polynesia",
            "dialCode": "+689",
            "isoCode": "PF"
        },
        {
            "name": "Gabon",
            "dialCode": "+241",
            "isoCode": "GA"
        },
        {
            "name": "Gambia",
            "dialCode": "+220",
            "isoCode": "GM"
        },
        {
            "name": "Georgia",
            "dialCode": "+995",
            "isoCode": "GE"
        },
        {
            "name": "Germany",
            "dialCode": "+49",
            "isoCode": "DE"
        },
        {
            "name": "Ghana",
            "dialCode": "+233",
            "isoCode": "GH"
        },
        {
            "name": "Gibraltar",
            "dialCode": "+350",
            "isoCode": "GI"
        },
        {
            "name": "Greece",
            "dialCode": "+30",
            "isoCode": "GR"
        },
        {
            "name": "Greenland",
            "dialCode": "+299",
            "isoCode": "GL"
        },
        {
            "name": "Grenada",
            "dialCode": "+1473",
            "isoCode": "GD"
        },
        {
            "name": "Guadeloupe",
            "dialCode": "+590",
            "isoCode": "GP"
        },
        {
            "name": "Guam",
            "dialCode": "+1671",
            "isoCode": "GU"
        },
        {
            "name": "Guatemala",
            "dialCode": "+502",
            "isoCode": "GT"
        },
        {
            "name": "Guernsey",
            "dialCode": "+44",
            "isoCode": "GG"
        },
        {
            "name": "Guinea",
            "dialCode": "+224",
            "isoCode": "GN"
        },
        {
            "name": "Guinea-Bissau",
            "dialCode": "+245",
            "isoCode": "GW"
        },
        {
            "name": "Guyana",
            "dialCode": "+592",
            "isoCode": "GY"
        },
        {
            "name": "Haiti",
            "dialCode": "+509",
            "isoCode": "HT"
        },
        {
            "name": "Holy See (Vatican City State)",
            "dialCode": "+379",
            "isoCode": "VA"
        },
        {
            "name": "Honduras",
            "dialCode": "+504",
            "isoCode": "HN"
        },
        {
            "name": "Hong Kong",
            "dialCode": "+852",
            "isoCode": "HK"
        },
        {
            "name": "Hungary",
            "dialCode": "+36",
            "isoCode": "HU"
        },
        {
            "name": "Iceland",
            "dialCode": "+354",
            "isoCode": "IS"
        },
        {
            "name": "India",
            "dialCode": "+91",
            "isoCode": "IN"
        },
        {
            "name": "Indonesia",
            "dialCode": "+62",
            "isoCode": "ID"
        },
        {
            "name": "Iran",
            "dialCode": "+98",
            "isoCode": "IR"
        },
        {
            "name": "Iraq",
            "dialCode": "+964",
            "isoCode": "IQ"
        },
        {
            "name": "Ireland",
            "dialCode": "+353",
            "isoCode": "IE"
        },
        {
            "name": "Isle of Man",
            "dialCode": "+44",
            "isoCode": "IM"
        },
        {
            "name": "Israel",
            "dialCode": "+972",
            "isoCode": "IL"
        },
        {
            "name": "Italy",
            "dialCode": "+39",
            "isoCode": "IT"
        },
        {
            "name": "Ivory Coast / Cote d'Ivoire",
            "dialCode": "+225",
            "isoCode": "CI"
        },
        {
            "name": "Jamaica",
            "dialCode": "+1876",
            "isoCode": "JM"
        },
        {
            "name": "Japan",
            "dialCode": "+81",
            "isoCode": "JP"
        },
        {
            "name": "Jersey",
            "dialCode": "+44",
            "isoCode": "JE"
        },
        {
            "name": "Jordan",
            "dialCode": "+962",
            "isoCode": "JO"
        },
        {
            "name": "Kazakhstan",
            "dialCode": "+77",
            "isoCode": "KZ"
        },
        {
            "name": "Kenya",
            "dialCode": "+254",
            "isoCode": "KE"
        },
        {
            "name": "Kiribati",
            "dialCode": "+686",
            "isoCode": "KI"
        },
        {
            "name": "Korea, Democratic People's Republic of Korea",
            "dialCode": "+850",
            "isoCode": "KP"
        },
        {
            "name": "Korea, Republic of South Korea",
            "dialCode": "+82",
            "isoCode": "KR"
        },
        {
            "name": "Kosovo",
            "dialCode": "+383",
            "isoCode": "XK"
        },
        {
            "name": "Kuwait",
            "dialCode": "+965",
            "isoCode": "KW"
        },
        {
            "name": "Kyrgyzstan",
            "dialCode": "+996",
            "isoCode": "KG"
        },
        {
            "name": "Laos",
            "dialCode": "+856",
            "isoCode": "LA"
        },
        {
            "name": "Latvia",
            "dialCode": "+371",
            "isoCode": "LV"
        },
        {
            "name": "Lebanon",
            "dialCode": "+961",
            "isoCode": "LB"
        },
        {
            "name": "Lesotho",
            "dialCode": "+266",
            "isoCode": "LS"
        },
        {
            "name": "Liberia",
            "dialCode": "+231",
            "isoCode": "LR"
        },
        {
            "name": "Libya",
            "dialCode": "+218",
            "isoCode": "LY"
        },
        {
            "name": "Liechtenstein",
            "dialCode": "+423",
            "isoCode": "LI"
        },
        {
            "name": "Lithuania",
            "dialCode": "+370",
            "isoCode": "LT"
        },
        {
            "name": "Luxembourg",
            "dialCode": "+352",
            "isoCode": "LU"
        },
        {
            "name": "Macau",
            "dialCode": "+853",
            "isoCode": "MO"
        },
        {
            "name": "Madagascar",
            "dialCode": "+261",
            "isoCode": "MG"
        },
        {
            "name": "Malawi",
            "dialCode": "+265",
            "isoCode": "MW"
        },
        {
            "name": "Malaysia",
            "dialCode": "+60",
            "isoCode": "MY"
        },
        {
            "name": "Maldives",
            "dialCode": "+960",
            "isoCode": "MV"
        },
        {
            "name": "Mali",
            "dialCode": "+223",
            "isoCode": "ML"
        },
        {
            "name": "Malta",
            "dialCode": "+356",
            "isoCode": "MT"
        },
        {
            "name": "Marshall Islands",
            "dialCode": "+692",
            "isoCode": "MH"
        },
        {
            "name": "Martinique",
            "dialCode": "+596",
            "isoCode": "MQ"
        },
        {
            "name": "Mauritania",
            "dialCode": "+222",
            "isoCode": "MR"
        },
        {
            "name": "Mauritius",
            "dialCode": "+230",
            "isoCode": "MU"
        },
        {
            "name": "Mayotte",
            "dialCode": "+262",
            "isoCode": "YT"
        },
        {
            "name": "Mexico",
            "dialCode": "+52",
            "isoCode": "MX"
        },
        {
            "name": "Micronesia, Federated States of Micronesia",
            "dialCode": "+691",
            "isoCode": "FM"
        },
        {
            "name": "Moldova",
            "dialCode": "+373",
            "isoCode": "MD"
        },
        {
            "name": "Monaco",
            "dialCode": "+377",
            "isoCode": "MC"
        },
        {
            "name": "Mongolia",
            "dialCode": "+976",
            "isoCode": "MN"
        },
        {
            "name": "Montenegro",
            "dialCode": "+382",
            "isoCode": "ME"
        },
        {
            "name": "Montserrat",
            "dialCode": "+1664",
            "isoCode": "MS"
        },
        {
            "name": "Morocco",
            "dialCode": "+212",
            "isoCode": "MA"
        },
        {
            "name": "Mozambique",
            "dialCode": "+258",
            "isoCode": "MZ"
        },
        {
            "name": "Myanmar",
            "dialCode": "+95",
            "isoCode": "MM"
        },
        {
            "name": "Namibia",
            "dialCode": "+264",
            "isoCode": "NA"
        },
        {
            "name": "Nauru",
            "dialCode": "+674",
            "isoCode": "NR"
        },
        {
            "name": "Nepal",
            "dialCode": "+977",
            "isoCode": "NP"
        },
        {
            "name": "Netherlands",
            "dialCode": "+31",
            "isoCode": "NL"
        },
        {
            "name": "Netherlands Antilles",
            "dialCode": "+599",
            "isoCode": "AN"
        },
        {
            "name": "New Caledonia",
            "dialCode": "+687",
            "isoCode": "NC"
        },
        {
            "name": "New Zealand",
            "dialCode": "+64",
            "isoCode": "NZ"
        },
        {
            "name": "Nicaragua",
            "dialCode": "+505",
            "isoCode": "NI"
        },
        {
            "name": "Niger",
            "dialCode": "+227",
            "isoCode": "NE"
        },
        {
            "name": "Nigeria",
            "dialCode": "+234",
            "isoCode": "NG"
        },
        {
            "name": "Niue",
            "dialCode": "+683",
            "isoCode": "NU"
        },
        {
            "name": "Norfolk Island",
            "dialCode": "+672",
            "isoCode": "NF"
        },
        {
            "name": "North Macedonia",
            "dialCode": "+389",
            "isoCode": "MK"
        },
        {
            "name": "Northern Mariana Islands",
            "dialCode": "+1670",
            "isoCode": "MP"
        },
        {
            "name": "Norway",
            "dialCode": "+47",
            "isoCode": "NO"
        },
        {
            "name": "Oman",
            "dialCode": "+968",
            "isoCode": "OM"
        },
        {
            "name": "Pakistan",
            "dialCode": "+92",
            "isoCode": "PK"
        },
        {
            "name": "Palau",
            "dialCode": "+680",
            "isoCode": "PW"
        },
        {
            "name": "Palestine",
            "dialCode": "+970",
            "isoCode": "PS"
        },
        {
            "name": "Panama",
            "dialCode": "+507",
            "isoCode": "PA"
        },
        {
            "name": "Papua New Guinea",
            "dialCode": "+675",
            "isoCode": "PG"
        },
        {
            "name": "Paraguay",
            "dialCode": "+595",
            "isoCode": "PY"
        },
        {
            "name": "Peru",
            "dialCode": "+51",
            "isoCode": "PE"
        },
        {
            "name": "Philippines",
            "dialCode": "+63",
            "isoCode": "PH"
        },
        {
            "name": "Pitcairn",
            "dialCode": "+872",
            "isoCode": "PN"
        },
        {
            "name": "Poland",
            "dialCode": "+48",
            "isoCode": "PL"
        },
        {
            "name": "Portugal",
            "dialCode": "+351",
            "isoCode": "PT"
        },
        {
            "name": "Puerto Rico",
            "dialCode": "+1939",
            "isoCode": "PR"
        },
        {
            "name": "Qatar",
            "dialCode": "+974",
            "isoCode": "QA"
        },
        {
            "name": "Reunion",
            "dialCode": "+262",
            "isoCode": "RE"
        },
        {
            "name": "Romania",
            "dialCode": "+40",
            "isoCode": "RO"
        },
        {
            "name": "Russia",
            "dialCode": "+7",
            "isoCode": "RU"
        },
        {
            "name": "Rwanda",
            "dialCode": "+250",
            "isoCode": "RW"
        },
        {
            "name": "Saint Barthelemy",
            "dialCode": "+590",
            "isoCode": "BL"
        },
        {
            "name": "Saint Helena, Ascension and Tristan Da Cunha",
            "dialCode": "+290",
            "isoCode": "SH"
        },
        {
            "name": "Saint Kitts and Nevis",
            "dialCode": "+1869",
            "isoCode": "KN"
        },
        {
            "name": "Saint Lucia",
            "dialCode": "+1758",
            "isoCode": "LC"
        },
        {
            "name": "Saint Martin",
            "dialCode": "+590",
            "isoCode": "MF"
        },
        {
            "name": "Saint Pierre and Miquelon",
            "dialCode": "+508",
            "isoCode": "PM"
        },
        {
            "name": "Saint Vincent and the Grenadines",
            "dialCode": "+1784",
            "isoCode": "VC"
        },
        {
            "name": "Samoa",
            "dialCode": "+685",
            "isoCode": "WS"
        },
        {
            "name": "San Marino",
            "dialCode": "+378",
            "isoCode": "SM"
        },
        {
            "name": "Sao Tome and Principe",
            "dialCode": "+239",
            "isoCode": "ST"
        },
        {
            "name": "Saudi Arabia",
            "dialCode": "+966",
            "isoCode": "SA"
        },
        {
            "name": "Senegal",
            "dialCode": "+221",
            "isoCode": "SN"
        },
        {
            "name": "Serbia",
            "dialCode": "+381",
            "isoCode": "RS"
        },
        {
            "name": "Seychelles",
            "dialCode": "+248",
            "isoCode": "SC"
        },
        {
            "name": "Sierra Leone",
            "dialCode": "+232",
            "isoCode": "SL"
        },
        {
            "name": "Singapore",
            "dialCode": "+65",
            "isoCode": "SG"
        },
        {
            "name": "Sint Maarten",
            "dialCode": "+1721",
            "isoCode": "SX"
        },
        {
            "name": "Slovakia",
            "dialCode": "+421",
            "isoCode": "SK"
        },
        {
            "name": "Slovenia",
            "dialCode": "+386",
            "isoCode": "SI"
        },
        {
            "name": "Solomon Islands",
            "dialCode": "+677",
            "isoCode": "SB"
        },
        {
            "name": "Somalia",
            "dialCode": "+252",
            "isoCode": "SO"
        },
        {
            "name": "South Africa",
            "dialCode": "+27",
            "isoCode": "ZA"
        },
        {
            "name": "South Georgia and the South Sandwich Islands",
            "dialCode": "+500",
            "isoCode": "GS"
        },
        {
            "name": "South Sudan",
            "dialCode": "+211",
            "isoCode": "SS"
        },
        {
            "name": "Spain",
            "dialCode": "+34",
            "isoCode": "ES"
        },
        {
            "name": "Sri Lanka",
            "dialCode": "+94",
            "isoCode": "LK"
        },
        {
            "name": "Sudan",
            "dialCode": "+249",
            "isoCode": "SD"
        },
        {
            "name": "Suriname",
            "dialCode": "+597",
            "isoCode": "SR"
        },
        {
            "name": "Svalbard and Jan Mayen",
            "dialCode": "+47",
            "isoCode": "SJ"
        },
        {
            "name": "Sweden",
            "dialCode": "+46",
            "isoCode": "SE"
        },
        {
            "name": "Switzerland",
            "dialCode": "+41",
            "isoCode": "CH"
        },
        {
            "name": "Syrian Arab Republic",
            "dialCode": "+963",
            "isoCode": "SY"
        },
        {
            "name": "Taiwan",
            "dialCode": "+886",
            "isoCode": "TW"
        },
        {
            "name": "Tajikistan",
            "dialCode": "+992",
            "isoCode": "TJ"
        },
        {
            "name": "Tanzania, United Republic of Tanzania",
            "dialCode": "+255",
            "isoCode": "TZ"
        },
        {
            "name": "Thailand",
            "dialCode": "+66",
            "isoCode": "TH"
        },
        {
            "name": "Timor-Leste",
            "dialCode": "+670",
            "isoCode": "TL"
        },
        {
            "name": "Togo",
            "dialCode": "+228",
            "isoCode": "TG"
        },
        {
            "name": "Tokelau",
            "dialCode": "+690",
            "isoCode": "TK"
        },
        {
            "name": "Tonga",
            "dialCode": "+676",
            "isoCode": "TO"
        },
        {
            "name": "Trinidad and Tobago",
            "dialCode": "+1868",
            "isoCode": "TT"
        },
        {
            "name": "Tunisia",
            "dialCode": "+216",
            "isoCode": "TN"
        },
        {
            "name": "Turkey",
            "dialCode": "+90",
            "isoCode": "TR"
        },
        {
            "name": "Turkmenistan",
            "dialCode": "+993",
            "isoCode": "TM"
        },
        {
            "name": "Turks and Caicos Islands",
            "dialCode": "+1649",
            "isoCode": "TC"
        },
        {
            "name": "Tuvalu",
            "dialCode": "+688",
            "isoCode": "TV"
        },
        {
            "name": "Uganda",
            "dialCode": "+256",
            "isoCode": "UG"
        },
        {
            "name": "Ukraine",
            "dialCode": "+380",
            "isoCode": "UA"
        },
        {
            "name": "United Arab Emirates",
            "dialCode": "+971",
            "isoCode": "AE"
        },
        {
            "name": "United Kingdom",
            "dialCode": "+44",
            "isoCode": "GB"
        },
        {
            "name": "United States",
            "dialCode": "+1",
            "isoCode": "US"
        },
        {
            "name": "Uruguay",
            "dialCode": "+598",
            "isoCode": "UY"
        },
        {
            "name": "Uzbekistan",
            "dialCode": "+998",
            "isoCode": "UZ"
        },
        {
            "name": "Vanuatu",
            "dialCode": "+678",
            "isoCode": "VU"
        },
        {
            "name": "Venezuela, Bolivarian Republic of Venezuela",
            "dialCode": "+58",
            "isoCode": "VE"
        },
        {
            "name": "Vietnam",
            "dialCode": "+84",
            "isoCode": "VN"
        },
        {
            "name": "Virgin Islands, British",
            "dialCode": "+1284",
            "isoCode": "VG"
        },
        {
            "name": "Virgin Islands, U.S.",
            "dialCode": "+1340",
            "isoCode": "VI"
        },
        {
            "name": "Wallis and Futuna",
            "dialCode": "+681",
            "isoCode": "WF"
        },
        {
            "name": "Yemen",
            "dialCode": "+967",
            "isoCode": "YE"
        },
        {
            "name": "Zambia",
            "dialCode": "+260",
            "isoCode": "ZM"
        },
        {
            "name": "Zimbabwe",
            "dialCode": "+263",
            "isoCode": "ZW"
        }
    ]
    }
});

'use strict';

angular.module('goApp')
  .directive('goFadeInOut', ['hesTemplateService', function(hesTemplateService) {
    // Runs during compile
    return {
      scope: {
        sOptions: '=?',
        onSwitch: '='
      }, // {} = isolate, true = child, false/undefined = no change
      restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
      link: function($scope, $element, $attrs, controller) {
        $element.css('display', 'none');
        $scope.sOptions = angular.extend({}, {
          duration: 2,
          delay: 0,
          loop: true,
          opacity: 1
        }, $scope.sOptions);

        $scope.$watch('onSwitch', function(newVal, oldVal) {
          if ($scope.onSwitch) {
            $element.css('display', 'inline-block');
            TweenMax.to($element, $scope.sOptions.duration, {
              alpha: $scope.sOptions.opacity,
              repeatDelay: $scope.sOptions.duration,
              yoyo: true,
              repeat: 10
            });
          } else {
            TweenMax.killTweensOf($element);
            TweenMax.to($element, 0, {
              alpha: 0,
              onComplete: function() {
                $element.css('display', 'none');
              }
            });
          }
        });
      }
    };
  }]);
'use strict';

angular.module('goApp')
  .directive('growingInput', ['hesTemplateService', function(hesTemplateService) {
    // Runs during compile
    return {
      scope: {
        ngModel: '='
      }, // {} = isolate, true = child, false/undefined = no change
      restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
      link: function($scope, $element, $attrs, controller) {
        $element.addClass('growing-input');

        if (!!$attrs.minHeight) {
          $scope.min_height = $attrs.minHeight;
        } else {
          $scope.min_height = 34;
        }

        $scope.adjustHeight = function() {
          $element[0].style.height = "1px";
          $element[0].style.height = ($element[0].scrollHeight - $attrs.heightOffset)+"px";
          if ($element[0].scrollHeight - $attrs.heightOffset < $scope.min_height) {
            $element[0].style.height = $scope.min_height + "px";
          }
        };

        // Copy/Paste will catch this.
        $scope.$watch('ngModel', function(val1, val2) {
          $scope.adjustHeight();
        });

        // New line will catch this
        $element.keyup(function() {
          $scope.adjustHeight();
        });

        $scope.$on('$destroy', function() {
          $element.removeClass('growing-input');
        });
      }
    };
  }]);
'use strict';

angular.module('goApp').directive('hesAllowHyperlinks', function() {
  return {
    restrict: 'EA',
    template: '<span></span>',
    replace: true,
    scope: {
      text: '=',
    },
    compile: function() {
      return function (scope, element) {
        var whiteSpaceCheck = new RegExp(/\s/g);
        function makeHyperlink(textToSearch) {
          var index = textToSearch.indexOf('http://');
          var safeIndex = textToSearch.indexOf('https://');
          if ((safeIndex > -1 && safeIndex < index) || (index < 0 && safeIndex > -1)) {
            index = safeIndex;
          }
          if (index > -1) {
            //Grab the text before the hyperlink
            var before = textToSearch.substring(0, index);

            //Grab the text to change into a hyperlink
            var restOfText = textToSearch.substring(index);
            var count = 4;
            var link = 'http';
            var characterAt = restOfText.substring(count, count + 1);
            while (!whiteSpaceCheck.test(characterAt)) {
              count++;
              link = link.concat(characterAt);
              if (count !== restOfText.length) {
                characterAt = restOfText.substring(count, count + 1);
              } else {
                break;
              }
            }
            
            //Check for trailing commas and periods
            if (link.substring(link.length - 1) === '.' || link.substring(link.length - 1) === ',') {
              link = link.substring(0, link.length - 1);
              count--;
            }

            //Get the rest of the text
            var after = restOfText.substring(count);

            var combinedText = before + '<a class="external" target="_blank" href="' + link + '">' + link + '</a>';
            return [combinedText, after];
          }
          else {
            return [textToSearch, ''];
          }
        }

        //Search for hyperlinks
        var remainingText = scope.text;
        var htmlText = '';
        while (remainingText.length !== 0) {
          var hyperlinkValues = makeHyperlink(remainingText);
          remainingText = hyperlinkValues[1];
          htmlText = htmlText.concat(hyperlinkValues[0]);
        }
        $(element).html(htmlText);
      };
    }
  };
});
'use strict';

angular.module('goApp')

.factory('HesArray', function() {
	var arrayUtilities = {};

	// Index of an element.
	var index = function(elems, searchElement /*, fromIndex */ ) {
		if(elems === null) {
			throw new TypeError();
		}

		var t = Object(elems);
		var len = t.length >>> 0;

		if(len === 0) {
			return -1;
		}

		var n = 0;

		if(arguments.length > 2) {
			n = Number(arguments[2]);

		  	if(n !== n) {
				n = 0;
		  	}
		  	else if(n !== 0 && n !== Infinity && n !== -Infinity) {
				n = (n > 0 || -1) * Math.floor(Math.abs(n));
		  	}
		}

		if(n >= len) {
			return -1;
		}

		var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);

		for(; k < len; k++) {
			if(k in t && t[k] === searchElement) {
				return k;
		  	}
		}

		return -1;
	};

	// Returns the first element.
	arrayUtilities.first = function(elems) {
		return elems[0];
	};

	// Returns the last element.
	arrayUtilities.last = function(elems) {
		return elems.length !== 0 ? elems[elems.length - 1] : undefined;
	};

	// Returns elements that pass validation.
	arrayUtilities.select = function(elems, callback, inv) {
		var ret = [];
		var callbackVal;
		inv = !inv;

		for(var i = 0, length = elems.length; i < length; i++) {
			callbackVal = !callback(elems[i], i);

			if(inv !== callbackVal) {
				ret.push(elems[i]);
			}
		}

		return ret;
	};

	// Collects elements based on some type of validation.
	arrayUtilities.collect = function(elems, callback) {
		var len = elems.length;

		if(typeof callback !== 'function') {
			throw new TypeError();
		}

		var res = new Array(len);

		for(var i = 0; i < len; i++) {
			if(i in elems) {
				res[i] = callback(elems[i], i);
			}
		}

		return res;
	};

	// Returns the first element that matches.
	arrayUtilities.findBy = function(elems, property, value, transform) {
		return arrayUtilities.select(elems, function(el) {
			return (transform === null || transform === undefined ? el[property] : transform(el[property])) === value;
		})[0];
	};

	// Returns all elements that matches.
	arrayUtilities.findAllBy = function(elems, property, value, transform) {
		return arrayUtilities.select(elems, function(el) {
			return (transform === null || transform === undefined ? el[property] : transform(el[property])) === value;
		});
	};

	// Removes an element.
	arrayUtilities.remove = function(elems, itemToRemove, comparison) {
		var _index;
		_index = arrayUtilities.indexOf(elems, itemToRemove, comparison);

		if(_index !== -1) {
			elems.splice(_index, 1);
			return elems;
		}
		else {
			return elems;
		}
	};

	// Replaces an element with a new one.
	arrayUtilities.replace = function(elems, currentItem, updatedItem, comparison) {
		var _index;
		_index = arrayUtilities.indexOf(elems, currentItem, comparison);

		if(_index !== -1) {
			elems[_index] = updatedItem;
		}

		return elems;
	};

	// Returns whether or not an array includes a given element.
	arrayUtilities.includes = function(elems, value, comparisonFn) {
		if(!comparisonFn) {
			var i, j;
				if(typeof value !== 'object') {
					value = [value];
				}
			for(j = 0; j < value.length; j++) {
				for(i = 0; i < elems.length; i++) {
					if(elems[i] === value[j]) {
						return true;
					}
				}
			}

			return false;
		}
		else {
			return arrayUtilities.indexOf(elems, value, comparisonFn) !== -1;
		}
	};

	// Returns the index of an element.
	arrayUtilities.indexOf = function(elems, item, comparison) {
    	var comparisonArray;

    	if(comparison === undefined) {
      		return index(elems, item);
    	}
    	else {
      		comparisonArray = arrayUtilities.collect(elems, comparison);
      		return index(comparisonArray, comparison(item));
    	}
  	};

  	// Returns the unique values of an array.
  	arrayUtilities.uniq = function(elems, uniqFunction) {
	    var uniqValues = [];
	    var _i;
	    var _len;

	    for(_i = 0, _len = elems.length; _i < _len; _i += 1) {
	    	if(!uniqFunction) {
	        	if(!arrayUtilities.includes(uniqValues, elems[_i])) {
	          		uniqValues[uniqValues.length] = elems[_i];
	        	}
	      	}
	      	else {
	        	if(!arrayUtilities.includes(elems, uniqFunction(elems[_i]), uniqValues.collect(elems, uniqFunction))) {
	          		uniqValues[uniqValues.length] = elems[_i];
	        	}
	      	}
	    }

	    return uniqValues;
  	};

  	// Shuffles an array.
  	arrayUtilities.shuffle = function(o) {
    	for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x) {}
    	return o;
  	};

  	return arrayUtilities;
});
'use strict';

angular.module('goApp')
  .directive('hesCheckbox', ['$parse', '$timeout', function($parse, $timeout) {
    return {
      priority: -101,
      restrict: 'A',
      require: '?ngModel',
      link: function($scope, $element, $attrs, $ctrl) {
        $element.attr('tabindex', '0');

        var falseValue = $attrs.ngFalseValue;
        var trueValue = $attrs.ngTrueValue;

        if(!angular.isString(falseValue)) {
          falseValue = 0;
        }

        if(!angular.isString(trueValue)) {
          trueValue = 1;
        }

        if(typeof $attrs.inactive === 'undefined' || $attrs.inactive === 'false') {
          $element.bind('click', function() {
            if($attrs.inactive !== 'true') {
              $element.toggleClass('checked');
              $element.attr('aria-checked', $element.hasClass('checked'));
              $scope.$apply(function() {
                $ctrl.$setViewValue($element.hasClass('checked'));
              });

              if(typeof $attrs.ngChange !== 'undefined') {
                $parse($attrs.ngChange)();
              }
            }
          });
        }

        // Spacebar.
        $element.bind("keydown", function(e) {
          if(e.keyCode == 32) {
            e.preventDefault();
            $element.click();
          }
        });

        if($attrs.labelName) {
          $timeout(function() {
            $("[name='" + $attrs.labelName + "']").bind('click', function(e) {
              if(e.target.tagName === 'A'){
                return;
              }
              $element.click();
            });

          }, 0);
        }

        $ctrl.$render = function() {
          if($ctrl.$viewValue) {
            $element.addClass('checked');
          }
          else {
            $element.removeClass('checked');
          }
        };

        $ctrl.$formatters.push(function(value) {
          return value == trueValue;
        });

        $ctrl.$parsers.push(function(value) {
          return value ? trueValue : falseValue;
        });
      }
    };
  }]);

'use strict';

angular.module('hes').factory('HesDate', ['$filter',
  function($filter) {

    var dateUtilities = {};
    var _MS_PER_DAY = 1000 * 60 * 60 * 24;

    dateUtilities.addDays = function(date, numberOfDays) {
      date.setDate(date.getDate() + parseInt(numberOfDays));
      return new Date(date);
    };

    dateUtilities.getDifferenceInDays = function(date1, date2) {
      // Discard the time and time-zone information.
      var utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
      var utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

      return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    };

    dateUtilities.toString = function(date, format) {
      return $filter('date')(date, format);
    };

    dateUtilities.momentFormat = function(date, format) {
      return moment(date).format(format);
    };

    dateUtilities.convert = function(d) {
      // Converts the date in d to a date-object. The input can be:
      //   a date object: returned without modification
      //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
      //   a number     : Interpreted as number of milliseconds
      //                  since 1 Jan 1970 (a timestamp)
      //   a string     : Any format supported by the javascript engine, like
      //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
      //  an object     : Interpreted as an object with year, month and date
      //                  attributes.  **NOTE** month is 0-11.

      return (
        d.constructor === Date ? d :
        d.constructor === Array ? new Date(d[0], d[1], d[2]) :
        d.constructor === Number ? new Date(d) :
        d.constructor === String ? this.parse(d) :
        typeof d === 'object' ? new Date(d.year, d.month, d.date) :
        NaN
      );
    };

    dateUtilities.compare = function(a, b) {
      // Compare two dates (could be of any type supported by the convert
      // function above) and returns:
      //  -1 : if a < b
      //   0 : if a = b
      //   1 : if a > b
      // NaN : if a or b is an illegal date
      // NOTE: The code inside isFinite does an assignment (=).
      return (
        isFinite(a = this.convert(a).valueOf()) &&
        isFinite(b = this.convert(b).valueOf()) ?
        (a > b) - (a < b) :
        NaN
      );
    };

    dateUtilities.inRange = function(d, start, end) {
      // Checks if date in d is between dates in start and end.
      // Returns a boolean or NaN:
      //    true  : if d is between start and end (inclusive)
      //    false : if d is before start or after end
      //    NaN   : if one or more of the dates is illegal.
      // NOTE: The code inside isFinite does an assignment (=).
      return (
        isFinite(d = this.convert(d).valueOf()) &&
        isFinite(start = this.convert(start).valueOf()) &&
        isFinite(end = this.convert(end).valueOf()) ?
        start <= d && d <= end :
        NaN
      );
    };

    dateUtilities.parse = function(dateString) {
      if (!dateString) {
        return null;
      }

      if (typeof dateString === 'string') {
        if (dateString.split('-').length === 3) {
          var dateParts = dateString.split('-');
          return new Date(dateParts[0], dateParts[1] * 1 - 1, dateParts[2]);
        }
      } else {
        return new Date(dateString);
      }
    };

    dateUtilities.getMidnightToday = function() {
      var date = new Date();

      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);

      return date;
    };

    dateUtilities.setCurrentDate = function(date) {
      dateUtilities._currentDate = date;
    };

    dateUtilities.getCurrentDate = function() {
      return dateUtilities._currentDate || dateUtilities.getMidnightToday();
    };

    dateUtilities.getSelectableYears = function() {
      if (!dateUtilities.availableYears) {
        var currentYear = new Date().getFullYear();
        dateUtilities.availableYears = [];
        for (var y = currentYear - 13; y > (currentYear - 120); y--) {
          dateUtilities.availableYears.push({
            year: y,
            value: y
          });
        }
      }
      return dateUtilities.availableYears;
    };

    return dateUtilities;
  }
]);
'use strict';

angular.module('goApp')
  .directive('hesDateSelect', ['hesTemplateService', 'HesDate',
    function(hesTemplateService, HesDate) {
      // Runs during compile
      return {
        scope: {
          dateFormat: '=',
          minDate: '=?'
        }, // {} = isolate, true = child, false/undefined = no change
        require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
        restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
        link: function($scope, $element, $attrs, ngModel) {
          $scope.settingDate = false;
          var picker;
          var options = {
            firstDay: 0,
            field: $element[0],
            bound: true,
            format: $scope.dateFormat,
            minDate: $scope.minDate,
            defaultDate: new Date()
          };

          picker = new Pikaday(options);

          ngModel.$render = function() {
            var date = ngModel.$modelValue;
            var mDate = angular.isDate(date) ? moment(date) : moment(date, [$scope.dateFormat, 'YYYY-MM-DD']);
            if (mDate.isValid()) {
              picker.setDate(mDate.format($scope.dateFormat));
            } else {
              picker.setDate(date);
            }

          };

          $scope.$watch($attrs.ngModel, function() {
            ngModel.$render();
          }, true);

          if ($element.is('input')) {
            ngModel.$parsers.unshift(function() {
              var date = picker.toString();
              return date;
            });
          }

          $scope.$on('$destroy', function() {
            picker.destroy();
            picker = null;
            options = null;
          });
        }
      };
    }
  ]);
'use strict';

angular.module('goApp')
  .directive('hesImage', ['hesTemplateService', 'DOMAIN', '$location', 'hesImageService',
    function(hesTemplateService, DOMAIN, $location, hesImageService) {
      // Runs during compile
      return {
        restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment

        link: function($scope, $element, $attrs) {
          $scope.defaultImages = {
            user: 'users/default.png',
            event: 'default-event.png',
            challengers: 'challengers-1.png',
            resource: 'resources/default.png',
            regionBanner: '/banners/banner-region.png',
            promotionLogo: '/promotions/default.png',
            mobileResponsiveOverlay: '/mobile/overlay-image.png'
          };

          $scope.usingHover = false;
          $element.addClass($attrs.imageClass);

          function setHoverImage() {
            var applyTheme = true;
            if ($attrs.noHover == 'true') {
              return;
            }

            var useDomain = false;
            if ($attrs.hasOwnProperty('useDomain') && $attrs.useDomain === 'true') {
              useDomain = true;
            }
            
            if ($attrs.hoverImageUrl) {
              if ($attrs.hesImage.indexOf("simple_uploads/") !== -1) {
                useDomain = true;
                applyTheme = false;
              }
              if ($attrs.hoverImageUrl !== '') {
                $scope.hoverImageUrl = (useDomain ? DOMAIN : '') + $attrs.hoverImageUrl;
              }
              if ($scope.hoverImageUrl.indexOf('https') === -1) {
                $scope.hoverImageUrl = $scope.hoverImageUrl.replace('http', $location.protocol());
              }
              if (applyTheme && !("noTheme" in $attrs) && $scope.hoverImageUrl.indexOf('http') === -1) {
                $scope.hoverImageUrl = hesImageService.getImagePath($scope.hoverImageUrl);
              }

              $attrs.$set('src', $scope.hoverImageUrl);
            }
          }

          function setImageUrl() {
            var useDomain = false;
            var applyTheme = !("noTheme" in $attrs);
            $scope.imageUrl = "";

            if ($attrs.hasOwnProperty('useDomain') && $attrs.useDomain === 'true' && $attrs.hesImage.indexOf('http') === -1) {
              useDomain = true;
            }

            if ($attrs.hasOwnProperty('isResource')) {
              $scope.imageUrl = $scope.defaultImages.resource;
            }

            if ($attrs.hasOwnProperty('isPromotionLogo')) {
              $scope.imageUrl = hesImageService.getImagePath($scope.defaultImages.promotionLogo);
              if ('/images/promotions/default.png' == $attrs.hesImage) {
                $attrs.hesImage = $scope.imageUrl;
                useDomain = false;
                applyTheme = false;
              }
            }
                     
            if ($attrs.hasOwnProperty('isMobileAppOverlay')) {
              $scope.imageUrl = hesImageService.getImagePath($scope.defaultImages.mobileResponsiveOverlay);
              if ('/mobile/overlay-image.png' == $attrs.hesImage) {
                $attrs.hesImage = $scope.imageUrl;
                useDomain = false;
                applyTheme = false;
              }
            }

            // This is necessary for the temporary state when a user uploads an image but has not saved it
            if ($attrs.hasOwnProperty('isTeam')) {
              $scope.imageUrl = hesImageService.getImagePath($scope.defaultImages.team);

              if ('/images/team/default.png' == $attrs.hesImage) {
                $attrs.hesImage = $scope.imageUrl;
                useDomain = false;
                applyTheme = false;
              }
            }

            if ($attrs.hasOwnProperty('isUser')) {
              $scope.imageUrl = hesImageService.getImagePath($scope.defaultImages.user);
            
              if ('/images/users/default.png' == $attrs.hesImage) {
                $attrs.hesImage = $scope.imageUrl;
                useDomain = false;
                applyTheme = false;
              }
            }


            if ($attrs.hesImage.indexOf("simple_uploads/") !== -1) {
              useDomain = true;
              applyTheme = false;
            }

            if ($attrs.hesImage !== '') {
              $scope.imageUrl = (useDomain ? DOMAIN : '') + $attrs.hesImage;
            }
            if ($scope.imageUrl.indexOf('https') === -1) {
              $scope.imageUrl = $scope.imageUrl.replace('http', $location.protocol());
            }
            if (applyTheme && $scope.imageUrl.indexOf('http') === -1) {
              $scope.imageUrl = hesImageService.getImagePath($scope.imageUrl);
            }

            $attrs.$set('src', $scope.imageUrl);
          }

          if ($attrs.hasOwnProperty('hoverImageUrl')) {
            var elm = $element;
            if ($attrs.hasOwnProperty('watchParent')) {
              elm = $element.closest($attrs.watchParent);
            }
            elm.on('mouseenter', function() {
              setHoverImage();
            });
            elm.on('mouseleave', function() {
              setImageUrl();
            });
          }

          setImageUrl();
          $attrs.$observe('hesImage', setImageUrl, true);
          $attrs.$observe('useDomain', setImageUrl);
        }
      };
    }
  ]);
'use strict';

angular.module('goApp')
  .directive('hesPopover', ['$compile', '$templateCache', '$http',
    function($compile, $templateCache, $http) {
      return {
        transclude: true,
        priority: -100,
        restrict: 'EA', // E = Element, A = Attribute, C = Class, M = Comment
        scope: {},
        compile: function($element, $attrs, $transclude) {
          return function postLink($scope, $element, $attrs) {
            var openTip, content, openTipOptions;
            var newParentScope = $scope.$parent.$new();


            openTipOptions = {
              target: $element,
              showOn: $attrs.event || 'mouseover focus',
              hideOn: $attrs.hideEvent || 'mouseout focusout',
              className: $attrs.popoverClass || 'hes-popover-style no-print',
              background: $attrs.backgroundColor || '#FFFFFF',
              borderColor: $attrs.borderColor || '#363636',
              borderRadius: 4,
              fixed: true,
              hideTriggers: ($attrs.hideTrigger ? $attrs.hideTrigger.split(',') : ['trigger', 'tip']),
              hideDelay: 0.3,
              group: $attrs.group || null,
              targetJoint: $attrs.targetJoint || 'top',
              tipJoint: $attrs.tipJoint || 'bottom'
            };

            if ($attrs.setZIndex) {
              Opentip.lastZIndex = $attrs.setZIndex * 1;
            }

            openTip = new Opentip($element, openTipOptions || {});

            $transclude(newParentScope, function(clone) {
              content = clone;
            });

            if (typeof $attrs.content !== 'undefined') {
              $scope.$watch(function() {
                return $element.attr('content');
              }, function(value) {
                openTip.setContent(value);
              });

              $element.append(content);
            } else if (typeof $attrs.htmlContent !== 'undefined'){
              $scope.$watch(function() {
                return $attrs.htmlContent;
              }, function(value) {
                var htmlContent = $compile(value)(newParentScope);
                openTip.setContent(htmlContent);
              });

              $element.append(content);
            } else if (typeof $attrs.template !== 'undefined') {
              $attrs.$observe('template', function(value) {
                $http.get(value, {
                  cache: $templateCache
                }).then(function(template) {
                  openTip.setContent($compile(template.data)(newParentScope));
                });
              });

              $element.append(content);
            } else {
              openTip.setContent(content);
            }
            if (typeof $attrs.customShow !== 'undefined') {
              $scope.$watch(function() {
                return $element.attr('custom-show');
              }, function(value) {
                if (value === 'true' && $element.css('visibility') != 'hidden') {
                  openTip.show();
                } else {
                  openTip.hide();
                }
              });
            }

            if (typeof $attrs.levitate !== 'undefined') {
              $scope.$watch(function() {
                return openTip.visible;
              }, function(value) {
                if (value === true) {
                  if ($attrs.levitate.indexOf('up') > -1) {
                    new TweenMax.to('#opentip-' + openTip.id, 1, {marginTop: '+=-15px', ease: 'Power1.easeInOut', yoyo: true, repeat: -1});
                  }
                  if ($attrs.levitate.indexOf('down') > -1) {
                    new TweenMax.to('#opentip-' + openTip.id, 1, {marginTop: '+=15px', ease: 'Power1.easeInOut', yoyo: true, repeat: -1});
                  }
                  if ($attrs.levitate.indexOf('left') > -1) {
                    new TweenMax.to('#opentip-' + openTip.id, 1, {marginLeft: '+=-15px', ease: 'Power1.easeInOut', yoyo: true, repeat: -1});
                  }
                  if ($attrs.levitate.indexOf('right') > -1) {
                    new TweenMax.to('#opentip-' + openTip.id, 1, {marginLeft: '+=15px', ease: 'Power1.easeInOut', yoyo: true, repeat: -1});
                  }
                }
                else {
                  TweenMax.killTweensOf('#opentip-' + openTip.id);
                }
              });
            }

            $element.click(function() {
              $element.toggleClass('active');
            });

            $scope.$on('$destroy', function() {
              newParentScope.$destroy();
              newParentScope = null;

              var allElms = openTip.triggerElement.find('*');
              allElms.unbind();
              allElms.off();
              if (openTip.container) {
                openTip.container.remove();
              }
              openTip.hide();
              openTip.triggerElement.remove();
              openTip = null;
              allElms = null;

              content.off();
              content.unbind();
              content.remove();
              content = null;

              $element.off();
              $element.unbind();
              Opentip.tips = [];

            });

          };
        }
      };
    }
  ]);
'use strict';

angular.module('goApp')

  .directive('hesValidator', ['hesTemplateService', '$compile', '$timeout',
    function(hesTemplateService, $compile, $timeout) {
      // Runs during compile
      return {
        controller: 'HesRequiredController',
        restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
        link: function($scope, $element, $attrs, controller) {

          function isElementInViewport(el) {

            //special bonus for those using jQuery
            if (typeof jQuery === "function" && el instanceof jQuery) {
              el = el[0];
            }

            var rect = el.getBoundingClientRect();
            var footer = $('.footer')[0].getBoundingClientRect();

            return (
              rect.top >= 0 &&
              rect.left >= 0 &&
              rect.bottom <= ($(window).height()) &&
              rect.right <= $(window).width() &&
              rect.bottom <= footer.top
            );
          }

          $timeout(function() {
            $scope.allFormElements = $element.find('input, select, textarea, button, .hes-checkbox, #text-angular-required');
            $scope.onElementNum = 0;
            $scope.allFormElements[$scope.onElementNum].focus();
            $('input, select, .hes-checkbox').keypress(function(e) {
              if (e.keyCode === 13) {
                if ($scope.onElementNum >= $scope.allFormElements.length) {
                  $scope.onElementNum = 0;
                }
                $scope.allFormElements[$scope.onElementNum + 1].focus();
                // $scope.onElementNum++;
              }
            });
            $('input, select, button, textarea, .hes-checkbox, button, #text-angular-required').on("focus", function(el) {
              if ($scope.allFormElements.index(el.currentTarget) > -1) {
                $scope.onElementNum = $scope.allFormElements.index(el.currentTarget);
                if (!isElementInViewport(el.currentTarget)) {
                  var target = $("#" + el.currentTarget.id);
                  if (target && target.offset()) {
                    $('html, body').animate({
                      scrollTop: target.offset().top - 100
                    }, 500);
                  }
                }
              }
            });
          }, 10);

          $element.after($compile(angular.element('<span class="hes-invalid-msg" ng-show="showInvalid">* Required Fields</span>'))($scope));
        }
      };
    }
  ])
  .directive('hesRequired', ['hesTemplateService', '$compile',
    function(hesTemplateService, $compile) {
      // Runs during compile
      return {
        scope: true, // {} = isolate, true = child, false/undefined = no change
        require: ['ngModel', '^hesValidator' /*, hesRequired'*/ ], // Array = multiple requires, ? = optional, ^ = check parent elements
        restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
        link: function($scope, $element, $attrs, controller) {
          var ngModelCtrl = controller[0];
          var hesRequiredCtrl = controller[1];
          $scope.showInvalid = false;

          var requiredElm = $element;

          if (!$element.is(hesRequiredCtrl.requireableElements)) {
            requiredElm = $($element.find(hesRequiredCtrl.requireableElements)[0]);
          }
          var invalidElement = $compile(angular.element('<span id="' + requiredElm.attr('id') + '-invalid" ng-show="showInvalid">*</span>'))($scope);
          invalidElement.addClass('hes-invalid');
          invalidElement.addClass(requiredElm.attr('type'));
          invalidElement.addClass(requiredElm.prop('nodeName').toLowerCase());
          // invalidElement.addClass($element[0].type);
          requiredElm.after(invalidElement);

          hesRequiredCtrl.registerElement($attrs.id || requiredElm.attr('id'));

          $scope.checkValidity = function() {
            $scope.showInvalid = false;
            // var requiredElm = $element;
            if (!$element.is(hesRequiredCtrl.requireableElements)) {
              requiredElm = $($element.find(hesRequiredCtrl.requireableElements)[0]);
            }

            requiredElm.removeClass('invalid');
            var isValid = ngModelCtrl.$modelValue !== undefined && ngModelCtrl.$modelValue !== '' && ngModelCtrl.$modelValue !== null;

            if ($element.hasClass('hes-checkbox')) {
              isValid = !!ngModelCtrl.$modelValue && ngModelCtrl.$modelValue != 0
            }
            if (!isValid) {
              hesRequiredCtrl.setElement(requiredElm.attr('id'), false);

              if (hesRequiredCtrl.getShowInvalid()) {
                //Show astrix
                $scope.showInvalid = true;
                requiredElm.addClass('invalid');
              }
            } else {
              hesRequiredCtrl.setElement(requiredElm.attr('id'), true);
            }
          };

          $scope.$watch(hesRequiredCtrl.getShowInvalid, function() {
            if (hesRequiredCtrl.getShowInvalid()) {
              $scope.checkValidity();
            }
          });

          $scope.$watch(function() {
            return ngModelCtrl.$modelValue;
          }, $scope.checkValidity);

          $scope.$on('$destroy', function() {
            hesRequiredCtrl.unregisterElement(requiredElm.attr('id'));
            hesRequiredCtrl = null;
            invalidElement = null;
          });
        }
      };
    }
  ])
  .directive('hesValidateClick', ['hesTemplateService',
    function(hesTemplateService) {
      // Runs during compile
      return {
        scope: {
          hesValidateClick: '&'
        }, // {} = isolate, true = child, false/undefined = no change
        require: ['^hesValidator'], // Array = multiple requires, ? = optional, ^ = check parent elements
        restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
        link: function($scope, $element, $attrs, controller) {
          $element.bind('click', function() {
            if (controller[0].isValid()) {
              controller[0].setShowInvalid(false);
              $scope.hesValidateClick();
            } else {
              controller[0].setShowInvalid(true);
            }
            $scope.$apply();
          });
          // $element.bind('keypress', function(e) {
          //   if (e.keyCode === 13) {
          //     if (controller[0].isValid()) {
          //       controller[0].setShowInvalid(false);
          //       $scope.hesValidateClick();
          //     } else {
          //       controller[0].setShowInvalid(true);
          //     }
          //     $scope.$apply();
          //   }
          // });
        }
      };
    }
  ])
  .controller('HesRequiredController', ['$scope',
    function($scope) {
      this.requiredElements = {};
      $scope.showInvalid = false;

      this.requireableElements = 'input, select, button, textarea, .hes-checkbox, #text-angular-required';

      this.getShowInvalid = function() {
        return $scope.showInvalid;
      };

      this.setShowInvalid = function(valid) {
        $scope.showInvalid = valid;
      };

      this.registerElement = function(id) {
        this.requiredElements[id] = {
          isValid: true
        };
      };

      this.unregisterElement = function(id) {
        this.requiredElements[id] = null;
      };

      this.setElement = function(id, isValid) {
        this.requiredElements[id].isValid = isValid;
      };

      this.isValid = function() {
        var valid = true;
        angular.forEach(this.requiredElements, function(element) {
          if (element !== null && !element.isValid) {
            $scope.showInvalid = true;
            valid = false;
          }
        });

        return valid;
      };

      $scope.isValid = this.isValid;
    }
  ]);
"use strict";

angular.module('goApp')
  .factory('hesEventHandlerService', function () {
    function EventHandler() {
      this.handlers = [];
    }

    EventHandler.prototype = {
      subscribe: function(scope, handler) {
        this.handlers.push(handler);
        var that = this;
        var off = function () {
          var i = that.handlers.indexOf(handler);
          if (i > -1) that.handlers.splice(i, 1);
        };
        if(!!scope) {
          scope.$on('$destroy', off);
        }
        return off;
      },
      invoke: function () {
        var handlers = this.handlers.concat([]);
        for(var i = 0; i < handlers.length; ++i) {
          handlers[i].apply(this, arguments);
        }
      },
      count: function() {
        return this.handlers.length;
      }
    };

    return EventHandler;
  });

'use strict';

angular.module('goApp')
  .factory('hesEventHandlerCollection', function () {
  function EventHandlerCollection() {
    this.handlers = [];
  }

  EventHandlerCollection.prototype = {
    subscribe: function(scope, handler) {
      this.handlers.push(handler);
      var that = this;
      var off = function () {
        var i = that.handlers.indexOf(handler);
        if (i > -1) that.handlers.splice(i, 1);
      };
      if(!!scope) {
        scope.$on('$destroy', off);
      }
      return off;
    },
    invoke: function () {
      var handlers = this.handlers.concat([]);
      for(var i = 0; i < handlers.length; ++i) {
        handlers[i].apply(this, arguments);
      }
    },
    count: function() {
      return this.handlers.length;
    }
  };
    
  return EventHandlerCollection;
});

'use strict';

angular.module('goApp')
  .directive('hesExternalLinks', ['hesTemplateService', '$timeout', function(hesTemplateService, $timeout) {
    // Runs during compile
    return {
      // name: '',
      priority: 999,
      // terminal: true,
      // scope: {}, // {} = isolate, true = child, false/undefined = no change
      // controller: function(\, \, \, \) {},
      // require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
      restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
      // template: hesTemplateService.getTemplate(''),
      // replace: true,
      // transclude: true,
      // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
      link: function($scope, $element, $attrs, controller) {
        function postDigest(callback) {
          var unregister = $scope.$watch(function() {
            unregister();
            $timeout(function() {
              callback();
              postDigest(callback);
            }, 0, false);
          });
        }

        postDigest(function() {
          $element.find("a[href^='http']").attr('target', '_blank');
        });
      }
    };
  }]);
'use strict';

angular.module('goApp')
  .directive('hesImgCropper', ['hesTemplateService', '$http', '$state', 'DOMAIN',
    function(hesTemplateService, $http, $state, DOMAIN) {
      return {
        restrict: 'A',
        replace: true,
        templateUrl: hesTemplateService.getTemplateUrl('/scripts/hes/hesImgCropper.html'),
        scope: {
          ngModel: '=',
          thumbnailUrl: '=',
          selected: '&',
          aspectRatio: '@',
          onCrop: '&',
          uncroppedPhoto: '=',
          options: '=',
          cropStyle: '=?',
          blurUrl: '=?',
          previewSize: '@',
          onCancel: '&',
          cropping: '=?',
          saveButtonLabel: '@'
        },
        require: '?ngModel',
        link: function($scope, element, $attrs) {
          var clear;
          var cropUrl;
          var myImg;

          $scope.hasBeenCropped = false;
          $scope.cropping = false;
          $scope.uncroppedPhoto = false;
          cropUrl = DOMAIN + '/files/crop';

          clear = function() {
            if (myImg) {
              var afterImg = myImg.next();
              if (afterImg.attr('type') !== 'button' && afterImg.children().attr('type') !== 'button') {
                afterImg.remove();
              }
              myImg.remove();
              element.find('button').hide();
              myImg = undefined;
            }
          };
          $scope.coordinates = {};
          $scope.cropStyle = $scope.cropStyle || 'rect';
          $scope.loading = $scope.uploadingPhoto;

          $scope.$watch('ngModel', function(nv) {
            if ($scope.hasBeenCropped) {
              $scope.onCrop();
              $scope.hasBeenCropped = false;
              clear();
            } else {
              clear();
              if (nv) {
                myImg = $('<img/>').attr('src', DOMAIN + nv).prependTo(element);
                element.find('button').show();
                $('#profile_pic_preview').attr('src', DOMAIN + nv);
                $('.profile-photo-preview').attr('src', DOMAIN + nv);
                $(myImg).Jcrop(angular.extend({
                  trackDocument: true,
                  aspectRatio: $scope.aspectRatio,
                  onChange: $scope.showPreview,
                  setSelect: [0, 0, 100000, 100000],
                  onSelect: function(x) {
                    $scope.showPreview(x);
                    $scope.$apply(function() {
                      $scope['selected']({
                        cords: x
                      });
                      $scope.coordinates = x;
                    });
                  }
                }, $scope.options));
              }
              $scope.loading = false;
            }
          }, true);

          $scope.showPreview = function(coords) {
            $scope.uncroppedPhoto = true;
            if (!$scope.previewSize) {
              $scope.previewSize = 100;
            }
            var rx = $scope.previewSize / coords.w;
            var ry = $scope.previewSize / coords.h;

            var rx2 = ($scope.previewSize * 1.5) / coords.w;
            var ry2 = ($scope.previewSize * 1.5) / coords.h;

            var loadedImg = $('.jcrop-holder img')[0];
            var darkerImg = $('.jcrop-holder img')[1];
            darkerImg.style.cssText = darkerImg.style.cssText + ' opacity:0.4;';


            var naturalImg = new Image();
            naturalImg.src = loadedImg.src;
            if ($scope.cropStyle === 'circle') {
              var grandchild = $($($('.jcrop-holder').find('div')[0]).find('div')[0]);
              grandchild.addClass('pic-round');
            }
            var child = $($('.jcrop-holder').find('div')[0]);
            child.addClass('border-default');
            var parent = $('.jcrop-holder')[0];
            parent.style.cssText = parent.style.cssText + ' margin:0 auto;';

            if ($scope.cropStyle === 'circle') {

              $('#profile_pic_preview').css({
                width: Math.round(rx * naturalImg.width) + 'px',
                height: Math.round(ry * naturalImg.height) + 'px',
                marginLeft: '-' + Math.round(rx * coords.x) + 'px',
                marginTop: '-' + Math.round(ry * coords.y) + 'px'
              });

              $('.profile-photo-preview').css({
                width: Math.round(rx2 * naturalImg.width) + 'px',
                height: Math.round(ry2 * naturalImg.height) + 'px',
                marginLeft: '-' + Math.round(rx2 * coords.x) + 'px',
                marginTop: '-' + Math.round(ry2 * coords.y) + 'px'
              });
            }
            loadedImg = null;
            naturalImg = null;
          };

          $scope.doCancel = function() {
            $scope.onCancel();
          };

          $scope.showCancel = function() {
            return $attrs.onCancel;
          };

          $scope.cropPhoto = function() {
            $scope.uncroppedPhoto = false;
            element.css({
              position: 'relative'
            });
            $('.jcrop-holder').hide();
            $scope.cropping = true;

            $http.put(cropUrl, {
              image: $scope.ngModel,
              crop: $scope.coordinates,
              type: $scope.cropStyle
            }).then(function(response) {
              $scope.cropping = false;
              $scope.hasBeenCropped = true;
              $scope.thumbnailUrl = response.data.thumbnail_url;
              $scope.ngModel = response.data.url;
              $scope.blurUrl = response.data.blur_url;

              element.css({
                position: ''
              });
            }).catch(function(err) {
              console.log(err);
              $scope.cropping = false;
              $scope.hasBeenCropped = false;
              $scope.thumbnailUrl = null;
              $scope.ngModel = null;
              $scope.blurUrl = null;

              element.css({
                position: ''
              });
            });

          };

          $scope.$on('$destroy', clear);
        }
      };
    }
  ]);
'use strict';

angular.module('goApp')
  .service('hesLocalStorageCollectionService', function( hesLocalStorageCollection ) {
    var collections = {};

    this.getCollection = function(options) {
      if (!options || !options.name) {
        console.error('Attempt of creating LocalStorageCollection instance with empty args');
        return;
      }

      if (!collections[options.name]) {
        collections[options.name] = new hesLocalStorageCollection(options);
      }

      return collections[options.name];
    }

  })
  .factory('hesLocalStorageCollection', function( hesEventHandlerService ) {
    function LSCollection( options ) {
      if (!options || !options.name) {
        console.error('Attempt of creating LocalStorageCollection instance with empty args');
        return;
      }

      this.name = options.name;
      this.localStorageItemName = options.localStorageItemName || this.name;
      // setting integer limit that is greater than 1
      this.limit = parseInt(Math.max(1, options.limit || 10));
      this.items = loadFromLocalStorage(this.localStorageItemName);
      this.events = {
        onUpdate: new hesEventHandlerService()
      };
    }

    LSCollection.prototype.addItem = function(item) {
      // if item already added: do nothing
      var foundItem = _.filter(this.items, {id: item.id})[0];
      if (!!foundItem){
        var idx = this.items.indexOf(foundItem);
        this.items.splice(idx,1);
      }

      if (this.items.length >= this.limit) {
        this.items = this.items.slice(0, this.limit - 1);
      }

      this.items.unshift(item);

      saveChanges(this);
    };

    LSCollection.prototype.removeItem = function(filterFn) {
      if (!filterFn || typeof filterFn !== 'function')
        return;

      _.remove(this.items, filterFn);
      saveChanges(this);
    };

    LSCollection.prototype.flush = function() {
      this.items = [];
      saveChanges(this);
    };

    function loadFromLocalStorage(LSName) {
      var items = localStorage.getItem(LSName) || '[]';
      return JSON.parse(items);
    }

    function saveToLocalStorage(LSName, items) {
      localStorage.setItem(LSName, JSON.stringify(items));
    }

    function saveChanges(instance) {
      saveToLocalStorage(instance.localStorageItemName, instance.items);
      instance.events.onUpdate.invoke();
    }

    return LSCollection;
  });
'use strict';

angular.module('goApp')
  .directive('hesReturnToHomeButton', ['MainNavigation', 'CurrentUser',
    function(MainNavigation, CurrentUser) {
      return {
        restrict: 'E',
        scope: true,
        replace: true,
        template: '<button ui-sref="go.u.home" ng-show="isVisible">Return to home</button>',
        link: function($scope, $element, $attrs) {
          function initVisibility(value) {
            MainNavigation.get().then(function(navigation){
              $scope.isVisible = !angular.isUndefined(value) ? value : !navigation.getVisibleItemsAmount();
            });
          }

          CurrentUser.get().then(initVisibility);

          $scope.$on('userLoggedIn', initVisibility);
          $scope.$on('userLoggedOut', function() {
            // set button visible for logged out users since they don't have menu
            initVisibility(true);
          });
        }
      };
    }
  ]);
'use strict';

angular.module('goApp')
  .directive('hesFocus',
    function(hesTemplateService, FocusManagerService) {
      // Runs during compile
      return {
        restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
        link: function($scope, $element, $attrs, controller) {

          if (!FocusManagerService.initialLoad) {
            $attrs.$observe('setFocus', function(newVal, oldVal) {
              if (newVal !== oldVal && newVal == 'true') {
                $element[0].focus();
              }
            });
          }

        }
      };
    });
angular.module('goApp')
  .directive('hesTriggerClickOn', function () {
    return function(scope, $el, attrs) {
      $el.on('click', triggerClick);

      function triggerClick() {
        $(attrs.hesTriggerClickOn).click();
      }

      scope.$on('$destroy', function() {
        $el.off('click', triggerClick);
      })
    }
  });
'use strict';

angular.module('goApp')
	.directive('hesIntegerInput', function() {
		return {
			restrict: 'A',
			scope: {
				model: '=ngModel',
			},
			link: function($scope, $element, $attrs) {
				$scope.$watch('model', function(newVal, oldVal) {
					function testVal() {
						if (newVal !== undefined && newVal !== "") {

							try {
								if (newVal % 1 === 0 && (newVal === null || (newVal + "").indexOf('.') === -1)) {
									var test = parseInt(newVal);
								} else {
									$scope.model = oldVal;
								}
							} catch (err) {
								$scope.model = oldVal;
							}
						}
					}

					if ($attrs.digitLimit) {
						if (newVal && (newVal+'').length > $attrs.digitLimit) {
							$scope.model = oldVal;
						} else {
							testVal();
						}
					} else {
						testVal();
					}
				});
			}
		};
	});
// utlivingwell.com, utlivingwell.wellnesslaunchpad.com

'use strict';

angular.module('goApp')
	.directive('hesLoadingGif', ['$timeout', 'hesTemplateService',
		function($timeout, hesTemplateService) {
			return {
				restrict: 'A',
				templateUrl: hesTemplateService.getTemplateUrl('/scripts/hes/loadingGif.html'),
				replace: true,
				scope: {
					loading: '=',
					delay: '=?'
				},
				link: function($scope, $element, $attrs) {
					TweenMax.to($element, 0, {
						display: 'inline-block'
					});

					$scope.delay = $scope.delay || 300;

					var icon = $('#loading-gif-animation img');

					$scope.rotateImage = function() {
						TweenMax.fromTo(icon, 2, {
							rotation: 0
						}, {
							rotation: 360,
							ease: Back.easeInOut,
							onComplete: $scope.checkIfFinished
						}, 0);
					};

					$scope.hideImage = function() {
						TweenMax.to($element, 0, {
							display: 'none'
						});
					};

					$scope.checkIfFinished = function() {
						if ($scope.loading) {
							$scope.rotateImage();
						} else {
							$scope.hideImage();
						}
					};

					$scope.$watch('loading', function(newValue, oldValue) {
						if ($scope.promise) {
							$timeout.cancel($scope.promise);
							$scope.promise = null;
						}

						if (newValue) {
							$scope.hideImage();
							$scope.promise = $timeout(function() {
								TweenMax.to($element, 0, {
									display: 'inline-block'
								});
								$scope.rotateImage();
							}, $scope.delay);
						} else if (!newValue) {
							$scope.hideImage();
						}
					});
				}
			};
		}
	]);
'use strict';

angular.module('goApp').directive('plusOne', function(hesTemplateService, $compile, $timeout) {
  return {
    restrict: 'A',
    link: function postLink($scope, $element, $attrs) {
      var plus_one;

      if ($attrs.imageUrl) {
        plus_one = angular.element('<img id="plus_one" class="click-through" hes-image="' + $attrs.imageUrl + '" />');
      } else if ($attrs.imageSpan) {
        plus_one = angular.element('<div id="plus_one" class="click-through">' + $attrs.imageSpan + '</div>');
      }

      $compile(plus_one)($scope);

      $element.on('click', function() {
        if ($attrs.toggleVar === "true") {
          $scope.runAnimation();
        }
      });

      $scope.runAnimation = function() {
        var dup = angular.element(plus_one).clone();
        $element.before(dup);
        TweenMax.fromTo(dup, 1, {top: 0, opacity: 1}, {top: -40, opacity: 0, onComplete: function () {
          dup.remove();
        }});
      };
    }
  };
});
angular.module('goApp')
  .run(function($rootScope) {
    $rootScope.$safeApply = function() {
      var $scope, fn, force = false;
      if(arguments.length == 1) {
        var arg = arguments[0];
        if(typeof arg == 'function') {
          fn = arg;
        }
        else {
          $scope = arg;
        }
      }
      else {
        $scope = arguments[0];
        fn = arguments[1];
        if(arguments.length == 3) {
          force = !!arguments[2];
        }
      }
      $scope = $scope || this;
      fn = fn || function() { };
      if(force || !$scope.$$phase) {
        $scope.$apply ? $scope.$apply(fn) : $scope.apply(fn);
      }
      else {
        fn();
      }
    }
  });
'use strict';
angular.module('goApp')
  .directive('hesTimedMessage', ['hesTemplateService', '$timeout',
    function(hesTemplateService, $timeout) {
      // Runs during compile
      return {
        scope: {
          show: '=',
          displayFor: '@?'
        }, // {} = isolate, true = child, false/undefined = no change
        restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
        link: function($scope, $element, $attrs, controller) {
          $scope.$watch('show', function() {
            if (!!$scope.show) {
              $($element).show();
              $timeout(function() {
                $scope.show = false;
              }, ($scope.displayFor || 3000));
            } else {
              $($element).hide();
            }
          });
        }
      };
    }
  ]);
'use strict';

angular.module('hes')
  .factory('Utils', function() {
    var service = {
      isUndefinedOrNull: function(obj) {
        return !angular.isDefined(obj) || obj === null;
      }
    };

    return service;
  });
'use strict';
angular.module('goApp')
  .directive('highContrastToggle', function(hesTemplateService) {
    // Runs during compile
    return {
      link: function($scope, $element, $attrs, controller) {
        $scope.toggle.mode = $attrs.hasOwnProperty('mode') ? ($attrs.mode || 'button') : 'button';
        $scope.$watch('mode', function() {
          $scope.toggle.mode = $attrs.hasOwnProperty('mode') ? ($attrs.mode || 'button') : 'button';
        });
      },
      controller: function($rootScope, $scope, DynamicCssService, ipCookie) {

        $scope.toggle = {
          isHighContrast: !!ipCookie('show-high-contrast'),
          mode: 'button'
        };

        $scope.toggleContrast = function(value, event) {
          if(event && event.type == 'click') {
            document.activeElement.blur();
          }
          $scope.toggle.isHighContrast = value;
          if ($scope.toggle.isHighContrast) {
            $('body').addClass('dark');
            ipCookie('show-high-contrast', 'true', {path: '/'});
          } else {
            $('body').removeClass('dark');
            ipCookie.remove('show-high-contrast',{ path: '/' });
          }
        };

        $scope.toggleContrast($scope.toggle.isHighContrast);

        $scope.$watch(function() { return ipCookie('show-high-contrast'); },
         function() {
            $scope.toggle.isHighContrast = !!ipCookie('show-high-contrast');
        });

      },
      restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
      templateUrl: hesTemplateService.getTemplateUrl('/scripts/highContrast/highContrast.html'),
      replace: true
    };
  });
'use strict';

angular.module('goApp').controller('HomeNormalController', function($scope, User) {

  $scope.data = new Object();
  $scope.hasCurrentProgram = $scope.site.hasCurrentPrograms();
  $scope.hasOngoingProgram = $scope.site.hasOngoingPrograms();
  $scope.hasPastPrograms = $scope.site.hasPastPrograms($scope.user);
  $scope.hasUpcomingProgram = $scope.site.hasUpcomingPrograms();

  $scope.currentProgram = _.head($scope.site.currentPrograms());

  $scope.data.selected_year = $scope.site.years[0];

  function setActives() {
    $scope.data.active_billboard_id = $scope.user.application_state.current_billboard_id;
    $scope.data.showEvaluationBanner = $scope.user.application_state.active_program_evaluation &&
                                       $scope.site.evaluation_billboard_id &&
                                       $scope.user.application_state.logging_state == 'logging_ended';
  }

  setActives();


  $scope.$watch('user.application_state.hash_key', setActives);

});
'use strict';

angular.module('goApp').controller('HomePlusController', function($scope, $timeout, $http, DOMAIN, $interval, User, Banner, UserChallenge, Goal, Daily, CurrentSite, RecentPostsLoader) {

  $scope.data = new Object();
  $scope.hasCurrentProgram = $scope.site.hasCurrentPrograms();
  $scope.hasOngoingProgram = $scope.site.hasOngoingPrograms();
  $scope.hasPastPrograms = $scope.site.hasPastPrograms($scope.user);
  $scope.hasUpcomingProgram = $scope.site.hasUpcomingPrograms();

  $scope.currentProgram = _.head($scope.site.currentPrograms());

  function setActives() {
    $scope.data.active_billboard_id = $scope.user.application_state.current_billboard_id;
    $scope.data.showEvaluationBanner = $scope.user.application_state.active_program_evaluation &&
      $scope.site.evaluation_billboard_id &&
      $scope.user.application_state.logging_state == 'logging_ended';
  }


  setActives();

  function htmlToPlaintext(text) {
    return text ? String(text).replace(/<[^>]+>/gm, '') : '';
  }

  $scope.truncate = function(str, length) {
    return _.truncate(htmlToPlaintext(str), {
      length: length,
      separator: ' '
    });
  }

  Banner.current().then(function(banners) {
    _.remove(banners, function(e) {
      return !e.banner_billboard_id;
    });
    $scope.data.banners = banners;
    $scope.data.banner_options = {
      current: 0,
      max: $scope.data.banners.length - 1
    }

    startCarousel();
  })

  $scope.page = function(direction, evt) {
    if ($scope.data.banner_options.max == 0) {
      return;
    }

    var isBack = direction.toLowerCase() == "back";
    if (isBack) {
      --$scope.data.banner_options.current;
      if ($scope.data.banner_options.current < 0) {
        $scope.data.banner_options.current = $scope.data.banner_options.max;
      }
    } else {
      ++$scope.data.banner_options.current;
      if ($scope.data.banner_options.current > $scope.data.banner_options.max) {
        $scope.data.banner_options.current = 0;
      }
    }
    // if evt exists then it was a user click so it should reset the interval on the carousel
    if (evt && carousel) {
      $interval.cancel(carousel);
      startCarousel();
    }
  }

  $scope.toggleBanner = function(val) {
    $scope.user.flags.show_banners = (val == 'show');
    new User($scope.user).save();
  }

  var carousel = null;

  function startCarousel() {
    var sleep_milliseconds = 7000;
    carousel = $interval(function() {
      $scope.page("next");
    }, sleep_milliseconds);
  }

  // Data sources
  if ($scope.site.flags.is_recipes_enabled || $scope.site.flags.is_tips_enabled) {
    Daily.get().then(function(data) {
      $scope.data.daily_tip = data.tip;
      $scope.data.daily_recipe = data.recipe;
    });
  }

  if ($scope.site.flags.is_challenges_enabled) {
    UserChallenge.index({
      filter: 'active',
      page_size: 5
    }, function(data) {
      $scope.data.user_challenges = data;
    });
  }

  if ($scope.site.flags.is_goal_enabled) {
    Goal.index({
      filter: 'active',
      page_size: 5
    }, function(data) {
      $scope.data.goals = data;
    });
  }

  if ($scope.site.flags.is_wall_enabled) {
    CurrentSite.get().then(function(site) {
      new RecentPostsLoader(100, site.id).then(function(posts) {
        var most_recent_moderator_post = _.find(posts, function(p) {
          return p.is_moderator == true
        });
        var new_posts = _.filter(posts, function(p) {
          return !p.is_moderator || p.is_recent
        });
        $scope.posts = {
          new: new_posts.length,
          moderator: most_recent_moderator_post
        }
      });
    });
  }

  //TODO: add watcher on application state
  $scope.$watch('user.application_state.hash_key', setActives);

});
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.u.home', {
    url: '/home',
    templateProvider: ['hesTemplateService', function(hesTemplateService) {
      return hesTemplateService.getTemplate('/scripts/home/home.html');
    }],
    resolve: {
      currentDate: ['$stateParams', 'HesDate', '$q',
        function($stateParams, HesDate, $q) {
          var defer = $q.defer();
          var cDate = new Date();

          if ($stateParams.dt !== undefined) {
            cDate = HesDate.parse($stateParams.dt);
          }

          HesDate.setCurrentDate(cDate);
          defer.resolve(cDate);

          return defer.promise;
        }
      ]
    },
    abstract: false
  });
  
});
angular.module('goApp').controller('TilesController', function($scope, DOMAIN, $http, dragulaService) {

  var default_tiles = ['logging_graph', 'challenges', 'goals', 'tips', 'recipes', 'wall'];

  $scope.templateMap = {
    logging_graph: '/scripts/home/homepageTile/chart.html',
    challenges:    '/scripts/home/homepageTile/challenges.html',
    goals:         '/scripts/home/homepageTile/goals.html',
    tips:          '/scripts/home/homepageTile/tips.html',
    recipes:       '/scripts/home/homepageTile/recipes.html',
    wall:          '/scripts/home/homepageTile/wall.html'
  }

  var show_tiles = {
    logging_graph: $scope.site.flags.is_logging_enabled,
    challenges:    $scope.site.flags.is_challenges_enabled,
    goals:         $scope.site.flags.is_goal_enabled,
    tips:          $scope.site.flags.is_tips_enabled,
    recipes:       $scope.site.flags.is_recipes_enabled,
    wall:          $scope.site.flags.is_wall_enabled
  }


  function init() {
    $scope.user.tiles_order_json = $scope.user.tiles_order_json || [];
    // first ensure all tiles are added in
    // then remove tiles if they are not an enabled feature
    _.each(default_tiles,function(tile) {
      if($scope.user.tiles_order_json.indexOf(tile) == -1) {
        $scope.user.tiles_order_json.push(tile);
      }
      if (!show_tiles[tile]) {
        _.remove($scope.user.tiles_order_json, function(t){return t == tile;}); 
      }
    });
    // finally attach tiles to scope
    $scope.tiles = $scope.user.tiles_order_json;
  }


  $scope.move = function(tile, direction) {
    if (direction == 'up') {
      arrayMove($scope.tiles, tile, -1);
    } else {
      arrayMove($scope.tiles, tile, 1);
    }
    saveOrder();
  }

  dragulaService.options($scope, 'bag', {
    revertOnSpill: true,
    moves: function(el, container, handle) {
      return handle.classList.contains('handle');
    }
  });

  $scope.$on('bag.drop', function(e, el) {
    saveOrder();
  });


  function saveOrder() {
    $http.post(DOMAIN + '/users/tiles_reorder', {
      order: $scope.tiles
    }).then(_.noop);
  }

  function arrayMove(array, element, delta) {
    var index = array.indexOf(element);
    var newIndex = index + delta;
    if (newIndex < 0  || newIndex == array.length) return; //Already at the top or bottom.
    var indexes = [index, newIndex].sort(); //Sort the indixes
    array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]); //Replace from lowest index, two elements, reverting the order
  }


  init();

})
'use strict';

angular.module('goApp')
  .directive('hesIcon', ['$rootScope', 'hesTemplateService', 'hesImageService',
    function($rootScope, hesTemplateService, hesImageService) {
      // Runs during compile
      return {
        scope: true,
        restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
        templateUrl: hesTemplateService.getTemplateUrl('/scripts/icons/iconTemplate.html'),
        replace: true,
        link: function($scope, $element, $attrs, controller) {

          function setIconName(name) {
            $scope.iconName = hesImageService.getIconTheme(name || $attrs.iconName);
          }

          setIconName();
          $attrs.$observe('iconName', function() {
            setIconName();
          });

          if ($attrs.hasOwnProperty('iconHoverName')) {
            var elm = $element;
            
            if ($attrs.hasOwnProperty('watchParent')) {
              elm = $element.closest($attrs.watchParent);
            }

            function setHover() {
              setIconName($attrs.iconHoverName);
              $rootScope.safeApply();
            }

            function setNormal() {
              setIconName();
              $rootScope.safeApply();
            }
            
            elm.on('mouseenter', setHover);
            elm.on('mouseleave', setNormal);
            elm.on('focus', setHover);
            elm.on('blur', setNormal);

            $scope.$on('$destroy', function() {
              elm.off();
            });

            // Hack to work for fileUploadPhoto.html 
            if ($attrs.watchParent == '.photoinput-button') {
              var focusWatchElm = $element.closest($attrs.watchParent).find('input[type="file"]');
              focusWatchElm.on('focus', setHover);
              focusWatchElm.on('blur', setNormal);
              $scope.$on('$destroy', function() {
                focusWatchElm.off();
              });
            }

          }
        }
      };
    }
  ]);
'use strict';

angular.module('goApp')
  .service('IdleService', function($rootScope, ngDialog, Idle, $state, $timeout, CurrentSite) {
    var watchers = [];
    var IdleService = {};

    // console.log('Idle Service');

    function init() {
      var timer = {
        keepAliveTime: null,
        idleStart: null
      };

      Idle.watch();
      // console.log('Init Idle Watcher');

      watchers.push($rootScope.$on('Keepalive', function() {
        if (!!timer.keepAliveTime) {
          var minutes = Math.floor(moment.duration(new Date() - timer.keepAliveTime).asMinutes());
          // console.log('Keepalive: ' + minutes);
          if (minutes >= 20) {
            $rootScope.$broadcast('IdleTimeout');
            // console.log('Above 20: ' + minutes);
          }
        } else {
          timer.keepAliveTime = new Date();
          // console.log('New minutes');
        }
      }));

      // watchers.push($rootScope.$on('IdleStart', function() {
      //   timer.idleStart = new Date();
      //   console.log('IdleStart: ', timer.idleStart);

      //   var dialog = ngDialog.open({
      //     className: 'ngdialog-theme-default timeout',
      //     template: '/scripts/idleTimeout/idleTimeout.html'
      //   });

      //   dialog.closePromise.then(function() {
      //     timer.idleStart = null;
      //     Idle.watch();
      //   });
      // }));

      // watchers.push($rootScope.$on('IdleWarn', function() {
      //   console.log('IdleWarn: ', timer.idleStart);
      //   if (!!timer.idleStart) {
      //     var minutes = Math.floor(moment.duration(new Date() - timer.idleStart).asMinutes());
      //     console.log('IdleWarn: ' + minutes);
      //     if (minutes >= 5) {
      //       $rootScope.$broadcast('IdleTimeout');
      //     }
      //   }
      // }));

      // watchers.push($rootScope.$on('IdleEnd', function() {
      //   console.log('IdleEnd: ', timer.idleStart);
      //   timer.idleStart = null;
      //   Idle.watch();
      //   ngDialog.closeAll();
      // }));

      watchers.push($rootScope.$on('IdleTimeout', function() {
        ngDialog.closeAll();
        IdleService.stop();
        $state.go('go.logout');
      }));
    }

    function start() {
      $timeout(function() {
        // need to resolve a site before trying to reference it
        CurrentSite.get().then(function(site){
          if (site.flags) {
            if (site.flags.is_timeout_enabled) {
              init();
            }
          };
        });
      }, 500);
    };

    function stop() {
      $rootScope.$offMany(watchers);
      Idle.unwatch();
    }

    IdleService.start = start;
    IdleService.stop = stop;

    return IdleService;
  });
'use strict';

angular.module('goApp')
  .controller('IdleTimeoutController', function($scope, Idle, ngDialog, $state, $interval, IdleService) {
    var idleActionWaiter;
    $scope.countdownNumbers = 300;
    $scope.minutes = Math.floor($scope.countdownNumbers / 60);
    $scope.seconds = 0;

    ngDialog.closeAll();

    idleActionWaiter = $interval(function() {
      $scope.countdownNumbers -= 1;

      $scope.minutes = Math.floor($scope.countdownNumbers / 60);
      $scope.seconds = $scope.countdownNumbers - ($scope.minutes * 60);

      if($scope.countdownNumbers == 0){
        $scope.timeoutGo();
      }
    }, 1000);

    $scope.timeoutStay = function(){
      ngDialog.closeAll();
      endCounting();
      Idle.watch();
    };

    $scope.timeoutGo = function(){
      ngDialog.closeAll();
      Idle.unwatch();
      $state.go('go.logout');
    };

    function endCounting(){
      $interval.cancel(idleActionWaiter);
      idleActionWaiter = null;
    }

    $scope.$on('$destroy', function() {
      endCounting();
    });
  });
'use strict';

angular.module('goApp')
  .directive('hesImageViewer', function(hesTemplateService, $mdDialog, $compile) {
    // Runs during compile
    return {
      templateUrl: hesTemplateService.getTemplateUrl('/scripts/imageViewer/imageViewer.html'),
      link: function($scope, $element, $attrs, controller) {
        $scope.config = {
          imageUrl: '',
          origin: $element.find('img')[0],
          imageClass: ''
        };

        $scope.disablePopup = $attrs.disablePopup == "true";

        function setImage() {
          $scope.config.imageUrl = $attrs.hesImageViewer;
          $scope.disablePopup = $scope.config.imageUrl.indexOf('default.png') >= 0;
        }

        $scope.openImageViewer = function() {
          if($scope.disablePopup) return;
          var imageUrl = $scope.config.imageUrl;
          var origin = $scope.config.origin;
          var imgDialog = $mdDialog.confirm({
            templateUrl: hesTemplateService.getTemplateUrl('/scripts/imageViewer/imageViewerDialog.html'),
            clickOutsideToClose: true,
            disableParentScroll: true,
            openFrom: origin,
            closeTo: origin,
            onRemoving: function() {
              $scope.config.origin.focus();
            },
            controller: function($scope, $mdDialog) {
              $scope.view = {
                imageUrl: imageUrl
              };
              $scope.close = function() {
                $mdDialog.cancel();
              };
            }
          });

          $mdDialog.show(imgDialog);
        };

        if ($attrs.hasOwnProperty('imageClass')) {
          $scope.config.imageClass = $attrs.imageClass;
        }

        if ($attrs.hasOwnProperty('screenReading')) {
          $scope.config.screenReader = $attrs.screenReading;
        }

        $attrs.$observe('hesImageViewer', setImage);
        $scope.$on('$destroy', function() {
          $mdDialog.hide();
        });
      }
    };
  });
'use strict';

angular.module('goApp').factory('Like', ['DOMAIN', '$rootScope', '$filter', '$timeout', '$http', 'ActiveResource',
    function(DOMAIN, $rootScope, $filter, $timeout, $http, ActiveResource) {
        var Like = ActiveResource('/likes/:id', {
            nestedRoutes: ['index', 'create'],
            parentResource: 'Promotion',
            domain: DOMAIN
        });

        Like.prototype.isFromMe = function() {
            return this.user.id === $rootScope.user.id;
        };

        return Like;
    }
]);
'use strict';
angular.module('goApp')
.directive('hesLoadMoreButton', ['hesTemplateService', function(hesTemplateService){
  // Runs during compile
    return {
      scope: {
        onClick: '&'
      }, // {} = isolate, true = child, false/undefined = no change
      controller: function($scope) {
        var ctrl = this;
        $scope.handleClick = function(){
          ctrl.manageFocus();
          $scope.onClick();
        }
      },
      restrict: 'E', // E = Element, A = Attribute, C = Class, M = Comment
      templateUrl: hesTemplateService.getTemplateUrl('/scripts/loadMoreButton/loadMoreButton.html'),
      link: function($scope, $element, $attrs, controller) {
        controller.manageFocus = function(){
          var sibs = $element.siblings();
          var focusElm = sibs[sibs.length - 1]
          if(!!focusElm){
            focusElm.focus();
          }
        }
      }
    };
}]);
'use strict';

angular.module('goApp')

.factory('LocationsLoader', ['LocationService', '$q',
  function(LocationService, $q) {
    return function(site_id) {
      return LocationService.get(false, site_id);
    };
  }
])
  // .run(['LocationsLoader', 'CurrentPromotion', '$timeout', function(LocationsLoader, CurrentPromotion, $timeout) {
  //   $timeout(function() {
  //     CurrentPromotion.get().then(function(promotion) {
  //       new LocationsLoader(promotion.id);
  //     });
  //   }, 100);
  // }]);
'use strict';

angular.module('goApp')

.factory('Location', ['$q', '$http', 'ActiveResource', 'DOMAIN', function($q, $http, ActiveResource, DOMAIN) {
	var Location = ActiveResource('/locations/:id/', {
		nestedRoutes: ['index', 'create'],
		parentResource: 'Site',
		domain: DOMAIN
	});

	Location.setOrder = function(sequence) {
		var defer = $q.defer();
		$http.post(DOMAIN + '/locations/reorder', {
			sequence: sequence
		}).then(function() {
			defer.resolve();
		})['catch'](function() {
			defer.reject();
		});
		return defer;
	};


	return Location;
}]);

'use strict';

angular.module('goApp')
  .config(['$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('go.u.site.locations', {
          url: '/locations',
          controller: 'LocationsController',
          templateProvider: ['hesTemplateService',
            function(hesTemplateService) {
              return hesTemplateService.getTemplate('/scripts/location/locations.html');
            }
          ]
        });
    }
  ]);
'use strict';

angular.module('goApp')
  .service('LocationService', ['Location', '$q',
    function(Location, $q) {
      var LocationService = {
        _locations: null,
        queued: false,
        queuedPromise: null,
        get: function(refresh, siteId) {
          var defer = $q.defer();
          var promise = defer.promise;
          if (LocationService._locations === null || refresh) {
            if (!LocationService.queued) {
              LocationService.queuedPromise = promise;
              LocationService.queued = true;
              Location.index({
                  site_id: siteId,
                  page_size: 0
                }, function(locations) {
                  LocationService.queued = false;
                  LocationService._locations = locations;
                  defer.resolve(LocationService._locations);
                },
                function(rejection) {
                  LocationService.queued = false;
                  defer.reject(rejection);
                });
            } else {
              promise = LocationService.queuedPromise;
            }
          } else {
            LocationService.queued = false;
            defer.resolve(LocationService._locations);
          }

          return promise;
        },
        getLocationById: function(locations, id, checkSubLocations) {
          if (angular.isNumber(locations)) {
            id = locations;
            locations = LocationService._locations;
          }
          if (checkSubLocations === undefined) {
            checkSubLocations = true;
          }

          var location = _.filter(locations, {id: id})[0];

          if (!location && checkSubLocations) {
            for (var i = 0; i < locations.length; i++) {
              if (locations[i].locations) {
                location = this.getLocationById(locations[i].locations, id, false);
                if (location !== undefined) {
                  break;
                }
              }
            }
          }

          return location;
        },
        expandChildLocations: function(plocations) {
          var locations = [];
          angular.forEach(plocations, function(location) {
            // if (plocations.length > 1) {
              locations.push(location);
            // }
            if (location.locations && location.locations.length > 0) {
              locations = locations.concat(LocationService.expandChildLocations(location.locations));
            }
          });

          return locations;
        }
      };

      return LocationService;
    }
  ]);
'use strict';

angular.module('goApp')
  .controller('LocationCreateEditController', ['$scope', 'ErrorService', 'BillboardService', '$state',
    function($scope, ErrorService, BillboardService, $state) {

      $scope.settings = {
        saving: false,
        showSaving: false
      }

      $scope.handleErrors = function(response) {
        $scope.settings.saving = false;
        $scope.settings.showSaving = false;
        ErrorService.showErrors(response, 'Could not save Location');
      };


      $scope.editBillboard = function(billboard_id, type) {
        var url = $state.href("go.u.billboardEdit",{
          id: billboard_id,
          site_id: $scope.dbSite.id,
          site_name: $scope.dbSite.name,
          name: $scope.data.editLocation.name,
          billboard_type: type,
        });
        window.open(url);
      }

      BillboardService.index({site_id: $scope.dbSite.id}).then(function(billboards) {
        $scope.data.billboards = billboards;
      });

      $scope.saveLocation = function() {
        $scope.settings.saving = true;
        $scope.settings.showSaving = true;
        $scope.data.editLocation.save(function() {
          $scope.settings.saving = false;
          $scope.settings.showSaving = false;
          $scope.confirm();
        })['catch']($scope.handleErrors);
      };
    }
  ]);
'use strict';

angular.module('goApp')
  .controller('LocationsController', ['$scope', '$q', 'LocationService', 'Location', 'ngDialog', 'ErrorService',
    function($scope, $q, LocationService, Location, ngDialog, ErrorService) {

      $scope.settings = {
        uploadEndpoint: '/sites/' + $scope.dbSite.id + '/locations'
      };

      $scope.upload = {
        file: null
      };

      $scope.confirmation = {
        location: null
      };

      $scope.view = {
        openedNodes: {}
      };


      $scope.tree = {
        options: {
          accept: function(srcNodeScope, destNodeScope, destIdx) {
            return true;
          },
          dropped: function(eventObj) {
            var movingLocation = eventObj.source.nodeScope.location;
            var dest = eventObj.dest;
            var parentLocation = {
              id: null
            };
            if (dest.nodesScope.location) {
              parentLocation = dest.nodesScope.location;
            }

            $scope.data.editLocation = new Location(movingLocation);
            $scope.data.editLocation.parent_location_id = parentLocation.id;

            var sequence = dest.nodesScope.$modelValue.map(function(location) {
              return location.id;
            });

            if (movingLocation.parent_location_id != $scope.data.editLocation.parent_location_id) {
              // only need to call this function if parent location id changed
              $scope.saveLocation().then(function() {
                Location.setOrder(sequence).then(function(){
                  $scope.refreshLocations();
                });
              });
            } else {
              Location.setOrder(sequence).then(function(){
                $scope.refreshLocations();
              });
            }

          }
        }
      };

      $scope.refreshLocations = function() {
        LocationService.get(true, $scope.dbSite.id).then(function(locations) {
          $scope.data.locations = locations;
        });
      };


      $scope.expandCollapse = function(node){
        node.toggle();
        $scope.view.openedNodes[node.location.id] = node.collapsed;
      };

      $scope.saveLocation = function() {
        var defer = $q.defer();
        $scope.data.editLocation.save(function() {
          defer.resolve();
        })['catch'](function(response) {
          ErrorService.showErrors(response, 'Update Parent Location Failed');
          defer.reject();
        });
        return defer;
      };

      $scope.editLocation = function(location) {
        $scope.data.editLocation = new Location(location);
        ngDialog.openConfirm({
          template: '/scripts/location/locationCreateEdit.html',
          controller: 'LocationCreateEditController',
          scope: $scope
        }).then(function() {
          $scope.refreshLocations();
        });
      };

      $scope.addLocation = function(parent_id) {
        var newLocation = new Location({
          site_id: $scope.dbSite.id,
          parent_location_id: parent_id
        });
        $scope.editLocation(newLocation);
      };

      $scope.confirmRemoveLocation = function(location) {
        $scope.confirmation.location = location;
        ngDialog.openConfirm({
          template: '/scripts/location/confirmDeleteLocation.html',
          scope: $scope
        }).then(function() {
          new Location(location).destroy().then($scope.refreshLocations);
        });
      };

      $scope.onUploadCompleted = function(data) {
        //$scope.data.locations = Location.wrap(data.data);
        $scope.refreshLocations();
      };


    }
  ]);
angular.module("goApp").controller("PromptLocationCtrl", function($scope, $rootScope, $q,  LocationService, CurrentUser, CurrentSite, ErrorService, ngDialog, $timeout){

    // stuff for send/test dialog
    $scope.confirmation = {
        cancelText: "No",
        confirmText: "Confirm",
        data: $scope.data,
        search: ""
      };

      var site = $rootScope.site

      $scope.data = {
        parentLocations: []
      };

      $scope.displayChildLocations = function() {
        return $scope.settingsUser.parentLocation ? $scope.settingsUser.parentLocation.locations.length > 0 : false;
    };

      function initLocations() {
        if ($scope.site.flags.allow_set_location) {
            LocationService.get(false, $scope.site.id).then(function(parentLocations) {

                var locationIsChild = false;
                var locationIsParent = false;

                $scope.data.parentLocations = parentLocations;

                // Does the user only have a parent location?
                for (var p = 0; p < $scope.data.parentLocations.length; p++) {
                    if (!!$scope.settingsUser.location && $scope.settingsUser.location.id === $scope.data.parentLocations[p].id) {
                        locationIsParent = true;
                        $scope.settingsUser.parentLocation = $scope.data.parentLocations[p];
                        break;
                    }
                }

                // If not, look through their children...
                if (!locationIsParent) {
                    for (var _p = 0; _p < $scope.data.parentLocations.length; _p++) {
                        for (var c = 0; c < $scope.data.parentLocations[_p].locations.length; c++) {
                            if (!!$scope.settingsUser.location && $scope.settingsUser.location.id === $scope.data.parentLocations[_p].locations[c].id) {
                                locationIsChild = true;
                                $scope.settingsUser.parentLocation = $scope.data.parentLocations[_p];
                                $scope.settingsUser.childLocation = $scope.data.parentLocations[_p].locations[c];
                                break;
                            }
                        }
                    }
                }
            });
        }
    }

    $q.all([
        CurrentSite.get(),
        CurrentUser.get()
    ]).then(function(data) {
        $scope.settingsUser = angular.copy(data[1]);
        $scope.settingsUser.placeholderEmail = $scope.settingsUser.email;
        initLocations();
    }, function() {
        // TODO: Handle this somehow?
    });

    function isFormValid() {
        return $scope.errors.length === 0 && !$scope.emailAlreadyTaken;
    }

    $scope.updateUserInfo = function() {
        ErrorService.clearErrors();

        $scope.saved = false;
        $scope.savingUser = true;
        $scope.errors = [];

        if ($scope.site.flags.allow_set_location) {
            if ($scope.settingsUser.childLocation) {
                $scope.user.location_id = $scope.settingsUser.childLocation.id;
            } else {
                $scope.user.location_id = $scope.settingsUser.parentLocation.id;
            }
        }

        if (isFormValid()) {
            $scope.user.save(function(user) {
                CurrentUser.get(true).then(function() {
                    $scope.savingUser = false;
                    $scope.saved = true;


                    $timeout(function() {
                        $scope.saved = false;
                        $scope.confirm()
                    },1000);
                });
            });
        } else {
            ErrorService.showErrors({
                status: 422,
                data: {
                    errors: $scope.errors
                }
            });

            $timeout(function() {
                $scope.savingUser = false;
            }, 2000);
        }
    };
})
'use strict';

angular.module('goApp')
  .controller('LoginController', function($rootScope, $scope, ipCookie, User, CurrentUser, $state, ngDialog, ErrorService, CurrentSite, Program, $window, $location, $timeout) {

    $scope.settings = {
      programLogo: null,
      // Check both URL query params and state params for hesPlatform
      hesPlatform: $location.search().hesPlatform || $state.params.hesPlatform || null
    };

    // Add white background class for hesPlatform full-page login
    if ($scope.settings.hesPlatform) {
      $timeout(function() {
        $('.content').addClass('hes-platform-bg');
      });
      $scope.$on('$destroy', function() {
        $('.content').removeClass('hes-platform-bg');
      });
    }

    //Use other error banner on mobile
    $scope.errorPriority = ($('body').width() < 700 ? 0 : 1);

    // Enter on email goes to password -- mobile
    $('input[type="email"]').keypress(function(e) {
      if (e.keyCode === 13) {
        $('#password-input').focus();
        return false;
      }
    });

    CurrentSite.get()
      .then(function(site) {
        $scope.stay_logged_in = site.flags.default_logged_in_checked;
      });

    $scope.authFailure = function(errorMsg) {
      $scope.hasError = true;
      $scope.loggingIn = false;
      $scope.authenticationError = errorMsg;
    };

    $scope.login = function() {
      $scope.hasError = false;
      $scope.loggingIn = true;

      ipCookie.remove('basic');
      $scope.$emit('errors', []);
      $scope.redirect = $state.params.redirect;

      $scope.programId = $state.params.programId;

      User.authenticate({
        site_id: $scope.site.id
      },{
        email: $scope.loginUser.email,
        password: $scope.loginUser.password,
        stay_logged_in: !!$scope.stay_logged_in
      }).$promise.then(function(user) {
        // user.flags.stay_logged_in = !!$scope.stay_logged_in;
        if (user.auth_basic_header) {
          ipCookie('basic', user.auth_basic_header, { path: '/' });
        }
        CurrentUser.set(user);

        CurrentSite.get(true).then(function() {
          var programId = $scope.programId || sessionStorage.getItem('sso_programId');
          if (!programId) {
            $rootScope.$broadcast('userLoggedIn', user, $scope.redirect, $scope.redirect_obj);
            if ($scope.confirm) $scope.confirm();
            $location.path("/");
          } else {
            sessionStorage.removeItem('sso_programId');
            $rootScope.streamlineRedirect(programId);
          }
        });
      }, function(err) {
        $scope.loggingIn = false;
        var errors = err.data;
        console.log(errors, err);
        $scope.loginUser.password = '';
        $scope.$emit('errors', errors.errors, 0);
        $scope.authFailure(errors.errors[0]);
        $('body').scrollTop(0);
        $timeout(function() {
          $('.banner-error').hide();
        }, 900000); //900000 = 15 minutes
      });
    };

    $scope.goToRegister = function() {
      $state.go('go.register');
    };

    if ($state.params.rejection) {
      $scope.$emit('errors', $state.params.rejection.errors, $scope.errorPriority);
      $scope.authFailure($state.params.rejection.errors[0]);
    }

    if ($state.params.hesPlatform) {
      sessionStorage.setItem('hesPlatform', 'true');
    }

    if ($state.params.programId) {
      sessionStorage.setItem('sso_programId', $state.params.programId);
      Program.ProgramLogo.show({
        id: $state.params.programId
      }, function(response) {
        $scope.settings.programLogo = response.logo;
        $scope.settings.programNam = response.name;
      });
    }

    $scope.loggingIn = false;
    $scope.loginUser = {
      email: '',
      password: ''
    };

    $scope.showPasswordChanged = function() {
      var ele = document.getElementById("password-input");
      if (ele.type === "password") {
        ele.type = "text";
      } else {
        ele.type = "password";
      }
    }

    // ******************
    // Forgotten Password
    // ******************

    $scope.closeForgottenPassword = function() {
      $scope.$emit('errors', []);
      ngDialog.closeAll();
    };

    $scope.startForgottenPassword = function() {
      $scope.displayForgottenPassword = true;
      ngDialog.closeAll();
      ngDialog.open({
        template: '/scripts/password/forgotten_password.html',
        controller: 'ForgottenPasswordCtrl',
        preCloseCallback: function() {
          ErrorService.clearErrors();
          $scope.displayForgottenPassword = false;
          return true;
        }
      });
    };

    $scope.displayForgottenPassword = false;

    $scope.$on('cancelForgottenPassword', function() {
      $scope.closeForgottenPassword();
    });
  });
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.login', {
    url: '/login?:programId',
    controller: 'LoginController',
    title: 'Login',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/login/login.html');
      }
    ],
    params: {
      pilotPassword: null,
      rejection: null,
      programId: null
    }
  });

  $stateProvider.state('go.logout', {
    url: '/logout',
    controller: 'LogoutCtrl',
    title: 'Logout',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/login/logout.html');
      }
    ],
    abstract: false
  });
});
'use strict';

angular.module('goApp')

.controller('LogoutCtrl', ['$rootScope', '$scope', '$state', 'CurrentUser', 'HesSocket', 'CurrentSite', 'SSOService', '$window', 'MessageService',
	function($rootScope, $scope, $state, CurrentUser, HesSocket, CurrentSite, SSOService, $window, MessageService) {

		$scope.showSSOLogout = false;

		$scope.closeWindow = function() {
			$window.close();
		};

		$scope.logout = function() {
			CurrentUser.remove();
			// console.log("$broadcast userLoggedOut");
			$rootScope.$broadcast('userLoggedOut',{});
			MessageService.flush();

			if(SSOService.isEnabled()) {
				$scope.showSSOLogout = SSOService.goToRedirect();
			}
			else {
				CurrentSite.get(true).then(function() {
					$state.go('go.welcome');
				});
			}
			$rootScope.elig_user = null;
			$rootScope.user = null;
		};

		CurrentUser.get().then(function() {
			$scope.logout();
		}, function() {
			if(SSOService.isEnabled()) {
				$scope.showSSOLogout = SSOService.goToRedirect();
				$scope.$on('$destroy', function() {
					SSOService.goToLogin();
				});
			}
		});
	}
]);
'use strict';
angular.module('goApp')
  .directive('mdHesPopover', function(hesTemplateService, $mdPanel, $timeout) {
    // Runs during compile
    return {
      // name: '',
      priority: -99,
      // terminal: true,
      // scope: {}, // {} = isolate, true = child, false/undefined = no change
      // controller: function(\, \, \, \) {},
      // require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
      restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
      // template: hesTemplateService.getTemplate(''),
      // templateUrl: hesTemplateService.getTemplateUrl('/scripts/'),
      // replace: true,
      // transclude: true,
      // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
      link: function($scope, $element, $attrs, controller) {
        var topPanelRef;

        function getPanelPosition() {
          var targetElm = $element.find($attrs.targetClass)[0] || $element;
          return $mdPanel.newPanelPosition()
            .relativeTo(targetElm)
            .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
        }

        function resize() {
          if (topPanelRef) {
            var position = getPanelPosition();
            topPanelRef.updatePosition(position);
          }
        };

        $scope.buildAndShowPopover = function() {
          var popupScope = $scope.$new();
          var panelPos = getPanelPosition();

          popupScope.popupTemplate = $attrs.template;
          popupScope.closePopover = function() {
            $mdDialog.cancel();
          };

          var config = {
            attachTo: angular.element($element),
            disableParentScroll: false,
            hasBackdrop: false,
            trapFocus: false,
            position: panelPos,
            panelClass: 'md-hes-popover',
            templateUrl: '/scripts/mdHesPopover/md-hes-popover.html',
            scope: popupScope,
            clickOutsideToClose: false
          };

          // $('body').addClass('dialog-open');
          $mdPanel.open(config).then(function(panelRef) {
            topPanelRef = panelRef;

            //For some reason the panel wrapper is being a jerk and not letting
            // interactions below it. Set the width to 0 to "hide" it
            $('.md-panel-outer-wrapper').width(0);

            popupScope.closePopover = function() {
              panelRef.destroy();
            };
          });

          $(window).on('resize', resize);
          $scope.$on('$destroy', function() {
            $($window).off('resize', resize);
            panelRef = null;
          });
        };


        var unwatchShow = $attrs.$observe('showPopover', function(newVal, prevVal) {
          if (!!newVal) {
            $timeout($scope.buildAndShowPopover, 1000);
            unwatchShow();
          }
        });
      }
    };
  });
angular.module('goApp')
  .config(function($mdIconProvider, $mdThemingProvider) {
    $mdIconProvider
      .iconSet('default-recipe', '/images/default/icon-sets/recipe-icon-set.svg', '1em')
      .iconSet('default-share', '/images/default/icon-sets/share-icon-set.svg', '1em')
      .iconSet('default-wall', '/images/default/icon-sets/wall-icon-set.svg', '1em')
      .iconSet('default-standard', '/images/default/icon-sets/standard-icon-set.svg', '1em')
      .iconSet('default-devices', '/images/default/icon-sets/devices-icon-set.svg', '1em');
  });
'use strict';
angular.module('goApp')
  .controller('ConversationController', function($rootScope, $scope, $state, MessageService, Message, conversation) {

  	$scope.data = {
  	  conversation: null,
      conversations: MessageService.getConversations(),
      newMessageImage: null
  	};

    /* Make sure conversation is set, and exists in MessageService */
    if ($scope.data.conversations.length == 0) {
      MessageService.addConversation(conversation);
    }
    MessageService.setCurrentConversation(conversation);
    $scope.data.conversation = MessageService.getConversationById(conversation.id);

    $scope.settings = {
      crumbs: [{
        state: 'go.u.usermenu.conversations_index',
        display: "Choose Conversation"
      }, {
        state: 'go.u.usermenu.conversation',
        display: _.truncate((conversation.conversation_name || conversation.membersString()), {
          length: 999
        })
      }]
    };

    function replyMessagePost() {
      var message = new Message({
        content: $scope.data.newMessageContent,
        image: $scope.data.newMessageImage,
        conversation_id: $scope.data.conversation.id,
        action: "message",
        user_image: $scope.user.profile.image.url,
        user_name: $scope.user.profile.full_name,
        user_id: $scope.user.id,
        created_at: new Date()
      });

      message.save(function(message) {});

      $scope.data.conversation = MessageService.pushMessage($scope.data.conversation, message);
      $scope.data.newMessageImage = null;
      $scope.view.isSending = false;
      $scope.data.conversation.last_seen_at_milliseconds = new Date();

    };

    $scope.isSameTime = function(message1, message2) { // Same time to the minute
      if ((!message1 || !message2) || message1.action != "message" || message2.action != "message") {
        return false;
      };

      return message1 && message2 &&
        parseInt(new Date(message1.created_at) / 60000) - parseInt(new Date(message2.created_at) / 60000) === 0;
    };

    $scope.isSameTimeUser = function(message1, message2) {
      if (!message1 || !message2) {
        return false;
      };
      return $scope.isSameTime(message1, message2) && message1.user_id === message2.user_id;
    };

    $scope.checkForSend = function(e, conversation) {
      if (e.keyCode == 13 && !e.shiftKey) {
        $scope.postMessage();
        e.preventDefault();
      }
    };

    $scope.postMessage = function() {
      if ((!$scope.data.newMessageContent || $scope.data.newMessageContent == "") && !$scope.data.newMessageImage) {
        return;
      };

      $scope.view.isSending = true;
      replyMessagePost();
      
      $scope.data.newMessageContent = null;
      $scope.data.newMessageImage = null;
    };

    function init() {
      var seenConvo = angular.copy(conversation);
      seenConvo.seen(function(){
        $rootScope.$broadcast('modelUpdate', {model:"Message"});
      });
      var convo = MessageService.getConversationById(conversation.id);
      if(convo) {
        convo.unseen = false;
        convo.last_seen_at_milliseconds = new Date();
      }
    }

    init();

  });
'use strict';
angular.module('goApp')
  .controller('ConversationCreateEditController', function($scope, $state, $timeout, MessageService, FriendService, conversation, ngDialog, User) {

  	$scope.data = {
  	  conversation: conversation,
  	  friends: [],
  	  newMessageImage: null
  	};

  	/* Breadcrumbs */
  	$scope.settings = {
  	  crumbs: []
  	};

  	if (conversation.is_new) {
  		$scope.settings.crumbs = [{
  	    state: 'go.u.usermenu.conversations_index',
  	    display: "Choose Conversation"
  	  }, {
  	    state: 'go.u.usermenu.conversation.createEdit',
  	    display: "New Conversation"
  	  }];
  	} else {
			$scope.settings.crumbs = [{
		    state: 'go.u.usermenu.conversations_index',
		    display: "Choose Conversation"
		  }, {
		    state: 'go.u.usermenu.conversation({conversationId: ' + conversation.id + '})',
		    display: _.truncate((conversation.conversation_name || conversation.membersString()), {
          length: 999
        })
		  }, {
		  	state: 'go.u.usermenu.conversation.edit',
		  	display: "Settings"
		  }];
  	}

  	FriendService.friends.get(true)
  	  .then(function(friends) {
  	    $scope.data.friends = MessageService.makeMembers(friends);
        if ($state.current.name == 'go.u.usermenu.conversation_create' && $state.params.user_id) {
          var quick_add = _.filter(friends, {friendee_id: parseInt($state.params.user_id)})[0];
          $scope.addConversationMember(quick_add);
        }
  	  });

  	$scope.friendList = function() {
  	  return MessageService.friendList($scope.data.friends, $scope.data.conversation);
  	};

  	/* Conversation Members */
  	$scope.addConversationMember = function(member) {
  	  if (!$scope.data.conversation.is_new) {
  	    if (!$scope.data.conversation.isGroup()) {
  	      var members = angular.copy($scope.data.conversation.getMembers());
  	      $scope.newConversation();
  	      $scope.data.conversation.members = members;
  	    } else {
  	      updateMembers(member, true);
  	    };
  	  };
  	  $scope.data.conversation.addMember(member);
  	  $scope.data.conversationMember = null;
  	  $timeout(function() {
  	    $('textarea.message').focus();
  	  }, 0);
  	};

  	$scope.removeConversationMember = function(member) {
  	  $scope.data.conversationMember = member;
  	  ngDialog.openConfirm({
  	    scope: $scope,
  	    template: '/scripts/messages/confirmRemoveMember.html'
  	  }).then(function() {

  	    $scope.data.conversationMember = null;
  	    if (!$scope.data.conversation.is_new) {
  	      updateMembers(member, false);
  	      $scope.data.conversation.removeMember(member);
  	      MessageService.touch();
  	    } else {
  	      $scope.data.conversation.removeMember(member);
  	    }

  	  });
  	};

  	function updateMembers(member, do_add) {
  	  $scope.data.conversation.users({
  	    operation: do_add ? 'add' : 'remove',
  	    members: [member.friendee_id || member.user_id]
  	  }, function(response) {
  	    
  	  });
  	};

  	/* Conversation Posting (new only) */
  	$scope.checkForSend = function(e, conversation) {
  	  if (e.keyCode == 13 && !e.shiftKey) {
  	    $scope.newConversationPost();
  	    e.preventDefault();
  	  }
  	};

    $scope.updateConversation = function() {
      $scope.updateVolume($scope.data.conversation);
      $scope.data.conversation.save(function(conversation) {
        $state.go('go.u.usermenu.conversation', {conversationId: conversation.id});
      });
    };

    $scope.updateVolume = function(conversation) {
      var user = User.build({
        id: $scope.user.id
      });
      user.conversation_volume({
        mute: conversation.muted,
        conversation_ids: [conversation.id]
      });
    };

  	$scope.newConversationPost = function() {
      $scope.data.conversation.prepareForPost({
        message: $scope.data.newMessageContent,
        image: $scope.data.newMessageImage,
        created_at: new Date()
      });
      $scope.data.conversation.save(function(conversation) {
        MessageService.buildMessages([conversation]);
        $state.go('go.u.usermenu.conversation', {conversationId: conversation.id});
      });
    };

  });
'use strict';

angular.module('goApp')

.factory('ConversationMixins', ['Message',function(Message) {
    var ConversationMixins = function(){};
    var TEAM_TYPE = 't', GROUP_TYPE = 'g', INDIVIDUAL_TYPE = 'i';

    ConversationMixins.prototype.initialize = function(attributes) {
      if(!this.members) { this.members = []; };

      _.forIn(attributes, function(key, value) {
        this[key] = value;
      });

    };

    ConversationMixins.prototype.addMember = function(member) {
      var fullName = member.full_name ||
                     member.friendee_full_name ||
                     member.profile.full_name ||
                     [member.profile.first_name, member.profile.last_name].join(" ");


      member.full_name = member.full_name || fullName;

      member.image = member.image || (member.profile && member.profile.image.url) || (member.friendee && member.friendee.profile.image.url);

      if (!_.find(this.members, {full_name: fullName})) {
        this.members.push(member);
      };

    };

    ConversationMixins.prototype.removeMember = function(member) {
      var memberPos = this.members.map(function(e) {return e.friendee_id; }).indexOf(member.friendee_id);
      this.members.splice(memberPos, 1);
    };

    ConversationMixins.prototype.prepareForPost = function(attributes) {
      this.message = Message.build({content: attributes.message, image: attributes.image, created_at: attributes.created_at});
      this.members = this.members.map(function(m) {
        return [m.friendee_id || m.user_id || m.id];
      });
    };

    ConversationMixins.prototype.memberNames = function() {
      return _.sortBy(_.compact(this.members).map(function(m) {
          return m.full_name;
        })
      );
    };

    ConversationMixins.prototype.getMembers = function() {
      return this.members;
    };

    ConversationMixins.prototype.getMembersExclude = function(user_id,truncate_obj) {
      return _.filter(this.members, function(m) {
        return m.user_id != user_id;
      }).map(function(m) {
        if (truncate_obj) {
          Object.keys(truncate_obj).forEach(function(key){
            m[key] = _.truncate(m[key],{length:parseInt(truncate_obj[key])});
          });
        }
        return m;
      });
    };

    ConversationMixins.prototype.membersString = function() {
      return _.compact(this.memberNames()).join(", ");
    };

    ConversationMixins.prototype.isGroup = function() {
      return this.conversation_type == GROUP_TYPE;
    };

    ConversationMixins.prototype.isTeam = function() {
      return this.conversation_type == TEAM_TYPE;
    };

    ConversationMixins.prototype.isIndividual = function() {
      return this.conversation_type == INDIVIDUAL_TYPE;
    };

    return ConversationMixins;

  }]
)

'use strict';

angular.module('goApp')

.factory('Conversation', ['ActiveResource', 'DOMAIN', 'ConversationMixins',
  function(ActiveResource, DOMAIN, ConversationMixins) {
    var Conversation = ActiveResource('/conversations/:id', {
        domain: DOMAIN
    }, {
      users: {
        method: 'POST',
        url: DOMAIN + '/conversations/:id/users'
      },
      seen: {
        method: 'POST',
        url: '/conversations/:id/seen'
      }
    });

    angular.extend(Conversation.prototype, ConversationMixins.prototype);

    return Conversation;
  }
])

'use strict';
angular.module('goApp')
  .controller('ConversationsListController', function($scope, $state, MessageService) {

  	$scope.data = {
  	  conversations: MessageService.getConversations()
  	};

  	MessageService.get(true, $scope.user.id).then(function() {
		$scope.data.conversations = MessageService.getConversations();
		$scope.view.fetchingConversations = false;

		if ($scope.data.conversations.length === 0) {
		  $scope.view.show_conversations = true;
		};
		MessageService.touch();
	});

  });
'use strict';

angular.module('goApp')

.directive('imageonload', function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        element.bind('load', function() {
          //call the function that was passed
          scope.$parent.$apply(attrs.imageonload);
        });
      }
    };
})
'use strict';

angular.module('goApp')

.constant("MessageDialog", {
  leaveConversationTitle: "Leave Conversation?",
  leaveConversationMessage: "Are you sure you want to leave this conversion?"
});
'use strict';

angular.module('goApp')

.factory('Message', ['ActiveResource', 'DOMAIN',
  function(ActiveResource, DOMAIN) {

    var Message = ActiveResource('/messages/:id', {
      nestedRoutes: ['index', 'create'],
      parentResource: 'Conversation',
      domain: DOMAIN
    });

    Message.prototype.getFormattedDate = function() {
      return moment(this.created_at).format('MMM DD, hh:mm a');
    };

    return Message;
  }
])

'use strict';

angular.module('goApp')

.config(['$stateProvider',
	function($stateProvider) {
		$stateProvider
			.state('go.u.usermenu.conversations_index', {
				title: 'Messages',
				url: '/messages',
				controller: 'ConversationsListController',
				abstract: false,
				templateProvider: ['hesTemplateService',
				function(hesTemplateService) {
					return hesTemplateService.getTemplate('/scripts/messages/conversationsList.html');
				}
			]
			})
			.state('go.u.usermenu.conversation', {
				title: 'Messages',
				url: '/messages/:conversationId',
				controller: 'ConversationController',
				abstract: false,
				templateProvider: ['hesTemplateService',
					function(hesTemplateService) {
						return hesTemplateService.getTemplate('/scripts/messages/conversation.html');
					}
				],
				resolve: {
				  conversation: function($q, $stateParams, UserConversation) {
				  	  var defer = $q.defer();
				  	  UserConversation.get({
				  	    id: $stateParams.conversationId
				  	  }, function(convo) {
				  	  	var c = UserConversation.build(convo.data[0]);
				  	    defer.resolve(c);
				  	  }, function() {
				  	    defer.reject('Conversation resource could not be found');
				  	  });

				  	  return defer.promise;
				  }
				}
			})
			.state('go.u.usermenu.conversation.edit', {
				url: '/edit',
				controller: 'ConversationCreateEditController',
				abstract: false,
				templateProvider: ['hesTemplateService',
					function(hesTemplateService) {
						return hesTemplateService.getTemplate('/scripts/messages/conversationSettings.html');
					}
				]
			})
			.state('go.u.usermenu.conversation_create', {
				title: 'Messages',
				url: '/conversation_create/:user_id',
				controller: 'ConversationCreateEditController',
				abstract: false,
				templateProvider: ['hesTemplateService',
					function(hesTemplateService) {
						return hesTemplateService.getTemplate('/scripts/messages/conversationSettings.html');
					}
				],
				resolve: {
				  conversation: function($q, UserConversation) {
				  	  var defer = $q.defer();
				  	  var convo = UserConversation.build({
				  	    is_new: true,
				  	    members: []
				  	  });
				  	  defer.resolve(convo);

				  	  return defer.promise;
				  }
				}
			});
	}
])
'use strict';

angular.module('goApp')

.service('MessageService', ['$q', '$state', '$rootScope', 'UserConversation', 'Conversation', 'Message', 'HesDate',
  function($q, $state, $rootScope, UserConversation, Conversation, Message, HesDate) {

    var MessageService = {
      _conversations: [],
      _last_updated: null,
      _current_conversation: null,
      _has_loaded: false
    };

    MessageService.get = function(refresh, userId, includeAll) {
      var defer = $q.defer();
      if (!MessageService._has_loaded || refresh) {
        UserConversation.index({
            user_id: userId,
            include: includeAll ? "all" : "last" 
          }, function(conversations) {
            MessageService._conversations = conversations;
            MessageService.buildMessages(MessageService._conversations);
            MessageService._has_loaded = true;
            defer.resolve(MessageService._conversations);
          },
          function(rejection) {
            defer.reject(rejection);
          });
      } else {
        defer.resolve(MessageService._conversations);
      }
      return defer.promise;
    };

    MessageService.getTeamChat = function(team_id) {
      return _.find(MessageService._conversations, {
        conversation_type: 't',
        conversation_type_id: parseInt(team_id)
      });
    };

    MessageService.getUserConversation = function(user) {
      return _.filter(MessageService._conversations, {conversation_type:"i", conversation_name:user.profile.full_name})[0];
    };

    MessageService.getFirstConversation = function() {
      // Get most recent -- Team is always on top, but not always most recent
      var recent = MessageService._conversations[0]

      for (var i = 1; i < MessageService._conversations.length; i++) {
        if (HesDate.compare(new Date(recent.current_messages[recent.current_messages.length - 1].created_at), new Date(MessageService._conversations[i].current_messages[MessageService._conversations[i].current_messages.length - 1].created_at)) < 0) {
          recent = MessageService._conversations[i];
        }
      }
      return recent;
    };

    MessageService.setCurrentConversation = function(conversation) {
      MessageService._current_conversation = conversation;
    };

    MessageService.getCurrentConversation = function() {
      return MessageService._current_conversation;
    };

    MessageService.buildMessages = function(conversations) {
      _.forEach(conversations, function(conversation) {
        _.forEach(conversation.current_messages, function(message, index) {
          conversation.current_messages[index] = new Message(message);
        });
      });
    };

    MessageService.pushMessage = function(conversation, message) {
      conversation.current_messages.push(message);
      return conversation;
    };

    MessageService.unshiftMessage = function(conversation, message) {
      conversation.current_messages.unshift(message);
      return conversation;
    };

    MessageService.addMessages = function(conversation, messages) {
      conversation.current_messages = messages;
      MessageService.buildMessages([conversation]);
    };

    MessageService.touch = function() {
      MessageService._last_updated = new Date();
    };

    MessageService.addConversation = function(conversation) {
      // place all new conversation directly under the last team conversation
      // if team conversation does not exist then place at top
      MessageService._conversations.splice((_.findLastIndex(MessageService._conversations, function(c) {
        return c.isTeam();
      }) + 1) || 0, 0, conversation);
      return conversation;
    };

    MessageService.moveToTop = function(conversation) {
      MessageService.removeConversation(conversation);
      MessageService.addConversation(conversation);
      MessageService.touch();
    };

    MessageService.deleteConversations = function(conversation) {
      _.remove(MessageService._conversations, {id: parseInt(conversation.id)});
    };

    MessageService.getConversations = function() {
      return MessageService._conversations;
    };

    MessageService.makeMembers = function(friends) {
      return friends.map(function(friend) {
        return {
          full_name: friend.friendee_full_name,
          image: friend.friendee.profile.image.url,
          friendee_id: friend.friendee_id
        }
      });
    };

    MessageService.friendList = function(friends, conversation) {
      return _.reject(friends, function(friend) {
        return _.find(conversation.members, {full_name: friend.full_name});
      });
    };

    MessageService.handleRealTimeMessage = function(message) {
      var conversation = MessageService.getConversationById(message.conversation_id);
      if(conversation) {
        var message = new Message(message);
        MessageService.pushMessage(conversation, message);
        if(!conversation.muted && ($state.current.name !== 'go.u.usermenu.conversation' && $state.params.conversationId != message.conversation_id)) {
          conversation.unseen = true;
        } else if (!conversation.muted) {
          var seenConvo = angular.copy(conversation);
          seenConvo.seen(function(){
            $rootScope.$broadcast('modelUpdate', {model:"Message"});
          });
        };
        MessageService.touch();
      }
    };

    MessageService.handleRealTimeConversation = function(conversation) {
      var oldConversation = MessageService.getConversationById(conversation.id);
      if(oldConversation){
        MessageService.removeConversation(oldConversation);
      };
      var conversation = new Conversation(conversation);
      MessageService.buildMessages([conversation]);
      MessageService.addConversation(conversation);
      MessageService.touch();
    };

    MessageService.handleRealTimeConversationRemove = function(id) {
      var convo = MessageService.getConversationById(id);
      if(convo) {
        MessageService.removeConversation(convo);
        convo.removed = true;
      };
    };

    MessageService.getConversationById = function(conversationId) {
      return _.find(MessageService._conversations, {id: parseInt(conversationId)});
    };

    MessageService.removeConversation = function(conversation) {
      _.remove(MessageService._conversations, {id: conversation.id});
    };

    MessageService.getLastUpdated = function() {
      return MessageService._last_updated;
    }

    MessageService.doExists = function(conversation, _exists_func, _notexists_func) {
      var convo = _.find(MessageService._conversations, function(c) {
        return angular.equals(c.memberNames(), conversation.memberNames()) 
               && c.conversation_type == conversation.conversation_type;
      });

      if(convo){
        return  _exists_func(convo);
      } else {
        return _notexists_func();
      };

    };

    MessageService.unseenCount = function() {
      return _.reduce(MessageService._conversations, function(sum, c) {
        return sum + (c.unseen ? 1 : 0);
      }, 0);
    };

    MessageService.unreadMessagesCount = function() {
      return _.reduce(MessageService._conversations, function(sum, c) {
        var last_seen_at = new Date(c.last_seen_at_milliseconds);
        return sum + _.reduce(c.current_messages, function(sum2, m) {
          var created_at = new Date(m.created_at_milliseconds);
          return sum2 + (!c.muted && c.members.length > 1 && m.action == "message" && (created_at > last_seen_at) ? 1 : 0);
        }, 0)
      }, 0);
    };

    MessageService.flush = function(){
      MessageService._conversations = [];
      MessageService._last_updated = null;
      MessageService._current_conversation = null;
      MessageService._has_loaded = false;
    };

    return MessageService;
  }
  ]);
'use strict';

angular.module('goApp')

.directive('scrollBottom', function ($timeout) {
  return {
    link: function (scope, element, attrs) {

      scope.scrollToBottom = function() {
        $timeout(function(){
          $(element).scrollTop($(element)[0].scrollHeight);
        });
      };

      scope.$watchCollection(attrs.scrollBottom, function (item) {
          scope.scrollToBottom($(element)[0].scrollHeight);
      });


    }
  }
})
'use strict';

angular.module('goApp')

.factory('UserConversation', ['ActiveResource', 'DOMAIN', 'ConversationMixins',
  function(ActiveResource, DOMAIN, ConversationMixins) {
    var UserConversation = ActiveResource('/conversations/:id', {
      domain: DOMAIN,
      nestedRoutes: ['index', 'show'],
      parentResource: 'User'
    }, {
        users: {
          method: 'POST',
          url: DOMAIN + '/conversations/:id/users'
        },
        seen: {
          method: 'POST',
          url: '/seen'
        }
    });


    angular.extend(UserConversation.prototype, ConversationMixins.prototype);

    return UserConversation;
  }
])

'use strict';

angular.module('goApp').service('MainNavigation', function($rootScope, $state, $q, $location, HesNavigationConfig, CurrentUser, CurrentSite) {
  var MainNavigation = new Object();

  var cached = null;
  var role = "";
  var deferred = null;
  

  MainNavigation.get = function(refresh) {
    if (deferred && deferred.promise.$$state.status == 0) {
      return deferred.promise;
    }

    deferred = $q.defer();

    if (!cached || refresh) {
      cached = new HesNavigationConfig();
      cached.turnOffAllMenus();
      CurrentSite.get().then(function(site){
        _.each(Object.keys(site.flags), function(flag) {
          if(site.flags[flag] && site.features_on) {
            cached.showRole(flag);
          }
        });
        CurrentUser.get().then(function(user){
          role = user.role;
        }).finally(function(){
          cached.showRole(role);
          deferred.resolve(cached);
        });
      });
    } else {
      deferred.resolve(cached);
    }

    deferred.promise.finally(function(){
      redirect_if_unauthorized();
    });

    return deferred.promise;
  }

  $rootScope.$on("userLoggedOut", function() {
    cached = null;
  });

  $rootScope.$on('$stateChangeSuccess', redirect_if_unauthorized);


  function redirect_if_unauthorized() {
    var nav = cached && cached.findMenuByLink($state.current.name);
    if (nav) {
      if(!nav.active) {
        console.log(nav);
        $location.path("/");
      }
    }
  }

  return MainNavigation;
});
'use strict';

angular.module('goApp')

  .factory('HesNavigationConfig', ['$rootScope', 'HesNavigation', '$state', 'CurrentSite', 'GOKP_MIGRATION_DATE', 'WELLPATH_MIGRATION_YEAR', 'ContentLoader', 'Content',
    function($rootScope, HesNavigation, $state, CurrentSite, GOKP_MIGRATION_DATE, WELLPATH_MIGRATION_YEAR, ContentLoader, Content) {
      return function(location) {
        var navigation = new HesNavigation();
        var userYear

        if ($rootScope.user && $rootScope.user.profile) {
          userYear = new Date($rootScope.user.profile.started_on)
        }

        //// Dashboard's menu ////
        navigation.addMenu('go.u.master', null, {
          roles: ['Master'],
        }, function() {
          this.addMenu('go.u.sites', 'Sites', {
            roles: ['Master'],
          });
          this.addMenu('go.u.billboards', 'Default Heros', {
            roles: ['Master'],
            params:{
              group: 'hero'
            },
            linkOpts: {
              reload: true,
              inherit: false //Do not inherit params for a route, if user is on site page, we only want the above params
            }
          });
          // this.addMenu("go.u.queued_emails", "Queued Emails", {
          //   roles: ["Master"]
          // })
        });

        //// Home button ////
        navigation.addMenu('go.u.home', null, {
          roles: 'all',
          hidden: true,
          joinedGroup: 1
        }, function() {
          this.addMenu('go.u.home', 'Home', {
            roles: 'all'
          });
        });


        //// First column ////
        navigation.addMenu('go.u.personal', null, {
          roles: ['is_logging_enabled', 'is_stats_enabled', 'is_badges_enabled', 'is_notifications_enabled'],
          joinedGroup: 1,
        }, function() {
          this.addMenu('go.u.personal.entries', 'Log Activity', {
            roles: ['is_logging_enabled'],
            siteMapHidden: !$rootScope.site.flags.is_logging_enabled,
            params: {
              year: $rootScope.site.years[0]
            }
          }, function() {
            var that = this;
            _.each($rootScope.site.years, function(year) {
              var dateYear = new Date(year+1, 0)
              that.addMenu('go.u.personal.entries', year, {
                roles: ['is_logging_enabled'],
                frame: 'logging-frame',
                hidden: userYear > dateYear,
                params: {
                  year: year
                }
              });
            });
          });
          this.addMenu('go.u.personal.stats', 'Stats', {
            roles: ['is_stats_enabled'],
            siteMapHidden: false,
            params: {
              year: $rootScope.site.years[0]
            }
          }, function() {
            var that = this;
            _.each($rootScope.site.years, function(year) {
              var dateYear = new Date(year+1, 0)
              that.addMenu('go.u.personal.stats', year, {
                roles: ['is_stats_enabled'],
                hidden: userYear > dateYear,
                params: {
                  year: year
                }
              });
            });
            // HACK for gokp
            var days_from_gokp_migration = $rootScope.user && moment($rootScope.user.profile.started_on).diff(GOKP_MIGRATION_DATE, "days");
            if (/^kp/.test($rootScope.site.default_url) || /gokp/.test($rootScope.site.default_url) || /^nathan/.test($rootScope.site.default_url) && typeof days_from_gokp_migration == 'number' && days_from_gokp_migration < 0) {
              that.addMenu('go.u.personal.gokp_legacy_stats', "Legacy");
            } else if (/^wellpathwellness/.test($rootScope.site.default_url)){
                var migrationYear = WELLPATH_MIGRATION_YEAR;
                if (!!$rootScope.user) {
                  var userStartYear = moment(
                    $rootScope.user.profile.started_on
                  ).year();
                } else {
                  var userStartYear = new Date().getFullYear();
                }
                if (migrationYear > userStartYear) {
                  var userPremigrationYears = migrationYear - userStartYear;

                  //There are only 2 years from launchpad for MidMichigan.
                  var years = [2020, 2019].slice(0, userPremigrationYears);
                  _.each(years, function (year) {
                    var dateYear = new Date(year+1, 0)
                    that.addMenu('go.u.personal.legacy_stats', year, {
                      roles: ['is_stats_enabled'],
                      hidden: userYear > dateYear,
                      params: {
                        year: year,
                      },
                    });
                  });
                }
            }
          });
          this.addMenu('go.u.usermenu.badges', 'Badges', {
            roles: ['is_badges_enabled'],
            siteMapHidden: !$rootScope.site.flags.is_badges_enabled,
            params: {
              year: $rootScope.site.years[0]
            }
          }, function() {
            var that = this;
            _.each($rootScope.site.years, function(year) {
              var dateYear = new Date(year+1, 0)
              that.addMenu('go.u.usermenu.badges', year, {
                roles: ['is_badges_enabled'],
                hidden: userYear > dateYear || ($rootScope.site.flags.is_wustl && year < 2026),
                params: {
                  year: year
                }
              });
            });
          });
          this.addMenu('go.u.personal.notifications_unread', 'Notifications', {
              roles: ['is_notifications_enabled'],
              siteMapHidden: !$rootScope.site.flags.is_notifications_enabled,
            },
            function() {
              this.addMenu('go.u.personal.notifications_unread', 'New');
              this.addMenu('go.u.personal.notifications_all', 'Cleared');
            });
        });


        //// Second column ////
        // this is a logical grouping and will never be shown as a link
        navigation.addMenu('go.u.content', null, {
          roles: ['is_wall_enabled', 'is_peers_enabled', 'is_challenges_enabled', 'is_goal_enabled'],
          joinedGroup: 2,
        }, function() {

          /// WALL ///
          this.addMenu('go.u.content.wall.all', 'Wall', {
            roles: ['is_wall_enabled'],
            siteMapHidden: !$rootScope.site.flags.is_wall_enabled,
          }, function() {
            this.addMenu('go.u.content.wall.all', 'All Posts');
            this.addMenu('go.u.content.wall.single', '', {
              hidden: true,
              active: false
            });
            this.addMenu('go.u.content.wall.filtered', 'My Posts', {
              params: {
                filter: 'my'
              }
            });
            this.addMenu('go.u.content.wall.filtered', $rootScope.site.friend_label_plural, {
              params: {
                filter: 'friends'
              }
            });
            this.addMenu('go.u.content.wall.following', 'Following', {
              active_regex: /\/wall\/\d+$/
            });
            this.addMenu('go.u.content.wall.filtered', 'Tagged', {
              params: {
                filter: 'tagged'
              }
            });
            if ($rootScope.site.hasGuidelines()) {
              this.addMenu('go.u.content.wall.guidelines', 'Guidelines', {
                hidden: false,
                params: {
                  filter: 'guidelines'
                }
              });
            }
          });

          /// FRIENDS ///
          this.addMenu('go.u.usermenu.friends.list', $rootScope.site.friend_label_plural, {
            roles: ['is_peers_enabled'],
            siteMapHidden: !$rootScope.site.flags.is_peers_enabled,
          }, function() {
            this.addMenu('go.u.usermenu.friends.list', 'My ' + $rootScope.site.friend_label_plural);
            this.addMenu('go.u.usermenu.friends.pending', 'Pending');
          });

          /// CHALLENGES ///
          this.addMenu('go.u.usermenu.challenges.active', 'Challenges', {
              roles: ['is_challenges_enabled'],
              siteMapHidden: !$rootScope.site.flags.is_challenges_enabled,
            },
            function() {
              this.addMenu('go.u.usermenu.challenges.active', 'My Challenges');
              this.addMenu('go.u.usermenu.challenges.history', 'History');
              this.addMenu('go.u.usermenu.challenges.select_user', 'Select User', {
                hidden: true
              });
              this.addMenu('go.u.usermenu.challenges.select_challenge', 'Select Challenge', {
                hidden: true
              });
            });

          /// GOALS ///
          this.addMenu('go.u.personal.goals.active', 'Goals', {
            roles: ['is_goal_enabled'],
            siteMapHidden: !$rootScope.site.flags.is_goals_enabled,
          }, function() {
            this.addMenu('go.u.personal.goals.active', 'My Goals');
            this.addMenu('go.u.personal.goals.history', 'History');
            this.addMenu('go.u.personal.goals.choose', 'Choose', {
              hidden: true
            });
            this.addMenu('go.u.personal.goals.create', 'Create', {
              hidden: true
            });
          });
        });


        //// Third column ////
        navigation.addMenu('go.u.usermenu', null, {
          roles: ['is_resources_enabled', 'is_recipes_enabled', 'is_tips_enabled'],
          joinedGroup: 3,
        }, function() {
          // this is a parent link, these get shown in the drawer and are top level tabs
          this.addMenu('go.u.content.recipes.today', 'Recipes', {
            roles: ['is_recipes_enabled'],
            siteMapHidden: !$rootScope.site.flags.is_recipes_enabled,
          }, function() {
            // this is a child link, these do not get shown in the drawer and are second level tabs
            this.addMenu('go.u.content.recipes.today', "Today's");
            this.addMenu('go.u.content.recipes.all', "All", {
              active_regex: /\/recipe\/\d+$/
            });
            this.addMenu('go.u.content.recipes.single', '', {
              hidden: true,
              active: false
            });
          });
          this.addMenu('go.u.content.tips.today', 'Tips', {
            roles: ['is_tips_enabled'],
            siteMapHidden: !$rootScope.site.flags.is_tips_enabled,
          }, function() {
            this.addMenu('go.u.content.tips.today', "Today's");
            this.addMenu('go.u.content.tips.all', "All", {
              active_regex: /\/tip\/\d+$/
            });
            this.addMenu('go.u.content.tips.single', '', {
              hidden: true,
              active: false
            });
          });
          this.addMenu('go.u.content.resources.all', 'Resources', {
            roles: ['is_resources_enabled'],
            siteMapHidden: !$rootScope.site.flags.is_resources_enabled,
          }, function() {
            this.addMenu('go.u.content.resources.all', "Resources");
          });
        });

        //// User menu ////
        navigation.addMenu('go.u.settings', null, {
          roles: 'all',
          joinedGroup: 3,
          hidden: true,
        }, function() {
          this.addMenu('go.u.settings.main', 'Settings', {
              roles: 'all'
            },
            function() {
              this.addMenu('go.u.settings.main', 'Personal');
              if ($rootScope.site.flags.is_launchpad_plus) {
                this.addMenu('go.u.settings.email', 'Email Preferences', {
                  roles: 'all',
                });
              }
              if ($rootScope.site.hasDevicesEnabled() && (($rootScope.site.flags.is_launchpad_plus && $rootScope.site.features_on) || $rootScope.site.flags.is_aktivetrak)) {
                this.addMenu('go.u.settings.tracking', 'Tracking Method');
              }
            });
        });

        navigation.addMenu('go.u.coordinator', null, {
          roles: ['Coordinator', 'Location Coordinator', 'Regional Coordinator'],
          hidden: true
        }, function() {
          this.addMenu('go.u.coordinator.helm', 'Dashboard', {
            roles: ['Coordinator', 'Location Coordinator', 'Regional Coordinator'],
          }, function() {
            if (!$rootScope.site.flags.is_aktivetrak && !($rootScope.site.features_on && $rootScope.site.programs.reporting && $rootScope.site.programs.reporting.length == 0)) {
              this.addMenu('go.u.coordinator.program_reports', 'Program Reports');
            };

            if (($rootScope.site.programs.upcoming && $rootScope.site.programs.upcoming.length != 0) || $rootScope.site.hasComingSoonPrograms()) {
              this.addMenu('go.u.coordinator.upcoming_launches', 'Upcoming Launches');
            };

            if ($rootScope.user) {
              if ($rootScope.user.isRegionalCoordinatorOrAbove()) {
                this.addMenu('go.u.coordinator.notifications', 'Send Notification', {
                  roles: ['is_notifications_enabled', 'Coordinator', 'Regional Coordinator']
                });
                this.addMenu('go.u.coordinator.stats', 'Stats', {
                  roles: ['is_stats_enabled']
                });
                this.addMenu('go.u.coordinator.participants', 'Participants', {
                  roles: ['Coordinator']
                });
              }
            }

            if ($rootScope.user) {
              if ($rootScope.user.isRegionalCoordinatorOrAbove()) {
                this.addMenu('go.u.coordinator.reporting', $rootScope.site.name + ' Reporting', {
                  roles: ['Coordinator', 'Regional Coordinator']
                });
              }
            }

            if ($rootScope.user) {
              if ($rootScope.user.isCoordinatorOrAbove()) {
                this.addMenu('go.u.coordinator.flagged_posts', 'Flagged Posts', {
                  roles: ['is_wall_enabled']
                });
                if ($rootScope.site.flags.is_eligibility_displayed) {
                  this.addMenu('go.u.coordinator.eligibility', 'Eligibility', {
                    roles: ["Coordinator"]
                  });
                }
              }
            }
          });
        });

        navigation.addMenu('go.u.wallexpert', null, {
          roles: ['Poster']
        }, function() {
          this.addMenu('go.u.wallexpert.posts', 'My Posts', {
            roles: ['Poster']
          });
          this.addMenu('go.u.wallexpert.walls', 'Site Walls', {
            roles: ['Poster']
          });
        });

        navigation.addMenu('go.u.evaluations', null, {
          roles: 'all',
          hidden: true,
        }, function() {
          this.addMenu('go.u.evaluations.current', 'Evaluation', {
            roles: 'all'
          });
        });

        //// HELP ////
        navigation.addMenu('go.help', null, {
          roles: 'all',
          hidden: true,
          joinedGroup: 1,
        }, function() {
          this.addMenu("go.help", ($rootScope.site.flags.is_faqs_enabled ? "Help" : "Contact"), {
            roles: 'all'
          }, function() {
            if ($rootScope.site.flags.is_faqs_enabled) {
              this.addMenu('go.help.faqs', 'FAQs', {
                roles: 'all'
              });
            }
            this.addMenu('go.help.contact', 'Contact', {
              roles: 'all'
            });
          });
        });

        navigation.addMenu('go.give', null, {
          roles: 'all',
          hidden: true,
          siteMapHidden: !$rootScope.site.flags.is_feedback_enabled,
          joinedGroup: 3,
        }, function() {
          this.addMenu('go.give.feedback', 'Feedback', {
            roles: 'all',
          });
        });

        navigation.addMenu('go.map', null, {
          roles: 'all',
          joinedGroup: 3,
          hidden: true,
        }, function() {
          this.addMenu('go.map.site_map', 'Site Map', {
            roles: 'all',
            hidden: !$rootScope.user,
          });
        });

        navigation.addMenu('go.privacy_terms', null, {
          roles: 'all',
          joinedGroup: 2,
          hidden: true,
        }, function() {
          var label = "";
          if ($rootScope.site.flags.is_privacy_enabled && $rootScope.site.flags.is_terms_enabled) {
            label = "Privacy & Terms";
          } else if ($rootScope.site.flags.is_privacy_enabled) {
            label = "Privacy";
          } else if ($rootScope.site.flags.is_terms_enabled) {
            label = "Terms"
          }
          this.addMenu("go.privacy_terms", label, {
            roles: 'all'
          }, function() {
            if ($rootScope.site.flags.is_privacy_enabled) {
              this.addMenu('go.privacy_terms.privacy', 'Privacy', {
                roles: 'all'
              });
            }
            if ($rootScope.site.flags.is_terms_enabled) {
              this.addMenu('go.privacy_terms.terms', 'Terms', {
                roles: 'all'
              });
            }
          });
        });

        return navigation;
      };
    }
  ]);
'use strict';

angular.module('goApp').controller('NavigationCtrl', function(
	$scope, $rootScope, MainNavigation) {

	init();

	$scope.$on("userLoggedIn", function() {
		init();
	});

	function init() {
		MainNavigation.get(true).then(function(navigation) {
			$scope.navigation = navigation;
		});
	}

});
'use strict';

angular.module('goApp')

.factory('HesNavigation', ['HesArray', 
	function(HesArray) {
		var Navigation = function() {
			var _indexedMenus = {};
			var menuIdentity = 0;
			var visibleRoles = [];

			this.childMenus = [];

			// Creates a new menu.
			var createMenu = function(link, name /*, options, addFunction*/ ) {
				var menu, options, addFunction;

				if(arguments.length > 2) {
					if(angular.isFunction(arguments[2])) {
						options = {
							parent: this
						};
						addFunction = arguments[2];
					}
					else {
						options = arguments[2];
						options.parent = this;
						addFunction = arguments[3];
					}
				}
				else {
					options = {
						parent: this
					};
				}

				menu = new Menu(link, name, options);

				if(this.roles && this.roles !== 'all' && menu.roles === 'all') {
					menu.roles = this.roles;
				}

				this.childMenus.push(menu);
				menuIdentity += 1;
				menu.id = menuIdentity;
				_indexedMenus[menu.id] = menu;

				if(addFunction) {
					addFunction.call(menu);
				}

				return menu;
			};

			// Adds a menu to the navigation.
			this.addMenu = function() {
				return createMenu.apply(this, arguments);
			};

			// Finds a menu in the navigation.
			this.findMenu = function(id) {
				return _indexedMenus[id];
			};

			this.findMenuByName = function(menuName) {
				return _.filter(_indexedMenus, {name: menuName})[0];
			};

			this.findMenuByLink = function(menuLink) {
				return _.findLast(_indexedMenus, {link: menuLink});
			};

			// Makes a menu inactive.
			this.turnOffMenu = function(id) {
				if(this.findMenu(id)) {
					this.findMenu(id).turnOff();
				}
			};

			// Makes a menu active.
			this.turnOnMenu = function(id) {
				if(this.findMenu(id)) {
					this.findMenu(id).turnOn();
				}
			};

			// Displays all menus tied to a given role.
			this.showRole = function(role) {
				visibleRoles.push(role);
				this.makeVisible();
			};

			this.getVisibleItemsAmount = function() {
				return _.filter(_indexedMenus, function (menuItem) {
					return menuItem.active;
				}).length;
			};

			// Makes menus visible based on visible roles.
			this.makeVisible = function() {
				var menu, id;
		
				for(id in _indexedMenus) {
					menu = _indexedMenus[id];

					if(menu.visibleForRoles(visibleRoles)) {
						menu.turnOn();
					} else if (menu.isParentActive()) {
						menu.turnOn();
					}
				}
			};

			// Hides all menus tied to a given role.
			this.hideRole = function(role) {
				var savedVisibleRoles;
				savedVisibleRoles = HesArray.remove(visibleRoles, role);
				this.turnOffAllMenus();
				visibleRoles = savedVisibleRoles;
				this.makeVisible();
			};

			// Turns off all menus.
			this.turnOffAllMenus = function() {
				var id;
				
				for (id in _indexedMenus) {
					_indexedMenus[id].turnOff();
				}

				visibleRoles = [];
			};

			// Structure for menus.
			var Menu = function(link, name, options) {
				options = angular.extend({
					roles: [], // used to be 'all'
					parent: null,
					active: true,
					hidden: false,
					hideText: false,
					name: null,
					imageUrl: '',
					searchable: false,
					frame: '',
					params: {},
					joinedGroup: 0,
					siteMapHidden: false,
          			linkOpts: {}
				}, options || {});

				this.link = link;
				this.name = name;
				this.parent = options.parent;
				this.hidden = options.hidden;
				this.active = options.active;
				this.hideText = options.hideText;
				this.params   = options.params;
				this.active_regex = options.active_regex;
				this.roles = options.roles === 'all' ? options.roles : typeof options.roles === 'object' ? options.roles : [options.roles];
				this.childMenus = [];
				this.id = null;
				this.imageUrl = options.imageUrl;
				this.searchable = options.searchable;
				this.frame = options.frame;
				this.joinedGroup = options.joinedGroup;
				this.siteMapHidden = options.siteMapHidden;
        		this.linkOpts = options.linkOpts
			};

			// Gets the ID of a menu.
			Menu.prototype.getId = function() {
				return this.id;
			};

			// Gets the name of a menu.
			Menu.prototype.getName = function() {
				// return $inflector.underscore(this.name);
				return this.name;
			};

			// Gets the text of a menu.
			Menu.prototype.getText = function() {
				return !this.hideText ? this.name : '';
			};

			// Adds a child menu.
			Menu.prototype.addMenu = function() {
				return createMenu.apply(this, arguments);
			};

			// Makes a menu inactive.
			Menu.prototype.turnOff = function() {
				this.active = false;
			};

			// Makes a menu active.
			Menu.prototype.turnOn = function() {
				this.active = true;
			};

			Menu.prototype.isActive = function() {
				return this.active || this.isParentActive();
			}

			Menu.prototype.isParentActive = function() {
				return this.roles.length == 0 && this.parent.name && this.parent.active;
			}


			Menu.prototype.getImageUrl = function(){
				return this.imageUrl;
			};

			Menu.prototype.isSearchable = function(){
				return this.searchable;
			};

			// Checks to see if a menu is visible for visible roles.
			Menu.prototype.visibleForRoles = function(roles) {
				if(this.roles === 'all') {
					return true;
				}

				if(typeof roles !== 'object') {
					roles = [roles];
				}

				return HesArray.includes(this.roles, roles);
			};

			// Adds a role to a menu.
			Menu.prototype.addRole = function(role) {
				if(this.roles === 'all') {
					this.roles = [];
				}

				this.roles.push(role);

				return this;
			};

			// Removes a role from a menu.
			Menu.prototype.removeRole = function(role) {
				if(this.roles === 'all') {
					throw 'Cannot remove a role since all roles are allowed';
				}

				HesArray.remove(this.roles, role);

				return this;
			};
			
			// return all active menus
			Menu.prototype.menus = function() {
				return _.filter(this.childMenus, {active:true, hidden: false});
			};

			Menu.prototype.getDefaultLink = function() {
				var _menus = this.menus() || [];
				if(!_menus[0]) {
					return this.link;
				}
				return _menus[0].link;
			};


			Menu.prototype.parentGroup = function() {
				var parts = this.link.split(".");

				var group_state = [];
				group_state.push(parts[0]);
				group_state.push(parts[1]);
				
				// NOTE NP: only append parts[2] if state requires the user resolve
				if (_.includes(parts,"u")) {
					group_state.push(parts[2]);
				}

				return _.find(_indexedMenus, {
					link: group_state.join('.')
				});
			}

	};

	// Returns all active menus.
	Navigation.prototype.menus = function() {
		return _.filter(this.childMenus, {active:true,hidden:false});
	};



		return Navigation;
	}
]);
'use strict';

angular.module('goApp').directive('hesAlert', function(hesTemplateService, $rootScope, $timeout, $state, $location, BadgeService) {
  // Runs during compile
  return {
    controller: 'AlertController',
    restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
    templateUrl: hesTemplateService.getTemplateUrl('/scripts/notifications/alert.html'),
    link: function($scope, $element, $attrs, controller) {
      var alertbox = $element.find('.notification-alert');
      var alertTimer = null;


      $scope.showAlert = function(opts) {
        alertbox.tabIndex = 0;
        var opts = _.merge({
          hide: true
        }, opts);

        TweenMax.to(alertbox, 0.5, {
          right: 25
        });

        if (alertTimer) {
          $timeout.cancel(alertTimer);
        }

        alertTimer = $timeout(function() {
          if(opts.hide){
            $scope.hideAlert();
          }
        }, 7500);

      };

      $scope.hideAlert = function() {
        $timeout.cancel(alertTimer);
        alertbox.tabIndex = -1;
        TweenMax.to(alertbox, 0.5, {
          right: -320
        });
      };

      $scope.goToNotificationLink = function(alert) {
        if(alert.no_click == true) {
          return;
        }
        $scope.hideAlert();
        TweenMax.to(alertbox, 0, {
          right: -320
        });
        alert.goToLink();
      };
    }
  };
}).controller('AlertController', function($scope, $location, BadgeService, $rootScope, $state) {

  // Listens for new notifications from the Notification resource.
  $scope.$on('notificationPublished', function(event, notification) {
    buildAlert();
    notification.message = notification.message.replace(/<(.|\n)*?>/g, ''); // XXS issue patch
    $scope.alert = notification;
    $scope.alert.is_message = false;
    $scope.alert.type = notification.getType() || 'wall_post';


    if (!/NO_POPUP/.test(notification.key) && $scope.alert.type != 'coordinator') {
      $scope.showAlert();
    }
  });


  function buildAlert() {
    $scope.alert = {
      title: 'New Message',
      message: ''
    };
  }

  $rootScope.testAlert = function(msg,type,title) {
    buildAlert();
    $scope.alert.title = title;
    $scope.alert.type = type;
    if(title){$scope.alert.is_message=true;}
    if($scope.alert.type == 'badge'){
      $scope.alert.from_user = $scope.user;
    }
    $scope.alert.message = msg;
    $scope.showAlert({hide:false});
  }

  $scope.isAlertShown = function() {
    return document.querySelector('.notification-alert').tabIndex == 0
  }

});

'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.u.personal.notifications_unread', {
    controller: 'NotificationsController',
    url: '/notifications/unread',
    title: 'New',
    templateProvider: ['hesTemplateService', function(hesTemplateService) {
      return hesTemplateService.getTemplate('/scripts/notifications/notifications.html');
    }]
  });

  $stateProvider.state('go.u.personal.notifications_all', {
    controller: 'NotificationsController',
    url: '/notifications/all',
    title: 'Cleared',
    templateProvider: ['hesTemplateService', function(hesTemplateService) {
      return hesTemplateService.getTemplate('/scripts/notifications/notifications.html');
    }]
  });


});
'use strict';

angular.module('goApp').controller("NotificationsController", function($scope, $rootScope, $location, $state, Notification) {
  $scope.data = new Object();
  $scope.data.is_loading = true;

  var filter = $state.current.name == 'go.u.personal.notifications_all' ? "all" : "unread";

  Notification.markAllAsSeen({ids: 'all'});

  $rootScope.clearAllNotifications = function() {
    Notification.markAllAsRead({ids: 'all'}).$promise.then(function(){
      $scope.data.notifications = [];
      $rootScope.$broadcast('modelUpdate', {model:"Notification"});
    });
  }

  $scope.clear = function($event, notification) {
    $event.stopPropagation();
    notification.markAsRead().then(function(newNotif) {
      var index = $scope.data.notifications.indexOf(notification);
      $scope.data.notifications.splice(index, 1);
    })
  }

  Notification.index({page_size:0, filter: filter}, function(notifications){
    $scope.data.notifications = notifications;
    $scope.data.is_loading = false;
  })
});

'use strict';

angular.module('goApp').factory('Notification', ['DOMAIN', '$rootScope', '$filter', '$timeout', '$http', 'ActiveResource', 'HesDate', '$q', '$location',
  function(DOMAIN, $rootScope, $filter, $timeout, $http, ActiveResource, HesDate, $q, $location) {
    var Notification = ActiveResource('/notifications/:id', {
      nestedRoutes: ['index', 'create'],
      parentResource: 'Promotion',
      domain: DOMAIN
    }, {
      markAllAsRead: {
        method: "POST",
        url: "/mark_as_read",
        isArray: false
      },
      markAllAsSeen: {
        method: "POST",
        url: "/mark_as_seen",
        isArray: false
      }
    });

    Notification.prototype.getCreatedOn = function(){
      return HesDate.momentFormat(this.updated_at, 'L');
    };

    Notification.prototype.fromCreatedOn = function() {
      return moment(this.created_at).fromNow();
    }

    Notification.prototype.fromUpdatedOn = function() {
      return moment(this.created_at).fromNow();
    }

    var defered_count = null;
    Notification.count = function() {
      if (defered_count && defered_count.promise.$$state.status == 0) {
        return defered_count.promise;
      }
      var defered_count = $q.defer();
      
      $http.get(DOMAIN + '/notifications/count',{isArray:false}).then(function(response){
        defered_count.resolve(response.data);
      }).finally(function(){
        defered_count = null;
      });

      return defered_count.promise;
    }


    Notification.prototype.getType = function() {
      var type;
      if (this.key.indexOf('post') > -1)
        type = 'wall_post';
      else if (this.key.indexOf('message') > -1)
        type = 'message';
      else if (this.key.indexOf('team') > -1)
        type = 'team';
      else if (this.key.indexOf('friend') > -1)
        type = 'friend';
      else if (this.key.indexOf('device') > -1 || this.key.indexOf('FITBIT') > -1 || this.key.indexOf('VALIDIC') > -1)
        type = 'device';
      else if (this.key.indexOf('badge') > -1)
        type = 'badge';
      else if (this.key.indexOf('challenge') > -1)
        type = "challenge";
      else if (this.key.indexOf('coordinator') > -1)
        type = "coordinator";
      return type;
    };

    Notification.prototype.formatDate = function(relativeTime) {
      if (relativeTime) {
        return moment(new Date(this.updated_at)).fromNow();
      } else {
        return ($filter('date')(this.updated_at, 'M/d') + ', ' + $filter('date')(this.updated_at, 'h:mma')).toLowerCase();
      }
    };


    // Notification.markAllAsSeen = function() {
    //   return $http.post(DOMAIN + '/notifications/mark_as_seen', {ids: 'all'});
    // };

    Notification.prototype.markAsRead = function() {
      return $http.post(DOMAIN + '/notifications/mark_as_read', {ids: this.id});
    };

    Notification.prototype.goToLink = function() {
      var params = {};
      switch(this.getType()){
        case "badge":
         params.badge_id = this.key.split("_")[2];
         $location.path(this.link).search(params);
        case "challenge":
          params.challenge_id = this.key.split("_")[3];
          this.link = this.link.split("?")[0];
          case "friend":
          params.friend_id = this.key.split("_")[1];
          this.link = this.link.split("?")[0];
        }
        if (this.link && this.link != "") {
          $location.path(this.link);
        }
    }

    return Notification;
  }
]);
'use strict';

angular.module('goApp')
  .factory('Organization', ['$http', 'ActiveResource', 'DOMAIN', 'HesDate',
    function($http, ActiveResource, DOMAIN, HesDate) {

      var Organization = ActiveResource('/organizations/:id', {
        nestedRoutes: ['index'],
        parentResource: 'Reseller',
        domain: DOMAIN
      });

      return Organization;
    }
  ]);
'use strict';

angular.module('goApp')

.controller('ForgottenPasswordCtrl', function($scope, PasswordResetService, $timeout, $state, ngDialog, User, ErrorService, ContentLoader, Content, DialogService, $interpolate, $rootScope, Utils) {

		$scope.submittedForgottenPassword = false;
		$scope.submitted = false;
		$scope.settings = {
			contents: []
		};
	
		$scope.emailInvalidMessage = 'Must be a valid email address.<br/>Ex: name@yourdomain.com';
		$scope.emailNotFoundMessage = '<img class="invalid-image" src="/images/default/icons/error.png" style="float: left;">&nbsp;No account was found with that email.'

		function closeModal() {
			$scope.$emit('cancelForgottenPassword');
		}

		function initializePasswordUser() {
			$scope.passwordUser = {
				email: ''
			};
		}

		$scope.sanitizeEmail = function(value) {
			if (!value) return value;
			return value
			  .replace(/\u2018/g, "'")
			  .replace(/\u2019/g, "'")
			  .replace(/\u00A0/g, ' ')
			  .replace(/\u200B/g, '')
			  .trim();
		  };

		$scope.cancelForgottenPassword = function() {
			closeModal();
			ngDialog.closeAll();
		};

		$scope.contactUs = function() {
			$rootScope.redirecting = true
			ngDialog.closeAll();
			$state.go('go.help.contact');
		};

		$scope.submitForgottenPassword = function() {
			ErrorService.clearErrors();
			$scope.login_error = false;
			$scope.passwordUser.email = $scope.sanitizeEmail($scope.passwordUser.email);
			$scope.email_invalid = !Utils.isEmail($scope.passwordUser.email);
			if($scope.email_invalid){
			  return;
			}
	
			if ($scope.passwordUser.email !== '' && $scope.submitted === false) {
				$scope.submitted = true;
				User.validate($scope.site.id, {
					field: "email",
					value: $scope.passwordUser.email
				}).then(function(response) {
					$scope.submitted = false;
					ErrorService.showErrors({}, $scope.emailNotFoundMessage, 1);
					$scope.login_error = true;
				}, function(response) {
					ErrorService.clearErrors();
					$scope.login_error = false;
					PasswordResetService.forgotPassword($scope.passwordUser.email, $scope.site.id);
					$scope.settings.sentEmailContent = $interpolate($scope.settings.sentEmailMessage.content)({
						email: $scope.passwordUser.email
					});
					$scope.submitted = false;
					$scope.submittedForgottenPassword = true;
					$rootScope.redirecting = true;
				});
			}	
		};

		initializePasswordUser();

		new ContentLoader({
			category: 'reset_password'
		}).then(function(contents) {
			$scope.settings.contents = contents;
			$scope.settings.sentEmailMessage = Content.getByKey($scope.settings.contents, 'forgot_password', true);
		});

	}
);
'use strict';

angular.module('goApp')

.service('PasswordResetService', ['$http', 'DOMAIN',
    function($http, DOMAIN) {

        var PasswordResetService = {

            forgotPassword: function(email, site_id) {
                var data = {
                    email: email
                };

                return $http.post(DOMAIN + '/sites/' + site_id + '/users/forgot', data);
            },

            resetPassword: function(id, password) {
                var data = {
                    thing: id,
                    password: password
                };

                return $http.put(DOMAIN + '/users/password_reset', data);
            },

            verifyResetPassword: function(id) {
                var data = {
                    thing: id
                };

                return $http.post(DOMAIN + '/users/verify_password_reset', data);
            }
        };

        return PasswordResetService;
    }
]);
// 'use strict';

// angular.module('goApp')

// .config(['$stateProvider',
// 	function($stateProvider) {
// 		$stateProvider
// 			.state('go.passwordReset', {
// 				url: '/password_reset/:id',
// 				title: 'RESET PASSWORD',
// 				controller: 'ResetPasswordCtrl',
// 				abstract: false,
// 				templateProvider: ['hesTemplateService',
// 		        	function(hesTemplateService) {
// 		        		return hesTemplateService.getTemplate('/scripts/password/reset_password.html');
// 		        	}
// 		        ],
// 		        resolve: {
// 		        	allow: ['PasswordResetLoader', '$stateParams',
// 		        		function(PasswordResetLoader, $stateParams) {
// 		        			return new PasswordResetLoader($stateParams.id)
// 		        		}
// 		        	],

// 		        	id: ['$stateParams',
// 		        		function($stateParams) {
// 		        			return $stateParams.id;
// 		        		}
// 		        	]
// 		        }
// 			});
// 	}
// ]);
'use strict';

angular.module('goApp')

.factory('PasswordResetLoader', ['$q', 'PasswordResetService', function($q, PasswordResetService) {
  return function PasswordResetInit(id) {
    
    var defer = $q.defer();

    PasswordResetService.verifyResetPassword(id).then(function(response) {
      defer.resolve(response.data);
      return response.data;
    }, function() {
      defer.reject('Cannot verify reset password token.');
    });

    return defer.promise;
  };
}]);
'use strict';

angular.module('goApp')
  .controller('PilotPasswordController', ['$scope', 'CurrentPromotion', 'ngDialog', 'ErrorService', '$state', 'ipCookie',
    function($scope, CurrentPromotion, ngDialog, ErrorService, $state, ipCookie) {
      $scope.settings = {
        loading: true
      };

      $scope.data = {
        pilotPassword: '',
        incorrectPassword: false
      };

      CurrentPromotion.get().then(function(promotion){
        $scope.settings.loading = false;
      });

      $scope.verifyPilotPassword = function(){
        $scope.site.verifyPilotPassword($scope.data.pilotPassword, function(response){
          ngDialog.close();
          ipCookie('pilotPassword', response.message, { expires: 1 });
          $state.go('go.welcome', {pilotPassword: $scope.data.pilotPassword});
        }, function(){
          $scope.data.incorrectPassword = true;          
        });
      };

      $scope.ariaClickEnter = function($event) {
        if ($event.keyCode == 13 || $event.keyCode == 32) {
          $event.preventDefault();
          window.setTimeout(function() {
            $('.pilot-password button').click();
          }, 0);
        }
      }
    }
  ]);
'use strict';

angular.module('goApp')

.controller('ResetPasswordCtrl', ['$scope', 'PasswordResetService', 'PasswordResetLoader', '$state', 'ErrorService', 'ContentLoader', 'Content', 'DialogService', '$interpolate', 'ngDialog',
    function($scope, PasswordResetService, PasswordResetLoader, $state, ErrorService, ContentLoader, Content, DialogService, $interpolate, ngDialog) {

        $scope.settings = {
            loading: true
        };

		$scope.resetSuccess = false;

        $scope.passwordUser = {
            password: '',
            passwordConfirmation: '',
            email: ''
        };

        function initializePasswordReset() {
            new PasswordResetLoader($state.params.reset_password).then(function(response) {
                // Whether or not the user can reset the password with the link provided.
                if (response.allow) {
                    $scope.canResetPassword = true;
                    $scope.passwordUser.email = response.email;
                } else {
                    $scope.canResetPassword = false;
                }
            }).finally(function() {
                $scope.settings.loading = false;
            })
        }

        initializePasswordReset();

        $scope.createNewPassword = function() {
            $scope.resettingPassword = true;

            if (!!$scope.passwordUser.password && 
                // $scope.passwordUser.passwordConfirmation && 
                !$scope.password_invalid && 
                !$scope.password_invalid_format) {
                PasswordResetService.resetPassword($state.params.reset_password, $scope.passwordUser.password).then(function() {
                    $scope.passwordResetSuccess = true;
                    ngDialog.closeAll();
					var message = $interpolate(($scope.settings.passwordResetSuccessMessage.content_html || ''))({
						email: $scope.passwordUser.email
					});
					DialogService.openInformationDialog($scope.settings.passwordResetSuccessMessage.title_html, message);	
					$scope.resetSuccess = true;
                }, function(response) {
                    $scope.passwordResetError = true;
                    $scope.resettingPassword = false;
                    ErrorService.showPriorityErrors(response, 'Could not reset password!', 3);
                });
            } else {
                $scope.resettingPassword = false;
                if (!$scope.passwordUser.password) {
                    ErrorService.showPriorityErrors({}, 'Password required.', 3);
                    $('#password')[0].focus();
                } else if ($scope.password_invalid_format) {
                    $('#password')[0].focus();
                } else if (!$scope.passwordUser.passwordConfirmation) {
                    $('#password2')[0].focus();
                } else if ($scope.password_invalid) {
                    $('#password2')[0].focus();
                }
            }
        };

        $scope.closePopup = function() {
            ngDialog.closeAll();
        };

		$scope.showPasswordChanged = function() {
			var eles = document.getElementsByClassName("passwords");
			for (var i = 0; i < eles.length; i++) {
				if (eles[i].type === "password") {
					eles[i].type = "text";
				} else {
					eles[i].type = "password";
				}
			}
		}

        $scope.comparePasswords = function(input) {
            $scope.password_invalid = $scope.passwordUser.password !== input;
            $scope.$safeApply();
        };

        new ContentLoader({
            category: 'registration',
        }).then(function(contents) {
            $scope.settings.contents = contents;
            $scope.settings.requirementErrorMessage = Content.getByKey($scope.settings.contents, 'password_requirement_error_message', true);
        });

        new ContentLoader({
            category: 'reset_password',
        }).then(function(contents) {
            $scope.settings.contents = contents;
            $scope.settings.passwordResetExpiredMessage = Content.getByKey($scope.settings.contents, 'password_reset_expired', true);
            $scope.settings.passwordResetSuccessMessage = Content.getByKey($scope.settings.contents, 'password_reset_success', true);
        });

        $scope.$watch('passwordUser.passwordConfirmation', function(password) {
            if (password) {
                if ($scope.retype_password_timeout) {
                    clearTimeout($scope.retype_password_timeout);
                }
                $scope.retype_password_timeout = setTimeout(function() {
                    $scope.comparePasswords(password);
                }, 1000);
            } else {
                clearTimeout($scope.retype_password_timeout);
            }
        });

        // Validate the password as it changes.
        $scope.$watch('passwordUser.password', function(password) {

            if ($scope.reset_user_password_timeout) {
                clearTimeout($scope.reset_user_password_timeout);
            }
            $scope.reset_user_password_timeout = setTimeout(function() {
                if (!!password && !new RegExp($scope.site.password_regular_expression_string).test(password)) {
                    // if password set and it has incorrect format
                    $scope.password_invalid_format = true;
                } else {
                    // if password set and format is correct
                    $scope.password_invalid_format = false;
                    if (!!password && $scope.passwordUser.passwordConfirmation) {
                        $scope.comparePasswords($scope.passwordUser.passwordConfirmation);
                    } else {
                        clearTimeout($scope.reset_user_password_timeout);
                    }
                }

                $scope.$safeApply();
            }, 1000);
        });
    }
]);


'use strict';

angular.module('goApp')
  .controller('PhotoUploadController', ['$scope', 'PhotoUploadService', '$timeout', '$http', 'DOMAIN',
    function($scope, PhotoUploadService, $timeout, $http, DOMAIN) {

      $scope.config = {
        photoSaving: false,
        photoSaved: false,
        photoSaveMsg: '',
        photoSaveError: false,
        uploaded: false,
        uploadingPhoto: false,
        croppingPhoto: false,
        inOutOptions: {
          duration: 0.75
        },
        uploadedPhoto: '',
        resize: {
          width: 1920,
          height: 1080
        },
        saveButtonLabel: 'Save'
      };

      $scope.config = angular.extend($scope.config, PhotoUploadService.getSettings());

      $scope.uploadPhotoStart = function() {
        $scope.config.uploaded = false;
        $scope.config.uploadingPhoto = true;
      };

      $scope.uploadPhotoFinished = function() {
        $scope.config.uploaded = true;
        $timeout(function() {
          $scope.config.uploadingPhoto = false;
        }, 750);
      };

      $scope.cancelSave = function() {
        $scope.photoNotCropped = false;
        $scope.config.uploaded = false;
        $scope.config.uploadedPhoto = '';
      };

      $scope.setPhoto = function() {
        $timeout(function() {
          $scope.confirm($scope.config.uploadedPhoto);
        }, 0);
      };
    }
  ]);
'use strict';

angular.module('goApp')
  .service('PhotoUploadService', ['ngDialog', '$q',
    function(ngDialog, $q) {

      var PhotoUploadService = {
        _settings: {},
        setDefaultSettings: function() {
          PhotoUploadService._settings = {
            aspectRatio: null
          };
        },
        getSettings: function() {
          return PhotoUploadService._settings;
        },
        showPhotoCroppingDialog: function(settings, cancelFunction) {
          PhotoUploadService._settings = angular.extend(PhotoUploadService._settings, settings);
          var defer = $q.defer();
          ngDialog.openConfirm({
              template: '/scripts/photoUpload/photoUpload.html',
              controller: 'PhotoUploadController'
            }).then(function(imageUrl) {
              defer.resolve(imageUrl);
            }, function(rejection) {
              if (angular.isFunction(cancelFunction)) {
                cancelFunction();
              }
              defer.reject(rejection);
            })
            .finally(function() {
              PhotoUploadService.setDefaultSettings();
            });

          return defer.promise;
        },
        showPhotoUploadDialog: function(settings) {
          PhotoUploadService._settings = angular.extend(PhotoUploadService._settings, settings);
          var defer = $q.defer();
          ngDialog.openConfirm({
              template: '/scripts/photoUpload/photoUpload.html',
              controller: 'PhotoUploadController'
            }).then(function(imageUrl) {
              defer.resolve(imageUrl);
            }, function(rejection) {
              defer.reject(rejection);
            })
            .finally(function() {
              PhotoUploadService.setDefaultSettings();
            });

          return defer.promise;
        },
        showCustomPhotoUploadDialog: function(settings) {
          PhotoUploadService._settings = angular.extend(PhotoUploadService._settings, settings);
          var defer = $q.defer();
          ngDialog.openConfirm({
              template: '/scripts/photoUpload/customPhotoUpload.html',
              controller: 'PhotoUploadController'
            }).then(function(imageUrl) {
              defer.resolve(imageUrl);
            }, function(rejection) {
              defer.reject(rejection);
            })
            .finally(function() {
              PhotoUploadService.setDefaultSettings();
            });

          return defer.promise;
        }
      };

      PhotoUploadService.setDefaultSettings();

      return PhotoUploadService;
    }
  ]);
angular.module('goApp')
  .service('hesPopupScopeService', function(hesPopupScope) {
    function getCollection(collectionName) {

    }

    return {
      getCollection: getCollection,
      getScope: getScope,
      initCollection: initCollection
    }
  })
  .factory('hesPopupScope', function($rootScope, $interpolate) {
    function PopupScope(data) {
      this.name = data.name;
      this.content = data.content;
    }

    return PopupScope;
  });
'use strict';

angular.module('goApp')
  .controller('PrivacyController', ['$scope', '$q', 'CurrentSite', 'ContentLoader', 'ErrorService',
    function($scope, $q, CurrentSite, ContentLoader, ErrorService) {

      $scope.privacyConfig = {
        loading: true
      };
      $scope.privacy = [];

      $q.all([
        CurrentSite.get(),
      ]).then(function() {
        new ContentLoader({
          site_id: $scope.site.id,
          category: 'privacy'
        }).then(function(privacy) {
          $scope.privacy = privacy;
          $scope.privacyConfig.loading = false;
        });
      }, function(response) {
        ErrorService.showErrors(response);
        $scope.privacyConfig.loading = false;
      });

    $scope.strip_tags = function(str) {
      return str.replace(/<\/?[^>]+(>|$)/g, "") ;
    };

    }
  ]);
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.privacy_terms.privacy', {
    title: 'Privacy',
    url: '/privacy',
    abstract: false,
    controller: 'PrivacyController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/privacy/privacy.html');
      }
    ]
  });
  
});

'use strict';

angular.module('goApp')
  .factory('Profile', ['ActiveResource', '$http', 'DOMAIN',
    function(ActiveResource, $http, DOMAIN) {
      var Profile = ActiveResource('/profiles/:id', {
        nestedRoutes: ['update'],
        parentResource: 'User',
        domain: DOMAIN
      });

      Profile.prototype.getFullName = function(){
        return this.first_name + " " + this.last_name;
      };

      return Profile;
    }
  ]);
'use strict';

angular.module('goApp')
  .config(['$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('go.u.profileupload', {
          url: '/profileupload',
          title: 'UPLOAD IMAGE',
          background: 'filled',
          controller: 'ProfileUploadController',
          templateProvider: ['hesTemplateService',
            function(hesTemplateService) {
              return hesTemplateService.getTemplate('/scripts/profile/profileUpload.html');
            }
          ]
        });
    }
  ]);
'use strict';

angular.module('goApp')
  .controller('ProfileUploadController', ['$scope', 'CurrentUser', '$timeout', 'Profile',
    function($scope, CurrentUser, $timeout, Profile) {
      $scope.config = {
        user: null,
        photoSaving: false,
        photoSaved: false,
        photoSaveMsg: '',
        photoSaveError: false,
        uploaded: false,
        uploadingPhoto: false,
        inOutOptions: {
          duration: 0.75
        }
      };

      CurrentUser.get().then(function(user) {
        $scope.config.user = user;
      });

      $scope.uploadPhotoStart = function() {
        $scope.config.uploaded = false;
        $scope.config.uploadingPhoto = true;
      };

      $scope.uploadPhotoFinished = function() {
        $scope.config.uploaded = true;
        $scope.config.uploadingPhoto = false;
      };

      $scope.cancelSave = function() {
        $scope.photoNotCropped = false;
        $scope.config.uploaded = false;
        $scope.profilePhoto = '';
      };

      $scope.hasDefaultImage = function() {
        if ($scope.user) {
          var url_string = $scope.user.profile.image.url;
          return url_string.indexOf('default.png') > -1;
        } else {
          return false;
        }
      };

      // 'otherUser' is used when editing a user in the dashboard.
      $scope.saveProfilePhoto = function(otherUser) {
        $scope.config.photoSaving = true;
        $scope.config.photoSaved = false;
        $scope.config.photoSaveMsg = '';
        $scope.config.photoSaveError = false;

        var userProfile = Profile.build({
          user_id: otherUser ? otherUser.id : $scope.config.user.id,
          image: $scope.profilePhoto,
          id: otherUser ? otherUser.profile.id : $scope.config.user.profile.id
        });

        userProfile.save(function(profile) {
          otherUser ? otherUser.profile.image.url = profile.image.url : $scope.config.user.profile.image.url = profile.image.url;
          $scope.config.photoSaved = true;
          $scope.config.photoSaving = false;
          $scope.config.uploaded = false;
          $scope.profilePhoto = '';

          if(!otherUser) {
            CurrentUser.get(true);
          }

          $timeout(function() {
            $scope.config.photoSaved = false;
          }, 3000);
        })['catch'](function(error) {
          $scope.config.photoSaving = false;
          $scope.config.photoSaveError = true;
          $scope.config.photoSaveMsg = "Could not update profile photo. Please try again.";
        });
      };
    }
  ]);
angular.module('goApp').controller("PreviewLoggingContentController", function($scope, $state, SiteLoader, ContentService, ContentLoader, ProgramLoader){
  $scope.data = new Object();

  // custom content needs these;
  $state.params.category = "shared_logging_content";
  new SiteLoader({siteId: $state.params.siteId}).then(function(site){
    $scope.dbSite = site;
  });
  // end custom content stuff

  function fetchData() {
    ProgramLoader({id: $state.params.programId}).then(function(program){
      $scope.data.program = program;
      $scope.data.applications_states = [
        // {logging_state: "logging_ended", current_billboard_id: $scope.data.program["enter_billboard_id"], hash_key: 1 },
        {logging_state: "registration_closed", current_billboard_id: $scope.data.program["registration_closed_billboard_id"], hash_key: 2},
        {logging_state: "enter_logging", current_billboard_id: $scope.data.program["enter_billboard_id"], hash_key: 3 },
        {logging_state: "opt_in_no_logging", current_billboard_id: $scope.data.program["opt_in_billboard_id"], hash_key: 4},
        {logging_state: "enter_no_logging", current_billboard_id: $scope.data.program["enter_billboard_id"], hash_key: 5},
        {logging_state: "coming_soon", current_billboard_id: $scope.data.program["coming_soon_billboard_id"], hash_key: 6},
        {logging_state: "opt_in_logging", current_billboard_id: $scope.data.program["opt_in_billboard_id"], hash_key: 7}
      ];
      
      $scope.data.app_state = $scope.data.applications_states[0];
    });
  }
  
  fetchData();

});
angular.module('goApp').config(function($stateProvider){
  
  $stateProvider.state('go.u.preview_logging_states', {
    url: "/site/:siteId/program/:programId/preview_logging_states",
    title: "Preview Logging States",
    controller: "PreviewLoggingContentController",
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/programs/logging_content/preview_logging_content.template.html');
      }
    ],
  });

});
'use strict';

angular.module('goApp')

.factory('ProgramsLoader', ['Program', '$q',
    function(Program, $q) {
  return function() {
    var defer = $q.defer();

    Program.index({
      page_size: 0
    }, function(routes) {
      defer.resolve(routes);
    }, function() {
      defer.reject('Programs could not be loaded.');
    });

    return defer.promise;
  };
}])

.factory('ProgramLoader', ['Program', '$q', '$stateParams', 'Utils',
  function(Program, $q, $stateParams, Utils) {
    return function(obj) {
      var defer = $q.defer();

      if (Utils.isUndefinedOrNull(obj.id) || obj.id === 'new') {
        defer.resolve(Program.build({
          site_id: $stateParams.siteId,
          enabled: true,
          promotion: {
            app_name: "Promotion"
          }
        }));
      } else {
        Program.show({
          id: obj.id
        }, function(route) {
          defer.resolve(route);
        }, function() {
          defer.reject('Program could not be loaded.');
        });
      }

      return defer.promise;
    };
  }
]);
'use strict';

angular.module('goApp')
  .factory('Program', ['$http', 'ActiveResource', 'DOMAIN', '$filter', 'SITE', '$q', 'ApiResponse', 'MetaHandler', 'HesDate',
    function($http, ActiveResource, DOMAIN, $filter, SITE, $q, ApiResponse, MetaHandler, HesDate) {
      var Program = ActiveResource('/programs/:id', {
        nestedRoutes: ['index', 'create', 'destroy'],
        parentResource: ['Site'],
        domain: DOMAIN
      });

      Program.SSOUrl = ActiveResource('/challenge_urls/:id', {
        domain: DOMAIN
      });

      Program.ActivitySummaryUrl = ActiveResource('/activity_summary_urls/:id', {
        domain: DOMAIN
      });

      Program.ProgramLogo = ActiveResource('/programs/:id/logo', {
        domain: DOMAIN
      });

      Program.RegistrationClosed = ActiveResource('/sites/:site_id/programs/:program_id/registration_closed', {
        domain: DOMAIN
      });



      Program.prototype.swapPromotion = function(promotions) {
        if (this.promotion) {
          var matchedPromotion = $filter('filter')(promotions, {
            app_id: this.app_id,
            promotion_id: this.promotion_id
          })[0];
          this.promotion = matchedPromotion;
        } else if (this.promotion_id == -1) {
          this.promotion = $filter('filter')(promotions, {
            promotion_id: -1
          })[0];
        }
      };

      Program.prototype.setPromotionIds = function() {
        if (this.promotion) {
          this.app_id = this.promotion.app_id;
          this.promotion_id = this.promotion.promotion_id;
        }
      };

      Program.prototype.getActivitySummaryURL = function() {
        return DOMAIN + '/activity_summary_urls/' + this.id + "?redirect=true";
      };

      Program.prototype.getReportsURL = function() {
        return DOMAIN + '/reports_urls/' + this.id + "?redirect=true";
      };

      Program.prototype.getSSOURL = function() {
        return DOMAIN + '/challenge_urls/' + this.id + "";
      };

      Program.prototype.isRegistrationClosed = function() {
        return this.registration_closed;
      };

      Program.prototype.programLogo = function() {
        return DOMAIN + this.logo;
      };

      Program.prototype.mobileBanner = function() {
        return DOMAIN + this.billboard2;
      };

      Program.prototype.webBanner = function() {
        return DOMAIN + this.billboard1;
      };

      Program.prototype.mobileBannerHover = function() {
        return DOMAIN + this.billboard2_hover;
      };

      Program.prototype.webBannerHover = function() {
        return DOMAIN + this.billboard1_hover;
      };

      Program.prototype.getAppId = function() {
        return (this.promotion && this.promotion.app_id) || this.app_id;
      };

      Program.prototype.getAppDomain = function() {
        return (this.promotion && this.promotion.domain_name);
      };

      Program.prototype.displayName = function() {
        return this.name + " (" + this.effective_date_start.split("-")[0] + ")";
      };


      return Program;
    }
  ]);
'use strict';

angular.module('goApp')
  .controller('ProgramCreateEditController', ['$scope', '$state', '$timeout', 'ErrorService', 'Utils', 'HesDate', 'ProgramLoader', 'PromotionsLoader', 'LocationService', 'BillboardService',
    function($scope, $state, $timeout, ErrorService, Utils, HesDate, ProgramLoader, PromotionsLoader, LocationService, BillboardService) {
      $scope.dateFormat = 'L';

      $scope.settings = {
        saving: false,
        errors: [],
        loading: true
      };

      $scope.view = {
        isEdit: false,
        addingLocation: false
      };

      $scope.data = {
        promotions: [],
        locations: [],
        programLocationsIDs: [],
        locationBuffer: null
      };

      $scope.getLocationName = function(id) {
        var name = '';
        if (id) {
          name = LocationService.getLocationById($scope.data.locations, id, false).name;
        }
        return name;
      };

      $scope.handleErrors = function(response) {
        $scope.settings.saving = false;
        $scope.settings.showSaving = false;
        ErrorService.showPriorityErrors(response, 'Could not save Program', 1);
      };

      $scope.pushLocation = function(location_id) {
        if (!location_id) {
          var toAdd = $scope.data.locations
            .filter($scope.shouldShow)
            .map(function(location) { return location.id; });
          $scope.data.programLocationsIDs = $scope.data.programLocationsIDs.concat(toAdd);
          $scope.data.locationBuffer = null;
          $scope.view.addingLocation = false;
          return;
        }
        $scope.data.programLocationsIDs.push(location_id);
        $scope.data.locationBuffer = null;
        $scope.view.addingLocation = false;
      };

      $scope.deleteLocation = function(location_id) {
        var index = $scope.data.programLocationsIDs.indexOf(location_id);
        $scope.data.programLocationsIDs.splice(index, 1);
        $scope.data.locationBuffer = null;
      };

      $scope.shouldShow = function(location) {
        // user should not be able to add the same location to a program more than once
        return $scope.data.programLocationsIDs.indexOf(location.id) === -1;
      };

      $scope.save = function() {
        var wasNew = $scope.editProgram.isNew();
        $scope.settings.saving = true;
        var timeoutSave = $timeout(function() {
          $scope.settings.showSaving = true;
        }, 300);
        $scope.editProgram.setPromotionIds();
        delete $scope.editProgram.row;
        $scope.editProgram.locations = $scope.data.programLocationsIDs;
        $scope.editProgram.save(function(program) {
          $timeout.cancel(timeoutSave);
          $scope.settings.saving = false;
          $scope.settings.showSaving = false;
          $scope.editProgram = program;
          if (wasNew) {
            $scope.dbSite.programs.push(program);
            $state.go("go.u.site.program",{programId:program.id});
          } else {
            $scope.$emit('programsUpdated');
            init();
          }
        })['catch']($scope.handleErrors);
      };

      $scope.editBillboard = function(billboard_id, type) {
        var url = $state.href("go.u.billboardEdit",{
          id: billboard_id,
          site_id: $scope.dbSite.id,
          site_name: $scope.dbSite.name,
          name: $scope.editProgram.name,
          billboard_type: type,
          app_domain: $scope.editProgram.promotion.domain_name.replace(/\./g, '%2E')
        });
        window.open(url);
      }


      function init() {
        new PromotionsLoader().then(function(promotions) {
          $scope.data.promotions = promotions;
          $scope.data.promotions.unshift({
            promotion_id: -1,
            subdomain: 'Coming Soon Placeholder'
          });
          new ProgramLoader({
            id: $state.params.programId
          }).then(function(program) {
            $scope.editProgram = program;
            $scope.editProgram.coordinator_report_promotion_id = $scope.editProgram.coordinator_report_promotion_id || "-1";

            LocationService.get(true, $scope.editProgram.site_id).then(function(locations) {
              $scope.data.locations = LocationService.expandChildLocations(locations);
            });

            BillboardService.index({app_domain: $scope.editProgram.getAppDomain(), site_id: $scope.editProgram.site_id}).then(function(billboards) {
              $scope.data.billboards = billboards;
            });

            $scope.view.isEdit = !$scope.editProgram.isNew();
            if ($scope.view.isEdit) {
              $scope.editProgram = $scope.dbSite.getProgramById(program.id);
              $scope.editProgram.swapPromotion($scope.data.promotions);
              $scope.data.programLocationsIDs = program.location_ids ||
                program.locations.data.map(function(location) { return location.id; });
            }
            $scope.settings.loading = false;
          });
        });
      }


      $scope.timeframe = function(state) {
        return [
          moment($scope.editProgram.time_frames[state][0]).format("MMM D"),
          moment($scope.editProgram.time_frames[state][1]).format("MMM D")
        ].join(" to ");
      }

      init();
      
    }
  ]);
'use strict';

angular.module('goApp')
  .service('CurrentPromotion', ['$rootScope', 'Promotion', '$q', 'HesDate', '$state', 'Utils', '$window', 'SSOService', '$http', 'ipCookie', 'THEMES',
    function($rootScope, Promotion, $q, HesDate, $state, Utils, $window, SSOService, $http, ipCookie, THEMES) {
      var CurrentPromotion = {
        set: function(promotion) {
          $rootScope.promotion = new Promotion(promotion);
          return $rootScope.promotion;
        },

        hasEnded: function(func) {
          if($rootScope.promotion) {
            var promotion = $rootScope.promotion;
          }
        },

        removeUser: function() {
          // Remove the cookie and HTTP header.
          ipCookie.remove('basic');
          delete $http.defaults.headers.common['Authorization'];

          // Remove the current user.
          $rootScope.user = null;
        },

        get: function(forceRefresh) {
          var defer = $q.defer();
          if($rootScope.promotion === null || $rootScope.promotion === undefined || forceRefresh) {
            // Promotion.show({
            //   id: 'current'
            // }, function(promotion) {
            //   if(!Utils.isUndefinedOrNull(promotion.id)) {
            //     if(promotion.disabled_on === null || HesDate.compare(promotion.current_date, promotion.disabled_on) <= 0) {
            //       promotion.theme = (promotion.theme !== undefined && promotion.theme !== null) ? promotion.theme.toLowerCase() : THEMES[0].key.toLowerCase();
            //       $rootScope.promotion = promotion;
            //       SSOService.setOrganization(promotion);
            //
            //       if(SSOService.isEnabled() && !SSOService.getToken()) {
            //         SSOService.goToLogin();
            //       }
            //       else {
            //         defer.resolve(CurrentPromotion.set(promotion));
            //       }
            //     }
            //     else {
            //       CurrentPromotion.removeUser();
            //       $window.location.href = 'http://www.healthfortheholidays.com';
            //     }
            //   }
            //   else {
            //     $window.location.href = 'http://www.healthfortheholidays.com';
            //   }
            // },
            //
            // function(response) {
            //   defer.reject('Error getting current promotion');
            //   $state.go('404', {errors: response});
            // });

            defer.resolve({});
          }
          else {
            defer.resolve($rootScope.promotion);
          }

          return defer.promise;
        }
      };

      return CurrentPromotion;
    }
  ]);
'use strict';

angular.module('goApp')
  .factory('Promotion', ['$http', 'ActiveResource', 'DOMAIN',
    function($http, ActiveResource, DOMAIN) {
      //This is not your momma's promotions. This is slimed down.
      var Promotion = ActiveResource('/promotions/:id', {
        domain: DOMAIN
      });



      return Promotion;
    }
  ]);
'use strict';

angular.module('goApp')

.factory('PromotionsLoader', ['Promotion', '$q', 'Utils',
  function(Promotion, $q, Utils) {
    return function(opts) {
      var defer = $q.defer();

      var options = {
        page_size: 0
      };

      Promotion.index(options, function(promotions) {
        defer.resolve(promotions);
      }, function() {
        defer.reject('Promotions could not be loaded.');
      });

      return defer.promise;
    };
  }
]);
'use strict';
angular.module('goApp')
  .controller('AllRecipesController',
    function($scope, RecipeService, ContentService, $anchorScroll, $timeout, $stateParams) {
      $scope.data = {
        limit: RecipeService.viewState.limit,
        filteredItems: [],
        selectedFilter: RecipeService.viewState.category,
        appliedSearch: RecipeService.viewState.search,
        search: RecipeService.viewState.search,
        allFilters: RecipeService.categoriesList
      };
      var noFavoritesMsg = ContentService.getContentByCategoryAndKey('recipes', null, 'no_favorites_message').content_html;

      $scope.allRecipes = [];
      RecipeService.getRecipes().then(function(recipes) {
        $scope.allRecipes = recipes;
      });
      
      RecipeService.getFavorites().then(function(favorites) {
        $scope.data.hasFavorites = favorites.length > 0;
      });

      $scope.applySearch = function(value) {
        $scope.data.limit = RecipeService.viewState.increment;
        $scope.data.appliedSearch = value;
        RecipeService.viewState.search = value;
        $scope.$state.go('go.u.content.recipes.all', RecipeService.viewState, {
          notify: false,
          location: true
        });
      };

      $scope.showMore = function() {
        $scope.data.limit += RecipeService.viewState.increment;
      }

      $scope.searchFilterMessage = function() {
        var message = 'Displaying ';
        var category = "";
        var search = "";
        if ($scope.selectedFilter != 'all') {
          category = $scope.data.selectedFilter + ' ';
        }
        if ($scope.data.appliedSearch) {
          if (!!category) {
            search += " and ";
          }
          search += $scope.data.appliedSearch + " results";
        }
        return (!!category || !!search) ? (message + category + search) : '';
      };

      $scope.searchEmptyMessage = function() {
        // var message = 'There are no recipes in "' + _.filter($scope.data.allFilters, {
        //   key: $scope.data.selectedFilter
        // })[0].display + '"';
        var message = new String();
        if (!!$scope.data.appliedSearch) {
          if ($scope.data.selectedFilter != 'all') {
            message += 'No recipes found in '+ _.startCase($scope.data.selectedFilter) +' course,';
            var all_recipe_link = $scope.$state.href('go.u.content.recipes.all', {category:'all', search: $scope.data.appliedSearch}, {absolute: false});
            message += ' would you like to search in <a class="underline" href="'+ all_recipe_link +'">all recipes</a>?';
          } else {
            message = "Oops, we don't have any recipes matching your search."
          }
        } else if ($scope.data.selectedFilter === 'favorites') {
          message = noFavoritesMsg || 'Once you like a recipe it will show up under favorites.';
        }

        return message;
      };

      if ((!!$stateParams.category ||
          !!$stateParams.search)) {
        var scrollTo = $scope.$state.params.previousStateParams.id;
        if (!!scrollTo) {
          $timeout(function() {
            $anchorScroll(scrollTo);
            $scope.data.scrollTo = scrollTo;
          });
        }
      }

      $scope.$watch('data.selectedFilter', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          RecipeService.viewState.category = newVal;
          $timeout(function() {
            $scope.$state.go('go.u.content.recipes.all', RecipeService.viewState, {
              notify: false,
              location: true
            });
          });
        }
      });

      $scope.$on('$stateChangeStart', function() {
        RecipeService.viewState.category = $scope.data.selectedFilter;
        RecipeService.viewState.limit = $scope.data.limit;
        RecipeService.viewState.search = $scope.data.appliedSearch;
        RecipeService.viewState.fromList = true;
      });

      // Sets the url parameter so if a user clicks a recipe, they will be brought back to where they are in the
      // list, even if they didn't do any searching
      // Only gets triggered when the user on initial load
      $scope.$state.go('go.u.content.recipes.all', RecipeService.viewState, {
        notify: false,
        location: true
      });
    });
angular.module('goApp')
  .filter('recipeCategoryFilter', function(RecipeService) {
    function recipeCategoryFilter(recipes, category) {
      var results = recipes;

      //Array of Category values, i.e. ["Dinner"], ["Breakfast", "Brunch"]
      var categoryValues = RecipeService.categoryKeyValues[category];

      if (!!categoryValues) {
        results = _.filter(recipes, function(recipe, idx) {
          return _.filter(recipe.recipe_categories, function(recipeCategory) {
            
            // See if the category includes the category values
            // i.e. categoryValues == ['Breakfast', 'Brunch']
            // then recipeCategory.category == 'Brunch' will return true
            // then recipeCategory.category == 'Lunch' will return false
            return _.includes(categoryValues, recipeCategory.category);
          }).length > 0;
        });
      } else if(category == 'favorites'){
        results = RecipeService._favorites;
      }

      return results;
    }

    return recipeCategoryFilter;
  });
angular.module('goApp')
  .filter('recipeSearchFilter', function(RecipeService) {
    function recipeCategoryFilter(recipes, searchString) {
      var results = recipes;

      if (!!searchString) {
        var searchLowered = searchString.toLowerCase();      
        results = _.filter(recipes, function(recipe, idx) {
          // Check title, description, ingredients and health category
          if (recipe.title.toLowerCase().indexOf(searchLowered) > -1
            || recipe.description.toLowerCase().indexOf(searchLowered) > -1
            || recipe.getIngredientItemsString().indexOf(searchLowered) > -1
            || recipe.getHealthCategories().toLowerCase().indexOf(searchLowered) > -1) {
            return true;
          }
          return false;
        });
      }

      return results;
    }

    return recipeCategoryFilter;
  });
'use strict';

angular.module('goApp')
  .controller('RecipeController', function($scope, ngDialog, Recipe, RecipeService, $state, $stateParams, CurrentUser, Post, WallFactory, $anchorScroll, Daily) {
    $scope.received_favorite = false;
    $scope.settings = {
      savingRating: false,
      savedRating: false,
      share_content: '',
      saving: false,
      share_saved: false,
      noComment: false,
      showBreadcrumb: RecipeService.viewState.fromList && $state.current.name !== 'go.u.content.recipes.today',
      crumbs: [{
        state: 'go.u.content.recipes.all('+ JSON.stringify(RecipeService.viewState) + ')',
        display: RecipeService.getCategoryDisplay(RecipeService.viewState.category)
      }],
      recipeWall: {}
    };

    $scope.saveRating = function(recipe, rating) {
      $scope.settings.savingRating = true;
      recipe.rate(rating)
        .finally(function() {
          $scope.settings.savingRating = false;
        });
    };

    $scope.printRecipe = function() {
      window.print();
    };

    var recipe = null;
    if($state.current.name == "go.u.content.recipes.today") {
      Daily.get().then(function(data){
        recipe = data.recipe;
        $scope.settings.crumbs.push({
          state: $state.current.name,
          display: recipe.title
        })
        $scope.showRecipe(recipe);
      });
   } else {
     RecipeService.getRecipe($stateParams.id).then(function(recipe){
       $scope.settings.crumbs.push({
         state: $state.current.name,
         display: recipe.title
       })
       $scope.showRecipe(recipe);
     }, function() {
      $scope.show_broken_recipe = true;
      $scope.settings.showBreadcrumb = true;
      $scope.settings.crumbs.push( {
        state: $state.current.name,
        display: "Not found"
      });
     });
   }

    $scope.showRecipe = function(recipe) {
      $scope.recipe = new Recipe(recipe);
      $scope.recipe.getLike();
      $scope.recipe.getUserRating();
      $scope.settings.recipeWall = new WallFactory($scope.recipe, {
        page_size: 0
      });

      $scope.settings.recipeWall.load();

      CurrentUser.get().then(function() {
        if ($scope.user) {
          var stateParams = angular.copy($stateParams);

          $scope.recentlyViewedCollection = RecipeService.getRecentlyViewedCollection($scope.user.id);
          $scope.recentlyViewedCollection.addItem({
            state: $state.current.name,
            stateParams: stateParams,
            id: $scope.recipe.id
          });
        }
      });
    };

    $scope.scrollToComments = function(){
      $anchorScroll('recipe_comments');
    };


    //TODO Start:  Move to ShareDial
    $scope.postToWall = function(recipe) {
      $scope.resource = recipe;
      $scope.settings.resourceType = 'recipe';
      $scope.settings.share_content = '';
      ngDialog.open({
        template: '/scripts/wall/sharing-resource.html',
        scope: $scope,
        className: 'ngdialog-theme-default shared_resource',
        showClose: false
      });
    };

    $scope.shareToWall = function(recipe) {
      $scope.settings.saving = true;
      if ($scope.settings.share_content != '') {
        var share = new Post({
          content: $scope.settings.share_content,
          postable_type: 'Recipe',
          postable_id: recipe.id
        });
        share.save(function(shared_recipe) {
          $scope.settings.share_saved = true;
          $scope.settings.saving = false;
          $scope.settings.noComment = false;
          $scope.settings.share_content = '';
        }, function(error) {
          $scope.settings.saving = false;
        });
      } else {
        $scope.settings.saving = false;
        $scope.settings.noComment = true;
      }
    };

    $scope.closeDialog = function() {
      $scope.settings.noComment = false;
      ngDialog.closeAll();
    };
    //TODO End:  Move to ShareDial

    $scope.getCurrentCourse = function() {
      return RecipeService.courses.getCurrent();
    };

    $scope.gsubMetrics = function(str) {
      if (typeof str != "string") {
        return str;
      }
      var new_str = str;
      new_str = new_str.replace(/minute(s?)/g,"Min");
      new_str = new_str.replace(/hours/g,"Hours");
      new_str = new_str.replace(/hour/g,"Hour");
      return new_str;
    }
    
  });
'use strict';

angular.module('goApp')
  .factory('Recipe', function(ActiveResource, DOMAIN, $http, $state, $q) {

    var Recipe = ActiveResource('/recipes/:id', {
      domain: DOMAIN
    }, {
      daily: {
        url: '/daily',
        method: 'GET',
        isArray: false
      },
      usersRating: {
        url: '/user_rating',
        method: 'GET',
        isArray: false
      },
      rate: {
        url: '/user_rating',
        method: 'POST'
      },
      unrate: {
        url: '/user_rating',
        method: 'DELETE'
      },
      usersLike: {
        url: '/user_like',
        method: 'GET',
        isArray: false
      },
      like: {
        url: '/user_like',
        method: 'POST'
      },
      unlike: {
        url: '/user_like',
        method: 'DELETE'
      },
      favorites: {
        url: '/favorites',
        method: 'GET',
        isArray: true
      }
    });

    Recipe.prototype.getFullUrl = function(state, course) {
      var stateParams = {
        id: this.id
      };

      state = state || 'go.u.recipes.all.recipe';

      if (course) {
        stateParams.course = course;
      }

      return $state.href(state, stateParams, {
        absolute: true
      });
    };

    Recipe.prototype.getUserRating = function() {
      var that = this;
      if (this.userRating === undefined) {
        this.rating = this.rating * 20;
        this.userRating = null;
        return Recipe.usersRating({
          id: this.id
        }).$promise.then(
          function(response) {
            that.userRating = response.score * 20;
            that.rating = response.rateable.rating * 20;
          },
          function(response) {
            that.userRating = null;
          });
      }
    };

    Recipe.prototype.rate = function(pRating) {
      var that = this;
      return Recipe.rate({
        id: this.id,
        score: (pRating / 20)
      }).$promise.then(function(response) {
        that.userRating = response.score * 20;
        that.rating = response.rateable.rating * 20;
      });
    };

    Recipe.prototype.unRate = function() {
      var that = this;
      return Recipe.unrate({
          id: this.id
        }).$promise
        .then(function(response) {
          that.userRating = null;
          that.rating = response.rateable.rating * 20;
        });
    };

    Recipe.prototype.toggleFavorite = function() {
      if (this.favorited) {
        this.favorited = false;
        this.removeLike();
      } else {
        this.favorited = true;
        this.like();
      }
    };

    Recipe.prototype.like = function() {
      var that = this;
      return Recipe.like({
          id: this.id
        }).$promise
        .then(function(response) {
          that.favorited = true;
        });
    };

    Recipe.prototype.removeLike = function() {
      var that = this;
      return Recipe.unlike({
          id: this.id
        }).$promise
        .then(function(response) {
          that.favorited = false;
        });
    };

    Recipe.prototype.getLike = function() {
      var that = this;
      if (this.favorited === undefined) {
        return Recipe.usersLike({
            id: this.id
          }).$promise
          .then(function(response) {
            that.favorited = response;
          }, function(response) {
            that.favorited = false;
          });
      }
    };

    Recipe.prototype.getHealthCategories = function() {
      return this.health_categories;
      if (!this.healthCategories) {
        var tmpCategories = [];
        _.each(this.recipe_categories, function(cat, idx) {
          if ((cat.category_type === 'HealthConsideration' || cat.category_type === 'DietaryRestriction') && cat.category != 'HES Pick') {
            if (tmpCategories.indexOf(cat.category) === -1) {
              tmpCategories.push(cat.category);
            }
          }
        });
        this.healthCategories = tmpCategories.join(', ');
      }
      return this.healthCategories
    };

    Recipe.prototype.getIngredientItemsString = function() {
      return this.ingredient_string;
      if (!this.ingredientString) {
        var tmpString = '';
        _.each(this.ingredients, function(ingredient, idx) {
          tmpString += ' ' + ingredient.item.toLowerCase();
        });
        this.ingredientString = tmpString;
      }
      return this.ingredientString;
    };

    Recipe.prototype.getFirstCategoryType = function(type) {
      var firstFound = '';
      var results = _.filter(this.recipe_categories, {
        category_type: type
      });
      if (results.length > 0) {
        firstFound = results[0].category;
      }
      return firstFound;
    };

    Recipe.prototype.getDifficulty = function() {
      if (!this._difficulty) {
        this._difficulty = this.getFirstCategoryType('EaseofPrep').trim();
      }
      return this._difficulty;
    };

    Recipe.prototype.getCourse = function() {
      if (!this._course) {
        this._course = this.getFirstCategoryType('Meal').replace('Brunch', 'Breakfast');
      }
      return this._course;
    };

    Recipe.prototype.getSummary = function() {
      if (!this._summary) {
        this._summary = this.description.slice(0, 150) + (this.description.length > 150 ? '...' : '');
      }
      return this._summary;
    };


    Recipe.prototype.getCourse

    return Recipe;
  });
'use strict';

angular.module('goApp')
  .service('RecipeService', function(HesDate, Recipe, $q, hesLocalStorageCollectionService) {
    var RecipeService = {
      _recipes: null,
      _daily: null,
      viewState: {
        category: 'all',
        search: '',
        limit: 20,
        increment: 20,
        fromList: false
      },
      categoryKeyValues: {
        'breakfast': ['Breakfast', 'Brunch'],
        'dinner': ['Dinner'],
        'lunch': ['Lunch'],
        'snacks': ['Snacks']
      },
      categoriesList: [{
        key: 'all',
        display: 'All Recipes'
      }, {
        key: 'breakfast',
        display: 'Breakfast'
      }, {
        key: 'lunch',
        display: 'Lunch'
      }, {
        key: 'dinner',
        display: 'Dinner'
      }, {
        key: 'snacks',
        display: 'Snacks'
      }, {
        key: 'favorites',
        display: 'Favorites'
      }],
      getCategoryDisplay: function(category) {
        var display = RecipeService.categoriesList[0].display;
        var found = _.filter(RecipeService.categoriesList, {
          key: category
        })[0];
        if (!!found) {
          display = found.display;
        }
        return display;
      },
      setDefaults: function() {
        RecipeService.viewState.category = 'all';
        RecipeService.viewState.search = '';
        RecipeService.viewState.limit = 20;
        RecipeService.viewState.increment = 20;
        RecipeService.viewState.fromList = false;
      },
      getRecentlyViewedCollection: function(userId) {
        return hesLocalStorageCollectionService.getCollection({
          name: 'recipes',
          localStorageItemName: 'recentlyViewedLpdRecipes' + userId,
          limit: 8
        });
      },

      getRecipes: function() {
        if (RecipeService._recipes === null && !RecipeService.defer) {
          RecipeService.defer = $q.defer();
          Recipe.index({
            page_size: 0
          }, function(recipes) {
            RecipeService._recipes = recipes;
            RecipeService.defer.resolve(RecipeService._recipes);
          }, function() {
            RecipeService.defer.reject('Recipes could not be found');
            RecipeService.defer = null;
          });
        } else if (!!RecipeService._recipes) {
          RecipeService.defer.resolve(RecipeService._recipes);
        }

        return RecipeService.defer.promise;
      },

      getFavorites: function() {
        var promise = Recipe.favorites({page_size:0}).$promise;

        promise.then(function(favorites) {
            RecipeService._favorites = favorites;
          }, function() {
            RecipeService._favorites = [];
          });

        return promise;
      },

      getDaily: function() {
        var defer = $q.defer();
        if (!RecipeService._daily) {
          Recipe.daily({}, function(dailyRecipe) {
            RecipeService._daily = dailyRecipe;
            defer.resolve(RecipeService._daily);
          }, function() {
            defer.reject('Daily recipe could not be found');
          });
        } else {
          defer.resolve(RecipeService._daily);
        }

        return defer.promise;
      },

      getRecipe: function(recipeId) {
        return Recipe.show({
          id: recipeId
        }).$promise;
      }
    };

    return RecipeService;
  });
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.u.content.recipes', {
    abstract: true,
    template: '<ui-view></ui-view>',
    onEnter: function(RecipeService) {
      RecipeService.setDefaults();
    }
  });

  $stateProvider.state('go.u.content.recipes.today', {
    url: "/recipes/today",
    title: "Today's Recipe",
    controller: "RecipeController",
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/recipes/views/recipe.html');
      }
    ],
    onEnter: function(RecipeService) {
      RecipeService.setDefaults();
    }
  });

  $stateProvider.state('go.u.content.recipes.all', {
    url: "/recipes/all?:category:search",
    title: "All Recipes",
    controller: "AllRecipesController",
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/recipes/views/recipes.html');
      }
    ],
    onEnter: function($stateParams, RecipeService) {
      if (!$stateParams.category &&
        !$stateParams.search) {
        RecipeService.setDefaults();
      } else {
        RecipeService.viewState.category = $stateParams.category || RecipeService.viewState.category;
        RecipeService.viewState.search = $stateParams.search;
      }
    },
    params: {
      search: null,
      category: null
    }
  });

  $stateProvider.state('go.u.content.recipes.single', {
    url: "/recipe/:id",
    title: "Recipe",
    controller: "RecipeController",
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/recipes/views/recipe.html');
      }
    ]
  });

});
'use strict';

angular.module('goApp').run(function($timeout, $window) {

  function refreshAt(hours, minutes, seconds) {
    var now = new Date();
    var then = new Date();

    if (now.getHours() > hours ||
      (now.getHours() == hours && now.getMinutes() > minutes) ||
      now.getHours() == hours && now.getMinutes() == minutes && now.getSeconds() >= seconds) {
      then.setDate(now.getDate() + 1);
    }
    then.setHours(hours);
    then.setMinutes(minutes);
    then.setSeconds(seconds);

    var timeout = (then.getTime() - now.getTime());
    $timeout(function() {
      $window.location.reload(true);
    }, timeout);
  }

  //Let's refresh the page at 3:00 AM
  refreshAt(3, 0, 0);

});
'use strict';

angular.module('goApp')
  .controller('EligibilityCheckController', ['$rootScope', '$scope', 'CurrentUser', 'ContentLoader', 'Content', 'Eligibility', 'ErrorService', '$state', '$q', 'CurrentSite', 'HesDate', 'MONTHS', 'MONTH_DAYS', 'Utils',
    function($rootScope, $scope, CurrentUser, ContentLoader, Content, Eligibility, ErrorService, $state, $q, CurrentSite, HesDate, MONTHS, MONTH_DAYS, Utils) {

      $scope.data = {
        birth_date: '',
        birthMonth: '',
        birthDay: '',
        birthYear: '',
        identifier: ''
      };

      $rootScope.elig_user = null;

      $scope.eligLabelMessage = {};

      $scope.settings = {
        customErrorMsg: ''
      };

      $scope.yearOptions = {
        years: HesDate.getSelectableYears(),
        months: MONTHS,
        days: MONTH_DAYS
      };


      $q.all([
        CurrentSite.get(),
      ]).then(function() {
        new ContentLoader({
          site_id: $scope.site.id,
          category: 'eligibility'
        }, true).then(function(eligibilityContent) {
          $scope.eligLabelMessage = _.find(eligibilityContent, {key: 'label_message'});
        });
      });

      $scope.confirmIdentifier = function() {
        ErrorService.clearErrors();

        if($scope.displayBirthDate()) {

          if($scope.data.birthDay === '' || !$scope.data.birthDay || $scope.data.birthMonth  === '' || !$scope.data.birthMonth || $scope.data.birthYear === '' || !$scope.data.birthYear) {
            $scope.settings.customErrorMsg = 'Please enter a Date of Birth';
            ErrorService.showPriorityErrors({}, $scope.settings.customErrorMsg, 0);
            return;
          }
          else {
            var day = $scope.data.birthDay;
            var month = $scope.data.birthMonth;
            var year = $scope.data.birthYear;

            // Need to add leading zeroes if they entered one digit for the month or day.
            if(day.length === 1) {
              day = "0" + day;
            }

            if(month.length === 1) {
              month = "0" + month;
            }

            // Put this in the database's format.
            $scope.data.formattedBirthDate = month + "/" + day + "/" + year;
            $scope.data.birth_date =  year + '-' + month + '-' + day;
          }
        }

        Eligibility.validate($scope.site.id, $scope.data.identifier, $scope.data.birth_date, function(eligibility) {

          // Build a user with the results...
          var _user = {
            birth_date: $scope.data.birth_date,
            eligibility_id: eligibility.id,
            email: eligibility.email,
            identifier: eligibility.identifier,
            profile: {
              first_name: eligibility.first_name,
              last_name: eligibility.last_name
            }
          };

          // CurrentUser.set(_user);
          $rootScope.elig_user = _user;

          // And continue to registration.
          $state.go('go.register');
        }, function() {
          // Error checking eligibility.
        })['catch'](function(errors) {
          if (errors.status === 422 || errors.status === 404) {
            var converter = new Showdown.converter();
            var htmlText = converter.makeHtml($scope.eligLabelMessage.summary_html);
            var fixedText = $(htmlText).text();

            if(errors.status === 404) {
              if($scope.displayBirthDate()) {
                $scope.settings.customErrorMsg = "Cannot find eligibility record for " + moment($scope.data.formattedBirthDate).format('L') + " and " + $scope.data.identifier + ".";
              }
              else {
                $scope.settings.customErrorMsg = "Cannot find eligibility record for " + fixedText + ".";
              }
            } else if(errors.status === 422) {
              $scope.settings.customErrorMsg = "You've already created an account. Sign in <a ui-sref='go.welcome.login'>here</a>.</span>";
            }

            ErrorService.showPriorityErrors({}, $scope.settings.customErrorMsg, 0);
          }
        });
      };

      $scope.displayBirthDate = function() {
        return $scope.site.isBirthDateEligibilityDisplayed();
      };

      $scope.showEligibilityHelp = function() {
      };

      $scope.goToWelcome = function() {
        $state.go('go.welcome');
      };
    }
  ]);
'use strict';

angular.module('goApp')
  .controller('RegistrationController', ['$rootScope', '$scope', '$state', 'User', 'CurrentUser', 'CurrentSite', 'ipCookie', 'ContentLoader', 'Content', 'ngDialog', 'ErrorService', 'SSOService', '$http', 'DOMAIN', 'SITE', 'STATE_CHOICES', 'Eligibility', 'LocationService', 'SiteEvaluation', 'Program', '$window',
    function($rootScope, $scope, $state, User, CurrentUser, CurrentSite, ipCookie, ContentLoader, Content, ngDialog, ErrorService, SSOService, $http, DOMAIN, SITE, STATE_CHOICES, Eligibility, LocationService, SiteEvaluation, Program, $window) {

      $scope.settings = {
        loading: true
      };

      $scope.selectRegion = {
        selection: {}
      };

      // Sanitize email input
      $scope.sanitizeEmail = function(value) {
        if (!value) return value;
        return value
          .replace(/\u2018/g, "'") // Left single quotation mark
          .replace(/\u2019/g, "'") // Right single quotation mark
          .replace(/\u00A0/g, ' ') // Non-breaking space
          .replace(/\u200B/g, '')  // Zero-width space
          .trim();
      };

      var password_format = /^(?=.*[a-zA-Z0-9]).{4,20}$/;
      $scope.messages = {
        closed: 'Sorry, you can no longer create an account.',
        emailDupMessage: "<span>Email address is already in use. Would you like to <a ui-sref='go.welcome.login'>log in</a>?</span>",
        emailInvalidMessage: '<span>Please enter a valid email address.</span>',
        emailErrorMessage: '',
        addressLabel: 'Address',
        address_content: '',
        contents: [],
        customConfidentiality: null
      };

      $scope.data = {
        parentLocations: [],
        errors: [],
      };

      $scope.stateChoices = STATE_CHOICES;

      $scope.ariaClickLinkInside = function($event) {
        if ($event.keyCode == 13 || $event.keyCode == 32) {
          $event.preventDefault();
          window.setTimeout(function() {
            $('.style-read-more a')[0].click();
          }, 0);
        }
      }

      function initLocations() {
        if ($scope.site.flags.allow_set_location) {
          LocationService.get(false, $scope.site.id).then(function(parentLocations) {

            var locationIsChild = false;
            var locationIsParent = false;

            $scope.data.parentLocations = parentLocations;

            // Does the user only have a parent location?
            for (var p = 0; p < $scope.data.parentLocations.length; p++) {
              if (!!$scope.newUser.location && !!$scope.data.parentLocations[p] && ($scope.newUser.location.id === $scope.data.parentLocations[p].id)) {
                locationIsParent = true;
                $scope.newUser.parentLocation = $scope.data.parentLocations[p];
                break;
              }
            }

            // If not, look through their children...
            if (!locationIsParent) {
              for (var _p = 0; _p < $scope.data.parentLocations.length; _p++) {
                for (var c = 0; c < $scope.data.parentLocations[_p].locations.length; c++) {
                  if ($scope.newUser.location.id === $scope.data.parentLocations[_p].locations[c].id) {
                    locationIsChild = true;
                    $scope.newUser.parentLocation = $scope.data.parentLocations[_p];
                    $scope.newUser.childLocation = $scope.data.parentLocations[_p].locations[c];
                    break;
                  }
                }
              }
            }
          });
        }
      }

      $scope.locationChanged = function(location) {
        if (location === 'parent') {
          $scope.newUser.childLocation = null;
        }
      };

      $scope.recalculateLocation = function() {
        $scope.newUserLocation = null;
        $scope.newUser.location = null;
      };

      $scope.displayChildLocations = function() {
        return $scope.newUser.parentLocation ? $scope.newUser.parentLocation.locations.length > 0 : false;
      };

      CurrentSite.get().then(function(site) {
        new ContentLoader({
          category: 'registration',
          site_id: $scope.site.id
        }).then(function(contents) {
          initLocations();

          $scope.messages.contents = contents;
          var message = Content.getByKey($scope.messages.contents, 'closed_message', true);
          if (message && message.content_html !== undefined) {
            $scope.messages.closed = message.content_html;
          }

          var addressLabel = Content.getByKey($scope.messages.contents, 'address_label', true);
          $scope.messages.addressLabel = !!addressLabel.title_html ? addressLabel.title_html.replace('</p>','*</p>') : $scope.messages.addressLabel;
          $scope.messages.address_content = !!addressLabel.content_html ? addressLabel.content_html : $scope.messages.address_content;

          $scope.messages.agreeReadMore = Content.getByKey($scope.messages.contents, 'read_more', true);
          $scope.messages.welcomeToSite = Content.getByKey($scope.messages.contents, 'registration_message', true);
          $scope.messages.customConfidentiality = Content.getByKey($scope.messages.contents, 'custom_confidentiality_message', true);
          $scope.messages.customConfidentiality2 = Content.getByKey($scope.messages.contents, 'custom_confidentiality_message_2', true);
          $scope.messages.smsAgreement = Content.getByKey($scope.messages.contents, 'sms_agreement', true);

          var mobilePasswordMsg = Content.getByKey(contents, 'mobile_password_message', true);
          $scope.messages.mobilePasswordMsg = mobilePasswordMsg.content_html || '';

          // Max participants check.
          site.verifyCanRegister(function(response) {
            // Registration dates check.
            if (!ipCookie('pilotPassword') && (response.max_participants || response.registration_ended)) {
              $scope.registrationFrozen = true;
              if (response.max_participants && !response.registration_ended) {
                var message = Content.getByKey($scope.messages.contents, 'closed_max_message', true);
                if (message && message.content_html !== '') {
                  $scope.messages.closed = message.content_html;
                }
              } } else if ($scope.user) {
                $state.go('go.u.home');
            } else {
              $scope.registrationFrozen = false;

              // wustl sites verify via the sso + eligibility roster lookup (server-side handle_wustl),
              // not the standalone check-eligibility screen, so skip it entirely - same as launchpad
              if (!$scope.site.isWUSTL()) {
                if ($scope.site.isEligibilityDisplayed() && !$rootScope.elig_user) {
                  $state.go('go.welcome.check_eligibility');
                } else if ($scope.site.isEligibilityDisplayed()) {

                  // Define some properties based on the eligibility.
                  $scope.newUser = new User({
                    birth_date: $rootScope.elig_user.birth_date,
                    eligibility_identifier: $rootScope.elig_user.identifier,
                    email: $rootScope.elig_user.email,
                    origin_url: SITE,
                    profile: {
                      first_name: $rootScope.elig_user.profile.first_name,
                      last_name: $rootScope.elig_user.profile.last_name
                    }
                  });
                } else {
                  // Continue with normal registration...
                }
              }
            }

            if (!!site.initial_site_evaluation_id) {
              SiteEvaluation.show({
                site_id: site.id,
                id: site.initial_site_evaluation_id
              }, function(site_evaluation) {
                $scope.data.site_evaluation = site_evaluation;
                $scope.newUser.evaluation = {
                  site_evaluation_id: site_evaluation.id
                };
              });
            }


            if (SSOService.isEnabled()) {
              var userInfo = SSOService.getUserInformation() || {};
              $scope.newUser.profile = {
                first_name: userInfo.first_name ? userInfo.first_name.trim() : '',
                last_name: userInfo.last_name ? userInfo.last_name.trim() : ''
              };
              $scope.newUser.email = userInfo.email ? userInfo.email.trim() : '';
              // wustl extras come from the eligibility roster via the sso_info cookie (see sso_controller#handle_wustl);
              // dob/address land on profile here so do_sso can forward them to connected challenges later.
              // structure_level_10 isn't copied here - do_sso reads it straight off eligibility, not profile.
              if ($scope.site.isWUSTL()) {
                $scope.newUser.profile.dob = userInfo.dob;
                $scope.newUser.profile.line1 = userInfo.line1;
                $scope.newUser.profile.line2 = userInfo.line2;
                $scope.newUser.profile.postal_code = userInfo.postal_code;
                $scope.newUser.profile.state_province = userInfo.state_province;
                $scope.newUser.profile.country = userInfo.country;
                $scope.newUser.profile.city = userInfo.city;
                $scope.newUser.eligibility_identifier = userInfo.identifier;
                $scope.newUser.birth_date = userInfo.dob;
              }
            }

            $scope.settings.loading = false;
          }, function(response) {
            //Can Not Register
            if (response.data.max_participants && !response.data.registration_ended) {
              var message = Content.getByKey($scope.messages.contents, 'closed_max_message', true);
              if (message && message.content_html !== '') {
                $scope.messages.closed = message.content_html;
              }
            }
            $scope.registrationFrozen = true;
            $scope.settings.loading = false;
          });
        }, function() {
          // Error getting site.
          $scope.registrationFrozen = true;
          $scope.settings.loading = false;
        });
      })['catch'](function() {
        $scope.settings.loading = false;
        $scope.registrationFrozen = true;
      });
      

      $scope.timeZones = [];
      $scope.time_zones = function(){
        $http.get(DOMAIN + '/timezones/all').then(function(result) {
          $scope.timeZones = result.data
        });
      }  

      $scope.time_zones();
      $scope.agreedSms = false;

      $scope.phone_invalid = false;
      $scope.setPhone = function(){
        if($scope.newUser.allows_sms){
          $scope.phone_invalid = $scope.newUser.profile.phone == undefined ? true : false
        }else{
          $scope.phone_invalid = false
        }
      }

      $scope.agreedTerms = false;
      $scope.newUser = new User({
        origin_url: SITE,
        email: $rootScope.registerEmail || ipCookie('registerEmail') || ''
      });
      $scope.registrationFrozen = false;

      $scope.retype = {
        email: '',
        password: ''
      };

      $scope.settings = {
        loading: true
      };

      $scope.showEligibility = false;

      $scope.resetUserImage = function() {
        $scope.newUser.profile.image = null;
      };

      $scope.checkUnique = function(field, value) {
        User.validate($scope.site.id, {
          field: field,
          value: value
        }).then(function(response) {
          if (field === 'email') {
            $scope.email_duplicate = false;
          }
        }, function(response) {
          if (field === 'email' && response.status === 422) {
            $scope.messages.emailErrorMessage = $scope.messages.emailDupMessage;
            $scope.email_duplicate = true;
          }
        });
      };

      $scope.checkEmailFormat = function(email) {
        if (email && !!$('#email').val()) {
          $scope.email_duplicate = false;
        } else {
          $scope.email_duplicate = true;
          $scope.messages.emailErrorMessage = $scope.messages.emailInvalidMessage;
        }
      };

      $scope.compareStrings = function(input, input_type) {
        if (input_type === 'email') {
          $scope.email_invalid = $scope.newUser.email.toLowerCase() !== input.toLowerCase();
        } else {
          $scope.password_invalid = $scope.newUser.password !== input;
        }

        $scope.safeApply();
      };

      $scope.register = function() {
        $scope.creating = true;
        $scope.somethingWentWrong = false;

        // Clear any errors.
        $scope.$emit('errors', []);
        $scope.data.errors = [];

        if (!$scope.email_invalid && !$scope.password_invalid && !$scope.password_invalid_format && !$scope.not_an_email && !$scope.phone_invalid) {

          // Create the user.
          $scope.site.verifyCanRegister(function(response) {
            if (response.max_participants || response.registration_ended) {
              $scope.registrationFrozen = true;
              if (response.max_participants && !response.registration_ended) {
                var message = Content.getByKey($scope.messages.contents, 'closed_max_message', true);
                if (message && message.content_html !== '') {
                  $scope.messages.closed = message.content_html;
                }
              }
            } else {
              if ($scope.site.flags.allow_set_location) {
                if ($scope.newUser.childLocation) {
                  $scope.newUser.location_id = $scope.newUser.childLocation.id;
                } else {
                  $scope.newUser.location_id = $scope.newUser.parentLocation.id;
                }
              }

              $http.post(DOMAIN + '/sites/' + $scope.site.id + '/users', $scope.newUser).then(function(response) {
                var _user = _.head(response.data.data);
                if (_user.auth_basic_header) {
                  ipCookie('basic', _user.auth_basic_header, { path: '/' });
                }
                CurrentUser.set(_user);

                CurrentUser.get(true).then(function(_user) {
                  CurrentSite.get(true).then(function() {
                    var programId = $state.params.programId || sessionStorage.getItem('sso_programId');
                    if (programId) {
                      sessionStorage.removeItem('sso_programId');
                      $rootScope.streamlineRedirect(programId);
                    } else {
                      $rootScope.$broadcast('userLoggedIn', _user, 'none');
                      $state.go('go.u.home');
                    }
                  });
                });
              }, function(response) {
                ErrorService.showErrors(response, 'Could not create user!');
                $scope.creating = false;
                $scope.somethingWentWrong = true;
                console.log(response);
                $scope.data.errors = response.data.errors;
                $('#create_account_button').prop("disabled", false);
              });
            }
          });
        } else {
          $scope.creating = false;
          $('#create_account_button').prop("disabled", false);

          var errorArray = [];

          if ($scope.password_invalid) {
            errorArray.push("Passwords do not match.");
            $("#password2").focus();
          }

          if ($scope.password_invalid_format) {
            errorArray.push($scope.site.password_help_message);
            $("#password").focus();
          }

          if ($scope.email_invalid) {
            errorArray.push("Emails do not match.");
            $("#email2").focus();
          }

          if ($scope.email_duplicate) {
            errorArray.push("Email already in use.");
            $("#email").focus();
          }

          if ($scope.not_an_email) {
            errorArray.push("Please enter a valid email address.");
            $("#email").focus();
          }

          if ($scope.phone_invalid){
            errorArray.push("Invalid phone number");
            $("#phone").focus();
          }

          $scope.$emit('errors', errorArray);
        }
      };

      // Watchers.
      $scope.$watch('newUser.email', function(email) {
        if (email) {
          var sanitizedEmail = $scope.sanitizeEmail(email);
          $scope.newUser.email = sanitizedEmail;
          if ($scope.emailTimeout) {
            clearTimeout($scope.emailTimeout);
          }

          $scope.emailTimeout = setTimeout(function() {
            $scope.checkUnique('email', sanitizedEmail);
          }, 1000);

          if ($scope.retype.email) {
            $scope.compareStrings($scope.retype.email, 'email');
          }
        }
      });

      $scope.$watch('newUser.password', function(password) {
        if ($scope.newUserPasswordTimeout) {
          clearTimeout($scope.newUserPasswordTimeout);
        }

        $scope.newUserPasswordTimeout = setTimeout(function() {
          if (!!password && !new RegExp($scope.site.password_regular_expression_string).test(password)) {
            // if password set and it has incorrect format
            $scope.password_invalid_format = true;
          } else {
            // if password set and format is correct
            $scope.password_invalid_format = false;
            if ($scope.retype.password) {
              $scope.compareStrings($scope.retype.password, 'password');
            } else {
              clearTimeout($scope.newUserPasswordTimeout);
            }
          }
          $scope.$safeApply();
        }, 1000);
      });

      $scope.$watch('retype.email', function(email) {
        if (email) {
          var sanitizedEmail = $scope.sanitizeEmail(email);
          $scope.retype.email = sanitizedEmail;
          if ($scope.retypeEmailTimeout) {
            clearTimeout($scope.retypeEmailTimeout);
          }

          $scope.retypeEmailTimeout = setTimeout(function() {
            $scope.compareStrings(sanitizedEmail, 'email');
          }, 1000);
        } else {
          clearTimeout($scope.retypeEmailTimeout);
        }
      });

      $scope.$watch('retype.password', function(password) {
        if (password) {
          if ($scope.retype_password_timeout) {
            clearTimeout($scope.retype_password_timeout);
          }
          $scope.retype_password_timeout = setTimeout(function() {
            $scope.compareStrings(password, 'password');
          }, 1000);
        } else {
          clearTimeout($scope.retype_password_timeout);
        }
      });
    }
  ]);
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.register', {
    url: '/register?:programId',
    controller: 'RegistrationController',
    title: 'Create an Account',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/registration/registration.html');
      }
    ],
    params: {
      programId: null
    }
  });
});
'use strict';

angular.module('goApp')
	.factory('ReportField', ['ActiveResource', 'DOMAIN',
		function(ActiveResource, DOMAIN) {

			var ReportField = ActiveResource('/report_fields/:id', {
				nestedRoutes: ['index', 'show', 'create', 'update', 'destroy'],
				parentResource: 'Site',
				domain: DOMAIN
			});

			return ReportField;
		}
	]);
'use strict';

angular.module('goApp')
	.controller('ReportsCtrl',
		function($scope, $filter, $location, $stateParams, $log, Report, ReportField, HesArray, Site, LocationsLoader, reports, reportFields, DOMAIN, $timeout, HesDate, ngDialog, SiteLoader, $state, SitesLoader, Utils, ErrorService, DialogService) {

			$scope.grid = null;
			$scope.regexDateField = new RegExp(' (on|at|date)$');
			$scope.reportData = {
				rows: []
			};

			$scope.exportCall = {
				exportReport: null
			};

			$scope.data = {
				locations: [],
				selectedReport: null
			};

			$scope.selectRegion = {
				level1: '',
				level2: '',
				level3: ''
			};

			$scope.settings = {
				reportRunning: false,
				reportSaving: false,
				confirmDeleteReport: false,
				deleteReportError: '',
				recordedOnReportField: null,
				loading: true
			};

			$scope.hasFilters = false;

			// All reports.
			$scope.reports = reports;

			// Default reports.
			$scope.defaultReports = HesArray.select($scope.reports, function(report) {
				return !report.parent;
			});

			// Custom reports.
			$scope.customReports = HesArray.select($scope.reports, function(report) {
				return !!report.parent;
			});

			$scope.allReports = HesArray.select($scope.reports, function(report) {
				report.group = !!report.parent ? 'Custom' : report.group || 'Default';
				return true;
			});

			$scope.reportFields = reportFields;

			// hidden fields come back marked from the api so saved reports still resolve;
			// they stay out of the pickers, don't run, and persist on save
			$scope.selectableReportFields = HesArray.select(reportFields, function(field) {
				return !field.hidden;
			});

			$scope.dateFormat = 'l';

			$scope.filterCriteria = [{
				value: '<',
				text: '<'
			}, {
				value: '<=',
				text: '<='
			}, {
				value: '=',
				text: 'is'
			}, {
				value: 'like',
				text: 'starts with'
			}, {
				value: '<>',
				text: 'is not'
			}, {
				value: '>',
				text: '>'
			}, {
				value: '>=',
				text: '>='
			}, {
				value: 'between',
				text: 'between'
			}];

			// **********
			// Promotions
			// **********

			//Find the register on field
			$scope.recordedOnReportField = $filter('filter')(reportFields, function(field) {
				return field.display_name.toLowerCase() === 'recorded on';
			})[0];

			$scope.isDateField = function(field) {
				return angular.isString(field) ? false : $scope.regexDateField.test(field.display_name.toLowerCase());
			};

			// *****
			// Table
			// *****

			$scope.resetView = function() {
				$timeout(function() {
					$('.coordinator-page').css('display', 'block');
					$('.coordinator-page').css('display', 'inline-block');
				}, 500);
			};

			function clearTableFilters() {
				// $scope.tableState.search.predicateObject = {};
			}

			function resetVisibleRowCount() {
				$scope.numberOfRowsVisible = 20;
				$scope.allRowsDisplayed = false;
				$scope.paginationNeeded = false;
				$scope.grid = null;
			}

			function scrollReportTableUp() {
				$('.table-wrapper').scrollTop(0);
			}

			$scope.displayMoreRows = function(inView) {
				if (!$scope.allRowsAreDisplayed($scope.hasFilters)) {
					if (inView) {
						$timeout(function() {
							$scope.numberOfRowsVisible += 20;
						}, 100);
					}
				} else {
					$scope.allRowsDisplayed = true;
				}
			};

			$scope.smartTableThings = function(tableState) {
				$scope.hasFilters = false;
				$scope.tableState = tableState;

				resetVisibleRowCount();

				if ($scope.reportData && $scope.reportData.rows) {
					var copyOfData = $scope.reportData.rows;
					var filteredData;

					// Filtering.
					if (tableState.search.predicateObject) {
						var searchObj = {};
						angular.forEach(Object.keys(tableState.search.predicateObject), function(key, idx) {
							searchObj[key.replace('column_', '')] = tableState.search.predicateObject[key];
						})

						filteredData = $filter('filter')(copyOfData, searchObj);
					}

					// Sorting.
					if (tableState.sort.predicate) {
						filteredData = $filter('orderBy')(filteredData, tableState.sort.predicate, tableState.sort.reverse);
					}

					// Were all the filters cleared?
					for (var filterProperty in tableState.search.predicateObject) {
						if (tableState.search.predicateObject.hasOwnProperty(filterProperty)) {
							$scope.hasFilters = true;
							break;
						}
					}
					$timeout(function() {
						$scope.displayedCollection = filteredData;

						if ($scope.allRowsAreDisplayed($scope.hasFilters)) {
							$scope.allRowsDisplayed = true;
							$scope.paginationNeeded = false;
						} else {
							$scope.paginationNeeded = true;
						}
					});
				}
			};

			// *******
			// Reports
			// *******
			$scope.getRecordedOnFilter = function(filters) {
				var recordedOnFilter = $filter('filter')(filters, function(filter) {
					return filter.field.display_name.toLowerCase() === 'recorded on';
				})[0];

				return recordedOnFilter;
			};

			$scope.setEffectiveDates = function() {
				$scope.reportFilter = {};
				if ($scope.reportSite) {
					var today = moment(today).format('MM/DD/YYYY');
					var minDate = moment($scope.reportSite.registration_starts_on, 'YYYY-MM-DD').format('MM/DD/YYYY');

					if ($scope.currentReport.report_type === 'SQL') {
						$scope.reportFilter = {
							reported_on_min: minDate,
							reported_on_max: today
						};
					}
				}
			};

			$scope.canDeleteReport = function(report) {
				var canDelete = false;

				if (!!report && !report.isNew()) {
					if (report.isCustomReport()) {
						canDelete = !Utils.isUndefinedOrNull($scope.user) && ($scope.user.isMaster() || ($scope.user.isCoordinatorOrAbove() && !report.createdByMaster()));
					} else {
						canDelete = !Utils.isUndefinedOrNull($scope.user) && $scope.user.isMaster();
					}
				}
				return canDelete;
			};

			$scope.canSaveReport = function(report) {
				return $scope.user.isMaster() || $scope.canDeleteReport(report) || report.isNew();
			}

			$scope.promptCreateReport = function() {
				$scope.newReport = new Report($scope.currentReport);
				$scope.newReport.id = null;
				$scope.newReport.as_custom = true;
				delete $scope.newReport.parent;
				ngDialog.openConfirm({
					template: '/scripts/reports/createSaveAsDialog.html',
					scope: $scope
				}).then(function() {
					$scope.createReport($scope.newReport);
				});
			};

			$scope.createReport = function(reportToCreate) {
				reportToCreate.created_by_master = $scope.user.isMaster();
				reportToCreate.site_id = $scope.reportSite.id;
				reportToCreate.report_type = $scope.displaySQLLayout ? 'SQL' : 'Simple';

				removeReportFields(reportToCreate);

				reportToCreate.create(function(newReport) {

					// Make the new report the current report and add it to the right collection.
					newReport.group = newReport.isCustomReport() ? 'Custom' : newReport.group || 'Default';
					$scope.currentReport = angular.copy(newReport);
					if (!reportToCreate.isCustomReport()) {
						$scope.currentReport.site_id = $scope.site.id;
					} else {
						$scope.currentReport.site_id = $scope.reportSite.id;
					}

					$scope.allReports.push(newReport);
					$scope.data.selectedReport = newReport;

					// Prepare the report with everything it needs to run, then run it.
					if ($scope.currentReport.isSimple()) {
						hydrateReportFields($scope.currentReport);
					}

					$scope.currentReport.filters = [];
					$scope.setEffectiveDates();

					$scope.runReport();
				});
			};

			$scope.setBetweenValues = function(filter, asArray) {
				if (filter.value) {
					if (asArray && !angular.isArray(filter.value)) {
						filter = []
						filter.value = [filter.value[0], filter.value[1]];
					} else if (!asArray && angular.isArray(filter.value)) {
						filter.value = {
							0: filter.value[0],
							1: filter.value[1]
						}
					}
				} else {
					filter.value = asArray ? [] : {};
				}
			};

			$scope.deleteReport = function(report) {
				var message = 'Are you sure you want to delete ' + report.name + ' report?';
				DialogService.openConfirmationDialog('Delete Report', message, 'No', 'Yes')
					.then(function() {
						$scope.deleteReportConfirmed(report);
					});
			};

			$scope.deleteReportConfirmed = function(reportToDelete) {
				if ($scope.canDeleteReport(reportToDelete)) {
					//Only under 1 condition should as_custom be false.
					reportToDelete.deleting = true;
					reportToDelete.as_custom = !(!reportToDelete.isCustomReport() && $scope.user.isMaster());
					reportToDelete.site_id = $scope.reportSite.id;
					reportToDelete.$destroy({
						as_custom: reportToDelete.as_custom
					}, function() {
						reportToDelete.deleted = true;

						var reportsArray = $scope.allReports;

						for (var i = 0; i < reportsArray.length; i++) {
							if (reportsArray[i].id === reportToDelete.id) {
								reportsArray.splice(i, 1);
							}
						}

						if ($scope.currentReport.id === reportToDelete.id) {
							$scope.resetReportPage();
						}
						reportToDelete = null;

					}, function(response) {
						reportToDelete.deleting = false;
						ErrorService.showErrors(response, 'Report could not be deleted.');
					});
				}
			};

			$scope.resetReportPage = function() {

				// Initialize a new report.
				$scope.currentReport = new Report({
					fields: [''],
					filters: [],
					name: 'New Report',
					site_id: $scope.reportSite.id,
					report_type: 'Simple'
				});

				// Default to the simple layout by default.
				$scope.switchToSimpleLayout();

				// Don't want to reset region for Region or Location Coordinators.
				if ($scope.user.isMaster() || $scope.user.isCoordinator()) {
					$scope.selectRegion.level1 = null;
				}

				// Don't want to reset location for Location Coordinators.
				if ($scope.user.isCoordinatorOrAbove()) {
					$scope.selectRegion.level2 = null;
					$scope.selectRegion.level3 = null;
				}

				// Reset visual stuff.
				$scope.noRowsReturned = true;
				$scope.reportError = false;
				$scope.reportPristine = true;
				$scope.settings.reportRunning = false;
				$scope.reportSaveError = false;
				$scope.showReportDetails = true;
				$scope.reportData = {};

				$scope.resetView();
			};

			$scope.getDateFieldsInFilters = function() {
				var filters = JSON.parse(JSON.stringify($scope.currentReport.filters));
				angular.forEach(filters, function(filter) {
					if ($scope.isDateField(filter.field) && filter.sign === 'between' && angular.isArray(filter.value)) {
						filter.value[0] = moment(filter.value[0], 'MM/DD/YYYY').format('YYYY-MM-DD HH:mm:ss');
						filter.value[1] = moment(filter.value[1], 'MM/DD/YYYY').format('YYYY-MM-DD HH:mm:ss').replace('00:00:00', '23:59:59');
					}
				});
				return filters;
			};

			$scope.runReport = function() {
				var removeLeadingSpaces = true;

				// Reset table things.
				clearTableFilters();
				resetVisibleRowCount();
				scrollReportTableUp();
				var reportFilters = $scope.getDateFieldsInFilters();


				$scope.noRowsReturned = false;
				$scope.reportData = {};
				$scope.reportError = false;
				$scope.reportPristine = false;
				$scope.settings.reportRunning = true;
				$scope.reportSaveError = false;
				$scope.showReportDetails = true;
				$scope.displayedCollection = [];

				$scope.currentReport.report_type = $scope.displaySQLLayout ? 'SQL' : 'Simple';


				//Set location for report
				var selectedLocation = null;
				var selectedTopLevelLocation = null;
				if ($scope.reportSite.isLocationDisplayed()) {
					selectedTopLevelLocation = $scope.selectRegion.level1;
					if ($scope.selectRegion.level2 !== null) {
						selectedLocation = $scope.selectRegion.level2;

						//Location level 3 is forced in the HTML when it exists
						if ($scope.selectRegion.level3 !== null) {
							selectedLocation = $scope.selectRegion.level3;
						}
					}
				}

				function getRows(rows) {
					var wrappedRows = [];
					angular.forEach(rows, function(row) {
						wrappedRows.push({
							row: row
						});
					});
					return wrappedRows;
				}

				$scope.currentReport.run($scope.currentReport.fields, reportFilters, $scope.reportFilter, selectedTopLevelLocation, selectedLocation, $scope.currentReport.sql, $scope.currentReport.parent !== undefined ? $scope.currentReport.parent : true, $scope.reportSite.id)
					.then(function(request) {
						var data = request.data.data;
						$scope.settings.reportRunning = false;
						$scope.showReportDetails = false;

						if (data[0][0] === 'rows' && data[1][0] === 'fields') {
							$scope.reportData = {
								fields: data[1][1],
								rows: getRows(data[0][1])
							};
						} else if (data[0][0] === 'fields' && data[1][0] === 'rows') {
							$scope.reportData = {
								fields: data[0][1],
								rows: getRows(data[1][1])
							};
						}

						$scope.displayedCollection = $scope.reportData.rows;

						if ($scope.displayedCollection.length > 0) {

							// Removes the first character of a string if it's a space. Helpful when sorting alphabetically.
							if (removeLeadingSpaces) {
								for (var i = 0; i < $scope.displayedCollection.length; i++) {
									for (var _i = 0; _i < $scope.displayedCollection[i].length; _i++) {
										if (typeof $scope.displayedCollection[i][_i] === 'string' && $scope.displayedCollection[i][_i].charAt(0) === ' ') {
											$scope.displayedCollection[i][_i] = $scope.displayedCollection[i][_i].substring(1);
										}
									}
								}
							}

							$scope.allRowsDisplayed = $scope.allRowsAreDisplayed(false);
							$scope.allRowsDisplayed ? $scope.paginationNeeded = false : $scope.paginationNeeded = true;
						} else {
							$scope.noRowsReturned = true;
						}

						if (false && $scope.displayedCollection.length == 50000) {
							ngDialog.open({
								template: '/scripts/reports/limit-50k-dialog.html',
								scope: $scope,
							});
						}

						$scope.grid = null;
						// formatDHTMLXData();
					}, function(response) {
						$scope.reportError = true;
						$scope.settings.reportRunning = false;
					});
			};

			$scope.saveReport = function() {
				if ($scope.currentReport.isNew()) {
					if ($scope.user.isMaster() && ($scope.reportSite.isDefault())) {
						$scope.currentReport.as_custom = false;
					} else {
						$scope.currentReport.as_custom = true;
					}
					$scope.createReport($scope.currentReport);
				} else {
					removeReportFields($scope.currentReport);
					$scope.settings.reportSaving = true;

					$scope.currentReport.save(function(report) {
						$scope.currentReport = angular.copy(report);
						$scope.currentReport.site_id = $scope.reportSite.id;
						$scope.settings.reportSaving = false;

						if ($scope.currentReport.isSimple() && !$scope.currentReport.hydrated) {
							hydrateReportFields($scope.currentReport);
						}

						var reportsArray = [];
						if (report.isCustomReport()) {
							report.group = 'Custom';
						} else {
							report.group = 'Default';
						}
						reportsArray = $scope.allReports;

						for (var i = 0; i < reportsArray.length; i++) {
							if (reportsArray[i].id === report.id) {
								reportsArray[i] = report;
							}
						}
					}, function() {
						if ($scope.currentReport.isSimple() && !$scope.currentReport.hydrated) {
							hydrateReportFields($scope.currentReport);
						}

						$scope.settings.reportSaving = false;
						$scope.reportSaveError = true;
					});
				}
			};

			$scope.showReport = function(report, isCustom) {
				if (!!report) {
					$scope.currentReport = angular.copy(report);
					$scope.currentReport.site_id = $scope.reportSite.id;

					// Switch to the correct layout.
					switchToCorrectLayout();

					// Reset region and location. Don't want to reset region for Region or Location Coordinators.
					if ($scope.user.isMaster() || $scope.user.isCoordinator()) {
						$scope.selectRegion.level1 = null;
					}

					// Don't want to reset location for Location Coordinators.
					if ($scope.user.isCoordinatorOrAbove()) {
						$scope.selectRegion.level2 = null;
						$scope.selectRegion.level3 = null;
					}

					$scope.setEffectiveDates();
					$scope.runReport();
					$scope.data.selectedReport = null;
				}
			};

			$scope.switchToSimpleLayout = function() {
				$scope.currentReport.report_type = 'Simple';
				$scope.displaySimpleLayout = true;
				$scope.displaySQLLayout = false;
				hydrateReportFields($scope.currentReport);
				$scope.setEffectiveDates();

				// Remove any SQL.
				$scope.currentReport.sql = null;
			};

			$scope.switchToSQLLayout = function() {
				$scope.currentReport.report_type = 'SQL';
				$scope.displaySimpleLayout = false;
				$scope.displaySQLLayout = true;
				$scope.currentReport.filters = [];
				$scope.setEffectiveDates();
			};

			$scope.toggleReportDetails = function() {
				$scope.showReportDetails = !$scope.showReportDetails;
			};


			// ******
			// Fields
			// ******

			function hydrateReportFields(report) {
				if (!report.hydrated) {
					for (var i = 0, fieldLength = report.fields.length; i < fieldLength; i++) {
						// fields hidden on the back end don't resolve; keep the raw id so saving persists them
						report.fields[i] = HesArray.findBy($scope.reportFields, 'id', report.fields[i].toString(), getReportId) || report.fields[i].toString();
					}

					if (report.filters) {
						if (report.filters.hashes) {
							report.filters = report.filters.hashes;
						} else {
							report.filters = [];
						}

						for (var _i = 0, filterLength = report.filters.length; _i < filterLength; _i++) {
							report.filters[_i].field = HesArray.findBy($scope.reportFields, 'id', report.filters[_i].field) || report.filters[_i].field;
						}
					} else {
						report.filters = [];
					}

					report.hydrated = true;
				}
			}

			// hidden fields hydrate to objects with hidden: true; raw id strings only
			// happen for ids that no longer exist at all ('' is the choose-field placeholder)
			$scope.isHiddenField = function(field) {
				if (typeof field === 'string') {
					return field.length > 0;
				}
				return !!(field && field.hidden);
			};

			$scope.addField = function() {
				if (HesArray.select($scope.currentReport.fields, function(field) {
						return !$scope.isHiddenField(field) && !field.id;
					}).length === 0) {
					$scope.currentReport.fields.push($scope.selectableReportFields[0]);
					$scope.resetView();
				}
			};

			$scope.removeField = function(index) {
				if ($scope.currentReport.fields.length > 1) {
					$scope.currentReport.fields.splice(index, 1);
				} else {
					$scope.currentReport.fields[0] = $scope.selectableReportFields[0];
				}
				$scope.resetView();
			};

			function removeReportFields(report) {
				if (report.isSimple()) {
					for (var i = 0, fieldLength = report.fields.length; i < fieldLength; i++) {
						report.fields[i] = report.fields[i].id || report.fields[i];
					}

					if (report.filters) {
						for (var j = 0, filterLength = report.filters.length; j < filterLength; j++) {
							report.filters[j].field = report.filters[j].field.id || report.filters[j].field;
						}
					}

					report.hydrated = false;
				}
			}

			// *******
			// Filters
			// *******

			$scope.canAddFilter = function() {
				return HesArray.select($scope.currentReport.filters, function(filter) {
					// filters on hidden fields keep a raw id string; treat them as complete
					if ($scope.isHiddenField(filter.field)) {
						return !filter.sign || !filter.value;
					}
					return !filter.field || !filter.field.id || !filter.sign || !filter.value;
				}).length === 0;
			}

			$scope.addFilter = function(filter) {
				//Saved reports have Filters which are coming from the server as an Object 
				if (!angular.isArray($scope.currentReport.filters)) {
					$scope.currentReport.filters = [];
				}
				filter = filter || {
					field: '',
					sign: '',
					value: ''
				};
				if ($scope.canAddFilter()) {
					$scope.currentReport.filters.push(filter);
				}
			};

			$scope.removeFilter = function(index) {
				$scope.currentReport.filters.splice(index, 1);
				$scope.resetView();
			};


			// *********
			// Locations
			// *********

			function getLocations() {
				$scope.loadingLocations = true;
				new LocationsLoader($scope.reportSite.id).then(function(locations) {
					$scope.data.locations = locations;
				});
			}

			$scope.removeLocation = function() {
				$scope.selectedLocation = null;
			};

			// *****
			// Other
			// *****

			function formatDHTMLXData() {
				var DGrid = dhtmlXGridObject;
				var gridData = {
					fields: JSON.parse(JSON.stringify($scope.reportData.fields)),
					rows: JSON.parse(JSON.stringify($scope.displayedCollection))
				};
				var rows = {
					rows: []
				};

				if ('rows' in gridData === false) {
					rows.rows = gridData;
					gridData = rows;
				}

				for (var i = 0, len = gridData.rows.length; i < len; i++) {
					if (!$scope.displayedCollection[i].data) {
						gridData.rows[i] = {
							id: i + 1,
							data: $scope.displayedCollection[i]
						};
					}
				}

				if (gridData) {
					var header = HesArray.collect(gridData.fields || [], function(column) {
						return typeof column === 'string' ? column : column[0]
					}).join(',');

					$scope.grid = new DGrid('gridbox');
					$scope.grid.setHeader(header);
					$scope.grid.init();

					return $scope.grid.parseNoRender(gridData, 'json');
				}
			}

			function getReportId(item) {
				return item.toString();
			}

			function setFieldOptions() {
				var competitionRegex = /^Competition ([0-9]+) Fields$/;
				var evaluationRegex = /^Evaluation ([0-9]+) Fields$/;

				for (var i = 0; i < reportFields.length; i++) {

					// Participant fields go first.
					if (reportFields[i].category === 'Participant Fields') {
						participantFields.push(reportFields[i]);
						reportFields[i].selectSequence = 1;
					}

					// Then registration fields
					else if (reportFields[i].category === 'Registration Fields') {
						registrationFields.push(reportFields[i]);
						reportFields[i].selectSequence = 2;
					}

					// Then evaluation fields.
					else if (evaluationRegex.test(reportFields[i].category)) {
						evaluationFields.push(reportFields[i]);
						reportFields[i].selectSequence = 3;
					}

					// Then competition fields.
					else if (competitionRegex.test(reportFields[i].category)) {
						competitionFields.push(reportFields[i]);
						reportFields[i].selectSequence = 4;
					}

					// Then milestone fields.
					else if (reportFields[i].category === 'Milestone Fields') {
						milestoneFields.push(reportFields[i]);
						reportFields[i].selectSequence = 5;
					}

					// Then program fields.
					else if (reportFields[i].category === 'Program Fields') {
						programFields.push(reportFields[i]);
						reportFields[i].selectSequence = 8;
					}

					// Challenge Fields
					else if (reportFields[i].category === 'Regional Challenge Fields') {
						programFields.push(reportFields[i]);
						reportFields[i].selectSequence = 6;
					}

					// Challenge Fields
					else if (reportFields[i].category === 'Peer-to-Peer Challenge Fields') {
						programFields.push(reportFields[i]);
						reportFields[i].selectSequence = 7;
					}

					// Success Story Fields
					else if (reportFields[i].category === 'Success Story Fields') {
						programFields.push(reportFields[i]);
						reportFields[i].selectSequence = 9;
					}

					// Success Story Fields
					else {
						programFields.push(reportFields[i]);
						reportFields[i].selectSequence = 10;
					}
				}

				$scope.reportFields = participantFields.concat(registrationFields).concat(evaluationFields).concat(competitionFields).concat(programFields).concat(milestoneFields);
				$scope.reportFields.unshift({
					display_name: "-- Choose Field --",
					category: "",
					selectSequence: -9999,
					id: ""
				});
			}

			function switchToCorrectLayout() {
				if ($scope.currentReport.isSQL()) {
					$scope.switchToSQLLayout();
				} else if ($scope.currentReport.isSimple()) {
					$scope.switchToSimpleLayout();
				}
			}

			$scope.allRowsAreDisplayed = function(viewingFiltered) {
				if (viewingFiltered) {
					return ($scope.numberOfRowsVisible >= $scope.displayedCollection.length) || $scope.displayedCollection.length === 0;
				} else {
					return ($scope.numberOfRowsVisible >= $scope.reportData.rows.length) || $scope.reportData.rows.length === 0;
				}
			};

			function ConvertToCSV(objArray, fields) {
				var array = objArray;
				var str = '';

				for (var i = 0; i < array.length; i++) {
					var line = '';
					for (var index = 0; index < fields.length; index++) {
						var field = fields[index];

						if (line != '') line += ','

						var val = array[i][index];
						if (field[1] === 'time' || field[1] === 'date' || field[1] === 'datetime') {
							val = moment(val).format('l');
						}

						if (field[1] !== "integer" && field[1] !== "decimal") {
							if (val !== null && val !== undefined) {
								try {
									val = '"' + val.replace(/"/g, '""') + '"';
								} catch (e) {
									val = val === null ? '' : val.toString();
								}
							} else {
								val = '';
							}
						}
						line += val === null ? '' : val;
					}

					str += line + '\n';
				}

				return str;
			}

			$scope.exportReport = function() {
				$scope.exportCall.exportReport($scope.currentReport.name);
			};

			$scope.switchSites = function() {
				$scope.settings.loading = true;
				$state.go('go.u.reports', {
					siteId: $scope.reportSite.id
				});
			};

			var competitionFields = [];
			var evaluationFields = [];
			var milestoneFields = [];
			var participantFields = [];
			var programFields = [];
			var registrationFields = [];

			$scope.sqlOptions = ':location_id<br />:organization_id<br />:site_id<br />:reported_on_max<br />:reported_on_min<br />:reseller_id<br />:top_level_location_id';

			setFieldOptions();

			// Initialize a new report.
			new SiteLoader({
				siteId: $state.params.siteId || $scope.site.id
			}).then(function(site) {
				$scope.reportSite = site;
				getLocations();
				if ($scope.user.isMaster()) {
					var oldLogo = $scope.site.logo;
					$scope.site.logo = $scope.reportSite.logo;
					$scope.$on('$destroy', function() {
						$scope.site.logo = oldLogo;
					});
				}

				new SitesLoader().then(function(sites) {
					$scope.sites = sites;
					$scope.resetReportPage();
					$scope.settings.loading = false;
				}, function(){
					$scope.sites = [];
					$scope.resetReportPage();
					$scope.settings.loading = false;
				});
			});
		});
'use strict';

angular.module('goApp')

.factory('ReportsLoader', ['Report', '$q', 'Utils',
    function(Report, $q, Utils) {
        return function(options) {
            var defer = $q.defer();
            var opts = angular.extend({}, options);

            Report.index(opts, function(reports) {
                defer.resolve(reports);
            }, function() {
                defer.reject('Reports could not be loaded.');
            });

            return defer.promise;
        };
    }
])


.factory('ReportFieldsLoader', ['ReportField', '$q',
    function(ReportField, $q) {
        return function(siteId) {
            var defer = $q.defer();

            ReportField.index({
                site_id: siteId,
                siteize: true
            }, function(reportFields) {
                defer.resolve(reportFields);
            }, function() {
                defer.reject('Report field could not be loaded.');
            });

            return defer.promise;
        };
    }
]);
'use strict';

angular.module('goApp')
	.factory('Report',
		function(ActiveResource, $http, DOMAIN, HesArray, $stateParams) {

			var Report = ActiveResource('/reports/:id', {
				nestedRoutes: ['index', 'show', 'create', 'update', 'destroy'],
				parentResource: 'Site',
				domain: DOMAIN
			});

			Report.prototype.createdByMaster = function() {
				return this.created_by_master;
			};

			Report.prototype.isSimple = function() {
				return this.report_type === 'Simple';
			};

			Report.prototype.isSQL = function() {
				return this.report_type === 'SQL';
			};

			Report.prototype.isCustomReport = function() {
				//this.parent is true for Custom Reports and false for default... not sure why
				return this.parent;
			};

			Report.prototype.run = function(fields, filters, reportFilters, region, location, sql, is_custom, siteId, evalDefId) {
				var fieldsToUse;
				var filtersToUse;

				siteId = siteId || $stateParams.siteId;

				// Were objects or strings passed in? Hidden fields stay as raw id strings, so the array can be mixed
				var hasObjectFields = false;
				for (var _i = 0; _i < fields.length; _i++) {
					if (typeof fields[_i] === 'object') {
						hasObjectFields = true;
						break;
					}
				}

				if (hasObjectFields) {
					fieldsToUse = HesArray.collect(fields, function(field) {
						return field.id || field;
					});

					filtersToUse = HesArray.collect(filters, function(filter) {
						return {
							field: filter.field.id || filter.field || '',
							sign: filter.sign || '',
							value: filter.value || ''
						};
					});
				} else if (typeof fields[0] === 'string') {
					fieldsToUse = fields;
					filtersToUse = [];
				} else {
					fieldsToUse = [];
					filtersToUse = [];
				}

				// Object that contains all report fields, filters, locations, SQL, etc...
				var reportObject = {};

				// Date range.
				reportObject.max_date = reportFilters.reported_on_max;
				reportObject.min_date = reportFilters.reported_on_min;

				// Either SQL or filters.
				if (sql) {
					reportObject.sql = sql;
				} else {
					reportObject.field = fieldsToUse;
					reportObject.filter = filtersToUse;
				}

				// Region.
				if (region) {
					reportObject.top_level_location = region.id;
				}

				// Location.
				if (location) {
					reportObject.location = location.id;
				}

				if (evalDefId) {
					reportObject.evaluation_definition_id = evalDefId;
				}

				return $http.post(DOMAIN + '/sites/' + siteId + '/reports/' + this.id + '/run' + '?is_custom=' + is_custom, reportObject);
			};

			return Report;
		}
	);
'use strict';

angular.module('goApp')

.config(['$stateProvider',
	function($stateProvider) {
		$stateProvider
			.state('go.u.reports', {
				url: '/site/:siteId/reports',
				controller: 'ReportsCtrl',
				abstract: false,
				templateProvider: ['hesTemplateService',
					function(hesTemplateService) {
						return hesTemplateService.getTemplate('/scripts/reports/masterDashboardReports.html');
					}
				],
				resolve: {
					reports: ['ReportsLoader', '$stateParams',
						function(ReportsLoader, $stateParams) {
							$stateParams.siteId = $stateParams.siteId || 1
							return new ReportsLoader({
								site_id: $stateParams.siteId
							});
						}
					],

					reportFields: ['ReportFieldsLoader', '$stateParams',
						function(ReportFieldsLoader, $stateParams) {
							$stateParams.siteId = $stateParams.siteId || 1
							return new ReportFieldsLoader($stateParams.siteId);
						}
					]
				}
			});
	}
]);
angular.module('goApp').directive("requiredTermsCheckbox",function($state, $http, DOMAIN, ngDialog){
  return {
    restrict: "A",
    scope: {
      customContent: "="
    },
    template: "\
      <div ng-if='data.has_loaded'> \
        <input ng-disabled='isDisabled()' ng-click='toggle()' ng-model='data.is_checked' id='required_terms' type='checkbox'></input>\
        <label for='required_terms'>Is Required Term?</label>\
        <span ng-if='isDisabled()'>(must save to toggle required terms checkbox)</span>\
      </div>\
    ",
    link: function(scope,element,attributes){
      scope.data = new Object();
      scope.data.is_checked = null;
      scope.data.has_loaded = false;

      $http.get(DOMAIN+"/sites/"+$state.params.siteId+"/required_terms").then(function(repsonse){
        scope.data.has_loaded = true;
        scope.data.required_terms = repsonse.data;
        scope.data.is_checked = !!_.filter(scope.data.required_terms,{custom_content_id: scope.customContent.id})[0];
      });

      scope.isDisabled = function(){
        return !scope.customContent.id || scope.customContent.site_id != $state.params.siteId;
      }

      scope.toggle = function(){
        scope.data.is_checked = !scope.data.is_checked;

        if (scope.data.is_checked == true) {
          scope.confirmation = {
            message: "Enabling this chechbox will force all users to accept this term in order to use the site. Click yes to require this term immediately.",
            confirmText: 'Yes',
            cancelText: 'Cancel'
          }
          ngDialog.openConfirm({
            template: '/scripts/dialogs/confirmationDialog.html',
            scope: scope
          }).then(function() {
            $http.post(DOMAIN+"/sites/"+$state.params.siteId+"/required_terms",{
              custom_content_id: scope.customContent.id
            }).then(_.noop);
          }, function(){
            scope.data.is_checked = false;
          });
        } else {
          $http.delete(DOMAIN+"/sites/"+$state.params.siteId+"/required_terms/"+scope.customContent.id).then(_.noop);
        }
      }

    }
  }
});
angular.module('goApp').run(function($rootScope, $state, $q, CurrentUser, ContentLoader) {
  $rootScope.$on('$stateChangeStart', function(evt, toState, toParams, fromState, fromParams) {
    CurrentUser.get(false).then(function(user) {
      if(user.required_term_ids.length == 0 || _.includes(["go.help.contact", "go.logout", "go.u.settings.main", "go.u.settings.email"],toState.name)) return;
      $q.all([
        new ContentLoader({category:'privacy',site_id: $rootScope.site.id}),
        new ContentLoader({category:'terms',  site_id: $rootScope.site.id})
      ]).then(function(contents) {
        contents = _.flatten(contents),
        _.each(user.required_term_ids, function(required_term_id){
          var content = _.filter(contents,{id:required_term_id})[0];
          if (content) {
            var redirect_to = null;
            switch(content.category) {
              case "terms":
                redirect_to = "go.privacy_terms.terms";
                break;
              case "privacy":
              redirect_to = "go.privacy_terms.privacy";
               break;
            }
            if (redirect_to && redirect_to != toState.name) {
              $state.go(redirect_to);
              return false;
            }
          }
        });
      });
    });
  });
});
angular.module('goApp').directive("requiredTermPrompts",function($rootScope, $state, $http, DOMAIN, ngDialog, CurrentUser, $location){
  return {
    restrict: "A",
    scope: {
      requiredTermPrompts: "="
    },
    template: "\
      <div class='required-terms' ng-if='termToAccept'> \
        <p><strong>Our {{ policyType(termToAccept) }} Policy has been updated.</strong></p>\
        <p>We encourage you to review the full, updated version of our {{ policyType(termToAccept) }} Policy below.</p>\
        <p>Thank you for being a part of the {{ site.name }} community, If you have any questions, please feel free to <a ui-sref='go.help.contact'>contact us</a>.</p>\
        <p>Agree to continue using {{ site.name }}.</p>\
        <br/>\
        <button ng-click='acceptTerm()'>Agree</button>\
      </div>\
    ",
    link: function(scope,element,attributes){
      scope.site = $rootScope.site;

      function init(has_accepted) {
        CurrentUser.get(false).then(function(user){
          scope.termToAccept = _.filter(scope.requiredTermPrompts, function(term){
            return user.required_term_ids.indexOf(term.id) > -1; 
          })[0];
          if (!scope.termToAccept && has_accepted) {
            $location.path("/");
          }
        });
      }

      scope.acceptTerm = function(){
        if (!scope.termToAccept) return;
        $http.post(DOMAIN+"/sites/"+$rootScope.site.id+"/required_terms/accept_term",{
          custom_content_id: scope.termToAccept.id
        }).then(function(){
          CurrentUser.get(true).then(function(){
            init(true);
          });
        });
      }

      scope.policyType = function(term) {
        switch(term.category){
          case "terms":
           return "Terms";
          case "privacy":
          return "Privacy";
        }
      }

      scope.$watch("requiredTermPrompts",function(new_val){
        if(!new_val) return;
        init();
      })

    }
  }
});
'use strict';

angular.module('goApp').controller('ResourcesController', function($scope, ContentLoader, Content, LocationService, $q) {
  $scope.data = new Object();

  // since this view depends on 2 promises to resolve, use the $q.all function
  // this waits until all promise are resoled before running the then callback
  $q.all([
    new ContentLoader({category:'resources',site_id: $scope.site.id}),
    new ContentLoader({category:'location_resources',site_id: $scope.site.id})
  ]).then(function(data){
    var resources = data[0] || [], // data[0] is resource, data[1] is location resources
        location_resources = data[1] || [];
    // filter location resources to ones whose key is equal to user's location
    // or top level location name
    var location_resources = _.filter(location_resources, function(resource) {
      var loc = $scope.user.location,
          top_loc = $scope.user.top_level_location;
      return (loc && loc.name == resource.key) ||
             (top_loc && top_loc.name == resource.key);
    });

    // first order normal resources by sequence
    resources = _.orderBy(resources, ["sequence"], ['asc']);
    
    // then make the location resources first if there is any
    resources.unshift(location_resources);
    resources = _.flatten(resources);

    // lastly group both resources by group key. this hash maintains order
    $scope.data.grouped_contents = _.groupBy(resources,"group");
  });

  
});
'use strict';

angular.module('goApp').config(function($stateProvider) {

	$stateProvider.state('go.u.content.resources', {
		abstract: true,
		template: '<ui-view></ui-view>'
	});

	$stateProvider.state('go.u.content.resources.all', {
		url: "/resources",
		title: "Resources",
		controller: "ResourcesController",
		templateProvider: function(hesTemplateService) {
		  return hesTemplateService.getTemplate('/scripts/resources/views/resources.html');
		}
	});

});
angular.module('goApp')
  .component('hesSearchInput', {
    templateUrl: '/scripts/searchInput/searchInput.html',
    bindings: {
      searchValue: '<',
      onSearch: '&',
      placeholderText: '@'
    },
    controller: function(){
      var ctrl = this;

      ctrl.onEnter = function(){
        ctrl.onSearch({value: ctrl.searchValue});
      };

      ctrl.clearSearch = function(){
        ctrl.searchValue = '';
        ctrl.onEnter();
      };

      ctrl.$onInit = function(){
        //Needed?
        ctrl.searchValueCopy = ctrl.searchValue;
      };
    }
  });
'use strict';

angular.module('goApp')

.controller('DashboardSettingsCtrl', ['$rootScope', '$scope', '$q', 'CurrentSite', 'Location', 'User', '$timeout', '$location', '$state', 'Profile', 'ErrorService', 'user', 'SiteLoader', '$http', 'DOMAIN', 'LocationsLoader',
    function($rootScope, $scope, $q, CurrentSite, Location, User, $timeout, $location, $state, Profile, ErrorService, user, SiteLoader, $http, DOMAIN, LocationsLoader) {
        $scope.dashboardSettingsUser = {};
        $scope.settingsUserLocation = null;
        $scope.photoNotCropped = false;
        $scope.photo_crop_error = false;

        $scope.settingsConfig = {
            photoSaving: false,
            photoSaved: false,
            photoSaveError: false,
            photoSaveMsg: ''
        };

        $scope.stateChangeInfo = {
            toState: null,
            toParams: null,
            prevent: false,
            userAllow: false,
            imageHasChanged: false
        };

        $scope.data = {
            parentLocations: [],
            filterdSites: [],
            sitesQuery: ''
        };

        var stateChangeListener = $rootScope.$on('$stateChangeStart', function(evt, toState, toParams, fromState, fromParams) {
            if (($scope.photoNotCropped) && !$scope.stateChangeInfo.userAllow) {
                evt.preventDefault();
                $scope.stateChangeInfo.toState = toState;
                $scope.stateChangeInfo.toParams = toParams;
                $scope.stateChangeInfo.prevent = true;
            }
        });

        function hideDeviceRefreshMessages() {
            $scope.deviceError = false;
            $scope.deviceSuccess = false;
        }

        function isFormValid() {
            return $scope.errors.length === 0 && !$scope.emailAlreadyTaken && !$scope.usernameAlreadyTaken;
        }

        $scope.stayOnPage = function() {
            $scope.stateChangeInfo.prevent = false;
        };

        $scope.navigateAnyway = function() {
            $scope.stateChangeInfo.prevent = false;
            $scope.stateChangeInfo.userAllow = true;
            $state.transitionTo($scope.stateChangeInfo.toState, $scope.stateChangeInfo.toParams);
        };

        $scope.checkUniqueEmail = function() {
            if ($scope.dashboardSettingsUser && $scope.dashboardUser) {

                // Don't need to validate if they entered their existing email address.
                if ($scope.dashboardSettingsUser.placeholderEmail === $scope.dashboardUser.email) {
                    if (userValidators.emailTimeout) {
                        clearTimeout(userValidators.emailTimeout);
                        delete userValidators.emailTimeout;
                    }

                    ErrorService.clearErrors();
                    $scope.emailAlreadyTaken = false;
                } else {
                    if (userValidators.emailTimeout) {
                        clearTimeout(userValidators.emailTimeout);
                        delete userValidators.emailTimeout;
                    }

                    userValidators.emailTimeout = setTimeout(function() {
                        User.validate($scope.dashboardSettingsUser.site_id, {
                            field: 'email',
                            value: $scope.dashboardSettingsUser.placeholderEmail
                        }).then(function() {
                            ErrorService.clearErrors();
                            $scope.emailAlreadyTaken = false;
                        }, function() {
                            ErrorService.showErrors({}, 'Email has already been taken.');
                            $scope.emailAlreadyTaken = true;
                        });
                    }, 1000);
                }
            }
        };

        $scope.displayChildLocations = function() {
            return $scope.dashboardSettingsUser.parentLocation ? $scope.dashboardSettingsUser.parentLocation.locations.length > 0 : false;
        };

        $scope.displayGrandchildLocations = function() {
            return $scope.dashboardSettingsUser.childLocation ? $scope.dashboardSettingsUser.childLocation.locations.length > 0 : false;
        };

        $scope.displayLocationSelect = function() {
            // return $scope.dashboardSettingsUser.topLevelLocation ? $scope.dashboardSettingsUser.topLevelLocation.locations.length > 0 : false;
            return true;
        };

        $scope.isCurrentSubscription = function(subscription) {
            return parseInt(subscription.subscriptionId) === $scope.dashboardUser.fitbit_user.id;
        };

        $scope.locationChanged = function(location) {
            if (location === 'parent') {
                $scope.dashboardSettingsUser.childLocation = null;
            }
        };

        $scope.recalculateLocation = function() {
            $scope.settingsUserLocation = null;
            $scope.dashboardSettingsUser.location = null;
        };

        $scope.refreshWeekData = function(deviceType, chosenWeek) {
            var path = DOMAIN + '/fitbits/refresh_week?week=' + chosenWeek + '&user_id=' + $scope.dashboardUser.id;

            $scope.refreshingDeviceData = true;
            $scope.deviceSuccess = false;
            $scope.deviceError = false;

            $http.post(path).then(function() {
                $scope.deviceSuccess = true;
                $scope.refreshingDeviceData = false;

                $timeout(function() {
                    hideDeviceRefreshMessages();
                }, 5000);
            }, function() {
                $scope.deviceError = true;
                $scope.refreshingDeviceData = false;

                $timeout(function() {
                    hideDeviceRefreshMessages();
                }, 5000);
            });
        };

        $scope.saveProfilePhoto = function() {
            $scope.settingsConfig.photoSaving = true;
            $scope.settingsConfig.photoSaved = false;
            $scope.settingsConfig.photoSaveMsg = '';
            $scope.settingsConfig.photoSaveError = false;

            var userProfile = Profile.build({
                user_id: $scope.dashboardUser.id,
                image: $scope.profilePhoto,
                id: $scope.dashboardUser.profile.id
            });

            userProfile.save(function(profile) {
                $scope.dashboardUser.profile.image.url = profile.image.url;
                $scope.settingsConfig.photoSaved = true;
                $scope.settingsConfig.photoSaving = false;

                $timeout(function() {
                    $scope.settingsConfig.photoSaved = false;
                }, 3000);
            })['catch'](function(error) {
                $scope.settingsConfig.photoSaving = false;
                $scope.settingsConfig.photoSaveError = true;
                $scope.settingsConfig.photoSaveMsg = "Could not update profile photo. Please try again.";
            });
        };


        $scope.setEmailPreferences = function() {
            // $scope.user.allows_daily_email = $scope.dashboardSettingsUser.allows_daily_email ? true : false;
            // $scope.user.allows_daily_email_monday_only = $scope.dashboardSettingsUser.allows_daily_email_monday_only == 1 ? true : false;
        };

        $scope.updateUserInfo = function() {
            if ($scope.photoNotCropped) {
                $scope.photo_crop_error = true;
            } else {
                $scope.photo_crop_error = false;
                $scope.saved = false;
                $scope.savingUser = true;
                $scope.errors = [];

                // Name.
                if (!$scope.dashboardSettingsUser.profile.first_name) {
                    $scope.errors.push('First name required.');
                } else {
                    $scope.dashboardUser.profile.first_name = $scope.dashboardSettingsUser.profile.first_name;
                }

                if (!$scope.dashboardSettingsUser.profile.last_name) {
                    $scope.errors.push('Last name required.');
                } else {
                    $scope.dashboardUser.profile.last_name = $scope.dashboardSettingsUser.profile.last_name;
                }

                // Email
                if (!$scope.dashboardSettingsUser.placeholderEmail) {
                    $scope.errors.push('Email required.')
                } else {
                    $scope.dashboardUser.email = $scope.dashboardSettingsUser.placeholderEmail;
                }

                if ($scope.emailAlreadyTaken) {
                    ErrorService.showErrors({}, 'Email has already been taken.');
                }

                // Password.
                if ($scope.dashboardSettingsUser.placeholderPassword || $scope.dashboardSettingsUser.placeholderRetypePassword) {
                    if ($scope.dashboardSettingsUser.placeholderPassword) {
                        if ($scope.dashboardSettingsUser.placeholderPassword === $scope.dashboardSettingsUser.placeholderRetypePassword) {
                            $scope.dashboardUser.password = $scope.dashboardSettingsUser.placeholderPassword;
                        } else {
                            $scope.errors.push('Passwords must match.');
                        }
                    } else {
                        $scope.errors.push('Password required.');
                    }
                }

                // Location.
                if ($scope.dashboardUserSite.flags.is_location_displayed) {
                    if ($scope.dashboardSettingsUser.childLocation) {
                        $scope.dashboardUser.location_id = $scope.dashboardSettingsUser.childLocation.id;
                    } else {
                        $scope.dashboardUser.location_id = $scope.dashboardSettingsUser.parentLocation.id;
                    }
                }

                $scope.dashboardUser.origin_url = $scope.dashboardSettingsUser.origin_url;

                $scope.dashboardUser.flags.has_seen_why_steps = $scope.dashboardSettingsUser.flags.has_seen_why_steps;

                $scope.setEmailPreferences();

                // Save if there are no errors.
                if (isFormValid()) {
                    $scope.dashboardUser.save(function() {
                        $scope.savingUser = false;
                        $scope.saved = true;
                        $timeout(function() {
                            $scope.saved = false;
                        }, 1700);
                        $scope.uploaded = false;
                        $scope.stateChangeInfo.imageHasChanged = false;

                        // TODO: Find out why this is returning an incorrect URL in production.
                        if ($scope.hasUpdatedPhoto) {
                            $scope.dashboardUser.profile.image.url = $scope.dashboardUser.profile.image.url;

                            // Reset this now.
                            $scope.hasUpdatedPhoto = false;
                        }
                    }, function() {
                        // TODO: Handle this somehow?
                    });
                } else {
                    $scope.savingUser = false;
                    $scope.uploaded = false;
                }
            }
        };

        $scope.clearSiteSearch = function() {
            $scope.data.sitesQuery = '';
        };

        $scope.addSite = function(site) {
            if ($scope.dashboardUser.super_coordinator_sites === undefined) {
                $scope.dashboardUser.super_coordinator_sites = [];
            }
            $scope.dashboardUser.super_coordinator_sites.push(site);
        };

        $scope.removeSite = function(site) {
            var idx = $scope.dashboardUser.super_coordinator_sites.indexOf(site);
            $scope.dashboardUser.super_coordinator_sites.splice(idx, 1);
        };

        $scope.uploadPhotoStart = function() {
            $scope.uploadingPhoto = true;
        };

        $scope.uploadPhotoFinished = function() {
            $scope.hasUpdatedPhoto = true;
            $scope.uploaded = true;
            $scope.uploadingPhoto = false;
        };

        var userValidators = {};

        $scope.errors = [];
        $scope.uploadingPhoto = false;

        // True/false choices.
        $scope.trueFalseChoices = [{
            displayValue: 'Yes',
            dataValue: true
        }, {
            displayValue: 'No',
            dataValue: false
        }];

        // Role options.
        $scope.roleChoices = ['User', 'Reseller', 'Super Coordinator', 'Poster', 'Master', 'Coordinator', 'Regional Coordinator', 'Location Coordinator'];
        // Get site and user first.
        $q.all([
            CurrentSite.get()
        ]).then(function(data) {
            new SiteLoader({
                siteId: user.site_id
            }).then(function(dashboardUserSite) {
                $scope.dashboardUser = user;
                $scope.dashboardUserSite = dashboardUserSite;
                $scope.dashboardSettingsUser = angular.copy(user);
                $scope.dashboardSettingsUser.placeholderEmail = $scope.dashboardSettingsUser.email;
                if (!$scope.dashboardUser.super_coordinator_sites) {
                    $scope.dashboardUser.super_coordinator_sites = [];
                }

                // Get all of the user's site's locations.
                if ($scope.dashboardUserSite.flags.is_location_displayed) {
                    new LocationsLoader().then(function(parentLocations) {
                        var locationIsChild = false;
                        var locationIsParent = false;

                        $scope.data.parentLocations = parentLocations;

                        // Does the user only have a parent location?
                        for (var p = 0; p < $scope.data.parentLocations.length; p++) {
                            if (!!$scope.dashboardSettingsUser.location && !!$scope.data.parentLocations[p] && ($scope.dashboardSettingsUser.location.id === $scope.data.parentLocations[p].id)) {
                                locationIsParent = true;
                                $scope.dashboardSettingsUser.parentLocation = $scope.data.parentLocations[p];
                                break;
                            }
                        }

                        // If not, look through their children...
                        if (!locationIsParent) {
                            for (var _p = 0; _p < $scope.data.parentLocations.length; _p++) {
                                for (var c = 0; c < $scope.data.parentLocations[_p].locations.length; c++) {
                                    if ($scope.dashboardSettingsUser.location.id === $scope.data.parentLocations[_p].locations[c].id) {
                                        locationIsChild = true;
                                        $scope.dashboardSettingsUser.parentLocation = $scope.data.parentLocations[_p];
                                        $scope.dashboardSettingsUser.childLocation = $scope.data.parentLocations[_p].locations[c];
                                        break;
                                    }
                                }
                            }
                        }

                        // If it's not a child, check the grandchildren.
                        // if(!locationIsParent && !locationIsChild) {
                        //  for(var _p = 0; _p < $scope.parentLocations.length; _p++) {
                        //      for(var _c = 0; _c < $scope.parentLocations[_p].locations.length; _c++) {
                        //          for(var g = 0; g < $scope.parentLocations[_p].locations[_c].locations.length; g++) {
                        //              if($scope.dashboardSettingsUser.location_id ===  $scope.parentLocations[_p].locations[_c].locations[g]) {
                        //                  $scope.dashboardSettingsUser.parentLocation = $scope.parentLocations[_p];
                        //                  $scope.dashboardSettingsUser.childLocation = $scope.parentLocations[_p].locations[_c];
                        //                  $scope.dashboardSettingsUser.grandchildLocation = $scope.parentLocations[_p].locations[_c].locations[g];
                        //              }
                        //          }
                        //      }
                        //  }
                        // }
                    });
                }
            });
        }, function() {
            // TODO: Handle this somehow?
        });

        $scope.$on('$destroy', function() {
            if (angular.isFunction(stateChangeListener)) {
                stateChangeListener();
            }

            stateChangeListener = null;
        });
    }
]);
'use strict';

angular.module('goApp')

.controller('SettingsCtrl', ['$rootScope', '$scope', '$q', '$stateParams', 'CurrentUser', 'CurrentSite', 'User', '$timeout', '$location', '$state', 'ErrorService', 'STATE_CHOICES', 'LocationService', 'ngDialog', 'ContentLoader', 'Content', 'DialogService', 'Banner', '$http', 'DOMAIN',
	function($rootScope, $scope, $q, $stateParams, CurrentUser, CurrentSite, User, $timeout, $location, $state, ErrorService, STATE_CHOICES, LocationService, ngDialog, ContentLoader, Content, DialogService, Banner, $http, DOMAIN) {

		var password_format = /^(?=.*[a-zA-Z0-9]).{4,20}$/;
		var userValidators = {};

		$scope.emailAlreadyTaken = false;
		$scope.errors = [];
		$scope.password_invalid_format = false;
		$scope.settingsUser = {
			flags: {}
		};

		$scope.stateChangeInfo = {
			toState: null,
			toParams: null,
			prevent: false,
			userAllow: false
		};

		$scope.data = {
			parentLocations: [],
			addressLabel: 'Address',
			addressContent: ''
		};

		$scope.stateChoices = STATE_CHOICES;

		function initLocations() {
			if ($scope.site.flags.allow_set_location) {
				LocationService.get(false, $scope.site.id).then(function(parentLocations) {

					var locationIsChild = false;
					var locationIsParent = false;

					$scope.data.parentLocations = parentLocations;

					// Does the user only have a parent location?
					for (var p = 0; p < $scope.data.parentLocations.length; p++) {
						if (!!$scope.settingsUser.location && $scope.settingsUser.location.id === $scope.data.parentLocations[p].id) {
							locationIsParent = true;
							$scope.settingsUser.parentLocation = $scope.data.parentLocations[p];
							break;
						}
					}

					// If not, look through their children...
					if (!locationIsParent) {
						for (var _p = 0; _p < $scope.data.parentLocations.length; _p++) {
							for (var c = 0; c < $scope.data.parentLocations[_p].locations.length; c++) {
								if (!!$scope.settingsUser.location && $scope.settingsUser.location.id === $scope.data.parentLocations[_p].locations[c].id) {
									locationIsChild = true;
									$scope.settingsUser.parentLocation = $scope.data.parentLocations[_p];
									$scope.settingsUser.childLocation = $scope.data.parentLocations[_p].locations[c];
									break;
								}
							}
						}
					}
				});
			}
		}

		$scope.timeZones = [];
		$scope.time_zones = function(){
		  $http.get(DOMAIN + '/timezones/all').then(function(result) {
			  $scope.timeZones = result.data
		  });
		}  
		$scope.time_zones();
		
		new ContentLoader({
			site_id: $scope.site.id,
			category: 'registration'
		}).then(function(contents) {
			$scope.smsAgreement = Content.getByKey(contents, 'sms_agreement', true);
			var mobilePasswordMsg = Content.getByKey(contents, 'mobile_password_message', true);
            $scope.settings.mobilePasswordMsg = mobilePasswordMsg.content_html || '';


			var addressLabel = Content.getByKey(contents, 'address_label', true);
			$scope.data.addressLabel = !!addressLabel.title_html ? addressLabel.title_html.replace('</p>','*</p>') : $scope.data.addressLabel;
			$scope.data.addressContent = !!addressLabel.content_html ? addressLabel.content_html : $scope.data.addressContent;
		});

		new ContentLoader({
			promotion_id: $scope.site.id,
			category: 'mobile_password_instructions'
		  }).then(function(contents) {
			$scope.mobilePasswordInstruction = contents[0];
		});

		$scope.phone_invalid = false;
		$scope.setPhone = function(){
			$scope.phone_invalid = false
		}

		$scope.unsubFromAllChangeHandler = function() {
			if ($scope.settingsUser.subscription.email_unsubscribe_all) {
				$scope.settingsUser.subscription.email_friend_requests = false;
				$scope.settingsUser.subscription.email_wall_posts = false;
				$scope.settingsUser.subscription.email_team = false;
				//$scope.settingsUser.subscription.email_badges = false;
				$scope.settingsUser.subscription.email_challenges = false;
				$scope.settingsUser.subscription.email_site = false;
				$scope.settingsUser.subscription.email_daily = 0;
			}
		};

		$scope.subChangeHandler = function() {
			if ($scope.settingsUser.subscription.email_friend_requests ||
				$scope.settingsUser.subscription.email_wall_posts ||
				$scope.settingsUser.subscription.email_team ||
				//$scope.settingsUser.subscription.email_badges ||
				$scope.settingsUser.subscription.email_challenges ||
				$scope.settingsUser.subscription.email_site ||
				$scope.settingsUser.subscription.email_daily != 0)
				$scope.settingsUser.subscription.email_unsubscribe_all = false;
		};
		$scope.locationChanged = function(location) {
			if (location === 'parent') {
				$scope.settingsUser.childLocation = null;
			}
		};

		$scope.recalculateLocation = function() {
			$scope.settingsUserLocation = null;
			$scope.settingsUser.location = null;
		};

		$scope.displayChildLocations = function() {
			return $scope.settingsUser.parentLocation ? $scope.settingsUser.parentLocation.locations.length > 0 : false;
		};

		$scope.changePassword = function(toggle) {
			$scope.data.changing_password = toggle;
			if (!$scope.data.changing_password) {
				$scope.settingsUser.placeholderPassword = null;
				$scope.settingsUser.placeholderRetypePassword = null;
			}
		};

		function isFormValid() {
			return $scope.errors.length === 0 && !$scope.emailAlreadyTaken;
		}


		$scope.checkUniqueEmail = function() {

			// Don't need to validate if they entered their existing email address.
			if ($scope.settingsUser.placeholderEmail === $scope.user.email) {
				if (userValidators.emailTimeout) {
					clearTimeout(userValidators.emailTimeout);
					delete userValidators.emailTimeout;
				}

				ErrorService.clearErrors();
				$scope.emailAlreadyTaken = false;
			} else {
				if (userValidators.emailTimeout) {
					clearTimeout(userValidators.emailTimeout);
					delete userValidators.emailTimeout;
				}

				userValidators.emailTimeout = setTimeout(function() {
					User.validate($scope.site.id, {
						field: 'email',
						value: $scope.settingsUser.placeholderEmail
					}).then(function() {
						$scope.emailAlreadyTaken = false;
					}, function() {
						$scope.emailAlreadyTaken = true;
					}).finally(function() {});
				}, 1000);
			}
		};

		$scope.comparePasswords = function(input) {
			$scope.password_invalid = $scope.settingsUser.placeholderPassword !== input;
			$scope.safeApply();
		};

		$scope.navigateAnyway = function() {
			$scope.stateChangeInfo.prevent = false;
			$scope.stateChangeInfo.userAllow = true;
			$state.transitionTo($scope.stateChangeInfo.toState, $scope.stateChangeInfo.toParams);
		};

		$scope.stayOnPage = function() {
			$scope.stateChangeInfo.prevent = false;
		};

		$scope.cancelPhotoCrop = function() {
			$scope.settingsUser.profile.image = $scope.user.profile.image;
		};

		$scope.saveUserImage = function(cropped_url) {
			$scope.saved = false;
			$scope.savingUser = true;

			var photoUser = angular.copy($scope.user);
			photoUser.profile.image = cropped_url;
			photoUser.save(function(user) {
				if ($scope.settingsForm) {
					$scope.settingsForm.$setPristine();
				}
				CurrentUser.get(true).then(function() {
					$scope.savingUser = false;
					$scope.saved = true;
					$scope.settingsUser.profile.image = user.profile.image;

					$timeout(function() {
						$scope.saved = false;
					}, 3000);
				});
			});
		};

		$scope.updateUserInfo = function() {
			ErrorService.clearErrors();

			$scope.saved = false;
			$scope.savingUser = true;
			$scope.errors = [];

			// Name.
			if (!$scope.settingsUser.profile.first_name) {
				$scope.errors.push('First name required.');
			} else {
				$scope.user.profile.first_name = $scope.settingsUser.profile.first_name;
			}

			if (!$scope.settingsUser.profile.last_name) {
				$scope.errors.push('Last name required.');
			} else {
				$scope.user.profile.last_name = $scope.settingsUser.profile.last_name;
			}

			// Email
			if (!$scope.settingsUser.placeholderEmail) {
				$scope.errors.push('Email required.')
			} else {
				$scope.user.email = $scope.settingsUser.placeholderEmail;
			}

			if ($scope.emailAlreadyTaken) {
				$scope.errors.push('Email has already been taken.');
			}

			if ($scope.password_invalid_format) {
				$scope.errors.push($scope.site.password_help_message);
			}

			// Password.
			if ($scope.settingsUser.placeholderPassword || $scope.settingsUser.placeholderRetypePassword) {
				if ($scope.settingsUser.placeholderPassword && !$scope.settingsUser.placeholderRetypePassword) {
					$scope.errors.push('Passwords must match.');
				}
				else if ($scope.settingsUser.placeholderPassword) {
					if ($scope.settingsUser.placeholderPassword === $scope.settingsUser.placeholderRetypePassword) {
						$scope.user.password = $scope.settingsUser.placeholderPassword;
					} else {
						$scope.errors.push('Passwords must match.');
					}
				} else {
					$scope.errors.push('Password required.');
				}
			}

			if ($scope.site.flags.allow_set_location) {
				if ($scope.settingsUser.childLocation) {
					$scope.user.location_id = $scope.settingsUser.childLocation.id;
				} else {
					$scope.user.location_id = $scope.settingsUser.parentLocation.id;
				}
			}


                        if ($scope.site.flags.is_address_displayed && $scope.settingsUser.profile) {
                                if ($scope.settingsUser.profile.line1 !== undefined) {
                                        $scope.user.profile.line1 = $scope.settingsUser.profile.line1;
                                }
                                if ($scope.settingsUser.profile.line2 !== undefined) {
                                        $scope.user.profile.line2 = $scope.settingsUser.profile.line2;
                                }
                                if ($scope.settingsUser.profile.city !== undefined) {
                                        $scope.user.profile.city = $scope.settingsUser.profile.city;
                                }
                                if ($scope.settingsUser.profile.state_province !== undefined) {
                                        $scope.user.profile.state_province = $scope.settingsUser.profile.state_province;
                                }
                                if ($scope.settingsUser.profile.postal_code !== undefined) {
                                        $scope.user.profile.postal_code = $scope.settingsUser.profile.postal_code;
                                }
                        }
			
			// sms
			if($scope.site.flags.is_sms_enabled){
				$scope.user.allows_sms = $scope.settingsUser.allows_sms
				if($scope.user.allows_sms){
					// if true update 
					if($scope.settingsUser.profile.phone != undefined){
						$scope.user.profile.phone = $scope.settingsUser.profile.phone
						$scope.user.profile.time_zone = $scope.settingsUser.profile.time_zone
						$scope.phone_invalid = false
					}else{
						$scope.phone_invalid = true
						$scope.errors.push('Invalid phone number');
					}
				}else{
					// if not then reset
					$scope.user.profile.phone = ""
					$scope.user.profile.time_zone = $scope.site.time_zone
				}
				
			}



			// $scope.user.flags.show_banners = !!$scope.settingsUser.flags.show_banners; // coerce to true or false value api cant handle 1 and 0s
			$scope.user.subscription = $scope.settingsUser.subscription;
			$scope.user.profile_prompts = $scope.settingsUser.profile_prompts

			if (isFormValid()) {
				$scope.user.save(function(user) {
					// settingsForm does not exist on email preferences page
					if ($scope.settingsForm) {
						$scope.settingsForm.$setPristine();
					}
					CurrentUser.get(true).then(function() {
						$scope.savingUser = false;
						$scope.saved = true;
						$scope.data.changing_password = false;
						$scope.settingsUser.placeholderPassword = '';
						$scope.settingsUser.placeholderRetypePassword = '';

						$timeout(function() {
							$scope.saved = false;
						}, 3000);
					});
				}, function() {
					// TODO: Handle this somehow?
				});
			} else {
				ErrorService.showErrors({
					status: 422,
					data: {
						errors: $scope.errors
					}
				});

				$timeout(function() {
					$scope.savingUser = false;
				}, 2000);
			}
		};

		// Get site and user first.
		$q.all([
			CurrentSite.get(),
			CurrentUser.get()
		]).then(function(data) {
			$scope.settingsUser = angular.copy(data[1]);
			$scope.settingsUser.placeholderEmail = $scope.settingsUser.email;
			initLocations();
		}, function() {
			// TODO: Handle this somehow?
		});

		// Unsaved Check
		var deregister_state_watcher = $scope.$on('$stateChangeStart', function(event, toState, toParams) {
			if ($scope.isFormDirty()) {
				event.preventDefault();

				DialogService.openConfirmationDialog("", "You haven't saved.", 'Stay', "Leave","tiny", true).then(function() {
					deregister_state_watcher();
					$timeout(function() {
						$state.go(toState.name, toParams);
					});
				}, _.noop);
			}
		});


		$scope.isFormDirty = function() {
			return $scope.settingsForm && $scope.settingsForm.$dirty;
		};

		$scope.resetPage = function() {
			ErrorService.clearErrors();
			$q.all([
				CurrentSite.get(),
				CurrentUser.get()
			]).then(function(data) {
				$scope.settingsUser = angular.copy(data[1]);
				$scope.settingsUser.placeholderEmail = $scope.settingsUser.email;
				initLocations();
			}, function() {
				// TODO: Handle this somehow?
			});
			$scope.settingsForm.$setPristine();
			$scope.changePassword(false);
			resetErrors();
		};

		function resetErrors() {
		$scope.password_invalid_format = false;
		// $scope.password_must_match = false;
		}

		// Watchers.
		$scope.$watch('settingsUser.placeholderPassword', function(password) {
			if (password) {
				if ($scope.retype_password_timeout) {
					clearTimeout($scope.retype_password_timeout);
				}

				$scope.retype_password_timeout = setTimeout(function() {
					if (!!password && !new RegExp($scope.site.password_regular_expression_string).test(password)) {
						 // if password set and it has incorrect format
						$scope.password_invalid_format = true;
					} else {
						 // if password set and format is correct
						$scope.password_invalid_format = false;
						if ($scope.settingsUser.placeholderRetypePassword) {
							$scope.comparePasswords($scope.settingsUser.placeholderRetypePassword);
						} else {
							clearTimeout($scope.retype_password_timeout);
						}
					}
					$scope.$safeApply();
				}, 1000);
			}
		});

		Banner.current().then(function(banners){
			$scope.has_banners = banners.length > 0;
		});


		$scope.$watch('settingsUser.placeholderRetypePassword', function(password) {
			if ($scope.settingsUser.placeholderRetypePassword) {
				if ($scope.new_user_password_timeout) {
					clearTimeout($scope.new_user_password_timeout);
				}

				$scope.new_user_password_timeout = setTimeout(function() {
					$scope.comparePasswords($scope.settingsUser.placeholderRetypePassword, 'password');
				}, 1000);
			} else {
				clearTimeout($scope.new_user_password_timeout);
			}
		});

		if (!!$stateParams.loc_msg) {
			ngDialog.closeAll();
			new ContentLoader({
				site_id: $scope.site.id,
				category: 'settings'
			}).then(function(homeContents) {
				$scope.information = {
					title: 'Location Required',
					message:  'Oops, we need a location. You will not be able to use the site until you select a valid location. Thanks!'
				};
				ngDialog.openConfirm({
					template: '/scripts/dialogs/informationOneButton.html',
					scope: $scope
				});
			});
		}

		$scope.$on("$destroy", function() {
			if (typeof deregister_state_watcher == 'function') {
				deregister_state_watcher();
			}
			$scope.entry_form
		});

	}
]);
'use strict';

angular.module('goApp')

.config(['$stateProvider',
	function($stateProvider) {
		$stateProvider

			.state('go.u.settings.main', {
				url: '/settings/personal',
				title: 'Settings',
				controller: 'SettingsCtrl',
				abstract: false,
				templateProvider: ['hesTemplateService',
					function(hesTemplateService) {
						return hesTemplateService.getTemplate('/scripts/settings/settings.html');
					}
				]
			})
			.state('go.u.settings.email', {
				url: '/settings/email',
				title: 'Settings',
				controller: 'SettingsCtrl',
				abstract: false,
				templateProvider: ['hesTemplateService',
					function(hesTemplateService) {
						return hesTemplateService.getTemplate('/scripts/settings/settings-email.html');
					}
				]
			})
			.state('go.u.settings.tracking', {
				url: '/settings/tracking',
				title: 'Settings',
				controller: 'ChooseHowToLogController as ChooseLogCtrl',
				abstract: false,
				templateProvider: ['hesTemplateService',
					function(hesTemplateService) {
						return hesTemplateService.getTemplate('/scripts/settings/settings-tracking.html');
					}
				]
			})
	}
]);

'use strict';

angular.module('goApp')
  .controller('EmailResourceCtrl',
    function($scope, $http, DOMAIN, $timeout, $mdToast, EmailResource) {

      $scope.isSending = false;
      $scope.emails = '';
      $scope.properEmails = true;

      function checkEmails(emails) {
        if (emails) {
          $scope.properEmails = true;
          $scope.emailForm.emails.$error.properEmails = false;
          for (var i = 0; i < emails.length; i++) {
            if (!(emails[i].contains('@'))) {
              $scope.properEmails = false;
              $scope.emailForm.emails.$error.properEmails = true;
            }
          }
        }
      }

      $scope.setEmails = function() {
        if ($scope.emails.length > 0) {
          var emails = $scope.emails.split(/(,|;) ?/);
          emails = _.filter(emails, function(email) {
            return email.length > 1
          });
        }

        checkEmails(emails);
        $scope.emailForm.emails.$error.emails = emails !== false ? false : true;
        return emails ? emails : false;
      };

      function showSuccess() {
        var simpleToast = $mdToast.simple('Sent Successfully');
        simpleToast.parent($('#' + $scope.ngDialogId + ' .ngdialog-content')[0]);
        $mdToast.show(simpleToast);
      };

      $scope.emailResource = function() {
        $scope.isSending = true;
        $scope.emailForm.emails.$error.emails = false;
        $scope.emailForm.emails.$error.properEmails = false;
        var sendToEmails = $scope.setEmails();
        if (!($scope.emailForm.emails.$error.emails || $scope.emailForm.emails.$error.properEmails)) {
          $scope.emailForm.emails.$error.fail = false;
          EmailResource.sendEmail($scope.message, sendToEmails, $scope.ngDialogData.type, $scope.ngDialogData.resource)
            .then(function() {
              $scope.isSending = false;
              showSuccess();
              $timeout(function() {
                $scope.closeThisDialog();
              }, 3000);
            }, function(error) {
              $scope.isSending = false;
              if (error.data.errors[0] === "Must include at least 1 email address.") {
                $scope.emailForm.emails.$error.properEmails = true;
              } else {
                $scope.emailForm.emails.$error.fail = true;
              }
            });
        } else {
          $scope.isSending = false;
        }
      };
    });
'use strict';
angular.module('goApp')
  .factory('EmailResource', function($http, DOMAIN) {
    var url = DOMAIN + '/emails/content';
    return {
      sendEmail: function(message, emails, resourceType, resource) {
        var options = {
          message: message,
          emails: emails,
          model: resourceType,
          id: resource.id
        };
        return $http.post(url, options);
      }
    };
  });
angular.module('goApp')
  .component('hesShareDial', {
    // templateUrl: hesTemplateService.getTemplateUrl('/scripts/shareResource/shareDial.html'),
    templateUrl: '/scripts/shareResource/shareDial.html',
    bindings: {
      type: '@',
      resource: '<'
    },
    controller: function(ngDialog) {
      var ctrl = this;

      ctrl.settings = {
        shareOpen: false,
        emailOpen: false,
        wallOpen: false
      };

      ctrl.print = function() {
        window.print();
      };

      ctrl.openEmailDialog = function() {
        if (!ctrl.settings.emailOpen) {
          ctrl.settings.emailOpen = true;
          ngDialog.open({
              template: '/scripts/shareResource/email/emailResource.html',
              data: {
                resource: ctrl.resource,
                type: ctrl.type
              }
            }).closePromise
            .finally(function() {
              ctrl.settings.emailOpen = false;
            });
        }
      };

      ctrl.shareToWall = function() {
        if (!ctrl.settings.wallOpen) {
          ctrl.settings.wallOpen = true;
          ngDialog.open({
              template: '/scripts/shareResource/shareToWall/shareToWall.html',
              controller: 'ShareToWallController',
              className: 'ngdialog-theme-default share-to-wall',
              data: {
                resource: ctrl.resource,
                type: ctrl.type
              }
            }).closePromise
            .finally(function() {
              ctrl.settings.wallOpen = false;
            });
        }
      };
    }
  });
'use strict';
angular.module('goApp')
  .controller('ShareToWallController',
    function($scope) {
      $scope.view = {
        resource: $scope.ngDialogData.resource,
        type: $scope.ngDialogData.type,
        hasSent: false
      }

      $scope.postCreated = function(){
        $scope.view.hasSent = true;
      }
    });
'use strict';

angular.module('goApp').controller('SiteMapController', function($scope, MainNavigation){
  $scope.navigation = new Object();
  
  function setCurrentMenu() {
    MainNavigation.get().then(function(navigation){
      $scope.navigation.current_menu = navigation;
      $scope.navigation.active_menus = _.filter(navigation.childMenus,{active:true});
    });
  }
  
  setCurrentMenu();

});

'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.map', {
  		abstract: true,
  		controller: "TabsController",
  		templateProvider: ['hesTemplateService',
  			function(hesTemplateService) {
  				return hesTemplateService.getTemplate('/scripts/tabs/secondary-tabs-only-layout.html');
  			}
  		]
  	})


  $stateProvider.state('go.map.site_map', {
    title: 'Site Map',
    url: '/site_map',
    abstract: false,
    controller: 'SiteMapController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/site_map/site_map.html');
      }
    ]
  });
  
});




'use strict';

angular.module('goApp').service("ActivityService", function(Activity, $q, DialogService, ErrorService) {
  var ActivityService = {
    _activities: [],
    data: {
      _editActivity: null
    },
    _activity: new Activity(),
    _siteId: null,
    get: function(refresh, siteId) {
      var defer = $q.defer();
      ActivityService._siteId = siteId;
      if (ActivityService._activities.length === 0 || refresh) {
        Activity.index({
            site_id: siteId,
            page_size: 0
          }, function(activities) {
            ActivityService._activities = activities;
            defer.resolve(ActivityService._activities);
          },
          function(rejection) {
            defer.reject(rejection);
          });
      } else {
        defer.resolve(ActivityService._activities);
      }

      return defer.promise;
    },
    getEditDataActivity: function(){
      return ActivityService.data;
    },
    getActivityById: function(id) {
      ActivityService.data._editActivity = null;
      if (id === 'new') {
        ActivityService.data._editActivity = Activity.build({
          site_id: ActivityService._siteId
        });
      } else {
        ActivityService.data._editActivity = _.find(ActivityService._activities, {
          id: parseInt(id)
        });
      }

      return ActivityService.data._editActivity;
    },
    getActivities: function() {
      return ActivityService._activities;
    },
    saveActivity: function(activity) {
      var defer = $q.defer();
      activity.save(function(response) {
        ActivityService.get(true, activity.site_id).then(function() {
          defer.resolve(response);
        });
      }, function(rejection) {
        ErrorService.showPriorityErrors(rejection, 'Could not save activity', 1);
        defer.reject(rejection);
      });
      return defer.promise;
    },
    showRemoveActivityDialog: function(activity) {
      DialogService.openConfirmationDialog('Remove Activity', 'Remove <em>' + activity.name + '</em> from the activities list?', 'Cancel', 'Remove')
        .then(function() {
          activity.$destroy(function(response) {
            ActivityService.removeActivityFromList(activity);
          }, function(rejection) {
            ErrorService.showPriorityErrors(rejection, 'Could not remove activity!', 1);
          });
        });
    },
    removeActivityFromList: function(activity) {
      var index = ActivityService._activities.map(function(b) {
        return b.id;
      }).indexOf(activity.id);
      if (typeof index == 'number' && index > -1) {
        ActivityService._activities.splice(index, 1);
        return index;
      }
    }
  };

  return ActivityService;
});
'use strict';

angular.module('goApp')
  .controller('ActivitiesListController', ['$rootScope', '$scope', 'ActivityService',
    function($rootScope, $scope, ActivityService) {
      $scope.settings = {
        loading: true
      };

      $scope.data = {
        activities: []
      };


      ActivityService.get(false, $scope.dbSite.id)
        .then(function(activities) {
          $scope.data.activities = activities;
        })
        .finally(function() {
          $scope.settings.loading = false;
        });


      $scope.confirmRemoveActivity = function(activity) {
        ActivityService.showRemoveActivityDialog(activity);
      };

      $scope.$watch(function() {
        return ActivityService._activities;
      }, function() {
        $scope.data.activities = ActivityService._activities;
      });

      $scope.$on('$destroy', function() {
        $rootScope.$broadcast('reloadActivities');
      });
    }
  ]);
'use strict';

angular.module('goApp')
  .factory('Activity', ['$http', 'ActiveResource', 'DOMAIN',
    function($http, ActiveResource, DOMAIN) {

      var Activity = ActiveResource('/exercise_activities/:id', {
        nestedRoutes: ['index', 'create', 'update', 'destroy', 'show'],
        parentResource: 'Site',
        domain: DOMAIN
      });

      return Activity;
    }
  ]);
'use strict';

angular.module('goApp')
  .controller('ActivityEditorController', ['$scope', 'ActivityService',
    function($scope, ActivityService) {
      $scope.settings = {
        loading: true
      };

      $scope.data = ActivityService.getEditDataActivity();

      $scope.backToList = function() {
        $scope.$state.transitionTo('go.u.site.activities', {
          siteId: $scope.$state.params.siteId
        });
      };

      $scope.cancelEdit = function() {
        $scope.data._editActivity.$show(function() {
          $scope.backToList();
        });
      };

      $scope.saveActivity = function() {
        $scope.settings.saving = true;
        ActivityService.saveActivity($scope.data._editActivity)
          .then(function() {
            $scope.forms.activityEdit.$setPristine();
            $scope.backToList();
          }).finally(function() {
            $scope.settings.saving = false;
          });
      };
    }
  ]);
'use strict';

angular
  .module('goApp')
  .controller(
    'BannersController',
    function (
      $scope,
      $rootScope,
      $state,
      Banner,
      DialogService,
      $timeout,
      LocationService,
      BillboardService
    ) {
      $scope.data = new Object();
      $scope.data.banners = [];

      LocationService.get(true, $scope.dbSite.id).then(function (locations) {
        var locs = [];
        _.each(locations, function (l) {
          locs.push({
            id: l.id,
            label: l.name,
            level: 1,
            group: $scope.dbSite.location_labels[0],
          });
          _.each(l.locations, function (lo) {
            locs.push({
              id: lo.id,
              label: lo.name,
              level: 2,
              group: $scope.dbSite.location_labels[1],
            });
          });
        });
        $scope.data.locations = _.groupBy(locs, 'group');
      });

      BillboardService.index({ site_id: $scope.dbSite.id }).then(function (
        billboards
      ) {
        $scope.data.billboards = billboards;
      });

      $scope.editBillboard = function (billboard_id, type, name) {
        $state.transitionTo('go.u.billboardEdit', {
          id: billboard_id,
          site_id: $scope.dbSite.id,
          site_name: $scope.dbSite.name,
          billboard_type: type,
          group: 'banner'
        });
      };

      $scope.delete = function (banner) {
        DialogService.openConfirmationDialog(
          'Confirm delete',
          'Are you sure you want to delete the following banner? <br/><br/>' +
            banner.name,
          'Cancel',
          'Yes'
        ).then(function (data) {
          new Banner({ id: banner.id }).destroy().then(init);
        });
      };

      $scope.new = function () {
        $scope.data.banners.unshift(new Banner());
      };

      $scope.save = function (banner) {
        banner.status = 'Saving';
        banner.site_id = $scope.dbSite.id;
        new Banner(banner).save().then(
          function (data) {
            _.merge(banner, data);
            banner.status = 'Saved!';
            $timeout(function () {
              banner.status = null;
            }, 2000);
          },
          function (response) {
            DialogService.openInformationDialog(
              'Error',
              response.data.errors[0].base.join('<br/>'),
              'OK'
            );
          }
        );
      };

      $scope.refresh = init;

      function init() {
        Banner.index(
          { page_size: 0, site_id: $scope.dbSite.id },
          function (banners) {
            $scope.data.banners = banners;
          }
        );
      }

      init();
    }
  );

'use strict';

angular.module('goApp')
	.controller('ComingSoonController', ['$scope', 'CurrentSite', 'Program',
		function($scope, CurrentSite, Program) {

			$scope.comingSoon = {};

			CurrentSite.get().then(function() {
				$scope.comingSoon.programs = $scope.site.upcomingPrograms();

				// for(var _i = 0; _i < $scope.comingSoon.programs.length; _i++) {
				// 	$scope.comingSoon.programs[_i] = new Program($scope.comingSoon.programs[_i]);
				// }
			}, function() {
					// Error getting current site.
			});
    }
  ]);
'use strict';

angular.module('goApp')
  .controller('CoordinatorsBoxController', ['$scope', 'Site', 'ErrorService', 'Utils', '$timeout',
    function($scope, Site, ErrorService, Utils, $timeout) {

      $scope.coordinatorsBox = {
        coordinators: $scope.dbSite.coordinators ? $scope.dbSite.coordinators.split(',') : [],
        coordinatorEmail: null
      };

      $scope.settings = {
        isSaving: false, 
        saved: false
      };

      $scope.addCoordinator = function(email) {
        if (!Utils.isUndefinedOrNull(email) && email !== '') {
          $scope.coordinatorsBox.coordinators.push(email);
          $scope.coordinatorsBox.coordinatorEmail = null;
        }
      };

      $scope.removeCoordinator = function(email) {
        var idx = $scope.coordinatorsBox.coordinators.indexOf(email);
        if (idx >= 0) {
          $scope.coordinatorsBox.coordinators.splice(idx, 1);
        }
      };

      $scope.save = function() {
        $scope.settings.isSaving = true;
        Site.build({
          id: $scope.dbSite.id,
          coordinators: $scope.coordinatorsBox.coordinators.join(",")
        }).save(function(promotion) {
          $scope.dbSite.coordinators = promotion.coordinators;
          $scope.coordinatorsBox.coordinators = $scope.dbSite.coordinators ? $scope.dbSite.coordinators.split(",") : [];
          $scope.settings.isSaving = false;
          $scope.settings.saved = true;
          $timeout(function(){
            $scope.settings.saved = false;
          }, 3000);
        }, function(response) {
          ErrorService.showErrors(response);
          $scope.settings.isSaving = false;
        });
      };

    }
  ]);
'use strict';

angular.module('goApp')
  .service('CurrentSite', ['$rootScope', 'Site', '$q', 'HesDate', '$state', 'Utils', '$window', 'SSOService', '$http', 'ipCookie', 'THEMES', 'SITE',
    function( $rootScope, Site, $q, HesDate, $state, Utils, $window, SSOService, $http, ipCookie, THEMES, SITE ) {
    var CurrentSite = {
      queued: false, queuedPromise: null,

      get: function( forceRefresh ) {
        var defer = $q.defer();
        var promise = defer.promise;
        var siteExists = !Utils.isUndefinedOrNull($rootScope.site);
        var identifier = siteExists ? $rootScope.site.id : SITE;

        if (siteExists && !forceRefresh) {
          CurrentSite.queued = false;
          defer.resolve($rootScope.site);
        } else {
          if (!CurrentSite.queued) {
            CurrentSite.queued = true;
            CurrentSite.queuedPromise = defer.promise;
            Site.show({
              id: identifier
            }, function( site ) {
              CurrentSite.queued = false;
              site.init();
              $rootScope.site = site;
              SSOService.setDetail(site.sso_detail);
              defer.resolve(CurrentSite.set(site));
              if (SSOService.isEnabled() && !SSOService.getToken() && $state.current.name != "go.privacy_terms.privacy") {
                SSOService.goToLogin();
                defer.resolve(CurrentSite.set(site));
              } else {
                if (site.disable_after === null || HesDate.compare(site.current_date, site.disable_after) <= 0) {
                  defer.resolve(CurrentSite.set(site));
                  if (SSOService.isEnabled() && SSOService.getToken() && ipCookie('basic')) {
                    var programId = sessionStorage.getItem('sso_programId');
                    if (programId) {
                      sessionStorage.removeItem('sso_programId');
                      if ($rootScope.user) {
                        $rootScope.streamlineRedirect(programId);
                      } else {
                        var unbind = $rootScope.$on('didSetUser', function() {
                          unbind();
                          $rootScope.streamlineRedirect(programId);
                        });
                      }
                    }
                  }
                } else {
                  $window.location.href = 'https://www.hesonline.com/products/elevate/';
                }
              }
            }, function( response ) {
              CurrentSite.queued = false;
              defer.reject('Error getting site');
              if (response.status === 404) {
                CurrentSite.removeUser();
                $rootScope.site = {};
                $window.location.href = 'https://www.hesonline.com/products/elevate/';
              } else {
                if (Utils.isUndefinedOrNull($rootScope.site)) {
                  $state.go(response.status === 404 ? '404' : '500', {
                    errors: response
                  });
                }
              }
            });
          } else {
            promise = CurrentSite.queuedPromise;
          }
        }

        return promise;
      },

      removeUser: function() {
        ipCookie.remove('basic',{ path: '/' });
        delete $http.defaults.headers.common['Authorization'];
        $rootScope.user = null;
      },

      set: function( site ) {
        $rootScope.site = new Site(site);
        return $rootScope.site;
      }
    };

    return CurrentSite;
  }]);

'use strict';

angular.module('goApp')
  .controller('EopReportingController', ['$scope', 'EopReportingResource', 'ErrorService',
    function($scope, EopReportingResource, ErrorService) {
      $scope.data = {
        html: ''
      };

      $scope.view = {
        loading: true,
        errorLoading: false,
        parentLocation: null,
        childLocation: null
      };

      $scope.reset = function() {
        $scope.view.parentLocation = null;
        $scope.view.childLocation = null;
        $scope.getEopHTML();
      };

      $scope.getEopHTML = function() {
        $scope.view.loading = true;
        ErrorService.clearErrors();
        var options = {
          site_id: $scope.dbSite.id
        };
        if (!!$scope.view.parentLocation) {
          if (!!$scope.view.childLocation) {
            options.location_id = $scope.view.childLocation.id;
          } else {
            options.location_id = $scope.view.parentLocation.id;
          }
        }
        EopReportingResource.build().$show(options,
          function(eop) {
            $scope.data.html = eop.content;
            $scope.view.loading = false;
          },
          function(response) {
            $scope.view.errorLoading = true;
            $scope.view.loading = false;
            ErrorService.showPriorityErrors(response, 'Could not get EOP data.', 1);
          });
      };

      $scope.getEopHTML();
    }
  ]);
'use strict';

angular.module('goApp')
  .factory('EopReportingResource', ['$http', 'ActiveResource', 'DOMAIN',
    function($http, ActiveResource, DOMAIN) {

      var EopReportingResource = ActiveResource('/eop', {
        nestedRoutes: ['show','index'],
        parentResource: 'Site',
        domain: DOMAIN
      });

      return EopReportingResource;
    }
  ]);
'use strict';

angular.module('goApp')
	.controller('HistoryController', ['$scope', 'CurrentSite', 'Site', 'Program', '$location', '$window', 'ErrorService', 'LocationService',
		function($scope, CurrentSite, Site, Program, $location, $window, ErrorService, LocationService) {

			$scope.past = {};
			$scope.past.sortedLocationPrograms = [];
			$scope.view.sortFinished = false;

			CurrentSite.get().then(function() {
				$scope.past.overallPrograms = $scope.site.pastOverallPrograms($scope.user);
				$scope.past.locationPrograms = $scope.site.pastLocationPrograms($scope.user);
				sortHistoryProgramsByLocation();
			}, function() {
				// Error getting current site.
			});

			function sortHistoryProgramsByLocation() {
				$scope.sortedReportingPrograms = [{
					location_id: null,
					name: $scope.site.global_program_group,
					programs: []
				}];

				LocationService.get()
					.then(sortPrograms)
					.finally(function() {
						$scope.view.sortFinished = true;
					});

				function sortPrograms(locations) {
					angular.forEach($scope.past.locationPrograms, function(program) {
						var programGroup = _.filter($scope.past.sortedLocationPrograms, {location_id: program.location_id});
						if (programGroup.length) {
							programGroup[0].programs.push(program);
						} else {
							var location = LocationService.getLocationById(program.location_id);
							$scope.past.sortedLocationPrograms.push({
								location_id: program.location_id,
								name: (location && location.name),
								programs: [program]
							});
						}
					});
				}
			}

			$scope.displayLocationPrograms = function() {
				return !_.isEmpty($scope.past.locationPrograms);
			};

			$scope.displayOverallPrograms = function() {
				return !_.isEmpty($scope.past.overallPrograms);
			};

			$scope.downloadHistory = function(program) {
				Program.ActivitySummaryUrl.show({
					id: program.id
				}, function(response) {
					window.location = response.redirect_url;
				}, function(errors) {
					ErrorService.showErrors(errors, 'Could not access site');
				});
			};

			$scope.setToActive = function(program) {
				program.active = true;
			};

			$scope.setToInactive = function(program) {
				program.active = false;
			};
		}
	]);
'use strict';

angular.module('goApp')
	.controller('OngoingController', ['$scope', 'CurrentSite', 'Site', 'Program', '$window',
		function($scope, CurrentSite, Site, Program, $window) {

			$scope.ongoing = {
				programs: []
			};

			CurrentSite.get().then(function() {
				$scope.ongoing.programs = $scope.site.ongoingPrograms();

				for (var _i = 0; _i < $scope.ongoing.programs.length; _i++) {
					//I really hate that I have to do this... it should be put on the API
					var program = $scope.ongoing.programs[_i];
					Program.RegistrationClosed.show({
						site_id: $scope.site.id,
						program_id: program.id
					}, function(response) {
						program.registration_closed = response.registration_closed;
					}, function(response) {});
				}
			}, function() {
				// Error getting current site.
			});
		}
	]);
'use strict';

angular.module('goApp')
.controller('SiteController', function($scope, $state, $filter, dbSite, Content, ContentLoader, ngDialog, $rootScope, LocationService, ErrorService, BadgeService, Challenge, Goal, SiteEvaluation, Site) {
  $rootScope.dbSite = dbSite;

  var oldLogo = angular.copy($scope.site.logo);
  $scope.site.logo = $scope.dbSite.logo;

  $scope.contents = {
    eligibility: []
  };

  $scope.data = {
    numbers: 0,
    locations: [],
    month_integers: [],
    tblPrograms: {
      fields: [
        ["Name", "string"],
        ["App Name", "string"],
        ["App Url", "html"],
        ["Effect. Start", "string", {
          width: 90,
          cellFilter: 'date'
        }],
        ["Effect. Ends", "string", {
          width: 90,
          cellFilter: 'date'
        }],
        ["Enabled?", "string"],
        ["Actions", "actions", {
          width: 150
        }]
      ]
    }
  };

  $scope.confirmDeleteProgram = function(program) {
    $scope.confirmation = {
      message: 'Do you want to remove this program (' + program.name + ')?',
      confirmText: 'Delete',
      cancelText: 'Cancel'
    };
    ngDialog.openConfirm({
      template: '/scripts/dialogs/confirmationDialog.html',
      scope: $scope
    }).then(function() {
      program.$destroy(function() {
        $scope.dbSite.$show(function() {
          $scope.$broadcast('programsUpdated');
        });
      }, function(response) {
        ErrorService.showErrors(response, 'Could not delete program.');
      });
    });
  };

  function setTableData() {

    var rows = [],
      gridRows = [];

    if ($scope.dbSite.programs) {
      var programs = $scope.dbSite.programs.slice(0);
      for (var i = 0; i < programs.length; i++) {
        var program = programs[i];
        var programLink = $state.href('go.u.site.program', {
          siteId: $scope.dbSite.id,
          programId: program.id
        });

        var doDeleteProgram = function(args) {
          $scope.confirmDeleteProgram.apply(this, args);
        };

        program.row = [
          program.name,
          (program.promotion ? program.promotion.app_name : 'N/A'),
          (program.promotion ? '<a target="_blank" href="http://' + program.promotion.subdomain + '.' + program.promotion.domain_name + '">' + program.promotion.subdomain + '.' + program.promotion.domain_name + '</a>' : 'N/A'),
          program.effective_date_start,
          program.effective_date_end,
          program.enabled ? 'Yes' : 'No', [
            ['edit', programLink],
            ['delete', doDeleteProgram, [program]]
          ]
        ];

        gridRows.push(program);
      }
    }

    $scope.data.tblPrograms.rows = gridRows;
  }

  setTableData();

  LocationService.get(true, $scope.dbSite.id).then(function(locations) {
    $scope.data.locations = locations;
  });

  new ContentLoader({
    category: 'eligibility',
    site_id: $scope.dbSite.id
  }, true).then(function(contents) {
    $scope.contents.eligibility = contents;
  });


  $scope.getEligCustomContent = function(key) {
    return Content.getByKey($scope.contents.eligibility, key);
  };

  $scope.showContent = function(content) {
    $scope.content = content;
    ngDialog.open({
      template: '/scripts/content/contentPreview.html',
      scope: $scope
    });
  };

  BadgeService.get(true, $scope.dbSite.id).then(function(badges) {
    $scope.data.badges = _.groupBy(_.orderBy(badges,"sequence"),'category');
  });

  Challenge.index({site_id: $scope.dbSite.id}, function(challenges) {
    $scope.data.challenges = challenges;
  });

  Goal.index({site_id: $scope.dbSite.id, page_size: 0}, function(goals) {
    $scope.data.goals = goals;
    $scope.data.months = _.uniq(_.map(goals, 'month'));
  });

  $scope.goalsByMonth = function(month) {
    return $filter('filter')($scope.data.goals, {
      month: month
    }, true);
  };

  SiteEvaluation.index({site_id: $scope.dbSite.id}, function(siteEvals) {
    $scope.data.siteEvals = siteEvals;
  });

  $scope.humanize = BadgeService.humanize;

  $scope.formatNumberWithCommas = function(number){
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  $scope.$on('programsUpdated', function() {
    setTableData();
  });

  $scope.$on('$destroy', function() {
    $scope.site.logo = oldLogo;

  });

  $scope.clearCache = function() {
    new Site({id:$scope.dbSite.id, updated_at: new Date()}).save().then(function(){
      $state.go($state.current, {}, {reload: true});
    });
  }

});
'use strict';

angular.module('goApp').controller('SiteCreateEditController', function($scope, $state, $timeout, ErrorService, THEMES, BillboardService, DOMAIN, $http) {
  $scope.dateFormat = 'L';

  $scope.data = {
    // organizations: OrganizationService.getOrganizations(), 
    // organization_id: $scope.dbSite.organization_id > 0 ? $scope.dbSite.organization_id : undefined, 
    // lengths: [{id: 28, name: '4 Weeks'}, {id: 42, name: '6 weeks'}]
  };

  $scope.settings = {
    saving: false,
    errors: []
  };

  $scope.view = {
    isEdit: false
  };

  $scope.themes = THEMES;

  $scope.data.site_feature_flags = [
    'is_badges_enabled',
    'is_challenges_enabled',
    'is_email_preferences_enabled',
    'is_privacy_enabled',
    'is_faqs_enabled',
    'is_recipes_enabled',
    'is_goal_enabled',
    'is_resources_enabled',
    'is_logging_enabled',
    'is_stats_enabled',
    'is_messages_enabled',
    'is_tips_enabled',
    'is_notifications_enabled',
    'is_terms_enabled',
    'is_peers_enabled',
    'is_wall_enabled',
    'is_sms_enabled',
    'prompt_location_confirm_before_opt_in',
    'launch_with_features_on',
  ];

  $scope.data.pseudo_flags = [
    "is_email_to_non_campaign_participants_enabled"
  ];

  $scope.data.chunked_flags = _.chunk($scope.data.site_feature_flags.concat($scope.data.pseudo_flags), 2);
  
  
  $scope.stripIs = function(str) {
    return str.split("is_").slice(1,2).join("_");
  }

  $scope.updateFeatureFlags = function(site, opts) {

    $scope.data.site_feature_flags.forEach(function(flag) {
      site.flags[flag] = false;
    });
    site.flags.is_launchpad_plus = true
    if(opts.is_plus) {
      site.flags.is_aktivetrak = false;
      site.flags.is_launchpad = false;
      site.is_email_to_non_campaign_participants_enabled = true;
      $scope.data.site_feature_flags.forEach(function(flag) {
        if(flag != "prompt_location_confirm_before_opt_in" && flag != 'launch_with_features_on'){
          site.flags[flag] = true;
        }
      });
    } else if(opts.is_aktivetrak) {
      site.flags.is_launchpad_plus = false
      site.flags.is_launchpad = false
      site.is_email_to_non_campaign_participants_enabled = false;
      site.flags['is_logging_enabled'] = true;
      site.flags['is_terms_enabled'] = true;
      site.flags['is_privacy_enabled'] = true;
      site.flags['is_faqs_enabled'] = true;
    }else if(opts.is_launchpad){
      site.flags.is_aktivetrak = false;
      site.flags.is_launchpad_plus = false;
      site.is_email_to_non_campaign_participants_enabled = false;
    }
  }

  $scope.editSite = $scope.dbSite;

  // For google fit, is_validic_enabled is swizzled
  $scope.editSite.flags.is_validic_enabled = $scope.editSite.flags.is_validic_really_enabled;
  // This is deliberate, so when it's sent back to the API (#update/#create), it'll "reset" the flag
  delete $scope.editSite.flags.swizzled;
  delete $scope.editSite.flags.is_validic_really_enabled;

  if ($state.current.name === 'go.u.site.edit') {
    $scope.view.isEdit = true;
    $scope.editSite.location_labels = $scope.editSite.getEditLocationLabels();
  }

  $scope.handleErrors = function(response) {
    $scope.settings.saving = false;
    $scope.settings.showSaving = false;
    ErrorService.showErrors(response, 'Could not save Site');
  };

  $scope.keepMeLoggedInChangeHandler = function() {
    $scope.editSite.flags.default_logged_in_checked = $scope.editSite.flags.is_stay_logged_in_displayed;
  };

  $scope.editBillboard = function(billboard_id, type) {
    var url = $state.href("go.u.billboardEdit",{
      id: billboard_id,
      site_id: $scope.dbSite.id,
      site_name: $scope.dbSite.name,
      billboard_type: type,
    });
    window.open(url);
  }

  BillboardService.index({site_id: $scope.dbSite.id, billboard_type:'placeholder'}).then(function(billboards) {
    $scope.data.billboards = billboards;
  });

  BillboardService.index({site_id: $scope.dbSite.id, billboard_type:'banner'}).then(function(billboards) {
    $scope.data.banner_billboards = billboards;
  });

  $scope.locationDisplayedChangeHandler = function() {
    $timeout(function () {
      // Timeout is used to check on the next digest
      if (!$scope.editSite.flags.is_location_displayed)
        $scope.editSite.flags.allow_set_location = false;
    });
  };

  $scope.areUrlsValid = function() {
    // return true if last url in urls list does not contain an asterisk,
    // otherwise return false
    if (($scope.editSite.urls||"").split("\n").slice(-1)[0].indexOf("*") > -1){
      return false;
    }
    return true;
  }

  $scope.save = function() {
    if (!$scope.areUrlsValid()) return;

    var wasNew = $scope.editSite.isNew();
    $scope.settings.saving = true;
    var timeoutSave = $timeout(function() {
      $scope.settings.showSaving = true;
    }, 300);

    //Remove items saved elsewhere
    delete $scope.editSite.programs;
    delete $scope.editSite.css_config_json;

    $scope.editSite.save(function(site) {
      $timeout.cancel(timeoutSave);
      $scope.settings.saving = false;
      $scope.settings.showSaving = false;
      $scope.editSite = site;
      $state.transitionTo('go.u.site', {
        siteId: site.id
      }, {
        reload: true
      });
    })['catch']($scope.handleErrors);
  };

  $scope.timeZones = [];
  $scope.time_zones = function(){
    $http.get(DOMAIN + '/timezones/all').then(function(result) {
      $scope.timeZones = result.data
    });
  }  
  $scope.time_zones();
  $scope.editSite.friend_label = $scope.editSite.friend_label || "Friend"
  $scope.editSite.friend_label_plural =  $scope.editSite.friend_label_plural || "Friends"
  });

'use strict';

angular.module('goApp')

.factory('SitesLoader', ['Site', '$q', 'Utils',
  function(Site, $q, Utils) {
    return function(opts) {
      var defer = $q.defer();

      var options = {
        page_size: 0
      };
      
      // if (!Utils.isUndefinedOrNull(opts.organization_id)) {
      //   options.organization_id = opts.organization_id;
      // } else if(!Utils.isUndefinedOrNull(opts.reseller_id)){
      //   options.reseller_id = opts.reseller_id;
      // }

      Site.index(options, function(sites) {
        defer.resolve(sites);
      }, function() {
        defer.reject('Sites could not be loaded.');
      });

      return defer.promise;
    };
  }
])
.factory('SiteLoader', ['Site', '$q', 'Utils',
  function(Site, $q, Utils) {
    return function(opts) {
      var defer = $q.defer();
      
      if (Utils.isUndefinedOrNull(opts.siteId) || opts.siteId === 'new') {
        defer.resolve(Site.build({
          organization_id: parseInt(opts.organization_id),
          is_active: true,
          from_address: 'no-reply@elevatewellbeing.com',
          password_min_length: 8,
          password_max_length: 20,
          password_min_letters: 1,
          password_min_numbers: 1,
          password_min_symbols: 1,
          user_challenge_days: 3,
          flags: {
            is_gender_displayed: true,
            is_stay_logged_in_displayed: true,
            is_social_media_displayed: true,
            is_show_individual_leaderboard: true,
            is_video_enabled: false, 
            is_buddy_feature_displayed: true,
            is_messaging_enabled: true,
            enable_account_lockouts: true
          }
        }));
      } else {
        Site.show({
          id: opts.siteId
        }, function(site) {
          site.init();
          defer.resolve(site);
        }, function() {
          defer.reject('Site could not be loaded.');
        });
      }

      return defer.promise;
    };
  }
]);
'use strict';

angular.module('goApp').factory('Site', function($http, ActiveResource, DOMAIN, HesDate, THEMES, $filter, Program, SITE, ipCookie, ActivityService) {
  var Site = ActiveResource('/sites/:id', {
    nestedRoutes: ['index', 'create', 'update', 'destroy'],
    parentResource: ['Organization', 'Reseller'],
    domain: DOMAIN
  }, {
    coordinator_stats: {
      method: "GET",
      isArray: false,
      params: {id: "@id"},
      url: "/coordinator_stats"
    }
  });

  Site.PilotAuth = ActiveResource('/authenticate', {
    nestedRoutes: ['create'],
    parentResource: ['Site'],
    domain: DOMAIN
  });

  Site.CanRegister = ActiveResource('/can_register', {
    nestedRoutes: ['show'],
    parentResource: ['Site'],
    domain: DOMAIN
  });

  Site.prototype.init = function() {
    this.theme = (this.theme !== undefined && this.theme !== null) ? this.theme.toLowerCase() : THEMES[0].key.toLowerCase();
    this.css_config_json = this.css_config_json || {};
    this.from_address = this.from_address || 'no-reply@elevatewellbeing.com';

    if (angular.isArray(this.programs)) {
      this.programs = Program.wrap(this.programs);
      // this.programs.past = this.programs.current = this.programs.upcoming =
      // this.programs.ongoing = this.programs.reporting = [];
    } else {
      this.programs.past = Program.wrap(this.programs.past);
      this.programs.current = Program.wrap(this.programs.current);
      this.programs.upcoming = Program.wrap(this.programs.upcoming);
      this.programs.ongoing = Program.wrap(this.programs.ongoing);
      this.programs.reporting = Program.wrap(this.programs.reporting);
    }
  };

  Site.prototype.allPrograms = function() {
    return this.pastPrograms().concat(this.currentPrograms()).concat(this.upcomingPrograms()).concat(this.ongoingPrograms());
  };

  Site.prototype.currentPrograms = function() {
    return this.programs.current;
  };

  Site.prototype.ongoingPrograms = function() {
    return this.programs.ongoing;
  };

  Site.prototype.getEditLocationLabels = function() {
    return this.location_labels && angular.isArray(this.location_labels) ? this.location_labels.join("|") : '';
  };

  Site.prototype.getSiteUrls = function() {
    return this.urls.split(' ');
  };

  Site.prototype.getTheme = function() {
    return this.theme;
  };

  Site.prototype.hasCurrentPrograms = function() {
    return (this.currentPrograms()||[]).length > 0;
  };

  Site.prototype.hasOngoingPrograms = function() {
    return this.ongoingPrograms().length > 0;
  };

  Site.prototype.hasPastPrograms = function(user) {
    return this.pastPrograms(user).length > 0;
  };

  Site.prototype.hasUpcomingPrograms = function() {
    return this.upcomingPrograms().length > 0;
  };

  Site.prototype.hasComingSoonPrograms = function() {
    if (this.currentPrograms() && this.currentPrograms().length == 0) {
      return false;
    } else {
      var coming_soon = false;
      angular.forEach(this.currentPrograms(), function(program) {
        if (program.logging_state == "coming_soon") {
          coming_soon = true;
        }
      });
      return coming_soon;
    }
  };

  Site.prototype.hasNestedLocations = function() {
    return this.location_labels.length && this.location_labels.length > 1;
  };

  Site.prototype.pastPrograms = function(user) {
    var programs = this.programs.past;
    if (user && user.registered_program_ids) {
      var userPrograms = [];
      angular.forEach(user.registered_program_ids, function(progId) {
        var prog = $filter('filter')(programs, {
          id: progId
        }, true)[0];
        if (prog) {
          userPrograms.push(prog);
        }
      });
      programs = userPrograms;
    }
    return programs;
  };

  Site.prototype.pastLocationPrograms = function(user) {
    return _.reject(this.pastPrograms(user), {
      location_id: null
    });
  };

  Site.prototype.pastOverallPrograms = function(user) {
    return _.filter(this.pastPrograms(user), {
      location_id: null
    });
  };

  Site.prototype.reportingPrograms = function(user) {
    var programs = this.programs.reporting;
    if (user && user.isLocationCoordinator()) {
      programs = $filter('filter')(programs, {
        location_id: user.location.id
      });
    }
    return programs;
  };

  Site.prototype.upcomingPrograms = function() {
    return this.programs.upcoming;
  };

  Site.prototype.getEditLocationLabels = function() {
    return this.location_labels && angular.isArray(this.location_labels) ? this.location_labels.join("|") : '';
  };

  Site.prototype.getFriendsLabel = function(asPlural) {
    return !!asPlural ? this.friend_label_plural : this.friend_label;
  };

  Site.prototype.isLocationDisplayed = function() {
    return this.flags.is_location_displayed;
  };

  Site.prototype.isAutomaticWallPostEnabled = function() {
    return this.flags.is_automatic_wall_post_enabled;
  }

  Site.prototype.getProgramById = function(id) {
    return $filter('filter')(this.programs, {
      id: id
    }, true)[0];
  };

  Site.prototype.isDefault = function() {
    return this.name === 'dashboard';
  };

  Site.prototype.isEligibilityDisplayed = function() {
    return this.flags.is_eligibility_displayed;
  };

  Site.prototype.isBirthDateEligibilityDisplayed = function() {
    return this.flags.is_birth_date_eligibility_displayed;
  };

  Site.prototype.isWUSTL = function() {
    return !!this.flags.is_wustl;
  };

  Site.prototype.getLocationLabel = function(level) {
    var label = 'Location';
    
    if (this.location_labels && this.location_labels.length && level >= 0) {
      if (level <= this.location_labels.length - 1) {
        label = this.location_labels[level];
      }
    }

    return label;
  };

  Site.prototype.placeholderBanner = function() {
    return DOMAIN + this.placeholder_image;
  };

  Site.prototype.verifyCanRegister = function(onSuccess, onFailure) {
    var canReg = new Site.CanRegister();
    canReg.site_id = this.id;

    return canReg.$show({}, onSuccess, onFailure);
  };

  Site.prototype.hasGuidelines = function() {
    return this.has_guidelines;
  }

  Site.prototype.hasLaunched = function() {
    if (this.launch_on) {
      return HesDate.compare(this.current_date, this.launch_on) >= 0 || !!ipCookie('pilotPassword');
    } else {
      return true;
    }
  };

  Site.prototype.currentProgramStatus = function() {
    return this.current_program_status;
  };

  Site.prototype.canOptInToCampaign = function() {
    return HesDate.compare(this.current_date, this.launch_on) >= 0 && HesDate.compare(this.current_date, this.registration_ends_after) <= 0;
  };

  Site.prototype.isCampaignClosed = function() {
    if (this.disable_after) {
      return HesDate.compare(this.current_date, this.registration_ends_after) > 0 && HesDate.compare(this.current_date, this.disable_after) < 0;
    } else {
      return HesDate.compare(this.current_date, this.registration_ends_after) > 0;
    }
  };

  Site.prototype.isRegistrationOpen = function() {
    if (this.late_registration_ends_on) {
      return this.flags.is_registration_frozen !== true && HesDate.compare(this.current_date, this.registration_starts_on) >= 0 && (HesDate.compare(this.current_date, this.registration_ends_after) <= 0 || HesDate.compare(this.current_date, this.late_registration_ends_after) <= 0);
    } else {
      return this.flags.is_registration_frozen !== true && HesDate.compare(this.current_date, this.registration_starts_on) >= 0 && HesDate.compare(this.current_date, this.registration_ends_after) <= 0;
    }
  };

  Site.prototype.launchesOn = function() {
    return HesDate.parse(this.launch_on);
  };

  Site.prototype.registrationEndsAfter = function() {
    return HesDate.parse(this.registration_ends_after);
  };

  Site.prototype.verifyPilotPassword = function(password, onSuccess, onFailure) {
    var pilotAuth = new Site.PilotAuth();
    pilotAuth.password = password;
    pilotAuth.site_id = this.id;

    return pilotAuth.create(onSuccess, onFailure);
  };

  Site.prototype.getFavicon = function(){
    return '/images/' + this.theme + '/favicon.ico';
  };

  Site.prototype.hasDevicesEnabled = function(){
    return this.flags.is_fitbit_enabled || this.flags.is_healthkit_enabled || this.flags.is_validic_enabled || this.flags.is_health_connect_enabled || this.flags.is_garmin_enabled || this.flags.is_google_health_enabled;
  };

  Site.prototype.userChallengeDays = function(){
    return this.user_challenge_days;
  };

  return Site;
});

'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider
    .state('go.u.sites', {
      url: '/sites',
      controller: 'SitesController',
      abstract: false,
      background: 'filled',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/sites/sites.html');
        }
      ],
      resolve: {
        sites: ['SitesLoader', '$stateParams',
          function(SitesLoader, $stateParams) {
            return new SitesLoader({
              // organization_id: $stateParams.org_id,
              // reseller_id: $stateParams.reseller_id
            });
          }
        ]
      }
    })
    .state('go.u.site', {
      url: '/site/:siteId',
      controller: 'SiteController',
      abstract: false,
      background: 'filled',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/sites/site.html');
        }
      ],
      resolve: {
        dbSite: ['SiteLoader', '$stateParams', function(SiteLoader, $stateParams) {
          return new SiteLoader({
            siteId: $stateParams.siteId,
          });
        }]
      }
    })
    .state('go.u.site.create', {
      url: '/create',
      controller: 'SiteCreateEditController',
      background: 'filled',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/sites/site-createEdit.html');
        }
      ]
    })
    .state('go.u.site.edit', {
      url: '/edit',
      controller: 'SiteCreateEditController',
      background: 'filled',
      abstract: false,
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/sites/site-createEdit.html');
        }
      ]
    })
    .state('go.u.site.program', {
      url: '/program/:programId',
      controller: 'ProgramCreateEditController',
      abstract: false,
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/programs/programCreateEdit.html');
        }
      ]
    })
    .state('go.u.site.user', {
      url: '/user',
      abstract: false,
      background: 'filled',
      template: '<div ui-view></div>'
    })
    .state('go.u.site.users', {
      controller: 'UsersController',
      url: '/users',
      abstract: false,
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/users/users.html');
        }
      ]
    })
    .state('go.u.site.coordinators', {
      title: 'Coordinators',
      url: '/coordinators',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/sites/coordinatorsBox/coordinatorsBox.html');
        }
      ],
      controller: 'CoordinatorsBoxController'
    })
    .state('go.u.site.activities', {
      title: 'Exercise Activities',
      url: '/activities',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/sites/activity/activitiesList.html');
        }
      ],
      onEnter: function(ActivityService, $stateParams) {
        ActivityService.get(true, $stateParams.siteId);
      },
      controller: 'ActivitiesListController'
    })
    .state('go.u.site.activities.edit', {
      title: 'Exercise Activities',
      url: '/:activityId',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/sites/activity/activityEditor.html');
        }
      ],
      onEnter: function(ActivityService, $stateParams) {
        ActivityService.get(false, $stateParams.siteId).then(function() {
          ActivityService.getActivityById($stateParams.activityId);
        });
      },
      controller: 'ActivityEditorController'
    })
    .state('go.u.site.eop', {
      url: '/eop',
      abstract: false,
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/sites/eopReporting/eopReporting.html');
        }
      ],
      controller: 'EopReportingController'
    })
    .state('go.u.site.banners', {
      url: '/banners',
      controller: 'BannersController',
      title: 'Banners',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/sites/banners/banners.html');
        }
      ],
      abstract: false
    })
});
'use strict';

angular.module('goApp')
  .controller('SitesController', ['$scope', '$filter', 'sites', '$state',
    function($scope, $filter, sites, $state) {
      $scope.data = {
        sites: sites,
        tblSites: {
          fields: [
            ["Name", "string"],
            ["Urls", "string"],
            ["Actions", "actions", {
              width: 400
            }]
          ],
          rows: [],
          actions: []
        }
      };

      function setTableData() {

        var rows = [],
          gridRows = [];
        for (var i = 0; i < $scope.data.sites.length; i++) {
          var site = $scope.data.sites[i];
          var siteLink = '/site/' + site.id;

          // rows.push([
          site.row = [
            (site.name || 'N/A'),
            (site.urls || 'N/A'),
            // (site.getNumberOfWeeks() || 'N/A'),
            // site.registration_starts_on || 'N/A',
            // site.registration_ends_on || 'N/A',
            // (site.launch_on),
            [
              ['view', siteLink],
              ['edit', siteLink + '/edit'],
              ['users', siteLink + '/users'],
              ['reports', siteLink + '/reports'],
              ['delete', siteLink + '/delete']
            ]
          ];
          // ]);
          gridRows.push(site);
        }

        $scope.data.tblSites.rows = gridRows;
      }

      setTableData();

    }
  ]);
angular.module("goApp").controller("SmsDialogCtrl", function($scope, ContentLoader, SendSms, $state){

    // stuff for send/test dialog
    $scope.confirmation = {
        title: "Send SMS",
        message: "Are you sure you want to send this to " + $scope.data.total + " recipients?",
        cancelText: "No",
        confirmText: "Send",
        data: $scope.data,
        search: ""
      };

    $scope.test_sms ={
        recipients: [],
        message: $scope.data.message
    }

    $scope.sending = "test"
    $scope.sentTestMessage = ''
    $scope.test = function(){
        $scope.sending = "loading"
        $scope.sentTestMessage = '';
        SendSms.test($scope.test_sms).then(
            function (response) {
            if (response.status == 200) {
                $scope.sending = "test";
                $scope.sentTestMessage = 'Sent';
            }
            },
            function (error) {
                console.log(error);
                $scope.sentTestMessage = 'error, see console log';
            }
        );
    }
  
    // stuff for edit dialog
    if(!!$scope.ngDialogData){

        $scope.batch = $scope.ngDialogData.batch;
        $scope.batch.filters = {
            ALL_SUBSCRIBED_PARTICIPANTS : $scope.batch.recipients_query == "ALL_SUBSCRIBED_PARTICIPANTS" ? 1 : 0,
            PROGRAM_PARTICIPANTS : $scope.batch.recipients_query == "PROGRAM_PARTICIPANTS" ? 1 : 0,
            NON_PROGRAM_PARTICIPANTS : $scope.batch.recipients_query == "NON_PROGRAM_PARTICIPANTS" ? 1 : 0
        }

        $scope.reset = function(){
            $scope.batch.program_id = !$scope.batch.filters.PROGRAM_PARTICIPANTS && !$scope.batch.filters.NON_PROGRAM_PARTICIPANTS ? "" : $scope.batch.program_id
        }
        $scope.reset()
        
        $scope.is_scheduled = !!$scope.batch.send_at ? true : false;
        if(!!$scope.is_scheduled){
            $scope.batch.send_at = new Date($scope.batch.send_at)
        }
        
        $scope.templates = [];
        new ContentLoader({
            site_id: $scope.dbSite.id,
            category: 'sms_templates'
          }, true).then(function(content) { 
            content.forEach(data => {
              $scope.templates.push({"name": data.title, "content": data.content.replace(/(<([^>]+)>)/gi, "")})
            });
          });
    }

    $scope.update_batch = function () {
        console.log($scope.batch)
        SendSms.updateBatch($scope.batch).then(
            $scope.closeThisDialog(),
            function (error) {
                $scope.sentMessage = "Failed :( , error is logged";
                console.log(error);
            }
        );
    };

    $scope.setTemplate = function(){
        $scope.batch.message = !!$scope.current_template ? $scope.current_template.content : ""
    }

  })
angular.module("goApp").controller("SmsQueueCtrl", function($scope, $http, DOMAIN, ngDialog, DialogService, SendSms){
  
  $scope.data = {
    batches: [],
    table: {
      fields: [
        ["batch_id", "int", {
          width: 120
        }],
        ["status", "string"],
        ["send_at", "string"],
        ["created_on", "string"],
        ["actions", "actions", {
          width: 200
        }]
      ],
      rows: [],
      actions: []
    }
  };

  $scope.getBatches = function(){
    SendSms.getBatches($scope.dbSite.id).then(function(response){
      $scope.data.batches = response.data.data
      $scope.setTableData();
    })
  }

  $scope.refreshBatches = function(){
    $scope.data.table.rows = []
    $scope.getBatches()
  }

  $scope.setTableData = function() {

    var showBatch = function(ele) {
        ngDialog.openConfirm({
          template: '/scripts/sms/show/show.template.html',
          className: 'ngdialog-theme-default col-3',
          controller:'SmsShowCtrl',
          scope: $scope,
          data:{
            batch: ele
          }
        }).then(function() {
          console.log("close")
        });
    }

    var editBatch = function(ele) {
      SendSms.getBatch(ele.batch_id).then(function(response){
        console.log(response.data.data)
        ngDialog.openConfirm({
          template: '/scripts/sms/dialogs/editSmsDialog.html',
          className: 'ngdialog-theme-default col-3',
          controller:'SmsDialogCtrl',
          scope: $scope,
          data:{
            batch: response.data.data[0]
          }
        }).then(function() {
          console.log("close")
        });
      })
    }

    var cancelBatch = function(ele) {
      var message = "Are you sure you want to cancel batch '"+ele.batch_id+"'? It will hide it from the table."
      DialogService.openConfirmationDialog("Confirm", message, 'No', "Yes").then(function() {
        SendSms.cancelBatch(ele).then(function(){
          _.remove($scope.data.table.rows, {
            batch_id: ele.batch_id
          });
        });
      });
    }

    var gridRows = [];
    for (var i = 0; i < $scope.data.batches.length; i++) {
      var ele = $scope.data.batches[i];

      ele.row = [
        (ele.batch_id || ''),
        (ele.status || 'N/A'),
        (ele.send_at || ''),
        (ele.created_at || 'N/A'),
        [
          ['show', showBatch, ele],
          [ele.status == 'in queue' ? 'edit' : '', editBatch, ele],
          [ele.status == 'in queue' ? 'cancel' : '', cancelBatch, ele]
        ]
      ];
      gridRows.push(ele);
    }

    $scope.data.table.rows = gridRows;
  }

  $scope.getBatches()

})
angular
  .module('goApp')
  .config(function (intlTelInputOptions) {
    angular.extend(intlTelInputOptions, {
      utilsScript: '/bower_components/intl-tel-input/build/js/utils.js',
      defaultCountry: 'auto',
      autoFormat: true,
      autoPlaceholder: true
    });
  })
;
angular.module("goApp").controller("SmsShowCtrl", function($scope, SendSms){
  
    $scope.data = {
        batch: {},
        messages: [],
        batch_recipients_length: 0,
        expected_recipents: [],
        table: {
            fields: [
            ["user_id", "string"],
            ["email", "string"],
            ["phone", "string"],
            ["sid", "string"],
            ["status", "string"],
            ["last updated", "string"],
            ],
            rows: [],
            actions: []
        }
    };
  
    $scope.getBatchMessages = function(){
        SendSms.getMessages($scope.ngDialogData.batch).then(function(response){
            console.log(response.data)
            $scope.data.batch = response.data.batch
            $scope.data.messages = response.data.messages
            $scope.data.batch_recipients_length = response.data.batch_recipients_length
            $scope.data.expected_recipents = response.data.expected_recipents
            $scope.setTableData()
        })
    }

    $scope.refreshMessages = function(){
        SendSms.refreshMessages($scope.data.batch).then(
        function (response) {
            if (response.status == 200) {
                $scope.data.table.rows = []
                $scope.getBatchMessages()
            }
        },
        function (error) {
            $scope.errorMessage = "Not able to refresh";
            console.log(error);
        })
    }
    
    $scope.setTableData = function() {
        var gridRows = [];
        for (var i = 0; i < $scope.data.messages.length; i++) {
          var msg = $scope.data.messages[i];

          msg.row = [
            (msg.user_id    || 'Manual'),
            (msg.email      || 'N/A'),
            (msg.phone      || 'N/A'),
            (msg.twilio_sid || 'N/A'),
            (msg.status     || 'N/A'),
            (msg.updated_at || 'N/A')
          ];
        
          gridRows.push(msg);
        }

        $scope.data.table.rows = gridRows;
    }
    
    $scope.getBatchMessages()

  })
"use strict";

angular
  .module("goApp")

  .controller("SmsCtrl", ["$rootScope","$scope","$http","DOMAIN","DialogService","SendSms","ContentLoader","$state",
    function ($, $scope, $http, DOMAIN, DialogService, SendSms, ContentLoader, $state) {
      $scope.sms = {
        site_id: $scope.dbSite.id,
        recipients: "",
        message: "",
        is_scheduled: false,
        send_at: "",
        filters: {
        },
        program_id: null
      };

      $scope.data = {
        templates: []
      };

      $scope.setTemplate = function(){
        $scope.sms.message = !!$scope.data.current_template ? $scope.data.current_template.content : ""
      }

      $scope.reset = function(){
        $scope.sms.program_id = !$scope.sms.filters.PROGRAM_PARTICIPANTS && !$scope.sms.filters.NON_PROGRAM_PARTICIPANTS ? "" : $scope.sms.program_id
      }

      $scope.sentMessage = "";

      $scope.submit = function () {
        SendSms.getEstimateRecipients($scope.sms).then(function (response) {
          var data = response.data.data[0];

          DialogService.openSmsSendDialog(data).then(function () {
            SendSms.send($scope.sms).then(
                function (response) {
                  if (response.status == 200) {
                    $scope.sentMessage = $scope.sms.is_scheduled ? "scheduled" : "Sent!";
                    $state.go("go.u.site.sms.queued")
                  }
                },
                function (error) {
                  $scope.sentMessage = "Failed :( , error is logged";
                  console.log(error);
                }
              );
          });
        });
      };

      new ContentLoader({
        site_id: $scope.dbSite.id,
        category: 'sms_templates'
      }, true).then(function(content) { 
        content.forEach(data => {
          $scope.data.templates.push({"name": data.title, "content": data.content.replace(/(<([^>]+)>)/gi, "")})
        });
      });
    
    },
  ]);

"use strict";

angular
  .module("goApp")
  .factory("SendSms", function (ActiveResource, $http, DOMAIN, $stateParams) {
    var SendSms = ActiveResource("/sms_messages", {
      domain: DOMAIN,
      parentResource: ["Site"],
    });

    SendSms.send = function (sms) {
      return $http.post(DOMAIN + "/sms_messages/send", {sms: sms})
    };

    SendSms.test = function (test) {
      return $http.post(DOMAIN + "/sms_messages/test", {test: test})
    };

    SendSms.getEstimateRecipients = function (sms) {
      return $http.post(DOMAIN + "/sms_messages/recipients", sms);
    };

    SendSms.getBatch = function(batchId){
      return $http.get(DOMAIN + "/batch/show", { params: {batch_id: batchId}});
    }

    SendSms.getBatches = function(siteId){
      return $http.get(DOMAIN + "/batch/queue", { params: {site_id: siteId}});
    }

    SendSms.updateBatch = function(batch){
      return $http.post(DOMAIN + "/batch/update", batch);
    }

    SendSms.getMessages = function(ele){
      return $http.get(DOMAIN + "/batch/messages", { params: {batch_id: ele.batch_id}});
    }

    SendSms.refreshMessages = function(batch){
      return $http.post(DOMAIN + "/sms_messages/refresh", { params: {batch_id: batch.id}});
    }

    SendSms.cancelBatch = function(ele){
      return $http.post(DOMAIN + "/batch/cancel", {batch_id: ele.batch_id});
    }

    return SendSms;
  });

angular.module("goApp").config(function ($stateProvider) {
  $stateProvider
    .state("go.u.site.sms", {
      url: "/sms",
      template: "<div ui-view></div>",
      abstract: true,
    })
    .state("go.u.site.sms.queued", {
      url: "/queued",
      title: "SMS",
      controller: "SmsQueueCtrl",
      templateProvider: [
        "hesTemplateService",
        function (hesTemplateService) {
          return hesTemplateService.getTemplate(
            "/scripts/sms/queued/queued.html"
          );
        },
      ]
    })
    .state("go.u.site.sms.send", {
      url: "/send",
      title: "Send SMS",
      controller: "SmsCtrl",
      templateProvider: [
        "hesTemplateService",
        function (hesTemplateService) {
          return hesTemplateService.getTemplate("/scripts/sms/send.html");
        },
      ],
    });
});

'use strict';

angular.module('goApp').service('HesSocket', function($rootScope, DOMAIN, $q, $window, ENVIRONMENT) {
	var HesSocket = new Object();

	var socket, listeners = {},
			isReconnect = false,
			channels = [],
			isConnected = false;


	$rootScope.socket = function() {
		return socket;
	};

	HesSocket.ioSocket = socket;

	HesSocket.connect = function() {
		var defer = $q.defer();

		if (socket) {
			if (isConnected) {
				defer.resolve(socket);
			} else {
				socket.io.skipReconnect = false;
				socket.io.reconnecting = false;
				socket.removeAllListeners();
				socket.io.reconnect();
				isConnected = true;
				defer.resolve(socket);
			}
		} else {

			var uri;
			switch (ENVIRONMENT) {
				case 'staging':
					uri = '';
					break;
				case 'production':
					uri = 'https://socketio.hesapps.com';
					break;
				default:
					uri = "localhost" + ':8001';
					break;
			}

			socket = io.connect(uri, {
				path: '/socket.io/1/',
				'sync disconnect on unload': true,
				transports: null,
				reconnection: true,
				reconnectionDelay: 3000,
				reconnectionAttempts: Infinity,
				secure: false
			});

			socket.on('connect', function() {
				isConnected = true;
				if (isReconnect) {
					for (var k = 0; k < channels.length; k++) {
						socket.emit("joinChannel", {
							channel: channels[k]
						});
					}
					isReconnect = false;
				}

				defer.resolve(socket);
			});

			socket.on('disconnect', function() {
				isConnected = false;
				isReconnect = true;
				defer.resolve(socket);
			});

			socket.on('connect_error', function(obj) {
				isConnected = true;
				if (isReconnect) {
					for (var k = 0; k < channels.length; k++) {
						socket.emit("joinChannel", {
							channel: channels[k]
						});
					}
					isReconnect = false;
				}
				
				defer.resolve(socket);
			});
		}

		return defer.promise;
	}

	HesSocket.on = function(eventName, callback) {
		socket.on(eventName, function() {
			var args = arguments;
			$rootScope.$apply(function() {
				if (callback) {
					callback.apply(socket, args);
				}
			});
		});

		listeners[eventName] = listeners[eventName] || [];
		listeners[eventName].push(getFunctionHashCode(callback));
	}


	HesSocket.emit = function(eventName, data, callback) {
		if (socket) {
			socket.emit(eventName, data, function() {
				var args = arguments;
				$rootScope.$apply(function() {
					if (callback) {
						callback.apply(socket, args);
					}
				});
			});
			
			if(eventName == 'joinChannel') {
				if(!_.find(channels,data.channel)) {
					channels.push(data.channel);
				}
			}
		}
	}


	HesSocket.alreadyListening = function(eventName, callback) {
		return listeners[eventName] && listeners[eventName].indexOf(getFunctionHashCode(callback)) !== -1;
	}


	HesSocket.removeAllListeners = function(eventName) {
		socket.removeAllListeners(eventName);
	}
	
	HesSocket.isConnected = function() {
		return isConnected;
	}

	HesSocket.isInitialized = function() {
		return !!socket;
	}

	HesSocket.getIoSocket = function() {
		return socket;
	}

	HesSocket.flush = function() {
		$rootScope.$digest();
	}

	HesSocket.disconnect = function() {
		channels = [];
		isConnected = false;
		isReconnect = true;
		if (!!socket) {
			HesSocket.removeAllListeners();
			socket.io.disconnect();
		}
	}


	function getFunctionHashCode(callback) {
		var hash = 0,
			i, l, char;

		callback = callback.toString();
		if (callback.length === 0) {
			return hash;
		}
		for (i = 0, l = callback.length; i < l; i++) {
			char = callback.charCodeAt(i);
			hash = ((hash << 5) - hash) + char;

			// Convert to 32-bit integer.
			hash |= 0;
		}
		return hash;
	}

	return HesSocket;
		
});
'use strict';


angular.module('goApp')
  .service('SSOService', ['ipCookie', '$window','SsoDetail',
    function(ipCookie, $window, SsoDetail) {

      var ssoService = {
        getLabel: function() {
          return ssoService.details.sso_label;
        },

        getToken: function() {
          return ipCookie('sso_session_token');
        },

        getUserInformation: function() {
          return ipCookie('sso_info');
        },

        goToLogin: function() {
          $window.location.href = ssoService.details.login_url;
        },

        goToRedirect: function() {
          var redirect = ssoService.details.redirect;
          var ret = true;

          ipCookie.remove('sso_session_token');

          if(redirect !== null && redirect !== '' && new RegExp(/^http/).test(redirect)) {
            ret = false;
            $window.location.href = redirect;
          }
          else {
            return redirect;
          }

          return ret;
        },

        isEnabled: function() {
          return ssoService.details.is_sso_enabled;
        },

        setDetail: function(detail) {
          ssoService.details = detail || {};
          return ssoService.details;
        }
      };

      return ssoService;
    }
  ]);
'use strict';

angular.module('goApp')
  .controller('SsoDetailController', ['$scope', 'SsoDetailService', 'SsoDetail', 'SsoDetailLoader', 'LocationService','ngDialog', 'ErrorService', 'DOMAIN', '$http', '$window',
    function($scope, SsoDetailService, SsoDetail, SsoDetailLoader, LocationService, ngDialog, ErrorService, DOMAIN, $http, $window) {

      $scope.data = {
        ssoDetails: [],
        locations: []
      };

      $scope.hasSSODetails = function() {
        return $scope.data.ssoDetails.length > 0;
      };

      function ssoURL() {
        var subdomain =  $scope.dbSite.urls.split("\n")[0].split(".")[0];
        return location.protocol + DOMAIN.replace(/dashboard/g, subdomain) + '/sso';
      };

      $scope.testSSO = {
        key: null,
        url: ssoURL()
      };

      $scope.doSsoTest = function() {
        ErrorService.clearErrors();
        if($scope.testSSO.extras){
          var splitNewLines = $scope.testSSO.extras.split('\n');
          for(var i = 0; i < splitNewLines.length; i++){
            var splitEquals = splitNewLines[i].split('=');
            if(splitEquals.length === 2){
              $scope.testSSO[splitEquals[0]] = splitEquals[1];
            }
          }
        }
        $http.post($scope.testSSO.url, $scope.testSSO).then(function(response){
          $window.open(response.data);
        })['catch'](function(response){
          ErrorService.showErrors(response, 'Failed test!');
        });
      };

      $scope.editSsoDetail = function(ssoDetail, isNew) {
        //ssoDetail.id = isNew;
        $scope.ssoDetail = ssoDetail;

        ngDialog.openConfirm({
          template: '/scripts/ssoDetail/ssoDetailCreateEdit.html',
          controller: 'SsoDetailController',
          scope: $scope
        }).then(function() {
          $scope.refreshSsoDetails(); 
        });

      };

      $scope.saveSsoDetail = function(ssoDetail) {
        ssoDetail.saving = true;
        ssoDetail.save(function(ssod){
          ssoDetail = ssod;
          ssoDetail.saving = false;
          $scope.confirm();
        })['catch']($scope.handleErrors);
      };

      $scope.destroySsoDetail = function(ssoDetail) {
        ngDialog.openConfirm({
          template: '/scripts/ssoDetail/ssoDetailDestroy.html',
          controller: 'SsoDetailController',
          scope: $scope
        }).then(function() {
          ssoDetail.destroy().then(function(ssod){
            $scope.refreshSsoDetails();
          })['catch']($scope.handleErrors);
        });
      };

      $scope.newSsoDetail = function() {
        var ssoDetail = new SsoDetail();
        ssoDetail.site_id = $scope.dbSite.id;
        $scope.editSsoDetail(ssoDetail, true);
      };

      $scope.getLocationName = function(id) {
        var name = '';
        if (id) {
          name = LocationService.getLocationById($scope.data.locations, id, false).name;
        }
        return name;
      };

      $scope.refreshSsoDetails = function() {
        SsoDetailService.get(true, $scope.dbSite.id).then(function(sso_details) {
          $scope.data.ssoDetails = sso_details;
          if ($scope.hasSSODetails()) {
            $scope.testSSO.key = $scope.testSSO.key || $scope.data.ssoDetails[0].wskey;
          };
        });
      };
      $scope.refreshSsoDetails();

      LocationService.get(false, $scope.dbSite.id).then(function(locations) {
        $scope.data.locations = LocationService.expandChildLocations(locations);
      });

    }
  ]);
'use strict';

angular.module('goApp')

.factory('SsoDetailLoader', ['SsoDetailService', '$q',
  function(SsoDetailService, $q) {
    return function(site_id) {
      return SsoDetailService.get(false, site_id);
    };
  }
])
'use strict';

angular.module('goApp')

.factory('SsoDetail', ['ActiveResource', 'DOMAIN', '$http',
	function(ActiveResource, DOMAIN, $http) {
		var SsoDetail = ActiveResource('/sso_details/:id/', {
			nestedRoutes: ['index', 'create', 'update', 'destroy', 'show'],
			parentResource: 'Site',
			domain: DOMAIN
		});

		return SsoDetail;
}]);
'use strict';

angular.module('goApp')
  .config(['$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('go.u.site.ssoDetails', {
          url: '/sso_details',
          controller: 'SsoDetailController',
          templateProvider: ['hesTemplateService',
            function(hesTemplateService) {
              return hesTemplateService.getTemplate('/scripts/ssoDetail/ssoDetail.html');
            }
          ]
        });
    }
  ]);
'use strict';

angular.module('goApp')
  .service('SsoDetailService', ['SsoDetail', '$q',
    function(SsoDetail, $q) {
      var SsoDetailService = {
        _ssoDetails: null,
        _ssoDetail: null,
        queued: false,
        queuedPromise: null,
        get: function(refresh, siteId) {
          var defer = $q.defer();
          var promise = defer.promise;
          if (SsoDetailService._ssoDetails === null || refresh) {
            if (!SsoDetailService.queued) {
              SsoDetailService.queuedPromise = promise;
              SsoDetailService.queued = true;
              SsoDetail.index({
                  site_id: siteId,
                  page_size: 0
                }, function(ssoDetails) {
                  SsoDetailService.queued = false;
                  SsoDetailService._ssoDetails = ssoDetails;
                  defer.resolve(SsoDetailService._ssoDetails);
                },
                function(rejection) {
                  SsoDetailService.queued = false;
                  defer.reject(rejection);
                });
            } else {
              promise = SsoDetailService.queuedPromise;
            }
          } else {
            SsoDetailService.queued = false;
            defer.resolve(SsoDetailService._ssoDetails);
          }

          return promise;
        }
      };

      return SsoDetailService;
    }
  ]);
'use strict';

angular.module('goApp')
  .controller('StarRatingCtrl', function($scope, $filter, $timeout, $rootScope) {

    this.init = function() {
      $scope.hoverClass = 'yellow-1';
      $scope.emptyClass = 'none';
      $scope.isRated = 'red-1';
      $scope.notHighlighted = true;
      $scope.highlightedByUser = false;
      $scope.highlightedAverage = false;
      $scope.stars = new Array($scope.size);
      $scope.ratingTip = "";

      for (var i = 0, n = $scope.stars.length; i < n; i++) {
        $scope.stars[i] = angular.extend({
          index: i
        }, {}, $scope.stars[i]);
      }

      $scope.resetValue();
      $scope.setClass();
      $scope.resetMessage();

      $timeout(function() {
        $scope.outHover();
      }, 1000)
      
    };

    this.resetValue = function() {
      if ($scope.userRating) {
        $scope.value = $scope.userRating / 20;
      } else {
        $scope.value = $filter('number')($scope.average / 20, 1);
      }
    };

    $scope.resetValue = this.resetValue;
    $scope.resetMessage = function() {
      var averageRating = ((parseInt($scope.average) || 0) / 20),
        userRating;

      if ($scope.cleared_rating) {
        clearTimeout($scope.cleared_rating);
        $scope.cleared_rating = null;
      }

      if (!$scope.savingRating) {
        userRating = !$scope.userRating ? 'None' : $scope.userRating / 20;
        $scope.rating_message = 'Average: <span class="font-bold">' + averageRating + '</span>';
        $rootScope.$safeApply();
      }
    };
    $scope.resetMessage();

    $scope.$watch('savingRating', function(status) {
      if (!status) {
        $scope.resetMessage();
      }
    });

    $scope.$watch('userRating', function(rating) {
      $scope.setClass();
      $scope.resetMessage();
    });

    $scope.$watch('average', function(rating) {
      $scope.setClass();
      $scope.resetMessage();
    });

    $scope.clearRating = function() {
      if ($scope.userRating) {
        $scope.userRating = undefined;
      }
      $scope.resetMessage();
      $scope.resetValue();
      $scope.setClass();

      $scope.rating_message = "Your rating has been cleared!";
      $scope.cleared_rating = setTimeout(function() {
        $scope.resetMessage()
      }, 2500);

      $scope.clearHandler();
    };

    $scope.clearRatingAria = function($event) {
      if ($event.keyCode == 13) {
        $scope.clearRating();
      }
    };

    this.setClass = function(onHover) {
      if ($scope.userRating || onHover) {
        $scope.highlightedByUser = true;
        $scope.highlightedAverage = false;
        $scope.notHighlighted = false;
      } else if ($scope.average) {
        $scope.highlightedByUser = false;
        $scope.highlightedAverage = true;
        $scope.notHighlighted = false;
      } else {
        $scope.highlightedByUser = false;
        $scope.highlightedAverage = false;
        $scope.notHighlighted = true;
      }
    };
    $scope.setClass = this.setClass;

    $scope.setRating = function(rating) {
      $scope.userRating = (rating + 1) * 20;
      $scope.changeHandler({
        rating: $scope.value * 20
      });
    };

    $scope.setRatingAria = function($event, $index) {
      if ($event.keyCode == 13) {
        $timeout(function() {
          $scope.setRating($index);
        }, 0);
      }
    };

    $scope.onHover = function(idx) {
      if (!$scope.savingRating) {
        switch (idx) {
          case 0:
            $scope.ratingTip = "Poor";
            break;
          case 1:
            $scope.ratingTip = "Okay";
            break;
          case 2:
            $scope.ratingTip = "Good";
            break;
          case 3:
            $scope.ratingTip = "Great";
            break;
          case 4:
            $scope.ratingTip = "Awesome";
            break;
        }

      }
      $scope.value = idx + 1;
      $scope.setClass(true);
    };

    $scope.outHover = function($event) {
      $scope.resetMessage();
      $scope.resetValue();
      $scope.setClass();
    };

    $scope.showPopover = function(index) {
      var text = (index + 1) + " Star";
      if ($scope.popoverText()) {
        text = $scope.popoverText()(index);
      }
      return text;
    }
  });
'use strict';

angular.module('goApp')
  .directive('hesStarRating', function(hesTemplateService) {
    return {
      scope: {
        size: '=',
        changeHandler: '&',
        clearHandler: '&',
        userRating: '=',
        popoverText: '&?',
        doPopover: "=?",
        savingRating: '=',
        average: '=',
        user: '='
      },
      controller : 'StarRatingCtrl',
      restrict: 'A',
      templateUrl: hesTemplateService.getTemplateUrl('/scripts/star-rating/starRating.html'),
      link: function($scope, iElm, iAttrs, controller) {
        controller.init();
      }
    };
  });
'use strict';

angular.module('goApp').controller('StatsController', function($scope, $q, $state, $http, User, DOMAIN, ContentLoader, ExportService, GOKP_MIGRATION_DATE) {
  $scope.data = new Object();

  $scope.fetchData = function(year) {
    $scope.data.selected_year = $state.params.year || year || $scope.data.selected_year || $scope.site.years[0];
    if ($scope.site.flags.is_launchpad_plus && $scope.site.features_on) {
      User.stats({user_id: $scope.user.id, year: $scope.data.selected_year}).$promise.then(function(stats) {
        $scope.data.stats = stats;
      }, function(err) {
        console.log("failed to fetch stats for user#"+ $scope.user.id);
      });
    }
    User.campaigns({user_id: $scope.user.id, year: $scope.data.selected_year}).$promise.then(function(campaigns) {
      $scope.data.campaigns = _.filter(campaigns, function(ca) {
        return moment(ca.promotion.launch_on) <= new Date();
      });
    }, function(err) {
      console.log("failed to fetch campaigns for user#"+ $scope.user.id);
    });
  }

  $scope.fetchData($state.params.year);

  $scope.formattedDate = function(date) {
    return moment(date).format("MMM D");
  }

  $scope.isCurrent = function(c) {
    switch(c.logging_state) {
      case "logging_ended":
        return false;
      case "registration_closed":
        return false;
      case "enter_logging":
        return true;
      case "opt_in_logging":
        return true;
      case "enter_no_logging":
        return true;
      case "coming_soon":
        return true;
      case "opt_in_no_logging":
        return true;
      default:
        return false;
    }
  }


  $scope.data.app_content = {};
  new ContentLoader({
    site_id: $scope.site.id,
    category: 'hes_app_content'
  }, false).then(function(contents) {
    $scope.data.app_content = contents;
  });


  $scope.getGokpUserData = function(year) {
    var uri = DOMAIN+'/gokp_user_exports?year='+year;
    window.location = uri;
  }

  $scope.gokp_years = (function() {
    var yearsDiff = moment(GOKP_MIGRATION_DATE).diff($scope.user.profile.started_on, 'years');
    var currentYear = moment(GOKP_MIGRATION_DATE).year();
    var years = [currentYear];
    _.times(yearsDiff, function(n){
      years.push(currentYear-n);
    });
    years = _.uniq(years);
    return _.chunk(years, 3);
  })();

  $scope.exportEntries = ExportService.exportEntries;

  $scope.exportStats = ExportService.exportStats;

  $scope.canExportStats = function() {
    if ($scope.isMobile()) { return false; }
    // WashU only exposes the report for 2026 onward.
    if ($scope.site.flags.is_wustl && parseInt($scope.data.selected_year, 10) < 2026) { return false; }
    return true;
  };

});

'use strict';

angular.module('goApp').config(function($stateProvider) {


  $stateProvider.state('go.u.personal.gokp_legacy_stats', {
    title: 'Stats',
    url: '/stats/gokp_legacy',
    abstract: false,
    controller: 'StatsController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/stats/gokp_legacy_stats.html');
      }
    ]
  });

  $stateProvider.state('go.u.personal.legacy_stats', {
    title: 'Stats',
    url: '/stats/legacy/:year',
    abstract: false,
    controller: 'StatsController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/stats/legacy_stats.html');
      }
    ]
  });


  $stateProvider.state('go.u.personal.stats', {
    title: 'Stats',
    url: '/stats/:year',
    params: {year: new Date().getFullYear().toString()},
    abstract: false,
    controller: 'StatsController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/stats/stats.html');
      }
    ]
  });


});




'use strict';

angular.module('hes')
  .directive('hesTable', ['hesTemplateService', '$window', '$timeout',
    function(hesTemplateService, $window, $timeout) {
      // Runs during compile
      return {
        scope: {
          tblData: '=',
          showExport: '=?',
          reportName: '=?',
          showNoData: '=?',
          loading: '=?',
          customNoDataMsg: '@?',
          filteredData: '=?',
          externalCalls: '=?'
        }, // {} = isolate, true = child, false/undefined = no change
        controller: 'HesTableController',
        // restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
        templateUrl: hesTemplateService.getTemplateUrl('/scripts/table/hesTable.html'),
        link: function($scope, $element, $attrs, controller) {
          $scope.tableElm = $element.find('table');
          $scope.tableElm.addClass('hes-table');

          if ($scope.externalCalls) {
            $scope.externalCalls.exportReport = $scope.exportReport;
          }

          function setColumns() {
            $scope.table.gridOptions.columnDefs = [];
            angular.forEach($scope.tblData.fields, function(field, idx) {
              //Field 0 - Name
              //Field 1 - Type
              //Field 3 - object for custom column defs
              var colDef = {
                name: field[0],
                type: field[1],
                field: 'row[' + idx + ']',
                enableColumnMenu: false
              };
  
              var dateColArray = ['Registered On', 'Recorded On', 'recorded_on', 'Completed On -', 'Started On'];
              var dateTimeColArray = ['Registered At', 'Recorded At', 'Team Made Official At', 'Last Login'];
  
              if (colDef.type === 'actions') {
                colDef.cellTemplate = '/scripts/table/actionColTemplate.html';
                colDef.enableFiltering = false;
                colDef.rowHeight = '*'
              } else if(colDef.type === 'html'){
                colDef.cellTemplate = '/scripts/table/htmlColTemplate.html';
                colDef.type = 'string';
              } else {
                colDef.width = "*";
                if (dateTimeColArray.includes(colDef.name) || field[1] === 'time') {
                  colDef.cellFilter = 'datePlusTime';
                  colDef.type = 'date';
                  colDef.enableSorting = true;
                  colDef.sortDirectionCycle = ['desc', 'asc', null]; // Sort direction cycle descending > ascending > unsorted
                } else if (dateColArray.some(function(col) { return colDef.name.indexOf(col) === 0; })) {
                  colDef.cellFilter = 'dateOnly';
                  colDef.type = 'date';
                  colDef.enableSorting = true;
                  colDef.sortDirectionCycle = ['desc', 'asc', null];
                } else if (field[1] === "integer" || field[1] === "decimal") {
                  colDef.type = "number";
                  colDef.sortDirectionCycle = ['desc', 'asc', null];
                }
              }
  
              if (field.length === 3 && angular.isObject(field[2])) {
                colDef = angular.extend(colDef, field[2]);
              }
  
              $scope.table.gridOptions.columnDefs.push(colDef);
            });
          }

          setColumns();

          function setGridExport() {
            $scope.table.gridOptions.enableSelectAll = true;
            if ($scope.showExport && $scope.tblData.rows.length > 0) {
              var reportName = $scope.reportName || 'report';
              $scope.table.gridOptions.exporterCsvFilename = ($scope.reportName || 'report') + '.csv';
            }
          }

          setGridExport();

          function isValidDateFormat(dateString) {
            var formats = ['YYYY-MM-DD']; // List of acceptable formats
            return moment(dateString, formats, true).isValid(); // true = strict mode
          }
  
          function isValidDateTimeFormat(dateString) {
            var formats = ['MM/DD/YYYY hh:mm a', 'MM/DD/YYYY h:mm a']; // List of acceptable formats
            return moment(dateString, formats, true).isValid(); // true = strict mode
          }
  
          // Incoming data is not reliably formatted as a proper date format or object
          // Function to detect and convert date strings to Date objects required for sorting in UI Grid
          function parseDateInRows(data) {
            return data.map(function(item) {
                item.row = item.row.map(function(value) {
                    if (typeof value === 'string') {
                        var date;
                        // Remove timezone abbreviation added by report_setup.yml (e.g., ' CT') for proper parsing
                        var cleanUpDate = value.replace(' CT', '');
                        // both date formats start with a digit. skip the slow strict parse for other values.
                        if (!/^\d/.test(cleanUpDate)) {
                          return value;
                        }
                        switch (true) {
                          case isValidDateFormat(cleanUpDate):
                            date = moment(cleanUpDate, 'YYYY-MM-DD').toDate();
                            break;
                        
                          case isValidDateTimeFormat(cleanUpDate):
                            date = new Date(cleanUpDate);
                            break;
                        
                          default:
                            return value; // Return value if no valid date format found
                        }
                        
                        return !isNaN(date.getTime()) ? date : value;
                    }
                    return value;  // Return value as-is if not a string
                });
                return item;
            });
          }

          $scope.$watch('tblData.rows.length', function() {
            var transformedData = parseDateInRows($scope.tblData.rows);
            $scope.table.gridOptions.data = transformedData;
            $scope.clearTableFilters();
            $scope.resetVisibleRowCount();
            $scope.scrollReportTableUp();
            if ($scope.tblData.rows !== undefined && $scope.tblData.rows.length > 0) {
              setGridExport();
              setColumns();
              $scope.table.noRows = false;
              $scope.table.allRowsDisplayed = $scope.allRowsAreDisplayed();
            } else {
              $scope.table.noRows = true;
            }
          }, true);
        }
      };
    }
  ])
  .controller('HesTableController', ['$rootScope', '$scope', '$filter', '$timeout', 'Utils', 'DOMAIN', 'uiGridExporterService', 'uiGridExporterConstants',
    function($rootScope, $scope, $filter, $timeout, Utils, DOMAIN, uiGridExporterService, uiGridExporterConstants) {
      $scope.config = {
        incrementRows: 20
      };

      $scope.table = {
        visibleRows: 20,
        hasFilters: false,
        state: '',
        displayedCollection: [],
        allRowsDisplayed: false,
        paginationNeeded: false,
        noRows: false,
        gridOptions: {
          enableSorting: true,
          enableCellEditOnFocus: false,
          enableFiltering: true,
          columnDefs: [],
          exporterFieldCallback: function(grid, row, col, input) {
            if (!Utils.isUndefinedOrNull(col.filter) && col.cellFilter !== '') {
              input = $filter(col.cellFilter)(input);
            }
            return input;
          },
          onRegisterApi: function(gridApi) {
            $scope.table.gridApi = gridApi;
          }
        }
      };



      $scope.clearTableFilters = function() {
        if (angular.isDefined($scope.tableState) && angular.isDefined($scope.tableState.search.predicateObject)) {
          $scope.tableState.search.predicateObject = {};
        }
      };

      $scope.resetVisibleRowCount = function() {
        $scope.table.visibleRows = 20;
        $scope.table.allRowsDisplayed = false;
        $scope.table.paginationNeeded = false;
      };

      $scope.scrollReportTableUp = function() {
        $('.table-wrapper').scrollTop(0);
      };

      function ConvertToCSV(objArray, fields) {
        var array = objArray;
        var str = '';

        for (var i = 0; i < array.length; i++) {
          var line = '';
          for (var index = 0; index < fields.length; index++) {
            var field = fields[index];

            if (line != '') line += ','

            var val = array[i][index];
            if ($scope.isColumnDateTime(index)) {
              val = moment(value).format('l');
            }
            if (!Utils.isUndefinedOrNull(val)) {
              if (field[1] !== "integer" && field[1] !== "actions" && !angular.isNumber(val)) {
                val = '"' + val.replace(/"/g, '""') + '"';
              } else if (field[1] === "actions") {
                val = ''
              }
            } else {
              val = '';
            }
            line += val;
          }

          str += line + '\n';
        }

        return str;
      }

      function doExport(grid, lastColumn) {
        var rowTypes = uiGridExporterConstants.VISIBLE;
        var colTypes = uiGridExporterConstants.VISIBLE;
        uiGridExporterService.csvExport(grid, rowTypes, colTypes);

        if (lastColumn.colDef.type === 'actions') {
          lastColumn.colDef.visible = true;
          grid.refresh();
        }
      }

      $scope.exportReport = function(reportName) {
        if (reportName) {
          $scope.table.gridOptions.exporterCsvFilename = reportName + '.csv';
        }
        var grid = $scope.table.gridApi.grid;
        var columns = $scope.table.gridApi.grid.columns;
        var lastColumn = columns[columns.length - 1];
        if (lastColumn.colDef.type === 'actions') {
          lastColumn.hideColumn();
          grid.refresh().then(function() {
            doExport(grid, lastColumn);
          });
        } else {
          doExport(grid, lastColumn);
        }
      };

      $scope.isColumnActions = function(idx) {
        var numOfFields = $scope.tblData.fields.length;
        if (!angular.isDefined($scope.tblData.fields[numOfFields - 1])) {
          $scope.tblData.fields.length--;
          numOfFields = $scope.tblData.fields.length;
        }
        return idx >= (numOfFields - 1) && $scope.tblData.fields[numOfFields - 1][1].toLowerCase() === "actions";
      };

      $rootScope.isObjectFunction = function(func) {
        return angular.isFunction(func);
      };

      $scope.isColumnSorted = function(idx) {
        var text = false;
        if ($scope.tableState && $scope.tableState.sort && $scope.tableState.sort.predicate) {
          if ($scope.tableState.sort.predicate == idx) {
            text = $scope.tableState.sort.reverse ? 'reverse' : '-reverse';
          }
        }

        return text;
      };

      $scope.isColumnDateTime = function(idx) {
        var fieldType = $scope.tblData.fields[idx][1];
        return fieldType === 'time' || fieldType === 'date' || fieldType === 'datetime';
      };

      $scope.formatValue = function(idx, value) {
        var formattedVal = value;
        if ($scope.isColumnDateTime(idx)) {
          formattedVal = moment(value).format('l');
        }
        return formattedVal;
      };

      $scope.allRowsAreDisplayed = function(viewingFiltered) {
        if (viewingFiltered) {
          return ($scope.table.visibleRows >= $scope.table.displayedCollection.length) || $scope.table.displayedCollection.length === 0;
        } else {
          return ($scope.table.visibleRows >= $scope.tblData.rows.length) || $scope.tblData.rows.length === 0;
        }
      };

      $scope.displayMoreRows = function(inView) {
        if (!$scope.allRowsAreDisplayed($scope.table.hasFilters)) {
          if (inView) {
            $timeout(function() {
              $scope.table.visibleRows += $scope.config.incrementRows;
            }, 100);
          }
        } else {
          $scope.table.allRowsDisplayed = true;
        }
      };

      $scope.onSearchChange = function(idx, value) {
        if (!Modernizr.canvas) {
          if ($scope.searchChange) {
            $timeout.cancel($scope.searchChange);
          }
          $scope.searchChange = $timeout(function() {
            if ($scope.tableState.search && !angular.isDefined($scope.tableState.search.predicateObject)) {
              $scope.tableState.search.predicateObject = {};
            }
            $scope.tableState.search.predicateObject[idx] = value;
            $scope.configureTable($scope.tableState);
          }, 400);
        }
      };


      $scope.configureTable = function(tableState) {
        $scope.table.hasFilters = false;
        $scope.tableState = tableState;

        $scope.resetVisibleRowCount();

        if ($scope.tblData && $scope.tblData.rows) {
          var copyOfData = $scope.tblData.rows.slice();
          var filteredData = $scope.tblData.rows.slice();

          // Filtering.
          if (tableState.search.predicateObject) {
            filteredData = $filter('filter')(copyOfData, tableState.search.predicateObject);
          }

          // Sorting.
          if (tableState.sort.predicate) {
            filteredData = $filter('orderBy')(filteredData, tableState.sort.predicate, tableState.sort.reverse);
          }

          // Were all the filters cleared?
          for (var filterProperty in tableState.search.predicateObject) {
            if (tableState.search.predicateObject.hasOwnProperty(filterProperty)) {
              $scope.table.hasFilters = true;
              break;
            }
          }

          $scope.table.displayedCollection = filteredData;
          $scope.filteredData = filteredData;

          if ($scope.tblData.rows.length === 0) {
            $scope.table.noRows = true;
          } else {
            $scope.table.noRows = false;
          }

          if ($scope.allRowsAreDisplayed($scope.table.hasFilters)) {
            $scope.table.allRowsDisplayed = true;
            $scope.table.paginationNeeded = false;
          } else {
            $scope.table.paginationNeeded = true;
          }
        }
      };



    }
  ]);
'use strict';
angular.module('goApp')
  .directive('tablePages', ['hesTemplateService', function(hesTemplateService) {
    // Runs during compile
    return {
      scope: {
        leftIcon: '@',
        rightIcon: '@'
      },
      require: ['^tablePager'],
      restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
      templateUrl: hesTemplateService.getTemplateUrl('/scripts/tablePager/tablePager.html'),
      link: function($scope, $element, $attrs, controller) {
        var tablePagerController = controller[0];
        $scope = angular.extend($scope, tablePagerController);
      }
    };
  }])
  .directive('tablePager', ['hesTemplateService', function(hesTemplateService) {
    // Runs during compile
    return {
      scope: {
        data: '=',
        pageSize: '@',
        pagedData: '=',
        customFilter: '&filter',
        filterObject: '=?',
        page: '=?'
      },
      controller: 'TablePagerController',
      restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
      link: function($scope, $element, $attrs, controller) {
        if ($scope.filterObject) {
          $scope.$watch('filterObject', function() {
            controller.doFiltering();
          }, true);
        }
        $scope.$watch('data', function() {
          $scope.filteredData = $scope.data;
          controller.doFiltering();
        });

        $scope.$watch('page', function() {
          controller.setPagedData();
        }, true);
      }
    };
  }])
  .controller('TablePagerController', ['$scope',
    function($scope) {

      $scope.filteredData = $scope.filteredData || [];
      $scope.pageSize = $scope.pageSize || 8;

      this.doFiltering = function() {
        if (angular.isFunction($scope.customFilter())) {
          $scope.filteredData = $scope.customFilter()($scope.data);
        }

        $scope.page = 0;
        $scope.setPages();
      };

      this.getCurrentPage = function() {
        return $scope.page;
      };

      this.getPageSize = function() {
        return $scope.pageSize * 1;
      };

      $scope.getPageSize = this.getPageSize;

      this.isPaged = function() {
        return $scope.filteredData.length > $scope.getPageSize();
      };

      this.getPagedDataSize = function() {
        return $scope.pagedData.length;
      }

      this.getFilteredDataSize = function() {
        return $scope.filteredData.length;
      };

      $scope.setPages = function() {
        $scope.pagedData = $scope.filteredData.slice($scope.page * $scope.getPageSize(), $scope.page * $scope.getPageSize() + $scope.getPageSize());
      };

      this.hasMorePages = function() {
        return ($scope.page * $scope.getPageSize()) + $scope.getPageSize() < $scope.filteredData.length;
      };

      this.nextTeamsPage = function() {
        $scope.page++;
      };

      this.previousTeamsPage = function() {
        $scope.page--;
      };

      this.setPagedData = function() {
        $scope.pagedData = $scope.filteredData.slice($scope.page * $scope.getPageSize(), $scope.page * $scope.getPageSize() + $scope.getPageSize());
      };
    }
  ]);
'use strict';

angular.module('goApp').controller("TabsController", function($scope, $rootScope, $state, $location, $timeout, MainNavigation, FriendService) {
  $scope.data = {
    notificationState: null
  };
  $scope.navigation = new Object();

  setCurrentMenu();

  $scope.isActiveParent = function(menu) {
    // NOTE NP: no longer need this due to new tab system
    // if ($scope.navigation.current_menu.parentGroup().menus().length <= 1) {
    //   return false;
    // }

    return menu.link == $state.current.name || !!_.find(menu.childMenus, function(m) {
      return m.link == $state.current.name && m.active == true;
    });
  };

  $scope.clearAll = function() {
    $rootScope.clearAllNotifications();
  };

  $scope.hasChildren = function() {
    return $scope.navigation.current_menu && $scope.navigation.current_menu.parentGroup().id != $scope.navigation.current_menu.parent.id;
  };

  $scope.hasMoreThanOneChildren = function() {
    return $scope.navigation.current_menu.parent.childMenus.length > 1;
  };

  $scope.isSelected = function(menu) {
    return $state.href(menu.link, menu.params) == $location.path();
  };

  $scope.includes = function(menu) {
    return ($state.href($state.current.name, $state.params,{}).indexOf($state.href(menu.link, menu.params,{})) > -1) ||
           (menu.active_regex && menu.active_regex.test($state.href($state.current.name, $state.params,{}))); // `new Regex()` expression is throwing errors in IE
  };

  $scope.hasNotification = function() {
    if ($state.current.name == "go.u.usermenu.friends.list" || $state.current.name == "go.u.usermenu.friends.search") {
      FriendService.incomingRequests.get(true).then(function(data) {
        if (data.length > 0) {
          $scope.data.notificationState = "go.u.usermenu.friends.pending";
        }
      });
    } else {
      $scope.data.notificationState = null;
    }
  };

  $scope.$on('$stateChangeSuccess', setCurrentMenu);


  function setCurrentMenu() {
    MainNavigation.get().then(function(navigation){
      $scope.navigation.current_menu = navigation.findMenuByLink($state.current.name);
    });

    $timeout(function() {
      $scope.hasNotification();
    }, 0);
  }

});

'use strict';

angular.module('goApp')
	.controller('TermsController', ['$scope', '$q', 'CurrentSite', 'ContentLoader',
		function($scope, $q, CurrentSite, ContentLoader) {

			$scope.terms = [];

			// Get site first.
			$q.all([
				CurrentSite.get(),
			]).then(function() {
				new ContentLoader({
          site_id: $scope.site.id,
          category: 'terms'
        }).then(function(terms) {
        	$scope.terms = terms;
        });
			}, function() {
			});
		}
	]);
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.privacy_terms.terms', {
    title: 'Terms',
    url: '/terms',
    abstract: false,
    controller: 'TermsController',
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/terms/terms.html');
      }
    ]
  });
  
});




'use strict';

angular.module('hes.config')
  .service('DynamicCssService', ['THEMES',
    function(THEMES) {
      return function(theme) {
        return "styles/themes/" + theme + "/" + theme.toLowerCase() + ".css";
      };
    }
  ]);
'use strict';

angular.module('goApp')
  .controller('EditThemeController', ['$scope', 'theme', '$state',
    function($scope, theme, $state) {
      $scope.colorpickerSettings = {
        control: 'wheel',
        defaultValue: '',
        inline: false,
        letterCase: 'lowercase',
        opacity: false,
        position: 'bottom right',
        theme: 'default'
      };

      $scope.view = {
        saving: false
      };

      $scope.theme = theme;

      $scope.saveTheme = function() {
        $scope.view.saving = true;
        theme.save().finally(function() {
          $scope.view.saving = false;
        });
      };

      $scope.cancel = function() {
        theme.resetWorkingDataToBackup();
        $state.go('go.u.site', {
          siteId: $scope.dbSite.id
        });
      };

      $scope.resetThemeToDefaults = function() {
        theme.resetAllToDefaults();
      };

      $scope.resetVariableToDefaults = function(variableIndex) {
        theme.resetVariableToDefaults(variableIndex);
      };

      $scope.resetVariableToBackup = function(variableIndex) {
        theme.resetVariableToBackup(variableIndex);
      };

      $scope.isVariableUnsaved = function(variableIndex) {
        return theme.isVariableUnsaved(variableIndex);
      };

      $scope.isVariableNotDefault = function(variableIndex) {
        return theme.isVariableNotDefault(variableIndex);
      };
    }
  ]);
'use strict';

angular.module('hes.config')
	.service('hesTemplateService', ['$rootScope', '$q', '$templateFactory', '$templateCache', 'CurrentSite',
		function($rootScope, $q, $templateFactory, $templateCache, CurrentSite) {
			var templateService = {
				getTemplate: function(url) {
					return CurrentSite.get().then(function() {
						return $templateFactory.fromUrl(templateService.getTemplateUrl(url))
					}, function() {
						return $templateFactory.fromUrl(templateService.getTemplateUrl(url))
					});
				},

				getTemplateUrl: function(url) {
					var custom_url;

					if ('site' in $rootScope && 'customized_files' in $rootScope.site) {
						custom_url = $rootScope.site.customized_files[url];
					}

					return custom_url !== undefined ? custom_url : url;
				}
			};

			return templateService;
		}
	]);
angular
  .module('hes.constants')
  .constant('THEMES', [
    {key: "default",   value: "Default"}
  ]);
'use strict';

angular.module('hes')
  .factory('Theme', ['$q', '$http', 'DOMAIN', 'Site',
    function($q, $http, DOMAIN, Site) {
      /*
       * Variables cheat sheet
       *
       * previouslySavedRawData - data that came from the server, site's property css_config_json
       * defaultsData - data that came from theme's css-config.json file
       * backupData - defaultsData patched with previouslySavedRawData and combined into a working object (suitable for controller),
       *              backup is used to roll back current changes
       * workingData - clone of backupData, this model is actually used for controller to display ongoing changes,
       *
       * */

      function Theme(name, site) {
        var defer = $q.defer(),
          that = this;

        this.name = name;
        this.previouslySavedRawData = [];
        this.defaultsData = [];
        this.backupData = [];
        this.workingData = [];

        fetchDefaults(name).then(function(result) {
          that.defaultsData = result.data;
          that.init();
        });

        this.init = function() {
          this.previouslySavedRawData = site.css_config_json || {};
          patchSitesThemeConfig(this);
          this.resetWorkingDataToBackup();

          defer.resolve(this);
        };

        this.save = function() {
          var defer = $q.defer();
          var that = this;
          var cssConfigJson = _.cloneDeep(this.workingData);
          var savedData = [];

          angular.forEach(cssConfigJson, function(variable) {
            var defaultVariable = _.filter(that.defaultsData, {
              variable: variable.variable
            })[0];

            if (variable.value.toLowerCase() !== defaultVariable.value.toLowerCase()) {
              savedData.push({
                value: variable.value,
                variable: variable.variable
              });
            }
          });

          new Site({
            id: site.id,
            css_config_json: cssConfigJson
          }).save(function(result) {
            defer.resolve(result);
          }, function(error) {
            defer.reject(error);
          });

          this.backupData = _.cloneDeep(this.workingData);
          return defer.promise;
        };

        return defer.promise;
      }


      Theme.prototype.resetWorkingDataToBackup = function() {
        this.workingData = _.cloneDeep(this.backupData);
      };

      Theme.prototype.resetAllToDefaults = function() {
        this.workingData = _.cloneDeep(this.defaultsData);
      };

      Theme.prototype.resetVariableToDefaults = function(variableIndex) {
        this.workingData[variableIndex].value = this.defaultsData[variableIndex].value;
      };

      Theme.prototype.resetVariableToBackup = function(variableIndex) {
        this.workingData[variableIndex].value = this.backupData[variableIndex].value;
      };

      Theme.prototype.isVariableUnsaved = function(variableIndex) {
        return this.workingData[variableIndex].value.toLowerCase() !== this.backupData[variableIndex].value.toLowerCase();
      };

      Theme.prototype.isVariableNotDefault = function(variableIndex) {
        return this.workingData[variableIndex].value.toLowerCase() !== this.defaultsData[variableIndex].value.toLowerCase();
      };

      function fetchDefaults(themeName) {
        var port = location.port ? ':' + location.port : '';

        return $http.get('/styles/themes/' + themeName + '/css-config.json');
      }

      function patchSitesThemeConfig(theme) {
        theme.backupData = _.cloneDeep(theme.defaultsData);

        angular.forEach(theme.previouslySavedRawData, function(variableObj) {
          var variable = _.filter(theme.backupData, {
            variable: variableObj.variable
          });
          if (!!variable && variable.length > 0) {
            $.extend(variable[0], variableObj, {
              description: variable[0].description
            });
          }
        });
      }

      return Theme;
    }
  ]);
'use strict';

angular.module('goApp')

  .config(['$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('go.u.site.theme-edit', {
          url: '/theme-edit',
          controller: 'EditThemeController',
          background: 'filled',
          templateProvider: ['hesTemplateService',
            function(hesTemplateService) {
              return hesTemplateService.getTemplate('/scripts/themes/editTheme.html');
            }
          ],
          resolve: {
            /*theme: function(CurrentSite, Theme) {
              return CurrentSite.get()
                .then(function(site) {
                  return new Theme(site.theme, site);
                });
            }*/
            theme: ['SiteLoader', '$stateParams', 'CurrentSite', 'ThemesService',
              function(SiteLoader, $stateParams, CurrentSite, ThemesService) {

              return new SiteLoader({
                  siteId: $stateParams.siteId,
                })
                .then(function(site) {
                  return ThemesService.getTheme(site.theme, site)
                    .then(function(theme) {
                      return theme;
                    });
                });
            }]
          }
        });
    }
  ]);

'use strict';

angular.module('hes')
  .service('ThemesService', ['$q', 'Theme',
    function($q, Theme) {
      var themes = {};

      function getTheme(themeName, site) {
        var defer = $q.defer();

        if (!themeName || typeof themeName !== 'string') {
          defer.reject();
          console.error('Theme name must be a string');

          return defer.promise;
        }

        if (themes[themeName + site.id]) {
          defer.resolve(themes[themeName + site.id]);
        } else {
          new Theme(themeName, site)
            .then(function(theme) {
              themes[themeName + site.id] = theme;

              defer.resolve(themes[themeName + site.id]);
            });
        }

        return defer.promise;
      }

      return {
        getTheme: getTheme
      };
    }
  ]);
'use strict';
angular.module('goApp')
  .controller('AllTipsController',
    function($scope, TipService, ContentService, $anchorScroll, $timeout, $stateParams, $state, CurrentUser, $rootScope) {
      $scope.data = {
        limit: TipService.viewState.limit,
        filteredItems: [],
        selectedFilter: TipService.viewState.category,
        appliedSearch: TipService.viewState.search,
        search: TipService.viewState.search,
        allFilters: TipService.categoriesList
      };
      var noFavoritesMsg = ContentService.getContentByCategoryAndKey('tips', null, 'no_favorites_message').content_html;

      $scope.allTips = [];
      CurrentUser.get().then(function(user){

        
        var tip_date = moment(user.profile.started_on).subtract(1,'days').format("YYYY-MM-DD");
       
        var start_date = [
          moment(tip_date),
          ($rootScope.site.programs.past[0] && (moment($rootScope.site.programs.past[0].ends_on).add(0,'days'))),
          (!$rootScope.site.programs.past[0] && $rootScope.site.programs.current[0] && (moment($rootScope.site.programs.current[0].ends_on).add(0,'days')))
        ];


        start_date = _.max(_.compact(start_date));


        TipService.getTips(start_date).then(function(tips) {
          console.log(tips);
          $scope.allTips = tips;
        });
        TipService.getFavorites(user.id).then(function(favorites) {
          $scope.data.hasFavorites = favorites.length > 0;
        });
      });

      $scope.applySearch = function(value) {
        $scope.data.limit = TipService.viewState.increment;
        $scope.data.appliedSearch = value;
        TipService.viewState.search = value;
        $scope.$state.go('go.u.content.tips.all', TipService.viewState, {
          notify: false,
          location: true
        });
      };

      $scope.showMore = function() {
        $scope.data.limit += TipService.viewState.increment;
      }

      $scope.searchFilterMessage = function() {
        var message = 'Displaying ';
        var category = "";
        var search = "";
        if ($scope.selectedFilter != 'all') {
          category = $scope.data.selectedFilter + ' ';
        }
        if ($scope.data.appliedSearch) {
          if (!!category) {
            search += " and ";
          }
          search += $scope.data.appliedSearch + " results";
        }
        return (!!category || !!search) ? (message + category + search) : '';
      };

      $scope.searchEmptyMessage = function() {
        // var message = 'There are no tips in "' + _.filter($scope.data.allFilters, {
        //   key: $scope.data.selectedFilter
        // })[0].display + '"';
        var message = new String();
        if (!!$scope.data.appliedSearch) {
          if ($scope.data.selectedFilter != 'all') {
            message += 'No tips found in '+ _.startCase($scope.data.selectedFilter) +',';
            var all_tips_link = $scope.$state.href('go.u.content.tips.all', {category:'all', search: $scope.data.appliedSearch}, {absolute: false});
            message += ' would you like to search in <a class="underline" href="'+ all_tips_link +'">all tips</a>?';
          } else {
            message = "Oops, we don't have any tips matching your search."
          }
        } else if ($scope.data.selectedFilter === 'favorites') {
          message = noFavoritesMsg || 'Once you like a tip it will show up under favorites.';
        }

        return message;
      };

      if ((!!$stateParams.category ||
          !!$stateParams.search)) {
        var scrollTo = $scope.$state.params.previousStateParams.id;
        if (!!scrollTo) {
          $timeout(function() {
            $anchorScroll(scrollTo);
          });
        }
      }

      $scope.$watch('data.selectedFilter', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          TipService.viewState.category = newVal;
          $timeout(function() {
            $scope.$state.go('go.u.content.tips.all', TipService.viewState, {
              notify: false,
              location: true
            });
          });
        }
      });

      $scope.$on('$stateChangeStart', function() {
        TipService.viewState.category = $scope.data.selectedFilter;
        TipService.viewState.limit = $scope.data.limit;
        TipService.viewState.search = $scope.data.appliedSearch;
        TipService.viewState.fromList = true;
      });

      // Sets the url parameter so if a user clicks a tip, they will be brought back to where they are in the
      // list, even if they didn't do any searching
      // Only gets triggered when the user on initial load
      $scope.$state.go('go.u.content.tips.all', TipService.viewState, {
        notify: false,
        location: true
      });
    });
angular.module('goApp')
  .filter('tipCategoryFilter', function(TipService) {
    function tipCategoryFilter(tips, category) {
      var results = tips;

      if (category == 'favorites') {
        results = _.filter(tips, function(tip, idx) {
          return TipService._favorites.indexOf(tip.id) !== -1;
        });
      }

      return results;
    }

    return tipCategoryFilter;
  });
angular.module('goApp')
  .filter('tipSearchFilter', function() {
    function tipCategoryFilter(tips, searchString) {
      var results = tips;

      if (!!searchString) {
        var searchLowered = searchString.toLowerCase();      
        results = _.filter(tips, function(tip, idx) {
          // Check title, description, ingredients and health category
          if (tip.title.toLowerCase().indexOf(searchLowered) > -1
            || tip.content_html.toLowerCase().indexOf(searchLowered) > -1) {
            return true;
          }
          return false;
        });
      }

      return results;
    }

    return tipCategoryFilter;
  });
'use strict';

angular.module('goApp')
  .controller('TipController', function($scope, ngDialog, Tip, TipService, $state, $stateParams, CurrentUser, WallFactory, $anchorScroll, Daily) {
    $scope.received_favorite = false;
    $scope.settings = {
      savingRating: false,
      savedRating: false,
      share_content: '',
      saving: false,
      share_saved: false,
      noComment: false,
      showBreadcrumb: TipService.viewState.fromList && $state.current.name !== 'go.u.content.tips.today',
      crumbs: [{
        state: 'go.u.content.tips.all('+ JSON.stringify(TipService.viewState) + ')',
        display: 'Tips'
      }],
      tipWall: {}
    };

    var tip = null;
    if ($state.current.name == "go.u.content.tips.today") {
      Daily.get().then(function(data){
        tip = data.tip;
        $scope.showTip(tip);
        $scope.settings.crumbs.push( {
          state: $state.current.name,
          display: (tip && tip.title)
        });
      });
    } else { // otherwise its a single tip
      CurrentUser.get().then(function(user){

        function showBrokenTip() {
          $scope.show_broken_tip = true;
          $scope.settings.showBreadcrumb = true;
          $scope.settings.crumbs.push( {
            state: $state.current.name,
            display: "Not found"
          })
        };

        TipService.getTip($stateParams.id).then(function(tip){
          if (tip.id && tip.days_from_start <= $scope.site.days_from_start) {
            $scope.showTip(tip);
            $scope.settings.crumbs.push( {
              state: $state.current.name,
              display: (tip && tip.title)
            });
          } else {
            showBrokenTip();
          }
        }, function(){
          showBrokenTip();
        });
      });
    }

    $scope.showTip = function(tip) {
      $scope.tip = new Tip(tip);
      $scope.tip.getLike();
      tip['class'] = 'CustomContent';
      $scope.settings.tipWall = new WallFactory($scope.tip, {
        page_size: 0
      });

      $scope.settings.tipWall.load();

      CurrentUser.get().then(function() {
        if ($scope.user) {
          var stateParams = angular.copy($stateParams);

          $scope.recentlyViewedCollection = TipService.getRecentlyViewedCollection($scope.user.id);
          $scope.recentlyViewedCollection.addItem({
            state: $state.current.name,
            stateParams: stateParams,
            id: $scope.tip.id
          });
        }
      });
    };

    $scope.scrollToComments = function(){
      $anchorScroll("tip_comments");
    };


    // //TODO Start:  Move to ShareDial
    // $scope.postToWall = function(tip) {
    //   $scope.resource = tip;
    //   $scope.settings.resourceType = 'tip';
    //   $scope.settings.share_content = '';
    //   ngDialog.open({
    //     template: '/scripts/wall/sharing-resource.html',
    //     scope: $scope,
    //     className: 'ngdialog-theme-default shared_resource',
    //     showClose: false
    //   });
    // };

    // $scope.shareToWall = function(tip) {
    //   $scope.settings.saving = true;
    //   if ($scope.settings.share_content != '') {
    //     var share = new Post({
    //       content: $scope.settings.share_content,
    //       postable_type: 'Tip',
    //       postable_id: tip.id
    //     });
    //     share.save(function(shared_tip) {
    //       $scope.settings.share_saved = true;
    //       $scope.settings.saving = false;
    //       $scope.settings.noComment = false;
    //       $scope.settings.share_content = '';
    //     }, function(error) {
    //       $scope.settings.saving = false;
    //     });
    //   } else {
    //     $scope.settings.saving = false;
    //     $scope.settings.noComment = true;
    //   }
    // };

    // $scope.closeDialog = function() {
    //   $scope.settings.noComment = false;
    //   ngDialog.closeAll();
    // };
    // //TODO End:  Move to ShareDial

    $scope.getCurrentCourse = function() {
      return TipService.courses.getCurrent();
    };

    
  });
'use strict';

angular.module('goApp')
  .service('TipService', function(HesDate, Tip, $q, hesLocalStorageCollectionService, hesEventHandlerService, $filter, Content, $rootScope) {
    var TipService = {
      _tips: null,
      _daily: null,
      viewState: {
        category: 'all',
        search: '',
        limit: 20,
        increment: 20,
        fromList: false
      },
      categoriesList: [{
        key: 'all',
        display: 'All Tips'
      }, {
        key: 'favorites',
        display: 'Favorites'
      }],
      setDefaults: function() {
        TipService.viewState.category = 'all';
        TipService.viewState.search = '';
        TipService.viewState.limit = 20;
        TipService.viewState.increment = 20;
        TipService.viewState.fromList = false;
      },
      getRecentlyViewedCollection: function(userId) {
        return hesLocalStorageCollectionService.getCollection({
          name: 'tips',
          localStorageItemName: 'recentlyViewedKaaTips' + userId,
          limit: 8
        });
      },

      getFavorites: function(user_id) {
        var promise = Tip.favorites(user_id).$promise;

        promise.then(function(favorites) {
          TipService._favorites = favorites;
        }, function() {
          TipService._favorites = [];
        });

        return promise;
      },

      getDaily: function(start_date) {
        var defer = $q.defer();

        if(!TipService._daily) {
          TipService.getTips(start_date)
            .then(function(tips) {
              TipService._daily = $filter('orderBy')(tips, '-days_from_start')[0];
              defer.resolve(TipService._daily);
            }, function(error) {
              defer.reject('Daily tip could not be found', error);
            });
        } else {
          defer.resolve(TipService._daily);
        }
        return defer.promise;
      },

      getTips: function(start_date) {
        if (TipService._tips === null && !TipService.defer) {
          TipService.defer = $q.defer();
          Tip.index({
            category: 'tips',
            page_size: 0
          }, function(tips) {
            TipService._tips = _.filter(tips, function(tip){
              return Date.parse(tip.date) >= Date.parse(start_date || new Date());
            });
            TipService.defer.resolve(TipService._tips);
          }, function() {
            TipService.defer.reject('Tips could not be found');
            //Set to null so we'll try again
            TipService.defer = null;
          });
        } else if (!!TipService._tips) {
          TipService.defer.resolve(TipService._tips);
        }

        return TipService.defer.promise;
      },

      getTip: function(tipId, force) {
        var defer = $q.defer();
        if (TipService._tips === null || force) {
          Tip.show({
            id: tipId
          }, function(tip) {
            defer.resolve(tip);
          }, function() {
            defer.reject('Tip could not be found');
          });
        } else {
          var tip = $filter('filter')(TipService._tips, {
            id: tipId * 1
          }, true)[0];
          if (!!tip) {
            defer.resolve(tip);
          } else {
            TipService.getTip(tipId, true).then(function(tip) {
              defer.resolve(tip);
            }, function() {
              defer.reject('Tip could not be found');
            });
          }
        }

        return defer.promise;
      }
    };

    TipService.flush = function() {
      TipService._tips = null;
      TipService._daily = null;
    }

    $rootScope.$on('userLoggedOut',function(ev,data){
      TipService.flush();
    });

    return TipService;
  });
'use strict';

angular.module('goApp')
  .factory('Tip', function(ActiveResource, User, DOMAIN, $http, $state, $q) {
    var Tip = ActiveResource('/custom_content/:id', {
      domain: DOMAIN,
      category: "tips"
    }, {
      usersLike: {
        url: '/user_like',
        method: 'GET',
        isArray: false
      },
      like: {
        url: '/user_like',
        method: 'POST'
      },
      unlike: {
        url: '/user_like',
        method: 'DELETE'
      }
    });

    Tip.shared = function(params) {
      // Keeping /tips/ because it's the shareable type
      return $http.post(DOMAIN + '/tips/' + params.id + '/shares?via=' + params.media);
    };

    Tip.prototype.getFullUrl = function() {
      return $state.href('go.u.tips.all.tip', {
        id: this.id
      }, {
        absolute: true
      });
    };
    
    Tip.prototype.getDescription = function() {
      return this.summary_html;
    };

    Tip.prototype.toggleFavorite = function() {
      if (this.favorited) {
        this.favorited = false;
        this.removeLike();
      } else {
        this.favorited = true;
        this.like();
      }
    };

    Tip.prototype.like = function() {
      var that = this;
      return Tip.like({
          id: this.id
        }).$promise
        .then(function(response) {
          that.favorited = true;
        });
    };

    Tip.prototype.removeLike = function() {
      var that = this;
      return Tip.unlike({
          id: this.id
        }).$promise
        .then(function(response) {
          that.favorited = false;
        });
    };

    Tip.prototype.getLike = function() {
      var that = this;
      if (this.favorited === undefined) {
        return Tip.usersLike({
            id: this.id
          }).$promise
          .then(function(response) {
            that.favorited = response;
          }, function(response) {
            that.favorited = false;
          });
      }
    };

    Tip.setOrder = function(sequence, promotionId, successCallback, errorCallback) {
      $http.post(DOMAIN + '/promotions/' + promotionId + '/tips/reorder', {
        sequence: sequence
      }).then(successCallback)['catch'](errorCallback);
    };

    Tip.favorites = function(user_id) {
      return User.custom_content_likes({
        id: user_id,
        category: "tips"
      });
    };

    return Tip;
  });
'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.u.content.tips', {
    abstract: true,
    template: '<ui-view></ui-view>'
  });

  $stateProvider.state('go.u.content.tips.today', {
    url: "/tips/today",
    title: "Today's Tip",
    controller: "TipController",
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/tips/views/tip.html');
      }
    ],
  });

  $stateProvider.state('go.u.content.tips.all', {
    url: "/tips/all?:category:search",
    title: "All Tips",
    controller: "AllTipsController",
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/tips/views/tips.html');
      }
    ],
    onEnter: function($stateParams, TipService) {
      if (!$stateParams.category &&
        !$stateParams.search) {
        TipService.setDefaults();
      } else {
        TipService.viewState.category = $stateParams.category || TipService.viewState.category;
        TipService.viewState.search = $stateParams.search;
      }
    },
    params: {
      search: null,
      category: null
    }
  });

  $stateProvider.state('go.u.content.tips.single', {
    url: "/tip/:id",
    title: "Tip",
    controller: "TipController",
    focusFirst: true,
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/tips/views/tip.html');
      }
    ]
  });

});
'use strict';

angular.module('goApp')
  .component('hesUserTotalSteps', {
    bindings: {
      user: '<',
      year: '<'
    },
    templateUrl: '/scripts/totalSteps/total-steps.html',
    controller: function($scope, CurrentUser, User, ExportService) {
      var ctrl = this;

      ctrl.view = {
        totalSteps: 0
      };

      ctrl.exportEntries = ExportService.exportEntries;

      function getStats() {
        User.stats({
          user_id: ctrl.user.id,
          year: ctrl.year //$state.params.year
        }).$promise.then(function(stats) {
          ctrl.view.totalSteps = stats.total_steps;
        }, function(err) {
          console.log("failed to fetch stats for user#" + ctrl.user.id);
        });
      }

      // ctrl.$onInit = function() {
      //   getStats();
      // };

      ctrl.$onChanges = function(changesObj) {
        if (!!changesObj.year) {
          getStats();
        }
      }

      $scope.$on("EntryUpdated", function(e, data) {
        getStats();
      });
    }
  });
'use strict';

angular.module('goApp')
    .factory('Unsubscribe', ['ActiveResource', 'DOMAIN', 'HesDate',
    function(ActiveResource, DOMAIN, HesDate) {

      var Unsubscribe = ActiveResource('/unsubscribe', {
        domain: DOMAIN
      });

      return Unsubscribe;
    }
  ])
  .controller('UnsubscribeController', ['$scope', '$state', 'CurrentSite', 'Content', 'Unsubscribe', 'ErrorService', '$timeout', 'ContentLoader',
    function($scope, $state, CurrentSite, Content, Unsubscribe, ErrorService, $timeout, ContentLoader) {

      $scope.setup = {
        content: null, 
        unsubscribed: false,
        loading: true
      };


      CurrentSite.get().then(function(site) {
        new ContentLoader({
          category: 'unsubscribe',
          site_id: site.id
        }).then(function(contents) {
          $scope.setup.content = Content.getByKey(contents, 'unsubscribed', true);
        });
        if($state.params.email){
          new Unsubscribe({
            email: encodeURIComponent($state.params.email),
            site_id: site.id
          }).create(function(response){
            $scope.setup.unsubscribed = true;
            $scope.setup.loading = false;
          }, function(errors){
            ErrorService.showPriorityErrors(errors, 'A failure occurred while trying to unsubscribe.', 1);
            $scope.setup.loading = false;
          });
        } else {
          $scope.setup.loading = false;
        }
      });
    }
  ]);
'use strict';

angular.module('goApp')

.config(['$stateProvider', '$urlMatcherFactoryProvider', '$urlRouterProvider',
  function($stateProvider, $urlMatcherFactoryProvider, $urlRouterProvider) {

    function valToString(val) {
      return val !== null ? val.toString() : val;
    }

    $urlMatcherFactoryProvider.type('nonURIEncoded', {
      performsAllNeededUriEncoding: false,
      encode: valToString,
      decode: valToString,
      // squash: true,
      // encode: function(val) {
      //   return encodeURI(val);
      // },
      // decode: function(val) {
      //   return encodeURI(val);
      // },
      is: function() {
        return true;
      }
    });


    $urlRouterProvider.rule(function($injector, $location) {
      var path = $location.path();

        if($location.url().indexOf('/unsubscribe/')  !== -1){
          return '/unsubscribe?email=' + encodeURIComponent(path.replace('/unsubscribe/',''));
        }
    });

    $stateProvider
      .state('go.unsubscribe', {
        url: '/unsubscribe?email',
        title: 'Unsubscribe',
        controller: 'UnsubscribeController',
        abstract: false,
        background: 'filled',
        templateProvider: ['hesTemplateService',
          function(hesTemplateService) {
            return hesTemplateService.getTemplate('/scripts/unsubscribe/unsubscribe.html');
          }
        ],
      });
  }
]);
angular.module('goApp')
  .directive('fileDropzone', function() {
    return {
      restrict: 'A',
      scope: {
        file: '=',
        fileName: '='
      },
      link: function(scope, element, attrs) {
        var checkSize,
          isTypeValid,
          processDragOverOrEnter,
          validMimeTypes;

        processDragOverOrEnter = function(event) {
          if (event != null) {
            event.preventDefault();
          }
          event.dataTransfer.effectAllowed = 'copy';
          return false;
        };

        validMimeTypes = attrs.fileDropzone;

        checkSize = function(size) {
          var _ref;
          if (((_ref = attrs.maxFileSize) === (void 0) || _ref === '') || (size / 1024) / 1024 < attrs.maxFileSize) {
            return true;
          } else {
            alert("File must be smaller than " + attrs.maxFileSize + " MB");
            return false;
          }
        };

        isTypeValid = function(type) {
          if ((validMimeTypes === (void 0) || validMimeTypes === '') || validMimeTypes.indexOf(type) > -1) {
            return true;
          } else {
            alert("Invalid file type.  File must be one of following types " + validMimeTypes);
            return false;
          }
        };

        element.bind('dragover', processDragOverOrEnter);
        element.bind('dragenter', processDragOverOrEnter);

        return element.bind('drop', function(event) {
          var file, name, reader, size, type;
          if (event != null) {
            event.preventDefault();
          }
          reader = new FileReader();
          reader.onload = function(evt) {
            if (checkSize(size) && isTypeValid(type)) {
              return scope.$apply(function() {
                scope.file = evt.target.result;
                if (angular.isString(scope.fileName)) {
                  return scope.fileName = name;
                }
              });
            }
          };
          file = event.dataTransfer.files[0];
          name = file.name;
          type = file.type;
          size = file.size;
          reader.readAsDataURL(file);
          return false;
        });
      }
    };
  })


  .directive("fileread", [function() {
    return {
      scope: {
        fileread: "="
      },
      link: function(scope, element, attributes) {
        element.bind("change", function(changeEvent) {
          var reader = new FileReader();
          reader.onload = function(loadEvent) {
            scope.$apply(function() {
              scope.fileread = loadEvent.target.result;
            });
          }
          reader.readAsDataURL(changeEvent.target.files[0]);
        });
      }
    }
  }]);
'use strict';

angular.module('hes')
  .directive('hesFileUpload',
    function(hesTemplateService, Utils, $compile, $http, $templateCache) {
      var uploadIds = 1;
      return {
        priority: 3,
        scope: {
          label: '@',
          labelImage: '@',
          webFont: '@',
          showThumnbnail: '@',
          hidePreCrop: '@',
          useCloud: '=',
          showDragDrop: '=allowDrop',
          ngModel: '=',
          showThumbnail: '=',
          thumbnailUrl: '=?',
          onStart: '&?start',
          onComplete: '&?complete',
          onFailure: '&?failure',
          onCancel: '&?cancel',
          imageClass: '@?',
          placeHolder: '@?',
          useDomain: '@',
          aspectRatio: '@',
          resizeWidth: '@?',
          resizeHeight: '@?',
          noCenter: '@?',
          useUrl: "@?",
          alias: "@?",
          noResize: "@?",
          screenReaderLabel: "@",
          disablePopup: "=",
        },
        controller: 'HesFileUpload',
        require: ['ngModel', 'hesFileUpload'],
        templateUrl: hesTemplateService.getTemplateUrl('/scripts/upload/fileUpload.html'),
        replace: true,
        link: function($scope, $element, $attrs, controller) {

          $scope.uploadId = uploadIds++;
          if ($attrs.label) {
            $scope.label = $attrs.label;
          } else {
            $scope.label = "Choose File";
          }

          $scope.ariaClickLabel = function(event) {
            $scope.dragAndDrop = true;
            if (event.keyCode == 13 || event.keyCode == 32) {
              window.setTimeout(function() {
                $(event.currentTarget.parentNode.parentNode.querySelector('input')).click();
              }, 0);
          }
          }

          $scope.dragAndDrop = false;

          if (typeof $attrs.template !== 'undefined') {
            var content = '';
            $attrs.$observe('template', function(value) {
              $http.get(value, {
                cache: $templateCache
              }).then(function(template) {
                content = $compile(template.data)($scope);
                $element.html(content);
              });
            });
          }

          if (angular.isDefined($attrs.showCropper)) {
            $scope.showCropper = true;
          }

          if ($scope.useUrl && $scope.useUrl !== '') {
            $scope.setUrl($scope.useUrl);
            $scope.$watch('useUrl', function() {
              $scope.setUrl($scope.useUrl);
              $scope.setupUploader();
            });
          }

          if (angular.isDefined($attrs.allowAnyType)) {
            $scope.allowAnyType = true;
          }

          if (angular.isDefined($attrs.allowCsvType)) {
            $scope.allowCsvType = true;
          }

          if (angular.isDefined($attrs.allowAnySize)) {
            $scope.allowAnySize = true;
          }

          if (angular.isDefined($attrs.isSecure)) {
            $scope.isSecure = true;
            $scope.options.formData['secure'] = true;
          }

          if (angular.isDefined($attrs.useCloud)) {
            $scope.options.formData['use_cloud'] = true;
          }

          if (angular.isDefined($attrs.isGallery)) {
            $scope.isGallery = true;
          }

          if (angular.isDefined($attrs.showRemove)) {
            $scope.showRemove = true;
          }

          if (!angular.isDefined($scope.imageClass)) {
            $scope.imageClass = 'md-img-rect';
          }

          if (typeof $scope.noResize !== 'undefined' && $scope.noResize === 'true') {
            // Not going to resize this file.
          } else {
            var width = 500;
            var height = 500;
            if ($scope.resizeWidth) {
              width = $scope.resizeWidth;
            }

            if ($scope.resizeHeight) {
              height = $scope.resizeHeight;
            }

            $scope.options.formData['resize_to_fit'] = [width, height];
          }

          $scope.useImage = !(Utils.isUndefinedOrNull($scope.labelImage) || $scope.labelImage === '');
          $scope.useWebFont = !(Utils.isUndefinedOrNull($scope.webFont) || $scope.webFont === '');

          $scope.showLink = $attrs.hasOwnProperty('showLink');

          $scope.setupUploader();


        }
      };
    })
  .controller('HesFileUpload', function($rootScope, $scope, DOMAIN, FileUploader, Utils, ipCookie, DialogService, $timeout, PhotoUploadService) {

    $scope.useImage = !(Utils.isUndefinedOrNull($scope.labelImage) || $scope.labelImage === '');
    $scope.useWebFont = !(Utils.isUndefinedOrNull($scope.webFont) || $scope.webFont === '');
    var path = ($rootScope.user && $rootScope.user.isMaster()) ? "/files/master_upload" : "/files/upload"; // master_upload can handle files larger than 5mb upto 200mb

    $scope.options = {
      url: DOMAIN + path,
      autoUpload: false,
      formData: {}
    };
    $scope.setup = {
      uploader: new FileUploader($scope.options),
      previewUrl: ($scope.useDomain != 'false' && (!!$scope.thumbnailUrl && !$scope.placeHolder) ? DOMAIN : '') + ($scope.thumbnailUrl || $scope.placeHolder || '')
    };

    if (!Utils.isUndefinedOrNull($scope.ngModel) && !Utils.isUndefinedOrNull($scope.ngModel.url)) {
      $scope.setup.previewUrl = $scope.ngModel.url;
    }

    function updatePreview() {
      $scope.dragAndDrop = false;
      if (!Utils.isUndefinedOrNull($scope.ngModel) && !Utils.isUndefinedOrNull($scope.ngModel.url)) {
        $scope.setup.previewUrl = $scope.ngModel.url;
      } else if (!Utils.isUndefinedOrNull($scope.ngModel) && angular.isString($scope.ngModel)) {
        if (!$scope.showCropper) {
          $scope.setup.previewUrl = $scope.ngModel !== '' ? ($scope.useDomain != 'false' ? DOMAIN : '') + $scope.ngModel : $scope.ngModel;
        }
      }
    }

    $scope.$watch('ngModel', updatePreview);

    $scope.isOldManIE = !$scope.setup.uploader.isHTML5 || !Modernizr.canvas;

    $scope.setUrl = function(url) {
      $scope.options.url = DOMAIN + url;
    };

    $scope.removeImage = function() {
      DialogService.openConfirmationDialog('Remove Image', 'Remove this image? (You still need to save)', 'Cancel', 'Remove')
        .then(function() {
          $scope.ngModel = null;
          $scope.setup.previewUrl = '';
        });
    };

    $scope.setupUploader = function() {
      // $scope.setup.uploader = new FileUploader($scope.options);
      // $scope.setup.previewUrl = $scope.useDomain ? DOMAIN : '' + ($scope.thumbnailUrl || $scope.placeHolder || '');
      $scope.setup.uploader.onAfterAddingFile = function(fileItem) {
        if (fileItem) {
          var file = fileItem.file;
          var uploadErrors = [];
          $scope.uploadErrors = [];
          var acceptFileTypes = /^(like|image)\/(gif|jpe?g|png|svg|vtt.*?)$/i;
          var extensionTypes = /.*\.(gif|jpe?g|png|svg|vtt.*?)$/i;
          var csvType = /^text\/csv$/i;
          var csvExtension = /\.(csv)$/i;
          var specialCharsRegex = /[^a-zA-Z0-9_\-.]/;


          if (!$scope.allowAnyType && !$scope.allowCsvType && file['type'] !== undefined && file['type'].length && !acceptFileTypes.test(file['type'])) {
            uploadErrors.push('Sorry… this is the incorrect file type. Your image needs to be a .png, .jpeg, .jpg, or .gif.');
          } else if (!$scope.allowAnyType && !$scope.allowCsvType && !extensionTypes.test(file['name'])) {
            uploadErrors.push('Sorry… this is the incorrect file type. Your image needs to be a .png, .jpeg, .jpg, or .gif.');
          }

          //4.25 MB Limit but we'll say it's 4 MB
          if (!$scope.allowAnySize && file['size'] !== undefined && file['size'] > 4250000) {
            uploadErrors.push('File size must be 4 MB or less');
          }

          if (!$scope.allowAnyType && $scope.allowCsvType) {
            if (file['type'] !== undefined && file['type'].length && !csvType.test(file['type'])) {
              uploadErrors.push('Sorry… this is the incorrect file type. Your file needs to be a .csv.');
            } else if (!csvExtension.test(file['name'])) {
              uploadErrors.push('Sorry… this is the incorrect file type.Your file needs to be a .csv.');
            }

            var fileName = file['name'];
            if (specialCharsRegex.test(fileName)) {
              uploadErrors.push('Sorry… your file name contains special characters. Only letters, numbers, underscore, dash, and dot are allowed');
            }
          }

          if (uploadErrors.length > 0) {
            $scope.uploadErrors = uploadErrors;
            var errorMessage = 'Please correct the following error' + (uploadErrors.length > 1 ? 's' : '') + ':<br/> <ul>';
            _.forEach(uploadErrors, function(message, idx) {
              errorMessage += '<li>' + message + '</li>';
            });
            errorMessage += '</ul>';
            DialogService.openInformationDialog("Error", uploadErrors[0], "OK");
          } else {

            fileItem.headers = {
              Authorization: ipCookie('basic')
            };

            fileItem.url = $scope.options.url;
            if ($scope.isGallery) {
              fileItem.url += fileItem.file.name;
            }
            fileItem.alias = $scope.alias || 'file';
            fileItem.formData = [$scope.options.formData];
            fileItem.onBeforeUpload = function() {
              if (angular.isFunction($scope.onStart)) {
                $scope.onStart({
                  fileItem: fileItem
                });
              }
              $scope.setup.uploadingDialog = DialogService.openUploadingDialog("Uploading...");
            };
            fileItem.upload($scope.options);
            fileItem.onSuccess = function(data, status, headers, config) {
              $scope.uploading = false;
              $timeout(function() {
                $scope.setup.uploadingDialog.close();
              }, 250);

              if (data.files) {
                if (!$scope.showCropper) {
                  $scope.ngModel = data.files[0].url;
                  $scope.setup.previewUrl = ($scope.useDomain != 'false' ? DOMAIN : '') + $scope.ngModel;
                }
              }

              function doComplete(imageUrl) {
                if (angular.isFunction($scope.onComplete)) {
                  var onComplete = $scope.onComplete({
                    imageUrl: imageUrl
                  });
                  if (angular.isFunction(onComplete)) {
                    onComplete(data, fileItem);
                  }
                }
              }

              if ($scope.showCropper) {
                $timeout(function() {
                PhotoUploadService.showPhotoCroppingDialog({
                    aspectRatio: $scope.aspectRatio || 1,
                    uploaded: true,
                    uploadingPhoto: false,
                    uploadedPhoto: data.files[0].url,
                    saveButtonLabel: 'Crop'
                  }, $scope.onCancel)
                  .then(function(imageUrl) {
                    $scope.ngModel = imageUrl;
                    $scope.setup.previewUrl = $scope.ngModel !== '' ? ($scope.useDomain != 'false' ? DOMAIN : '') + $scope.ngModel : $scope.ngModel;
                    doComplete(imageUrl);
                    // $scope.$apply();
                  });
                }, 500)
              } else {
                if (data.files) {
                  doComplete(data.files[0].url);
                } else {
                  doComplete("");
                }
              }

              $scope.$apply();
            };

            fileItem.onError = function(response, status, headers) {
              $scope.setup.uploadingDialog.close();
              if (angular.isFunction($scope.onFailure)) {
                onFailure(response, status, headers, this);
              }

              DialogService.openInformationDialog("Unexpected Error", "Oops, something went wrong while uploading your file.", "OK");
            };

            fileItem.overrideWarnings = function() {
              this.url += "?override_warnings=true";
              this.upload($scope.options);
            };
          };
        }
      };
    };

  });
angular.module('goApp')

.directive('hesUploadImage', ['hesTemplateService', 'ngDialog',
    function(hesTemplateService, ngDialog) {

      return {
        restrict: 'A',
        templateUrl: hesTemplateService.getTemplateUrl('/scripts/upload/hesUploadImage.html'),
        controller: 'HesUploadImageController',
        // controller: '@',
        // name: 'controllerName',
        // scope: false,
        scope: {
          selectedPhoto: '=',
          title: '@dialogTitle',
          message: '@'
        },
        // replace: true,

        link: function($scope, $element, $attrs) {
          //$attrs.use options are
          //profilePhoto - used to upload and change the user's profile photo. Includes cropping. - Pages: Settings, Prestart
          //wall - used to upload an entire photo to the wall - Pages: Wall
          //teamProfile - used to upload a team's photo. Includes cropping. - Pages: Team
          //team - used to upload a photo to the team photo collection. - Pages: Team

          $scope.contents = {
            title: null,
            message: null
          };

          $scope.showCropper = false;
          if ($attrs.use == 'profilePhoto' || $attrs.use == 'teamProfilePhoto') {
            $scope.contents.title = 'UPLOAD PHOTO';
            $scope.contents.message = 'To crop your photo, drag the corners of the selection box below and then click "Set Profile Photo" when you are done.';
            $scope.showCropper = true;
          }

          if ($attrs.hasOwnProperty('crop')) {
            $scope.showCropper = true;
            if ($attrs.crop === "rect") {
              $scope.config.cropType = 'rect';
            } else if ($attrs.crop === 'circle') {
              $scope.config.cropType = 'circle';
            } else {
              $scope.message = 'You may crop the image by selecting an area or click save to use the image.';
            }
          }

          //TODO: watch selected Photo

        }
      };
    }
  ])
  .controller('HesUploadImageController', ['$scope', 'ngDialog',
    function($scope, ngDialog) {

      $scope.config = {
        photoSaving: false,
        photoSaved: false,
        photoSaveMsg: '',
        photoSaveError: false,
        photoNotCropped: null,
        uploaded: false,
        uploadingPhoto: false,
        cropType: "generic",
        inOutOptions: {
          duration: 0.75
        },
        tempPhoto: null
      };

      $scope.uploadPhotoStart = function() {
        $scope.config.uploaded = false;
        $scope.config.uploadingPhoto = true;
        $scope.config.tempPhoto = null;
      };

      $scope.uploadPhotoFinished = function() {
        $scope.openDialog();
        $scope.config.uploaded = true;
        $scope.config.uploadingPhoto = false;
        if ($scope.showCropper) {
          $scope.config.photoNotCropped = $scope.config.tempPhoto;
        }
      };

      $scope.confirmUsePhoto = function() {
        $scope.selectedPhoto = $scope.config.tempPhoto;
      };

      $scope.hasImage = function() {
        return $scope.selectedPhoto;
      };

      $scope.hasDefaultImage = function() {
        if ($scope.hasImage() && $scope.selectedPhoto.hasOwnProperty('url')) {
          var url_string = $scope.selectedPhoto.url;
          return url_string.indexOf('default.png') > -1;
        } else {
          return false;
        }
      };

      $scope.openDialog = function() {
        ngDialog.openConfirm({
          template: '/scripts/upload/hesUploadImageDialog.html',
          scope: $scope
        }).then(function() {
          $scope.selectedPhoto = $scope.config.tempPhoto;
        });
      };

    }
  ]);
'use strict';

angular.module('goApp')

  .factory('CurrentUser',
    function($rootScope, $http, ipCookie, $q, User, CurrentSite, ImpersonateService, $location, $timeout, $state, $interval) {
      var CurrentUser = {
        queued: false,
        queuedPromise: null,
      };

      CurrentUser.get = function(forceRefresh) {
        var defer = $q.defer();
        var promise = defer.promise;

        // Either use the existing current user, grab it from the database, or reject the promise.
        if ($rootScope.user) {

          // Return the existing current user or request a new one if forced.
          if (forceRefresh) {
            User.show({
              id: 'me'
            }, function(user) {
              CurrentUser.set(user);
              defer.resolve($rootScope.user);
            }, function() {

              // What should be done here?
              defer.reject('Failure forcing refresh of user');
            });
          } else {
            defer.resolve($rootScope.user);
          }
        } else if (!$rootScope.user && ipCookie('basic')) {

          var impersonatedUser = ImpersonateService.getUser();

          // If there is a user to impersonate, check their promotion's subdomain. If it is the same as the current promotion, set the user as the current user.
          if (!impersonatedUser) {
            if (!CurrentUser.queued) {
              CurrentUser.queued = true;
              CurrentUser.queuedPromise = defer.promise;

              User.show({
                id: 'me'
              }, function(user) {
                CurrentUser.queued = false;
                CurrentUser.set(user);
                defer.resolve($rootScope.user);
              }, function() {

                // What should be done here?
                defer.reject('User loading issue.');
              });
            } else {
              promise = CurrentUser.queuedPromise;
            }
          } else {
            CurrentSite.get(true).then(function(site) {
              // Load the user with their auth_key.
              User.getUserFromAuthKey(impersonatedUser.auth_key).then(function(response) {
                CurrentUser.set(response.data);
                defer.resolve($rootScope.user);
                CurrentUser.queued = false;
                $rootScope.$broadcast('userLoggedIn', $rootScope.user);
              }, function() {
                defer.reject('Could not impersonate.');
              });
              ImpersonateService.removeUser();
            });
          }
        } else if (!$rootScope.user && !ipCookie('basic')) {
          CurrentUser.queued = false;
          defer.reject('User could not be loaded.');
        }

        return promise;
      };

      CurrentUser.set = function(user) {

        if (user.auth_basic_header && (!ipCookie('basic') || ipCookie('basic') != user.auth_basic_header)) {
          ipCookie('basic', user.auth_basic_header, {path: '/'});
        }

        // Set the user on the root scope.
        $rootScope.user = new User(user);
        $rootScope.$broadcast("didSetUser");
      };

      CurrentUser.remove = function() {
        CurrentSite.removeUser();
        $rootScope.user = null;
      };

      CurrentUser.checkIfEvaluationAvailable = function(toState) {
        if (!!toState.name && toState.name.match('evaluation') || !toState) {
          return;
        }

        if (!$rootScope.sawEvaluation &&
          $rootScope.user && $rootScope.user.active_evaluation_ids &&
          $rootScope.user.active_evaluation_ids.length > 0) {
          for (var i = 0; i < $rootScope.user.active_evaluation_ids.length; i++) {
            if ($rootScope.user.completed_evaluation_ids.indexOf($rootScope.user.active_evaluation_ids[i]) === -1) {
              $timeout(function() {
                $state.go('go.u.evaluations.evaluation', {
                  evaluationId: $rootScope.user.active_evaluation_ids[i]
                });
              }, 1);

              break;
            }
          }
        }
      }

      CurrentUser.joinedProgramChecker = {
        userStatePromise: null,
        isChecking: false,
        cancel: function() {
          $interval.cancel(CurrentUser.joinedProgramChecker.userStatePromise);
          if (CurrentUser.joinedProgramChecker.navigateWatcher) {
            CurrentUser.joinedProgramChecker.navigateWatcher();
          }
        },
        start: function() {
          if (!CurrentUser.joinedProgramChecker.isChecking) {
            CurrentUser.joinedProgramChecker.isChecking = true;

            CurrentUser.joinedProgramChecker.navigateWatcher =
              $rootScope.$on('$stateChangeSuccess', function() {
                CurrentUser.joinedProgramChecker.cancel();
              });
            CurrentUser.joinedProgramChecker.userStatePromise =
              $interval(function() {
                $rootScope.user.applicationState()
                  .then(function(response) {
                    var userAppState = response.data;
                    CurrentUser.joinedProgramChecker.isChecking = false;
                    if (userAppState.hash_key !== $rootScope.user.application_state.hash_key) {
                      CurrentUser.get(true);
                      CurrentUser.joinedProgramChecker.cancel();
                    }
                  }, function() {
                    CurrentUser.joinedProgramChecker.isChecking = false;
                    $interval.cancel(CurrentUser.joinedProgramChecker.userStatePromise);
                  });
              }, 5000);
          }
        }
      };


      return CurrentUser;
    });
'use strict';

angular.module('goApp')

.factory('UsersLoader', ['User', '$q', function(User, $q) {
  return function(siteId) {
    var defer = $q.defer();

    User.index({
      page_size: 0,
      site_id: siteId
    }, function(users) {
      defer.resolve(users);
    }, function() {
      defer.reject('Users could not be loaded.');
    });

    return defer.promise;
  };
}])

.factory('UserLoader', ['User', '$q', function(User, $q) {
  return function(userId) {
    var defer = $q.defer();

    User.show({
      id: userId
    }, function(user) {
      defer.resolve(user);
    }, function() {
      defer.reject('User could not be loaded.');
    });

    return defer.promise;
  };
}]);
'use strict';

angular.module('goApp').factory('User', function(ActiveResource, $http, DOMAIN, $window, $q) {
  var baseUrl = '/users/:id'
  var User = ActiveResource(baseUrl, {
    nestedRoutes: ['index', 'create', 'destroy', 'authenticate'],
    parentResource: 'Site',
    domain: DOMAIN
  }, {
    authenticate: {
      method: 'post',
      url: '/authenticate'
    },
    custom_content_likes: {
      method: 'GET',
      isArray: true,
      url: '/custom_content_likes'
    },
    hideOverlay: {
      method: 'POST',
      isArray: false,
      url: '/hide_overlay'
    },
    stats: {
      method: 'GET',
      isArray: false,
      url: '/stats'
    },
    conversation_volume: {
      method: 'POST',
      url: '/conversation_volume'
    },
    campaigns: {
      method: 'GET',
      isArray: true,
      url: '/campaigns'
    }
  });

  // *****
  // *****
  // Admin
  // *****

  User.search = function(query, options) {
    return $http.get(DOMAIN + '/users/search', {
      params: angular.extend({
        query: query
      }, options)
    });
  };


  User.prototype.updateFlags = function(flags) {
    var self = this;

    Object.keys(flags).map(function(key){
      self.flags[key] = flags[key];
    });

    var promise = new User({
      id: self.id,
      flags: flags
    }).save();

    promise.then(_.noop);

    return promise;
  }

  User.prototype.hideOverlayUpdate = function(programId) {
    var user = this;
    return User.hideOverlay({
      program_id: programId
    }).$promise.then(function() {
      user.hide_program_overlay = programId;
    });
  }

  User.prototype.applicationState = function() {
    return $http.get(DOMAIN + '/users/application_state');
  };

  User.prototype.checkEligibility = function(identifier) {
    return $http.get(DOMAIN + '/sites/' + this.site_id + '/users/check_eligibility/' + identifier);
  };

  User.prototype.requestPassword = function() {
    return $http.post(DOMAIN + '/users/request_password', this);
  };

  User.getUserFromAuthKey = function(authKey) {
    return $http.get(DOMAIN + '/get_user_from_auth_key/' + encodeURIComponent(authKey));
  };

  User.getUserFromToken = function(token) {
    return $http.get(DOMAIN + '/get_user_from_reset_token/' + encodeURIComponent(token));
  };

  User.impersonate = function(userId) {
    $window.open('http://' + DOMAIN + '/users/impersonate?impersonate_id=' + userId + "&port=" + window.location.port, '_blank');
  };

  User.validate = function(siteID, attribute) {
    return $http.post(DOMAIN + '/sites/' + siteID + '/users/validate/', attribute);
  };

  User.prototype.getTopLevelLocationId = function() {
    return this.top_level_location_id;
  };

  User.prototype.hasLocationLogo = function() {
    return (this.location && this.location.logo);
  };

  User.prototype.locationLogo = function() {
    if (this.location && this.location.logo) {
      return DOMAIN + this.location.logo;
    }
  };

  User.prototype.isProgramLoggingActive = function() {
    var programLoggingActive = false;
    switch (this.application_state.logging_state) {
      case 'enter_logging':
      case 'opt_in_logging':
        programLoggingActive = true;
        break;
      default:
        programLoggingActive = false;
    }

    return programLoggingActive;
  }

  // *******
  // Profile
  // *******

  User.prototype.fullName = function() {
    return this.profile.first_name + ' ' + this.profile.last_name;
  };

  User.prototype.hasProfilePhoto = function() {
    return !!this.profile.image && !!this.profile.image.url && this.profile.image.url.indexOf('default') === -1;
  };

  // ****
  // Role
  // ****

  User.prototype.isCoordinator = function() {
    return this.role === 'Coordinator';
  };

  User.prototype.isLocationCoordinator = function() {
    return this.role === 'Location Coordinator';
  };

  User.prototype.isRegionalCoordinator = function() {
    return this.role === 'Regional Coordinator';
  };

  User.prototype.isMaster = function() {
    return this.role === 'Master';
  };

  User.prototype.isCoordinatorOrAbove = function() {
    return this.isCoordinator() || this.isMaster();
  };

  User.prototype.isRegionalCoordinatorOrAbove = function() {
    return this.isRegionalCoordinator() || this.isCoordinator() || this.isMaster();
  };

  User.prototype.isLocationCoordinatorOrAbove = function() {
    return this.isCoordinator() || this.isMaster() || this.isLocationCoordinator() || this.isRegionalCoordinator();
  };

  User.prototype.isPoster = function() {
    return this.role === 'Poster';
  };

  User.prototype.hasRegisteredForProgram = function(program_id) {
    return !!program_id && this.registered_program_ids.indexOf(parseInt(program_id, 10)) >= 0;
  };

  // **************
  // Device Methods
  // **************

  User.prototype.saveManuallyLog = function() {
    var defer = $q.defer();
    this.active_device = 'MANUAL';
    this.save(function(user) {
      defer.resolve(user);
    }, function(response) {
      defer.reject(response);
    })

    return defer.promise;
  }

  User.prototype.activeDevice = function() {
    return this.active_device ? this.active_device.charAt(0).toUpperCase() + this.active_device.slice(1).toLowerCase() : '';
  };

  User.prototype.connectedValidicApp = function() {
    return this.validic_user ? this.validic_user.applications : undefined;
  };

  User.prototype.formattedActiveDevice = function() {
    if (this.isValidicConnected()) {
      return this.validic_user.applications;
    } else if (this.isAppleHealthConnected()) {
      return 'Apple Health';
    } else if (this.isHealthConnectConnected()) {
      return 'Health Connect';
    } else if (this.isGoogleHealthConnected()) {
      return 'Google Health';
    } else {
      return this.active_device ? this.active_device.charAt(0).toUpperCase() + this.active_device.slice(1).toLowerCase() : '';
    }
  };

  User.prototype.isAnyDeviceConnected = function() {
    return this.isFitbitConnected() || this.isValidicConnected() || this.isAppleHealthConnected() || this.isHealthConnectConnected() || this.isGarminConnected() || this.isGoogleHealthConnected();
  };

  User.prototype.isAppleHealthConnected = function() {
    return this.active_device === 'APPLE';
  };

  User.prototype.isHealthConnectConnected = function() {
    return this.active_device === 'HEALTH_CONNECT';
  };

  User.prototype.isFitbitConnected = function() {
    return this.active_device === 'FITBIT';
  };

  User.prototype.isLoggingManually = function() {
    return this.active_device && this.active_device === 'MANUAL';
  };

  User.prototype.hasChosenLogging = function() {
    return !!this.active_device;
  };

  User.prototype.isValidicConnected = function() {
    return this.active_device === 'VALIDIC';
  };

  User.prototype.isGarminConnected = function() {
    return this.active_device === 'GARMIN';
  };

  User.prototype.isGoogleHealthConnected = function() {
    return this.active_device === 'GOOGLE_HEALTH';
  };

  User.prototype.remove_pending_eval = function(id) {
    this.pending_evaluation_ids = _.remove(this.pending_evaluation_ids, id);
    return this;
  };

  User.prototype.getTruncatedName = function(len) {
    return _.truncate(this.profile.first_name, {
      length: len || 13
    });
  };

  User.prototype.getRecentActivities = function(){
    return $http.get(DOMAIN+"/users/recent_activities");
  }

  return User;
});

'use strict';

angular.module('goApp')

.config(['$stateProvider',
	function($stateProvider) {
		$stateProvider
			.state('go.u.site.user.dashboard_settings', {
				url: '/:userId/settings',
				controller: 'DashboardSettingsCtrl',
				background: 'filled',
				abstract: false,
				templateProvider: ['hesTemplateService',
					function(hesTemplateService) {
						return hesTemplateService.getTemplate('/scripts/settings/dashboard.html');
					}
				],
				resolve: {
					user: ['UserLoader', '$stateParams', function(UserLoader, $stateParams) {
						return new UserLoader($stateParams.userId);
					}]
				}
			})

			.state('go.u.site.user.impersonate', {
				url: '/:userId/impersonate',
				controller: 'ImpersonateCtrl',
				background: 'filled',
				templateProvider: ['hesTemplateService',
					function(hesTemplateService) {
						return hesTemplateService.getTemplate('/scripts/authentication/impersonate.html');
					}
				]
			});
	}
]);

'use strict';

angular.module('goApp')
  .controller('UsersController', ['$scope', '$filter', '$state', '$q', 'UsersLoader', 'CurrentSite', '$window', '$location', 'ngDialog', 'User', 'LocationService', 'LocationsLoader',
    function($scope, $filter, $state, $q, UsersLoader, CurrentSite, $window, $location, ngDialog, User, LocationService, LocationsLoader) {
      $scope.data = {
        loading: true,
        users: [],
        table: {
          fields: [
            ['First Name', 'string'],
            ['Last Name', 'string'],
            ['Email', 'string']
          ],
          rows: [],
          actions: []
        }
      };

      if (!$scope.user.isMaster() && ($scope.dbSite || $scope.site).flags.is_logging_enabled) {
        $scope.data.table.fields.push(
          ['Days Logged', 'string']
        );
      }

      if ($scope.user.isMaster()) {
        $scope.data.table.fields.push(
          ['Actions', 'actions', {
            width: 300
          }]
        );
      }

      $scope.siteId = $state.params.siteId;

      if (!$scope.dbSite) {
        $scope.dbSite = $scope.site;
      }

      $scope.editUser = function(user) {
        var url = $state.href('go.u.site.user.dashboard_settings', {
          userId: user.id
        });
        $window.open(url, '_blank');
      };

      $scope.impersonateUser = function(user) {
        User.impersonate(user.id);
      };

      $scope.confirmDeleteUser = function(user) {
        $scope.confirmation = {
          message: 'Do you want to remove this user (' + user.first_name + ' ' + user.last_name + ')?',
          confirmText: 'Delete',
          cancelText: 'Cancel'
        };
        ngDialog.openConfirm({
          scope: $scope,
          template: '/scripts/dialogs/confirmationDialog.html'
        }).then(function() {
          user.site_id = $scope.siteId;
          user.$destroy().then(function(user) {
            $scope.doLoad();
          });
        });
      };


      if ($scope.dbSite.flags.is_location_displayed) {
        $scope.data.table.fields.splice(3, 0, [$scope.dbSite.getLocationLabel($scope.dbSite.hasNestedLocations() ? 1 : 0), 'string']);

          if ($scope.dbSite.hasNestedLocations()) {
            $scope.data.table.fields.splice(3, 0, [$scope.dbSite.getLocationLabel(0), 'string']);
          }
      }


      $scope.data.table.fields.splice(3, 0, ['SSOID', 'string']);

      // same result as LocationService.getLocationById, but one lookup per user instead of a scan
      function mapLocationsById(locations) {
        var locationsById = {};
        angular.forEach(locations, function(location) {
          if (!locationsById.hasOwnProperty(location.id)) {
            locationsById[location.id] = location;
          }
        });
        angular.forEach(locations, function(location) {
          angular.forEach(location.locations, function(subLocation) {
            if (!locationsById.hasOwnProperty(subLocation.id)) {
              locationsById[subLocation.id] = subLocation;
            }
          });
        });
        return locationsById;
      }

      $scope.doLoad = function() {
        // refresh so that the cached locations of a different site are not used
        $q.all([new UsersLoader($scope.dbSite.id), LocationService.get(true, $scope.dbSite.id)]).then(function(results) {
          $scope.data.users = results[0];
          $scope.data.locations = results[1];
          var locationsById = mapLocationsById($scope.data.locations);


          function setTableData() {

            var gridRows = [];
            for (var i = 0; i < $scope.data.users.length; i++) {
              var user = $scope.data.users[i];

              var doEdit = function(args) {
                $scope.editUser.apply(this, args);
              };

              var doImpersonate = function(args) {
                $scope.impersonateUser.apply(this, args);
              };

              var doDeleteUser = function(args) {
                $scope.confirmDeleteUser.apply(this, args);
              };

              user.row = [
                $scope.data.users[i].first_name,
                $scope.data.users[i].last_name,
                $scope.data.users[i].email
              ];


              if ($scope.dbSite.flags.is_location_displayed) {
                var location = locationsById[user.location_id];
                user.row.splice(3, 0, location ? location.name : '');

                if ($scope.dbSite.hasNestedLocations()) {
                  var top_level_location = locationsById[user.top_level_location_id];
                  user.row.splice(3, 0, top_level_location ? top_level_location.name : '');
                }
              }

              user.row.splice(3, 0, $scope.data.users[i].sso_identifier);

              if (!$scope.user.isMaster() && $scope.dbSite.flags.is_logging_enabled) {
                user.row.push($scope.data.users[i].days_logged);
              }

              if ($scope.user.isMaster()) {
                user.row.push([
                  ['edit', doEdit, [user]],
                  ['impersonate', doImpersonate, [user]],
                  ['delete', doDeleteUser, [user]]
                ]);
              }

              gridRows.push(user);
            }

            $scope.data.table.rows = gridRows;
          }

          setTableData();

      }).finally(function(){
        $scope.data.loading = false;
      });
      };
      $scope.doLoad();
    }
  ]);
'use strict';

angular.module('goApp')
	.directive('hesUsersPopover', ['hesTemplateService', function(hesTemplateService) {
		// Runs during compile
		return {
			scope: {
				items: '=',
				user: '='
			},
			templateUrl: hesTemplateService.getTemplateUrl('/scripts/users/usersPopover.html'),
			controller: function($scope, CurrentUser) {

				function userIsCurrentUser(user) {
					return user.id === parseInt($scope.user.id);
				};

				function appendUsers(len) {
					var tmpContent = '';
					var userTracker = [];
					for (var i = 0; i < len; i++) {
						var name = userIsCurrentUser($scope.items[i].user) ? 'You' : $scope.items[i].user.profile.first_name + ' ' + $scope.items[i].user.profile.last_name;
						if (userTracker.indexOf(name) === -1) {
							tmpContent += name + '<br />';
							userTracker.unshift(name);
						}
					}
					return tmpContent;
				}

				$scope.buildContent = function() {
					var content = '';
					var currentUserHasLiked = false;

					// Has the current user liked this?
					for (var i = 0; i < $scope.items.length; i++) {
						if (userIsCurrentUser($scope.items[i].user)) {
							var like = $scope.items[i];

							// Move the current user's like to the beginning so it can be displayed first.
							$scope.items.splice(i, 1);
							$scope.items.unshift(like);

							currentUserHasLiked = true;
							break;
						}
					}

					switch ($scope.items.length) {
						case 0:
							content = 'Be the first!';
							break;
						default:
							var userTracker = [];
							if ($scope.items.length < 11) {
								content += appendUsers($scope.items.length);
							} else {
								content += appendUsers(9);
								content += ($scope.items.length - 11) + ' others';
							}

							break;
					}

					return content;
				};
			}
		};
	}]);
/*!
 * Pikaday jQuery plugin.
 *
 * Copyright © 2013 David Bushell | BSD & MIT license | https://github.com/dbushell/Pikaday
 */

(function (root, define, factory)
{
    'use strict';

    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['jquery', 'pikaday'], factory);
    } else {
        // Browser globals
        factory(root.jQuery, root.Pikaday);
    }
}(window, window.define, function ($, Pikaday)
{
    'use strict';

    $.fn.pikaday = function()
    {
        var args = arguments;

        if (!args || !args.length) {
            args = [{ }];
        }

        return this.each(function()
        {
            var self   = $(this),
                plugin = self.data('pikaday');

            if (!(plugin instanceof Pikaday)) {
                if (typeof args[0] === 'object') {
                    var options = $.extend({}, args[0]);
                    options.field = self[0];
                    self.data('pikaday', new Pikaday(options));
                }
            } else {
                if (typeof args[0] === 'string' && typeof plugin[args[0]] === 'function') {
                    plugin[args[0]].apply(plugin, Array.prototype.slice.call(args,1));
                }
            }
        });
    };

}));

/*!
 * VERSION: 0.14.0
 * DATE: 2015-05-26
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * Requires TweenLite and CSSPlugin version 1.17.0 or later (TweenMax contains both TweenLite and CSSPlugin). ThrowPropsPlugin is required for momentum-based continuation of movement after the mouse/touch is released (ThrowPropsPlugin is a membership benefit of Club GreenSock - http://greensock.com/club/).
 *
 * @license Copyright (c) 2008-2015, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {

	"use strict";

	_gsScope._gsDefine("utils.Draggable", ["events.EventDispatcher","TweenLite","plugins.CSSPlugin"], function(EventDispatcher, TweenLite, CSSPlugin) {

		var _tempVarsXY = {css:{}}, //speed optimization - we reuse the same vars object for x/y TweenLite.set() calls to minimize garbage collection tasks and improve performance.
			_tempVarsX = {css:{}},
			_tempVarsY = {css:{}},
			_tempVarsRotation = {css:{}},
			_globals = _gsScope._gsDefine.globals,
			_tempEvent = {}, //for populating with pageX/pageY in old versions of IE
			_doc = document,
			_docElement = _doc.documentElement || {},
			_createElement = function(type) {
				return _doc.createElementNS ? _doc.createElementNS("http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
			},
			_tempDiv = _createElement("div"),
			_emptyArray = [],
			_emptyFunc = function() { return false; },
			_RAD2DEG = 180 / Math.PI,
			_max = 999999999999999,
			_getTime = Date.now || function() {return new Date().getTime();},
			_isOldIE = !!(!_doc.addEventListener && _doc.all),
			_placeholderDiv = _doc.createElement("div"),
			_renderQueue = [],
			_lookup = {}, //when a Draggable is created, the target gets a unique _gsDragID property that allows gets associated with the Draggable instance for quick lookups in Draggable.get(). This avoids circular references that could cause gc problems.
			_lookupCount = 0,
			_clickableTagExp = /^(?:a|input|textarea|button|select)$/i,
			_dragCount = 0, //total number of elements currently being dragged
			_prefix,
			_isMultiTouching,
			_isAndroid = (navigator.userAgent.toLowerCase().indexOf("android") !== -1), //Android handles touch events in an odd way and it's virtually impossible to "feature test" so we resort to UA sniffing
			_lastDragTime = 0,
			_temp1 = {}, // a simple object we reuse and populate (usually x/y properties) to conserve memory and improve performance.
			_temp2 = {},
			_windowProxy = {}, //memory/performance optimization - we reuse this object during autoScroll to store window-related bounds/offsets.
			_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
				if (typeof(a) === "string") {
					a = TweenLite.selector(a);
				}
				if (!a || a.nodeType) { //if it's not an array, wrap it in one.
					return [a];
				}
				var b = [],
					l = a.length,
					i;
				for (i = 0; i !== l; b.push(a[i++]));
				return b;
			},
			ThrowPropsPlugin,

			_renderQueueTick = function() {
				var i = _renderQueue.length;
				while (--i > -1) {
					_renderQueue[i]();
				}
			},
			_addToRenderQueue = function(func) {
				_renderQueue.push(func);
				if (_renderQueue.length === 1) {
					TweenLite.ticker.addEventListener("tick", _renderQueueTick, this, false, 1);
				}
			},
			_removeFromRenderQueue = function(func) {
				var i = _renderQueue.length;
				while (--i > -1) {
					if (_renderQueue[i] === func) {
						_renderQueue.splice(i, 1);
					}
				}
				TweenLite.to(_renderQueueTimeout, 0, {overwrite:"all", delay:15, onComplete:_renderQueueTimeout}); //remove the "tick" listener only after the render queue is empty for 15 seconds (to improve performance). Adding/removing it constantly for every click/touch wouldn't deliver optimal speed, and we also don't want the ticker to keep calling the render method when things are idle for long periods of time (we want to improve battery life on mobile devices).
			},
			_renderQueueTimeout = function() {
				if (!_renderQueue.length) {
					TweenLite.ticker.removeEventListener("tick", _renderQueueTick);
				}
			},

			_extend = function(obj, defaults) {
				var p;
				for (p in defaults) {
					if (obj[p] === undefined) {
						obj[p] = defaults[p];
					}
				}
				return obj;
			},
			_getDocScrollTop = function() {
				return (window.pageYOffset != null) ? window.pageYOffset : (_doc.scrollTop != null) ? _doc.scrollTop : _docElement.scrollTop || _doc.body.scrollTop || 0;
			},
			_getDocScrollLeft = function() {
				return (window.pageXOffset != null) ? window.pageXOffset : (_doc.scrollLeft != null) ? _doc.scrollLeft : _docElement.scrollLeft || _doc.body.scrollLeft || 0;
			},
			_addScrollListener = function(e, callback) {
				_addListener(e, "scroll", callback);
				if (!_isRoot(e.parentNode)) {
					_addScrollListener(e.parentNode, callback);
				}
			},
			_removeScrollListener = function(e, callback) {
				_removeListener(e, "scroll", callback);
				if (!_isRoot(e.parentNode)) {
					_removeScrollListener(e.parentNode, callback);
				}
			},
			_isRoot = function (e) {
				return !!(!e || e === _docElement || e === _doc || e === _doc.body || e === window || !e.nodeType || !e.parentNode);
			},
			_getMaxScroll = function(element, axis) {
				var dim = (axis === "x") ? "Width" : "Height",
					scroll = "scroll" + dim,
					client = "client" + dim,
					body = _doc.body;
				return Math.max(0, _isRoot(element) ? Math.max(_docElement[scroll], body[scroll]) - (window["inner" + dim] || _docElement[client] || body[client]) : element[scroll] - element[client]);
			},
			_recordMaxScrolls = function(e) { //records _gsMaxScrollX and _gsMaxScrollY properties for the element and all ancestors up the chain so that we can cap it, otherwise dragging beyond the edges with autoScroll on can endlessly scroll.
				var isRoot = _isRoot(e),
					x = _getMaxScroll(e, "x"),
					y = _getMaxScroll(e, "y");
				if (isRoot) {
					e = _windowProxy;
				} else {
					_recordMaxScrolls(e.parentNode);
				}
				e._gsMaxScrollX = x;
				e._gsMaxScrollY = y;
				e._gsScrollX = e.scrollLeft || 0;
				e._gsScrollY = e.scrollTop || 0;
			},

			//just used for IE8 and earlier to normalize events and populate pageX/pageY
			_populateIEEvent = function(e, preventDefault) {
				e = e || window.event;
				_tempEvent.pageX = e.clientX + _doc.body.scrollLeft + _docElement.scrollLeft;
				_tempEvent.pageY = e.clientY + _doc.body.scrollTop + _docElement.scrollTop;
				if (preventDefault) {
					e.returnValue = false;
				}
				return _tempEvent;
			},

			//grabs the first element it finds (and we include the window as an element), so if it's selector text, it'll feed that value to TweenLite.selector, if it's a jQuery object or some other selector engine's result, it'll grab the first one, and same for an array. If the value doesn't contain a DOM element, it'll just return null.
			_unwrapElement = function(value) {
				if (!value) {
					return value;
				}
				if (typeof(value) === "string") {
					value = TweenLite.selector(value);
				}
				if (value.length && value !== window && value[0] && value[0].style && !value.nodeType) {
					value = value[0];
				}
				return (value === window || (value.nodeType && value.style)) ? value : null;
			},

			_checkPrefix = function(e, p) {
				var s = e.style,
					capped, i, a;
				if (s[p] === undefined) {
					a = ["O","Moz","ms","Ms","Webkit"];
					i = 5;
					capped = p.charAt(0).toUpperCase() + p.substr(1);
					while (--i > -1 && s[a[i]+capped] === undefined) { }
					if (i < 0) {
						return "";
					}
					_prefix = (i === 3) ? "ms" : a[i];
					p = _prefix + capped;
				}
				return p;
			},

			_setStyle = function(e, p, value) {
				var s = e.style;
				if (!s) {
					return;
				}
				if (s[p] === undefined) {
					p = _checkPrefix(e, p);
				}
				if (value == null) {
					if (s.removeProperty) {
						s.removeProperty(p.replace(/([A-Z])/g, "-$1").toLowerCase());
					} else { //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
						s.removeAttribute(p);
					}
				} else if (s[p] !== undefined) {
					s[p] = value;
				}
			},

			_getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : _emptyFunc,
			_horizExp = /(?:Left|Right|Width)/i,
			_suffixExp = /(?:\d|\-|\+|=|#|\.)*/g,
			_convertToPixels = function(t, p, v, sfx, recurse) {
				if (sfx === "px" || !sfx) { return v; }
				if (sfx === "auto" || !v) { return 0; }
				var horiz = _horizExp.test(p),
					node = t,
					style = _tempDiv.style,
					neg = (v < 0),
					pix;
				if (neg) {
					v = -v;
				}
				if (sfx === "%" && p.indexOf("border") !== -1) {
					pix = (v / 100) * (horiz ? t.clientWidth : t.clientHeight);
				} else {
					style.cssText = "border:0 solid red;position:" + _getStyle(t, "position", true) + ";line-height:0;";
					if (sfx === "%" || !node.appendChild) {
						node = t.parentNode || _doc.body;
						style[(horiz ? "width" : "height")] = v + sfx;
					} else {
						style[(horiz ? "borderLeftWidth" : "borderTopWidth")] = v + sfx;
					}
					node.appendChild(_tempDiv);
					pix = parseFloat(_tempDiv[(horiz ? "offsetWidth" : "offsetHeight")]);
					node.removeChild(_tempDiv);
					if (pix === 0 && !recurse) {
						pix = _convertToPixels(t, p, v, sfx, true);
					}
				}
				return neg ? -pix : pix;
			},
			_calculateOffset = function(t, p) { //for figuring out "top" or "left" in px when it's "auto". We need to factor in margin with the offsetLeft/offsetTop
				if (_getStyle(t, "position", true) !== "absolute") { return 0; }
				var dim = ((p === "left") ? "Left" : "Top"),
					v = _getStyle(t, "margin" + dim, true);
				return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), (v + "").replace(_suffixExp, "")) || 0);
			},

			_getStyle = function(element, prop, keepUnits) {
				var rv = (element._gsTransform || {})[prop],
					cs;
				if (rv || rv === 0) {
					return rv;
				} else if (element.style[prop]) {
					rv = element.style[prop];
				} else if ((cs = _getComputedStyle(element))) {
					rv = cs.getPropertyValue(prop.replace(/([A-Z])/g, "-$1").toLowerCase());
					rv = (rv || cs.length) ? rv : cs[prop]; //Opera behaves VERY strangely - length is usually 0 and cs[prop] is the only way to get accurate results EXCEPT when checking for -o-transform which only works with cs.getPropertyValue()!
				} else if (element.currentStyle) {
					rv = element.currentStyle[prop];
				}
				if (rv === "auto" && (prop === "top" || prop === "left")) {
					rv = _calculateOffset(element, prop);
				}
				return keepUnits ? rv : parseFloat(rv) || 0;
			},

			_dispatchEvent = function(instance, type, callbackName) {
				var vars = instance.vars,
					callback = vars[callbackName],
					listeners = instance._listeners[type];
				if (typeof(callback) === "function") {
					callback.apply(vars[callbackName + "Scope"] || vars.callbackScope || instance, vars[callbackName + "Params"] || [instance.pointerEvent]);
				}
				if (listeners) {
					instance.dispatchEvent(type);
				}
			},
			_getBounds = function(obj, context) { //accepts any of the following: a DOM element, jQuery object, selector text, or an object defining bounds as {top, left, width, height} or {minX, maxX, minY, maxY}. Returns an object with left, top, width, and height properties.
				var e = _unwrapElement(obj),
					top, left, offset;
				if (!e) {
					if (obj.left !== undefined) {
						offset = _getOffsetTransformOrigin(context); //the bounds should be relative to the origin
						return {left: obj.left - offset.x, top: obj.top - offset.y, width: obj.width, height: obj.height};
					}
					left = obj.min || obj.minX || obj.minRotation || 0;
					top = obj.min || obj.minY || 0;
					return {left:left, top:top, width:(obj.max || obj.maxX || obj.maxRotation || 0) - left, height:(obj.max || obj.maxY || 0) - top};
				}
				return _getElementBounds(e, context);
			},

			_svgBorderFactor,
			_svgBorderScales,
			_svgScrollOffset,
			_hasBorderBug,
			_setEnvironmentVariables = function() { //some browsers factor the border into the SVG coordinate space, some don't (like Firefox). Some apply transforms to them, some don't. We feature-detect here so we know how to handle the border(s). We can't do this immediately - we must wait for the document.body to exist.
				if (!_doc.createElementNS) {
					_svgBorderFactor = 0;
					_svgBorderScales = false;
					return;
				}
				var div = _createElement("div"),
					svg = _doc.createElementNS("http://www.w3.org/2000/svg", "svg"),
					wrapper = _createElement("div"),
					style = div.style,
					parent = _doc.body || _docElement,
					matrix, e1, point, oldValue;
				if (_doc.body && _transformProp) {
					style.position = wrapper.style.position = "absolute";
					parent.appendChild(wrapper);
					wrapper.appendChild(div);
					style.height = "10px";
					oldValue = div.offsetTop;
					wrapper.style.border = "5px solid red";
					_hasBorderBug = (oldValue !== div.offsetTop); //some browsers, like Firefox 38, cause the offsetTop/Left to be affected by a parent's border.
					parent.removeChild(wrapper);
				}
				style = svg.style;
				svg.setAttributeNS(null, "width", "400px");
				svg.setAttributeNS(null, "height", "400px");
				svg.setAttributeNS(null, "viewBox", "0 0 400 400");
				style.display = "block";
				style.boxSizing = "border-box";
				style.border = "0px solid red";
				style.transform = "none";
				// in some browsers (like certain flavors of Android), the getScreenCTM() matrix is contaminated by the scroll position. We can run some logic here to detect that condition, but we ended up not needing this because we found another workaround using getBoundingClientRect().
				div.style.cssText = "width:100px;height:100px;overflow:scroll";
				parent.appendChild(div);
				div.appendChild(svg);
				point = svg.createSVGPoint().matrixTransform(svg.getScreenCTM());
				e1 = point.y;
				div.scrollTop = 100;
				point.x = point.y = 0;
				point = point.matrixTransform(svg.getScreenCTM());
				_svgScrollOffset = (e1 - point.y < 100.1) ? 0 : e1 - point.y - 150;
				div.removeChild(svg);
				parent.removeChild(div);
				// -- end _svgScrollOffset calculation.
				parent.appendChild(svg);
				matrix = svg.getScreenCTM();
				e1 = matrix.e;
				style.border = "50px solid red";
				matrix = svg.getScreenCTM();
				if (e1 === 0 && matrix.e === 0 && matrix.f === 0 && matrix.a === 1) { //Opera has a bunch of bugs - it doesn't adjust the x/y of the matrix, nor does it scale when box-sizing is border-box but it does so elsewhere; to get the correct behavior we set _svgBorderScales to true.
					_svgBorderFactor = 1;
					_svgBorderScales = true;
				} else {
					_svgBorderFactor = (e1 !== matrix.e) ? 1 : 0;
					_svgBorderScales = (matrix.a !== 1);
				}
				parent.removeChild(svg);
			},

			_supports3D = (_checkPrefix(_tempDiv, "perspective") !== ""),

			// start matrix and point conversion methods...
			_transformOriginProp = _checkPrefix(_tempDiv, "transformOrigin").replace(/^ms/g, "Ms").replace(/([A-Z])/g, "-$1").toLowerCase(),
			_transformProp = _checkPrefix(_tempDiv, "transform"),
			_transformPropCSS = _transformProp.replace(/^ms/g, "Ms").replace(/([A-Z])/g, "-$1").toLowerCase(),
			_point1 = {}, //we reuse _point1 and _point2 objects inside matrix and point conversion methods to conserve memory and minimize garbage collection tasks.
			_point2 = {},
			_SVGElement = window.SVGElement,
			_isSVG = function(e) {
				return !!(_SVGElement && typeof(e.getBBox) === "function" && e.getCTM && (!e.parentNode || (e.parentNode.getBBox && e.parentNode.getCTM)));
			},
			_isIE10orBelow = (((/MSIE ([0-9]{1,}[\.0-9]{0,})/).exec(navigator.userAgent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).exec(navigator.userAgent)) && parseFloat( RegExp.$1 ) < 11), //Ideally we'd avoid user agent sniffing, but there doesn't seem to be a way to feature-detect and sense a border-related bug that only affects IE10 and IE9.
			_tempTransforms = [],
			_tempElements = [],
			_getSVGOffsets = function(e) { //SVG elements don't always report offsetTop/offsetLeft/offsetParent at all (I'm looking at you, Firefox 29 and Android), so we have to do some work to manufacture those values. You can pass any SVG element and it'll spit back an object with offsetTop, offsetLeft, offsetParent, scaleX, and scaleY properties. We need the scaleX and scaleY to handle the way SVG can resize itself based on the container.
				if (!e.getBoundingClientRect || !e.parentNode || !_transformProp) {
					return {offsetTop:0, offsetLeft:0, scaleX:1, scaleY:1, offsetParent:_docElement};
				}
				if (Draggable.cacheSVGData !== false && e._gsCache && e._gsCache.lastUpdate === TweenLite.ticker.frame) { //performance optimization. Assume that if the offsets are requested again on the same tick, we can just feed back the values we already calculated (no need to keep recalculating until another tick elapses).
					return e._gsCache;
				}
				var curElement = e,
					cache = _cache(e),
					eRect, parentRect, offsetParent, cs, m, i, point1, point2, borderWidth, borderHeight, width, height;
				cache.lastUpdate = TweenLite.ticker.frame;
				if (e.getBBox && !cache.isSVGRoot) { //if it's a nested/child SVG element, we must find the parent SVG canvas and measure the offset from there.
					curElement = e.parentNode;
					eRect = e.getBBox();
					while (curElement && (curElement.nodeName + "").toLowerCase() !== "svg") {
						curElement = curElement.parentNode;
					}
					cs = _getSVGOffsets(curElement);
					cache.offsetTop = eRect.y * cs.scaleY;
					cache.offsetLeft = eRect.x * cs.scaleX;
					cache.scaleX = cs.scaleX;
					cache.scaleY = cs.scaleY;
					cache.offsetParent = curElement || _docElement;
					return cache;
				}
				//only root SVG elements continue here...
				offsetParent = cache.offsetParent;
				if (offsetParent === _doc.body) {
					offsetParent = _docElement; //avoids problems with margins/padding on the body
				}
				//walk up the ancestors and record any non-identity transforms (and reset them to "none") until we reach the offsetParent. We must do this so that the getBoundingClientRect() is accurate for measuring the offsetTop/offsetLeft. We'll revert the values later...
				_tempElements.length = _tempTransforms.length = 0;
				while (curElement) {
					m = _getStyle(curElement, _transformProp, true);
					if (m !== "matrix(1, 0, 0, 1, 0, 0)" && m !== "none" && m !== "translate3d(0px, 0px, 0px)") {
						_tempElements.push(curElement);
						_tempTransforms.push(curElement.style[_transformProp]);
						curElement.style[_transformProp] = "none";
					}
					if (curElement === offsetParent) {
						break;
					}
					curElement = curElement.parentNode;
				}
				parentRect = offsetParent.getBoundingClientRect();
				m = e.getScreenCTM();
				point2 = e.createSVGPoint();
				point1 = point2.matrixTransform(m);
				point2.x = point2.y = 10;
				point2 = point2.matrixTransform(m);
				cache.scaleX = (point2.x - point1.x) / 10;
				cache.scaleY = (point2.y - point1.y) / 10;
				if (_svgBorderFactor === undefined) {
					_setEnvironmentVariables();
				}
				if (cache.borderBox && !_svgBorderScales && e.getAttribute("width")) { //some browsers (like Safari) don't properly scale the matrix to accommodate the border when box-sizing is border-box, so we must calculate it here...
					cs = _getComputedStyle(e) || {};
					borderWidth = (parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth)) || 0;
					borderHeight = (parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth)) || 0;
					width = parseFloat(cs.width) || 0;
					height = parseFloat(cs.height) || 0;
					cache.scaleX *= (width - borderWidth) / width;
					cache.scaleY *= (height - borderHeight) / height;
				}
				if (_svgScrollOffset) { //some browsers (like Chrome for Android) have bugs in the way getScreenCTM() is reported (it doesn't factor in scroll position), so we must revert to a more expensive technique for calculating offsetTop/Left.
					eRect = e.getBoundingClientRect();
					cache.offsetLeft = eRect.left - parentRect.left;
					cache.offsetTop = eRect.top - parentRect.top;
				} else {
					cache.offsetLeft = point1.x - parentRect.left;
					cache.offsetTop = point1.y - parentRect.top;
				}
				cache.offsetParent = offsetParent;
				i = _tempElements.length;
				while (--i > -1) {
					_tempElements[i].style[_transformProp] = _tempTransforms[i];
				}
				return cache;
			},
			_getOffsetTransformOrigin = function(e, decoratee) { //returns the x/y position of the transformOrigin of the element, in its own local coordinate system (pixels), offset from the top left corner.
				decoratee = decoratee || {};
				if (!e || e === _docElement || !e.parentNode || e === window) {
					return {x:0, y:0};
				}
				var cs = _getComputedStyle(e),
					v = (_transformOriginProp && cs) ? cs.getPropertyValue(_transformOriginProp) : "50% 50%",
					a = v.split(" "),
					x = (v.indexOf("left") !== -1) ? "0%" : (v.indexOf("right") !== -1) ? "100%" : a[0],
					y = (v.indexOf("top") !== -1) ? "0%" : (v.indexOf("bottom") !== -1) ? "100%" : a[1];
				if (y === "center" || y == null) {
					y = "50%";
				}
				if (x === "center" || isNaN(parseFloat(x))) { //remember, the user could flip-flop the values and say "bottom center" or "center bottom", etc. "center" is ambiguous because it could be used to describe horizontal or vertical, hence the isNaN(). If there's an "=" sign in the value, it's relative.
					x = "50%";
				}
				if (e.getBBox && _isSVG(e)) { //SVG elements must be handled in a special way because their origins are calculated from the top left.
					if (!e._gsTransform) {
						TweenLite.set(e, {x:"+=0", overwrite:false}); //forces creation of the _gsTransform where we store all the transform components including xOrigin and yOrigin for SVG elements, as of GSAP 1.15.0 which also takes care of calculating the origin from the upper left corner of the SVG canvas.
						if (e._gsTransform.xOrigin === undefined) {
							console.log("Draggable requires at least GSAP 1.17.0");
						}
					}
					v = e.getBBox();
					decoratee.x = (e._gsTransform.xOrigin - v.x);
					decoratee.y = (e._gsTransform.yOrigin - v.y);
				} else {
					if (e.getBBox && !e.offsetWidth && (x + y).indexOf("%") !== -1) { //Firefox doesn't report offsetWidth/height on <svg> elements.
						e = e.getBBox();
						e = {offsetWidth: e.width, offsetHeight: e.height};
					}
					decoratee.x = ((x.indexOf("%") !== -1) ? e.offsetWidth * parseFloat(x) / 100 : parseFloat(x));
					decoratee.y = ((y.indexOf("%") !== -1) ? e.offsetHeight * parseFloat(y) / 100 : parseFloat(y));

				}
				return decoratee;
			},
			_cache = function(e) { //computes some important values and stores them in a _gsCache object attached to the element itself so that we can optimize performance
				if (Draggable.cacheSVGData !== false && e._gsCache && e._gsCache.lastUpdate === TweenLite.ticker.frame) { //performance optimization. Assume that if the offsets are requested again on the same tick, we can just feed back the values we already calculated (no need to keep recalculating until another tick elapses).
					return e._gsCache;
				}
				var cache = e._gsCache = e._gsCache || {},
					cs = _getComputedStyle(e),
					isSVG = (e.getBBox && _isSVG(e)),
					isSVGRoot = ((e.nodeName + "").toLowerCase() === "svg"),
					curSVG;
				cache.isSVG = isSVG;
				cache.isSVGRoot = isSVGRoot;
				cache.borderBox = (cs.boxSizing === "border-box");
				cache.computedStyle = cs;
				if (isSVGRoot) {
					if (!(cache.offsetParent = e.offsetParent)) { //some browsers don't report offsetParent for SVG elements.
						e.parentNode.insertBefore(_tempDiv, e);
						cache.offsetParent = _tempDiv.offsetParent;
						e.parentNode.removeChild(_tempDiv);
					}
				} else if (isSVG) {
					curSVG = e.parentNode;
					while (curSVG && (curSVG.nodeName + "").toLowerCase() !== "svg") { //offsetParent is always the SVG canvas for SVG elements.
						curSVG = curSVG.parentNode;
					}
					cache.offsetParent = curSVG;
				}
				return cache;
			},
			_getOffset2DMatrix = function(e, offsetOrigin, parentOffsetOrigin, zeroOrigin) {
				if (e === window || !e || !e.style || !e.parentNode) {
					return [1,0,0,1,0,0];
				}
				var cache = e._gsCache || _cache(e),
					parent = e.parentNode,
					parentCache = parent._gsCache || _cache(parent),
					cs = cache.computedStyle,
					parentOffsetParent = cache.isSVG ? parentCache.offsetParent : parent.offsetParent,
					m, isRoot, offsets, rect, t, sx, sy, offsetX, offsetY, parentRect, borderTop, borderLeft, borderTranslateX, borderTranslateY;
				m = (cache.isSVG && (e.style[_transformProp] + "").indexOf("matrix") !== -1) ? e.style[_transformProp] : cs ? cs.getPropertyValue(_transformPropCSS) : e.currentStyle ? e.currentStyle[_transformProp] : "1,0,0,1,0,0"; //some browsers (like Chrome 40) don't correctly report transforms that are applied inline on an SVG element (they don't get included in the computed style), so we double-check here and accept matrix values

				if (e.getBBox && (e.getAttribute("transform") + "").indexOf("matrix") !== -1) { //SVG can store transform data in its "transform" attribute instead of the CSS, so look for that here (only accept matrix()).
					m = e.getAttribute("transform");
				}
				m = (m + "").match(/(?:\-|\b)[\d\-\.e]+\b/g) || [1,0,0,1,0,0];
				if (m.length > 6) {
					m = [m[0], m[1], m[4], m[5], m[12], m[13]];
				}
				if (zeroOrigin) {
					m[4] = m[5] = 0;
				} else if (cache.isSVG && (t = e._gsTransform) && (t.xOrigin || t.yOrigin)) {
					//SVGs handle origin very differently. Factor in GSAP's handling of origin values here:
					m[0] = parseFloat(m[0]);
					m[1] = parseFloat(m[1]);
					m[2] = parseFloat(m[2]);
					m[3] = parseFloat(m[3]);
					m[4] = parseFloat(m[4]) - (t.xOrigin - (t.xOrigin * m[0] + t.yOrigin * m[2]));
					m[5] = parseFloat(m[5]) - (t.yOrigin - (t.xOrigin * m[1] + t.yOrigin * m[3]));
				}
				if (offsetOrigin) {
					if (_svgBorderFactor === undefined) {
						_setEnvironmentVariables();
					}
					offsets = (cache.isSVG || cache.isSVGRoot) ? _getSVGOffsets(e) : e;
					if (cache.isSVG) { //don't just rely on "instanceof _SVGElement" because if the SVG is embedded via an object tag, it won't work (SVGElement is mapped to a different object))
						rect = e.getBBox();
						parentRect = (parentCache.isSVGRoot) ? {x:0, y:0} : parent.getBBox();
						offsets = {offsetLeft:rect.x - parentRect.x, offsetTop:rect.y - parentRect.y, offsetParent:cache.offsetParent};
					} else if (cache.isSVGRoot) {
						borderTop = parseInt(cs.borderTopWidth, 10) || 0;
						borderLeft = parseInt(cs.borderLeftWidth, 10) || 0;
						borderTranslateX = ((m[0] - _svgBorderFactor) * borderLeft + m[2] * borderTop);
						borderTranslateY = (m[1] * borderLeft + (m[3] - _svgBorderFactor) * borderTop);

						sx = offsetOrigin.x;
						sy = offsetOrigin.y;
						offsetX = (sx - (sx * m[0] + sy * m[2])); //accommodate the SVG root's transforms when the origin isn't in the top left.
						offsetY = (sy - (sx * m[1] + sy * m[3]));

						m[4] = parseFloat(m[4]) + offsetX;
						m[5] = parseFloat(m[5]) + offsetY;
						offsetOrigin.x -= offsetX;
						offsetOrigin.y -= offsetY;
						sx = offsets.scaleX;
						sy = offsets.scaleY;
						offsetOrigin.x *= sx;
						offsetOrigin.y *= sy;
						m[0] *= sx;
						m[1] *= sy;
						m[2] *= sx;
						m[3] *= sy;

						if (!_isIE10orBelow) {
							offsetOrigin.x += borderTranslateX;
							offsetOrigin.y += borderTranslateY;
						}
					} else if (!_hasBorderBug && e.offsetParent) {
						offsetOrigin.x += parseInt(_getStyle(e.offsetParent, "borderLeftWidth"), 10) || 0;
						offsetOrigin.y += parseInt(_getStyle(e.offsetParent, "borderTopWidth"), 10) || 0;
					}
					isRoot = (parent === _docElement || parent === _doc.body);
					m[4] = Number(m[4]) + offsetOrigin.x + (offsets.offsetLeft || 0) - parentOffsetOrigin.x - (isRoot ? 0 : parent.scrollLeft || 0);
					m[5] = Number(m[5]) + offsetOrigin.y + (offsets.offsetTop || 0) - parentOffsetOrigin.y - (isRoot ? 0 : parent.scrollTop || 0);
					if (parent && _getStyle(e, "position", cs) === "fixed") { //fixed position elements should factor in the scroll position of the document.
						m[4] += _getDocScrollLeft();
						m[5] += _getDocScrollTop();
					}
					if (parent && parent !== _docElement && parentOffsetParent === offsets.offsetParent) {
						m[4] -= parent.offsetLeft || 0;
						m[5] -= parent.offsetTop || 0;
						if (!_hasBorderBug && parent.offsetParent && !cache.isSVG && !cache.isSVGRoot) {
							m[4] -= parseInt(_getStyle(parent.offsetParent, "borderLeftWidth"), 10) || 0;
							m[5] -= parseInt(_getStyle(parent.offsetParent, "borderTopWidth"), 10) || 0;
						}
					}
				}
				return m;
			},
			_getConcatenatedMatrix = function(e, invert) {
				if (!e || e === window || !e.parentNode) {
					return [1,0,0,1,0,0];
				}
				//note: we keep reusing _point1 and _point2 in order to minimize memory usage and garbage collection chores.
				var originOffset = _getOffsetTransformOrigin(e, _point1),
					parentOriginOffset = _getOffsetTransformOrigin(e.parentNode, _point2),
					m = _getOffset2DMatrix(e, originOffset, parentOriginOffset),
					a, b, c, d, tx, ty, m2, determinant;
				while ((e = e.parentNode) && e.parentNode && e !== _docElement) {
					originOffset = parentOriginOffset;
					parentOriginOffset = _getOffsetTransformOrigin(e.parentNode, (originOffset === _point1) ? _point2 : _point1);
					m2 = _getOffset2DMatrix(e, originOffset, parentOriginOffset);
					a = m[0];
					b = m[1];
					c = m[2];
					d = m[3];
					tx = m[4];
					ty = m[5];
					m[0] = a * m2[0] + b * m2[2];
					m[1] = a * m2[1] + b * m2[3];
					m[2] = c * m2[0] + d * m2[2];
					m[3] = c * m2[1] + d * m2[3];
					m[4] = tx * m2[0] + ty * m2[2] + m2[4];
					m[5] = tx * m2[1] + ty * m2[3] + m2[5];
				}
				if (invert) {
					a = m[0];
					b = m[1];
					c = m[2];
					d = m[3];
					tx = m[4];
					ty = m[5];
					determinant = (a * d - b * c);
					m[0] = d / determinant;
					m[1] = -b / determinant;
					m[2] = -c / determinant;
					m[3] = a / determinant;
					m[4] = (c * ty - d * tx) / determinant;
					m[5] = -(a * ty - b * tx) / determinant;
				}
				return m;
			},
			_localToGlobal = function(e, p, fromTopLeft, decoratee, zeroOrigin) {
				e = _unwrapElement(e);
				var m = _getConcatenatedMatrix(e, false, zeroOrigin),
					x = p.x,
					y = p.y;
				if (fromTopLeft) {
					_getOffsetTransformOrigin(e, p);
					x -= p.x;
					y -= p.y;
				}
				decoratee = (decoratee === true) ? p : decoratee || {};
				decoratee.x = x * m[0] + y * m[2] + m[4];
				decoratee.y = x * m[1] + y * m[3] + m[5];
				return decoratee;
			},
			_localizePoint = function(p, localToGlobal, globalToLocal) {
				var x = p.x * localToGlobal[0] + p.y * localToGlobal[2] + localToGlobal[4],
					y = p.x * localToGlobal[1] + p.y * localToGlobal[3] + localToGlobal[5];
				p.x = x * globalToLocal[0] + y * globalToLocal[2] + globalToLocal[4];
				p.y = x * globalToLocal[1] + y * globalToLocal[3] + globalToLocal[5];
				return p;
			},

			_getElementBounds = function(e, context, fromTopLeft) {
				if (!(e = _unwrapElement(e))) {
					return null;
				}
				context = _unwrapElement(context);
				var isSVG = (e.getBBox && _isSVG(e)),
					origin, left, right, top, bottom, mLocalToGlobal, mGlobalToLocal, p1, p2, p3, p4, bbox, width, height, cache, borderLeft, borderTop, viewBox, viewBoxX, viewBoxY, computedDimensions, cs;
				if (e === window) {
					top = _getDocScrollTop();
					left = _getDocScrollLeft();
					right = left + (_docElement.clientWidth || e.innerWidth || _doc.body.clientWidth || 0);
					bottom = top + (((e.innerHeight || 0) - 20 < _docElement.clientHeight) ? _docElement.clientHeight : e.innerHeight || _doc.body.clientHeight || 0); //some browsers (like Firefox) ignore absolutely positioned elements, and collapse the height of the documentElement, so it could be 8px, for example, if you have just an absolutely positioned div. In that case, we use the innerHeight to resolve this.
				} else if (context === undefined || context === window) {
					return e.getBoundingClientRect();
				} else {
					origin = _getOffsetTransformOrigin(e);
					left = -origin.x;
					top = -origin.y;
					if (isSVG) {
						bbox = e.getBBox();
						width = bbox.width;
						height = bbox.height;
					} else if (e.offsetWidth) {
						width = e.offsetWidth;
						height = e.offsetHeight;
					} else {
						computedDimensions = _getComputedStyle(e);
						width = parseFloat(computedDimensions.width);
						height = parseFloat(computedDimensions.height);
					}
					right = left + width;
					bottom = top + height;
					if (e.nodeName.toLowerCase() === "svg" && !_isOldIE) { //root SVG elements are a special beast because they have 2 types of scaling - transforms on themselves as well as the stretching of the SVG canvas itself based on the outer size and the viewBox. If, for example, the SVG's viewbox is "0 0 100 100" but the CSS is set to width:200px; height:200px, that'd make it appear at 2x scale even though the element itself has no CSS transforms but the offsetWidth/offsetHeight are based on that css, not the viewBox so we need to adjust them accordingly.
						cache = _getSVGOffsets(e);
						cs = cache.computedStyle || {};
						viewBox = (e.getAttribute("viewBox") || "0 0").split(" ");
						viewBoxX = parseFloat(viewBox[0]);
						viewBoxY = parseFloat(viewBox[1]);
						borderLeft = parseFloat(cs.borderLeftWidth) || 0;
						borderTop = parseFloat(cs.borderTopWidth) || 0;
						right -= width - ((width - borderLeft) / cache.scaleX) - viewBoxX;
						bottom -= height - ((height - borderTop) / cache.scaleY) - viewBoxY;
						left -= borderLeft / cache.scaleX - viewBoxX;
						top -= borderTop / cache.scaleY - viewBoxY;
						if (computedDimensions) { //when we had to use computed styles, factor in the border now.
							right += (parseFloat(cs.borderRightWidth) + borderLeft) / cache.scaleX;
							bottom += (borderTop + parseFloat(cs.borderBottomWidth)) / cache.scaleY;
						}
					}
				}
				if (e === context) {
					return {left:left, top:top, width: right - left, height: bottom - top};
				}
				mLocalToGlobal = _getConcatenatedMatrix(e);
				mGlobalToLocal = _getConcatenatedMatrix(context, true);
				p1 = _localizePoint({x:left, y:top}, mLocalToGlobal, mGlobalToLocal);
				p2 = _localizePoint({x:right, y:top}, mLocalToGlobal, mGlobalToLocal);
				p3 = _localizePoint({x:right, y:bottom}, mLocalToGlobal, mGlobalToLocal);
				p4 = _localizePoint({x:left, y:bottom}, mLocalToGlobal, mGlobalToLocal);
				left = Math.min(p1.x, p2.x, p3.x, p4.x);
				top = Math.min(p1.y, p2.y, p3.y, p4.y);
				_temp1.x = _temp1.y = 0;
				if (fromTopLeft) {
					_getOffsetTransformOrigin(context, _temp1);
				}
				return {left:left + _temp1.x, top:top + _temp1.y, width:Math.max(p1.x, p2.x, p3.x, p4.x) - left, height:Math.max(p1.y, p2.y, p3.y, p4.y) - top};
			},
			// end matrix and point conversion methods



			_isArrayLike = function(e) {
				return (e.length && e[0] && ((e[0].nodeType && e[0].style && !e.nodeType) || (e[0].length && e[0][0]))) ? true : false; //could be an array of jQuery objects too, so accommodate that.
			},

			_flattenArray = function(a) {
				var result = [],
					l = a.length,
					i, e, j;
				for (i = 0; i < l; i++) {
					e = a[i];
					if (_isArrayLike(e)) {
						j = e.length;
						for (j = 0; j < e.length; j++) {
							result.push(e[j]);
						}
					} else {
						result.push(e);
					}
				}
				return result;
			},

			_isTouchDevice = (("ontouchstart" in _docElement) && ("orientation" in window)),
			_touchEventLookup = (function(types) { //we create an object that makes it easy to translate touch event types into their "pointer" counterparts if we're in a browser that uses those instead. Like IE10 uses "MSPointerDown" instead of "touchstart", for example.
				var standard = types.split(","),
					converted = ((_tempDiv.onpointerdown !== undefined) ? "pointerdown,pointermove,pointerup,pointercancel" : (_tempDiv.onmspointerdown !== undefined) ? "MSPointerDown,MSPointerMove,MSPointerUp,MSPointerCancel" : types).split(","),
					obj = {},
					i = 8;
				while (--i > -1) {
					obj[standard[i]] = converted[i];
					obj[converted[i]] = standard[i];
				}
				return obj;
			}("touchstart,touchmove,touchend,touchcancel")),

			_addListener = function(element, type, func, capture) {
				if (element.addEventListener) {
					element.addEventListener(_touchEventLookup[type] || type, func, capture);
				} else if (element.attachEvent) {
					element.attachEvent("on" + type, func);
				}
			},

			_removeListener = function(element, type, func) {
				if (element.removeEventListener) {
					element.removeEventListener(_touchEventLookup[type] || type, func);
				} else if (element.detachEvent) {
					element.detachEvent("on" + type, func);
				}
			},

			_hasTouchID = function(list, ID) {
				var i = list.length;
				while (--i > -1) {
					if (list[i].identifier === ID) {
						return true;
					}
				}
				return false;
			},

			_onMultiTouchDocumentEnd = function(e) {
				_isMultiTouching = (e.touches && _dragCount < e.touches.length);
				_removeListener(e.target, "touchend", _onMultiTouchDocumentEnd);
			},

			_onMultiTouchDocument = function(e) {
				_isMultiTouching = (e.touches && _dragCount < e.touches.length);
				_addListener(e.target, "touchend", _onMultiTouchDocumentEnd);
			},

			_parseThrowProps = function(draggable, snap, max, min, factor, forceZeroVelocity) {
				var vars = {},
					a, i, l;
				if (snap) {
					if (factor !== 1 && snap instanceof Array) { //some data must be altered to make sense, like if the user passes in an array of rotational values in degrees, we must convert it to radians. Or for scrollLeft and scrollTop, we invert the values.
						vars.end = a = [];
						l = snap.length;
						for (i = 0; i < l; i++) {
							a[i] = snap[i] * factor;
						}
						max += 1.1; //allow 1.1 pixels of wiggle room when snapping in order to work around some browser inconsistencies in the way bounds are reported which can make them roughly a pixel off. For example, if "snap:[-$('#menu').width(), 0]" was defined and #menu had a wrapper that was used as the bounds, some browsers would be one pixel off, making the minimum -752 for example when snap was [-753,0], thus instead of snapping to -753, it would snap to 0 since -753 was below the minimum.
						min -= 1.1;
					} else if (typeof(snap) === "function") {
						vars.end = function(value) {
							return snap.call(draggable, value) * factor; //we need to ensure that we can scope the function call to the Draggable instance itself so that users can access important values like maxX, minX, maxY, minY, x, and y from within that function.
						};
					} else {
						vars.end = snap;
					}
				}
				if (max || max === 0) {
					vars.max = max;
				}
				if (min || min === 0) {
					vars.min = min;
				}
				if (forceZeroVelocity) {
					vars.velocity = 0;
				}
				return vars;
			},

			_isClickable = function(e) { //sometimes it's convenient to mark an element as clickable by adding a data-clickable="true" attribute (in which case we won't preventDefault() the mouse/touch event). This method checks if the element is an <a>, <input>, or <button> or has an onclick or has the data-clickable or contentEditable attribute set to true (or any of its parent elements).
				var data;
				return (!e || !e.getAttribute || e.nodeName === "BODY") ? false : ((data = e.getAttribute("data-clickable")) === "true" || (data !== "false" && (e.onclick || _clickableTagExp.test(e.nodeName + "") || e.getAttribute("contentEditable") === "true"))) ? true : _isClickable(e.parentNode);
			},

			_setSelectable = function(elements, selectable) {
				var i = elements.length,
					e;
				while (--i > -1) {
					e = elements[i];
					e.ondragstart = e.onselectstart = selectable ? null : _emptyFunc;
					_setStyle(e, "userSelect", (selectable ? "text" : "none"));
				}
			},

			_addPaddingBR,
			_addPaddingLeft = (function() { //this function is in charge of analyzing browser behavior related to padding. It sets the _addPaddingBR to true if the browser doesn't normally factor in the bottom or right padding on the element inside the scrolling area, and it sets _addPaddingLeft to true if it's a browser that requires the extra offset (offsetLeft) to be added to the paddingRight (like Opera).
				var div = _doc.createElement("div"),
					child = _doc.createElement("div"),
					childStyle = child.style,
					parent = _doc.body || _tempDiv,
					val;
				childStyle.display = "inline-block";
				childStyle.position = "relative";
				div.style.cssText = child.innerHTML = "width:90px; height:40px; padding:10px; overflow:auto; visibility: hidden";
				div.appendChild(child);
				parent.appendChild(div);
				_addPaddingBR = (child.offsetHeight + 18 > div.scrollHeight); //div.scrollHeight should be child.offsetHeight + 20 because of the 10px of padding on each side, but some browsers ignore one side. We allow a 2px margin of error.
				childStyle.width = "100%";
				if (!_transformProp) {
					childStyle.paddingRight = "500px";
					val = div.scrollLeft = div.scrollWidth - div.clientWidth;
					childStyle.left = "-90px";
					val = (val !== div.scrollLeft);
				}
				parent.removeChild(div);
				return val;
			}()),




			//The ScrollProxy class wraps an element's contents into another div (we call it "content") that we either add padding when necessary or apply a translate3d() transform in order to overscroll (scroll past the boundaries). This allows us to simply set the scrollTop/scrollLeft (or top/left for easier reverse-axis orientation, which is what we do in Draggable) and it'll do all the work for us. For example, if we tried setting scrollTop to -100 on a normal DOM element, it wouldn't work - it'd look the same as setting it to 0, but if we set scrollTop of a ScrollProxy to -100, it'll give the correct appearance by either setting paddingTop of the wrapper to 100 or applying a 100-pixel translateY.
			ScrollProxy = function(element, vars) {
				element = _unwrapElement(element);
				vars = vars || {};
				var content = _doc.createElement("div"),
					style = content.style,
					node = element.firstChild,
					offsetTop = 0,
					offsetLeft = 0,
					prevTop = element.scrollTop,
					prevLeft = element.scrollLeft,
					scrollWidth = element.scrollWidth,
					scrollHeight = element.scrollHeight,
					extraPadRight = 0,
					maxLeft = 0,
					maxTop = 0,
					elementWidth, elementHeight, contentHeight, nextNode, transformStart, transformEnd;

				if (_supports3D && vars.force3D !== false) {
					transformStart = "translate3d(";
					transformEnd = "px,0px)";
				} else if (_transformProp) {
					transformStart = "translate(";
					transformEnd = "px)";
				}

				this.scrollTop = function(value, force) {
					if (!arguments.length) {
						return -this.top();
					}
					this.top(-value, force);
				};

				this.scrollLeft = function(value, force) {
					if (!arguments.length) {
						return -this.left();
					}
					this.left(-value, force);
				};

				this.left = function(value, force) {
					if (!arguments.length) {
						return -(element.scrollLeft + offsetLeft);
					}
					var dif = element.scrollLeft - prevLeft,
						oldOffset = offsetLeft;
					if ((dif > 2 || dif < -2) && !force) { //if the user interacts with the scrollbar (or something else scrolls it, like the mouse wheel), we should kill any tweens of the ScrollProxy.
						prevLeft = element.scrollLeft;
						TweenLite.killTweensOf(this, true, {left:1, scrollLeft:1});
						this.left(-prevLeft);
						if (vars.onKill) {
							vars.onKill();
						}
						return;
					}
					value = -value; //invert because scrolling works in the opposite direction
					if (value < 0) {
						offsetLeft = (value - 0.5) | 0;
						value = 0;
					} else if (value > maxLeft) {
						offsetLeft = (value - maxLeft) | 0;
						value = maxLeft;
					} else {
						offsetLeft = 0;
					}
					if (offsetLeft || oldOffset) {
						if (transformStart) {
							if (!this._suspendTransforms) {
								style[_transformProp] = transformStart + -offsetLeft + "px," + -offsetTop + transformEnd;
							}
						} else {
							style.left = -offsetLeft + "px";
						}
						if (_addPaddingLeft && offsetLeft + extraPadRight >= 0) {
							style.paddingRight = offsetLeft + extraPadRight + "px";
						}
					}
					element.scrollLeft = value | 0;
					prevLeft = element.scrollLeft; //don't merge this with the line above because some browsers adjsut the scrollLeft after it's set, so in order to be 100% accurate in tracking it, we need to ask the browser to report it.
				};

				this.top = function(value, force) {
					if (!arguments.length) {
						return -(element.scrollTop + offsetTop);
					}
					var dif = element.scrollTop - prevTop,
						oldOffset = offsetTop;
					if ((dif > 2 || dif < -2) && !force) { //if the user interacts with the scrollbar (or something else scrolls it, like the mouse wheel), we should kill any tweens of the ScrollProxy.
						prevTop = element.scrollTop;
						TweenLite.killTweensOf(this, true, {top:1, scrollTop:1});
						this.top(-prevTop);
						if (vars.onKill) {
							vars.onKill();
						}
						return;
					}
					value = -value; //invert because scrolling works in the opposite direction
					if (value < 0) {
						offsetTop = (value - 0.5) | 0;
						value = 0;
					} else if (value > maxTop) {
						offsetTop = (value - maxTop) | 0;
						value = maxTop;
					} else {
						offsetTop = 0;
					}
					if (offsetTop || oldOffset) {
						if (transformStart) {
							if (!this._suspendTransforms) {
								style[_transformProp] = transformStart + -offsetLeft + "px," + -offsetTop + transformEnd;
							}
						} else {
							style.top = -offsetTop + "px";
						}
					}
					element.scrollTop = value | 0;
					prevTop = element.scrollTop;
				};

				this.maxScrollTop = function() {
					return maxTop;
				};

				this.maxScrollLeft = function() {
					return maxLeft;
				};

				this.disable = function() {
					node = content.firstChild;
					while (node) {
						nextNode = node.nextSibling;
						element.appendChild(node);
						node = nextNode;
					}
					if (element === content.parentNode) { //in case disable() is called when it's already disabled.
						element.removeChild(content);
					}
				};

				this.enable = function() {
					node = element.firstChild;
					if (node === content) {
						return;
					}
					while (node) {
						nextNode = node.nextSibling;
						content.appendChild(node);
						node = nextNode;
					}
					element.appendChild(content);
					this.calibrate();
				};

				this.calibrate = function(force) {
					var widthMatches = (element.clientWidth === elementWidth),
						x, y;
					prevTop = element.scrollTop;
					prevLeft = element.scrollLeft;
					if (widthMatches && element.clientHeight === elementHeight && content.offsetHeight === contentHeight && scrollWidth === element.scrollWidth && scrollHeight === element.scrollHeight && !force) {
						return; //no need to recalculate things if the width and height haven't changed.
					}
					if (offsetTop || offsetLeft) {
						x = this.left();
						y = this.top();
						this.left(-element.scrollLeft);
						this.top(-element.scrollTop);
					}
					//first, we need to remove any width constraints to see how the content naturally flows so that we can see if it's wider than the containing element. If so, we've got to record the amount of overage so that we can apply that as padding in order for browsers to correctly handle things. Then we switch back to a width of 100% (without that, some browsers don't flow the content correctly)
					if (!widthMatches || force) {
						style.display = "block";
						style.width = "auto";
						style.paddingRight = "0px";
						extraPadRight = Math.max(0, element.scrollWidth - element.clientWidth);
						//if the content is wider than the container, we need to add the paddingLeft and paddingRight in order for things to behave correctly.
						if (extraPadRight) {
							extraPadRight += _getStyle(element, "paddingLeft") + (_addPaddingBR ? _getStyle(element, "paddingRight") : 0);
						}
					}
					style.display = "inline-block";
					style.position = "relative";
					style.overflow = "visible";
					style.verticalAlign = "top";
					style.width = "100%";
					style.paddingRight = extraPadRight + "px";
					//some browsers neglect to factor in the bottom padding when calculating the scrollHeight, so we need to add that padding to the content when that happens. Allow a 2px margin for error
					if (_addPaddingBR) {
						style.paddingBottom = _getStyle(element, "paddingBottom", true);
					}
					if (_isOldIE) {
						style.zoom = "1";
					}
					elementWidth = element.clientWidth;
					elementHeight = element.clientHeight;
					scrollWidth = element.scrollWidth;
					scrollHeight = element.scrollHeight;
					maxLeft = element.scrollWidth - elementWidth;
					maxTop = element.scrollHeight - elementHeight;
					contentHeight = content.offsetHeight;
					style.display = "block";
					if (x || y) {
						this.left(x);
						this.top(y);
					}
				};

				this.content = content;
				this.element = element;
				this._suspendTransforms = false;
				this.enable();
			},





			Draggable = function(target, vars) {
				EventDispatcher.call(this, target);
				target = _unwrapElement(target); //in case the target is a selector object or selector text
				if (!ThrowPropsPlugin) {
					ThrowPropsPlugin = _globals.com.greensock.plugins.ThrowPropsPlugin;
				}
				this.vars = vars = vars || {};
				this.target = target;
				this.x = this.y = this.rotation = 0;
				this.dragResistance = parseFloat(vars.dragResistance) || 0;
				this.edgeResistance = isNaN(vars.edgeResistance) ? 1 : parseFloat(vars.edgeResistance) || 0;
				this.lockAxis = vars.lockAxis;
				this.autoScroll = vars.autoScroll || 0;
				this.lockedAxis = null;
				this.allowEventDefault = !!vars.allowEventDefault;
				var type = (vars.type || (_isOldIE ? "top,left" : "x,y")).toLowerCase(),
					xyMode = (type.indexOf("x") !== -1 || type.indexOf("y") !== -1),
					rotationMode = (type.indexOf("rotation") !== -1),
					xProp = rotationMode ? "rotation" : xyMode ? "x" : "left",
					yProp = xyMode ? "y" : "top",
					allowX = (type.indexOf("x") !== -1 || type.indexOf("left") !== -1 || type === "scroll"),
					allowY = (type.indexOf("y") !== -1 || type.indexOf("top") !== -1 || type === "scroll"),
					minimumMovement = vars.minimumMovement || 2,
					self = this,
					triggers = _slice(vars.trigger || vars.handle || target),
					killProps = {},
					dragEndTime = 0,
					checkAutoScrollBounds = false,
					isClickable = vars.clickableTest || _isClickable,
					enabled, scrollProxy, startPointerX, startPointerY, startElementX, startElementY, hasBounds, hasDragCallback, maxX, minX, maxY, minY, tempVars, cssVars, touch, touchID, rotationOrigin, dirty, old, snapX, snapY, isClicking, touchEventTarget, matrix, interrupted, clickTime, startScrollTop, startScrollLeft, applyObj, allowNativeTouchScrolling, touchDragAxis,

					//this method gets called on every tick of TweenLite.ticker which allows us to synchronize the renders to the core engine (which is typically synchronized with the display refresh via requestAnimationFrame). This is an optimization - it's better than applying the values inside the "mousemove" or "touchmove" event handler which may get called many times inbetween refreshes.
					render = function(suppressEvents) {
						if (self.autoScroll && self.isDragging && (dirty || checkAutoScrollBounds)) {
							var e = target,
								autoScrollFactor = self.autoScroll * 15, //multiplying by 15 just gives us a better "feel" speed-wise.
								parent, isRoot, rect, pointerX, pointerY, changeX, changeY, gap;
							checkAutoScrollBounds = false;
							_windowProxy.scrollTop = ((window.pageYOffset != null) ? window.pageYOffset : (_docElement.scrollTop != null) ? _docElement.scrollTop : _doc.body.scrollTop);
							_windowProxy.scrollLeft = ((window.pageXOffset != null) ? window.pageXOffset : (_docElement.scrollLeft != null) ? _docElement.scrollLeft : _doc.body.scrollLeft);
							pointerX = self.pointerX - _windowProxy.scrollLeft;
							pointerY = self.pointerY - _windowProxy.scrollTop;
							while (e && !isRoot) { //walk up the chain and sense wherever the pointer is within 40px of an edge that's scrollable.
								isRoot = _isRoot(e.parentNode);
								parent = isRoot ? _windowProxy : e.parentNode;
								rect = isRoot ? {bottom:Math.max(_docElement.clientHeight, window.innerHeight || 0), right: Math.max(_docElement.clientWidth, window.innerWidth || 0), left:0, top:0} : parent.getBoundingClientRect();
								changeX = changeY = 0;
								if (allowY) {
									if (pointerY > rect.bottom - 40 && (gap = parent._gsMaxScrollY - parent.scrollTop)) {
										checkAutoScrollBounds = true;
										changeY = Math.min(gap, (autoScrollFactor * (1 - Math.max(0, (rect.bottom - pointerY)) / 40)) | 0);
									} else if (pointerY < rect.top + 40 && parent.scrollTop) {
										checkAutoScrollBounds = true;
										changeY = -Math.min(parent.scrollTop, (autoScrollFactor * (1 - Math.max(0, (pointerY - rect.top)) / 40)) | 0);
									}
									if (changeY) {
										parent.scrollTop += changeY;
									}
								}

								if (allowX) {
									if (pointerX > rect.right - 40 && (gap = parent._gsMaxScrollX - parent.scrollLeft)) {
										checkAutoScrollBounds = true;
										changeX = Math.min(gap, (autoScrollFactor * (1 - Math.max(0, (rect.right - pointerX)) / 40)) | 0);
									} else if (pointerX < rect.left + 40 && parent.scrollLeft) {
										checkAutoScrollBounds = true;
										changeX = -Math.min(parent.scrollLeft, (autoScrollFactor * (1 - Math.max(0, (pointerX - rect.left)) / 40)) | 0);
									}
									if (changeX) {
										parent.scrollLeft += changeX;
									}
								}

								if (isRoot && (changeX || changeY)) {
									window.scrollTo(parent.scrollLeft, parent.scrollTop);
									setPointerPosition(self.pointerX + changeX, self.pointerY + changeY);
								}
								e = parent;
							}
						}
						if (dirty) {
							var x = self.x,
								y = self.y,
								min = 0.000001;
							if (x < min && x > -min) { //browsers don't handle super small decimals well.
								x = 0;
							}
							if (y < min && y > -min) {
								y = 0;
							}
							if (rotationMode) {
								applyObj.data.rotation = self.rotation = x;
								applyObj.setRatio(1); //note: instead of doing TweenLite.set(), as a performance optimization we skip right to the method that renders the transforms inside CSSPlugin. For old versions of IE, though, we do a normal TweenLite.set() to leverage its ability to re-reroute to an IE-specific 2D renderer.
							} else {
								if (scrollProxy) {
									if (allowY) {
										scrollProxy.top(y);
									}
									if (allowX) {
										scrollProxy.left(x);
									}
								} else if (xyMode) {
									if (allowY) {
										applyObj.data.y = y;
									}
									if (allowX) {
										applyObj.data.x = x;
									}
									applyObj.setRatio(1); //note: instead of doing TweenLite.set(), as a performance optimization we skip right to the method that renders the transforms inside CSSPlugin. For old versions of IE, though, we do a normal TweenLite.set() to leverage its ability to re-reroute to an IE-specific 2D renderer.
								} else {
									if (allowY) {
										target.style.top = y + "px";
									}
									if (allowX) {
										target.style.left = x + "px";
									}
								}
							}
							if (hasDragCallback && !suppressEvents) {
								_dispatchEvent(self, "drag", "onDrag");
							}
						}
						dirty = false;
					},

					//copies the x/y from the element (whether that be transforms, top/left, or ScrollProxy's top/left) to the Draggable's x and y (and rotation if necessary) properties so that they reflect reality and it also (optionally) applies any snapping necessary. This is used by the ThrowPropsPlugin tween in an onUpdate to ensure things are synced and snapped.
					syncXY = function(skipOnUpdate, skipSnap) {
						var snappedValue;
						if (!target._gsTransform && (xyMode || rotationMode)) { //just in case the _gsTransform got wiped, like if the user called clearProps on the transform or something (very rare), doing an x tween forces a re-parsing of the transforms and population of the _gsTransform.
							TweenLite.set(target, {x:"+=0", overwrite:false});
						}
						if (xyMode) {
							self.y = target._gsTransform.y;
							self.x = target._gsTransform.x;
						} else if (rotationMode) {
							self.x = self.rotation = target._gsTransform.rotation;
						} else if (scrollProxy) {
							self.y = scrollProxy.top();
							self.x = scrollProxy.left();
						} else {
							self.y = parseInt(target.style.top, 10) || 0;
							self.x = parseInt(target.style.left, 10) || 0;
						}
						if ((snapX || snapY) && !skipSnap) {
							if (snapX) {
								snappedValue = snapX(self.x);
								if (snappedValue !== self.x) {
									self.x = snappedValue;
									if (rotationMode) {
										self.rotation = snappedValue;
									}
									dirty = true;
								}
							}
							if (snapY) {
								snappedValue = snapY(self.y);
								if (snappedValue !== self.y) {
									self.y = snappedValue;
									dirty = true;
								}
							}
							if (dirty) {
								render(true);
							}
						}
						if (!skipOnUpdate) {
							_dispatchEvent(self, "throwupdate", "onThrowUpdate");
						}
					},

					calculateBounds = function() {
						var bounds, targetBounds, snap, snapIsRaw;
						hasBounds = false;
						if (scrollProxy) {
							scrollProxy.calibrate();
							self.minX = minX = -scrollProxy.maxScrollLeft();
							self.minY = minY = -scrollProxy.maxScrollTop();
							self.maxX = maxX = self.maxY = maxY = 0;
							hasBounds = true;
						} else if (!!vars.bounds) {
							bounds = _getBounds(vars.bounds, target.parentNode); //could be a selector/jQuery object or a DOM element or a generic object like {top:0, left:100, width:1000, height:800} or {minX:100, maxX:1100, minY:0, maxY:800}
							if (rotationMode) {
								self.minX = minX = bounds.left;
								self.maxX = maxX = bounds.left + bounds.width;
								self.minY = minY = self.maxY = maxY = 0;
							} else if (vars.bounds.maxX !== undefined || vars.bounds.maxY !== undefined) {
								bounds = vars.bounds;
								self.minX = minX = bounds.minX;
								self.minY = minY = bounds.minY;
								self.maxX = maxX = bounds.maxX;
								self.maxY = maxY = bounds.maxY;
							} else {
								targetBounds = _getBounds(target, target.parentNode);
								self.minX = minX = _getStyle(target, xProp) + bounds.left - targetBounds.left;
								self.minY = minY = _getStyle(target, yProp) + bounds.top - targetBounds.top;
								self.maxX = maxX = minX + (bounds.width - targetBounds.width);
								self.maxY = maxY = minY + (bounds.height - targetBounds.height);
							}
							if (minX > maxX) {
								self.minX = maxX;
								self.maxX = maxX = minX;
								minX = self.minX;
							}
							if (minY > maxY) {
								self.minY = maxY;
								self.maxY = maxY = minY;
								minY = self.minY;
							}
							if (rotationMode) {
								self.minRotation = minX;
								self.maxRotation = maxX;
							}
							hasBounds = true;
						}
						if (vars.liveSnap) {
							snap = (vars.liveSnap === true) ? (vars.snap || {}) : vars.liveSnap;
							snapIsRaw = (snap instanceof Array || typeof(snap) === "function");
							if (rotationMode) {
								snapX = buildSnapFunc((snapIsRaw ? snap : snap.rotation), minX, maxX, 1);
								snapY = null;
							} else {
								if (allowX) {
									snapX = buildSnapFunc((snapIsRaw ? snap : snap.x || snap.left || snap.scrollLeft), minX, maxX, scrollProxy ? -1 : 1);
								}
								if (allowY) {
									snapY = buildSnapFunc((snapIsRaw ? snap : snap.y || snap.top || snap.scrollTop), minY, maxY, scrollProxy ? -1 : 1);
								}
							}
						}

					},

					onThrowComplete = function() {
						self.isThrowing = false;
						_dispatchEvent(self, "throwcomplete", "onThrowComplete");
					},
					onThrowOverwrite = function() {
						self.isThrowing = false;
					},

					animate = function(throwProps, forceZeroVelocity) {
						var snap, snapIsRaw, tween, overshootTolerance;
						if (throwProps && ThrowPropsPlugin) {
							if (throwProps === true) {
								snap = vars.snap || {};
								snapIsRaw = (snap instanceof Array || typeof(snap) === "function");
								throwProps = {resistance:(vars.throwResistance || vars.resistance || 1000) / (rotationMode ? 10 : 1)};
								if (rotationMode) {
									throwProps.rotation = _parseThrowProps(self, snapIsRaw ? snap : snap.rotation, maxX, minX, 1, forceZeroVelocity);
								} else {
									if (allowX) {
										throwProps[xProp] = _parseThrowProps(self, snapIsRaw ? snap : snap.x || snap.left || snap.scrollLeft, maxX, minX, scrollProxy ? -1 : 1, forceZeroVelocity || (self.lockedAxis === "x"));
									}
									if (allowY) {
										throwProps[yProp] = _parseThrowProps(self, snapIsRaw ? snap : snap.y || snap.top || snap.scrollTop, maxY, minY, scrollProxy ? -1 : 1, forceZeroVelocity || (self.lockedAxis === "y"));
									}
								}
							}
							self.isThrowing = true;
							overshootTolerance = (!isNaN(vars.overshootTolerance)) ? vars.overshootTolerance : (vars.edgeResistance === 1) ? 0 : (1 - self.edgeResistance) + 0.2;
							self.tween = tween = ThrowPropsPlugin.to(scrollProxy || target, {throwProps:throwProps, ease:(vars.ease || _globals.Power3.easeOut), onComplete:onThrowComplete, onOverwrite:onThrowOverwrite, onUpdate:(vars.fastMode ? _dispatchEvent : syncXY), onUpdateParams:(vars.fastMode ? [self, "onthrowupdate", "onThrowUpdate"] : _emptyArray)}, (isNaN(vars.maxDuration) ? 2 : vars.maxDuration), (!isNaN(vars.minDuration) ? vars.minDuration : (overshootTolerance === 0) ? 0 : 0.5), overshootTolerance);
							if (!vars.fastMode) {
								//to populate the end values, we just scrub the tween to the end, record the values, and then jump back to the beginning.
								if (scrollProxy) {
									scrollProxy._suspendTransforms = true; //Microsoft browsers have a bug that causes them to briefly render the position incorrectly (it flashes to the end state when we seek() the tween even though we jump right back to the current position, and this only seems to happen when we're affecting both top and left), so we set a _suspendTransforms flag to prevent it from actually applying the values in the ScrollProxy.
								}
								tween.render(tween.duration(), true, true);
								syncXY(true, true);
								self.endX = self.x;
								self.endY = self.y;
								if (rotationMode) {
									self.endRotation = self.x;
								}
								tween.play(0);
								syncXY(true, true);
								if (scrollProxy) {
									scrollProxy._suspendTransforms = false;
								}
							}
						} else if (hasBounds) {
							self.applyBounds();
						}
					},

					updateMatrix = function() {
						matrix = _getConcatenatedMatrix(target.parentNode, true);
						if (!matrix[1] && !matrix[2] && matrix[0] == 1 && matrix[3] == 1 && matrix[4] == 0 && matrix[5] == 0) { //if there are no transforms, we can optimize performance by not factoring in the matrix
							matrix = null;
						}
					},

					recordStartPositions = function() {
						var edgeTolerance = 1 - self.edgeResistance;
						updateMatrix();
						if (scrollProxy) {
							calculateBounds();
							startElementY = scrollProxy.top();
							startElementX = scrollProxy.left();
						} else {
							//if the element is in the process of tweening, don't force snapping to occur because it could make it jump. Imagine the user throwing, then before it's done, clicking on the element in its inbetween state.
							if (isTweening()) {
								syncXY(true, true);
								calculateBounds();
							} else {
								self.applyBounds();
							}
							if (rotationMode) {
								rotationOrigin = _localToGlobal(target, {x:0, y:0});
								syncXY(true, true);
								startElementX = self.x; //starting rotation (x always refers to rotation in type:"rotation", measured in degrees)
								startElementY = self.y = Math.atan2(rotationOrigin.y - startPointerY, startPointerX - rotationOrigin.x) * _RAD2DEG;
							} else {
								startScrollTop = target.parentNode ? target.parentNode.scrollTop || 0 : 0;
								startScrollLeft = target.parentNode ? target.parentNode.scrollLeft || 0 : 0;
								startElementY = _getStyle(target, yProp); //record the starting top and left values so that we can just add the mouse's movement to them later.
								startElementX = _getStyle(target, xProp);
							}
						}
						if (hasBounds && edgeTolerance) {
							if (startElementX > maxX) {
								startElementX = maxX + (startElementX - maxX) / edgeTolerance;
							} else if (startElementX < minX) {
								startElementX = minX - (minX - startElementX) / edgeTolerance;
							}
							if (!rotationMode) {
								if (startElementY > maxY) {
									startElementY = maxY + (startElementY - maxY) / edgeTolerance;
								} else if (startElementY < minY) {
									startElementY = minY - (minY - startElementY) / edgeTolerance;
								}
							}
						}
					},

					isTweening = function() {
						return (self.tween && self.tween.isActive());
					},

					buildSnapFunc = function(snap, min, max, factor) {
						if (typeof(snap) === "function") {
							return function(n) {
								var edgeTolerance = !self.isPressed ? 1 : 1 - self.edgeResistance; //if we're tweening, disable the edgeTolerance because it's already factored into the tweening values (we don't want to apply it multiple times)
								return snap.call(self, (n > max ? max + (n - max) * edgeTolerance : (n < min) ? min + (n - min) * edgeTolerance : n)) * factor;
							};
						}
						if (snap instanceof Array) {
							return function(n) {
								var i = snap.length,
									closest = 0,
									absDif = _max,
									val, dif;
								while (--i > -1) {
									val = snap[i];
									dif = val - n;
									if (dif < 0) {
										dif = -dif;
									}
									if (dif < absDif && val >= min && val <= max) {
										closest = i;
										absDif = dif;
									}
								}
								return snap[closest];
							};
						}
						return isNaN(snap) ? function(n) { return n; } : function() { return snap * factor; };
					},

					//called when the mouse is pressed (or touch starts)
					onPress = function(e) {
						var temp, i;
						if (!enabled || self.isPressed || !e || (e.type === "mousedown" && _getTime() - clickTime < 30 && _touchEventLookup[self.pointerEvent.type])) { //when we DON'T preventDefault() in order to accommodate touch-scrolling and the user just taps, many browsers also fire a mousedown/mouseup sequence AFTER the touchstart/touchend sequence, thus it'd result in two quick "click" events being dispatched. This line senses that condition and halts it on the subsequent mousedown.
							return;
						}
						interrupted = isTweening();
						self.pointerEvent = e;
						if (_touchEventLookup[e.type]) { //note: on iOS, BOTH touchmove and mousemove are dispatched, but the mousemove has pageY and pageX of 0 which would mess up the calculations and needlessly hurt performance.
							touchEventTarget = (e.type.indexOf("touch") !== -1) ? e.currentTarget : _doc; //pointer-based touches (for Microsoft browsers) don't remain locked to the original target like other browsers, so we must use the document instead. The event type would be "MSPointerDown" or "pointerdown".
							_addListener(touchEventTarget, "touchend", onRelease);
							_addListener(touchEventTarget, "touchmove", onMove);
							_addListener(touchEventTarget, "touchcancel", onRelease);
							_addListener(_doc, "touchstart", _onMultiTouchDocument);
						} else {
							touchEventTarget = null;
							_addListener(_doc, "mousemove", onMove); //attach these to the document instead of the box itself so that if the user's mouse moves too quickly (and off of the box), things still work.
						}
						touchDragAxis = null;
						_addListener(_doc, "mouseup", onRelease);
						if (e && e.target) {
							_addListener(e.target, "mouseup", onRelease); //we also have to listen directly on the element because some browsers don't bubble up the event to the _doc on elements with contentEditable="true"
						}
						isClicking = (isClickable.call(self, e.target) && !vars.dragClickables);
						if (isClicking) {
							_addListener(e.target, "change", onRelease); //in some browsers, when you mousedown on a <select> element, no mouseup gets dispatched! So we listen for a "change" event instead.
							_dispatchEvent(self, "press", "onPress");
							_setSelectable(triggers, true); //accommodates things like inputs and elements with contentEditable="true" (otherwise user couldn't drag to select text)
							return;
						}
						allowNativeTouchScrolling = (!touchEventTarget || allowX === allowY || scrollProxy || self.vars.allowNativeTouchScrolling === false) ? false : allowX ? "y" : "x";
						if (_isOldIE) {
							e = _populateIEEvent(e, true);
						} else if (!allowNativeTouchScrolling && !self.allowEventDefault) {
							e.preventDefault();
							if (e.preventManipulation) {
								e.preventManipulation();  //for some Microsoft browsers
							}
						}
						if (e.changedTouches) { //touch events store the data slightly differently
							e = touch = e.changedTouches[0];
							touchID = e.identifier;
						} else if (e.pointerId) {
							touchID = e.pointerId; //for some Microsoft browsers
						} else {
							touch = touchID = null;
						}
						_dragCount++;
						_addToRenderQueue(render); //causes the Draggable to render on each "tick" of TweenLite.ticker (performance optimization - updating values in a mousemove can cause them to happen too frequently, like multiple times between frame redraws which is wasteful, and it also prevents values from updating properly in IE8)
						startPointerY = self.pointerY = e.pageY; //record the starting x and y so that we can calculate the movement from the original in _onMouseMove
						startPointerX = self.pointerX = e.pageX;
						if (allowNativeTouchScrolling || self.autoScroll) {
							_recordMaxScrolls(target.parentNode);
						}
						if (self.autoScroll && !rotationMode && !scrollProxy && target.parentNode && !target.getBBox && target.parentNode._gsMaxScrollX && !_placeholderDiv.parentNode) {//add a placeholder div to prevent the parent container from collapsing when the user drags the element left.
							_placeholderDiv.style.width = (target.parentNode.scrollWidth) + "px";
							target.parentNode.appendChild(_placeholderDiv);
						}
						recordStartPositions();
						if (matrix) {
							temp = startPointerX * matrix[0] + startPointerY * matrix[2] + matrix[4];
							startPointerY = startPointerX * matrix[1] + startPointerY * matrix[3] + matrix[5];
							startPointerX = temp;
						}
						if (self.tween) {
							self.tween.kill();
						}
						self.isThrowing = false;
						TweenLite.killTweensOf(scrollProxy || target, true, killProps); //in case the user tries to drag it before the last tween is done.
						if (scrollProxy) {
							TweenLite.killTweensOf(target, true, {scrollTo:1}); //just in case the original target's scroll position is being tweened somewhere else.
						}
						self.tween = self.lockedAxis = null;
						if (vars.zIndexBoost || (!rotationMode && !scrollProxy && vars.zIndexBoost !== false)) {
							target.style.zIndex = Draggable.zIndex++;
						}
						self.isPressed = true;
						hasDragCallback = !!(vars.onDrag || self._listeners.drag);
						if (!rotationMode) {
							i = triggers.length;
							while (--i > -1) {
								_setStyle(triggers[i], "cursor", vars.cursor || "move");
							}
						}
						_dispatchEvent(self, "press", "onPress");
					},

					//called every time the mouse/touch moves
					onMove = function(e) {
						var originalEvent = e,
							touches, pointerX, pointerY, i;
						if (!enabled || _isMultiTouching || !self.isPressed || !e) {
							return;
						}
						self.pointerEvent = e;
						touches = e.changedTouches;
						if (touches) { //touch events store the data slightly differently
							e = touches[0];
							if (e !== touch && e.identifier !== touchID) { //Usually changedTouches[0] will be what we're looking for, but in case it's not, look through the rest of the array...(and Android browsers don't reuse the event like iOS)
								i = touches.length;
								while (--i > -1 && (e = touches[i]).identifier !== touchID) {}
								if (i < 0) {
									return;
								}
							}
						} else if (e.pointerId && touchID && e.pointerId !== touchID) { //for some Microsoft browsers, we must attach the listener to the doc rather than the trigger so that when the finger moves outside the bounds of the trigger, things still work. So if the event we're receiving has a pointerId that doesn't match the touchID, ignore it (for multi-touch)
							return;
						}
						if (_isOldIE) {
							e = _populateIEEvent(e, true);
						} else {
							if (touchEventTarget && allowNativeTouchScrolling && !touchDragAxis) { //Android browsers force us to decide on the first "touchmove" event if we should allow the default (scrolling) behavior or preventDefault(). Otherwise, a "touchcancel" will be fired and then no "touchmove" or "touchend" will fire during the scrolling (no good).
								pointerX = e.pageX;
								pointerY = e.pageY;
								if (matrix) {
									i = pointerX * matrix[0] + pointerY * matrix[2] + matrix[4];
									pointerY = pointerX * matrix[1] + pointerY * matrix[3] + matrix[5];
									pointerX = i;
								}
								touchDragAxis = (Math.abs(pointerX - startPointerX) > Math.abs(pointerY - startPointerY) && allowX) ? "x" : "y";
								if (self.vars.lockAxisOnTouchScroll !== false) {
									self.lockedAxis = (touchDragAxis === "x") ? "y" : "x";
									if (typeof(self.vars.onLockAxis) === "function") {
										self.vars.onLockAxis.call(self, originalEvent);
									}
								}
								if (_isAndroid && allowNativeTouchScrolling === touchDragAxis) {
									onRelease(originalEvent);
									return;
								}
							}
							if (!self.allowEventDefault && (!allowNativeTouchScrolling || (touchDragAxis && allowNativeTouchScrolling !== touchDragAxis)) && originalEvent.cancelable !== false) {
								originalEvent.preventDefault();
								if (originalEvent.preventManipulation) { //for some Microsoft browsers
									originalEvent.preventManipulation();
								}
							}
						}
						if (self.autoScroll) {
							checkAutoScrollBounds = true;
						}
						setPointerPosition(e.pageX, e.pageY);
					},

					setPointerPosition = function(pointerX, pointerY) {
						var dragTolerance = 1 - self.dragResistance,
							edgeTolerance = 1 - self.edgeResistance,
							xChange, yChange, x, y, dif, temp;

						self.pointerX = pointerX;
						self.pointerY = pointerY;

						if (rotationMode) {
							y = Math.atan2(rotationOrigin.y - pointerY, pointerX - rotationOrigin.x) * _RAD2DEG;
							dif = self.y - y;
							self.y = y;
							if (dif > 180) {
								startElementY -= 360;
							} else if (dif < -180) {
								startElementY += 360;
							}
							x = startElementX + (startElementY - y) * dragTolerance;

						} else {
							if (matrix) {
								temp = pointerX * matrix[0] + pointerY * matrix[2] + matrix[4];
								pointerY = pointerX * matrix[1] + pointerY * matrix[3] + matrix[5];
								pointerX = temp;
							}
							yChange = (pointerY - startPointerY);
							xChange = (pointerX - startPointerX);
							if (yChange < minimumMovement && yChange > -minimumMovement) {
								yChange = 0;
							}
							if (xChange < minimumMovement && xChange > -minimumMovement) {
								xChange = 0;
							}
							if ((self.lockAxis || self.lockedAxis) && (xChange || yChange)) {
								temp = self.lockedAxis;
								if (!temp) {
									self.lockedAxis = temp = (allowX && Math.abs(xChange) > Math.abs(yChange)) ? "y" : allowY ? "x" : null;
									if (temp && typeof(self.vars.onLockAxis) === "function") {
										self.vars.onLockAxis.call(self, self.pointerEvent);
									}
								}
								if (temp === "y") {
									yChange = 0;
								} else if (temp === "x") {
									xChange = 0;
								}
							}
							x = startElementX + xChange * dragTolerance;
							y = startElementY + yChange * dragTolerance;
						}

						if (snapX || snapY) {
							if (snapX) {
								x = snapX(x);
							}
							if (snapY) {
								y = snapY(y);
							}
						} else if (hasBounds) {
							if (x > maxX) {
								x = maxX + (x - maxX) * edgeTolerance;
							} else if (x < minX) {
								x = minX + (x - minX) * edgeTolerance;
							}
							if (!rotationMode) {
								if (y > maxY) {
									y = maxY + (y - maxY) * edgeTolerance;
								} else if (y < minY) {
									y = minY + (y - minY) * edgeTolerance;
								}
							}
						}
						if (!rotationMode) {
							x = Math.round(x); //helps work around an issue with some Win Touch devices
							y = Math.round(y);
						}
						if (self.x !== x || (self.y !== y && !rotationMode)) {
							if (rotationMode) {
								self.endRotation = self.x = self.endX = x;
							} else {
								if (allowY) {
									self.y = self.endY = y;
								}
								if (allowX) {
									self.x = self.endX = x;
								}
							}
							dirty = true; //a flag that indicates we need to render the target next time the TweenLite.ticker dispatches a "tick" event (typically on a requestAnimationFrame) - this is a performance optimization (we shouldn't render on every move because sometimes many move events can get dispatched between screen refreshes, and that'd be wasteful to render every time)
							if (!self.isDragging) {
								self.isDragging = true;
								_dispatchEvent(self, "dragstart", "onDragStart");
							}
						}
					},

					//called when the mouse/touch is released
					onRelease = function(e, force) {
						if (!enabled || !self.isPressed || (e && touchID != null && !force && ((e.pointerId && e.pointerId !== touchID) || (e.changedTouches && !_hasTouchID(e.changedTouches, touchID))))) {  //for some Microsoft browsers, we must attach the listener to the doc rather than the trigger so that when the finger moves outside the bounds of the trigger, things still work. So if the event we're receiving has a pointerId that doesn't match the touchID, ignore it (for multi-touch)
							return;
						}
						self.isPressed = false;
						var originalEvent = e,
							wasDragging = self.isDragging,
							touches, i, syntheticEvent, eventTarget;
						if (touchEventTarget) {
							_removeListener(touchEventTarget, "touchend", onRelease);
							_removeListener(touchEventTarget, "touchmove", onMove);
							_removeListener(touchEventTarget, "touchcancel", onRelease);
							_removeListener(_doc, "touchstart", _onMultiTouchDocument);
						} else {
							_removeListener(_doc, "mousemove", onMove);
						}
						_removeListener(_doc, "mouseup", onRelease);
						if (e && e.target) {
							_removeListener(e.target, "mouseup", onRelease);
						}
						dirty = false;
						if (_placeholderDiv.parentNode) { //_placeholderDiv just props open auto-scrolling containers so they don't collapse as the user drags left/up.
							_placeholderDiv.parentNode.removeChild(_placeholderDiv);
						}
						if (isClicking) {
							if (e) {
								_removeListener(e.target, "change", onRelease);
							}
							_setSelectable(triggers, false);
							_dispatchEvent(self, "release", "onRelease");
							_dispatchEvent(self, "click", "onClick");
							isClicking = false;
							return;
						}
						_removeFromRenderQueue(render);
						if (!rotationMode) {
							i = triggers.length;
							while (--i > -1) {
								_setStyle(triggers[i], "cursor", vars.cursor || "move");
							}
						}
						if (wasDragging) {
							dragEndTime = _lastDragTime = _getTime();
							self.isDragging = false;
						}
						_dragCount--;
						if (e) {
							if (_isOldIE) {
								e = _populateIEEvent(e, false);
							}
							touches = e.changedTouches;
							if (touches) { //touch events store the data slightly differently
								e = touches[0];
								if (e !== touch && e.identifier !== touchID) { //Usually changedTouches[0] will be what we're looking for, but in case it's not, look through the rest of the array...(and Android browsers don't reuse the event like iOS)
									i = touches.length;
									while (--i > -1 && (e = touches[i]).identifier !== touchID) {}
									if (i < 0) {
										return;
									}
								}
							}
							self.pointerEvent = originalEvent;
							self.pointerX = e.pageX;
							self.pointerY = e.pageY;
						}
						if (originalEvent && !wasDragging) {
							if (interrupted && (vars.snap || vars.bounds)) { //otherwise, if the user clicks on the object while it's animating to a snapped position, and then releases without moving 3 pixels, it will just stay there (it should animate/snap)
								animate(vars.throwProps);
							}
							_dispatchEvent(self, "release", "onRelease");
							if (!_isAndroid || originalEvent.type !== "touchmove") { //to accommodate native scrolling on Android devices, we have to immediately call onRelease() on the first touchmove event, but that shouldn't trigger a "click".
								_dispatchEvent(self, "click", "onClick");
								eventTarget = originalEvent.target || originalEvent.srcElement || target; //old IE uses srcElement
								if (eventTarget.click) { //some browsers (like mobile Safari) don't properly trigger the click event
									eventTarget.click();
								}
								else if (_doc.createEvent) {
									syntheticEvent = _doc.createEvent("MouseEvents");
									syntheticEvent.initEvent("click", true, true);
									eventTarget.dispatchEvent(syntheticEvent);
								}
								clickTime = _getTime();
							}
						} else {
							animate(vars.throwProps); //will skip if throwProps isn't defined or ThrowPropsPlugin isn't loaded.
							if (!_isOldIE && !self.allowEventDefault && originalEvent && (vars.dragClickables || !isClickable.call(self, originalEvent.target)) && wasDragging && (!allowNativeTouchScrolling || (touchDragAxis && allowNativeTouchScrolling === touchDragAxis)) && originalEvent.cancelable !== false) {
								originalEvent.preventDefault();
								if (originalEvent.preventManipulation) {
									originalEvent.preventManipulation();  //for some Microsoft browsers
								}
							}
							_dispatchEvent(self, "release", "onRelease");
						}
						if (wasDragging) {
							_dispatchEvent(self, "dragend", "onDragEnd");
						}
						return true;
					},

					updateScroll = function(e) {
						if (e && self.isDragging) {
							var parent = e.target || e.srcElement || target.parentNode,
								deltaX = parent.scrollLeft - parent._gsScrollX,
								deltaY = parent.scrollTop - parent._gsScrollY;
							if (deltaX || deltaY) {
								startPointerX -= deltaX;
								startPointerY -= deltaY;
								parent._gsScrollX += deltaX;
								parent._gsScrollY += deltaY;
								setPointerPosition(self.pointerX, self.pointerY);
							}
						}
					},

					onClick = function(e) {
						var time = _getTime(),
							recentlyClicked = time - clickTime < 40,
							recentlyDragged = time - dragEndTime < 40;
						if (self.isPressed || recentlyDragged || recentlyClicked) {
							if (e.preventDefault) {
								e.preventDefault();
								if (recentlyClicked || (recentlyDragged && self.vars.suppressClickOnDrag !== false)) {
									e.stopImmediatePropagation(); //otherwise some browsers bubble up click events, creating a duplicate.
								}
							} else {
								e.returnValue = false;
							}
							if (e.preventManipulation) {
								e.preventManipulation();  //for some Microsoft browsers
							}
						}
					};

				old = Draggable.get(this.target);
				if (old) {
					old.kill(); // avoids duplicates (an element can only be controlled by one Draggable)
				}

				//give the user access to start/stop dragging...
				this.startDrag = function(e) {
					onPress(e);
					if (!self.isDragging) {
						self.isDragging = true;
						_dispatchEvent(self, "dragstart", "onDragStart");
					}
				};
				this.drag = onMove;
				this.endDrag = function(e) {
					onRelease(e, true);
				};
				this.timeSinceDrag = function() {
					return self.isDragging ? 0 : (_getTime() - dragEndTime) / 1000;
				};
				this.hitTest = function(target, threshold) {
					return Draggable.hitTest(self.target, target, threshold);
				};

				this.getDirection = function(from, diagonalThreshold) { //from can be "start" (default), "velocity", or an element
					var mode = (from === "velocity" && ThrowPropsPlugin) ? from : (typeof(from) === "object" && !rotationMode) ? "element" : "start",
						xChange, yChange, ratio, direction, r1, r2;
					if (mode === "element") {
						r1 = _parseRect(self.target);
						r2 = _parseRect(from);
					}
					xChange = (mode === "start") ? self.x - startElementX : (mode === "velocity") ? ThrowPropsPlugin.getVelocity(this.target, xProp) : (r1.left + r1.width / 2) - (r2.left + r2.width / 2);
					if (rotationMode) {
						return xChange < 0 ? "counter-clockwise" : "clockwise";
					} else {
						diagonalThreshold = diagonalThreshold || 2;
						yChange = (mode === "start") ? self.y - startElementY : (mode === "velocity") ? ThrowPropsPlugin.getVelocity(this.target, yProp) : (r1.top + r1.height / 2) - (r2.top + r2.height / 2);
						ratio = Math.abs(xChange / yChange);
						direction = (ratio < 1 / diagonalThreshold) ? "" : (xChange < 0) ? "left" : "right";
						if (ratio < diagonalThreshold) {
							if (direction !== "") {
								direction += "-";
							}
							direction += (yChange < 0) ? "up" : "down";
						}
					}
					return direction;
				};


				this.applyBounds = function(newBounds) {
					var x, y;
					if (newBounds && vars.bounds !== newBounds) {
						vars.bounds = newBounds;
						return self.update(true);
					}
					syncXY(true);
					calculateBounds();
					if (hasBounds) {
						x = self.x;
						y = self.y;
						if (hasBounds) {
							if (x > maxX) {
								x = maxX;
							} else if (x < minX) {
								x = minX;
							}
							if (y > maxY) {
								y = maxY;
							} else if (y < minY) {
								y = minY;
							}
						}
						if (self.x !== x || self.y !== y) {
							self.x = self.endX = x;
							if (rotationMode) {
								self.endRotation = x;
							} else {
								self.y = self.endY = y;
							}
							dirty = true;
							render();
						}
					}
					return self;
				};

				this.update = function(applyBounds) {
					var x = self.x,
						y = self.y;
					updateMatrix();
					if (applyBounds) {
						self.applyBounds();
					} else {
						if (dirty) {
							render();
						}
						syncXY(true);
					}
					if (self.isPressed && ((allowX && Math.abs(x - self.x) > 0.01) || (allowY && (Math.abs(y - self.y) > 0.01 && !rotationMode)))) {
						recordStartPositions();
					}
					return self;
				};

				this.enable = function(type) {
					var id, i, trigger;
					if (type !== "soft") {
						i = triggers.length;
						while (--i > -1) {
							trigger = triggers[i];
							_addListener(trigger, "mousedown", onPress);
							_addListener(trigger, "touchstart", onPress);
							_addListener(trigger, "click", onClick, true);
							if (!rotationMode) {
								_setStyle(trigger, "cursor", vars.cursor || "move");
							}
							_setStyle(trigger, "touchCallout", "none");
							_setStyle(trigger, "touchAction", (allowX === allowY || scrollProxy) ? "none" : allowX ? "pan-y" : "pan-x");
						}
						_setSelectable(triggers, false);
					}
					_addScrollListener(self.target, updateScroll);
					enabled = true;
					if (ThrowPropsPlugin && type !== "soft") {
						ThrowPropsPlugin.track(scrollProxy || target, (xyMode ? "x,y" : rotationMode ? "rotation" : "top,left"));
					}
					if (scrollProxy) {
						scrollProxy.enable();
					}
					target._gsDragID = id = "d" + (_lookupCount++);
					_lookup[id] = this;
					if (scrollProxy) {
						scrollProxy.element._gsDragID = id;
					}
					TweenLite.set(target, {x:"+=0", overwrite:false}); //simply ensures that there's a _gsTransform on the element.
					applyObj = {
						t:target,
						data:_isOldIE ? cssVars : target._gsTransform,
						tween:{},
						setRatio:(_isOldIE ? function() { TweenLite.set(target, tempVars); } : CSSPlugin._internals.setTransformRatio || CSSPlugin._internals.set3DTransformRatio)
					};
					this.update(true);
					return self;
				};

				this.disable = function(type) {
					var dragging = this.isDragging,
						i, trigger;
					if (!rotationMode) {
						i = triggers.length;
						while (--i > -1) {
							_setStyle(triggers[i], "cursor", null);
						}
					}
					if (type !== "soft") {
						i = triggers.length;
						while (--i > -1) {
							trigger = triggers[i];
							_setStyle(trigger, "touchCallout", null);
							_setStyle(trigger, "touchAction", null);
							_removeListener(trigger, "mousedown", onPress);
							_removeListener(trigger, "touchstart", onPress);
							_removeListener(trigger, "click", onClick);
						}
						_setSelectable(triggers, true);
						if (touchEventTarget) {
							_removeListener(touchEventTarget, "touchcancel", onRelease);
							_removeListener(touchEventTarget, "touchend", onRelease);
							_removeListener(touchEventTarget, "touchmove", onMove);
						}
						_removeListener(_doc, "mouseup", onRelease);
						_removeListener(_doc, "mousemove", onMove);
					}
					_removeScrollListener(target, updateScroll);
					enabled = false;
					if (ThrowPropsPlugin && type !== "soft") {
						ThrowPropsPlugin.untrack(scrollProxy || target, (xyMode ? "x,y" : rotationMode ? "rotation" : "top,left"));
					}
					if (scrollProxy) {
						scrollProxy.disable();
					}
					_removeFromRenderQueue(render);
					this.isDragging = this.isPressed = isClicking = false;
					if (dragging) {
						_dispatchEvent(this, "dragend", "onDragEnd");
					}
					return self;
				};

				this.enabled = function(value, type) {
					return arguments.length ? (value ? this.enable(type) : this.disable(type)) : enabled;
				};

				this.kill = function() {
					self.isThrowing = false;
					TweenLite.killTweensOf(scrollProxy || target, true, killProps);
					self.disable();
					delete _lookup[target._gsDragID];
					return self;
				};

				if (type.indexOf("scroll") !== -1) {
					scrollProxy = this.scrollProxy = new ScrollProxy(target, _extend({onKill:function() { //ScrollProxy's onKill() gets called if/when the ScrollProxy senses that the user interacted with the scroll position manually (like using the scrollbar). IE9 doesn't fire the "mouseup" properly when users drag the scrollbar of an element, so this works around that issue.
						if (self.isPressed) {
							onRelease(null);
						}}}, vars));
					//a bug in many Android devices' stock browser causes scrollTop to get forced back to 0 after it is altered via JS, so we set overflow to "hidden" on mobile/touch devices (they hide the scroll bar anyway). That works around the bug. (This bug is discussed at https://code.google.com/p/android/issues/detail?id=19625)
					target.style.overflowY = (allowY && !_isTouchDevice) ? "auto" : "hidden";
					target.style.overflowX = (allowX && !_isTouchDevice) ? "auto" : "hidden";
					target = scrollProxy.content;
				}

				if (vars.force3D !== false) {
					TweenLite.set(target, {force3D:true}); //improve performance by forcing a GPU layer when possible
				}
				if (rotationMode) {
					killProps.rotation = 1;
				} else {
					if (allowX) {
						killProps[xProp] = 1;
					}
					if (allowY) {
						killProps[yProp] = 1;
					}
				}
				if (rotationMode) {
					tempVars = _tempVarsRotation;
					cssVars = tempVars.css;
					tempVars.overwrite = false;
				} else if (xyMode) {
					tempVars = (allowX && allowY) ? _tempVarsXY : allowX ? _tempVarsX : _tempVarsY;
					cssVars = tempVars.css;
					tempVars.overwrite = false;
				}

				this.enable();
			},
			p = Draggable.prototype = new EventDispatcher();

		p.constructor = Draggable;
		p.pointerX = p.pointerY = 0;
		p.isDragging = p.isPressed = false;
		Draggable.version = "0.14.0";
		Draggable.zIndex = 1000;

		_addListener(_doc, "touchcancel", function() {
			//some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document. Very strange indeed.
		});
		_addListener(_doc, "contextmenu", function(e) {
			var p;
			for (p in _lookup) {
				if (_lookup[p].isPressed) {
					_lookup[p].endDrag();
				}
			}
		});

		Draggable.create = function(targets, vars) {
			if (typeof(targets) === "string") {
				targets = TweenLite.selector(targets);
			}
			var a = _isArrayLike(targets) ? _flattenArray(targets) : [targets],
				i = a.length;
			while (--i > -1) {
				a[i] = new Draggable(a[i], vars);
			}
			return a;
		};

		Draggable.get = function(target) {
			return _lookup[(_unwrapElement(target) || {})._gsDragID];
		};

		Draggable.timeSinceDrag = function() {
			return (_getTime() - _lastDragTime) / 1000;
		};

		var _tempRect = {}, //reuse to reduce garbage collection tasks
			_parseRect = function(e, undefined) { //accepts a DOM element, a mouse event, or a rectangle object and returns the corresponding rectangle with left, right, width, height, top, and bottom properties
				if (e === window) {
					_tempRect.left = _tempRect.top = 0;
					_tempRect.width = _tempRect.right = _docElement.clientWidth || e.innerWidth || _doc.body.clientWidth || 0;
					_tempRect.height = _tempRect.bottom = ((e.innerHeight || 0) - 20 < _docElement.clientHeight) ? _docElement.clientHeight : e.innerHeight || _doc.body.clientHeight || 0;
					return _tempRect;
				}
				var r = (e.pageX !== undefined) ? {left:e.pageX, top:e.pageY, right:e.pageX + 1, bottom:e.pageY + 1} : (!e.nodeType && e.left !== undefined && e.top !== undefined) ? e : _unwrapElement(e).getBoundingClientRect();
				if (r.right === undefined && r.width !== undefined) {
					r.right = r.left + r.width;
					r.bottom = r.top + r.height;
				} else if (r.width === undefined) { //some browsers don't include width and height properties. We can't just set them directly on r because some browsers throw errors, so create a new generic object.
					r = {width: r.right - r.left, height: r.bottom - r.top, right: r.right, left: r.left, bottom: r.bottom, top: r.top};
				}
				return r;
			};

		Draggable.hitTest = function(obj1, obj2, threshold) {
			if (obj1 === obj2) {
				return false;
			}
			var r1 = _parseRect(obj1),
				r2 = _parseRect(obj2),
				isOutside = (r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top),
				overlap, area, isRatio;
			if (isOutside || !threshold) {
				return !isOutside;
			}
			isRatio = ((threshold + "").indexOf("%") !== -1);
			threshold = parseFloat(threshold) || 0;
			overlap = {left:Math.max(r1.left, r2.left), top:Math.max(r1.top, r2.top)};
			overlap.width = Math.min(r1.right, r2.right) - overlap.left;
			overlap.height = Math.min(r1.bottom, r2.bottom) - overlap.top;
			if (overlap.width < 0 || overlap.height < 0) {
				return false;
			}
			if (isRatio) {
				threshold *= 0.01;
				area = overlap.width * overlap.height;
				return (area >= r1.width * r1.height * threshold || area >= r2.width * r2.height * threshold);
			}
			return (overlap.width > threshold && overlap.height > threshold);
		};

		_placeholderDiv.style.cssText = "visibility:hidden;height:1px;top:-1px;pointer-events:none;position:relative;clear:both;";

		return Draggable;

	}, true);


}); if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); }

//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
(function(name) {
	"use strict";
	var getGlobal = function() {
		return (_gsScope.GreenSockGlobals || _gsScope)[name];
	};
	if (typeof(define) === "function" && define.amd) { //AMD
		define(["TweenLite"], getGlobal);
	} else if (typeof(module) !== "undefined" && module.exports) { //node
		require("../TweenLite.js");
		require("../plugins/CSSPlugin.js");
		module.exports = getGlobal();
	}
}("Draggable"));
/*!
 * VERSION: 0.0.7
 * DATE: 2015-10-06
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2015, GreenSock. All rights reserved.
 * DrawSVGPlugin is a Club GreenSock membership benefit; You must have a valid membership to use
 * this code without violating the terms of use. Visit http://greensock.com/club/ to sign up or get more details.
 * This work is subject to the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";function a(a,b,c,d){return c=parseFloat(c)-parseFloat(a),d=parseFloat(d)-parseFloat(b),Math.sqrt(c*c+d*d)}function b(a){return"string"!=typeof a&&a.nodeType||(a=_gsScope.TweenLite.selector(a),a.length&&(a=a[0])),a}function c(a,b,c){var d,e,f=a.indexOf(" ");return-1===f?(d=void 0!==c?c+"":a,e=a):(d=a.substr(0,f),e=a.substr(f+1)),d=-1!==d.indexOf("%")?parseFloat(d)/100*b:parseFloat(d),e=-1!==e.indexOf("%")?parseFloat(e)/100*b:parseFloat(e),d>e?[e,d]:[d,e]}function d(c){if(!c)return 0;c=b(c);var d,e,f,g,h,i,j,k,l=c.tagName.toLowerCase();if("path"===l)h=c.style.strokeDasharray,c.style.strokeDasharray="none",d=c.getTotalLength()||0,e=c.getBBox(),c.style.strokeDasharray=h;else if("rect"===l)e=c.getBBox(),d=2*(e.width+e.height);else if("circle"===l)d=2*Math.PI*parseFloat(c.getAttribute("r"));else if("line"===l)d=a(c.getAttribute("x1"),c.getAttribute("y1"),c.getAttribute("x2"),c.getAttribute("y2"));else if("polyline"===l||"polygon"===l)for(f=c.getAttribute("points").split(" "),d=0,h=f[0].split(","),"polygon"===l&&(f.push(f[0]),-1===f[0].indexOf(",")&&f.push(f[1])),i=1;i<f.length;i++)g=f[i].split(","),1===g.length&&(g[1]=f[i++]),2===g.length&&(d+=a(h[0],h[1],g[0],g[1])||0,h=g);else"ellipse"===l&&(j=parseFloat(c.getAttribute("rx")),k=parseFloat(c.getAttribute("ry")),d=Math.PI*(3*(j+k)-Math.sqrt((3*j+k)*(j+3*k))));return d||0}function e(a,c){if(!a)return[0,0];a=b(a),c=c||d(a)+1;var e=g(a),f=e.strokeDasharray||"",h=parseFloat(e.strokeDashoffset),i=f.indexOf(",");return 0>i&&(i=f.indexOf(" ")),f=0>i?c:parseFloat(f.substr(0,i))||1e-5,f>c&&(f=c),[Math.max(0,-h),Math.max(0,f-h)]}var f,g=document.defaultView?document.defaultView.getComputedStyle:function(){};f=_gsScope._gsDefine.plugin({propName:"drawSVG",API:2,version:"0.0.7",global:!0,overwriteProps:["drawSVG"],init:function(a,b,f){if(!a.getBBox)return!1;var g,h,i,j=d(a)+1;return this._style=a.style,b===!0||"true"===b?b="0 100%":b?-1===(b+"").indexOf(" ")&&(b="0 "+b):b="0 0",g=e(a,j),h=c(b,j,g[0]),this._length=j+10,0===g[0]&&0===h[0]?(i=Math.max(1e-5,h[1]-j),this._dash=j+i,this._offset=j-g[1]+i,this._addTween(this,"_offset",this._offset,j-h[1]+i,"drawSVG")):(this._dash=g[1]-g[0]||1e-6,this._offset=-g[0],this._addTween(this,"_dash",this._dash,h[1]-h[0]||1e-5,"drawSVG"),this._addTween(this,"_offset",this._offset,-h[0],"drawSVG")),!0},set:function(a){this._firstPT&&(this._super.setRatio.call(this,a),this._style.strokeDashoffset=this._offset,1===a||0===a?this._style.strokeDasharray=this._offset<.001&&this._length-this._dash<=10?"none":this._offset===this._dash?"0px, 999999px":this._dash+"px,"+this._length+"px":this._style.strokeDasharray=this._dash+"px,"+this._length+"px")}}),f.getLength=d,f.getPosition=e}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()();
/*!
 * VERSION: 0.8.0
 * DATE: 2015-12-11
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2015, GreenSock. All rights reserved.
 * MorphSVGPlugin is a Club GreenSock membership benefit; You must have a valid membership to use
 * this code without violating the terms of use. Visit http://greensock.com/club/ to sign up or get more details.
 * This work is subject to the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";var a=Math.PI/180,b=180/Math.PI,c=/[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,d=/(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,e=/[achlmqstvz]/gi,f=_gsScope.TweenLite,g=function(a){window.console&&console.log(a)},h=function(b,c){var d,e,f,g,h,i,j=Math.ceil(Math.abs(c)/90),k=0,l=[];for(b*=a,c*=a,d=c/j,e=4/3*Math.sin(d/2)/(1+Math.cos(d/2)),i=0;j>i;i++)f=b+i*d,g=Math.cos(f),h=Math.sin(f),l[k++]=g-e*h,l[k++]=h+e*g,f+=d,g=Math.cos(f),h=Math.sin(f),l[k++]=g+e*h,l[k++]=h-e*g,l[k++]=g,l[k++]=h;return l},i=function(c,d,e,f,g,i,j,k,l){if(c!==k||d!==l){e=Math.abs(e),f=Math.abs(f);var m=g%360*a,n=Math.cos(m),o=Math.sin(m),p=(c-k)/2,q=(d-l)/2,r=n*p+o*q,s=-o*p+n*q,t=e*e,u=f*f,v=r*r,w=s*s,x=v/t+w/u;x>1&&(e=Math.sqrt(x)*e,f=Math.sqrt(x)*f,t=e*e,u=f*f);var y=i===j?-1:1,z=(t*u-t*w-u*v)/(t*w+u*v);0>z&&(z=0);var A=y*Math.sqrt(z),B=A*(e*s/f),C=A*-(f*r/e),D=(c+k)/2,E=(d+l)/2,F=D+(n*B-o*C),G=E+(o*B+n*C),H=(r-B)/e,I=(s-C)/f,J=(-r-B)/e,K=(-s-C)/f,L=Math.sqrt(H*H+I*I),M=H;y=0>I?-1:1;var N=y*Math.acos(M/L)*b;L=Math.sqrt((H*H+I*I)*(J*J+K*K)),M=H*J+I*K,y=0>H*K-I*J?-1:1;var O=y*Math.acos(M/L)*b;!j&&O>0?O-=360:j&&0>O&&(O+=360),O%=360,N%=360;var P,Q,R,S=h(N,O),T=n*e,U=o*e,V=o*-f,W=n*f,X=S.length-2;for(P=0;X>P;P+=2)Q=S[P],R=S[P+1],S[P]=Q*T+R*V+F,S[P+1]=Q*U+R*W+G;return S[S.length-2]=k,S[S.length-1]=l,S}},j=function(a){var b,d,e,f,h,j,k,l,m,n,o,p,q,r=(a+"").match(c)||[],s=[],t=0,u=0,v=r.length,w=2,x=0;if(!a||!isNaN(r[0])||isNaN(r[1]))return g("ERROR: malformed path data: "+a),s;for(b=0;v>b;b++)if(q=h,isNaN(r[b])?(h=r[b].toUpperCase(),j=h!==r[b]):b--,e=+r[b+1],f=+r[b+2],j&&(e+=t,f+=u),0===b&&(l=e,m=f),"M"===h)k&&k.length<8&&(s.length-=1,w=0),t=l=e,u=m=f,k=[e,f],x+=w,w=2,s.push(k),b+=2;else if("C"===h)k||(k=[0,0]),k[w++]=e,k[w++]=f,j||(t=u=0),k[w++]=t+1*r[b+3],k[w++]=u+1*r[b+4],k[w++]=t+=1*r[b+5],k[w++]=u+=1*r[b+6],b+=6;else if("S"===h)"C"===q||"S"===q?(n=t-k[w-4],o=u-k[w-3],k[w++]=t+n,k[w++]=u+o):(k[w++]=t,k[w++]=u),k[w++]=e,k[w++]=f,j||(t=u=0),k[w++]=t+=1*r[b+3],k[w++]=u+=1*r[b+4],b+=4;else if("Q"===h)n=e-t,o=f-u,k[w++]=t+2*n/3,k[w++]=u+2*o/3,j||(t=u=0),t+=1*r[b+3],u+=1*r[b+4],n=e-t,o=f-u,k[w++]=t+2*n/3,k[w++]=u+2*o/3,k[w++]=t,k[w++]=u,b+=4;else if("T"===h)n=t-k[w-4],o=u-k[w-3],k[w++]=t+n,k[w++]=u+o,n=t+1.5*n-e,o=u+1.5*o-f,k[w++]=e+2*n/3,k[w++]=f+2*o/3,k[w++]=t=e,k[w++]=u=f,b+=2;else if("H"===h)f=u,k[w++]=t+(e-t)/3,k[w++]=u+(f-u)/3,k[w++]=t+2*(e-t)/3,k[w++]=u+2*(f-u)/3,k[w++]=t=e,k[w++]=f,b+=1;else if("V"===h)f=e,e=t,j&&(f+=u-t),k[w++]=e,k[w++]=u+(f-u)/3,k[w++]=e,k[w++]=u+2*(f-u)/3,k[w++]=e,k[w++]=u=f,b+=1;else if("L"===h||"Z"===h)"Z"===h&&(e=l,f=m,k.closed=!0),("L"===h||Math.abs(t-e)>.5||Math.abs(u-f)>.5)&&(k[w++]=t+(e-t)/3,k[w++]=u+(f-u)/3,k[w++]=t+2*(e-t)/3,k[w++]=u+2*(f-u)/3,k[w++]=e,k[w++]=f,"L"===h&&(b+=2)),t=e,u=f;else if("A"===h){for(p=i(t,u,1*r[b+1],1*r[b+2],1*r[b+3],1*r[b+4],1*r[b+5],(j?t:0)+1*r[b+6],(j?u:0)+1*r[b+7]),d=0;d<p.length;d++)k[w++]=p[d];t=k[w-2],u=k[w-1],b+=7}else g("Error: malformed path data: "+a);return s.totalPoints=x+w,s},k=function(a,b){var c,d,e,f,g,h,i,j,k,l,m,n,o,p,q=0,r=.999999,s=a.length,t=b/((s-2)/6);for(o=2;s>o;o+=6)for(q+=t;q>r;)c=a[o-2],d=a[o-1],e=a[o],f=a[o+1],g=a[o+2],h=a[o+3],i=a[o+4],j=a[o+5],p=1/(Math.floor(q)+1),k=c+(e-c)*p,m=e+(g-e)*p,k+=(m-k)*p,m+=(g+(i-g)*p-m)*p,l=d+(f-d)*p,n=f+(h-f)*p,l+=(n-l)*p,n+=(h+(j-h)*p-n)*p,a.splice(o,4,c+(e-c)*p,d+(f-d)*p,k,l,k+(m-k)*p,l+(n-l)*p,m,n,g+(i-g)*p,h+(j-h)*p),o+=6,s+=6,q--;return a},l=function(a){var b,c,d,e,f="",g=a.length,h=100;for(c=0;g>c;c++){for(e=a[c],f+="M"+e[0]+","+e[1]+" C",b=e.length,d=2;b>d;d++)f+=(e[d++]*h|0)/h+","+(e[d++]*h|0)/h+" "+(e[d++]*h|0)/h+","+(e[d++]*h|0)/h+" "+(e[d++]*h|0)/h+","+(e[d]*h|0)/h+" ";e.closed&&(f+="z")}return f},m=function(a){for(var b=[],c=a.length-1,d=0;--c>-1;)b[d++]=a[c],b[d++]=a[c+1],c--;for(c=0;d>c;c++)a[c]=b[c];a.reversed=a.reversed?!1:!0},n=function(a){var b,c=a.length,d=0,e=0;for(b=0;c>b;b++)d+=a[b++],e+=a[b];return[d/(c/2),e/(c/2)]},o=function(a){var b,c,d,e=a.length,f=a[0],g=f,h=a[1],i=h;for(d=6;e>d;d+=6)b=a[d],c=a[d+1],b>f?f=b:g>b&&(g=b),c>h?h=c:i>c&&(i=c);return a.centerX=(f+g)/2,a.centerY=(h+i)/2,a.size=(f-g)*(h-i)},p=function(a,b){return b.length-a.length},q=function(a,b){var c=a.size||o(a),d=b.size||o(b);return Math.abs(d-c)<(c+d)/20?b.centerX-a.centerX||b.centerY-a.centerY:d-c},r=function(a,b){var c,d,e=a.slice(0),f=a.length,g=f-2;for(b=0|b,c=0;f>c;c++)d=(c+b)%g,a[c++]=e[d],a[c]=e[d+1]},s=function(a,b,c,d,e){var f,g,h,i,j=a.length,k=0,l=j-2;for(c*=6,g=0;j>g;g+=6)f=(g+c)%l,i=a[f]-(b[g]-d),h=a[f+1]-(b[g+1]-e),k+=Math.sqrt(h*h+i*i);return k},t=function(a,b,c){var d,e,f,g=a.length,h=n(a),i=n(b),j=i[0]-h[0],k=i[1]-h[1],l=s(a,b,0,j,k),o=0;for(f=6;g>f;f+=6)e=s(a,b,f/6,j,k),l>e&&(l=e,o=f);if(c)for(d=a.slice(0),m(d),f=6;g>f;f+=6)e=s(d,b,f/6,j,k),l>e&&(l=e,o=-f);return o/6},u=function(a,b,c){for(var d,e,f,g,h,i,j=a.length,k=99999999999,l=0,m=0;--j>-1;)for(d=a[j],i=d.length,h=0;i>h;h+=6)e=d[h]-b,f=d[h+1]-c,g=Math.sqrt(e*e+f*f),k>g&&(k=g,l=d[h],m=d[h+1]);return[l,m]},v=function(a,b,c,d){var e,f,g,h,i=b.length,j=0,k=(b[c].size||o(b[c]))*d,l=999999999999,m=a.size||o(a),n=a.centerX,p=a.centerY;for(e=c;i>e&&(m=b[e].size||o(b[e]),!(k>m));e++)f=b[e].centerX-n,g=b[e].centerY-p,h=Math.sqrt(f*f+g*g),l>h&&(j=e,l=h);return h=b[j],b.splice(j,1),h},w=function(a,b,c,d){var e,f,h,i,j,l=b.length-a.length,n=l>0?b:a,o=l>0?a:b,s=0,w="complexity"===d?p:q,x="position"===d?0:"number"==typeof d?d:.8,y=o.length,z="object"==typeof c&&c.push?c.slice(0):[c],A="reverse"===z[0]||z[0]<0,B="log"===c;if(o[0]){if(n.length>1&&(a.sort(w),b.sort(w),w===q))for(y=0;y<o.length;y++)n.splice(y,0,v(o[y],n,y,x));if(l)for(0>l&&(l=-l),n[0].length>o[0].length&&k(o[0],(n[0].length-o[0].length)/6|0),y=o.length;l>s;)h=u(o,n[y][0],n[y][1]),i=h[0],j=h[1],o[y++]=[i,j,i,j,i,j,i,j],o.totalPoints+=8,s++;for(y=0;y<a.length;y++)e=b[y],f=a[y],l=e.length-f.length,0>l?k(e,-l/6|0):l>0&&k(f,l/6|0),A&&!f.reversed&&m(f),c=z[y]||0===z[y]?z[y]:"auto",c&&(f.closed||Math.abs(f[0]-f[f.length-2])<.5&&Math.abs(f[1]-f[f.length-1])<.5?"auto"===c||"log"===c?(z[y]=c=t(f,e,0===y),0>c&&(A=!0,m(f),c=-c),r(f,6*c)):"reverse"!==c&&(y&&0>c&&m(f),r(f,6*(0>c?-c:c))):!A&&("auto"===c&&Math.abs(e[0]-f[0])+Math.abs(e[1]-f[1])+Math.abs(e[e.length-2]-f[f.length-2])+Math.abs(e[e.length-1]-f[f.length-1])>Math.abs(e[0]-f[f.length-2])+Math.abs(e[1]-f[f.length-1])+Math.abs(e[e.length-2]-f[0])+Math.abs(e[e.length-1]-f[1])||c%2)?(m(f),z[y]=-1,A=!0):"auto"===c?z[y]=0:"reverse"===c&&(z[y]=-1),f.closed!==e.closed&&(f.closed=e.closed=!1));return B&&g("shapeIndex: "+z),z}},x=function(a,b,c,d){var e=j(a[0]),f=j(a[1]);w(e,f,b||0===b?b:"auto",c)&&(a[0]=l(e),a[1]=l(f),d===!0&&g('precompile:["'+a[0]+'","'+a[1]+'"]'))},y=function(a,b,c){return b||c||a||0===a?function(d){x(d,a,b,c)}:x},z=function(a,b){if(!b)return a;var c,e,f,g=a.match(d)||[],h=g.length,i="";for("reverse"===b?(e=h-1,c=-2):(e=(2*(parseInt(b,10)||0)+1+100*h)%h,c=2),f=0;h>f;f+=2)i+=g[e-1]+","+g[e]+" ",e=(e+c)%h;return i},A=function(a,b){var c,d,e,f,g,h,i,j=0,k=parseFloat(a[0]),l=parseFloat(a[1]),m=k+","+l+" ",n=.999999;for(e=a.length,c=.5*b/(.5*e-1),d=0;e-2>d;d+=2){if(j+=c,h=parseFloat(a[d+2]),i=parseFloat(a[d+3]),j>n)for(g=1/(Math.floor(j)+1),f=1;j>n;)m+=(k+(h-k)*g*f).toFixed(2)+","+(l+(i-l)*g*f).toFixed(2)+" ",j--,f++;m+=h+","+i+" ",k=h,l=i}return m},B=function(a){var b=a[0].match(d)||[],c=a[1].match(d)||[],e=c.length-b.length;e>0?a[0]=A(b,e):a[1]=A(c,-e)},C=function(a){return isNaN(a)?B:function(b){B(b),b[1]=z(b[1],parseInt(a,10))}},D=function(a,b){var c=document.createElementNS("http://www.w3.org/2000/svg","path"),d=Array.prototype.slice.call(a.attributes),e=d.length;for(b=","+b+",";--e>-1;)-1===b.indexOf(","+d[e].nodeName+",")&&c.setAttributeNS(null,d[e].nodeName,d[e].nodeValue);return c},E=function(a,b){var c,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y=a.tagName.toLowerCase(),z=.552284749831;return"path"!==y&&a.getBBox?(i=D(a,"x,y,width,height,cx,cy,rx,ry,r,x1,x2,y1,y2,points"),"rect"===y?(g=+a.getAttribute("rx")||0,h=+a.getAttribute("ry")||0,e=+a.getAttribute("x")||0,f=+a.getAttribute("y")||0,m=(+a.getAttribute("width")||0)-2*g,n=(+a.getAttribute("height")||0)-2*h,g||h?(o=e+g*(1-z),p=e+g,q=p+m,r=q+g*z,s=q+g,t=f+h*(1-z),u=f+h,v=u+n,w=v+h*z,x=v+h,c="M"+s+","+u+" V"+v+" C"+[s,w,r,x,q,x,q-(q-p)/3,x,p+(q-p)/3,x,p,x,o,x,e,w,e,v,e,v-(v-u)/3,e,u+(v-u)/3,e,u,e,t,o,f,p,f,p+(q-p)/3,f,q-(q-p)/3,f,q,f,r,f,s,t,s,u].join(",")+"z"):c="M"+(e+m)+","+f+" v"+n+" h"+-m+" v"+-n+" h"+m+"z"):"circle"===y||"ellipse"===y?("circle"===y?(g=h=+a.getAttribute("r")||0,k=g*z):(g=+a.getAttribute("rx")||0,h=+a.getAttribute("ry")||0,k=h*z),e=+a.getAttribute("cx")||0,f=+a.getAttribute("cy")||0,j=g*z,c="M"+(e+g)+","+f+" C"+[e+g,f+k,e+j,f+h,e,f+h,e-j,f+h,e-g,f+k,e-g,f,e-g,f-k,e-j,f-h,e,f-h,e+j,f-h,e+g,f-k,e+g,f].join(",")+"z"):"line"===y?c="M"+a.getAttribute("x1")+","+a.getAttribute("y1")+" L"+a.getAttribute("x2")+","+a.getAttribute("y2"):("polyline"===y||"polygon"===y)&&(l=(a.getAttribute("points")+"").match(d)||[],e=l.shift(),f=l.shift(),c="M"+e+","+f+" L"+l.join(","),"polygon"===y&&(c+=","+e+","+f+"z")),i.setAttribute("d",c),b&&a.parentNode&&(a.parentNode.insertBefore(i,a),a.parentNode.removeChild(a)),i):a},F=function(a,b,c){var e,h,i="string"==typeof a;return(!i||(a.match(d)||[]).length<3)&&(e=i?f.selector(a):[a],e&&e[0]?(e=e[0],h=e.nodeName.toUpperCase(),b&&"PATH"!==h&&(e=E(e,!1),h="PATH"),a=e.getAttribute("PATH"===h?"d":"points")||"",e===c&&(a=e.getAttributeNS(null,"data-original")||a)):(g("WARNING: invalid morph to: "+a),a=!1)),a},G="Use MorphSVGPlugin.convertToPath(elementOrSelectorText) to convert to a path before morphing.",H=_gsScope._gsDefine.plugin({propName:"morphSVG",API:2,global:!0,version:"0.8.0",init:function(a,b,c){var d,f,h,i,j;return"function"!=typeof a.setAttribute?!1:(d=a.nodeName.toUpperCase(),j="POLYLINE"===d||"POLYGON"===d,"PATH"===d||j?(f="PATH"===d?"d":"points",("string"==typeof b||b.getBBox||b[0])&&(b={shape:b}),i=F(b.shape||b.d||b.points||"","d"===f,a),j&&e.test(i)?(g("WARNING: a <"+d+"> cannot accept path data. "+G),!1):(i&&(this._target=a,a.getAttributeNS(null,"data-original")||a.setAttributeNS(null,"data-original",a.getAttribute(f)),h=this._addTween(a,"setAttribute",a.getAttribute(f)+"",i+"","morphSVG",!1,f,"object"==typeof b.precompile?function(a){a[0]=b.precompile[0],a[1]=b.precompile[1]}:"d"===f?y(b.shapeIndex,b.map||H.defaultMap,b.precompile):C(b.shapeIndex)),h&&(this._overwriteProps.push("morphSVG"),h.end=i,h.endProp=f)),!0)):(g("WARNING: cannot morph a <"+d+"> SVG element. "+G),!1))},set:function(a){var b;if(this._super.setRatio.call(this,a),1===a)for(b=this._firstPT;b;)b.end&&this._target.setAttribute(b.endProp,b.end),b=b._next}});H.pathFilter=x,H.pointsFilter=B,H.subdivideRawBezier=k,H.defaultMap="size",H.pathDataToRawBezier=function(a){return j(F(a,!0))},H.equalizeSegmentQuantity=w,H.convertToPath=function(a,b){"string"==typeof a&&(a=f.selector(a));for(var c=a&&0!==a.length?a.length&&a[0]&&a[0].nodeType?Array.prototype.slice.call(a,0):[a]:[],d=c.length;--d>-1;)c[d]=E(c[d],b!==!1);return c},H.pathDataToBezier=function(a,b){var c,d,e,g,h,i,k,l,m=j(F(a,!0))[0]||[],n=0;if(b=b||{},l=b.align||b.relative,g=b.matrix||[1,0,0,1,0,0],h=b.offsetX||0,i=b.offsetY||0,"relative"===l||l===!0?(h-=m[0]*g[0]+m[1]*g[2],i-=m[0]*g[1]+m[1]*g[3],n="+="):(h+=g[4],i+=g[5],l&&(l="string"==typeof l?f.selector(l):[l],l&&l[0]&&(k=l[0].getBBox()||{x:0,y:0},h-=k.x,i-=k.y))),c=[],e=m.length,g)for(d=0;e>d;d+=2)c.push({x:n+(m[d]*g[0]+m[d+1]*g[2]+h),y:n+(m[d]*g[1]+m[d+1]*g[3]+i)});else for(d=0;e>d;d+=2)c.push({x:n+(m[d]+h),y:n+(m[d+1]+i)});return c}}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()();
/*!
 * VERSION: 0.9.9
 * DATE: 2015-04-28
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2015, GreenSock. All rights reserved.
 * ThrowPropsPlugin is a Club GreenSock membership benefit; You must have a valid membership to use
 * this code without violating the terms of use. Visit http://greensock.com/club/ to sign up or get more details.
 * This work is subject to the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";_gsScope._gsDefine("plugins.ThrowPropsPlugin",["plugins.TweenPlugin","TweenLite","easing.Ease","utils.VelocityTracker"],function(t,e,i,r){var s,n,o,a,l=function(){t.call(this,"throwProps"),this._overwriteProps.length=0},h=999999999999999,u=1e-10,f=_gsScope._gsDefine.globals,c=!1,p={x:1,y:1,z:2,scale:1,scaleX:1,scaleY:1,rotation:1,rotationZ:1,rotationX:2,rotationY:2,skewX:1,skewY:1,xPercent:1,yPercent:1},_=function(t,e,i,r){for(var s,n,o=e.length,a=0,l=h;--o>-1;)s=e[o],n=s-t,0>n&&(n=-n),l>n&&s>=r&&i>=s&&(a=o,l=n);return e[a]},d=function(t,e,i,r){if("auto"===t.end)return t;i=isNaN(i)?h:i,r=isNaN(r)?-h:r;var s="function"==typeof t.end?t.end(e):t.end instanceof Array?_(e,t.end,i,r):Number(t.end);return s>i?s=i:r>s&&(s=r),{max:s,min:s,unitFactor:t.unitFactor}},g=function(t,e,i){for(var r in e)void 0===t[r]&&r!==i&&(t[r]=e[r]);return t},m=l.calculateChange=function(t,r,s,n){null==n&&(n=.05);var o=r instanceof i?r:r?new i(r):e.defaultEase;return s*n*t/o.getRatio(n)},v=l.calculateDuration=function(t,r,s,n,o){o=o||.05;var a=n instanceof i?n:n?new i(n):e.defaultEase;return Math.abs((r-t)*a.getRatio(o)/s/o)},y=l.calculateTweenDuration=function(t,s,n,o,a,h){if("string"==typeof t&&(t=e.selector(t)),!t)return 0;null==n&&(n=10),null==o&&(o=.2),null==a&&(a=1),t.length&&(t=t[0]||t);var f,p,_,y,x,T,w,b,P,S,k=0,O=9999999999,C=s.throwProps||s,R=s.ease instanceof i?s.ease:s.ease?new i(s.ease):e.defaultEase,A=isNaN(C.checkpoint)?.05:Number(C.checkpoint),M=isNaN(C.resistance)?l.defaultResistance:Number(C.resistance);for(f in C)"resistance"!==f&&"checkpoint"!==f&&"preventOvershoot"!==f&&(p=C[f],"object"!=typeof p&&(P=P||r.getByTarget(t),P&&P.isTrackingProp(f)?p="number"==typeof p?{velocity:p}:{velocity:P.getVelocity(f)}:(y=Number(p)||0,_=y*M>0?y/M:y/-M)),"object"==typeof p&&(void 0!==p.velocity&&"number"==typeof p.velocity?y=Number(p.velocity)||0:(P=P||r.getByTarget(t),y=P&&P.isTrackingProp(f)?P.getVelocity(f):0),x=isNaN(p.resistance)?M:Number(p.resistance),_=y*x>0?y/x:y/-x,T="function"==typeof t[f]?t[f.indexOf("set")||"function"!=typeof t["get"+f.substr(3)]?f:"get"+f.substr(3)]():t[f]||0,w=T+m(y,R,_,A),void 0!==p.end&&(p=d(p,w,p.max,p.min),(h||c)&&(C[f]=g(p,C[f],"end"))),void 0!==p.max&&w>Number(p.max)+u?(S=p.unitFactor||l.defaultUnitFactors[f]||1,b=T>p.max&&p.min!==p.max||y*S>-15&&45>y*S?o+.1*(n-o):v(T,p.max,y,R,A),O>b+a&&(O=b+a)):void 0!==p.min&&Number(p.min)-u>w&&(S=p.unitFactor||l.defaultUnitFactors[f]||1,b=p.min>T&&p.min!==p.max||y*S>-45&&15>y*S?o+.1*(n-o):v(T,p.min,y,R,A),O>b+a&&(O=b+a)),b>k&&(k=b)),_>k&&(k=_));return k>O&&(k=O),k>n?n:o>k?o:k},x=l.prototype=new t("throwProps");return x.constructor=l,l.version="0.9.9",l.API=2,l._autoCSS=!0,l.defaultResistance=100,l.defaultUnitFactors={time:1e3,totalTime:1e3},l.track=function(t,e,i){return r.track(t,e,i)},l.untrack=function(t,e){r.untrack(t,e)},l.isTracking=function(t,e){return r.isTracking(t,e)},l.getVelocity=function(t,e){var i=r.getByTarget(t);return i?i.getVelocity(e):0/0},l._cssRegister=function(){var t=f.com.greensock.plugins.CSSPlugin;if(t){var e=t._internals,i=e._parseToProxy,o=e._setPluginRatio,a=e.CSSPropTween;e._registerComplexSpecialProp("throwProps",{parser:function(t,e,h,u,f,c){c=new l;var _,d,g,m,v,y={},x={},T={},w={},b={},P={};n={};for(g in e)"resistance"!==g&&"preventOvershoot"!==g&&(d=e[g],"object"==typeof d?(void 0!==d.velocity&&"number"==typeof d.velocity?y[g]=Number(d.velocity)||0:(v=v||r.getByTarget(t),y[g]=v&&v.isTrackingProp(g)?v.getVelocity(g):0),void 0!==d.end&&(w[g]=d.end),void 0!==d.min&&(x[g]=d.min),void 0!==d.max&&(T[g]=d.max),d.preventOvershoot&&(P[g]=!0),void 0!==d.resistance&&(_=!0,b[g]=d.resistance)):"number"==typeof d?y[g]=d:(v=v||r.getByTarget(t),y[g]=v&&v.isTrackingProp(g)?v.getVelocity(g):d||0),p[g]&&u._enableTransforms(2===p[g]));m=i(t,y,u,f,c),s=m.proxy,y=m.end;for(g in s)n[g]={velocity:y[g],min:x[g],max:T[g],end:w[g],resistance:b[g],preventOvershoot:P[g]};return null!=e.resistance&&(n.resistance=e.resistance),e.preventOvershoot&&(n.preventOvershoot=!0),f=new a(t,"throwProps",0,0,m.pt,2),u._overwriteProps.pop(),f.plugin=c,f.setRatio=o,f.data=m,c._onInitTween(s,n,u._tween),f}})}},l.to=function(t,i,r,l,h){i.throwProps||(i={throwProps:i}),0===h&&(i.throwProps.preventOvershoot=!0),c=!0;var u=new e(t,l||1,i);return u.render(0,!0,!0),u.vars.css?(u.duration(y(s,{throwProps:n,ease:i.ease},r,l,h)),u._delay&&!u.vars.immediateRender?u.invalidate():o._onInitTween(s,a,u),c=!1,u):(u.kill(),u=new e(t,y(t,i,r,l,h),i),c=!1,u)},x._onInitTween=function(t,e,i){this.target=t,this._props=[],o=this,a=e;var s,n,l,h,u,f,p,_,v,y=i._ease,x=isNaN(e.checkpoint)?.05:Number(e.checkpoint),T=i._duration,w=e.preventOvershoot,b=0;for(s in e)if("resistance"!==s&&"checkpoint"!==s&&"preventOvershoot"!==s){if(n=e[s],"number"==typeof n)u=Number(n)||0;else if("object"!=typeof n||isNaN(n.velocity)){if(v=v||r.getByTarget(t),!v||!v.isTrackingProp(s))throw"ERROR: No velocity was defined in the throwProps tween of "+t+" property: "+s;u=v.getVelocity(s)}else u=Number(n.velocity);f=m(u,y,T,x),_=0,h="function"==typeof t[s],l=h?t[s.indexOf("set")||"function"!=typeof t["get"+s.substr(3)]?s:"get"+s.substr(3)]():t[s],"object"==typeof n&&(p=l+f,void 0!==n.end&&(n=d(n,p,n.max,n.min),c&&(e[s]=g(n,e[s],"end"))),void 0!==n.max&&p>Number(n.max)?w||n.preventOvershoot?f=n.max-l:_=n.max-l-f:void 0!==n.min&&Number(n.min)>p&&(w||n.preventOvershoot?f=n.min-l:_=n.min-l-f)),this._overwriteProps[b]=s,this._props[b++]={p:s,s:l,c1:f,c2:_,f:h,r:!1}}return!0},x._kill=function(e){for(var i=this._props.length;--i>-1;)null!=e[this._props[i].p]&&this._props.splice(i,1);return t.prototype._kill.call(this,e)},x._roundProps=function(t,e){for(var i=this._props,r=i.length;--r>-1;)(t[i[r].p]||t.throwProps)&&(i[r].r=e)},x.setRatio=function(t){for(var e,i,r=this._props.length;--r>-1;)e=this._props[r],i=e.s+e.c1*t+e.c2*t*t,e.r&&(i=Math.round(i)),e.f?this.target[e.p](i):this.target[e.p]=i},t.activate([l]),l},!0),_gsScope._gsDefine("utils.VelocityTracker",["TweenLite"],function(t){var e,i,r,s,n=/([A-Z])/g,o={},a={x:1,y:1,z:2,scale:1,scaleX:1,scaleY:1,rotation:1,rotationZ:1,rotationX:2,rotationY:2,skewX:1,skewY:1,xPercent:1,yPercent:1},l=document.defaultView?document.defaultView.getComputedStyle:function(){},h=function(t,e,i){var r=(t._gsTransform||o)[e];return r||0===r?r:(t.style[e]?r=t.style[e]:(i=i||l(t,null))?r=i[e]||i.getPropertyValue(e)||i.getPropertyValue(e.replace(n,"-$1").toLowerCase()):t.currentStyle&&(r=t.currentStyle[e]),parseFloat(r)||0)},u=t.ticker,f=function(t,e,i){this.p=t,this.f=e,this.v1=this.v2=0,this.t1=this.t2=u.time,this.css=!1,this.type="",this._prev=null,i&&(this._next=i,i._prev=this)},c=function(){var t,i,n=e,o=u.time;if(o-r>=.03)for(s=r,r=o;n;){for(i=n._firstVP;i;)t=i.css?h(n.target,i.p):i.f?n.target[i.p]():n.target[i.p],(t!==i.v1||o-i.t1>.15)&&(i.v2=i.v1,i.v1=t,i.t2=i.t1,i.t1=o),i=i._next;n=n._next}},p=function(t){this._lookup={},this.target=t,this.elem=t.style&&t.nodeType?!0:!1,i||(u.addEventListener("tick",c,null,!1,-100),r=s=u.time,i=!0),e&&(this._next=e,e._prev=this),e=this},_=p.getByTarget=function(t){for(var i=e;i;){if(i.target===t)return i;i=i._next}},d=p.prototype;return d.addProp=function(e,i){if(!this._lookup[e]){var r=this.target,s="function"==typeof r[e],n=s?this._altProp(e):e,o=this._firstVP;this._firstVP=this._lookup[e]=this._lookup[n]=o=new f(n!==e&&0===e.indexOf("set")?n:e,s,o),o.css=this.elem&&(void 0!==this.target.style[o.p]||a[o.p]),o.css&&a[o.p]&&!r._gsTransform&&t.set(r,{x:"+=0",overwrite:!1}),o.type=i||o.css&&0===e.indexOf("rotation")?"deg":"",o.v1=o.v2=o.css?h(r,o.p):s?r[o.p]():r[o.p]}},d.removeProp=function(t){var e=this._lookup[t];e&&(e._prev?e._prev._next=e._next:e===this._firstVP&&(this._firstVP=e._next),e._next&&(e._next._prev=e._prev),this._lookup[t]=0,e.f&&(this._lookup[this._altProp(t)]=0))},d.isTrackingProp=function(t){return this._lookup[t]instanceof f},d.getVelocity=function(t){var e,i,r,s=this._lookup[t],n=this.target;if(!s)throw"The velocity of "+t+" is not being tracked.";return e=s.css?h(n,s.p):s.f?n[s.p]():n[s.p],i=e-s.v2,("rad"===s.type||"deg"===s.type)&&(r="rad"===s.type?2*Math.PI:360,i%=r,i!==i%(r/2)&&(i=0>i?i+r:i-r)),i/(u.time-s.t2)},d._altProp=function(t){var e=t.substr(0,3),i=("get"===e?"set":"set"===e?"get":e)+t.substr(3);return"function"==typeof this.target[i]?i:t},p.getByTarget=function(i){var r=e;for("string"==typeof i&&(i=t.selector(i)),i.length&&i!==window&&i[0]&&i[0].style&&!i.nodeType&&(i=i[0]);r;){if(r.target===i)return r;r=r._next}},p.track=function(t,e,i){var r=_(t),s=e.split(","),n=s.length;for(i=(i||"").split(","),r||(r=new p(t));--n>-1;)r.addProp(s[n],i[n]||i[0]);return r},p.untrack=function(t,i){var r=_(t),s=(i||"").split(","),n=s.length;if(r){for(;--n>-1;)r.removeProp(s[n]);r._firstVP&&i||(r._prev?r._prev._next=r._next:r===e&&(e=r._next),r._next&&(r._next._prev=r._prev))}},p.isTracking=function(t,e){var i=_(t);return i?!e&&i._firstVP?!0:i.isTrackingProp(e):!1},p},!0)}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()(),function(t){"use strict";var e=function(){return(_gsScope.GreenSockGlobals||_gsScope)[t]};"function"==typeof define&&define.amd?define(["TweenLite"],e):"undefined"!=typeof module&&module.exports&&(require("../TweenLite.js"),module.exports=e())}("ThrowPropsPlugin");
angular.module('goApp')
.factory('FetchedDataGroup', function ($q, hesEventHandlerService) {
  // Instances of this class doesn't aware of data type they store, all data manipulations are done outside,
  // the only exclusion - adding/removing items from it's top level data collection

  function FetchedDataGroup(dataFetcherFn, isLazy) {
    var that = this,
      data = [],
      status = {
        initiated: false,
        loading: false,
        _promise: null
      };

    if (!dataFetcherFn || typeof dataFetcherFn !== 'function') {
      console.error('Data Group creation attempt without data getter function', {providedData: arguments});
      return;
    }

    this.events = {
      onAnyUpdate: new hesEventHandlerService(),
      onPush: new hesEventHandlerService(),
      onRemove: new hesEventHandlerService(),
      onFetchDone: new hesEventHandlerService()
    };

    this.get = function (reload) {
      if (reload || !status.initiated) {
        loadData();
      }

      var defer = $q.defer();

      if (status.loading) {
        return status._promise;
      } else {
        defer.resolve(data);
      }

      return defer.promise;
    };

    this.splice = function(index, amount, noNotify) {
      if (angular.isUndefined(amount)) {
        amount = 1;
      }

      if (data.length > index + 1) {
        data.splice(index, amount);
      }

      if (!noNotify) {
        this.events.onRemove.invoke(data);
        this.events.onAnyUpdate.invoke(data);
      }
    };

    this.removeById = function (id, noNotify) {
      if (angular.isUndefined(id)) {
        return;
      }

      _.remove(data, {id: id});

      if (!noNotify) {
        this.events.onRemove.invoke(data);
        this.events.onAnyUpdate.invoke(data);
      }
    };

    this.push = function(item, notUnique, noNotify) {
      if (angular.isUndefined(item)) {
        return;
      }

      if (notUnique || !_.filter(data, item).length) {
        data.push(item);
      }

      if (!noNotify) {
        this.events.onPush.invoke(data);
        this.events.onAnyUpdate.invoke(data);
      }
    };

    function loadData() {
      // this promise can't fail atm, since in case of error we setting data=[]
      var defer = $q.defer();
      var promise;

      status.loading = true;
      status.initiated = true;
      status._promise = defer.promise;

      promise = dataFetcherFn();

      if (!promise || !promise.then)
        promise = (promise && promise.$promise) || (promise[0] && promise[0].$promise) || null;

      if (!promise) {
        console.error('Incorrect return from dataFetcherFn');
        promise = $q.defer().promise;
        promise.reject();
      }

      promise
      .then(function (fetchedData) {
        data = fetchedData;
      }, function() {
        console.error('Data fetching failed.');
        data = [];
      })
      .finally(function () {
        status.loading = false;
        defer.resolve(data);
        that.events.onFetchDone.invoke(data);
        that.events.onAnyUpdate.invoke(data);
        status._promise = null;
      });
    }

    if (!isLazy)
      loadData();
  }

  return FetchedDataGroup;
});
'use strict';
//----------------------------------------------------------------------------------------------------------------------
// A directive for rendering markdown in AngularJS.
//
// Written by John Lindquist (original author). Modified by Jonathan Rowny (ngModel support).
// Adapted by Christopher S. Case
//
// Taken from: http://blog.angularjs.org/2012/05/custom-components-part-1.html
//
// @module angular.markdown.js
//----------------------------------------------------------------------------------------------------------------------

angular.module('goApp')
  .service('markdownService', ['$compile', '$timeout',
    function($compile, $timeout) {
      return {
        markdownCompile: function() {
          var converter;
          converter = new Showdown.converter();
          return function(scope, element, attrs, model) {

            // Check for extensions
            var extAttr = attrs.extensions;
            var callPrettyPrint = false;
            var childScope = scope.$new();
            if (extAttr) {
              var extensions = [];

              // Convert the comma separated string into a list.
              extAttr.split(',').forEach(function(val) {
                // Strip any whitespace from the beginning or end.
                extensions.push(val.replace(/^\s+|\s+$/g, ''));
              });

              if (extensions.indexOf('prettify') >= 0) {
                callPrettyPrint = true;
              } // end if

              // Create a new converter.
              converter = new Showdown.converter({
                extensions: extensions
              });
            } // end if

            // Check for option to strip whitespace
            var stripWS = attrs.strip;
            if (String(stripWS).toLowerCase() === 'true') {
              stripWS = true;
            } else {
              stripWS = false;
            } // end if

            var render = function() {
              var htmlText = '';
              var val = '';

              // Check to see if we're using a model.
              if (attrs.ngModel) {
                if (model.$modelValue) {
                  val = model.$modelValue;
                } // end if
              } else {
                val = element.text();
              }

              if (stripWS) {
                val = val.replace(/^[ /t]+/g, '').replace(/\n[ /t]+/g, '\n');
              } // end stripWS

              // Compile the markdown, and set it.
              htmlText = converter.makeHtml(val);
              element.html($compile(htmlText)(childScope));

              // if (callPrettyPrint) {
              //   prettyPrint();
              // } // end if

              if (typeof attrs.noParagraph !== 'undefined') {
                element.html(element.html().replace(/<p*?>/i, '').replace('<p class=ng-scope>', '').replace('<P class=ng-scope>', '').replace('<p class="ng-scope">', '').replace('</p>', '').replace('</P>', ''));
              }

              element.find("a[href^='http']").attr('target', '_blank');

              element.show();
            };

            if (attrs.ngModel) {
              scope.$watch(attrs.ngModel, render);
            } else {
              // transclude(scope, function(clone) {
              //   element.append($compile(clone)(scope));
              //   element.hide();
              // });
            }

            $timeout(render, 0);

            element.on('$destroy', function() {
              childScope.$destroy();
              element.off();
              element.remove();
            });
          }; // end link
        }
      };
    }
  ])
  .directive('markdown', ['markdownService',
    function(markdownService) {
      return {
        restrict: 'EA',
        require: '?ngModel',
        replace: true,
        // transclude: true,
        template: '<span class="markdown"></span>',
        compile: markdownService.markdownCompile
      };
    }
  ])
  .directive('markdownDiv', ['markdownService',
    function(markdownService) {
      return {
        restrict: 'EA',
        require: '?ngModel',
        replace: true,
        // transclude: true,
        template: '<div class="markdown"></div>',
        compile: markdownService.markdownCompile
      };
    }
  ])
  .directive('markdownButton', ['markdownService',
    function(markdownService) {
      return {
        restrict: 'EA',
        require: '?ngModel',
        replace: true,
        // transclude: true,
        template: '<button class="markdown"></button>',
        compile: markdownService.markdownCompile
      };
    }
  ]); // end markdown directive
'use strict';

// angular.module('goApp').config(function($provide){
// 	$provide.decorator('taOptions', ['taRegisterTool', '$delegate', function(taRegisterTool, taOptions){
// 		// $delegate is the taOptions we are decorating
// 		// register the tool with textAngular
// 		taRegisterTool('upperRight', {
// 			iconclass: "fa fa-align-right",
// 			action: function(){
// 				return this.$editor().wrapSelection("upperRight", null);
// 			},
// 			activeState: function(){
// 				return document.queryCommandState('upperRight');
// 			}
// 		});

// 		taOptions.toolbar[1].push('upperRight');
// 		return taOptions;
// 	}]);
// });
'use strict';
var SINGLE_EMAIL_REGEX = new RegExp(/^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i);

angular.module('hes')
  .factory('Utils', function() {
    var service = {
      isUndefinedOrNull: function(obj) {
        return !angular.isDefined(obj) || obj === null;
      },
      ConvertReportToCSV: function(objArray, fields) {
        var array = objArray;
        var str = '';

        for (var i = 0; i < array.length; i++) {
          var line = '';
          for (var index = 0; index < fields.length; index++) {
            var field = fields[index];

            if (line != '') {
              line += ',';
            }

            var val = array[i][index];
            if (field[1] !== "integer" && field[1] !== "decimal") {
              if (val !== null && val !== undefined && val.replace !== undefined) {
                val = '"' + val.replace(/"/g, '""') + '"';
              } else {
                val = '';
              }
            }
            line += val;
          }

          str += line + '\n';
        }

        return str;
      },
      isEmail: function(value) {
        var pattern = SINGLE_EMAIL_REGEX;
        return pattern.test(value);
      } 
    };

    return service;
  });
angular.module('goApp').directive('walkthrough', function(hesTemplateService, $timeout, $rootScope, ContentLoader, ngDialog) {
  // Runs during compile
  return {
    scope: false,
    restrict: 'E', // E = Element, A = Attribute, C = Class, M = Comment
    link: function($scope, $element, $attrs) {
      $scope.data = {
        current_pos: 0,
        max_pos: -1, // update this after custom content is loaded,
        walkthrough_items: []
      }

      $scope.page = function(direction) {
        // valid direction strings are "forward" and "backward"
        var next_pos = $scope.data.current_pos + ((direction == "forward" && 1) || -1);
        // validate next_pos, return early if not valid
        if (next_pos < 0 || next_pos > $scope.data.max_pos) {
          return;
        }
        $scope.data.current_pos = next_pos;
        return $scope.data.current_pos;
      }

      function showWelcomeOverlay() {
        if (sessionStorage.getItem('hesPlatform')) {
          return false;
        }
        if ($scope.user.flags) {
          return $scope.site.features_on &&
                 !$scope.user.flags.has_seen_welcome_elevate &&
                 $scope.site.flags.is_launchpad_plus;
        }
        return false;
      }

      function init() {
        if (showWelcomeOverlay() && $scope.data.max_pos > -1) {
          ngDialog.open({
            className: 'ngdialog-theme-default goal-view-popup',
            template: '/scripts/walkthrough/walkthrough.template.html',
            scope: $scope,
            preCloseCallback: function(value) {
              $scope.user.updateFlags({'has_seen_welcome_elevate': true});
            }
          });
        }
      }

      var show_items = {
        'wall':               $scope.site.flags.is_wall_enabled,
        'peer_challenges':    $scope.site.flags.is_challenges_enabled,
        'recipes':            $scope.site.flags.is_recipes_enabled,
        'goals':              $scope.site.flags.is_goal_enabled,
      }

      new ContentLoader({
        site_id: $scope.site.id,
        category: 'walkthrough'
      }, true).then(function(contents) {
        // TODO make sure QA tests these scenarios
        // 1: do not show item if feature is not enabled
        // 2: do not show item if is hidden (API may handle that already)
        // 3: order the items by sequence asc
        
        $scope.data.walkthrough_items = _.orderBy(_.filter(contents, function(c){
          return (show_items[c.key] || !(c.key in show_items)) && !c.hidden;
        }), ['sequence'], ['asc']);
        
        // keep track of max position for paging
        $scope.data.max_pos = $scope.data.walkthrough_items.length-1;
        
        init(); // [mario voice] here we gooo!!
      });

    }
  }
});
'use strict';
angular.module('goApp')
  .component('hesResourceComments', {
    bindings: {
      wallable: '<',
      wall: '<',
      resourceName: '@'
    },
    templateUrl: '/scripts/wall/comments/resourceComments.html',
    controller: function(WallFactory) {
      var ctrl = this;

      ctrl.commentRemoved = function(removedComment) {
        ctrl.wall.removePost(removedComment);
      };

      ctrl.placeNewComment = function(newComment) {
        ctrl.view.resourceWall.placeNewPost(newComment);
      };

      ctrl.$onInit = function() {
        ctrl.view = {
          resourceWall: ctrl.wall
        };
      };
    }
  });
'use strict';
angular.module('goApp')
  .component('hesWallComments', {
    bindings: {
      post: '<',
      wallable: '<'
    },
    templateUrl: '/scripts/wall/comments/wallComments.html',
    controller: function(WallFactory) {
      var ctrl = this;

      ctrl.commentRemoved = function(removedComment) {
        ctrl.view.commentWall.removePost(removedComment);
      };

      ctrl.placeNewComment = function(newComment) {
        ctrl.view.limit ++;
        ctrl.view.commentWall.placeNewPost(newComment);
      };

      ctrl.$onInit = function() {
        ctrl.view = {
          commentWall: new WallFactory(ctrl.post, {}),
          limit: 2
        };
      };

      ctrl.increaseLimit = function(){
        ctrl.view.limit = ctrl.view.commentWall.posts.length;
      };

      ctrl.placeNewComments = function() {
        ctrl.view.limit += ctrl.view.commentWall.newPosts.length;
        ctrl.view.commentWall.placeIncomingPosts();
      };

      ctrl.$onDestroy = function(){
        ctrl.view.commentWall.unload();
      }
    }
  });
'use strict';
angular.module('goApp')
  .controller('WallExpertController', function($scope, $state, $stateParams, WallFactory, SitesLoader, wallable,  $rootScope) {

    $scope.view = {
      filter: $state.params.filter,
      total: 0,
      posts: [],
      activeSiteId: wallable.id,
      allSites: [],
      wallable: wallable,
      canSelectWall: $state.current.name === 'go.u.wallexpert.walls'
    }

    $scope.view.wall = new WallFactory(wallable, {
      filter: $scope.view.filter,
      page_size: 30
    });

    $scope.view.wall.load().then(function(posts) {
      $scope.view.posts = $scope.view.wall.posts;
      $scope.view.total = $scope.view.wall.getTotalPosts();
    });

    $scope.allowCreate = function() {
      return true;
    };

    $scope.placeNewPost = function(newPost) {
      $scope.view.wall.placeNewPost(newPost);
    };

    $scope.removePost = function(post){
      $scope.view.wall.removePost(post);
    };

    $scope.showMore = function() {
      return $scope.view.wall.getMorePosts();
    };

    $scope.changedSite = function(){
      $state.transitionTo('go.u.wallexpert.walls', {
        wallable_id: $scope.view.activeSiteId,
        filter: ''
      }, {reload: 'go.u.wallexpert.walls'});
    };

    new SitesLoader().then(function(sites){
      for(i =0; i< sites.length; i++){
        if(sites[i].name != null){
          if(!!sites[i].flags.is_wall_enabled){
            if(sites[i].disable_after){
              if($rootScope.site.current_date <= sites[i].disable_after){
                $scope.view.allSites.push(sites[i])
              }else{
                console.log(sites[i].name + " not added, disabled after: " + sites[i].disable_after)
              }
            }else{
              $scope.view.allSites.push(sites[i])
            }
          }else{
            console.log(sites[i].name + " not added, wall not enabled")
          }
        }
      }
    });

  });
'use strict';

angular.module('goApp').factory('Follow', ['DOMAIN', '$http', 'ActiveResource',
    function(DOMAIN, $http, ActiveResource) {
        var Follow = ActiveResource('/follows/:id', {
            nestedRoutes: ['index', 'create', 'destroy', 'show'],
            parentResource: 'User',
            domain: DOMAIN
        });


        Follow.prototype.getName = function(){
          return this.profile.full_name;
        };

        return Follow;
    }
]);
'use strict';
angular.module('goApp')
  .controller('FollowingController', function($scope, $state, UsersFollowing){
    $scope.view = {
      usersFollowing: new UsersFollowing()
    };

    $scope.goToWallFollow = function(follow){
      $state.transitionTo('go.u.content.wall.filtered', {
        filter: follow.id,
        follow: follow
      });
    }
    
  });
'use strict';
angular.module('goApp')
  .factory('UsersFollowing', function(Follow, CurrentUser, $q) {

    var following = [],
      followingIds = [],
      userId = -1,
      allFollowingUser = Follow.build({
        id: 'following',
        profile: {
          full_name: 'All Following',
          image: {
            url: '/images/users/all-following.png'
          }
        }
      });

    function _setFollowing(userFollows) {
      //Clear arrays
      following.splice(0);
      followingIds.splice(0);

      //populate
      _.each(userFollows, function(follow, idx) {
        following.push(follow);
        followingIds.push(follow.id);
      });
    }

    function getFollowing() {
      Follow.index({
        user_id: userId
      }, function(pFollowing) {
        _setFollowing(pFollowing);
      });
    }

    var UsersFollowing = function() {
      CurrentUser.get().then(function(user) {
        userId = user.id;
        getFollowing();
      });
    };

    UsersFollowing.prototype.isFollowing = function(userId) {
      return followingIds.indexOf(userId) !== -1;
    };

    UsersFollowing.prototype.follow = function(userId) {
      var follow = new Follow();
      follow.id = userId;
      follow.create(function() {
        getFollowing();
      });
    };

    UsersFollowing.prototype.unfollow = function(userId) {
      Follow.destroy({
        id: userId
      }, function() {
        getFollowing();
      })
    };

    UsersFollowing.prototype.all = function() {
      var all = following.slice(0);
      all.unshift(allFollowingUser);
      return all;
    };

    UsersFollowing.prototype.fetch = function(followeeId) {
      var defer = $q.defer();
      var followee = allFollowingUser;
      if (followeeId !== 'following') {
        CurrentUser.get().then(function(user) {
          followee = Follow.build({
            id: followeeId,
            user_id: user.id
          });
          Follow.show(followee,
            function(response) {
              defer.resolve(response)
            },
            function() {
              defer.reject();
            });
        }, function() {
          defer.reject();
        });
      } else {
        defer.resolve(followee);
      }
      return defer.promise;
    };

    return UsersFollowing;
  });
'use strict';
angular.module('goApp')
  .component('hesFollowToggle', {
    bindings: {
      user: '<',
      usersFollowing: '<'
    },
    templateUrl: '/scripts/wall/following/toggleFollow.html',
    controller: function() {
      var ctrl = this;

      ctrl.followingUser = function() {
        return ctrl.usersFollowing && ctrl.usersFollowing.isFollowing(ctrl.user.id)
      };

      ctrl.toggleFollow = function() {
        ctrl.followingUser(ctrl.user.id) ?
          ctrl.usersFollowing.unfollow(ctrl.user.id) :
          ctrl.usersFollowing.follow(ctrl.user.id);
      };
    }
  });
'use strict';
angular.module('goApp')
  .controller('GuidelinesController', function($scope, $rootScope, $state, ContentLoader, Content){

    new ContentLoader({
      site_id: $rootScope.site.id,
      category: 'wall'
    }, false).then(function(contents) {
      $scope.view.guidelines = Content.getByKey(contents, 'guidelines', true);
    });
    
  });
'use strict';

angular.module('goApp')
  .component('hesCreatePost', {
    bindings: {
      wallable: '<',
      parent: '<?',
      onCreate: '&',
      buttonLabel: '@?',
      hidePhoto: '<?',
      hideTag: '<?',
      depth: '@?',
      formClass: '@?',
      placeHolderMessage: '@?',
      postableType: '@?',
      postableId: '@?'
    },
    templateUrl: '/scripts/wall/post/create/createPost.html',
    controller: function(Post, PhotoUploadService, DialogService, ngDialog, $state) {
      var ctrl = this;
      ctrl.initializePost = function() {
        console.log(ctrl.wallable['class'].toString())
        return new Post({
          content: '',
          wallable_id: ctrl.wallable.id,
          wallable_type: ctrl.wallable['class'].toString() || "CustomContent",
          parent_post_id: !!ctrl.parent ? ctrl.parent.id : null,
          depth: ctrl.depth || 0,
          tagged_users: [],
          postable_type: !!ctrl.postableType && !!ctrl.postableId ?
            ctrl.postableType : null,
          postable_id: !!ctrl.postableType && !!ctrl.postableId ?
            ctrl.postableId : null
        })
      }

      ctrl.validation = {
        empty: false
      };

      ctrl.view = {
        saving: false,
        imageUploaded: false,
        uploadingDialog: null,
        buttonLabel: 'Post',
        hidePhoto: false,
        hideTag: false,
        placeHolderMessage: 'Add your message…',
        formClass: 'post-form'
      };

      ctrl.uploadingPhoto = function() {};

      ctrl.onFailure = function() {
        ctrl.view.uploadingDialog.close();
      };

      ctrl.openTagUsers = function() {
        ngDialog.open({
          controller: 'TagUsersController',
          template: '/scripts/wall/post/create/tagUsers/tagUsersDialog.html',
          resolve: {
            newPost: function() {
              return ctrl.data.newPost;
            }
          }
        });
      };

      ctrl.addPhoto = function(imageUrl) {
        PhotoUploadService.showPhotoUploadDialog({
            asepectRatio: 1,
            uploaded: true,
            uploadedPhoto: imageUrl,
            saveButtonLabel: 'Done'
          })
          .then(function(imageUrl) {
            ctrl.data.newPost.photo = imageUrl;
            ctrl.view.imageUploaded = true;
          });
      };

      ctrl.removePhoto = function() {
        ctrl.data.newPost.photo = null;
        ctrl.view.imageUploaded = false;
      };

      ctrl.create = function() {
        if (ctrl.data.newPost.content) {
        ctrl.validation.empty = false;
        ctrl.view.saving = true;
        ctrl.data.newPost.flattenTags();
        ctrl.data.newPost.create()
          .then(function(createdPost) {
            ctrl.onCreate({
              newPost: createdPost
            });
            ctrl.data.newPost = ctrl.initializePost();
          }, function(response) {
            if (response.data.errors[0] == 'Content can\'t be blank') {
              ctrl.validation.empty = true;
            }
          }).finally(function() {
            ctrl.view.saving = false;
          })
        } else {
          ctrl.validation.empty = true;
        }
      };

      ctrl.isState = function(state) {
        return state == $state.current.name;
      }

      ctrl.$onInit = function() {
        ctrl.data = {
          newPost: ctrl.initializePost()
        };

        ctrl.view.buttonLabel = ctrl.buttonLabel || ctrl.view.buttonLabel;
        ctrl.view.hidePhoto = ctrl.hidePhoto || ctrl.view.hidePhoto;
        ctrl.view.hideTag = ctrl.hideTag || ctrl.view.hideTag;
        ctrl.view.placeHolderMessage = ctrl.placeHolderMessage || ctrl.view.placeHolderMessage;
        ctrl.view.formClass = ctrl.formClass || ctrl.view.formClass;
      };
    }
  });
'use strict';

angular.module('goApp')
  .controller('TagUsersController', function($scope, FriendService, newPost, ngDialog) {
    $scope.view = {
      friends: [],
      search: null,
      taggedUsers: newPost.tagged_users.slice(0)
    };

    FriendService.friends.get(true).then(function(data) {
      $scope.view.friends = data.slice(0);
      _.forEach($scope.view.friends, function(friend) {
        friend.is_tagged = !!_.find($scope.view.taggedUsers, function(tagged) {
          return tagged.id === friend.friendee.id;
        }) ? 1 : 0;
      })
    });

    $scope.applySearch = function(value) {
      $scope.view.search = value;
    };

    $scope.closeModal = function() {
      ngDialog.close();
    };

    $scope.changeTagSelection = function(friend) {
      //Called after is_tagged has changed
      if (friend.is_tagged) {
        $scope.view.taggedUsers.push(friend.friendee);
      } else {
        _.remove($scope.view.taggedUsers, function(taggedUser) {
          return taggedUser.id === friend.friendee.id;
        });
      }
    };

    $scope.applyChanges = function() {
      newPost.tagged_users = $scope.view.taggedUsers;
      $scope.closeThisDialog();
    };

    $scope.removeTaggedChip = function($chip){
      var chipFriend = _.find($scope.view.friends, function(friend){
        return friend.friendee.id == $chip.id;
      });
      chipFriend.is_tagged = chipFriend.is_tagged ? 0 : 1;
      $scope.changeTagSelection(chipFriend);
    };

  });
'use strict';
angular.module('goApp')
  .component('hesPostMenu', {
    bindings: {
      post: '<',
      user: '<',
      onUpdate: '&?',
      onDelete: '&?'
    },
    templateUrl: '/scripts/wall/post/menu/postMenu.html',
    controller: function(DialogService) {
      var ctrl = this;

      ctrl.view = {
        showMenu: false
      };

      ctrl.hasAction = function() {
        return ctrl.post.canDelete(ctrl.user) || ctrl.post.canReport(ctrl.user) || ctrl.post.canUnreport(ctrl.user) || ctrl.post.userIsTagged(ctrl.user);
      };

      ctrl.toggleTooltip = function(event) {
        $(event.target).parent().find('.tooltip').toggleClass('clicked');
      }

      ctrl.toggleMenu = function() {
        ctrl.view.showMenu = !ctrl.view.showMenu;
      };

      ctrl.confirmDelete = function() {
        DialogService.openConfirmationDialog('Delete ' + ctrl.post.getTypeName(),
          'Are you sure you want to delete this?',
          'Cancel', 'Delete').then(function() {
          ctrl.post.destroy(function() {
            ctrl.onDelete();
          });
        });
      };

      ctrl.confirmReport = function() {
        DialogService.openConfirmationDialog('Report ' + ctrl.post.getTypeName(),
          'Are you sure you want to report this ' + ctrl.post.getTypeName() + '?',
          'Cancel', 'Report').then(function() {
          ctrl.post.report(ctrl.user).then(function() {
            if (_.isFunction(ctrl.onUpdate)) {
              ctrl.onUpdate();
            }
            post.init();
          });
        })
      }

      ctrl.unReportPlusUpdate = function() {
        ctrl.post.unreport().then(function() {
          if (_.isFunction(ctrl.onUpdate)) {
            ctrl.onUpdate();
          }
          post.init();
        });
      }

      ctrl.confirmRemoveTag = function() {
        DialogService.openConfirmationDialog('Remove Tag ' + ctrl.post.getTypeName(),
          'Are you sure you want to untag yourself from this ' + ctrl.post.getTypeName() + '?',
          'Cancel', 'Remove').then(function() {
          ctrl.post.removeUserTag(ctrl.user).then(function() {
            if (_.isFunction(ctrl.onUpdate)) {
              ctrl.onUpdate();
            }
            post.init();
          });
        })
      }
    }
  });
'use strict';
angular.module('goApp')
  .component('hesPost', {
    bindings: {
      post: '<',
      onDelete: '&',
      onUpdate: '&?',
      wallable: '<?',
      hideComment: '<?',
      hideLike: '<?',
      hideFollow: '@?',
      hideLocation: '<?',
      postClass: '@?',
      usersFollowing: '<?'
    },
    templateUrl: '/scripts/wall/post/post.html',
    controller: function(DialogService, CurrentUser, CurrentSite, WallFactory, $stateParams, $anchorScroll, $timeout) {
      var ctrl = this;

      ctrl.postDeleted = function() {
        ctrl.onDelete({
          post: ctrl.post
        });
      };

      ctrl.postUpdated = function() {
        ctrl.onUpdate({
          post: ctrl.post
        });
      };

      ctrl.toggleReplies = function() {
        ctrl.view.showReplies = !ctrl.view.showReplies;
      };

      ctrl.toggleMenu = function() {
        ctrl.view.showMenu = !ctrl.view.showMenu;
      };

      ctrl.toggleFlaggedContent = function() {
        ctrl.view.showFlagged = !ctrl.view.showFlagged;
      };

      CurrentUser.get().then(function(user) {
        ctrl.user = user;
      });

      CurrentSite.get().then(function(site) {
        ctrl.site = site;
      });

      ctrl.$onInit = function() {
        ctrl.view = {
          showReplies: false,
          showMenu: false,
          showFlagged: false,
          hideLike: ctrl.hideLike || false,
          hideComment: ctrl.hideComment || false,
          hideFollow: ctrl.hideFollow || false,
          postClass: ctrl.postClass || 'post',
          following: ctrl.usersFollowing
        };

        if (ctrl.post.getTypeName() == 'Comment' && !!$stateParams.reply &&
          $stateParams.reply == ctrl.post.id &&
          !ctrl.post.wasHighlighted) {

          var postClass = ctrl.view.postClass + ' transition';
          $timeout(function() {
            $anchorScroll.yOffset = 100;
            $anchorScroll('comment_' + ctrl.post.id);
            ctrl.view.postClass += ' highlight';
          })

          $timeout(function() {
            ctrl.post.wasHighlighted = true;
            ctrl.view.postClass = postClass
          }, 4000);
        }
      }
    }
  });
'use strict';
angular.module('goApp')
  .component('hesSharedPost', {
    bindings: {
      postableType: '@',
      postableId: '@'
    },
    templateUrl: '/scripts/wall/post/shared/sharedPost.html',
    controller: function(Recipe, Tip, Goal, $state) {
      var ctrl = this;

      ctrl.resource = {};
      //TODO: Have Post return a generic resource which can be rendered without additional logic

      ctrl.$onInit = function() {


        if (!!ctrl.postableType && !!ctrl.postableId) {
          switch (ctrl.postableType) {
            case 'Tip':
              Tip.show({
                id: ctrl.postableId
              }, function(tip) {
                ctrl.resource = tip;
                var idx = ctrl.resource.summary_html.lastIndexOf('</p>');
                ctrl.resource.summary_html = ctrl.resource.summary_html.substring(0,idx);
                if (!_.includes(["go.u.content.tips.today","go.u.content.tips.single"], $state.current.name)) {
                  ctrl.resource.summary_html += ' <a ui-sref="go.u.content.tips.single({id:'+ ctrl.resource.id + '})">read</a>';
                }
                ctrl.resource.summary_html += '</p>';
              });
              break;
            case 'Recipe':
              Recipe.show({
                id: ctrl.postableId
              }, function(recipe) {
                ctrl.resource = recipe;
                ctrl.resource.getSummary();
                if (!_.includes(["go.u.content.recipes.today","go.u.content.recipes.single"], $state.current.name)) {
                  ctrl.resource._summary += ' <a ui-sref="go.u.content.recipes.single({id:'+ ctrl.resource.id + '})">read</a>';
                }
              });
              break;
            case 'Goal':
              Goal.show({
                id: ctrl.postableId
              }, function(goal) {
                ctrl.resource = goal;
              });
              break;
          }
        }
      }

    }
  });
'use strict';
angular.module('goApp')
  .component('hesPostTaggedUsers', {
    bindings: {
      post: '<'
    },
    templateUrl: '/scripts/wall/post/tagged/taggedUsers.html',
    controller: function(ngDialog) {
      var ctrl = this;

      ctrl.showAllTaggedUsers = function(){
        ngDialog.open({
          template: '/scripts/wall/post/tagged/allTaggedUsersDialog.html',
          controller: function($scope){
            $scope.post = ctrl.post;
          }
        });
      }
    }
  });
// 'use strict';
// angular.module('goApp')
//   .component('hesPosts', {
//     bindings: {
//       posts: ''
//     },
//     templateUrl: '/scripts/wall/posts/posts.html',
//     controller: function(WallFactory){
//       var ctrl = this;

//       ctrl.view = {
//         total: 0,
//         posts: []
//       };

//       ctrl.wall = new WallFactory({
//         wallable_type: ctrl.wallable['class'].toString(),
//         wallable_id: ctrl.wallable.id,
//         filter: ctrl.filter
//       });

//       ctrl.wall.load().then(function(){
//         ctr.view.posts = ctrl.wall.posts;
//       });
//     }
//   })
'use strict';

angular.module('goApp')
  .factory('Post', function(DOMAIN, $rootScope, $filter, $timeout, $http, ActiveResource, ContentLoader, Content, Like, User) {
    var Post = ActiveResource('/posts/:id', {
      nestedRoutes: ['index', 'create'],
      parentResource: ['Site', 'Recipe', 'Tip', 'Post'],
      domain: DOMAIN
    }, {
      removePostTag: {
        method: 'DELETE',
        url: '/remove_tag/:user_id'
      }
    });

    Post.prototype.hasLiked = function(user) {
      var liked = false;
      // Likes can appear in two different forms.
      if (this.likes.constructor === Array) {
        for (var i = 0; i < this.likes.length; i++) {
          if (this.likes[i].user.id == user.id) {
            liked = true;
            break;
          }
        }
      } else if (this.likes.constructor === Object) {
        for (var i = 0; i < this.likes.data.length; i++) {
          if (this.likes.data[i].user.id == user.id) {
            liked = true;
            break;
          }
        }
      }

      return liked;
    };

    Post.prototype.unlike = function(user) {
      var like;

      // Likes can appear in two different forms.
      if (this.likes.constructor === Array) {
        for (var i = 0; i < this.likes.length; i++) {
          if (this.likes[i].user.id == user.id) {
            like = new Like(this.likes[i]);
            this.likes.splice(i, 1);
            break;
          }
        }
      } else if (this.likes.constructor === Object) {
        for (var i = 0; i < this.likes.data.length; i++) {
          if (this.likes.data[i].user.id == user.id) {
            like = new Like(this.likes.data[i]);
            this.likes.data.splice(i, 1);
            break;
          }
        }
      }

      like.destroy(function() {}, function() {
        // Display some sort of error?
      });
    };

    Post.prototype.like = function(user) {
      var like = new Like({
        user_id: user.id,
        likeable_id: this.id,
        likeable_type: 'Post'
      });

      var post = this;
      like.create(function(newLike) {
        // Likes can appear in two different forms.
        if (post.likes.constructor === Array) {
          post.likes.push(newLike);
        } else if (post.likes.constructor === Object) {
          post.likes.data.push(newLike);
        }
      }, function() {
        // Display some sort of error?
      });
    };

    Post.prototype.toggleLike = function(user) {
      if (this.hasLiked(user)) {
        this.unlike(user);
      } else {
        this.like(user);
      }
    };

    Post.prototype.formatContent = function() {
      this.content = decodeURIComponent(encodeURIComponent(this.content).replace(/%0A/g, '<br />'));
      return this;
    };

    Post.prototype.formatDate = function(relativeTime) {
      if (relativeTime) {
        return moment(new Date(this.created_at)).fromNow();
      } else {
        return ($filter('date')(this.created_at, 'M/d') + ', ' + $filter('date')(this.created_at, 'h:mma')).toLowerCase();
      }
    };

    Post.prototype.isFromMe = function() {
      return this.user.id === $rootScope.user.id;
    };

    Post.prototype.hasSharedContent = function() {
      return this.postable_id && (this.postable_type === 'Tip' || this.postable_type === 'Recipe' || this.postable_type === 'Article');
    };

    Post.prototype.getPosterName = function() {
      var name = this.user.profile.first_name + ' ' + this.user.profile.last_name;
      if (this.is_flagged && !this.displayReportedContent) {
        name = "Flagged User";
      }
      return name;
    };

    Post.prototype.getPosterImage = function() {
      var imgUrl = this.user.profile.image.url;
      if (this.is_flagged && !this.displayReportedContent) {
        imgUrl = '/users/default.png'
      }
      return imgUrl;
    };

    Post.prototype.canFollow = function() {
      return !this.isFromMe() && !this.is_flagged;
    };

    Post.prototype.init = function() {
      if (!!this.likes.data) {
        this.likes = this.likes.data;
      }

      var that = this;

      this.created_at = new Date(this.created_at);
      this.content = decodeURIComponent(encodeURIComponent(this.content).replace(/%0A/g, '<br />'));

      if (this.posts) {
        this.posts = Post.wrap(this.posts);
        angular.forEach(this.posts, function(reply) {
          reply.init();
        })
      }
      if (this.tagged_users) {
        this.tagged_users = User.wrap(this.tagged_users);
      }
    };

    Post.prototype.likePopoverContent = function(user) {
      var content = '<table>';
      var currentUserHasLiked = false;

      function userIsCurrentUser(likeUser) {
        return likeUser.user_id === parseInt($rootScope.user.id);
      }

      function userIsWallModerator(likeUser) {
        return likeUser.user.is_wall_expert;
      }

      // Has the current user liked this?
      for (var i = 0; i < this.likes.length; i++) {
        if (userIsCurrentUser(this.likes[i])) {
          var like = this.likes[i];

          // Move the current user's like to the beginning so it can be displayed first.
          this.likes.splice(i, 1);
          this.likes.unshift(like);

          currentUserHasLiked = true;
          break;
        }
      }

      switch (this.likes.length) {
        case 0:
          content = 'Be the first to Like!';
          break;
        default:
          content += '<tr><td class="font-xs">' + (userIsCurrentUser(this.likes[0]) ? 'You' : (userIsWallModerator(this.likes[0]) ? this.wall_moderator_name : this.likes[0].user.profile.first_name + ' ' + this.likes[0].user.profile.last_name));
          content += '</td></tr>';
          for (var i = 1; i < this.likes.length; i++) {
            content += '<tr><td class="font-xs">' + (userIsWallModerator(this.likes[i]) ? this.wall_moderator_name : this.likes[i].user.profile.first_name + ' ' + this.likes[i].user.profile.last_name) + '</td></tr>';
          }

          break;
      }
      content += '</table>';

      return content;
    };

    Post.prototype.hasPhoto = function() {
      return !!this.photo.url && this.photo.url !== "/images/posts/default.png";
    };

    Post.prototype.toggleComments = function() {
      this.display_comments = !this.display_comments;
      var that = this;
      if (this.display_comments) {
        $timeout(function() {
          $('#comment_on_' + that.id).focus();
        }, 0);
      }
    };

    Post.prototype.showComments = function() {
      return this.display_comments;
    };

    //User actions
    Post.prototype.canReport = function(user) {
      var allow = false;
      if (!!user && !!this.user && !this.is_flagged) {
        //this.user is an object on Post, not a resource, so we must use the actual flag
        allow = (user.id !== this.user.id) && !this.user.is_wall_expert && !user.isCoordinator();
      }
      return allow;
    };

    Post.prototype.report = function(user) {
      this.flagged_by = user.id;
      this.is_flagged = true;
      return this.update().then(function(post) {
        post.init();
      });
    };

    Post.prototype.canUnreport = function(user) {
      var allow = false;
      if (!!user && !!this.user && this.is_flagged) {
        allow = user.id === this.flagged_by || user.isMaster() || user.isCoordinator() || user.isPoster();
      }
      return allow;
    };

    Post.prototype.unreport = function(user) {
      this.flagged_by = null;
      this.is_flagged = false;
      return this.update().then(function(post) {
        post.init();
      });
    };

    Post.prototype.toggleReportedContent = function() {
      this.displayReportedContent = !this.displayReportedContent;
    };

    Post.prototype.canDelete = function(user) {
      var allow = false;
      if (!!user && !!this.user) {
        if (this.user.is_wall_expert) {
          allow = user.id === this.user.id;
        } else {
          allow = (user.id === this.user.id || user.isMaster() || user.isCoordinator() || user.isPoster());
        }
      }
      return allow;
    };

    Post.prototype.userIsTagged = function(user) {
      var isTagged = false;
      var compare = $.grep(this.tagged_users, function(e) {
        return e.id == user.id;
      });
      isTagged = compare.length > 0;
      return isTagged;
    };

    Post.prototype.removeUserTag = function(user) {
      var that = this;
      return Post.removePostTag({
        id: this.id,
        user_id: user.id
      }).$promise.then(function(response) {
        that.tagged_users = response.tagged_users;
      });
    };

    Post.prototype.flattenTags = function() {
      this.tagged_users = _.map(this.tagged_users, function(friendee) {
        // If they are already ids, just return them.
        return !!friendee.id ? friendee.id : friendee;
      });
    };

    Post.prototype.getTypeName = function() {
      if (!this.typeName) {
        this.typeName = 'Post';
        if ((!!this.wallable_type && this.wallable_type !== 'Site') || (!!this.depth && this.depth > 0)) {
          this.typeName = 'Comment';
        }
      }
      return this.typeName;
    };

    Post.prototype.isSitePost = function() {
      return this.wallable_type == 'Site' && this.depth == 0 &&
        !this.parent_post_id;
    };

    Post.prototype.isSitePostComment = function() {
      return this.wallable_type == 'Site' && this.depth > 0 &&
        !!this.parent_post_id
    };

    Post.Paged.prototype = _.extend(Post.prototype, Post.Paged.prototype);
    Post.Paged.prototype.init = Post.prototype.init;


    return Post;
  });
'use strict';

angular.module('goApp')
.factory('RecentPost', ['DOMAIN', '$rootScope', '$filter', '$timeout', '$http', 'ActiveResource', 'HesSocket',
    function(DOMAIN, $rootScope, $filter, $timeout, $http, ActiveResource, HesSocket) {
        var RecentPost = ActiveResource('/recent_posts', {
            nestedRoutes: ['index', 'create'],
            parentResource: 'Site',
            domain: DOMAIN
        });

        RecentPost.prototype.formatDate = function(relativeTime) {
            if(relativeTime) {
                return moment(new Date(this.created_at)).fromNow();
            }
            else {
                return ($filter('date')(this.created_at, 'M/d') + ', ' + $filter('date')(this.created_at, 'h:mma')).toLowerCase();
            }
        };

        RecentPost.prototype.isFromMe = function() {
            return this.user_id === $rootScope.user.id;
        };

        return RecentPost;
    }
]);

angular.module('goApp').factory('RecentPostsLoader', ['RecentPost', '$q', 'Post',
function(RecentPost, $q, Post) {
    return function(pageSize, siteId, after) {
        var defer = $q.defer();
        pageSize = pageSize || 0;
        RecentPost.index({
            site_id: siteId,
            page_size: pageSize,
            after: after
        }, function(posts) {
            posts = Post.wrap(posts);
            angular.forEach(posts, function(post) {
                post.init();
            });
            defer.resolve(posts);
        }, function(err) {
            defer.reject('Posts could not be loaded.');
            console.log(err);
        });

        return defer.promise;
    };
}
])
angular.module('goApp')
  .controller('SinglePostController',
    function($scope, $state, WallFactory, singlePost, wallable) {

      singlePost.$promise.then(function(post) {
        $scope.view.singlePost = post;
        $scope.view.crumbs.push({
          state: $state.current.name,
          display: post.getPosterName() + "'s Post"
        })
        $scope.view.wall = new WallFactory(wallable, {});
        $scope.view.wall.posts = [post];

        if (!!$state.params.reply) {
          $scope.view.singlePost.toggleComments();
          // var comment = _.find(post.posts, {
          //   id: $state.params.reply * 1
          // });
          // comment.highlight
        }
      });

      $scope.view = {
        singlePost: null,
        wallable: wallable,
        crumbs: [{
          state: 'go.u.content.wall.all',
          display: 'All Posts'
        }],
        wall: null
      };

      $scope.removePost = function() {
        $state.transitionTo('go.u.content.wall.all');
      };

    });
'use strict';
angular.module('goApp')
  .controller('WallController', function($scope, $state, $stateParams, WallFactory, wallable, FriendsLoader) {
    $scope.data = new Object();

    $scope.view = {
      filter: $state.params.filter,
      total: 0,
      posts: [],
      crumbs: [{
        state: 'go.u.content.wall.following',
        display: 'Following'
      }, {
        state: $state.current.name,
        display: !!$stateParams.follow ? $stateParams.follow.getName() : ''
      }],
      showBreadcrumb: $stateParams.filter == 'following' || /^\d+$/.test($stateParams.filter)
    }

    $scope.view.wall = new WallFactory(wallable, {
      filter: $scope.view.filter,
      page_size: 30
    });

    $scope.view.wall.load().then(function(posts) {
      $scope.view.posts = $scope.view.wall.posts;
      $scope.view.total = $scope.view.wall.getTotalPosts();

      if ($scope.view.showBreadcrumb && !$stateParams.follow) {
        $scope.view.wall.usersFollowing.fetch($stateParams.filter)
          .then(function(followee) {
            $scope.view.crumbs[1].display = followee.getName();
          });
      }
    });

    $scope.allowCreate = function() {
      return !$scope.view.filter;
    };

    $scope.placeNewPost = function(newPost) {
      $scope.view.wall.placeNewPost(newPost);
    };

    $scope.removePost = function(post) {
      $scope.view.wall.removePost(post);
    };

    $scope.showMore = function() {
      return $scope.view.wall.getMorePosts();
    };

    $scope.$on('$destroy', function() {
      $scope.view.wall.unload();
    });

    new FriendsLoader().then(function(friends){
      $scope.data.has_no_friends = friends.length == 0;
    });

  });
'use strict';
angular.module('goApp')
  .factory('WallFactory', function($rootScope, Post, UsersFollowing) {
    // A collection of paged posts

    return function Wall(wallable, options) {

      var Wall = {
        posts: wallable.posts || [],
        pagedPosts: new Post.Paged(),
        newPosts: [],
        options: _.extend({
          page_size: 30,
          wallable_type: wallable['class'].toString() || "CustomContent",
          wallable_id: wallable.id
        }, options)
      };

      function setPosts(posts) {
        _.each(posts, function(post, idx) {
          post.init();
          Wall.posts.unshift(post);
        });
      }

      function isSiteWall() {
        return Wall.options.wallable_type == 'Site';
      };

      function isCommentWall(post) {
        return Wall.options.wallable_type == 'Post' 
          && Wall.options.wallable_id == post.parent_post_id;
      }

      function handleSocketPost(evt, post) {
        if (!!post) {
          if (post.isSitePost() && isSiteWall()) {
            //Site Wall, Site Post
            Wall.newPosts.push(post);
          } else if (post.isSitePostComment()) {
            //Site Wall Comment on wall post
            if (isCommentWall(post)) {
              //Comments are being viewed, so queue in newPosts
              Wall.newPosts.push(post);
            } else if (isSiteWall()) {
              //Comments are collapsed, so just add it
              var parentPost = _.find(Wall.posts, function(pPost) {
                return pPost.id == post.parent_post_id;
              });
              if (!!parentPost && !parentPost.showComments()) {
                parentPost.posts.push(post);
              }
            }
          }
        }
      }

      var unlisten = $rootScope.$on('newPost', handleSocketPost);

      return {
        loading: false,
        posts: Wall.posts,
        newPosts: Wall.newPosts,
        usersFollowing: new UsersFollowing(),
        getTotalPosts: function() {
          return Wall.pagedPosts.getMeta().total_records || 0;
        },
        getMorePosts: function() {
          if (this.hasMore()) {
            Wall.pagedPosts.getNext(true).then(function(posts) {
              setPosts(posts);
            });
          }
        },
        hasMore: function() {
          return Wall.pagedPosts.hasNext();
        },
        placeNewPost: function(post) {
          setPosts([post]);
        },
        placeIncomingPosts: function() {
          if (Wall.newPosts.length) {
            setPosts(Wall.newPosts);
            Wall.newPosts.splice(0);
          }
        },
        removePost: function(post) {
          _.remove(this.posts, {
            id: post.id
          });
        },
        load: function() {
          var that = this;
          this.loading = true;
          return Post.Paged.index(Wall.options)
            .$promise.then(function(posts) {
              setPosts(posts);
              that.loading = false;
            },function(){
              that.loading = false;
            });
        },
        unload: function() {
          unlisten();
        }
      };
    };
  });
'use strict';
angular.module('goApp')
  .config(function($stateProvider) {

    $stateProvider.state('go.u.content.wall', {
      abstract: true,
      template: '<ui-view></ui-view>',
      resolve: {
        wallable: function(CurrentSite) {
          return CurrentSite.get();
        }
      }
    });

    $stateProvider.state('go.u.content.wall.single', {
      url: '/wall/post/:id?:reply',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/wall/views/singlePost.html');
        }
      ],
      controller: 'SinglePostController',
      resolve: {
        singlePost: function($q, $stateParams, Post) {
          var defer = $q.defer();
          Post.show({
            id: $stateParams.id
          }, function(post) {
            post.init()
            defer.resolve(post);
          }, function(rejection) {
            defer.reject(rejection);
          });
          return defer.promise;
        }
      }
    });

    $stateProvider.state('go.u.content.wall.all', {
      url: '/wall/all',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/wall/views/wall.html');
        }
      ],
      controller: 'WallController',
      resolve: {
        wallable: function(CurrentSite) {
          return CurrentSite.get();
        }
      }
    });

    $stateProvider.state('go.u.content.wall.filtered', {
      url: '/wall/:filter',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/wall/views/wall.html');
        }
      ],
      controller: 'WallController',
      params: {
        filter: null,
        follow: null
      },
      resolve: {
        wallable: function(CurrentSite) {
          return CurrentSite.get();
        }
      }
    });

    $stateProvider.state('go.u.content.wall.following', {
      url: '/following',
      controller: 'FollowingController',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/wall/following/followingUsers.html');
        }
      ]
    });

    $stateProvider.state('go.u.content.wall.guidelines', {
      url: '/guidelines',
      controller: 'GuidelinesController',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/wall/guidelines/guidelines.html');
        }
      ]
    });

    //Basically the same as wall.filtered but we want to render it underneath following
    $stateProvider.state('go.u.content.wall.following.view', {
      url: '/:filter',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/wall/views/wall.html');
        }
      ],
      controller: 'WallController',
      params: {
        filter: null,
        crumbName: null
      },
      resolve: {
        wallable: function(CurrentSite) {
          return CurrentSite.get();
        }
      }
    });

    $stateProvider.state('go.u.wallexpert', {
      abstract: true,
      url: '/wallexpert',
      controller: "TabsController",
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/tabs/tabbed-tile-layout.html');
        }
      ]
    });

    $stateProvider.state('go.u.wallexpert.posts', {
      url: '/wallexpert/posts',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/wall/expert/wall_expert.html');
        }
      ],
      resolve: {
        wallable: function(CurrentSite) {
          return CurrentSite.get();
        }
      },
      params: {
        filter: 'my'
      },
      controller: 'WallExpertController'
    });

    $stateProvider.state('go.u.wallexpert.walls', {
      url: '/wallexpert/walls/:wallable_id',
      templateProvider: ['hesTemplateService',
        function(hesTemplateService) {
          return hesTemplateService.getTemplate('/scripts/wall/expert/wall_expert.html');
        }
      ],
      resolve: {
        wallable: function(CurrentSite, $stateParams, SiteLoader) {
          if (!!$stateParams.wallable_id) {
            return new SiteLoader({
              siteId: $stateParams.wallable_id
            });
          } else {
            return CurrentSite.get();
          }
        }
      },
      controller: 'WallExpertController'
    });

  });
'use strict';

angular.module('goApp')
  .directive('hesWebcartButton', ['hesTemplateService', 
    function(hesTemplateService) {

      return {
        scope: { label: '@' },
        restrict: 'A',
        replace: true,
        controller: ['$scope', 'CurrentSite', 'ngDialog', 
          function($scope, CurrentSite, ngDialog) {
          CurrentSite.get().then(function(site) { $scope.site = site; });

          $scope.showWebcartPopup = function() {
            ngDialog.open({
              template: hesTemplateService.getTemplateUrl('/scripts/webcart/webcart.html'),
              className: 'webcart-dialog ngdialog-theme-default',
              resolve: {
                webcartLink: function() {
                  return $scope.site.webcart_link;
                }
              },
              controller: 'WebcartController'
            });
          }
        }],
        templateUrl: hesTemplateService.getTemplateUrl('/scripts/webcart/webcartLink.html'),
        link: function($scope, $element, $attrs, controller) {
        
        }
      };
  }]);
'use strict';

angular.module('goApp')
  .controller('WebcartController', ['$scope', 'Content', 'CurrentSite', 'ContentLoader', 'ErrorService',
    function( $scope, Content, CurrentSite, ContentLoader, ErrorService ) {
    $scope.contentLoaded = false;
    $scope.loadingError = null;

    CurrentSite.get().then(function() {
      new ContentLoader({
        site_id: $scope.site.id, category: 'webcart'
      }, true)
        .then(function( contents ) {
          $scope.popupContent = Content.getByKey(contents, 'popup', true);
          $scope.popupContent.title_html = $scope.popupContent.title_html || "Fitbit Webcart";
          $scope.loadingError = null;
        }, function( response ) {
          ErrorService.showErrors(response, "Oops. Content loading failed.");
          $scope.loadingError = 'Error. Content loading failed.';
        })
        .finally(function() {
          $scope.contentLoaded = true;
        });
    });
  }]);

'use strict';

angular.module('goApp')
    .controller('WelcomeController', ['$scope', '$state', 'DOMAIN', 'Content', 'SSOService', 'ipCookie', 'CurrentSite', 'ContentLoader', 'ngDialog',
        function($scope, $state, DOMAIN, Content, SSOService, ipCookie, CurrentSite, ContentLoader, ngDialog) {

            $scope.configWelcome = {
              hasPilotPassword: false,
              isMobile: false,
              activeTab: 0,
              comingSoonContent: {},
              hideDropdown: true
            };

            CurrentSite.get().then(function() {
              new ContentLoader({
                  site_id: $scope.site.id,
                  category: 'countdown'
              }).then(function(contents) {
                $scope.configWelcome.comingSoonContent = Content.getByKey(contents, 'coming_soon', true);
              });
              new ContentLoader({
                  site_id: $scope.site.id,
                  category: 'welcome_logo'
              }).then(function(contents) {
                $scope.configWelcome.welcomeText = Content.getByKey(contents, 'welcome_banner_text', true);
                $scope.configWelcome.welcomeLogo = Content.getByKey(contents, 'site_logo', true).image1.url || $scope.site.logo;
              });
              new ContentLoader({
                  site_id: $scope.site.id,
                  category: 'welcome'
              }).then(function(contents) {
                switch ($scope.site.currentProgramStatus()) {
                  case 'campaign_opt_in':
                    $scope.configWelcome.welcomeContent = Content.getByKey(contents, 'campaign_opt_in', true);
                    break;
                  case 'campaign_closed':
                    $scope.configWelcome.welcomeContent = Content.getByKey(contents, 'campaign_closed', true);
                    break;
                  case 'default':
                    $scope.configWelcome.welcomeContent = Content.getByKey(contents, 'default', true);
                    break;
                  default:
                    $scope.configWelcome.welcomeContent = Content.getByKey(contents, 'default', true);
                }
                $scope.setContent($scope.configWelcome.welcomeContent);

                // If password reset
                if ($state.params.reset_password) {
                  ngDialog.open({
                      className: 'ngdialog-theme-default',
                      template: '/scripts/password/reset_password.html',
                      controller: 'ResetPasswordCtrl',
                      data: $state.params
                  }).closePromise.finally(function(){
                      $state.transitionTo('go.welcome', {}, {reload:'go.welcome'});
                  });
                }
              });
            });

            $scope.showLogin = function(){
                return !SSOService.isEnabled();
            };

            $scope.setContent = function(content) {
              $('.welcome-banner').css('background-image', "url(" + encodeURI(content.image1.url) + ")");
              $('.welcome-banner').css('transition', "background-image 1s");
            };

            $scope.toggleMobileMenu = function() {
                $scope.configWelcome.hideDropdown = $scope.configWelcome.hideDropdown ? false : true;
            };

            $scope.setActiveTab = function(tabNum) {
                $scope.configWelcome.activeTab = tabNum;
                $scope.toggleMobileMenu();
                $scope.setContent($scope.configWelcome.contents[$scope.configWelcome.activeTab]);
            };

            $scope.goToRegistration = function() {
                $state.go('go.register');
            };

            if(ipCookie('pilotPassword')) {
              $scope.configWelcome.hasPilotPassword = true;
            }
        }
    ]);

'use strict';

angular.module('goApp').config(function($stateProvider) {

  $stateProvider.state('go.welcome', {
    url: '/welcome?reset_password=:id&login&showLogin',
    controllerProvider: ['$location', function($location) {
      return $location.search().hesPlatform ? 'LoginController' : 'WelcomeController';
    }],
    templateProvider: ['hesTemplateService', '$location',
      function(hesTemplateService, $location) {
        var template = $location.search().hesPlatform
          ? '/scripts/login/login.html'
          : '/scripts/welcome/welcome.html';
        return hesTemplateService.getTemplate(template);
      }
    ],
    params: {
      pilotPassword: null
    }
  })
  .state('go.welcome.login', {
    url: '/login?:programId&:hesPlatform',
    params: {
      pilotPassword: null,
      rejection: null,
      programId: null,
      hesPlatform: null
    },
    onEnter: function(ngDialog, $state, $location, hesTemplateService) {
      // If hesPlatform exists, login.html is already rendered as the page content by the parent state
      if ($location.search().hesPlatform) {
        return;
      }

      ngDialog.closeAll();
      ngDialog.openConfirm({
        className: 'ngdialog-theme-default login-dialog',
        template: hesTemplateService.getTemplateUrl('/scripts/login/login.html'),
        controller: 'LoginController',
        closeByDocument: true,
        closeByEscape: true
      }).then(function() {}, function(data) {
        if ($state.current.name == "go.welcome.login") {
          $state.go('go.welcome');
        }
      });
    },
    onExit: function(ngDialog) {
      ngDialog.closeAll();
    }
  })
  .state('go.welcome.forgot', {
    url: '/forgot',
    title: 'Forgot Password',
    onEnter: function(ngDialog, $rootScope, $state) {
      $rootScope.redirecting = false
      ngDialog.closeAll();
      ngDialog.open({
        template: '/scripts/password/forgotten_password.html',
        controller: 'ForgottenPasswordCtrl',
        className: 'ngdialog-theme-default',
        closeByEscape: true,
        closeByDocument: true,
        }).closePromise.then(function() {
          if(!$rootScope.redirecting){
            $state.transitionTo('go.welcome');
          }
        });
    },
    onExit: function(ngDialog, $state) {
      ngDialog.closeAll();
    }
  })
  .state('go.welcome.check_eligibility', {
    url: '/check_eligibility',
    onEnter: function(ngDialog, $state, hesTemplateService) {
      ngDialog.closeAll();
      ngDialog.openConfirm({
        className: 'ngdialog-theme-default login-dialog',
        template: hesTemplateService.getTemplateUrl('/scripts/registration/eligibilityCheck.html'),
        controller: 'EligibilityCheckController',
        closeByDocument: true,
        closeByEscape: true
      }).then(function() {}, function(data) {
        if ($state.current.name == "go.welcome.check_eligibility") {
          $state.go('go.welcome');
        }
      });
    },
    onExit: function(ngDialog) {
      ngDialog.closeAll();
    }
  });

});

angular.module('ngconstant', [])

.constant('THEMED_IMAGES', ['default/body_bg.png','default/buttons/button-active-left.png','default/buttons/button-active-middle.png','default/buttons/button-active-right.png','default/buttons/button-hover-left.png','default/buttons/button-hover-middle.png','default/buttons/button-hover-right.png','default/buttons/button-inactive-left.png','default/buttons/button-inactive-middle.png','default/buttons/button-inactive-right.png','default/chart-icons/10kaday.com.png','default/chart-icons/8ightwaystowellness.com.png','default/chart-icons/bloomspringchallenge.com.png','default/chart-icons/chirpychallenge.com.png','default/chart-icons/coasttocoastwellness.com.png','default/chart-icons/colorfulchoices.com.png','default/chart-icons/elevatewellbeing.com.png','default/chart-icons/getfitonroute66.com.png','default/chart-icons/gogold2026.com.png','default/chart-icons/goodnurturedchallenge.com.png','default/chart-icons/gorightthisweigh.com.png','default/chart-icons/goslamdunk.com.png','default/chart-icons/healthfortheholidays.com.png','default/chart-icons/healthtrails.com.png','default/chart-icons/ifeellikeamillion.com.png','default/chart-icons/keepamericaactive.com.png','default/chart-icons/masimoonthemove.png','default/chart-icons/myolaala.com.png','default/chart-icons/myworkofart.com.png','default/chart-icons/olachallenge.com.png','default/chart-icons/ousdwellnesschallenge.com.png','default/chart-icons/renewmyway.com.png','default/chart-icons/snowwonderchallenge.com.png','default/chart-icons/springintomotiontoday.png','default/chart-icons/startrakchallenge.com.png','default/chart-icons/sustainprogram.com.png','default/chart-icons/thenourishgarden.com.png','default/chart-icons/walktober.com.png','default/chart-icons/welltraveledtoday.com.png','default/chart-icons/worldwidewellnesstoday.com.png','default/chart-icons/yohohowellness.com.png','default/drawer/notifications-tab-1.png','default/drawer/notifications-tab.png','default/fitbit/activity-level.png','default/fitbit/apple-health-icon.png','default/fitbit/calories.png','default/fitbit/distance.png','default/fitbit/garmin_icon.png','default/fitbit/google-fit-icon.png','default/fitbit/gray-item_chargehronly.png','default/fitbit/gray-item_chargeonly.png','default/fitbit/gray-item_flexonly.png','default/fitbit/gray-item_surgeonly.png','default/fitbit/gray-item_ziponly.png','default/fitbit/item_chargehronly.png','default/fitbit/item_chargeonly.png','default/fitbit/item_flexonly.png','default/fitbit/item_surgeonly.png','default/fitbit/item_ziponly.png','default/fitbit/log-manually.svg','default/fitbit/marketplace_icon.png','default/fitbit/steps.png','default/flags/flags.png','default/flags/flags@2x.png','default/following/all.svg','default/gallery/folder.png','default/gallery/imadethis.png','default/gallery/logo_default.jpg','default/gallery/placeholder-image.png','default/gallery/placeholder.png','default/gallery/up-arrow.png','default/goals/completed-goal.svg','default/goals/default-goal.jpg','default/goals/new-ribbon.png','default/header/logo.png','default/header/second-logo.png','default/icon-sets/devices-icon-set.svg','default/icon-sets/recipe-icon-set.svg','default/icon-sets/share-icon-set.svg','default/icon-sets/standard-icon-set.svg','default/icon-sets/wall-icon-set.svg','default/icons/alert.png','default/icons/arrow_left.png','default/icons/arrow_right.png','default/icons/calendar-dark-grey.svg','default/icons/calendar-light-grey.svg','default/icons/checked_box.png','default/icons/checked_box_mobile.png','default/icons/checked_box_mobile_bolder.png','default/icons/close-button.png','default/icons/download.png','default/icons/download.svg','default/icons/edit-icon-enabled.svg','default/icons/edit-icon.svg','default/icons/error.png','default/icons/flag-icon-enabled.svg','default/icons/flag-icon.svg','default/icons/heart-icon-enabled.svg','default/icons/heart-icon.svg','default/icons/loading-checkmark2.svg','default/icons/loading_checkmark.svg','default/icons/loading_checkmark2.svg','default/icons/spinner.png','default/icons/trash-icon-enabled.svg','default/icons/trash-icon.svg','default/icons/unchecked_box.png','default/icons/unchecked_box_mobile.png','default/icons/unchecked_box_mobile_bolder.png','default/icons/x.png','default/navigation/settings-active.png','default/navigation/settings.png','default/placeholders/new-conversation.png','default/placeholders/plus.png','default/placeholders/recipe-placeholder.jpg','default/placeholders/tip-placeholder.jpg','default/placeholders/unearned-badge.svg','default/programs/10k/header_versioned_1.jpg','default/programs/10k/left_shadow_versioned_1.jpg','default/programs/10k/right_shadow_versioned_1.jpg','default/programs/cc/header_versioned_1.0.jpg','default/programs/cc/left_shadow_versioned_1.jpg','default/programs/cc/right_shadow_versioned_1.jpg','default/programs/flam/email-header.gif','default/programs/h4h/get_started.jpg','default/programs/h4h/header_versioned_1.0.jpg','default/programs/h4h/log_progress.jpg','default/programs/h4h/logo.jpg','default/programs/h4h/welcome.jpg','default/programs/healthtrails/header_versioned_1.0.jpg','default/programs/healthtrails/left-border.jpg','default/programs/healthtrails/log-prog.png','default/programs/healthtrails/rainbow.jpg','default/programs/healthtrails/right-border.jpg','default/programs/healthtrails/swoosh.jpg','default/programs/kaa/header_versioned_1.jpg','default/programs/kaa/left_shadow_versioned_1.jpg','default/programs/kaa/right_shadow_versioned_1.jpg','default/programs/logos/flam-hover.png','default/programs/logos/flam.png','default/programs/logos/healthtrails-hover.png','default/programs/logos/healthtrails.png','default/programs/moa/header_versioned_1.0.png','default/programs/moa/left_shadow_versioned_1.jpg','default/programs/moa/right_shadow_versioned_1.jpg','default/programs/passport/footer.jpg','default/programs/passport/header.jpg','default/programs/passport/header_versioned_1.0.jpg','default/programs/passport/log-progress-button.jpg','default/programs/r66/email-header.gif','default/programs/rtw/header_versioned_1.0.jpg','default/programs/rtw/left-border.jpg','default/programs/rtw/log-prog.png','default/programs/rtw/rainbow.jpg','default/programs/rtw/right-border.jpg','default/programs/sim/app_store.png','default/programs/sim/email.png','default/programs/sim/google_play.png','default/programs/sim/header_versioned_1.0.png','default/programs/sim/left-border.jpg','default/programs/sim/log_progress_button.png','default/programs/sim/mobile_devices_versioned_1.0.png','default/programs/sim/orange_email_line.jpg','default/programs/sim/right-border.jpg','default/programs/sim/sim_welcome_combined.jpg','default/programs/sim/walk_this_way.png','default/programs/slam/email_logo.png','default/programs/slam/header_versioned_1.0.jpg','default/programs/slam/left_shadow_versioned_1.jpg','default/programs/slam/right_shadow_versioned_1.jpg','default/programs/walk/app-logo.jpg','default/programs/walk/app_store.png','default/programs/walk/blue_email_line.jpg','default/programs/walk/email.png','default/programs/walk/google_play.png','default/programs/walk/header_versioned_1.0.png','default/programs/walk/left-border.jpg','default/programs/walk/log_progress_button.png','default/programs/walk/mobile_devices_versioned_1.0.png','default/programs/walk/orange_email_line.jpg','default/programs/walk/right-border.jpg','default/programs/walk/walk_this_way.png','default/programs/walk/welcome_combined.jpg','default/programs/walktober.png','default/programs/walktober_small.png','default/programs/walktober_small_hover.png','default/programs/yhh/header_versioned_1.jpg','default/programs/yhh/left_shadow_versioned_1.jpg','default/programs/yhh/right_shadow_versioned_1.jpg','default/stats/badges-icon.svg','default/stats/challenges-icon.svg','default/stats/goals-icon.svg','default/stats/steps-icon.svg','default/symbol-defs.svg','default/users/all-following.png','default/users/default.png','default/users/wallExpert.png','default/welcome/logo_white_trail.png','default/welcome/welcome_mobile_1.png','default/welcome/welcome_mobile_2.png','default/welcome/welcome_web_1.png','default/welcome/welcome_web_2.png','email/header_versioned_1.0.jpg'])

.constant('CSS_BUILD', 1792443669226)

.constant('ENVIRONMENT', 'production')

;